
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

/**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ var $3273ed08087da3da$var$Disposable = /** @class */ function() {
    function Disposable() {
        /**
         * The object has already been disposed.
         * @type {boolean}
         * @protected
         */ this.disposed = false;
    }
    /**
     * Clean up.
     */ Disposable.prototype.dispose = function() {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    };
    /**
     * Extension point for disposable objects.
     * @protected
     */ Disposable.prototype.disposeInternal = function() {};
    return Disposable;
}();
var $3273ed08087da3da$export$2e2bcd8739ae039 = $3273ed08087da3da$var$Disposable;


/**
 * @module ol/functions
 */ /**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function=} opt_comparator Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $b998d41b678ed5d1$export$2e0ae67339d5f1ac(haystack, needle, opt_comparator) {
    var mid, cmp;
    var comparator = opt_comparator || $b998d41b678ed5d1$export$4e734a3b32fb971b;
    var low = 0;
    var high = haystack.length;
    var found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
         * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $b998d41b678ed5d1$export$4e734a3b32fb971b(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $b998d41b678ed5d1$export$ee2e0f811dca1807(arr, obj) {
    return arr.indexOf(obj) >= 0;
}
function $b998d41b678ed5d1$export$8a3786cc03fdb777(arr, target, direction) {
    var n = arr.length;
    if (arr[0] <= target) return 0;
    else if (target <= arr[n - 1]) return n - 1;
    else {
        var i = void 0;
        if (direction > 0) for(i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        else if (direction < 0) for(i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        else for(i = 1; i < n; ++i){
            if (arr[i] == target) return i;
            else if (arr[i] < target) {
                if (arr[i - 1] - target < target - arr[i]) return i - 1;
                else return i;
            }
        }
        return n - 1;
    }
}
function $b998d41b678ed5d1$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        var tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $b998d41b678ed5d1$export$8b58be045bf06082(arr, data) {
    var extension = Array.isArray(data) ? data : [
        data
    ];
    var length = extension.length;
    for(var i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $b998d41b678ed5d1$export$cd7f480d6b8286c3(arr, obj) {
    var i = arr.indexOf(obj);
    var found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $b998d41b678ed5d1$export$71aa6c912b956294(arr, func) {
    var length = arr.length >>> 0;
    var value;
    for(var i = 0; i < length; i++){
        value = arr[i];
        if (func(value, i, arr)) return value;
    }
    return null;
}
function $b998d41b678ed5d1$export$e9bab7fafb253603(arr1, arr2) {
    var len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(var i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $b998d41b678ed5d1$export$c7d3d1f96a700512(arr, compareFnc) {
    var length = arr.length;
    var tmp = Array(arr.length);
    var i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $b998d41b678ed5d1$export$de3a4d4a0d731119(arr, func) {
    var index;
    var found = !arr.every(function(el, idx) {
        index = idx;
        return !func(el, idx, arr);
    });
    return found ? index : -1;
}
function $b998d41b678ed5d1$export$efa610630f9e181(arr, opt_func, opt_strict) {
    var compare = opt_func || $b998d41b678ed5d1$export$4e734a3b32fb971b;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        var res = compare(arr[index - 1], currentVal);
        return !(res > 0 || opt_strict && res === 0);
    });
}


function $013a1733c226ec50$export$22e23a2304399231() {
    return true;
}
function $013a1733c226ec50$export$8f11cee4bdc7e668() {
    return false;
}
function $013a1733c226ec50$export$1cd1943b3a73bbe8() {}
function $013a1733c226ec50$export$ff83df6f9971435f(fn) {
    var called = false;
    /** @type {ReturnType} */ var lastResult;
    /** @type {Array<any>} */ var lastArgs;
    var lastThis;
    return function() {
        var nextArgs = Array.prototype.slice.call(arguments);
        if (!called || this !== lastThis || !(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(nextArgs, lastArgs)) {
            called = true;
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}


/**
 * @module ol/util
 */ /**
 * @return {?} Any return.
 */ function $6c5e11070e371322$export$817eb92a8194bab0() {
    return /** @type {?} */ function() {
        throw new Error('Unimplemented abstract method.');
    }();
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ var $6c5e11070e371322$var$uidCounter_ = 0;
function $6c5e11070e371322$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$6c5e11070e371322$var$uidCounter_));
}
var $6c5e11070e371322$export$a4ad2735b021c132 = '6.5.0';


/**
 * @module ol/transform
 */ /**
 * @module ol/asserts
 */ 
var $40658b5e833b516b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Error object thrown when an assertion failed. This is an ECMA-262 Error,
 * extended with a `code` property.
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error.
 */ var $40658b5e833b516b$var$AssertionError = /** @class */ function(_super) {
    $40658b5e833b516b$var$__extends(AssertionError, _super);
    /**
     * @param {number} code Error code.
     */ function AssertionError(code) {
        var _this = this;
        var path = (0, $6c5e11070e371322$export$a4ad2735b021c132) === 'latest' ? (0, $6c5e11070e371322$export$a4ad2735b021c132) : 'v' + (0, $6c5e11070e371322$export$a4ad2735b021c132).split('-')[0];
        var message = 'Assertion failed. See https://openlayers.org/en/' + path + '/doc/errors/#' + code + ' for details.';
        _this = _super.call(this, message) || this;
        /**
         * Error code. The meaning of the code can be found on
         * https://openlayers.org/en/latest/doc/errors/ (replace `latest` with
         * the version found in the OpenLayers script's header comment if a version
         * other than the latest is used).
         * @type {number}
         * @api
         */ _this.code = code;
        /**
         * @type {string}
         */ _this.name = 'AssertionError';
        // Re-assign message, see https://github.com/Rich-Harris/buble/issues/40
        _this.message = message;
        return _this;
    }
    return AssertionError;
}(Error);
var $40658b5e833b516b$export$2e2bcd8739ae039 = $40658b5e833b516b$var$AssertionError;


function $35d5ec884318008e$export$a7a9523472993e97(assertion, errorCode) {
    if (!assertion) throw new (0, $40658b5e833b516b$export$2e2bcd8739ae039)(errorCode);
}


/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ var $e22e7611e69f42a9$var$tmp_ = new Array(6);
function $e22e7611e69f42a9$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $e22e7611e69f42a9$export$aad8462122ac592b(transform) {
    return $e22e7611e69f42a9$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $e22e7611e69f42a9$export$2060d2db72cce88f(transform1, transform2) {
    var a1 = transform1[0];
    var b1 = transform1[1];
    var c1 = transform1[2];
    var d1 = transform1[3];
    var e1 = transform1[4];
    var f1 = transform1[5];
    var a2 = transform2[0];
    var b2 = transform2[1];
    var c2 = transform2[2];
    var d2 = transform2[3];
    var e2 = transform2[4];
    var f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $e22e7611e69f42a9$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $e22e7611e69f42a9$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $e22e7611e69f42a9$export$5635d7ef4b8fee1c(transform, coordinate) {
    var x = coordinate[0];
    var y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $e22e7611e69f42a9$export$bb628a54ab399bc9(transform, angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $e22e7611e69f42a9$export$dcdf75081b88279d(transform, x, y) {
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, x, 0, 0, y, 0, 0));
}
function $e22e7611e69f42a9$export$3e4e33ea14aeb531(target, x, y) {
    return $e22e7611e69f42a9$export$adaa4cf7ef1b65be(target, x, 0, 0, y, 0, 0);
}
function $e22e7611e69f42a9$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $e22e7611e69f42a9$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    var sin = Math.sin(angle);
    var cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $e22e7611e69f42a9$export$12a96a1aaf5558e3(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return $e22e7611e69f42a9$export$f84e8e69fd4488a5($e22e7611e69f42a9$export$f672e0b6f7222cd7($e22e7611e69f42a9$export$185802fd694ee1f5(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function $e22e7611e69f42a9$export$6897c284b6f9f4dc(source) {
    return $e22e7611e69f42a9$export$bd70ea2a93c0fa4(source, source);
}
function $e22e7611e69f42a9$export$bd70ea2a93c0fa4(target, source) {
    var det = $e22e7611e69f42a9$export$a04698f914c55ed9(source);
    (0, $35d5ec884318008e$export$a7a9523472993e97)(det !== 0, 32); // Transformation matrix cannot be inverted
    var a = source[0];
    var b = source[1];
    var c = source[2];
    var d = source[3];
    var e = source[4];
    var f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function $e22e7611e69f42a9$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
function $e22e7611e69f42a9$export$f84e8e69fd4488a5(mat) {
    return 'matrix(' + mat.join(', ') + ')';
}


/**
 * @module ol/extent
 */ /**
 * @module ol/extent/Corner
 */ /**
 * Extent corner.
 * @enum {string}
 */ var $2f35615121725455$export$2e2bcd8739ae039 = {
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right'
};


/**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $dab4245bc22b806c$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};



function $6da4c8ed3074c92b$export$8aceca7c77505534(coordinates) {
    var extent = $6da4c8ed3074c92b$export$fe201bb3bbe031e9();
    for(var i = 0, ii = coordinates.length; i < ii; ++i)$6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent=} opt_extent Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $6da4c8ed3074c92b$var$_boundingExtentXYs(xs, ys, opt_extent) {
    var minX = Math.min.apply(null, xs);
    var minY = Math.min.apply(null, ys);
    var maxX = Math.max.apply(null, xs);
    var maxY = Math.max.apply(null, ys);
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, opt_extent);
}
function $6da4c8ed3074c92b$export$ab1029bcae9ddb4a(extent, value, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = extent[0] - value;
        opt_extent[1] = extent[1] - value;
        opt_extent[2] = extent[2] + value;
        opt_extent[3] = extent[3] + value;
        return opt_extent;
    } else return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $6da4c8ed3074c92b$export$9cd59f9826255e47(extent, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = extent[0];
        opt_extent[1] = extent[1];
        opt_extent[2] = extent[2];
        opt_extent[3] = extent[3];
        return opt_extent;
    } else return extent.slice();
}
function $6da4c8ed3074c92b$export$cbe64c389534206f(extent, x, y) {
    var dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $6da4c8ed3074c92b$export$ac68c24d37ca240f(extent, coordinate) {
    return $6da4c8ed3074c92b$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $6da4c8ed3074c92b$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $6da4c8ed3074c92b$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, coordinate) {
    var minX = extent[0];
    var minY = extent[1];
    var maxX = extent[2];
    var maxY = extent[3];
    var x = coordinate[0];
    var y = coordinate[1];
    var relationship = (0, $dab4245bc22b806c$export$2e2bcd8739ae039).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).LEFT;
    else if (x > maxX) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).RIGHT;
    if (y < minY) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).BELOW;
    else if (y > maxY) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).ABOVE;
    if (relationship === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).UNKNOWN) relationship = (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING;
    return relationship;
}
function $6da4c8ed3074c92b$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $6da4c8ed3074c92b$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = minX;
        opt_extent[1] = minY;
        opt_extent[2] = maxX;
        opt_extent[3] = maxY;
        return opt_extent;
    } else return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $6da4c8ed3074c92b$export$3e2152b047719fa1(opt_extent) {
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, opt_extent);
}
function $6da4c8ed3074c92b$export$4838bf78d04a9440(coordinate, opt_extent) {
    var x = coordinate[0];
    var y = coordinate[1];
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(x, y, x, y, opt_extent);
}
function $6da4c8ed3074c92b$export$29e3ad4dbd0cb863(coordinates, opt_extent) {
    var extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(opt_extent);
    return $6da4c8ed3074c92b$export$795cd48be4d5f252(extent, coordinates);
}
function $6da4c8ed3074c92b$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, opt_extent) {
    var extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(opt_extent);
    return $6da4c8ed3074c92b$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $6da4c8ed3074c92b$export$73b4897e93bc5c83(rings, opt_extent) {
    var extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(opt_extent);
    return $6da4c8ed3074c92b$export$9b319549574402d7(extent, rings);
}
function $6da4c8ed3074c92b$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $6da4c8ed3074c92b$export$998afeab28643bd6(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function $6da4c8ed3074c92b$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $6da4c8ed3074c92b$export$795cd48be4d5f252(extent, coordinates) {
    for(var i = 0, ii = coordinates.length; i < ii; ++i)$6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $6da4c8ed3074c92b$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$6da4c8ed3074c92b$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $6da4c8ed3074c92b$export$9b319549574402d7(extent, rings) {
    for(var i = 0, ii = rings.length; i < ii; ++i)$6da4c8ed3074c92b$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $6da4c8ed3074c92b$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $6da4c8ed3074c92b$export$f9ed8a3d123a08e2(extent, callback) {
    var val;
    val = callback($6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $6da4c8ed3074c92b$export$520c40045967cb15(extent) {
    var area = 0;
    if (!$6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent)) area = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) * $6da4c8ed3074c92b$export$c08559766941f856(extent);
    return area;
}
function $6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $6da4c8ed3074c92b$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $6da4c8ed3074c92b$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $6da4c8ed3074c92b$export$a1cfd206661d0801(extent, corner) {
    var coordinate;
    if (corner === (0, $2f35615121725455$export$2e2bcd8739ae039).BOTTOM_LEFT) coordinate = $6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent);
    else if (corner === (0, $2f35615121725455$export$2e2bcd8739ae039).BOTTOM_RIGHT) coordinate = $6da4c8ed3074c92b$export$e77c1cf70445e168(extent);
    else if (corner === (0, $2f35615121725455$export$2e2bcd8739ae039).TOP_LEFT) coordinate = $6da4c8ed3074c92b$export$cb1538b07e6964ff(extent);
    else if (corner === (0, $2f35615121725455$export$2e2bcd8739ae039).TOP_RIGHT) coordinate = $6da4c8ed3074c92b$export$b84fa077c8b05295(extent);
    else (0, $35d5ec884318008e$export$a7a9523472993e97)(false, 13); // Invalid corner
    return coordinate;
}
function $6da4c8ed3074c92b$export$7d6fa884b32a3751(extent1, extent2) {
    var minX = Math.min(extent1[0], extent2[0]);
    var minY = Math.min(extent1[1], extent2[1]);
    var maxX = Math.max(extent1[2], extent2[2]);
    var maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $6da4c8ed3074c92b$export$13ba650faf8308(center, resolution, rotation, size, opt_extent) {
    var dx = resolution * size[0] / 2;
    var dy = resolution * size[1] / 2;
    var cosRotation = Math.cos(rotation);
    var sinRotation = Math.sin(rotation);
    var xCos = dx * cosRotation;
    var xSin = dx * sinRotation;
    var yCos = dy * cosRotation;
    var ySin = dy * sinRotation;
    var x = center[0];
    var y = center[1];
    var x0 = x - xCos + ySin;
    var x1 = x - xCos - ySin;
    var x2 = x + xCos - ySin;
    var x3 = x + xCos + ySin;
    var y0 = y - xSin - yCos;
    var y1 = y - xSin + yCos;
    var y2 = y + xSin + yCos;
    var y3 = y + xSin - yCos;
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), opt_extent);
}
function $6da4c8ed3074c92b$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $6da4c8ed3074c92b$export$f3fe0e9a60cde324(extent1, extent2) {
    var intersection = $6da4c8ed3074c92b$export$72209efa88586d42(extent1, extent2);
    return $6da4c8ed3074c92b$export$520c40045967cb15(intersection);
}
function $6da4c8ed3074c92b$export$72209efa88586d42(extent1, extent2, opt_extent) {
    var intersection = opt_extent ? opt_extent : $6da4c8ed3074c92b$export$fe201bb3bbe031e9();
    if ($6da4c8ed3074c92b$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $6da4c8ed3074c92b$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $6da4c8ed3074c92b$export$1bc603050bd777b1(extent) {
    return $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) + $6da4c8ed3074c92b$export$c08559766941f856(extent);
}
function $6da4c8ed3074c92b$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $6da4c8ed3074c92b$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $6da4c8ed3074c92b$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $6da4c8ed3074c92b$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $6da4c8ed3074c92b$export$6a4fe494c558c238(extent, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = extent[0];
        opt_extent[1] = extent[1];
        opt_extent[2] = extent[2];
        opt_extent[3] = extent[3];
        return opt_extent;
    } else return extent;
}
function $6da4c8ed3074c92b$export$80cbab86674143b6(extent, value) {
    var deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    var deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $6da4c8ed3074c92b$export$a6a5a7a461419425(extent, start, end) {
    var intersects = false;
    var startRel = $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, start);
    var endRel = $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING || endRel === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING) intersects = true;
    else {
        var minX = extent[0];
        var minY = extent[1];
        var maxX = extent[2];
        var maxY = extent[3];
        var startX = start[0];
        var startY = start[1];
        var endX = end[0];
        var endY = end[1];
        var slope = (endY - startY) / (endX - startX);
        var x = void 0, y = void 0;
        if (!!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).ABOVE) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).RIGHT) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).BELOW) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).LEFT) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $6da4c8ed3074c92b$export$9f9dcb98c894b623(extent, transformFn, opt_extent, opt_stops) {
    var coordinates = [];
    if (opt_stops > 1) {
        var width = extent[2] - extent[0];
        var height = extent[3] - extent[1];
        for(var i = 0; i < opt_stops; ++i)coordinates.push(extent[0] + width * i / opt_stops, extent[1], extent[2], extent[1] + height * i / opt_stops, extent[2] - width * i / opt_stops, extent[3], extent[0], extent[3] - height * i / opt_stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    var xs = [];
    var ys = [];
    for(var i = 0, l = coordinates.length; i < l; i += 2){
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return $6da4c8ed3074c92b$var$_boundingExtentXYs(xs, ys, opt_extent);
}
function $6da4c8ed3074c92b$export$39a9ce3624977b84(extent, projection) {
    var projectionExtent = projection.getExtent();
    var center = $6da4c8ed3074c92b$export$c91255cadecfe081(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        var worldWidth = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(projectionExtent);
        var worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        var offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}


/**
 * @module ol/style/IconImageCache
 */ /**
 * @module ol/color
 */ 
/**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ function $6b000a049d919fe5$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
var $6b000a049d919fe5$export$2e2fd1ad24e4d350 = function() {
    // Wrapped in a iife, to save the overhead of checking for the native
    // implementation on every invocation.
    var cosh;
    if ('cosh' in Math) // The environment supports the native Math.cosh function, use it…
    cosh = Math.cosh;
    else // … else, use the reference implementation of MDN:
    cosh = function(x) {
        var y = /** @type {Math} */ Math.exp(x);
        return (y + 1 / y) / 2;
    };
    return cosh;
}();
var $6b000a049d919fe5$export$b9fae0bba9d9094d = function() {
    // Wrapped in a iife, to save the overhead of checking for the native
    // implementation on every invocation.
    var log2;
    if ('log2' in Math) // The environment supports the native Math.log2 function, use it…
    log2 = Math.log2;
    else // … else, use the reference implementation of MDN:
    log2 = function(x) {
        return Math.log(x) * Math.LOG2E;
    };
    return log2;
}();
function $6b000a049d919fe5$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $6b000a049d919fe5$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $6b000a049d919fe5$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $6b000a049d919fe5$export$8240f01c446270e6(mat) {
    var n = mat.length;
    for(var i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        var maxRow = i;
        var maxEl = Math.abs(mat[i][i]);
        for(var r = i + 1; r < n; r++){
            var absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        var tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(var j = i + 1; j < n; j++){
            var coef = -mat[j][i] / mat[i][i];
            for(var k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    var x = new Array(n);
    for(var l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(var m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $6b000a049d919fe5$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $6b000a049d919fe5$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $6b000a049d919fe5$export$ba467bec01d66def(a, b) {
    var r = a % b;
    return r * b < 0 ? r + b : r;
}
function $6b000a049d919fe5$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}


/**
 * A color represented as a short array [red, green, blue, alpha].
 * red, green, and blue should be integers in the range 0..255 inclusive.
 * alpha should be a float in the range 0..1 inclusive. If no alpha value is
 * given then `1` will be used.
 * @typedef {Array<number>} Color
 * @api
 */ /**
 * This RegExp matches # followed by 3, 4, 6, or 8 hex digits.
 * @const
 * @type {RegExp}
 * @private
 */ var $322346e1ff7894ca$var$HEX_COLOR_RE_ = /^#([a-f0-9]{3}|[a-f0-9]{4}(?:[a-f0-9]{2}){0,2})$/i;
/**
 * Regular expression for matching potential named color style strings.
 * @const
 * @type {RegExp}
 * @private
 */ var $322346e1ff7894ca$var$NAMED_COLOR_RE_ = /^([a-z]*)$|^hsla?\(.*\)$/i;
function $322346e1ff7894ca$export$590567be997858b6(color) {
    if (typeof color === 'string') return color;
    else return $322346e1ff7894ca$export$f84e8e69fd4488a5(color);
}
/**
 * Return named color as an rgba string.
 * @param {string} color Named color.
 * @return {string} Rgb string.
 */ function $322346e1ff7894ca$var$fromNamed(color) {
    var el = document.createElement('div');
    el.style.color = color;
    if (el.style.color !== '') {
        document.body.appendChild(el);
        var rgb = getComputedStyle(el).color;
        document.body.removeChild(el);
        return rgb;
    } else return '';
}
var $322346e1ff7894ca$export$3004f64547af360e = function() {
    // We maintain a small cache of parsed strings.  To provide cheap LRU-like
    // semantics, whenever the cache grows too large we simply delete an
    // arbitrary 25% of the entries.
    /**
     * @const
     * @type {number}
     */ var MAX_CACHE_SIZE = 1024;
    /**
     * @type {Object<string, Color>}
     */ var cache = {};
    /**
     * @type {number}
     */ var cacheSize = 0;
    return(/**
     * @param {string} s String.
     * @return {Color} Color.
     */ function(s) {
        var color;
        if (cache.hasOwnProperty(s)) color = cache[s];
        else {
            if (cacheSize >= MAX_CACHE_SIZE) {
                var i = 0;
                for(var key in cache)if ((i++ & 3) === 0) {
                    delete cache[key];
                    --cacheSize;
                }
            }
            color = $322346e1ff7894ca$var$fromStringInternal_(s);
            cache[s] = color;
            ++cacheSize;
        }
        return color;
    });
}();
function $322346e1ff7894ca$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    else return $322346e1ff7894ca$export$3004f64547af360e(color);
}
/**
 * @param {string} s String.
 * @private
 * @return {Color} Color.
 */ function $322346e1ff7894ca$var$fromStringInternal_(s) {
    var r, g, b, a, color;
    if ($322346e1ff7894ca$var$NAMED_COLOR_RE_.exec(s)) s = $322346e1ff7894ca$var$fromNamed(s);
    if ($322346e1ff7894ca$var$HEX_COLOR_RE_.exec(s)) {
        // hex
        var n = s.length - 1; // number of hex digits
        var d = void 0; // number of digits per channel
        if (n <= 4) d = 1;
        else d = 2;
        var hasAlpha = n === 4 || n === 8;
        r = parseInt(s.substr(1 + 0 * d, d), 16);
        g = parseInt(s.substr(1 + 1 * d, d), 16);
        b = parseInt(s.substr(1 + 2 * d, d), 16);
        if (hasAlpha) a = parseInt(s.substr(1 + 3 * d, d), 16);
        else a = 255;
        if (d == 1) {
            r = (r << 4) + r;
            g = (g << 4) + g;
            b = (b << 4) + b;
            if (hasAlpha) a = (a << 4) + a;
        }
        color = [
            r,
            g,
            b,
            a / 255
        ];
    } else if (s.indexOf('rgba(') == 0) {
        // rgba()
        color = s.slice(5, -1).split(',').map(Number);
        $322346e1ff7894ca$export$a3295358bff77e(color);
    } else if (s.indexOf('rgb(') == 0) {
        // rgb()
        color = s.slice(4, -1).split(',').map(Number);
        color.push(1);
        $322346e1ff7894ca$export$a3295358bff77e(color);
    } else (0, $35d5ec884318008e$export$a7a9523472993e97)(false, 14); // Invalid color
    return color;
}
function $322346e1ff7894ca$export$a3295358bff77e(color) {
    color[0] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(color[0] + 0.5 | 0, 0, 255);
    color[1] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(color[1] + 0.5 | 0, 0, 255);
    color[2] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(color[2] + 0.5 | 0, 0, 255);
    color[3] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(color[3], 0, 1);
    return color;
}
function $322346e1ff7894ca$export$f84e8e69fd4488a5(color) {
    var r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    var g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    var b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    var a = color[3] === undefined ? 1 : color[3];
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
}
function $322346e1ff7894ca$export$40dd713d7775a0b1(s) {
    if ($322346e1ff7894ca$var$NAMED_COLOR_RE_.test(s)) s = $322346e1ff7894ca$var$fromNamed(s);
    return $322346e1ff7894ca$var$HEX_COLOR_RE_.test(s) || s.indexOf('rgba(') === 0 || s.indexOf('rgb(') === 0;
}


/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache~shared}.
 */ var $f351daabfe6e2d22$var$IconImageCache = /** @class */ function() {
    function IconImageCache() {
        /**
         * @type {!Object<string, import("./IconImage.js").default>}
         * @private
         */ this.cache_ = {};
        /**
         * @type {number}
         * @private
         */ this.cacheSize_ = 0;
        /**
         * @type {number}
         * @private
         */ this.maxCacheSize_ = 32;
    }
    /**
     * FIXME empty description for jsdoc
     */ IconImageCache.prototype.clear = function() {
        this.cache_ = {};
        this.cacheSize_ = 0;
    };
    /**
     * @return {boolean} Can expire cache.
     */ IconImageCache.prototype.canExpireCache = function() {
        return this.cacheSize_ > this.maxCacheSize_;
    };
    /**
     * FIXME empty description for jsdoc
     */ IconImageCache.prototype.expire = function() {
        if (this.canExpireCache()) {
            var i = 0;
            for(var key in this.cache_){
                var iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    --this.cacheSize_;
                }
            }
        }
    };
    /**
     * @param {string} src Src.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("../color.js").Color} color Color.
     * @return {import("./IconImage.js").default} Icon image.
     */ IconImageCache.prototype.get = function(src, crossOrigin, color) {
        var key = $f351daabfe6e2d22$var$getKey(src, crossOrigin, color);
        return key in this.cache_ ? this.cache_[key] : null;
    };
    /**
     * @param {string} src Src.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("../color.js").Color} color Color.
     * @param {import("./IconImage.js").default} iconImage Icon image.
     */ IconImageCache.prototype.set = function(src, crossOrigin, color, iconImage) {
        var key = $f351daabfe6e2d22$var$getKey(src, crossOrigin, color);
        this.cache_[key] = iconImage;
        ++this.cacheSize_;
    };
    /**
     * Set the cache size of the icon cache. Default is `32`. Change this value when
     * your map uses more than 32 different icon images and you are not caching icon
     * styles on the application level.
     * @param {number} maxCacheSize Cache max size.
     * @api
     */ IconImageCache.prototype.setSize = function(maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    };
    return IconImageCache;
}();
/**
 * @param {string} src Src.
 * @param {?string} crossOrigin Cross origin.
 * @param {import("../color.js").Color} color Color.
 * @return {string} Cache key.
 */ function $f351daabfe6e2d22$var$getKey(src, crossOrigin, color) {
    var colorString = color ? (0, $322346e1ff7894ca$export$590567be997858b6)(color) : 'null';
    return crossOrigin + ':' + src + ':' + colorString;
}
var $f351daabfe6e2d22$export$2e2bcd8739ae039 = $f351daabfe6e2d22$var$IconImageCache;
var $f351daabfe6e2d22$export$747ccdf771a87ab8 = new $f351daabfe6e2d22$var$IconImageCache();


/**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ var $aeedce20e9577100$var$BaseEvent = /** @class */ function() {
    /**
     * @param {string} type Type.
     */ function BaseEvent(type) {
        /**
         * @type {boolean}
         */ this.propagationStopped;
        /**
         * The event type.
         * @type {string}
         * @api
         */ this.type = type;
        /**
         * The event target.
         * @type {Object}
         * @api
         */ this.target = null;
    }
    /**
     * Stop event propagation.
     * @api
     */ BaseEvent.prototype.preventDefault = function() {
        this.propagationStopped = true;
    };
    /**
     * Stop event propagation.
     * @api
     */ BaseEvent.prototype.stopPropagation = function() {
        this.propagationStopped = true;
    };
    return BaseEvent;
}();
function $aeedce20e9577100$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $aeedce20e9577100$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $aeedce20e9577100$export$2e2bcd8739ae039 = $aeedce20e9577100$var$BaseEvent;


/**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $e881b5dca21eb5d4$export$2e2bcd8739ae039 = {
    /**
     * Triggered when a property is changed.
     * @event module:ol/Object.ObjectEvent#propertychange
     * @api
     */ PROPERTYCHANGE: 'propertychange'
};





/**
 * @module ol/obj
 */ /**
 * Polyfill for Object.assign().  Assigns enumerable and own properties from
 * one or more source objects to a target object.
 * See https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign.
 *
 * @param {!Object} target The target object.
 * @param {...Object} var_sources The source object(s).
 * @return {!Object} The modified target object.
 */ var $beaefe87199bb537$export$e6e34fd1f2686227 = typeof Object.assign === 'function' ? Object.assign : function(target, var_sources) {
    if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
    var output = Object(target);
    for(var i = 1, ii = arguments.length; i < ii; ++i){
        var source = arguments[i];
        if (source !== undefined && source !== null) {
            for(var key in source)if (source.hasOwnProperty(key)) output[key] = source[key];
        }
    }
    return output;
};
function $beaefe87199bb537$export$42ffd38884aecdac(object) {
    for(var property in object)delete object[property];
}
var $beaefe87199bb537$export$a5c4301012ad6f07 = typeof Object.values === 'function' ? Object.values : function(object) {
    var values = [];
    for(var property in object)values.push(object[property]);
    return values;
};
function $beaefe87199bb537$export$dd1bc94b04021eeb(object) {
    var property;
    for(property in object)return false;
    return !property;
}


var $08c28d22c0cb5a39$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ var $08c28d22c0cb5a39$var$Target = /** @class */ function(_super) {
    $08c28d22c0cb5a39$var$__extends(Target, _super);
    /**
     * @param {*=} opt_target Default event target for dispatched events.
     */ function Target(opt_target) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {*}
         */ _this.eventTarget_ = opt_target;
        /**
         * @private
         * @type {Object<string, number>}
         */ _this.pendingRemovals_ = null;
        /**
         * @private
         * @type {Object<string, number>}
         */ _this.dispatching_ = null;
        /**
         * @private
         * @type {Object<string, Array<import("../events.js").Listener>>}
         */ _this.listeners_ = null;
        return _this;
    }
    /**
     * @param {string} type Type.
     * @param {import("../events.js").Listener} listener Listener.
     */ Target.prototype.addEventListener = function(type, listener) {
        if (!type || !listener) return;
        var listeners = this.listeners_ || (this.listeners_ = {});
        var listenersForType = listeners[type] || (listeners[type] = []);
        if (listenersForType.indexOf(listener) === -1) listenersForType.push(listener);
    };
    /**
     * Dispatches an event and calls all listeners listening for events
     * of this type. The event parameter can either be a string or an
     * Object with a `type` property.
     *
     * @param {import("./Event.js").default|string} event Event object.
     * @return {boolean|undefined} `false` if anyone called preventDefault on the
     *     event object or if any of the listeners returned false.
     * @api
     */ Target.prototype.dispatchEvent = function(event) {
        /** @type {import("./Event.js").default|Event} */ var evt = typeof event === 'string' ? new (0, $aeedce20e9577100$export$2e2bcd8739ae039)(event) : event;
        var type = evt.type;
        if (!evt.target) evt.target = this.eventTarget_ || this;
        var listeners = this.listeners_ && this.listeners_[type];
        var propagate;
        if (listeners) {
            var dispatching = this.dispatching_ || (this.dispatching_ = {});
            var pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
            if (!(type in dispatching)) {
                dispatching[type] = 0;
                pendingRemovals[type] = 0;
            }
            ++dispatching[type];
            for(var i = 0, ii = listeners.length; i < ii; ++i){
                if ('handleEvent' in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
                else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
                if (propagate === false || evt.propagationStopped) {
                    propagate = false;
                    break;
                }
            }
            --dispatching[type];
            if (dispatching[type] === 0) {
                var pr = pendingRemovals[type];
                delete pendingRemovals[type];
                while(pr--)this.removeEventListener(type, (0, $013a1733c226ec50$export$1cd1943b3a73bbe8));
                delete dispatching[type];
            }
            return propagate;
        }
    };
    /**
     * Clean up.
     */ Target.prototype.disposeInternal = function() {
        this.listeners_ && (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.listeners_);
    };
    /**
     * Get the listeners for a specified event type. Listeners are returned in the
     * order that they will be called in.
     *
     * @param {string} type Type.
     * @return {Array<import("../events.js").Listener>|undefined} Listeners.
     */ Target.prototype.getListeners = function(type) {
        return this.listeners_ && this.listeners_[type] || undefined;
    };
    /**
     * @param {string=} opt_type Type. If not provided,
     *     `true` will be returned if this event target has any listeners.
     * @return {boolean} Has listeners.
     */ Target.prototype.hasListener = function(opt_type) {
        if (!this.listeners_) return false;
        return opt_type ? opt_type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    };
    /**
     * @param {string} type Type.
     * @param {import("../events.js").Listener} listener Listener.
     */ Target.prototype.removeEventListener = function(type, listener) {
        var listeners = this.listeners_ && this.listeners_[type];
        if (listeners) {
            var index = listeners.indexOf(listener);
            if (index !== -1) {
                if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                    // make listener a no-op, and remove later in #dispatchEvent()
                    listeners[index] = (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
                    ++this.pendingRemovals_[type];
                } else {
                    listeners.splice(index, 1);
                    if (listeners.length === 0) delete this.listeners_[type];
                }
            }
        }
    };
    return Target;
}((0, $3273ed08087da3da$export$2e2bcd8739ae039));
var $08c28d22c0cb5a39$export$2e2bcd8739ae039 = $08c28d22c0cb5a39$var$Target;


/**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $294047c5e65f31a3$export$2e2bcd8739ae039 = {
    /**
     * Generic change event. Triggered when the revision counter is increased.
     * @event module:ol/events/Event~BaseEvent#change
     * @api
     */ CHANGE: 'change',
    /**
     * Generic error event. Triggered when an error occurs.
     * @event module:ol/events/Event~BaseEvent#error
     * @api
     */ ERROR: 'error',
    BLUR: 'blur',
    CLEAR: 'clear',
    CONTEXTMENU: 'contextmenu',
    CLICK: 'click',
    DBLCLICK: 'dblclick',
    DRAGENTER: 'dragenter',
    DRAGOVER: 'dragover',
    DROP: 'drop',
    FOCUS: 'focus',
    KEYDOWN: 'keydown',
    KEYPRESS: 'keypress',
    LOAD: 'load',
    RESIZE: 'resize',
    TOUCHMOVE: 'touchmove',
    WHEEL: 'wheel'
};


/**
 * @module ol/events
 */ 
function $d5bf8abd656a3cdc$export$63174c828edd6ff8(target, type, listener, opt_this, opt_once) {
    if (opt_this && opt_this !== target) listener = listener.bind(opt_this);
    if (opt_once) {
        var originalListener_1 = listener;
        listener = function() {
            target.removeEventListener(type, listener);
            originalListener_1.apply(this, arguments);
        };
    }
    var eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function $d5bf8abd656a3cdc$export$8d2a95bc11b44725(target, type, listener, opt_this) {
    return $d5bf8abd656a3cdc$export$63174c828edd6ff8(target, type, listener, opt_this, true);
}
function $d5bf8abd656a3cdc$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, $beaefe87199bb537$export$42ffd38884aecdac)(key);
    }
}


var $1f093ab5083c8a1f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ var $1f093ab5083c8a1f$var$Observable = /** @class */ function(_super) {
    $1f093ab5083c8a1f$var$__extends(Observable, _super);
    function Observable() {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {number}
         */ _this.revision_ = 0;
        return _this;
    }
    /**
     * Increases the revision counter and dispatches a 'change' event.
     * @api
     */ Observable.prototype.changed = function() {
        ++this.revision_;
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    };
    /**
     * Get the version number for this object.  Each time the object is modified,
     * its version number will be incremented.
     * @return {number} Revision.
     * @api
     */ Observable.prototype.getRevision = function() {
        return this.revision_;
    };
    /**
     * Listen for a certain type of event.
     * @param {string|Array<string>} type The event type or array of event types.
     * @param {function(?): ?} listener The listener function.
     * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
     *     called with an array of event types as the first argument, the return
     *     will be an array of keys.
     * @api
     */ Observable.prototype.on = function(type, listener) {
        if (Array.isArray(type)) {
            var len = type.length;
            var keys = new Array(len);
            for(var i = 0; i < len; ++i)keys[i] = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this, type[i], listener);
            return keys;
        } else return (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this, /** @type {string} */ type, listener);
    };
    /**
     * Listen once for a certain type of event.
     * @param {string|Array<string>} type The event type or array of event types.
     * @param {function(?): ?} listener The listener function.
     * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
     *     called with an array of event types as the first argument, the return
     *     will be an array of keys.
     * @api
     */ Observable.prototype.once = function(type, listener) {
        var key;
        if (Array.isArray(type)) {
            var len = type.length;
            key = new Array(len);
            for(var i = 0; i < len; ++i)key[i] = (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(this, type[i], listener);
        } else key = (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(this, /** @type {string} */ type, listener);
        /** @type {Object} */ listener.ol_key = key;
        return key;
    };
    /**
     * Unlisten for a certain type of event.
     * @param {string|Array<string>} type The event type or array of event types.
     * @param {function(?): ?} listener The listener function.
     * @api
     */ Observable.prototype.un = function(type, listener) {
        var key = /** @type {Object} */ listener.ol_key;
        if (key) $1f093ab5083c8a1f$export$b7ef3f8527533384(key);
        else if (Array.isArray(type)) for(var i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
        else this.removeEventListener(type, listener);
    };
    return Observable;
}((0, $08c28d22c0cb5a39$export$2e2bcd8739ae039));
function $1f093ab5083c8a1f$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(var i = 0, ii = key.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(key[i]);
    else (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(/** @type {import("./events.js").EventsKey} */ key);
}
var $1f093ab5083c8a1f$export$2e2bcd8739ae039 = $1f093ab5083c8a1f$var$Observable;




var $b68b3d6e32e3074a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Events emitted by {@link module:ol/Object~BaseObject} instances are instances of this type.
 */ var $b68b3d6e32e3074a$export$cf395d7c4a2d5a17 = /** @class */ function(_super) {
    $b68b3d6e32e3074a$var$__extends(ObjectEvent, _super);
    /**
     * @param {string} type The event type.
     * @param {string} key The property name.
     * @param {*} oldValue The old value for `key`.
     */ function ObjectEvent(type, key, oldValue) {
        var _this = _super.call(this, type) || this;
        /**
         * The name of the property whose value is changing.
         * @type {string}
         * @api
         */ _this.key = key;
        /**
         * The old value. To get the new value use `e.target.get(e.key)` where
         * `e` is the event object.
         * @type {*}
         * @api
         */ _this.oldValue = oldValue;
        return _this;
    }
    return ObjectEvent;
}((0, $aeedce20e9577100$export$2e2bcd8739ae039));
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @api
 */ var $b68b3d6e32e3074a$var$BaseObject = /** @class */ function(_super) {
    $b68b3d6e32e3074a$var$__extends(BaseObject, _super);
    /**
     * @param {Object<string, *>=} opt_values An object with key-value pairs.
     */ function BaseObject(opt_values) {
        var _this = _super.call(this) || this;
        // Call {@link module:ol/util~getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $6c5e11070e371322$export$5e82334337e0f204)(_this);
        /**
         * @private
         * @type {Object<string, *>}
         */ _this.values_ = null;
        if (opt_values !== undefined) _this.setProperties(opt_values);
        return _this;
    }
    /**
     * Gets a value.
     * @param {string} key Key name.
     * @return {*} Value.
     * @api
     */ BaseObject.prototype.get = function(key) {
        var value;
        if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    };
    /**
     * Get a list of object property names.
     * @return {Array<string>} List of property names.
     * @api
     */ BaseObject.prototype.getKeys = function() {
        return this.values_ && Object.keys(this.values_) || [];
    };
    /**
     * Get an object of all property names and values.
     * @return {Object<string, *>} Object.
     * @api
     */ BaseObject.prototype.getProperties = function() {
        return this.values_ && (0, $beaefe87199bb537$export$e6e34fd1f2686227)({}, this.values_) || {};
    };
    /**
     * @return {boolean} The object has properties.
     */ BaseObject.prototype.hasProperties = function() {
        return !!this.values_;
    };
    /**
     * @param {string} key Key name.
     * @param {*} oldValue Old value.
     */ BaseObject.prototype.notify = function(key, oldValue) {
        var eventType;
        eventType = $b68b3d6e32e3074a$export$1ae67e5877b1d378(key);
        this.dispatchEvent(new $b68b3d6e32e3074a$export$cf395d7c4a2d5a17(eventType, key, oldValue));
        eventType = (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE;
        this.dispatchEvent(new $b68b3d6e32e3074a$export$cf395d7c4a2d5a17(eventType, key, oldValue));
    };
    /**
     * Sets a value.
     * @param {string} key Key name.
     * @param {*} value Value.
     * @param {boolean=} opt_silent Update without triggering an event.
     * @api
     */ BaseObject.prototype.set = function(key, value, opt_silent) {
        var values = this.values_ || (this.values_ = {});
        if (opt_silent) values[key] = value;
        else {
            var oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    };
    /**
     * Sets a collection of key-value pairs.  Note that this changes any existing
     * properties and adds new ones (it does not remove any existing properties).
     * @param {Object<string, *>} values Values.
     * @param {boolean=} opt_silent Update without triggering an event.
     * @api
     */ BaseObject.prototype.setProperties = function(values, opt_silent) {
        for(var key in values)this.set(key, values[key], opt_silent);
    };
    /**
     * Apply any properties from another object without triggering events.
     * @param {BaseObject} source The source object.
     * @protected
     */ BaseObject.prototype.applyProperties = function(source) {
        if (!source.values_) return;
        (0, $beaefe87199bb537$export$e6e34fd1f2686227)(this.values_ || (this.values_ = {}), source.values_);
    };
    /**
     * Unsets a property.
     * @param {string} key Key name.
     * @param {boolean=} opt_silent Unset without triggering an event.
     * @api
     */ BaseObject.prototype.unset = function(key, opt_silent) {
        if (this.values_ && key in this.values_) {
            var oldValue = this.values_[key];
            delete this.values_[key];
            if ((0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.values_)) this.values_ = null;
            if (!opt_silent) this.notify(key, oldValue);
        }
    };
    return BaseObject;
}((0, $1f093ab5083c8a1f$export$2e2bcd8739ae039));
/**
 * @type {Object<string, string>}
 */ var $b68b3d6e32e3074a$var$changeEventTypeCache = {};
function $b68b3d6e32e3074a$export$1ae67e5877b1d378(key) {
    return $b68b3d6e32e3074a$var$changeEventTypeCache.hasOwnProperty(key) ? $b68b3d6e32e3074a$var$changeEventTypeCache[key] : $b68b3d6e32e3074a$var$changeEventTypeCache[key] = 'change:' + key;
}
var $b68b3d6e32e3074a$export$2e2bcd8739ae039 = $b68b3d6e32e3074a$var$BaseObject;


/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $f6d1853b3fcae320$export$2e2bcd8739ae039 = {
    OPACITY: 'opacity',
    VISIBLE: 'visible',
    EXTENT: 'extent',
    Z_INDEX: 'zIndex',
    MAX_RESOLUTION: 'maxResolution',
    MIN_RESOLUTION: 'minResolution',
    MAX_ZOOM: 'maxZoom',
    MIN_ZOOM: 'minZoom',
    SOURCE: 'source'
};






var $57c5f0299cb9b82f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 */ var $57c5f0299cb9b82f$var$BaseLayer = /** @class */ function(_super) {
    $57c5f0299cb9b82f$var$__extends(BaseLayer, _super);
    /**
     * @param {Options} options Layer options.
     */ function BaseLayer(options) {
        var _this = _super.call(this) || this;
        /**
         * @type {Object<string, *>}
         */ var properties = (0, $beaefe87199bb537$export$e6e34fd1f2686227)({}, options);
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY] === 'number', 64); // Layer opacity must be a number
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).Z_INDEX] = options.zIndex;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
         * @type {string}
         * @private
         */ _this.className_ = properties.className !== undefined ? options.className : 'ol-layer';
        delete properties.className;
        _this.setProperties(properties);
        /**
         * @type {import("./Layer.js").State}
         * @private
         */ _this.state_ = null;
        return _this;
    }
    /**
     * @return {string} CSS class name.
     */ BaseLayer.prototype.getClassName = function() {
        return this.className_;
    };
    /**
     * This method is not meant to be called by layers or layer renderers because the state
     * is incorrect if the layer is included in a layer group.
     *
     * @param {boolean=} opt_managed Layer is managed.
     * @return {import("./Layer.js").State} Layer state.
     */ BaseLayer.prototype.getLayerState = function(opt_managed) {
        /** @type {import("./Layer.js").State} */ var state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: opt_managed === undefined ? true : opt_managed
        };
        var zIndex = this.getZIndex();
        state.opacity = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.sourceState = this.getSourceState();
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex !== undefined ? zIndex : state.managed === false ? Infinity : 0;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    };
    /**
     * @abstract
     * @param {Array<import("./Layer.js").default>=} opt_array Array of layers (to be
     *     modified in place).
     * @return {Array<import("./Layer.js").default>} Array of layers.
     */ BaseLayer.prototype.getLayersArray = function(opt_array) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @abstract
     * @param {Array<import("./Layer.js").State>=} opt_states Optional list of layer
     *     states (to be modified in place).
     * @return {Array<import("./Layer.js").State>} List of layer states.
     */ BaseLayer.prototype.getLayerStatesArray = function(opt_states) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
     * will be visible regardless of extent.
     * @return {import("../extent.js").Extent|undefined} The layer extent.
     * @observable
     * @api
     */ BaseLayer.prototype.getExtent = function() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).EXTENT);
    };
    /**
     * Return the maximum resolution of the layer.
     * @return {number} The maximum resolution of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getMaxResolution = function() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_RESOLUTION);
    };
    /**
     * Return the minimum resolution of the layer.
     * @return {number} The minimum resolution of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getMinResolution = function() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_RESOLUTION);
    };
    /**
     * Return the minimum zoom level of the layer.
     * @return {number} The minimum zoom level of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getMinZoom = function() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_ZOOM);
    };
    /**
     * Return the maximum zoom level of the layer.
     * @return {number} The maximum zoom level of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getMaxZoom = function() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_ZOOM);
    };
    /**
     * Return the opacity of the layer (between 0 and 1).
     * @return {number} The opacity of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getOpacity = function() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY);
    };
    /**
     * @abstract
     * @return {import("../source/State.js").default} Source state.
     */ BaseLayer.prototype.getSourceState = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Return the visibility of the layer (`true` or `false`).
     * @return {boolean} The visibility of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getVisible = function() {
        return /** @type {boolean} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).VISIBLE);
    };
    /**
     * Return the Z-index of the layer, which is used to order layers before
     * rendering. The default Z-index is 0.
     * @return {number} The Z-index of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getZIndex = function() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).Z_INDEX);
    };
    /**
     * Set the extent at which the layer is visible.  If `undefined`, the layer
     * will be visible at all extents.
     * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setExtent = function(extent) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).EXTENT, extent);
    };
    /**
     * Set the maximum resolution at which the layer is visible.
     * @param {number} maxResolution The maximum resolution of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setMaxResolution = function(maxResolution) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_RESOLUTION, maxResolution);
    };
    /**
     * Set the minimum resolution at which the layer is visible.
     * @param {number} minResolution The minimum resolution of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setMinResolution = function(minResolution) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_RESOLUTION, minResolution);
    };
    /**
     * Set the maximum zoom (exclusive) at which the layer is visible.
     * Note that the zoom levels for layer visibility are based on the
     * view zoom level, which may be different from a tile source zoom level.
     * @param {number} maxZoom The maximum zoom of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setMaxZoom = function(maxZoom) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_ZOOM, maxZoom);
    };
    /**
     * Set the minimum zoom (inclusive) at which the layer is visible.
     * Note that the zoom levels for layer visibility are based on the
     * view zoom level, which may be different from a tile source zoom level.
     * @param {number} minZoom The minimum zoom of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setMinZoom = function(minZoom) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_ZOOM, minZoom);
    };
    /**
     * Set the opacity of the layer, allowed values range from 0 to 1.
     * @param {number} opacity The opacity of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setOpacity = function(opacity) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof opacity === 'number', 64); // Layer opacity must be a number
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY, opacity);
    };
    /**
     * Set the visibility of the layer (`true` or `false`).
     * @param {boolean} visible The visibility of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setVisible = function(visible) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).VISIBLE, visible);
    };
    /**
     * Set Z-index of the layer, which is used to order layers before rendering.
     * The default Z-index is 0.
     * @param {number} zindex The z-index of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setZIndex = function(zindex) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).Z_INDEX, zindex);
    };
    /**
     * Clean up.
     */ BaseLayer.prototype.disposeInternal = function() {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        _super.prototype.disposeInternal.call(this);
    };
    return BaseLayer;
}((0, $b68b3d6e32e3074a$export$2e2bcd8739ae039));
var $57c5f0299cb9b82f$export$2e2bcd8739ae039 = $57c5f0299cb9b82f$var$BaseLayer;




/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $f5e92a4d985a2824$export$2e2bcd8739ae039 = {
    /**
     * Triggered before a layer is rendered.
     * @event module:ol/render/Event~RenderEvent#prerender
     * @api
     */ PRERENDER: 'prerender',
    /**
     * Triggered after a layer is rendered.
     * @event module:ol/render/Event~RenderEvent#postrender
     * @api
     */ POSTRENDER: 'postrender',
    /**
     * Triggered before layers are rendered.
     * The event object will not have a `context` set.
     * @event module:ol/render/Event~RenderEvent#precompose
     * @api
     */ PRECOMPOSE: 'precompose',
    /**
     * Triggered after all layers are rendered.
     * The event object will not have a `context` set.
     * @event module:ol/render/Event~RenderEvent#postcompose
     * @api
     */ POSTCOMPOSE: 'postcompose',
    /**
     * Triggered when rendering is complete, i.e. all sources and tiles have
     * finished loading for the current viewport, and all tiles are faded in.
     * The event object will not have a `context` set.
     * @event module:ol/render/Event~RenderEvent#rendercomplete
     * @api
     */ RENDERCOMPLETE: 'rendercomplete'
};


/**
 * @module ol/source/State
 */ /**
 * @enum {string}
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ var $98f5bfe3c4864f05$export$2e2bcd8739ae039 = {
    UNDEFINED: 'undefined',
    LOADING: 'loading',
    READY: 'ready',
    ERROR: 'error'
};






var $534f30fce11effcd$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {function(import("../PluggableMap.js").FrameState):HTMLElement} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../source/Source.js").default} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../PluggableMap.js").default} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {import("../source/State.js").default} sourceState
 * @property {boolean} visible
 * @property {boolean} managed
 * @property {import("../extent.js").Extent} [extent]
 * @property {number} zIndex
 * @property {number} maxResolution
 * @property {number} minResolution
 * @property {number} minZoom
 * @property {number} maxZoom
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is be added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with {@link module:ol/Map#addLayer}. Components
 * like {@link module:ol/interaction/Select~Select} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * {@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 *
 * Please note that for performance reasons several layers might get rendered to
 * the same HTML element, which will cause {@link module:ol/Map~Map#forEachLayerAtPixel} to
 * give false positives. To avoid this, apply different `className` properties to the
 * layers at creation time.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 *
 * @template {import("../source/Source.js").default} SourceType
 * @api
 */ var $534f30fce11effcd$var$Layer = /** @class */ function(_super) {
    $534f30fce11effcd$var$__extends(Layer, _super);
    /**
     * @param {Options} options Layer options.
     */ function Layer(options) {
        var _this = this;
        var baseOptions = (0, $beaefe87199bb537$export$e6e34fd1f2686227)({}, options);
        delete baseOptions.source;
        _this = _super.call(this, baseOptions) || this;
        /**
         * @private
         * @type {?import("../events.js").EventsKey}
         */ _this.mapPrecomposeKey_ = null;
        /**
         * @private
         * @type {?import("../events.js").EventsKey}
         */ _this.mapRenderKey_ = null;
        /**
         * @private
         * @type {?import("../events.js").EventsKey}
         */ _this.sourceChangeKey_ = null;
        /**
         * @private
         * @type {import("../renderer/Layer.js").default}
         */ _this.renderer_ = null;
        // Overwrite default render method with a custom one
        if (options.render) _this.render = options.render;
        if (options.map) _this.setMap(options.map);
        _this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).SOURCE), _this.handleSourcePropertyChange_);
        var source = options.source ? /** @type {SourceType} */ options.source : null;
        _this.setSource(source);
        return _this;
    }
    /**
     * @param {Array<import("./Layer.js").default>=} opt_array Array of layers (to be modified in place).
     * @return {Array<import("./Layer.js").default>} Array of layers.
     */ Layer.prototype.getLayersArray = function(opt_array) {
        var array = opt_array ? opt_array : [];
        array.push(this);
        return array;
    };
    /**
     * @param {Array<import("./Layer.js").State>=} opt_states Optional list of layer states (to be modified in place).
     * @return {Array<import("./Layer.js").State>} List of layer states.
     */ Layer.prototype.getLayerStatesArray = function(opt_states) {
        var states = opt_states ? opt_states : [];
        states.push(this.getLayerState());
        return states;
    };
    /**
     * Get the layer source.
     * @return {SourceType} The layer source (or `null` if not yet set).
     * @observable
     * @api
     */ Layer.prototype.getSource = function() {
        return /** @type {SourceType} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).SOURCE) || null;
    };
    /**
     * @return {import("../source/State.js").default} Source state.
     */ Layer.prototype.getSourceState = function() {
        var source = this.getSource();
        return !source ? (0, $98f5bfe3c4864f05$export$2e2bcd8739ae039).UNDEFINED : source.getState();
    };
    /**
     * @private
     */ Layer.prototype.handleSourceChange_ = function() {
        this.changed();
    };
    /**
     * @private
     */ Layer.prototype.handleSourcePropertyChange_ = function() {
        if (this.sourceChangeKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        var source = this.getSource();
        if (source) this.sourceChangeKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(source, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleSourceChange_, this);
        this.changed();
    };
    /**
     * @param {import("../pixel").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../Feature").default>>} Promise that resolves with
     * an array of features.
     */ Layer.prototype.getFeatures = function(pixel) {
        return this.renderer_.getFeatures(pixel);
    };
    /**
     * In charge to manage the rendering of the layer. One layer type is
     * bounded with one layer renderer.
     * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target which the renderer may (but need not) use
     * for rendering its content.
     * @return {HTMLElement} The rendered element.
     */ Layer.prototype.render = function(frameState, target) {
        var layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) return layerRenderer.renderFrame(frameState, target);
    };
    /**
     * Sets the layer to be rendered on top of other layers on a map. The map will
     * not manage this layer in its layers collection, and the callback in
     * {@link module:ol/Map#forEachLayerAtPixel} will receive `null` as layer. This
     * is useful for temporary layers. To remove an unmanaged layer from the map,
     * use `#setMap(null)`.
     *
     * To add the layer to a map and have it managed by the map, use
     * {@link module:ol/Map#addLayer} instead.
     * @param {import("../PluggableMap.js").default} map Map.
     * @api
     */ Layer.prototype.setMap = function(map) {
        if (this.mapPrecomposeKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRECOMPOSE, function(evt) {
                var renderEvent = /** @type {import("../render/Event.js").default} */ evt;
                var layerStatesArray = renderEvent.frameState.layerStatesArray;
                var layerState = this.getLayerState(false);
                // A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.
                (0, $35d5ec884318008e$export$a7a9523472993e97)(!layerStatesArray.some(function(arrayLayerState) {
                    return arrayLayerState.layer === layerState.layer;
                }), 67);
                layerStatesArray.push(layerState);
            }, this);
            this.mapRenderKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, map.render, map);
            this.changed();
        }
    };
    /**
     * Set the layer source.
     * @param {SourceType} source The layer source.
     * @observable
     * @api
     */ Layer.prototype.setSource = function(source) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).SOURCE, source);
    };
    /**
     * Get the renderer for this layer.
     * @return {import("../renderer/Layer.js").default} The layer renderer.
     */ Layer.prototype.getRenderer = function() {
        if (!this.renderer_) this.renderer_ = this.createRenderer();
        return this.renderer_;
    };
    /**
     * @return {boolean} The layer has a renderer.
     */ Layer.prototype.hasRenderer = function() {
        return !!this.renderer_;
    };
    /**
     * Create a renderer for this layer.
     * @return {import("../renderer/Layer.js").default} A layer renderer.
     * @protected
     */ Layer.prototype.createRenderer = function() {
        return null;
    };
    /**
     * Clean up.
     */ Layer.prototype.disposeInternal = function() {
        this.setSource(null);
        _super.prototype.disposeInternal.call(this);
    };
    return Layer;
}((0, $57c5f0299cb9b82f$export$2e2bcd8739ae039));
function $534f30fce11effcd$export$acb1e9cb9ce4ca56(layerState, viewState) {
    if (!layerState.visible) return false;
    var resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    var zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
var $534f30fce11effcd$export$2e2bcd8739ae039 = $534f30fce11effcd$var$Layer;


/**
 * @module ol/coordinate
 */ 

/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number=} opt_precision Precision of the output string (i.e. number of decimal places)
 * @returns {string} Formatted string
 */ function $ff7180bdd45ebb19$export$24be126cb0a7bbeb(number, width, opt_precision) {
    var numberString = opt_precision !== undefined ? number.toFixed(opt_precision) : '' + number;
    var decimal = numberString.indexOf('.');
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join('0') + numberString;
}
function $ff7180bdd45ebb19$export$66e1c0999abad646(v1, v2) {
    var s1 = ('' + v1).split('.');
    var s2 = ('' + v2).split('.');
    for(var i = 0; i < Math.max(s1.length, s2.length); i++){
        var n1 = parseInt(s1[i] || '0', 10);
        var n2 = parseInt(s2[i] || '0', 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}


function $1bd0a226f9a16141$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function $1bd0a226f9a16141$export$cbe80a3fcd2b99b7(coordinate, circle) {
    var r = circle.getRadius();
    var center = circle.getCenter();
    var x0 = center[0];
    var y0 = center[1];
    var x1 = coordinate[0];
    var y1 = coordinate[1];
    var dx = x1 - x0;
    var dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    var d = Math.sqrt(dx * dx + dy * dy);
    var x = x0 + r * dx / d;
    var y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $1bd0a226f9a16141$export$18cdd31d17f97131(coordinate, segment) {
    var x0 = coordinate[0];
    var y0 = coordinate[1];
    var start = segment[0];
    var end = segment[1];
    var x1 = start[0];
    var y1 = start[1];
    var x2 = end[0];
    var y2 = end[1];
    var dx = x2 - x1;
    var dy = y2 - y1;
    var along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    var x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $1bd0a226f9a16141$export$35ad6765fe262b6(opt_fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $1bd0a226f9a16141$export$9ff8f16060979e0a(coordinate, opt_fractionDigits);
    });
}
function $1bd0a226f9a16141$export$6eb0ac5f024d8590(hemispheres, degrees, opt_fractionDigits) {
    var normalizedDegrees = (0, $6b000a049d919fe5$export$ba467bec01d66def)(degrees + 180, 360) - 180;
    var x = Math.abs(3600 * normalizedDegrees);
    var dflPrecision = opt_fractionDigits || 0;
    var precision = Math.pow(10, dflPrecision);
    var deg = Math.floor(x / 3600);
    var min = Math.floor((x - deg * 3600) / 60);
    var sec = x - deg * 3600 - min * 60;
    sec = Math.ceil(sec * precision) / precision;
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    return deg + '\u00b0 ' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(min, 2) + '\u2032 ' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(sec, 2, dflPrecision) + '\u2033' + (normalizedDegrees == 0 ? '' : ' ' + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0));
}
function $1bd0a226f9a16141$export$d9468344d3651243(coordinate, template, opt_fractionDigits) {
    if (coordinate) return template.replace('{x}', coordinate[0].toFixed(opt_fractionDigits)).replace('{y}', coordinate[1].toFixed(opt_fractionDigits));
    else return '';
}
function $1bd0a226f9a16141$export$e9bab7fafb253603(coordinate1, coordinate2) {
    var equals = true;
    for(var i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $1bd0a226f9a16141$export$bb628a54ab399bc9(coordinate, angle) {
    var cosAngle = Math.cos(angle);
    var sinAngle = Math.sin(angle);
    var x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    var y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $1bd0a226f9a16141$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $1bd0a226f9a16141$export$88e6ebb4fe54f538(coord1, coord2) {
    var dx = coord1[0] - coord2[0];
    var dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $1bd0a226f9a16141$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($1bd0a226f9a16141$export$88e6ebb4fe54f538(coord1, coord2));
}
function $1bd0a226f9a16141$export$6985570514055196(coordinate, segment) {
    return $1bd0a226f9a16141$export$88e6ebb4fe54f538(coordinate, $1bd0a226f9a16141$export$18cdd31d17f97131(coordinate, segment));
}
function $1bd0a226f9a16141$export$c883fd238161f841(coordinate, opt_fractionDigits) {
    if (coordinate) return $1bd0a226f9a16141$export$6eb0ac5f024d8590('NS', coordinate[1], opt_fractionDigits) + ' ' + $1bd0a226f9a16141$export$6eb0ac5f024d8590('EW', coordinate[0], opt_fractionDigits);
    else return '';
}
function $1bd0a226f9a16141$export$9ff8f16060979e0a(coordinate, opt_fractionDigits) {
    return $1bd0a226f9a16141$export$d9468344d3651243(coordinate, '{x}, {y}', opt_fractionDigits);
}
function $1bd0a226f9a16141$export$39a9ce3624977b84(coordinate, projection) {
    if (projection.canWrapX()) {
        var worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projection.getExtent());
        var worldsAway = $1bd0a226f9a16141$export$24e2b27d1ff0c1d5(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function $1bd0a226f9a16141$export$24e2b27d1ff0c1d5(coordinate, projection, opt_sourceExtentWidth) {
    var projectionExtent = projection.getExtent();
    var worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        var sourceExtentWidth = opt_sourceExtentWidth || (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}


var $b370ab32454a96fd$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature
 * @property {import("../layer/Layer.js").default} layer
 * @property {import("../geom/SimpleGeometry.js").default} geometry
 * @property {number} distanceSq
 * @property {import("./vector.js").FeatureCallback<T>} callback
 * @template T
 */ /**
 * @abstract
 */ var $b370ab32454a96fd$var$MapRenderer = /** @class */ function(_super) {
    $b370ab32454a96fd$var$__extends(MapRenderer, _super);
    /**
     * @param {import("../PluggableMap.js").default} map Map.
     */ function MapRenderer(map) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {import("../PluggableMap.js").default}
         */ _this.map_ = map;
        return _this;
    }
    /**
     * @abstract
     * @param {import("../render/EventType.js").default} type Event type.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     */ MapRenderer.prototype.dispatchRenderEvent = function(type, frameState) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @protected
     */ MapRenderer.prototype.calculateMatrices2D = function(frameState) {
        var viewState = frameState.viewState;
        var coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        var pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, $e22e7611e69f42a9$export$bd70ea2a93c0fa4)(pixelToCoordinateTransform, coordinateToPixelTransform);
    };
    /**
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {boolean} checkWrapped Check for wrapped geometries.
     * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {S} thisArg Value to use as `this` when executing `callback`.
     * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
     *     function, only layers which are visible and for which this function
     *     returns `true` will be tested for features.  By default, all visible
     *     layers will be tested.
     * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
     * @return {T|undefined} Callback result.
     * @template S,T,U
     */ MapRenderer.prototype.forEachFeatureAtCoordinate = function(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        var result;
        var viewState = frameState.viewState;
        /**
         * @param {boolean} managed Managed layer.
         * @param {import("../Feature.js").FeatureLike} feature Feature.
         * @param {import("../layer/Layer.js").default} layer Layer.
         * @param {import("../geom/Geometry.js").default} geometry Geometry.
         * @return {T|undefined} Callback result.
         */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        var projection = viewState.projection;
        var translatedCoordinate = (0, $1bd0a226f9a16141$export$39a9ce3624977b84)(coordinate.slice(), projection);
        var offsets = [
            [
                0,
                0
            ]
        ];
        if (projection.canWrapX() && checkWrapped) {
            var projectionExtent = projection.getExtent();
            var worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
            offsets.push([
                -worldWidth,
                0
            ], [
                worldWidth,
                0
            ]);
        }
        var layerStates = frameState.layerStatesArray;
        var numLayers = layerStates.length;
        var matches = /** @type {Array<HitMatch<T>>} */ [];
        var tmpCoord = [];
        for(var i = 0; i < offsets.length; i++)for(var j = numLayers - 1; j >= 0; --j){
            var layerState = layerStates[j];
            var layer = layerState.layer;
            if (layer.hasRenderer() && (0, $534f30fce11effcd$export$acb1e9cb9ce4ca56)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                var layerRenderer = layer.getRenderer();
                var source = layer.getSource();
                if (layerRenderer && source) {
                    var coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                    var callback_1 = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                    tmpCoord[0] = coordinates[0] + offsets[i][0];
                    tmpCoord[1] = coordinates[1] + offsets[i][1];
                    result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback_1, matches);
                }
                if (result) return result;
            }
        }
        if (matches.length === 0) return undefined;
        var order = 1 / matches.length;
        matches.forEach(function(m, i) {
            return m.distanceSq += i * order;
        });
        matches.sort(function(a, b) {
            return a.distanceSq - b.distanceSq;
        });
        matches.some(function(m) {
            return result = m.callback(m.feature, m.layer, m.geometry);
        });
        return result;
    };
    /**
     * @abstract
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {function(import("../layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback Layer
     *     callback.
     * @param {function(import("../layer/Layer.js").default): boolean} layerFilter Layer filter
     *     function, only layers which are visible and for which this function
     *     returns `true` will be tested for features.  By default, all visible
     *     layers will be tested.
     * @return {T|undefined} Callback result.
     * @template T
     */ MapRenderer.prototype.forEachLayerAtPixel = function(pixel, frameState, hitTolerance, callback, layerFilter) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {boolean} checkWrapped Check for wrapped geometries.
     * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
     *     function, only layers which are visible and for which this function
     *     returns `true` will be tested for features.  By default, all visible
     *     layers will be tested.
     * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
     * @return {boolean} Is there a feature at the given coordinate?
     * @template U
     */ MapRenderer.prototype.hasFeatureAtCoordinate = function(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        var hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, $013a1733c226ec50$export$22e23a2304399231), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    };
    /**
     * @return {import("../PluggableMap.js").default} Map.
     */ MapRenderer.prototype.getMap = function() {
        return this.map_;
    };
    /**
     * Render.
     * @abstract
     * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
     */ MapRenderer.prototype.renderFrame = function(frameState) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @protected
     */ MapRenderer.prototype.scheduleExpireIconCache = function(frameState) {
        if ((0, $f351daabfe6e2d22$export$747ccdf771a87ab8).canExpireCache()) frameState.postRenderFunctions.push($b370ab32454a96fd$var$expireIconCache);
    };
    return MapRenderer;
}((0, $3273ed08087da3da$export$2e2bcd8739ae039));
/**
 * @param {import("../PluggableMap.js").default} map Map.
 * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
 */ function $b370ab32454a96fd$var$expireIconCache(map, frameState) {
    (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).expire();
}
var $b370ab32454a96fd$export$2e2bcd8739ae039 = $b370ab32454a96fd$var$MapRenderer;



/**
 * @module ol/render/Event
 */ 
var $b80dddceb0c42ad4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b80dddceb0c42ad4$var$RenderEvent = /** @class */ function(_super) {
    $b80dddceb0c42ad4$var$__extends(RenderEvent, _super);
    /**
     * @param {import("./EventType.js").default} type Type.
     * @param {import("../transform.js").Transform=} opt_inversePixelTransform Transform for
     *     CSS pixels to rendered pixels.
     * @param {import("../PluggableMap.js").FrameState=} opt_frameState Frame state.
     * @param {?CanvasRenderingContext2D=} opt_context Context.
     */ function RenderEvent(type, opt_inversePixelTransform, opt_frameState, opt_context) {
        var _this = _super.call(this, type) || this;
        /**
         * Transform from CSS pixels (relative to the top-left corner of the map viewport)
         * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
         * @type {import("../transform.js").Transform|undefined}
         * @api
         */ _this.inversePixelTransform = opt_inversePixelTransform;
        /**
         * An object representing the current render frame state.
         * @type {import("../PluggableMap.js").FrameState|undefined}
         * @api
         */ _this.frameState = opt_frameState;
        /**
         * Canvas context. Not available when the event is dispatched by the map. Only available
         * when a Canvas renderer is used, null otherwise.
         * @type {CanvasRenderingContext2D|null|undefined}
         * @api
         */ _this.context = opt_context;
        return _this;
    }
    return RenderEvent;
}((0, $aeedce20e9577100$export$2e2bcd8739ae039));
var $b80dddceb0c42ad4$export$2e2bcd8739ae039 = $b80dddceb0c42ad4$var$RenderEvent;




/**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style
 * @property {string} variant
 * @property {string} weight
 * @property {string} size
 * @property {string} lineHeight
 * @property {string} family
 * @property {Array<string>} families
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ var $ce07df6d5d4656f1$export$981241db82723ce2 = 'ol-hidden';
var $ce07df6d5d4656f1$export$99b49471b0394319 = 'ol-selectable';
var $ce07df6d5d4656f1$export$1afde3d6e16a7b29 = 'ol-unselectable';
var $ce07df6d5d4656f1$export$68eede0dd8c6c1da = 'ol-unsupported';
var $ce07df6d5d4656f1$export$4d4f8be70b656192 = 'ol-control';
var $ce07df6d5d4656f1$export$e16017ac68d14492 = 'ol-collapsed';
/**
 * From http://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ var $ce07df6d5d4656f1$var$fontRegEx = new RegExp([
    '^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)',
    '(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?',
    '(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))',
    '(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))',
    '?\\s*([-,\\"\\\'\\sa-z]+?)\\s*$'
].join(''), 'i');
var $ce07df6d5d4656f1$var$fontRegExMatchIndex = [
    'style',
    'variant',
    'weight',
    'size',
    'lineHeight',
    'family'
];
var $ce07df6d5d4656f1$export$5abde8a6aec4a131 = function(fontSpec) {
    var match = fontSpec.match($ce07df6d5d4656f1$var$fontRegEx);
    if (!match) return null;
    var style = /** @type {FontParameters} */ {
        lineHeight: 'normal',
        size: '1.2em',
        style: 'normal',
        weight: 'normal',
        variant: 'normal'
    };
    for(var i = 0, ii = $ce07df6d5d4656f1$var$fontRegExMatchIndex.length; i < ii; ++i){
        var value = match[i + 1];
        if (value !== undefined) style[$ce07df6d5d4656f1$var$fontRegExMatchIndex[i]] = value;
    }
    style.families = style.family.split(/,\s?/);
    return style;
};


/**
 * @module ol/render/canvas
 */ 

/**
 * @module ol/has
 */ var $67c66761d21428d0$var$ua = typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
var $67c66761d21428d0$export$8442bdfd18b7b8a6 = $67c66761d21428d0$var$ua.indexOf('firefox') !== -1;
var $67c66761d21428d0$export$3227bfbdaa9275de = $67c66761d21428d0$var$ua.indexOf('safari') !== -1 && $67c66761d21428d0$var$ua.indexOf('chrom') == -1;
var $67c66761d21428d0$export$39dfd62a25e0fe93 = $67c66761d21428d0$var$ua.indexOf('webkit') !== -1 && $67c66761d21428d0$var$ua.indexOf('edge') == -1;
var $67c66761d21428d0$export$76c0a3b101d93136 = $67c66761d21428d0$var$ua.indexOf('macintosh') !== -1;
var $67c66761d21428d0$export$6b83a0446fc26f94 = typeof devicePixelRatio !== 'undefined' ? devicePixelRatio : 1;
var $67c66761d21428d0$export$98fcef3dc9973292 = typeof WorkerGlobalScope !== 'undefined' && typeof OffscreenCanvas !== 'undefined' && self instanceof WorkerGlobalScope; //eslint-disable-line
var $67c66761d21428d0$export$716f8695eedb9bad = typeof Image !== 'undefined' && Image.prototype.decode;
var $67c66761d21428d0$export$f751ce96c6c4e4fc = function() {
    var passive = false;
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function() {
                passive = true;
            }
        });
        window.addEventListener('_', null, options);
        window.removeEventListener('_', null, options);
    } catch (error) {
    // passive not supported
    }
    return passive;
}();




function $075f937d7366f1a2$export$9e05d10eae75c464(opt_width, opt_height, opt_canvasPool) {
    var canvas = opt_canvasPool && opt_canvasPool.length ? opt_canvasPool.shift() : (0, $67c66761d21428d0$export$98fcef3dc9973292) ? new OffscreenCanvas(opt_width || 300, opt_height || 300) : document.createElement('canvas');
    if (opt_width) canvas.width = opt_width;
    if (opt_height) canvas.height = opt_height;
    //FIXME Allow OffscreenCanvasRenderingContext2D as return type
    return /** @type {CanvasRenderingContext2D} */ canvas.getContext('2d');
}
function $075f937d7366f1a2$export$e823f88e4111159a(element) {
    var width = element.offsetWidth;
    var style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $075f937d7366f1a2$export$fc5b8aac72846d1e(element) {
    var height = element.offsetHeight;
    var style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $075f937d7366f1a2$export$5542201de9311ab2(newNode, oldNode) {
    var parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $075f937d7366f1a2$export$1d0aa160432dfea5(node) {
    return node && node.parentNode ? node.parentNode.removeChild(node) : null;
}
function $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.removeChild(node.lastChild);
}
function $075f937d7366f1a2$export$caeacfe04f52533a(node, children) {
    var oldChildren = node.childNodes;
    for(var i = 0;; ++i){
        var oldChild = oldChildren[i];
        var newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}




var $d4aabc5c971073f1$export$3847dfea4f8d4dfa = '10px sans-serif';
var $d4aabc5c971073f1$export$c495d52ee3fd74b2 = '#000';
var $d4aabc5c971073f1$export$17bd0c38d6ae694e = 'round';
var $d4aabc5c971073f1$export$e21b4112fdc612fc = [];
var $d4aabc5c971073f1$export$e06efc2409049f76 = 0;
var $d4aabc5c971073f1$export$365eb9648cf19bd0 = 'round';
var $d4aabc5c971073f1$export$80c1c01844597b7b = 10;
var $d4aabc5c971073f1$export$1eb2eaecacf2031e = '#000';
var $d4aabc5c971073f1$export$94d53b95641b5766 = 'center';
var $d4aabc5c971073f1$export$cf2279a1bff62eb = 'middle';
var $d4aabc5c971073f1$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
var $d4aabc5c971073f1$export$79661f132c62010e = 1;
var $d4aabc5c971073f1$export$1d36981fcadac93b = new (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039)();
var $d4aabc5c971073f1$export$18212182f4e22723 = new (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039)();
$d4aabc5c971073f1$export$18212182f4e22723.setSize = function() {
    console.warn('labelCache is deprecated.'); //eslint-disable-line
};
/**
 * @type {CanvasRenderingContext2D}
 */ var $d4aabc5c971073f1$var$measureContext = null;
/**
 * @type {string}
 */ var $d4aabc5c971073f1$var$measureFont;
var $d4aabc5c971073f1$export$7fdcec604f0b1fa7 = {};
var $d4aabc5c971073f1$export$a534074a28fa87ff = function() {
    var retries = 100;
    var size = '32px ';
    var referenceFonts = [
        'monospace',
        'serif'
    ];
    var len = referenceFonts.length;
    var text = 'wmytzilWMYTZIL@#/&?$%10\uF013';
    var interval, referenceWidth;
    /**
     * @param {string} fontStyle Css font-style
     * @param {string} fontWeight Css font-weight
     * @param {*} fontFamily Css font-family
     * @return {boolean} Font with style and weight is available
     */ function isAvailable(fontStyle, fontWeight, fontFamily) {
        var available = true;
        for(var i = 0; i < len; ++i){
            var referenceFont = referenceFonts[i];
            referenceWidth = $d4aabc5c971073f1$export$4ea92329b673abd1(fontStyle + ' ' + fontWeight + ' ' + size + referenceFont, text);
            if (fontFamily != referenceFont) {
                var width = $d4aabc5c971073f1$export$4ea92329b673abd1(fontStyle + ' ' + fontWeight + ' ' + size + fontFamily + ',' + referenceFont, text);
                // If width and referenceWidth are the same, then the fallback was used
                // instead of the font we wanted, so the font is not available.
                available = available && width != referenceWidth;
            }
        }
        if (available) return true;
        return false;
    }
    function check() {
        var done = true;
        var fonts = $d4aabc5c971073f1$export$1d36981fcadac93b.getKeys();
        for(var i = 0, ii = fonts.length; i < ii; ++i){
            var font = fonts[i];
            if ($d4aabc5c971073f1$export$1d36981fcadac93b.get(font) < retries) {
                if (isAvailable.apply(this, font.split('\n'))) {
                    (0, $beaefe87199bb537$export$42ffd38884aecdac)($d4aabc5c971073f1$export$7fdcec604f0b1fa7);
                    // Make sure that loaded fonts are picked up by Safari
                    $d4aabc5c971073f1$var$measureContext = null;
                    $d4aabc5c971073f1$var$measureFont = undefined;
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(font, retries);
                } else {
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(font, $d4aabc5c971073f1$export$1d36981fcadac93b.get(font) + 1, true);
                    done = false;
                }
            }
        }
        if (done) {
            clearInterval(interval);
            interval = undefined;
        }
    }
    return function(fontSpec) {
        var font = (0, $ce07df6d5d4656f1$export$5abde8a6aec4a131)(fontSpec);
        if (!font) return;
        var families = font.families;
        for(var i = 0, ii = families.length; i < ii; ++i){
            var family = families[i];
            var key = font.style + '\n' + font.weight + '\n' + family;
            if ($d4aabc5c971073f1$export$1d36981fcadac93b.get(key) === undefined) {
                $d4aabc5c971073f1$export$1d36981fcadac93b.set(key, retries, true);
                if (!isAvailable(font.style, font.weight, family)) {
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(key, 0, true);
                    if (interval === undefined) interval = setInterval(check, 32);
                }
            }
        }
    };
}();
var $d4aabc5c971073f1$export$4feaf6852ff92513 = function() {
    /**
     * @type {HTMLDivElement}
     */ var div;
    return function(fontSpec) {
        var height = $d4aabc5c971073f1$export$7fdcec604f0b1fa7[fontSpec];
        if (height == undefined) {
            if (0, $67c66761d21428d0$export$98fcef3dc9973292) {
                var font = (0, $ce07df6d5d4656f1$export$5abde8a6aec4a131)(fontSpec);
                var metrics = $d4aabc5c971073f1$var$measureText(fontSpec, "\u017Dg");
                var lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!div) {
                    div = document.createElement('div');
                    div.innerHTML = 'M';
                    div.style.margin = '0 !important';
                    div.style.padding = '0 !important';
                    div.style.position = 'absolute !important';
                    div.style.left = '-99999px !important';
                }
                div.style.font = fontSpec;
                document.body.appendChild(div);
                height = div.offsetHeight;
                document.body.removeChild(div);
            }
            $d4aabc5c971073f1$export$7fdcec604f0b1fa7[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function $d4aabc5c971073f1$var$measureText(font, text) {
    if (!$d4aabc5c971073f1$var$measureContext) $d4aabc5c971073f1$var$measureContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1);
    if (font != $d4aabc5c971073f1$var$measureFont) {
        $d4aabc5c971073f1$var$measureContext.font = font;
        $d4aabc5c971073f1$var$measureFont = $d4aabc5c971073f1$var$measureContext.font;
    }
    return $d4aabc5c971073f1$var$measureContext.measureText(text);
}
function $d4aabc5c971073f1$export$4ea92329b673abd1(font, text) {
    return $d4aabc5c971073f1$var$measureText(font, text).width;
}
function $d4aabc5c971073f1$export$915c7ba51467308f(font, text, cache) {
    if (text in cache) return cache[text];
    var width = $d4aabc5c971073f1$export$4ea92329b673abd1(font, text);
    cache[text] = width;
    return width;
}
function $d4aabc5c971073f1$export$a539decdd6096c57(font, lines, widths) {
    var numLines = lines.length;
    var width = 0;
    for(var i = 0; i < numLines; ++i){
        var currentWidth = $d4aabc5c971073f1$export$4ea92329b673abd1(font, lines[i]);
        width = Math.max(width, currentWidth);
        widths.push(currentWidth);
    }
    return width;
}
function $d4aabc5c971073f1$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function $d4aabc5c971073f1$export$3cb6f3a6e49cc0ee(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) context.globalAlpha *= opacity;
    if (transform) context.setTransform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        $d4aabc5c971073f1$var$executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D} context Context.
 */ function $d4aabc5c971073f1$var$executeLabelInstructions(label, context) {
    var contextInstructions = label.contextInstructions;
    for(var i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}
/**
 * @type {HTMLCanvasElement}
 * @private
 */ var $d4aabc5c971073f1$var$createTransformStringCanvas = null;
function $d4aabc5c971073f1$export$e989e34b92d28568(transform) {
    if (0, $67c66761d21428d0$export$98fcef3dc9973292) return (0, $e22e7611e69f42a9$export$f84e8e69fd4488a5)(transform);
    else {
        if (!$d4aabc5c971073f1$var$createTransformStringCanvas) $d4aabc5c971073f1$var$createTransformStringCanvas = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1).canvas;
        $d4aabc5c971073f1$var$createTransformStringCanvas.style.transform = (0, $e22e7611e69f42a9$export$f84e8e69fd4488a5)(transform);
        return $d4aabc5c971073f1$var$createTransformStringCanvas.style.transform;
    }
}





var $fa78c97693b12120$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ var $fa78c97693b12120$var$CompositeMapRenderer = /** @class */ function(_super) {
    $fa78c97693b12120$var$__extends(CompositeMapRenderer, _super);
    /**
     * @param {import("../PluggableMap.js").default} map Map.
     */ function CompositeMapRenderer(map) {
        var _this = _super.call(this, map) || this;
        /**
         * @type {import("../events.js").EventsKey}
         */ _this.fontChangeListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)((0, $d4aabc5c971073f1$export$1d36981fcadac93b), (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, map.redrawText.bind(map));
        /**
         * @private
         * @type {HTMLDivElement}
         */ _this.element_ = document.createElement('div');
        var style = _this.element_.style;
        style.position = 'absolute';
        style.width = '100%';
        style.height = '100%';
        style.zIndex = '0';
        _this.element_.className = (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + ' ol-layers';
        var container = map.getViewport();
        container.insertBefore(_this.element_, container.firstChild || null);
        /**
         * @private
         * @type {Array<HTMLElement>}
         */ _this.children_ = [];
        /**
         * @private
         * @type {boolean}
         */ _this.renderedVisible_ = true;
        return _this;
    }
    /**
     * @param {import("../render/EventType.js").default} type Event type.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     */ CompositeMapRenderer.prototype.dispatchRenderEvent = function(type, frameState) {
        var map = this.getMap();
        if (map.hasListener(type)) {
            var event_1 = new (0, $b80dddceb0c42ad4$export$2e2bcd8739ae039)(type, undefined, frameState);
            map.dispatchEvent(event_1);
        }
    };
    CompositeMapRenderer.prototype.disposeInternal = function() {
        (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.fontChangeListenerKey_);
        this.element_.parentNode.removeChild(this.element_);
        _super.prototype.disposeInternal.call(this);
    };
    /**
     * Render.
     * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
     */ CompositeMapRenderer.prototype.renderFrame = function(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRECOMPOSE, frameState);
        var layerStatesArray = frameState.layerStatesArray.sort(function(a, b) {
            return a.zIndex - b.zIndex;
        });
        var viewState = frameState.viewState;
        this.children_.length = 0;
        /**
         * @type {Array<import("../layer/BaseVector.js").default>}
         */ var declutterLayers = [];
        var previousElement = null;
        for(var i = 0, ii = layerStatesArray.length; i < ii; ++i){
            var layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            if (!(0, $534f30fce11effcd$export$acb1e9cb9ce4ca56)(layerState, viewState) || layerState.sourceState != (0, $98f5bfe3c4864f05$export$2e2bcd8739ae039).READY && layerState.sourceState != (0, $98f5bfe3c4864f05$export$2e2bcd8739ae039).UNDEFINED) continue;
            var layer = layerState.layer;
            var element = layer.render(frameState, previousElement);
            if (!element) continue;
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            if ('getDeclutter' in layer) declutterLayers.push(layer);
        }
        for(var i = declutterLayers.length - 1; i >= 0; --i)declutterLayers[i].renderDeclutter(frameState);
        (0, $075f937d7366f1a2$export$caeacfe04f52533a)(this.element_, this.children_);
        this.dispatchRenderEvent((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = '';
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    };
    /**
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {function(import("../layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback Layer
     *     callback.
     * @param {function(import("../layer/Layer.js").default): boolean} layerFilter Layer filter
     *     function, only layers which are visible and for which this function
     *     returns `true` will be tested for features.  By default, all visible
     *     layers will be tested.
     * @return {T|undefined} Callback result.
     * @template T
     */ CompositeMapRenderer.prototype.forEachLayerAtPixel = function(pixel, frameState, hitTolerance, callback, layerFilter) {
        var viewState = frameState.viewState;
        var layerStates = frameState.layerStatesArray;
        var numLayers = layerStates.length;
        for(var i = numLayers - 1; i >= 0; --i){
            var layerState = layerStates[i];
            var layer = layerState.layer;
            if (layer.hasRenderer() && (0, $534f30fce11effcd$export$acb1e9cb9ce4ca56)(layerState, viewState) && layerFilter(layer)) {
                var layerRenderer = layer.getRenderer();
                var data = layerRenderer.getDataAtPixel(pixel, frameState, hitTolerance);
                if (data) {
                    var result = callback(layer, data);
                    if (result) return result;
                }
            }
        }
        return undefined;
    };
    return CompositeMapRenderer;
}((0, $b370ab32454a96fd$export$2e2bcd8739ae039));
var $fa78c97693b12120$export$2e2bcd8739ae039 = $fa78c97693b12120$var$CompositeMapRenderer;





/**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $161dd067fe2d672c$export$2e2bcd8739ae039 = {
    /**
     * Triggered when an item is added to the collection.
     * @event module:ol/Collection.CollectionEvent#add
     * @api
     */ ADD: 'add',
    /**
     * Triggered when an item is removed from the collection.
     * @event module:ol/Collection.CollectionEvent#remove
     * @api
     */ REMOVE: 'remove'
};



var $931ffc4e747c14db$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @enum {string}
 * @private
 */ var $931ffc4e747c14db$var$Property = {
    LENGTH: 'length'
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/Collection~Collection} instances are instances of this
 * type.
 */ var $931ffc4e747c14db$export$a87ae6eb2761ec6d = /** @class */ function(_super) {
    $931ffc4e747c14db$var$__extends(CollectionEvent, _super);
    /**
     * @param {import("./CollectionEventType.js").default} type Type.
     * @param {*=} opt_element Element.
     * @param {number=} opt_index The index of the added or removed element.
     */ function CollectionEvent(type, opt_element, opt_index) {
        var _this = _super.call(this, type) || this;
        /**
         * The element that is added to or removed from the collection.
         * @type {*}
         * @api
         */ _this.element = opt_element;
        /**
         * The index of the added or removed element.
         * @type {number}
         * @api
         */ _this.index = opt_index;
        return _this;
    }
    return CollectionEvent;
}((0, $aeedce20e9577100$export$2e2bcd8739ae039));
/**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ var $931ffc4e747c14db$var$Collection = /** @class */ function(_super) {
    $931ffc4e747c14db$var$__extends(Collection, _super);
    /**
     * @param {Array<T>=} opt_array Array.
     * @param {Options=} opt_options Collection options.
     */ function Collection(opt_array, opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options || {};
        /**
         * @private
         * @type {boolean}
         */ _this.unique_ = !!options.unique;
        /**
         * @private
         * @type {!Array<T>}
         */ _this.array_ = opt_array ? opt_array : [];
        if (_this.unique_) for(var i = 0, ii = _this.array_.length; i < ii; ++i)_this.assertUnique_(_this.array_[i], i);
        _this.updateLength_();
        return _this;
    }
    /**
     * Remove all elements from the collection.
     * @api
     */ Collection.prototype.clear = function() {
        while(this.getLength() > 0)this.pop();
    };
    /**
     * Add elements to the collection.  This pushes each item in the provided array
     * to the end of the collection.
     * @param {!Array<T>} arr Array.
     * @return {Collection<T>} This collection.
     * @api
     */ Collection.prototype.extend = function(arr) {
        for(var i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    };
    /**
     * Iterate over each element, calling the provided callback.
     * @param {function(T, number, Array<T>): *} f The function to call
     *     for every element. This function takes 3 arguments (the element, the
     *     index and the array). The return value is ignored.
     * @api
     */ Collection.prototype.forEach = function(f) {
        var array = this.array_;
        for(var i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    };
    /**
     * Get a reference to the underlying Array object. Warning: if the array
     * is mutated, no events will be dispatched by the collection, and the
     * collection's "length" property won't be in sync with the actual length
     * of the array.
     * @return {!Array<T>} Array.
     * @api
     */ Collection.prototype.getArray = function() {
        return this.array_;
    };
    /**
     * Get the element at the provided index.
     * @param {number} index Index.
     * @return {T} Element.
     * @api
     */ Collection.prototype.item = function(index) {
        return this.array_[index];
    };
    /**
     * Get the length of this collection.
     * @return {number} The length of the array.
     * @observable
     * @api
     */ Collection.prototype.getLength = function() {
        return this.get($931ffc4e747c14db$var$Property.LENGTH);
    };
    /**
     * Insert an element at the provided index.
     * @param {number} index Index.
     * @param {T} elem Element.
     * @api
     */ Collection.prototype.insertAt = function(index, elem) {
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, elem, index));
    };
    /**
     * Remove the last element of the collection and return it.
     * Return `undefined` if the collection is empty.
     * @return {T|undefined} Element.
     * @api
     */ Collection.prototype.pop = function() {
        return this.removeAt(this.getLength() - 1);
    };
    /**
     * Insert the provided element at the end of the collection.
     * @param {T} elem Element.
     * @return {number} New length of the collection.
     * @api
     */ Collection.prototype.push = function(elem) {
        if (this.unique_) this.assertUnique_(elem);
        var n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    };
    /**
     * Remove the first occurrence of an element from the collection.
     * @param {T} elem Element.
     * @return {T|undefined} The removed element or undefined if none found.
     * @api
     */ Collection.prototype.remove = function(elem) {
        var arr = this.array_;
        for(var i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    };
    /**
     * Remove the element at the provided index and return it.
     * Return `undefined` if the collection does not contain this index.
     * @param {number} index Index.
     * @return {T|undefined} Value.
     * @api
     */ Collection.prototype.removeAt = function(index) {
        var prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, prev, index));
        return prev;
    };
    /**
     * Set the element at the provided index.
     * @param {number} index Index.
     * @param {T} elem Element.
     * @api
     */ Collection.prototype.setAt = function(index, elem) {
        var n = this.getLength();
        if (index < n) {
            if (this.unique_) this.assertUnique_(elem, index);
            var prev = this.array_[index];
            this.array_[index] = elem;
            this.dispatchEvent(new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, prev, index));
            this.dispatchEvent(new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, elem, index));
        } else {
            for(var j = n; j < index; ++j)this.insertAt(j, undefined);
            this.insertAt(index, elem);
        }
    };
    /**
     * @private
     */ Collection.prototype.updateLength_ = function() {
        this.set($931ffc4e747c14db$var$Property.LENGTH, this.array_.length);
    };
    /**
     * @private
     * @param {T} elem Element.
     * @param {number=} opt_except Optional index to ignore.
     */ Collection.prototype.assertUnique_ = function(elem, opt_except) {
        for(var i = 0, ii = this.array_.length; i < ii; ++i){
            if (this.array_[i] === elem && i !== opt_except) throw new (0, $40658b5e833b516b$export$2e2bcd8739ae039)(58);
        }
    };
    return Collection;
}((0, $b68b3d6e32e3074a$export$2e2bcd8739ae039));
var $931ffc4e747c14db$export$2e2bcd8739ae039 = $931ffc4e747c14db$var$Collection;
















var $0b703156bb914e6f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|import("../Collection.js").default<import("./Base.js").default>} [layers] Child layers.
 */ /**
 * @enum {string}
 * @private
 */ var $0b703156bb914e6f$var$Property = {
    LAYERS: 'layers'
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @api
 */ var $0b703156bb914e6f$var$LayerGroup = /** @class */ function(_super) {
    $0b703156bb914e6f$var$__extends(LayerGroup, _super);
    /**
     * @param {Options=} opt_options Layer options.
     */ function LayerGroup(opt_options) {
        var _this = this;
        var options = opt_options || {};
        var baseOptions = /** @type {Options} */ (0, $beaefe87199bb537$export$e6e34fd1f2686227)({}, options);
        delete baseOptions.layers;
        var layers = options.layers;
        _this = _super.call(this, baseOptions) || this;
        /**
         * @private
         * @type {Array<import("../events.js").EventsKey>}
         */ _this.layersListenerKeys_ = [];
        /**
         * @private
         * @type {Object<string, Array<import("../events.js").EventsKey>>}
         */ _this.listenerKeys_ = {};
        _this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)($0b703156bb914e6f$var$Property.LAYERS), _this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(layers.slice(), {
                unique: true
            });
            else (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ layers.getArray === 'function', 43); // Expected `layers` to be an array or a `Collection`
        } else layers = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(undefined, {
            unique: true
        });
        _this.setLayers(layers);
        return _this;
    }
    /**
     * @private
     */ LayerGroup.prototype.handleLayerChange_ = function() {
        this.changed();
    };
    /**
     * @private
     */ LayerGroup.prototype.handleLayersChanged_ = function() {
        this.layersListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.layersListenerKeys_.length = 0;
        var layers = this.getLayers();
        this.layersListenerKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layers, (0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, this.handleLayersAdd_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layers, (0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, this.handleLayersRemove_, this));
        for(var id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.listenerKeys_);
        var layersArray = layers.getArray();
        for(var i = 0, ii = layersArray.length; i < ii; i++){
            var layer = layersArray[i];
            this.listenerKeys_[(0, $6c5e11070e371322$export$5e82334337e0f204)(layer)] = [
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleLayerChange_, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleLayerChange_, this)
            ];
        }
        this.changed();
    };
    /**
     * @param {import("../Collection.js").CollectionEvent} collectionEvent CollectionEvent.
     * @private
     */ LayerGroup.prototype.handleLayersAdd_ = function(collectionEvent) {
        var layer = /** @type {import("./Base.js").default} */ collectionEvent.element;
        this.listenerKeys_[(0, $6c5e11070e371322$export$5e82334337e0f204)(layer)] = [
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleLayerChange_, this)
        ];
        this.changed();
    };
    /**
     * @param {import("../Collection.js").CollectionEvent} collectionEvent CollectionEvent.
     * @private
     */ LayerGroup.prototype.handleLayersRemove_ = function(collectionEvent) {
        var layer = /** @type {import("./Base.js").default} */ collectionEvent.element;
        var key = (0, $6c5e11070e371322$export$5e82334337e0f204)(layer);
        this.listenerKeys_[key].forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        delete this.listenerKeys_[key];
        this.changed();
    };
    /**
     * Returns the {@link module:ol/Collection collection} of {@link module:ol/layer/Layer~Layer layers}
     * in this group.
     * @return {!import("../Collection.js").default<import("./Base.js").default>} Collection of
     *   {@link module:ol/layer/Base layers} that are part of this group.
     * @observable
     * @api
     */ LayerGroup.prototype.getLayers = function() {
        return /** @type {!import("../Collection.js").default<import("./Base.js").default>} */ this.get($0b703156bb914e6f$var$Property.LAYERS);
    };
    /**
     * Set the {@link module:ol/Collection collection} of {@link module:ol/layer/Layer~Layer layers}
     * in this group.
     * @param {!import("../Collection.js").default<import("./Base.js").default>} layers Collection of
     *   {@link module:ol/layer/Base layers} that are part of this group.
     * @observable
     * @api
     */ LayerGroup.prototype.setLayers = function(layers) {
        this.set($0b703156bb914e6f$var$Property.LAYERS, layers);
    };
    /**
     * @param {Array<import("./Layer.js").default>=} opt_array Array of layers (to be modified in place).
     * @return {Array<import("./Layer.js").default>} Array of layers.
     */ LayerGroup.prototype.getLayersArray = function(opt_array) {
        var array = opt_array !== undefined ? opt_array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    };
    /**
     * @param {Array<import("./Layer.js").State>=} opt_states Optional list of layer states (to be modified in place).
     * @return {Array<import("./Layer.js").State>} List of layer states.
     */ LayerGroup.prototype.getLayerStatesArray = function(opt_states) {
        var states = opt_states !== undefined ? opt_states : [];
        var pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        var ownLayerState = this.getLayerState();
        for(var i = pos, ii = states.length; i < ii; i++){
            var layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
        }
        return states;
    };
    /**
     * @return {import("../source/State.js").default} Source state.
     */ LayerGroup.prototype.getSourceState = function() {
        return (0, $98f5bfe3c4864f05$export$2e2bcd8739ae039).READY;
    };
    return LayerGroup;
}((0, $57c5f0299cb9b82f$export$2e2bcd8739ae039));
var $0b703156bb914e6f$export$2e2bcd8739ae039 = $0b703156bb914e6f$var$LayerGroup;



var $3a171922c3a0c5ed$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/PluggableMap~PluggableMap} for which events trigger a map event.
 */ var $3a171922c3a0c5ed$var$MapEvent = /** @class */ function(_super) {
    $3a171922c3a0c5ed$var$__extends(MapEvent, _super);
    /**
     * @param {string} type Event type.
     * @param {import("./PluggableMap.js").default} map Map.
     * @param {?import("./PluggableMap.js").FrameState=} opt_frameState Frame state.
     */ function MapEvent(type, map, opt_frameState) {
        var _this = _super.call(this, type) || this;
        /**
         * The map where the event occurred.
         * @type {import("./PluggableMap.js").default}
         * @api
         */ _this.map = map;
        /**
         * The frame state at the time of the event.
         * @type {?import("./PluggableMap.js").FrameState}
         * @api
         */ _this.frameState = opt_frameState !== undefined ? opt_frameState : null;
        return _this;
    }
    return MapEvent;
}((0, $aeedce20e9577100$export$2e2bcd8739ae039));
var $3a171922c3a0c5ed$export$2e2bcd8739ae039 = $3a171922c3a0c5ed$var$MapEvent;


var $a1b91f073c6a6c43$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/PluggableMap~PluggableMap} for which events trigger a map browser event.
 * @template {UIEvent} EVENT
 */ var $a1b91f073c6a6c43$var$MapBrowserEvent = /** @class */ function(_super) {
    $a1b91f073c6a6c43$var$__extends(MapBrowserEvent, _super);
    /**
     * @param {string} type Event type.
     * @param {import("./PluggableMap.js").default} map Map.
     * @param {EVENT} originalEvent Original event.
     * @param {boolean=} opt_dragging Is the map currently being dragged?
     * @param {?import("./PluggableMap.js").FrameState=} opt_frameState Frame state.
     */ function MapBrowserEvent(type, map, originalEvent, opt_dragging, opt_frameState) {
        var _this = _super.call(this, type, map, opt_frameState) || this;
        /**
         * The original browser event.
         * @const
         * @type {EVENT}
         * @api
         */ _this.originalEvent = originalEvent;
        /**
         * The map pixel relative to the viewport corresponding to the original browser event.
         * @type {?import("./pixel.js").Pixel}
         */ _this.pixel_ = null;
        /**
         * The coordinate in the user projection corresponding to the original browser event.
         * @type {?import("./coordinate.js").Coordinate}
         */ _this.coordinate_ = null;
        /**
         * Indicates if the map is currently being dragged. Only set for
         * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
         *
         * @type {boolean}
         * @api
         */ _this.dragging = opt_dragging !== undefined ? opt_dragging : false;
        return _this;
    }
    Object.defineProperty(MapBrowserEvent.prototype, "pixel", {
        /**
         * The map pixel relative to the viewport corresponding to the original event.
         * @type {import("./pixel.js").Pixel}
         * @api
         */ get: function() {
            if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
            return this.pixel_;
        },
        set: function(pixel) {
            this.pixel_ = pixel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MapBrowserEvent.prototype, "coordinate", {
        /**
         * The coordinate corresponding to the original browser event.  This will be in the user
         * projection if one is set.  Otherwise it will be in the view projection.
         * @type {import("./coordinate.js").Coordinate}
         * @api
         */ get: function() {
            if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
            return this.coordinate_;
        },
        set: function(coordinate) {
            this.coordinate_ = coordinate;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Prevents the default browser action.
     * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
     * @api
     */ MapBrowserEvent.prototype.preventDefault = function() {
        _super.prototype.preventDefault.call(this);
        this.originalEvent.preventDefault();
    };
    /**
     * Prevents further propagation of the current event.
     * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
     * @api
     */ MapBrowserEvent.prototype.stopPropagation = function() {
        _super.prototype.stopPropagation.call(this);
        this.originalEvent.stopPropagation();
    };
    return MapBrowserEvent;
}((0, $3a171922c3a0c5ed$export$2e2bcd8739ae039));
var $a1b91f073c6a6c43$export$2e2bcd8739ae039 = $a1b91f073c6a6c43$var$MapBrowserEvent;


/**
 * @module ol/MapBrowserEventHandler
 */ 


/**
 * @module ol/MapBrowserEventType
 */ 
var /**
 * Constants for event names.
 * @enum {string}
 */ $150f412a4a7fa263$export$2e2bcd8739ae039 = {
    /**
     * A true single click with no dragging and no double click. Note that this
     * event is delayed by 250 ms to ensure that it is not a double click.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
     * @api
     */ SINGLECLICK: 'singleclick',
    /**
     * A click with no dragging. A double click will fire two of this.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
     * @api
     */ CLICK: (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK,
    /**
     * A true double click, with no dragging.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
     * @api
     */ DBLCLICK: (0, $294047c5e65f31a3$export$2e2bcd8739ae039).DBLCLICK,
    /**
     * Triggered when a pointer is dragged.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
     * @api
     */ POINTERDRAG: 'pointerdrag',
    /**
     * Triggered when a pointer is moved. Note that on touch devices this is
     * triggered when the map is panned, so is not the same as mousemove.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
     * @api
     */ POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};


/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $d564567e31203d44$export$2e2bcd8739ae039 = {
    POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};




var $6085d006f9d0efe2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6085d006f9d0efe2$var$MapBrowserEventHandler = /** @class */ function(_super) {
    $6085d006f9d0efe2$var$__extends(MapBrowserEventHandler, _super);
    /**
     * @param {import("./PluggableMap.js").default} map The map with the viewport to listen to events on.
     * @param {number=} moveTolerance The minimal distance the pointer must travel to trigger a move.
     */ function MapBrowserEventHandler(map, moveTolerance) {
        var _this = _super.call(this, map) || this;
        /**
         * This is the element that we will listen to the real events on.
         * @type {import("./PluggableMap.js").default}
         * @private
         */ _this.map_ = map;
        /**
         * @type {any}
         * @private
         */ _this.clickTimeoutId_;
        /**
         * Emulate dblclick and singleclick. Will be true when only one pointer is active.
         * @type {boolean}
         */ _this.emulateClicks_ = false;
        /**
         * @type {boolean}
         * @private
         */ _this.dragging_ = false;
        /**
         * @type {!Array<import("./events.js").EventsKey>}
         * @private
         */ _this.dragListenerKeys_ = [];
        /**
         * @type {number}
         * @private
         */ _this.moveTolerance_ = moveTolerance ? moveTolerance * (0, $67c66761d21428d0$export$6b83a0446fc26f94) : (0, $67c66761d21428d0$export$6b83a0446fc26f94);
        /**
         * The most recent "down" type event (or null if none have occurred).
         * Set on pointerdown.
         * @type {PointerEvent}
         * @private
         */ _this.down_ = null;
        var element = _this.map_.getViewport();
        /**
         * @type {number}
         * @private
         */ _this.activePointers_ = 0;
        /**
         * @type {!Object<number, boolean>}
         * @private
         */ _this.trackedTouches_ = {};
        _this.element_ = element;
        /**
         * @type {?import("./events.js").EventsKey}
         * @private
         */ _this.pointerdownListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(element, (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERDOWN, _this.handlePointerDown_, _this);
        /**
         * @type {PointerEvent}
         * @private
         */ _this.originalPointerMoveEvent_;
        /**
         * @type {?import("./events.js").EventsKey}
         * @private
         */ _this.relayedListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(element, (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERMOVE, _this.relayEvent_, _this);
        /**
         * @private
         */ _this.boundHandleTouchMove_ = _this.handleTouchMove_.bind(_this);
        _this.element_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).TOUCHMOVE, _this.boundHandleTouchMove_, (0, $67c66761d21428d0$export$f751ce96c6c4e4fc) ? {
            passive: false
        } : false);
        return _this;
    }
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */ MapBrowserEventHandler.prototype.emulateClick_ = function(pointerEvent) {
        var newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout(/** @this {MapBrowserEventHandler} */ (function() {
            this.clickTimeoutId_ = undefined;
            var newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }).bind(this), 250);
    };
    /**
     * Keeps track on how many pointers are currently active.
     *
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */ MapBrowserEventHandler.prototype.updateActivePointers_ = function(pointerEvent) {
        var event = pointerEvent;
        if (event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP || event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERCANCEL) delete this.trackedTouches_[event.pointerId];
        else if (event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN) this.trackedTouches_[event.pointerId] = true;
        this.activePointers_ = Object.keys(this.trackedTouches_).length;
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */ MapBrowserEventHandler.prototype.handlePointerUp_ = function(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        var newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.stopPropagation() or event.preventDefault().
        if (this.emulateClicks_ && !newEvent.propagationStopped && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_ === 0) {
            this.dragListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @return {boolean} If the left mouse button was pressed.
     * @private
     */ MapBrowserEventHandler.prototype.isMouseActionButton_ = function(pointerEvent) {
        return pointerEvent.button === 0;
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */ MapBrowserEventHandler.prototype.handlePointerDown_ = function(pointerEvent) {
        this.emulateClicks_ = this.activePointers_ === 0;
        this.updateActivePointers_(pointerEvent);
        var newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        this.down_ = pointerEvent;
        if (this.dragListenerKeys_.length === 0) {
            var doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(doc, (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE, this.handlePointerMove_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(doc, (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
             * `pointerEventHandler_` and not `documentPointerEventHandler_` like
             * the `pointerup` and `pointermove` listeners.
             *
             * The reason for this is the following: `TouchSource.vacuumTouches_()`
             * issues `pointercancel` events, when there was no `touchend` for a
             * `touchstart`. Now, let's say a first `touchstart` is registered on
             * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
             * But `documentPointerEventHandler_` doesn't know about the first
             * `touchstart`. If there is no `touchend` for the `touchstart`, we can
             * only receive a `touchcancel` from `pointerEventHandler_`, because it is
             * only registered there.
             */ (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.element_, (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.element_.getRootNode(), (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this));
        }
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */ MapBrowserEventHandler.prototype.handlePointerMove_ = function(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.dragging_ = true;
            var newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG, this.map_, pointerEvent, this.dragging_);
            this.dispatchEvent(newEvent);
        }
    };
    /**
     * Wrap and relay a pointer event.  Note that this requires that the type
     * string for the MapBrowserEvent matches the PointerEvent type.
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */ MapBrowserEventHandler.prototype.relayEvent_ = function(pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        var dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)(pointerEvent.type, this.map_, pointerEvent, dragging));
    };
    /**
     * Flexible handling of a `touch-action: none` css equivalent: because calling
     * `preventDefault()` on a `pointermove` event does not stop native page scrolling
     * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
     * when an interaction (currently `DragPan` handles the event.
     * @param {TouchEvent} event Event.
     * @private
     */ MapBrowserEventHandler.prototype.handleTouchMove_ = function(event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events.
        if (!this.originalPointerMoveEvent_ || this.originalPointerMoveEvent_.defaultPrevented) event.preventDefault();
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @return {boolean} Is moving.
     * @private
     */ MapBrowserEventHandler.prototype.isMoving_ = function(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    };
    /**
     * Clean up.
     */ MapBrowserEventHandler.prototype.disposeInternal = function() {
        if (this.relayedListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        _super.prototype.disposeInternal.call(this);
    };
    return MapBrowserEventHandler;
}((0, $08c28d22c0cb5a39$export$2e2bcd8739ae039));
var $6085d006f9d0efe2$export$2e2bcd8739ae039 = $6085d006f9d0efe2$var$MapBrowserEventHandler;




/**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $e4ad75f913b6f7ff$export$2e2bcd8739ae039 = {
    /**
     * Triggered after a map frame is rendered.
     * @event module:ol/MapEvent~MapEvent#postrender
     * @api
     */ POSTRENDER: 'postrender',
    /**
     * Triggered when the map starts moving.
     * @event module:ol/MapEvent~MapEvent#movestart
     * @api
     */ MOVESTART: 'movestart',
    /**
     * Triggered after the map is moved.
     * @event module:ol/MapEvent~MapEvent#moveend
     * @api
     */ MOVEEND: 'moveend'
};


/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $07fa325567004bb7$export$2e2bcd8739ae039 = {
    LAYERGROUP: 'layergroup',
    SIZE: 'size',
    TARGET: 'target',
    VIEW: 'view'
};






/**
 * @module ol/structs/PriorityQueue
 */ 

var $716c6804ea170b71$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See http://closure-library.googlecode.com/svn/docs/closure_goog_structs_heap.js.source.html
 * and http://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ var $716c6804ea170b71$var$PriorityQueue = /** @class */ function() {
    /**
     * @param {function(T): number} priorityFunction Priority function.
     * @param {function(T): string} keyFunction Key function.
     */ function PriorityQueue(priorityFunction, keyFunction) {
        /**
         * @type {function(T): number}
         * @private
         */ this.priorityFunction_ = priorityFunction;
        /**
         * @type {function(T): string}
         * @private
         */ this.keyFunction_ = keyFunction;
        /**
         * @type {Array<T>}
         * @private
         */ this.elements_ = [];
        /**
         * @type {Array<number>}
         * @private
         */ this.priorities_ = [];
        /**
         * @type {!Object<string, boolean>}
         * @private
         */ this.queuedElements_ = {};
    }
    /**
     * FIXME empty description for jsdoc
     */ PriorityQueue.prototype.clear = function() {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.queuedElements_);
    };
    /**
     * Remove and return the highest-priority element. O(log N).
     * @return {T} Element.
     */ PriorityQueue.prototype.dequeue = function() {
        var elements = this.elements_;
        var priorities = this.priorities_;
        var element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        } else {
            elements[0] = elements.pop();
            priorities[0] = priorities.pop();
            this.siftUp_(0);
        }
        var elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    };
    /**
     * Enqueue an element. O(log N).
     * @param {T} element Element.
     * @return {boolean} The element was added to the queue.
     */ PriorityQueue.prototype.enqueue = function(element) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!(this.keyFunction_(element) in this.queuedElements_), 31); // Tried to enqueue an `element` that was already added to the queue
        var priority = this.priorityFunction_(element);
        if (priority != $716c6804ea170b71$export$b4af72c40fd57063) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    };
    /**
     * @return {number} Count.
     */ PriorityQueue.prototype.getCount = function() {
        return this.elements_.length;
    };
    /**
     * Gets the index of the left child of the node at the given index.
     * @param {number} index The index of the node to get the left child for.
     * @return {number} The index of the left child.
     * @private
     */ PriorityQueue.prototype.getLeftChildIndex_ = function(index) {
        return index * 2 + 1;
    };
    /**
     * Gets the index of the right child of the node at the given index.
     * @param {number} index The index of the node to get the right child for.
     * @return {number} The index of the right child.
     * @private
     */ PriorityQueue.prototype.getRightChildIndex_ = function(index) {
        return index * 2 + 2;
    };
    /**
     * Gets the index of the parent of the node at the given index.
     * @param {number} index The index of the node to get the parent for.
     * @return {number} The index of the parent.
     * @private
     */ PriorityQueue.prototype.getParentIndex_ = function(index) {
        return index - 1 >> 1;
    };
    /**
     * Make this a heap. O(N).
     * @private
     */ PriorityQueue.prototype.heapify_ = function() {
        var i;
        for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
    };
    /**
     * @return {boolean} Is empty.
     */ PriorityQueue.prototype.isEmpty = function() {
        return this.elements_.length === 0;
    };
    /**
     * @param {string} key Key.
     * @return {boolean} Is key queued.
     */ PriorityQueue.prototype.isKeyQueued = function(key) {
        return key in this.queuedElements_;
    };
    /**
     * @param {T} element Element.
     * @return {boolean} Is queued.
     */ PriorityQueue.prototype.isQueued = function(element) {
        return this.isKeyQueued(this.keyFunction_(element));
    };
    /**
     * @param {number} index The index of the node to move down.
     * @private
     */ PriorityQueue.prototype.siftUp_ = function(index) {
        var elements = this.elements_;
        var priorities = this.priorities_;
        var count = elements.length;
        var element = elements[index];
        var priority = priorities[index];
        var startIndex = index;
        while(index < count >> 1){
            var lIndex = this.getLeftChildIndex_(index);
            var rIndex = this.getRightChildIndex_(index);
            var smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    };
    /**
     * @param {number} startIndex The index of the root.
     * @param {number} index The index of the node to move up.
     * @private
     */ PriorityQueue.prototype.siftDown_ = function(startIndex, index) {
        var elements = this.elements_;
        var priorities = this.priorities_;
        var element = elements[index];
        var priority = priorities[index];
        while(index > startIndex){
            var parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            } else break;
        }
        elements[index] = element;
        priorities[index] = priority;
    };
    /**
     * FIXME empty description for jsdoc
     */ PriorityQueue.prototype.reprioritize = function() {
        var priorityFunction = this.priorityFunction_;
        var elements = this.elements_;
        var priorities = this.priorities_;
        var index = 0;
        var n = elements.length;
        var element, i, priority;
        for(i = 0; i < n; ++i){
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == $716c6804ea170b71$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    };
    return PriorityQueue;
}();
var $716c6804ea170b71$export$2e2bcd8739ae039 = $716c6804ea170b71$var$PriorityQueue;


/**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $b8291d9739c3c64e$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
     * Indicates that tile loading failed
     * @type {number}
     */ ERROR: 3,
    EMPTY: 4
};


var $4c51fd53052a6bbc$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {function(import("./Tile.js").default, string, import("./coordinate.js").Coordinate, number): number} PriorityFunction
 */ var $4c51fd53052a6bbc$var$TileQueue = /** @class */ function(_super) {
    $4c51fd53052a6bbc$var$__extends(TileQueue, _super);
    /**
     * @param {PriorityFunction} tilePriorityFunction Tile priority function.
     * @param {function(): ?} tileChangeCallback Function called on each tile change event.
     */ function TileQueue(tilePriorityFunction, tileChangeCallback) {
        var _this = _super.call(this, /**
         * @param {Array} element Element.
         * @return {number} Priority.
         */ function(element) {
            return tilePriorityFunction.apply(null, element);
        }, /**
         * @param {Array} element Element.
         * @return {string} Key.
         */ function(element) {
            return /** @type {import("./Tile.js").default} */ element[0].getKey();
        }) || this;
        /** @private */ _this.boundHandleTileChange_ = _this.handleTileChange.bind(_this);
        /**
         * @private
         * @type {function(): ?}
         */ _this.tileChangeCallback_ = tileChangeCallback;
        /**
         * @private
         * @type {number}
         */ _this.tilesLoading_ = 0;
        /**
         * @private
         * @type {!Object<string,boolean>}
         */ _this.tilesLoadingKeys_ = {};
        return _this;
    }
    /**
     * @param {Array} element Element.
     * @return {boolean} The element was added to the queue.
     */ TileQueue.prototype.enqueue = function(element) {
        var added = _super.prototype.enqueue.call(this, element);
        if (added) {
            var tile = element[0];
            tile.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
        }
        return added;
    };
    /**
     * @return {number} Number of tiles loading.
     */ TileQueue.prototype.getTilesLoading = function() {
        return this.tilesLoading_;
    };
    /**
     * @param {import("./events/Event.js").default} event Event.
     * @protected
     */ TileQueue.prototype.handleTileChange = function(event) {
        var tile = /** @type {import("./Tile.js").default} */ event.target;
        var state = tile.getState();
        if (tile.hifi && state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED || state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR || state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) {
            tile.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
            var tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    };
    /**
     * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
     * @param {number} maxNewLoads Maximum number of new tiles to load.
     */ TileQueue.prototype.loadMoreTiles = function(maxTotalLoading, maxNewLoads) {
        var newLoads = 0;
        var state, tile, tileKey;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            tile = /** @type {import("./Tile.js").default} */ this.dequeue()[0];
            tileKey = tile.getKey();
            state = tile.getState();
            if (state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    };
    return TileQueue;
}((0, $716c6804ea170b71$export$2e2bcd8739ae039));
var $4c51fd53052a6bbc$export$2e2bcd8739ae039 = $4c51fd53052a6bbc$var$TileQueue;
function $4c51fd53052a6bbc$export$f08ad5eceeff5d45(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $716c6804ea170b71$export$b4af72c40fd57063;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $716c6804ea170b71$export$b4af72c40fd57063;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    var center = frameState.viewState.center;
    var deltaX = tileCenter[0] - center[0];
    var deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}



/**
 * @module ol/geom/GeometryType
 */ /**
 * The geometry type. One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, `'Circle'`.
 * @enum {string}
 */ var $419865bd7211e6e7$export$2e2bcd8739ae039 = {
    POINT: 'Point',
    LINE_STRING: 'LineString',
    LINEAR_RING: 'LinearRing',
    POLYGON: 'Polygon',
    MULTI_POINT: 'MultiPoint',
    MULTI_LINE_STRING: 'MultiLineString',
    MULTI_POLYGON: 'MultiPolygon',
    GEOMETRY_COLLECTION: 'GeometryCollection',
    CIRCLE: 'Circle'
};


/**
 * @module ol/proj/Units
 */ /**
 * Projection units: `'degrees'`, `'ft'`, `'m'`, `'pixels'`, `'tile-pixels'` or
 * `'us-ft'`.
 * @enum {string}
 */ var $03edbd434a9e6608$var$Units = {
    /**
     * Degrees
     * @api
     */ DEGREES: 'degrees',
    /**
     * Feet
     * @api
     */ FEET: 'ft',
    /**
     * Meters
     * @api
     */ METERS: 'm',
    /**
     * Pixels
     * @api
     */ PIXELS: 'pixels',
    /**
     * Tile Pixels
     * @api
     */ TILE_PIXELS: 'tile-pixels',
    /**
     * US Feet
     * @api
     */ USFEET: 'us-ft'
};
var $03edbd434a9e6608$export$1482081eec883108 = {};
// use the radius of the Normal sphere
$03edbd434a9e6608$export$1482081eec883108[$03edbd434a9e6608$var$Units.DEGREES] = 2 * Math.PI * 6370997 / 360;
$03edbd434a9e6608$export$1482081eec883108[$03edbd434a9e6608$var$Units.FEET] = 0.3048;
$03edbd434a9e6608$export$1482081eec883108[$03edbd434a9e6608$var$Units.METERS] = 1;
$03edbd434a9e6608$export$1482081eec883108[$03edbd434a9e6608$var$Units.USFEET] = 1200 / 3937;
var $03edbd434a9e6608$export$2e2bcd8739ae039 = $03edbd434a9e6608$var$Units;


/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $7d362782b4ccb93d$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};


/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $d35baefbe89be4c5$export$2e2bcd8739ae039 = {
    CENTER: 'center',
    RESOLUTION: 'resolution',
    ROTATION: 'rotation'
};


/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ var $57cd8651d88957a0$export$e98a216cdcc847dc = 42;
var $57cd8651d88957a0$export$6b8cb5cd370bd90c = 256;


/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * * a list of {@link module:ol/proj/Projection}
 * objects, one for each projection supported by the application
 * * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://epsg.io/, and are a JS function, so can be loaded in a script
 * tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj~addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection} object for the new projection and add it with
 * {@link module:ol/proj~addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj~addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection} with
 * {@link module:ol/proj~addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ 

/**
 * @module ol/proj/Projection
 */ 
/**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").default|string} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link module:ol/proj/Units~METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {function(number, import("../coordinate.js").Coordinate):number} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `{number}` view resolution and an `{import("../coordinate.js").Coordinate}` as arguments, and returns
 * the `{number}` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj#getPointResolution} function will be used.
 */ /**
 * @classdesc
 * Projection definition class. One of these is created for each projection
 * supported in the application and stored in the {@link module:ol/proj} namespace.
 * You can use these in applications, but this is not required, as API params
 * and options use {@link module:ol/proj~ProjectionLike} which means the simple string
 * code will suffice.
 *
 * You can use {@link module:ol/proj~get} to retrieve the object for a particular
 * projection.
 *
 * The library includes definitions for `EPSG:4326` and `EPSG:3857`, together
 * with the following aliases:
 * * `EPSG:4326`: CRS:84, urn:ogc:def:crs:EPSG:6.6:4326,
 *     urn:ogc:def:crs:OGC:1.3:CRS84, urn:ogc:def:crs:OGC:2:84,
 *     http://www.opengis.net/gml/srs/epsg.xml#4326,
 *     urn:x-ogc:def:crs:EPSG:4326
 * * `EPSG:3857`: EPSG:102100, EPSG:102113, EPSG:900913,
 *     urn:ogc:def:crs:EPSG:6.18:3:3857,
 *     http://www.opengis.net/gml/srs/epsg.xml#3857
 *
 * If you use [proj4js](https://github.com/proj4js/proj4js), aliases can
 * be added using `proj4.defs()`. After all required projection definitions are
 * added, call the {@link module:ol/proj/proj4~register} function.
 *
 * @api
 */ var $6dc418afeec7068a$var$Projection = /** @class */ function() {
    /**
     * @param {Options} options Projection options.
     */ function Projection(options) {
        /**
         * @private
         * @type {string}
         */ this.code_ = options.code;
        /**
         * Units of projected coordinates. When set to `TILE_PIXELS`, a
         * `this.extent_` and `this.worldExtent_` must be configured properly for each
         * tile.
         * @private
         * @type {import("./Units.js").default}
         */ this.units_ = /** @type {import("./Units.js").default} */ options.units;
        /**
         * Validity extent of the projection in projected coordinates. For projections
         * with `TILE_PIXELS` units, this is the extent of the tile in
         * tile pixel space.
         * @private
         * @type {import("../extent.js").Extent}
         */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
         * Extent of the world in EPSG:4326. For projections with
         * `TILE_PIXELS` units, this is the extent of the tile in
         * projected coordinate space.
         * @private
         * @type {import("../extent.js").Extent}
         */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
         * @private
         * @type {string}
         */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : 'enu';
        /**
         * @private
         * @type {boolean}
         */ this.global_ = options.global !== undefined ? options.global : false;
        /**
         * @private
         * @type {boolean}
         */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
         * @private
         * @type {function(number, import("../coordinate.js").Coordinate):number|undefined}
         */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
         * @private
         * @type {import("../tilegrid/TileGrid.js").default}
         */ this.defaultTileGrid_ = null;
        /**
         * @private
         * @type {number|undefined}
         */ this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
     * @return {boolean} The projection is suitable for wrapping the x-axis
     */ Projection.prototype.canWrapX = function() {
        return this.canWrapX_;
    };
    /**
     * Get the code for this projection, e.g. 'EPSG:4326'.
     * @return {string} Code.
     * @api
     */ Projection.prototype.getCode = function() {
        return this.code_;
    };
    /**
     * Get the validity extent for this projection.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */ Projection.prototype.getExtent = function() {
        return this.extent_;
    };
    /**
     * Get the units of this projection.
     * @return {import("./Units.js").default} Units.
     * @api
     */ Projection.prototype.getUnits = function() {
        return this.units_;
    };
    /**
     * Get the amount of meters per unit of this projection.  If the projection is
     * not configured with `metersPerUnit` or a units identifier, the return is
     * `undefined`.
     * @return {number|undefined} Meters.
     * @api
     */ Projection.prototype.getMetersPerUnit = function() {
        return this.metersPerUnit_ || (0, $03edbd434a9e6608$export$1482081eec883108)[this.units_];
    };
    /**
     * Get the world extent for this projection.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */ Projection.prototype.getWorldExtent = function() {
        return this.worldExtent_;
    };
    /**
     * Get the axis orientation of this projection.
     * Example values are:
     * enu - the default easting, northing, elevation.
     * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
     *     or south orientated transverse mercator.
     * wnu - westing, northing, up - some planetary coordinate systems have
     *     "west positive" coordinate systems
     * @return {string} Axis orientation.
     * @api
     */ Projection.prototype.getAxisOrientation = function() {
        return this.axisOrientation_;
    };
    /**
     * Is this projection a global projection which spans the whole world?
     * @return {boolean} Whether the projection is global.
     * @api
     */ Projection.prototype.isGlobal = function() {
        return this.global_;
    };
    /**
     * Set if the projection is a global projection which spans the whole world
     * @param {boolean} global Whether the projection is global.
     * @api
     */ Projection.prototype.setGlobal = function(global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    };
    /**
     * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
     */ Projection.prototype.getDefaultTileGrid = function() {
        return this.defaultTileGrid_;
    };
    /**
     * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
     */ Projection.prototype.setDefaultTileGrid = function(tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    };
    /**
     * Set the validity extent for this projection.
     * @param {import("../extent.js").Extent} extent Extent.
     * @api
     */ Projection.prototype.setExtent = function(extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    };
    /**
     * Set the world extent for this projection.
     * @param {import("../extent.js").Extent} worldExtent World extent
     *     [minlon, minlat, maxlon, maxlat].
     * @api
     */ Projection.prototype.setWorldExtent = function(worldExtent) {
        this.worldExtent_ = worldExtent;
    };
    /**
     * Set the getPointResolution function (see {@link module:ol/proj~getPointResolution}
     * for this projection.
     * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
     * @api
     */ Projection.prototype.setGetPointResolution = function(func) {
        this.getPointResolutionFunc_ = func;
    };
    /**
     * Get the custom point resolution function for this projection (if set).
     * @return {function(number, import("../coordinate.js").Coordinate):number|undefined} The custom point
     * resolution function (if set).
     */ Projection.prototype.getPointResolutionFunc = function() {
        return this.getPointResolutionFunc_;
    };
    return Projection;
}();
var $6dc418afeec7068a$export$2e2bcd8739ae039 = $6dc418afeec7068a$var$Projection;




var $84ad988f04807ab1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $84ad988f04807ab1$export$2d2c9be8b5b863f = 6378137;
var $84ad988f04807ab1$export$f3928063e5e96d35 = Math.PI * $84ad988f04807ab1$export$2d2c9be8b5b863f;
var $84ad988f04807ab1$export$21e6da8a7375dfe8 = [
    -$84ad988f04807ab1$export$f3928063e5e96d35,
    -$84ad988f04807ab1$export$f3928063e5e96d35,
    $84ad988f04807ab1$export$f3928063e5e96d35,
    $84ad988f04807ab1$export$f3928063e5e96d35
];
var $84ad988f04807ab1$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
var $84ad988f04807ab1$export$d26945d1ad52feeb = $84ad988f04807ab1$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ var $84ad988f04807ab1$var$EPSG3857Projection = /** @class */ function(_super) {
    $84ad988f04807ab1$var$__extends(EPSG3857Projection, _super);
    /**
     * @param {string} code Code.
     */ function EPSG3857Projection(code) {
        return _super.call(this, {
            code: code,
            units: (0, $03edbd434a9e6608$export$2e2bcd8739ae039).METERS,
            extent: $84ad988f04807ab1$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $84ad988f04807ab1$export$ae9d6ed80df710e5,
            getPointResolution: function(resolution, point) {
                return resolution / (0, $6b000a049d919fe5$export$2e2fd1ad24e4d350)(point[1] / $84ad988f04807ab1$export$2d2c9be8b5b863f);
            }
        }) || this;
    }
    return EPSG3857Projection;
}((0, $6dc418afeec7068a$export$2e2bcd8739ae039));
var $84ad988f04807ab1$export$b508d7ad9a891c1b = [
    new $84ad988f04807ab1$var$EPSG3857Projection('EPSG:3857'),
    new $84ad988f04807ab1$var$EPSG3857Projection('EPSG:102100'),
    new $84ad988f04807ab1$var$EPSG3857Projection('EPSG:102113'),
    new $84ad988f04807ab1$var$EPSG3857Projection('EPSG:900913'),
    new $84ad988f04807ab1$var$EPSG3857Projection('http://www.opengis.net/gml/srs/epsg.xml#3857')
];
function $84ad988f04807ab1$export$1ff8bb36c0983070(input, opt_output, opt_dimension) {
    var length = input.length;
    var dimension = opt_dimension > 1 ? opt_dimension : 2;
    var output = opt_output;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(var i = 0; i < length; i += dimension){
        output[i] = $84ad988f04807ab1$export$f3928063e5e96d35 * input[i] / 180;
        var y = $84ad988f04807ab1$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > $84ad988f04807ab1$export$d26945d1ad52feeb) y = $84ad988f04807ab1$export$d26945d1ad52feeb;
        else if (y < -$84ad988f04807ab1$export$d26945d1ad52feeb) y = -$84ad988f04807ab1$export$d26945d1ad52feeb;
        output[i + 1] = y;
    }
    return output;
}
function $84ad988f04807ab1$export$8c71322ec28ed6b4(input, opt_output, opt_dimension) {
    var length = input.length;
    var dimension = opt_dimension > 1 ? opt_dimension : 2;
    var output = opt_output;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(var i = 0; i < length; i += dimension){
        output[i] = 180 * input[i] / $84ad988f04807ab1$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $84ad988f04807ab1$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}




var $b58ae362632b32c5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b58ae362632b32c5$export$2d2c9be8b5b863f = 6378137;
var $b58ae362632b32c5$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
var $b58ae362632b32c5$export$1482081eec883108 = Math.PI * $b58ae362632b32c5$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ var $b58ae362632b32c5$var$EPSG4326Projection = /** @class */ function(_super) {
    $b58ae362632b32c5$var$__extends(EPSG4326Projection, _super);
    /**
     * @param {string} code Code.
     * @param {string=} opt_axisOrientation Axis orientation.
     */ function EPSG4326Projection(code, opt_axisOrientation) {
        return _super.call(this, {
            code: code,
            units: (0, $03edbd434a9e6608$export$2e2bcd8739ae039).DEGREES,
            extent: $b58ae362632b32c5$export$21e6da8a7375dfe8,
            axisOrientation: opt_axisOrientation,
            global: true,
            metersPerUnit: $b58ae362632b32c5$export$1482081eec883108,
            worldExtent: $b58ae362632b32c5$export$21e6da8a7375dfe8
        }) || this;
    }
    return EPSG4326Projection;
}((0, $6dc418afeec7068a$export$2e2bcd8739ae039));
var $b58ae362632b32c5$export$b508d7ad9a891c1b = [
    new $b58ae362632b32c5$var$EPSG4326Projection('CRS:84'),
    new $b58ae362632b32c5$var$EPSG4326Projection('EPSG:4326', 'neu'),
    new $b58ae362632b32c5$var$EPSG4326Projection('urn:ogc:def:crs:OGC:1.3:CRS84'),
    new $b58ae362632b32c5$var$EPSG4326Projection('urn:ogc:def:crs:OGC:2:84'),
    new $b58ae362632b32c5$var$EPSG4326Projection('http://www.opengis.net/gml/srs/epsg.xml#4326', 'neu')
];


/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ var $f5ec5c943d804ecb$var$cache = {};
function $f5ec5c943d804ecb$export$42ffd38884aecdac() {
    $f5ec5c943d804ecb$var$cache = {};
}
function $f5ec5c943d804ecb$export$3988ae62b71be9a3(code) {
    return $f5ec5c943d804ecb$var$cache[code] || $f5ec5c943d804ecb$var$cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, 'EPSG:$3')] || null;
}
function $f5ec5c943d804ecb$export$e16d8520af44a096(code, projection) {
    $f5ec5c943d804ecb$var$cache[code] = projection;
}


/**
 * @module ol/proj/transforms
 */ 
/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ var $11b5dd198626e1de$var$transforms = {};
function $11b5dd198626e1de$export$42ffd38884aecdac() {
    $11b5dd198626e1de$var$transforms = {};
}
function $11b5dd198626e1de$export$e16d8520af44a096(source, destination, transformFn) {
    var sourceCode = source.getCode();
    var destinationCode = destination.getCode();
    if (!(sourceCode in $11b5dd198626e1de$var$transforms)) $11b5dd198626e1de$var$transforms[sourceCode] = {};
    $11b5dd198626e1de$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $11b5dd198626e1de$export$cd7f480d6b8286c3(source, destination) {
    var sourceCode = source.getCode();
    var destinationCode = destination.getCode();
    var transform = $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    delete $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    if ((0, $beaefe87199bb537$export$dd1bc94b04021eeb)($11b5dd198626e1de$var$transforms[sourceCode])) delete $11b5dd198626e1de$var$transforms[sourceCode];
    return transform;
}
function $11b5dd198626e1de$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    var transform;
    if (sourceCode in $11b5dd198626e1de$var$transforms && destinationCode in $11b5dd198626e1de$var$transforms[sourceCode]) transform = $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    return transform;
}




/**
 * @module ol/sphere
 */ 

var $fb75384508533d8f$export$63f2df7bd7371262 = 6371008.8;
function $fb75384508533d8f$export$79376507b09a66f(c1, c2, opt_radius) {
    var radius = opt_radius || $fb75384508533d8f$export$63f2df7bd7371262;
    var lat1 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c1[1]);
    var lat2 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c2[1]);
    var deltaLatBy2 = (lat2 - lat1) / 2;
    var deltaLonBy2 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c2[0] - c1[0]) / 2;
    var a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $fb75384508533d8f$var$getLengthInternal(coordinates, radius) {
    var length = 0;
    for(var i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $fb75384508533d8f$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $fb75384508533d8f$export$f0d11c074a923179(geometry, opt_options) {
    var options = opt_options || {};
    var radius = options.radius || $fb75384508533d8f$export$63f2df7bd7371262;
    var projection = options.projection || 'EPSG:3857';
    var type = geometry.getType();
    if (type !== (0, $419865bd7211e6e7$export$2e2bcd8739ae039).GEOMETRY_COLLECTION) geometry = geometry.clone().transform(projection, 'EPSG:4326');
    var length = 0;
    var coordinates, coords, i, ii, j, jj;
    switch(type){
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POINT:
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POINT:
            break;
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING:
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINEAR_RING:
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $fb75384508533d8f$var$getLengthInternal(coordinates, radius);
            break;
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_LINE_STRING:
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON:
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $fb75384508533d8f$var$getLengthInternal(coordinates[i], radius);
            break;
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POLYGON:
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $fb75384508533d8f$var$getLengthInternal(coords[j], radius);
            }
            break;
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).GEOMETRY_COLLECTION:
            var geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
            for(i = 0, ii = geometries.length; i < ii; ++i)length += $fb75384508533d8f$export$f0d11c074a923179(geometries[i], opt_options);
            break;
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs-new.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $fb75384508533d8f$var$getAreaInternal(coordinates, radius) {
    var area = 0;
    var len = coordinates.length;
    var x1 = coordinates[len - 1][0];
    var y1 = coordinates[len - 1][1];
    for(var i = 0; i < len; i++){
        var x2 = coordinates[i][0];
        var y2 = coordinates[i][1];
        area += (0, $6b000a049d919fe5$export$cba01ba138429a1d)(x2 - x1) * (2 + Math.sin((0, $6b000a049d919fe5$export$cba01ba138429a1d)(y1)) + Math.sin((0, $6b000a049d919fe5$export$cba01ba138429a1d)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $fb75384508533d8f$export$520c40045967cb15(geometry, opt_options) {
    var options = opt_options || {};
    var radius = options.radius || $fb75384508533d8f$export$63f2df7bd7371262;
    var projection = options.projection || 'EPSG:3857';
    var type = geometry.getType();
    if (type !== (0, $419865bd7211e6e7$export$2e2bcd8739ae039).GEOMETRY_COLLECTION) geometry = geometry.clone().transform(projection, 'EPSG:4326');
    var area = 0;
    var coordinates, coords, i, ii, j, jj;
    switch(type){
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POINT:
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POINT:
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING:
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_LINE_STRING:
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINEAR_RING:
            break;
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON:
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($fb75384508533d8f$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($fb75384508533d8f$var$getAreaInternal(coordinates[i], radius));
            break;
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POLYGON:
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($fb75384508533d8f$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($fb75384508533d8f$var$getAreaInternal(coords[j], radius));
            }
            break;
        case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).GEOMETRY_COLLECTION:
            var geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
            for(i = 0, ii = geometries.length; i < ii; ++i)area += $fb75384508533d8f$export$520c40045967cb15(geometries[i], opt_options);
            break;
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return area;
}
function $fb75384508533d8f$export$cc800923e997bb8(c1, distance, bearing, opt_radius) {
    var radius = opt_radius || $fb75384508533d8f$export$63f2df7bd7371262;
    var lat1 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c1[1]);
    var lon1 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c1[0]);
    var dByR = distance / radius;
    var lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    var lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $6b000a049d919fe5$export$56cb859c01fa134d)(lon),
        (0, $6b000a049d919fe5$export$56cb859c01fa134d)(lat)
    ];
}



function $9c4744460e43e41b$export$dd516654c5f598fb(input, opt_output, opt_dimension) {
    var output;
    if (opt_output !== undefined) {
        for(var i = 0, ii = input.length; i < ii; ++i)opt_output[i] = input[i];
        output = opt_output;
    } else output = input.slice();
    return output;
}
function $9c4744460e43e41b$export$83e8ab53904f8022(input, opt_output, opt_dimension) {
    if (opt_output !== undefined && input !== opt_output) {
        for(var i = 0, ii = input.length; i < ii; ++i)opt_output[i] = input[i];
        input = opt_output;
    }
    return input;
}
function $9c4744460e43e41b$export$59ae956cd3e343f7(projection) {
    (0, $f5ec5c943d804ecb$export$e16d8520af44a096)(projection.getCode(), projection);
    (0, $11b5dd198626e1de$export$e16d8520af44a096)(projection, projection, $9c4744460e43e41b$export$dd516654c5f598fb);
}
function $9c4744460e43e41b$export$638ad73f7aafb913(projections) {
    projections.forEach($9c4744460e43e41b$export$59ae956cd3e343f7);
}
function $9c4744460e43e41b$export$3988ae62b71be9a3(projectionLike) {
    return typeof projectionLike === 'string' ? (0, $f5ec5c943d804ecb$export$3988ae62b71be9a3)(/** @type {string} */ projectionLike) : /** @type {Projection} */ projectionLike || null;
}
function $9c4744460e43e41b$export$2d8f7b4eec383d44(projection, resolution, point, opt_units) {
    projection = $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
    var pointResolution;
    var getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (opt_units && opt_units !== projection.getUnits()) {
            var metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, $03edbd434a9e6608$export$1482081eec883108)[opt_units];
        }
    } else {
        var units = projection.getUnits();
        if (units == (0, $03edbd434a9e6608$export$2e2bcd8739ae039).DEGREES && !opt_units || opt_units == (0, $03edbd434a9e6608$export$2e2bcd8739ae039).DEGREES) pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            var toEPSG4326_1 = $9c4744460e43e41b$export$e3c4995a701c26a3(projection, $9c4744460e43e41b$export$3988ae62b71be9a3('EPSG:4326'));
            if (toEPSG4326_1 === $9c4744460e43e41b$export$83e8ab53904f8022 && units !== (0, $03edbd434a9e6608$export$2e2bcd8739ae039).DEGREES) // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                var vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326_1(vertices, vertices, 2);
                var width = (0, $fb75384508533d8f$export$79376507b09a66f)(vertices.slice(0, 2), vertices.slice(2, 4));
                var height = (0, $fb75384508533d8f$export$79376507b09a66f)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            var metersPerUnit = opt_units ? (0, $03edbd434a9e6608$export$1482081eec883108)[opt_units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function $9c4744460e43e41b$export$eeb8392580a05a37(projections) {
    $9c4744460e43e41b$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $11b5dd198626e1de$export$e16d8520af44a096)(source, destination, $9c4744460e43e41b$export$dd516654c5f598fb);
        });
    });
}
function $9c4744460e43e41b$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $11b5dd198626e1de$export$e16d8520af44a096)(projection1, projection2, forwardTransform);
            (0, $11b5dd198626e1de$export$e16d8520af44a096)(projection2, projection1, inverseTransform);
        });
    });
}
function $9c4744460e43e41b$export$4860237d10380594() {
    (0, $f5ec5c943d804ecb$export$42ffd38884aecdac)();
    (0, $11b5dd198626e1de$export$42ffd38884aecdac)();
}
function $9c4744460e43e41b$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $9c4744460e43e41b$export$3988ae62b71be9a3(defaultCode);
    else if (typeof projection === 'string') return $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
    else return /** @type {Projection} */ projection;
}
function $9c4744460e43e41b$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>=} opt_output Output.
     * @param {number=} opt_dimension Dimension.
     * @return {Array<number>} Output.
     */ function(input, opt_output, opt_dimension) {
        var length = input.length;
        var dimension = opt_dimension !== undefined ? opt_dimension : 2;
        var output = opt_output !== undefined ? opt_output : new Array(length);
        for(var i = 0; i < length; i += dimension){
            var point = coordTransform([
                input[i],
                input[i + 1]
            ]);
            output[i] = point[0];
            output[i + 1] = point[1];
            for(var j = dimension - 1; j >= 2; --j)output[i + j] = input[i + j];
        }
        return output;
    });
}
function $9c4744460e43e41b$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    var sourceProj = $9c4744460e43e41b$export$3988ae62b71be9a3(source);
    var destProj = $9c4744460e43e41b$export$3988ae62b71be9a3(destination);
    (0, $11b5dd198626e1de$export$e16d8520af44a096)(sourceProj, destProj, $9c4744460e43e41b$export$6b4aafd331159e0d(forward));
    (0, $11b5dd198626e1de$export$e16d8520af44a096)(destProj, sourceProj, $9c4744460e43e41b$export$6b4aafd331159e0d(inverse));
}
function $9c4744460e43e41b$export$b15d9668511529b9(coordinate, opt_projection) {
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, 'EPSG:4326', opt_projection !== undefined ? opt_projection : 'EPSG:3857');
}
function $9c4744460e43e41b$export$3fb495868742d370(coordinate, opt_projection) {
    var lonLat = $9c4744460e43e41b$export$51186ad6e864892a(coordinate, opt_projection !== undefined ? opt_projection : 'EPSG:3857', 'EPSG:4326');
    var lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $6b000a049d919fe5$export$ba467bec01d66def)(lon + 180, 360) - 180;
    return lonLat;
}
function $9c4744460e43e41b$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    var equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    else {
        var transformFunc = $9c4744460e43e41b$export$e3c4995a701c26a3(projection1, projection2);
        return transformFunc === $9c4744460e43e41b$export$dd516654c5f598fb && equalUnits;
    }
}
function $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection) {
    var sourceCode = sourceProjection.getCode();
    var destinationCode = destinationProjection.getCode();
    var transformFunc = (0, $11b5dd198626e1de$export$3988ae62b71be9a3)(sourceCode, destinationCode);
    if (!transformFunc) transformFunc = $9c4744460e43e41b$export$83e8ab53904f8022;
    return transformFunc;
}
function $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination) {
    var sourceProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(source);
    var destinationProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(destination);
    return $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $9c4744460e43e41b$export$51186ad6e864892a(coordinate, source, destination) {
    var transformFunc = $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination);
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $9c4744460e43e41b$export$751c68e0e0efff79(extent, source, destination, opt_stops) {
    var transformFunc = $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination);
    return (0, $6da4c8ed3074c92b$export$9f9dcb98c894b623)(extent, transformFunc, undefined, opt_stops);
}
function $9c4744460e43e41b$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    var transformFunc = $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {?Projection}
 */ var $9c4744460e43e41b$var$userProjection = null;
function $9c4744460e43e41b$export$d0aeadbeac54116e(projection) {
    $9c4744460e43e41b$var$userProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
}
function $9c4744460e43e41b$export$1ae11279759d4e8f() {
    $9c4744460e43e41b$var$userProjection = null;
}
function $9c4744460e43e41b$export$3973b77d5f6f2790() {
    return $9c4744460e43e41b$var$userProjection;
}
function $9c4744460e43e41b$export$aa7494edfbe36197() {
    $9c4744460e43e41b$export$d0aeadbeac54116e('EPSG:4326');
}
function $9c4744460e43e41b$export$698f563af1ba02a5(coordinate, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return coordinate;
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, sourceProjection, $9c4744460e43e41b$var$userProjection);
}
function $9c4744460e43e41b$export$d4b8ec0b96db1ee2(coordinate, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return coordinate;
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, $9c4744460e43e41b$var$userProjection, destProjection);
}
function $9c4744460e43e41b$export$96bfd09e2cffb006(extent, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return extent;
    return $9c4744460e43e41b$export$751c68e0e0efff79(extent, sourceProjection, $9c4744460e43e41b$var$userProjection);
}
function $9c4744460e43e41b$export$494be3a3a25689ca(extent, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return extent;
    return $9c4744460e43e41b$export$751c68e0e0efff79(extent, $9c4744460e43e41b$var$userProjection, destProjection);
}
function $9c4744460e43e41b$export$1873f9cfeb8bd1d6(sourceProj, destProj, transform) {
    return function(coord) {
        var sourceX = coord[0];
        var sourceY = coord[1];
        var transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            var sourceExtent = sourceProj.getExtent();
            var sourceExtentWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceExtent);
            worldsAway = (0, $1bd0a226f9a16141$export$24e2b27d1ff0c1d5)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            sourceX = sourceX - worldsAway * sourceExtentWidth;
            sourceX = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(sourceX, sourceExtent[0], sourceExtent[2]);
            sourceY = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(sourceY, sourceExtent[1], sourceExtent[3]);
            transformed = transform([
                sourceX,
                sourceY
            ]);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(destProj.getExtent());
        return transformed;
    };
}
function $9c4744460e43e41b$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $9c4744460e43e41b$export$eeb8392580a05a37((0, $84ad988f04807ab1$export$b508d7ad9a891c1b));
    $9c4744460e43e41b$export$eeb8392580a05a37((0, $b58ae362632b32c5$export$b508d7ad9a891c1b));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $9c4744460e43e41b$export$4856f21c2f184f24((0, $b58ae362632b32c5$export$b508d7ad9a891c1b), (0, $84ad988f04807ab1$export$b508d7ad9a891c1b), (0, $84ad988f04807ab1$export$1ff8bb36c0983070), (0, $84ad988f04807ab1$export$8c71322ec28ed6b4));
}
$9c4744460e43e41b$export$86eed449eb2dcac4();






/**
 * @module ol/centerconstraint
 */ 
function $b21a6e049949bb31$export$c2f0af2c946f6897(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean=} opt_isMoving True if an interaction or animation is in progress.
     * @param {Array<number>=} opt_centerShift Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, opt_isMoving, opt_centerShift) {
        if (center) {
            var viewWidth = onlyCenter ? 0 : size[0] * resolution;
            var viewHeight = onlyCenter ? 0 : size[1] * resolution;
            var shiftX = opt_centerShift ? opt_centerShift[0] : 0;
            var shiftY = opt_centerShift ? opt_centerShift[1] : 0;
            var minX = extent[0] + viewWidth / 2 + shiftX;
            var maxX = extent[2] - viewWidth / 2 + shiftX;
            var minY = extent[1] + viewHeight / 2 + shiftY;
            var maxY = extent[3] - viewHeight / 2 + shiftY;
            // note: when zooming out of bounds, min and max values for x and y may
            // end up inverted (min > max); this has to be accounted for
            if (minX > maxX) {
                minX = (maxX + minX) / 2;
                maxX = minX;
            }
            if (minY > maxY) {
                minY = (maxY + minY) / 2;
                maxY = minY;
            }
            var x = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(center[0], minX, maxX);
            var y = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(center[1], minY, maxY);
            var ratio = 30 * resolution;
            // during an interaction, allow some overscroll
            if (opt_isMoving && smooth) {
                x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
                y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
            }
            return [
                x,
                y
            ];
        } else return undefined;
    });
}
function $b21a6e049949bb31$export$f883a24d5edde77c(center) {
    return center;
}



/**
 * @module ol/resolutionconstraint
 */ 


/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function $bac43a1f4a628548$var$getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    var xResolution = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(maxExtent) / viewportSize[0];
    var yResolution = (0, $6da4c8ed3074c92b$export$c08559766941f856)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    var result = Math.min(resolution, maxResolution);
    var ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(result, minResolution / 2, maxResolution * 2);
}
function $bac43a1f4a628548$export$d65a517690fc4385(resolutions, opt_smooth, opt_maxExtent, opt_showFullExtent) {
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean=} opt_isMoving True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, opt_isMoving) {
        if (resolution !== undefined) {
            var maxResolution = resolutions[0];
            var minResolution = resolutions[resolutions.length - 1];
            var cappedMaxRes = opt_maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, opt_maxExtent, size, opt_showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (opt_isMoving) {
                var smooth = opt_smooth !== undefined ? opt_smooth : true;
                if (!smooth) return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            var capped = Math.min(cappedMaxRes, resolution);
            var z = Math.floor((0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        } else return undefined;
    });
}
function $bac43a1f4a628548$export$22ac0f6b219de91a(power, maxResolution, opt_minResolution, opt_smooth, opt_maxExtent, opt_showFullExtent) {
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean=} opt_isMoving True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, opt_isMoving) {
        if (resolution !== undefined) {
            var cappedMaxRes = opt_maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, opt_maxExtent, size, opt_showFullExtent) : maxResolution;
            var minResolution = opt_minResolution !== undefined ? opt_minResolution : 0;
            // during interacting or animating, allow intermediary values
            if (opt_isMoving) {
                var smooth = opt_smooth !== undefined ? opt_smooth : true;
                if (!smooth) return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            var tolerance = 1e-9;
            var minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            var offset = -direction * (0.5 - tolerance) + 0.5;
            var capped = Math.min(cappedMaxRes, resolution);
            var cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            var zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            var newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(newResolution, minResolution, cappedMaxRes);
        } else return undefined;
    });
}
function $bac43a1f4a628548$export$1c4e6da9b4b066fe(maxResolution, minResolution, opt_smooth, opt_maxExtent, opt_showFullExtent) {
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean=} opt_isMoving True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, opt_isMoving) {
        if (resolution !== undefined) {
            var cappedMaxRes = opt_maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, opt_maxExtent, size, opt_showFullExtent) : maxResolution;
            var smooth = opt_smooth !== undefined ? opt_smooth : true;
            if (!smooth || !opt_isMoving) return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
            return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        } else return undefined;
    });
}


/**
 * @module ol/rotationconstraint
 */ 
function $d65f0a322291d127$export$e20fbacbb41798b(rotation) {
    if (rotation !== undefined) return 0;
    else return undefined;
}
function $d65f0a322291d127$export$f883a24d5edde77c(rotation) {
    if (rotation !== undefined) return rotation;
    else return undefined;
}
function $d65f0a322291d127$export$9ba78806de831083(n) {
    var theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean=} opt_isMoving True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, opt_isMoving) {
        if (opt_isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        } else return undefined;
    });
}
function $d65f0a322291d127$export$17a6e6f3448b17e8(opt_tolerance) {
    var tolerance = opt_tolerance || (0, $6b000a049d919fe5$export$cba01ba138429a1d)(5);
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean=} opt_isMoving True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, opt_isMoving) {
        if (opt_isMoving) return rotation;
        if (rotation !== undefined) {
            if (Math.abs(rotation) <= tolerance) return 0;
            else return rotation;
        } else return undefined;
    });
}


/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $c7ccf7e681a9b333$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $c7ccf7e681a9b333$export$57636bb43b1ccbb0(t) {
    return 1 - $c7ccf7e681a9b333$export$929e5a82286172a6(1 - t);
}
function $c7ccf7e681a9b333$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $c7ccf7e681a9b333$export$45db2fc2f15997e7(t) {
    return t;
}
function $c7ccf7e681a9b333$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $c7ccf7e681a9b333$export$9b47139b511b56e4(2 * t);
    else return 1 - $c7ccf7e681a9b333$export$9b47139b511b56e4(2 * (t - 0.5));
}




/**
 * @module ol/geom/GeometryLayout
 */ /**
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available. Supported values are `'XY'`,
 * `'XYZ'`, `'XYM'`, `'XYZM'`.
 * @enum {string}
 */ var $42282ac5c8474df1$export$2e2bcd8739ae039 = {
    XY: 'XY',
    XYZ: 'XYZ',
    XYM: 'XYM',
    XYZM: 'XYZM'
};












/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>=} opt_dest Destination.
 * @return {Array<number>} Transformed coordinates.
 */ function $14c6e714516e527b$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        var x = flatCoordinates[j];
        var y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
    }
    if (opt_dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var anchorX = anchor[0];
    var anchorY = anchor[1];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        var deltaX = flatCoordinates[j] - anchorX;
        var deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(var k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (opt_dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var anchorX = anchor[0];
    var anchorY = anchor[1];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        var deltaX = flatCoordinates[j] - anchorX;
        var deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(var k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (opt_dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(var k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (opt_dest && dest.length != i) dest.length = i;
    return dest;
}


var $50db89a00eb954f6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @type {import("../transform.js").Transform}
 */ var $50db89a00eb954f6$var$tmpTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ var $50db89a00eb954f6$var$Geometry = /** @class */ function(_super) {
    $50db89a00eb954f6$var$__extends(Geometry, _super);
    function Geometry() {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */ _this.extent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
         * @private
         * @type {number}
         */ _this.extentRevision_ = -1;
        /**
         * @protected
         * @type {number}
         */ _this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
         * @protected
         * @type {number}
         */ _this.simplifiedGeometryRevision = 0;
        /**
         * Get a transformed and simplified version of the geometry.
         * @abstract
         * @param {number} revision The geometry revision.
         * @param {number} squaredTolerance Squared tolerance.
         * @param {import("../proj.js").TransformFunction} [opt_transform] Optional transform function.
         * @return {Geometry} Simplified geometry.
         */ _this.simplifyTransformedInternal = (0, $013a1733c226ec50$export$ff83df6f9971435f)(function(revision, squaredTolerance, opt_transform) {
            if (!opt_transform) return this.getSimplifiedGeometry(squaredTolerance);
            var clone = this.clone();
            clone.applyTransform(opt_transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
        return _this;
    }
    /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [opt_transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ Geometry.prototype.simplifyTransformed = function(squaredTolerance, opt_transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, opt_transform);
    };
    /**
     * Make a complete copy of the geometry.
     * @abstract
     * @return {!Geometry} Clone.
     */ Geometry.prototype.clone = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @abstract
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ Geometry.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @return {boolean} Contains (x, y).
     */ Geometry.prototype.containsXY = function(x, y) {
        var coord = this.getClosestPoint([
            x,
            y
        ]);
        return coord[0] === x && coord[1] === y;
    };
    /**
     * Return the closest point of the geometry to the passed point as
     * {@link module:ol/coordinate~Coordinate coordinate}.
     * @param {import("../coordinate.js").Coordinate} point Point.
     * @param {import("../coordinate.js").Coordinate=} opt_closestPoint Closest point.
     * @return {import("../coordinate.js").Coordinate} Closest point.
     * @api
     */ Geometry.prototype.getClosestPoint = function(point, opt_closestPoint) {
        var closestPoint = opt_closestPoint ? opt_closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    };
    /**
     * Returns true if this geometry includes the specified coordinate. If the
     * coordinate is on the boundary of the geometry, returns false.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains coordinate.
     * @api
     */ Geometry.prototype.intersectsCoordinate = function(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    };
    /**
     * @abstract
     * @param {import("../extent.js").Extent} extent Extent.
     * @protected
     * @return {import("../extent.js").Extent} extent Extent.
     */ Geometry.prototype.computeExtent = function(extent) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Get the extent of the geometry.
     * @param {import("../extent.js").Extent=} opt_extent Extent.
     * @return {import("../extent.js").Extent} extent Extent.
     * @api
     */ Geometry.prototype.getExtent = function(opt_extent) {
        if (this.extentRevision_ != this.getRevision()) {
            var extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) (0, $6da4c8ed3074c92b$export$3e2152b047719fa1)(extent);
            this.extentRevision_ = this.getRevision();
        }
        return (0, $6da4c8ed3074c92b$export$6a4fe494c558c238)(this.extent_, opt_extent);
    };
    /**
     * Rotate the geometry around a given coordinate. This modifies the geometry
     * coordinates in place.
     * @abstract
     * @param {number} angle Rotation angle in radians.
     * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
     * @api
     */ Geometry.prototype.rotate = function(angle, anchor) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Scale the geometry (with an optional origin).  This modifies the geometry
     * coordinates in place.
     * @abstract
     * @param {number} sx The scaling factor in the x-direction.
     * @param {number=} opt_sy The scaling factor in the y-direction (defaults to sx).
     * @param {import("../coordinate.js").Coordinate=} opt_anchor The scale origin (defaults to the center
     *     of the geometry extent).
     * @api
     */ Geometry.prototype.scale = function(sx, opt_sy, opt_anchor) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Create a simplified version of this geometry.  For linestrings, this uses
     * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
     * algorithm.  For polygons, a quantization-based
     * simplification is used to preserve topology.
     * @param {number} tolerance The tolerance distance for simplification.
     * @return {Geometry} A new, simplified version of the original geometry.
     * @api
     */ Geometry.prototype.simplify = function(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    };
    /**
     * Create a simplified version of this geometry using the Douglas Peucker
     * algorithm.
     * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
     * @abstract
     * @param {number} squaredTolerance Squared tolerance.
     * @return {Geometry} Simplified geometry.
     */ Geometry.prototype.getSimplifiedGeometry = function(squaredTolerance) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Get the type of this geometry.
     * @abstract
     * @return {import("./GeometryType.js").default} Geometry type.
     */ Geometry.prototype.getType = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Apply a transform function to the coordinates of the geometry.
     * The geometry is modified in place.
     * If you do not want the geometry modified in place, first `clone()` it and
     * then use this function on the clone.
     * @abstract
     * @param {import("../proj.js").TransformFunction} transformFn Transform function.
     * Called with a flat array of geometry coordinates.
     */ Geometry.prototype.applyTransform = function(transformFn) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @abstract
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     */ Geometry.prototype.intersectsExtent = function(extent) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Translate the geometry.  This modifies the geometry coordinates in place.  If
     * instead you want a new geometry, first `clone()` this geometry.
     * @abstract
     * @param {number} deltaX Delta X.
     * @param {number} deltaY Delta Y.
     * @api
     */ Geometry.prototype.translate = function(deltaX, deltaY) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Transform each coordinate of the geometry from one coordinate reference
     * system to another. The geometry is modified in place.
     * For example, a line will be transformed to a line and a circle to a circle.
     * If you do not want the geometry modified in place, first `clone()` it and
     * then use this function on the clone.
     *
     * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
     *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
     * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
     *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
     * @return {Geometry} This geometry.  Note that original geometry is
     *     modified in place.
     * @api
     */ Geometry.prototype.transform = function(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ var sourceProj = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(source);
        var transformFn = sourceProj.getUnits() == (0, $03edbd434a9e6608$export$2e2bcd8739ae039).TILE_PIXELS ? function(inCoordinates, outCoordinates, stride) {
            var pixelExtent = sourceProj.getExtent();
            var projectedExtent = sourceProj.getWorldExtent();
            var scale = (0, $6da4c8ed3074c92b$export$c08559766941f856)(projectedExtent) / (0, $6da4c8ed3074c92b$export$c08559766941f856)(pixelExtent);
            (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)($50db89a00eb954f6$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $14c6e714516e527b$export$b92b2dedcfff79de)(inCoordinates, 0, inCoordinates.length, stride, $50db89a00eb954f6$var$tmpTransform, outCoordinates);
            return (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(sourceProj, destination)(inCoordinates, outCoordinates, stride);
        } : (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    };
    return Geometry;
}((0, $b68b3d6e32e3074a$export$2e2bcd8739ae039));
var $50db89a00eb954f6$export$2e2bcd8739ae039 = $50db89a00eb954f6$var$Geometry;






var $c76e993e57efc8c4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ var $c76e993e57efc8c4$var$SimpleGeometry = /** @class */ function(_super) {
    $c76e993e57efc8c4$var$__extends(SimpleGeometry, _super);
    function SimpleGeometry() {
        var _this = _super.call(this) || this;
        /**
         * @protected
         * @type {import("./GeometryLayout.js").default}
         */ _this.layout = (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XY;
        /**
         * @protected
         * @type {number}
         */ _this.stride = 2;
        /**
         * @protected
         * @type {Array<number>}
         */ _this.flatCoordinates = null;
        return _this;
    }
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @protected
     * @return {import("../extent.js").Extent} extent Extent.
     */ SimpleGeometry.prototype.computeExtent = function(extent) {
        return (0, $6da4c8ed3074c92b$export$be0ab0bf96ca59ca)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    };
    /**
     * @abstract
     * @return {Array<*>} Coordinates.
     */ SimpleGeometry.prototype.getCoordinates = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Return the first coordinate of the geometry.
     * @return {import("../coordinate.js").Coordinate} First coordinate.
     * @api
     */ SimpleGeometry.prototype.getFirstCoordinate = function() {
        return this.flatCoordinates.slice(0, this.stride);
    };
    /**
     * @return {Array<number>} Flat coordinates.
     */ SimpleGeometry.prototype.getFlatCoordinates = function() {
        return this.flatCoordinates;
    };
    /**
     * Return the last coordinate of the geometry.
     * @return {import("../coordinate.js").Coordinate} Last point.
     * @api
     */ SimpleGeometry.prototype.getLastCoordinate = function() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    };
    /**
     * Return the {@link module:ol/geom/GeometryLayout layout} of the geometry.
     * @return {import("./GeometryLayout.js").default} Layout.
     * @api
     */ SimpleGeometry.prototype.getLayout = function() {
        return this.layout;
    };
    /**
     * Create a simplified version of this geometry using the Douglas Peucker algorithm.
     * @param {number} squaredTolerance Squared tolerance.
     * @return {SimpleGeometry} Simplified geometry.
     */ SimpleGeometry.prototype.getSimplifiedGeometry = function(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        var simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        var simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
        else {
            // Simplification did not actually remove any coordinates.  We now know
            // that any calls to getSimplifiedGeometry with a squaredTolerance less
            // than or equal to the current squaredTolerance will also not have any
            // effect.  This allows us to short circuit simplification (saving CPU
            // cycles) and prevents the cache of simplified geometries from filling
            // up with useless identical copies of this geometry (saving memory).
            this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
            return this;
        }
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {SimpleGeometry} Simplified geometry.
     * @protected
     */ SimpleGeometry.prototype.getSimplifiedGeometryInternal = function(squaredTolerance) {
        return this;
    };
    /**
     * @return {number} Stride.
     */ SimpleGeometry.prototype.getStride = function() {
        return this.stride;
    };
    /**
     * @param {import("./GeometryLayout.js").default} layout Layout.
     * @param {Array<number>} flatCoordinates Flat coordinates.
     */ SimpleGeometry.prototype.setFlatCoordinates = function(layout, flatCoordinates) {
        this.stride = $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    };
    /**
     * @abstract
     * @param {!Array<*>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
     */ SimpleGeometry.prototype.setCoordinates = function(coordinates, opt_layout) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @param {import("./GeometryLayout.js").default|undefined} layout Layout.
     * @param {Array<*>} coordinates Coordinates.
     * @param {number} nesting Nesting.
     * @protected
     */ SimpleGeometry.prototype.setLayout = function(layout, coordinates, nesting) {
        /** @type {number} */ var stride;
        if (layout) stride = $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout);
        else {
            for(var i = 0; i < nesting; ++i)if (coordinates.length === 0) {
                this.layout = (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XY;
                this.stride = 2;
                return;
            } else coordinates = /** @type {Array} */ coordinates[0];
            stride = coordinates.length;
            layout = $c76e993e57efc8c4$var$getLayoutForStride(stride);
        }
        this.layout = layout;
        this.stride = stride;
    };
    /**
     * Apply a transform function to the coordinates of the geometry.
     * The geometry is modified in place.
     * If you do not want the geometry modified in place, first `clone()` it and
     * then use this function on the clone.
     * @param {import("../proj.js").TransformFunction} transformFn Transform function.
     * Called with a flat array of geometry coordinates.
     * @api
     */ SimpleGeometry.prototype.applyTransform = function(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.stride);
            this.changed();
        }
    };
    /**
     * Rotate the geometry around a given coordinate. This modifies the geometry
     * coordinates in place.
     * @param {number} angle Rotation angle in counter-clockwise radians.
     * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
     * @api
     */ SimpleGeometry.prototype.rotate = function(angle, anchor) {
        var flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            var stride = this.getStride();
            (0, $14c6e714516e527b$export$bb628a54ab399bc9)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    };
    /**
     * Scale the geometry (with an optional origin).  This modifies the geometry
     * coordinates in place.
     * @param {number} sx The scaling factor in the x-direction.
     * @param {number=} opt_sy The scaling factor in the y-direction (defaults to sx).
     * @param {import("../coordinate.js").Coordinate=} opt_anchor The scale origin (defaults to the center
     *     of the geometry extent).
     * @api
     */ SimpleGeometry.prototype.scale = function(sx, opt_sy, opt_anchor) {
        var sy = opt_sy;
        if (sy === undefined) sy = sx;
        var anchor = opt_anchor;
        if (!anchor) anchor = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
        var flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            var stride = this.getStride();
            (0, $14c6e714516e527b$export$dcdf75081b88279d)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    };
    /**
     * Translate the geometry.  This modifies the geometry coordinates in place.  If
     * instead you want a new geometry, first `clone()` this geometry.
     * @param {number} deltaX Delta X.
     * @param {number} deltaY Delta Y.
     * @api
     */ SimpleGeometry.prototype.translate = function(deltaX, deltaY) {
        var flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            var stride = this.getStride();
            (0, $14c6e714516e527b$export$d73ee8ef04f5226a)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    };
    return SimpleGeometry;
}((0, $50db89a00eb954f6$export$2e2bcd8739ae039));
/**
 * @param {number} stride Stride.
 * @return {import("./GeometryLayout.js").default} layout Layout.
 */ function $c76e993e57efc8c4$var$getLayoutForStride(stride) {
    var layout;
    if (stride == 2) layout = (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XY;
    else if (stride == 3) layout = (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYZ;
    else if (stride == 4) layout = (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYZM;
    return /** @type {import("./GeometryLayout.js").default} */ layout;
}
function $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout) {
    var stride;
    if (layout == (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XY) stride = 2;
    else if (layout == (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYZ || layout == (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYM) stride = 3;
    else if (layout == (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYZM) stride = 4;
    return /** @type {number} */ stride;
}
function $c76e993e57efc8c4$export$a3767472617c7861(simpleGeometry, transform, opt_dest) {
    var flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    else {
        var stride = simpleGeometry.getStride();
        return (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, 0, flatCoordinates.length, stride, transform, opt_dest);
    }
}
var $c76e993e57efc8c4$export$2e2bcd8739ae039 = $c76e993e57efc8c4$var$SimpleGeometry;


/**
 * @module ol/geom/flat/closest
 */ 
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $bf5604c1b8258b71$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    var x1 = flatCoordinates[offset1];
    var y1 = flatCoordinates[offset1 + 1];
    var dx = flatCoordinates[offset2] - x1;
    var dy = flatCoordinates[offset2 + 1] - y1;
    var offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(var i = 0; i < stride; ++i)closestPoint[i] = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(var i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
    closestPoint.length = stride;
}
function $bf5604c1b8258b71$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        var squaredDelta = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $bf5604c1b8258b71$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        max = $bf5604c1b8258b71$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $bf5604c1b8258b71$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        max = $bf5604c1b8258b71$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $bf5604c1b8258b71$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, opt_tmpPoint) {
    if (offset == end) return minSquaredDistance;
    var i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        } else return minSquaredDistance;
    }
    var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [
        NaN,
        NaN
    ];
    var index = offset + stride;
    while(index < end){
        $bf5604c1b8258b71$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $bf5604c1b8258b71$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $bf5604c1b8258b71$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, opt_tmpPoint) {
    var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [
        NaN,
        NaN
    ];
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        minSquaredDistance = $bf5604c1b8258b71$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $bf5604c1b8258b71$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, opt_tmpPoint) {
    var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [
        NaN,
        NaN
    ];
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        minSquaredDistance = $bf5604c1b8258b71$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}



/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $6b086aa46281540d$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(var i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $6b086aa46281540d$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(var i = 0, ii = coordinates.length; i < ii; ++i){
        var coordinate = coordinates[i];
        for(var j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $6b086aa46281540d$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, opt_ends) {
    var ends = opt_ends ? opt_ends : [];
    var i = 0;
    for(var j = 0, jj = coordinatess.length; j < jj; ++j){
        var end = $6b086aa46281540d$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $6b086aa46281540d$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, opt_endss) {
    var endss = opt_endss ? opt_endss : [];
    var i = 0;
    for(var j = 0, jj = coordinatesss.length; j < jj; ++j){
        var ends = $6b086aa46281540d$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}


/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

function $8780aae6970f5f65$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, opt_simplifiedFlatCoordinates) {
    var simplifiedFlatCoordinates = opt_simplifiedFlatCoordinates !== undefined ? opt_simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $8780aae6970f5f65$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    var n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ var markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ var stack = [
        offset,
        end - stride
    ];
    var index = 0;
    while(stack.length > 0){
        var last = stack.pop();
        var first = stack.pop();
        var maxSquaredDistance = 0;
        var x1 = flatCoordinates[first];
        var y1 = flatCoordinates[first + 1];
        var x2 = flatCoordinates[last];
        var y2 = flatCoordinates[last + 1];
        for(var i = first + stride; i < last; i += stride){
            var x = flatCoordinates[i];
            var y = flatCoordinates[i + 1];
            var squaredDistance_1 = (0, $6b000a049d919fe5$export$251bb0a9cef172e6)(x, y, x1, y1, x2, y2);
            if (squaredDistance_1 > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance_1;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(var i = 0; i < n; ++i)if (markers[i]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride + 1];
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        simplifiedOffset = $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        var simplifiedEnds = [];
        simplifiedOffset = $8780aae6970f5f65$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    var x2 = x1;
    var y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $8780aae6970f5f65$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    var x1 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    var y1 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    var x2, y2;
    do {
        x2 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        var x3 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        var y3 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        var dx1 = x2 - x1;
        var dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        var dx2 = x3 - x1;
        var dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        simplifiedOffset = $8780aae6970f5f65$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        var simplifiedEnds = [];
        simplifiedOffset = $8780aae6970f5f65$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}


/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>=} opt_coordinates Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $5454470599558ddd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, opt_coordinates) {
    var coordinates = opt_coordinates !== undefined ? opt_coordinates : [];
    var i = 0;
    for(var j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $5454470599558ddd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, opt_coordinatess) {
    var coordinatess = opt_coordinatess !== undefined ? opt_coordinatess : [];
    var i = 0;
    for(var j = 0, jj = ends.length; j < jj; ++j){
        var end = ends[j];
        coordinatess[i++] = $5454470599558ddd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $5454470599558ddd$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, opt_coordinatesss) {
    var coordinatesss = opt_coordinatesss !== undefined ? opt_coordinatesss : [];
    var i = 0;
    for(var j = 0, jj = endss.length; j < jj; ++j){
        var ends = endss[j];
        coordinatesss[i++] = $5454470599558ddd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}


/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $01ff26a2f986a1d0$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    var twiceArea = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        twiceArea += y1 * x2 - x1 * y2;
        x1 = x2;
        y1 = y2;
    }
    return twiceArea / 2;
}
function $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    var area = 0;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        area += $01ff26a2f986a1d0$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $01ff26a2f986a1d0$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    var area = 0;
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        area += $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}


var $548636579b4087f2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ var $548636579b4087f2$var$LinearRing = /** @class */ function(_super) {
    $548636579b4087f2$var$__extends(LinearRing, _super);
    /**
     * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
     *     For internal use, flat coordinates in combination with `opt_layout` are also accepted.
     * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
     */ function LinearRing(coordinates, opt_layout) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {number}
         */ _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.maxDeltaRevision_ = -1;
        if (opt_layout !== undefined && !Array.isArray(coordinates[0])) _this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
        else _this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, opt_layout);
        return _this;
    }
    /**
     * Make a complete copy of the geometry.
     * @return {!LinearRing} Clone.
     * @api
     */ LinearRing.prototype.clone = function() {
        return new LinearRing(this.flatCoordinates.slice(), this.layout);
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ LinearRing.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * Return the area of the linear ring on projected plane.
     * @return {number} Area (on projected plane).
     * @api
     */ LinearRing.prototype.getArea = function() {
        return (0, $01ff26a2f986a1d0$export$3c5e1905f889266e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * Return the coordinates of the linear ring.
     * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
     * @api
     */ LinearRing.prototype.getCoordinates = function() {
        return (0, $5454470599558ddd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {LinearRing} Simplified LinearRing.
     * @protected
     */ LinearRing.prototype.getSimplifiedGeometryInternal = function(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new LinearRing(simplifiedFlatCoordinates, (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XY);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */ LinearRing.prototype.getType = function() {
        return (0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINEAR_RING;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ LinearRing.prototype.intersectsExtent = function(extent) {
        return false;
    };
    /**
     * Set the coordinates of the linear ring.
     * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
     * @api
     */ LinearRing.prototype.setCoordinates = function(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return LinearRing;
}((0, $c76e993e57efc8c4$export$2e2bcd8739ae039));
var $548636579b4087f2$export$2e2bcd8739ae039 = $548636579b4087f2$var$LinearRing;







var $6eced4c969949f6b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ var $6eced4c969949f6b$var$Point = /** @class */ function(_super) {
    $6eced4c969949f6b$var$__extends(Point, _super);
    /**
     * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
     */ function Point(coordinates, opt_layout) {
        var _this = _super.call(this) || this;
        _this.setCoordinates(coordinates, opt_layout);
        return _this;
    }
    /**
     * Make a complete copy of the geometry.
     * @return {!Point} Clone.
     * @api
     */ Point.prototype.clone = function() {
        var point = new Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ Point.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        var flatCoordinates = this.flatCoordinates;
        var squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            var stride = this.stride;
            for(var i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        } else return minSquaredDistance;
    };
    /**
     * Return the coordinate of the point.
     * @return {import("../coordinate.js").Coordinate} Coordinates.
     * @api
     */ Point.prototype.getCoordinates = function() {
        return !this.flatCoordinates ? [] : this.flatCoordinates.slice();
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @protected
     * @return {import("../extent.js").Extent} extent Extent.
     */ Point.prototype.computeExtent = function(extent) {
        return (0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(this.flatCoordinates, extent);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */ Point.prototype.getType = function() {
        return (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POINT;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ Point.prototype.intersectsExtent = function(extent) {
        return (0, $6da4c8ed3074c92b$export$805bdfd6d6690e97)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    };
    /**
     * @param {!Array<*>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
     * @api
     */ Point.prototype.setCoordinates = function(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$60815ead40ec79ab)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return Point;
}((0, $c76e993e57efc8c4$export$2e2bcd8739ae039));
var $6eced4c969949f6b$export$2e2bcd8739ae039 = $6eced4c969949f6b$var$Point;







/**
 * @module ol/geom/flat/interiorpoint
 */ /**
 * @module ol/geom/flat/contains
 */ 
function $239aa88e7a573859$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    var outside = (0, $6da4c8ed3074c92b$export$f9ed8a3d123a08e2)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // http://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    var wn = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $239aa88e7a573859$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(var i = 1, ii = ends.length; i < ii; ++i){
        if ($239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $239aa88e7a573859$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        if ($239aa88e7a573859$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}



function $2166f19777f69377$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, opt_dest) {
    var i, ii, x, x1, x2, y1, y2;
    var y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ var intersections = [];
    // Calculate intersections with the horizontal line
    for(var r = 0, rr = ends.length; r < rr; ++r){
        var end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    var pointX = NaN;
    var maxSegmentLength = -Infinity;
    intersections.sort((0, $b998d41b678ed5d1$export$4e734a3b32fb971b));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        var segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $239aa88e7a573859$export$ae868c0f6acc3355)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (opt_dest) {
        opt_dest.push(pointX, y, maxSegmentLength);
        return opt_dest;
    } else return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $2166f19777f69377$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    var interiorPoints = [];
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        interiorPoints = $2166f19777f69377$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}



/**
 * @module ol/geom/flat/intersectsextent
 */ 
/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ function $3e64078bffae1cbd$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback) {
    var point1 = [
        flatCoordinates[offset],
        flatCoordinates[offset + 1]
    ];
    var point2 = [];
    var ret;
    for(; offset + stride < end; offset += stride){
        point2[0] = flatCoordinates[offset + stride];
        point2[1] = flatCoordinates[offset + stride + 1];
        ret = callback(point1, point2);
        if (ret) return ret;
        point1[0] = point2[0];
        point1[1] = point2[1];
    }
    return false;
}



function $acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent) {
    var coordinatesExtent = (0, $6da4c8ed3074c92b$export$30570204156ffd18)((0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)(), flatCoordinates, offset, end, stride);
    if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(extent, coordinatesExtent)) return false;
    if ((0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(extent, coordinatesExtent)) return true;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2]) return true;
    if (coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $3e64078bffae1cbd$export$4b80e395e36b5a56)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $6da4c8ed3074c92b$export$a6a5a7a461419425)(extent, point1, point2);
    });
}
function $acee589e5b390c5c$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        if ($acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $acee589e5b390c5c$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $acee589e5b390c5c$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$acee589e5b390c5c$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(var i = 1, ii = ends.length; i < ii; ++i)if ((0, $239aa88e7a573859$export$cedabedc7ac0e138)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $acee589e5b390c5c$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        if ($acee589e5b390c5c$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


/**
 * @module ol/geom/flat/orient
 */ /**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $155dc783a4ec227e$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(var i = 0; i < stride; ++i){
            var tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}


function $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // http://tinyurl.com/clockwise-method
    // https://github.com/OSGeo/gdal/blob/trunk/gdal/ogr/ogrlinearring.cpp
    var edge = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function $7892dc06ffd23218$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, opt_right) {
    var right = opt_right !== undefined ? opt_right : false;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        var isClockwise = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $7892dc06ffd23218$export$a1d138f4bd85f4b4(flatCoordinates, offset, endss, stride, opt_right) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        if (!$7892dc06ffd23218$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, opt_right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function $7892dc06ffd23218$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, opt_right) {
    var right = opt_right !== undefined ? opt_right : false;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        var isClockwise = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        var reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $155dc783a4ec227e$export$741858880c96b18c)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $7892dc06ffd23218$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, opt_right) {
    for(var i = 0, ii = endss.length; i < ii; ++i)offset = $7892dc06ffd23218$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, opt_right);
    return offset;
}







var $40aa8d43bbe572bf$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ var $40aa8d43bbe572bf$var$Polygon = /** @class */ function(_super) {
    $40aa8d43bbe572bf$var$__extends(Polygon, _super);
    /**
     * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
     *     Array of linear rings that define the polygon. The first linear ring of the
     *     array defines the outer-boundary or surface of the polygon. Each subsequent
     *     linear ring defines a hole in the surface of the polygon. A linear ring is
     *     an array of vertices' coordinates where the first coordinate and the last are
     *     equivalent. (For internal use, flat coordinates in combination with
     *     `opt_layout` and `opt_ends` are also accepted.)
     * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
     * @param {Array<number>=} opt_ends Ends (for internal use with flat coordinates).
     */ function Polygon(coordinates, opt_layout, opt_ends) {
        var _this = _super.call(this) || this;
        /**
         * @type {Array<number>}
         * @private
         */ _this.ends_ = [];
        /**
         * @private
         * @type {number}
         */ _this.flatInteriorPointRevision_ = -1;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */ _this.flatInteriorPoint_ = null;
        /**
         * @private
         * @type {number}
         */ _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.maxDeltaRevision_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.orientedRevision_ = -1;
        /**
         * @private
         * @type {Array<number>}
         */ _this.orientedFlatCoordinates_ = null;
        if (opt_layout !== undefined && opt_ends) {
            _this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
            _this.ends_ = opt_ends;
        } else _this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, opt_layout);
        return _this;
    }
    /**
     * Append the passed linear ring to this polygon.
     * @param {LinearRing} linearRing Linear ring.
     * @api
     */ Polygon.prototype.appendLinearRing = function(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!Polygon} Clone.
     * @api
     */ Polygon.prototype.clone = function() {
        var polygon = new Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ Polygon.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @return {boolean} Contains (x, y).
     */ Polygon.prototype.containsXY = function(x, y) {
        return (0, $239aa88e7a573859$export$ae868c0f6acc3355)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    };
    /**
     * Return the area of the polygon on projected plane.
     * @return {number} Area (on projected plane).
     * @api
     */ Polygon.prototype.getArea = function() {
        return (0, $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    };
    /**
     * Get the coordinate array for this geometry.  This array has the structure
     * of a GeoJSON coordinate array for polygons.
     *
     * @param {boolean=} opt_right Orient coordinates according to the right-hand
     *     rule (counter-clockwise for exterior and clockwise for interior rings).
     *     If `false`, coordinates will be oriented according to the left-hand rule
     *     (clockwise for exterior and counter-clockwise for interior rings).
     *     By default, coordinate orientation will depend on how the geometry was
     *     constructed.
     * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
     * @api
     */ Polygon.prototype.getCoordinates = function(opt_right) {
        var flatCoordinates;
        if (opt_right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $7892dc06ffd23218$export$b71b604ddfc778c7)(flatCoordinates, 0, this.ends_, this.stride, opt_right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $5454470599558ddd$export$cbb9596fc0f40db2)(flatCoordinates, 0, this.ends_, this.stride);
    };
    /**
     * @return {Array<number>} Ends.
     */ Polygon.prototype.getEnds = function() {
        return this.ends_;
    };
    /**
     * @return {Array<number>} Interior point.
     */ Polygon.prototype.getFlatInteriorPoint = function() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            var flatCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoint_ = (0, $2166f19777f69377$export$50e3b25928a5e892)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return this.flatInteriorPoint_;
    };
    /**
     * Return an interior point of the polygon.
     * @return {Point} Interior point as XYM coordinate, where M is the
     * length of the horizontal intersection that the point belongs to.
     * @api
     */ Polygon.prototype.getInteriorPoint = function() {
        return new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(this.getFlatInteriorPoint(), (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYM);
    };
    /**
     * Return the number of rings of the polygon,  this includes the exterior
     * ring and any interior rings.
     *
     * @return {number} Number of rings.
     * @api
     */ Polygon.prototype.getLinearRingCount = function() {
        return this.ends_.length;
    };
    /**
     * Return the Nth linear ring of the polygon geometry. Return `null` if the
     * given index is out of range.
     * The exterior linear ring is available at index `0` and the interior rings
     * at index `1` and beyond.
     *
     * @param {number} index Index.
     * @return {LinearRing} Linear ring.
     * @api
     */ Polygon.prototype.getLinearRing = function(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $548636579b4087f2$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    };
    /**
     * Return the linear rings of the polygon.
     * @return {Array<LinearRing>} Linear rings.
     * @api
     */ Polygon.prototype.getLinearRings = function() {
        var layout = this.layout;
        var flatCoordinates = this.flatCoordinates;
        var ends = this.ends_;
        var linearRings = [];
        var offset = 0;
        for(var i = 0, ii = ends.length; i < ii; ++i){
            var end = ends[i];
            var linearRing = new (0, $548636579b4087f2$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    };
    /**
     * @return {Array<number>} Oriented flat coordinates.
     */ Polygon.prototype.getOrientedFlatCoordinates = function() {
        if (this.orientedRevision_ != this.getRevision()) {
            var flatCoordinates = this.flatCoordinates;
            if ((0, $7892dc06ffd23218$export$f27cd06e85f4ba28)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $7892dc06ffd23218$export$b71b604ddfc778c7)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return this.orientedFlatCoordinates_;
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {Polygon} Simplified Polygon.
     * @protected
     */ Polygon.prototype.getSimplifiedGeometryInternal = function(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        var simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$60a9904b67f8d51b)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new Polygon(simplifiedFlatCoordinates, (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XY, simplifiedEnds);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */ Polygon.prototype.getType = function() {
        return (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ Polygon.prototype.intersectsExtent = function(extent) {
        return (0, $acee589e5b390c5c$export$76dcd8f8f83b6ddb)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    };
    /**
     * Set the coordinates of the polygon.
     * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
     * @api
     */ Polygon.prototype.setCoordinates = function(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        var ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    };
    return Polygon;
}((0, $c76e993e57efc8c4$export$2e2bcd8739ae039));
var $40aa8d43bbe572bf$export$2e2bcd8739ae039 = $40aa8d43bbe572bf$var$Polygon;
function $40aa8d43bbe572bf$export$f99d756c6d81ae3f(center, radius, opt_n, opt_sphereRadius) {
    var n = opt_n ? opt_n : 32;
    /** @type {Array<number>} */ var flatCoordinates = [];
    for(var i = 0; i < n; ++i)(0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, (0, $fb75384508533d8f$export$cc800923e997bb8)(center, radius, 2 * Math.PI * i / n, opt_sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XY, [
        flatCoordinates.length
    ]);
}
function $40aa8d43bbe572bf$export$c16b671815801c75(extent) {
    var minX = extent[0];
    var minY = extent[1];
    var maxX = extent[2];
    var maxY = extent[3];
    var flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XY, [
        flatCoordinates.length
    ]);
}
function $40aa8d43bbe572bf$export$2451009d645fb8c2(circle, opt_sides, opt_angle) {
    var sides = opt_sides ? opt_sides : 32;
    var stride = circle.getStride();
    var layout = circle.getLayout();
    var center = circle.getCenter();
    var arrayLength = stride * (sides + 1);
    var flatCoordinates = new Array(arrayLength);
    for(var i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(var j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    var ends = [
        flatCoordinates.length
    ];
    var polygon = new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, layout, ends);
    $40aa8d43bbe572bf$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), opt_angle);
    return polygon;
}
function $40aa8d43bbe572bf$export$87d6a1539a56e47f(polygon, center, radius, opt_angle) {
    var flatCoordinates = polygon.getFlatCoordinates();
    var stride = polygon.getStride();
    var sides = flatCoordinates.length / stride - 1;
    var startAngle = opt_angle ? opt_angle : 0;
    for(var i = 0; i <= sides; ++i){
        var offset = i * stride;
        var angle = startAngle + (0, $6b000a049d919fe5$export$ba467bec01d66def)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}


var $70364d0195659942$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter]
 * @property {import("./coordinate.js").Coordinate} [targetCenter]
 * @property {number} [sourceResolution]
 * @property {number} [targetResolution]
 * @property {number} [sourceRotation]
 * @property {number} [targetRotation]
 * @property {import("./coordinate.js").Coordinate} [anchor]
 * @property {number} start
 * @property {number} duration
 * @property {boolean} complete
 * @property {function(number):number} easing
 * @property {function(boolean):void} callback
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center
 * @property {import("./resolutionconstraint.js").Type} resolution
 * @property {import("./rotationconstraint.js").Type} rotation
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to fit
 * the extent into. Default is the current size of the first map in the DOM that
 * uses this view, or `[100, 100]` if no such map is found.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing~inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions to determine the
 * resolution constraint. If set the `maxResolution`, `minResolution`,
 * `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing~inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center
 * @property {import("./proj/Projection.js").default} projection
 * @property {number} resolution
 * @property {number} rotation
 * @property {number} zoom
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ var $70364d0195659942$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Spherical Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `opt_anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 */ var $70364d0195659942$var$View = /** @class */ function(_super) {
    $70364d0195659942$var$__extends(View, _super);
    /**
     * @param {ViewOptions=} opt_options View options.
     */ function View(opt_options) {
        var _this = _super.call(this) || this;
        var options = (0, $beaefe87199bb537$export$e6e34fd1f2686227)({}, opt_options);
        /**
         * @private
         * @type {Array<number>}
         */ _this.hints_ = [
            0,
            0
        ];
        /**
         * @private
         * @type {Array<Array<Animation>>}
         */ _this.animations_ = [];
        /**
         * @private
         * @type {number|undefined}
         */ _this.updateAnimationKey_;
        /**
         * @private
         * @const
         * @type {import("./proj/Projection.js").default}
         */ _this.projection_ = (0, $9c4744460e43e41b$export$549167224996a0fb)(options.projection, 'EPSG:3857');
        /**
         * @private
         * @type {import("./size.js").Size}
         */ _this.viewportSize_ = [
            100,
            100
        ];
        /**
         * @private
         * @type {import("./coordinate.js").Coordinate|undefined}
         */ _this.targetCenter_ = null;
        /**
         * @private
         * @type {number|undefined}
         */ _this.targetResolution_;
        /**
         * @private
         * @type {number|undefined}
         */ _this.targetRotation_;
        /**
         * @private
         * @type {import("./coordinate.js").Coordinate|undefined}
         */ _this.cancelAnchor_ = undefined;
        if (options.center) options.center = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(options.center, _this.projection_);
        if (options.extent) options.extent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(options.extent, _this.projection_);
        _this.applyOptions_(options);
        return _this;
    }
    /**
     * Set up the view with the given options.
     * @param {ViewOptions} options View options.
     */ View.prototype.applyOptions_ = function(options) {
        /**
         * @type {Object<string, *>}
         */ var properties = {};
        var resolutionConstraintInfo = $70364d0195659942$export$c68d65f9148da196(options);
        /**
         * @private
         * @type {number}
         */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
         * @private
         * @type {number}
         */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
         * @private
         * @type {number}
         */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
         * @private
         * @type {Array<number>|undefined}
         */ this.resolutions_ = options.resolutions;
        /**
         * Padding (in css pixels).
         * If the map viewport is partially covered with other content (overlays) along
         * its edges, this setting allows to shift the center of the viewport away from that
         * content. The order of the values in the array is top, right, bottom, left.
         * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
         * @type {Array<number>|undefined}
         * @api
         */ this.padding = options.padding;
        /**
         * @private
         * @type {number}
         */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        var centerConstraint = $70364d0195659942$export$964345001ee9ac52(options);
        var resolutionConstraint = resolutionConstraintInfo.constraint;
        var rotationConstraint = $70364d0195659942$export$4eeaa08dd550e3c0(options);
        /**
         * @private
         * @type {Constraints}
         */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) this.setResolution(options.resolution);
        else if (options.zoom !== undefined) this.setZoom(options.zoom);
        this.setProperties(properties);
        /**
         * @private
         * @type {ViewOptions}
         */ this.options_ = options;
    };
    /**
     * Get an updated version of the view options used to construct the view.  The
     * current resolution (or zoom), center, and rotation are applied to any stored
     * options.  The provided options can be used to apply new min/max zoom or
     * resolution limits.
     * @param {ViewOptions} newOptions New options to be applied.
     * @return {ViewOptions} New options updated with the current view state.
     */ View.prototype.getUpdatedOptions_ = function(newOptions) {
        var options = (0, $beaefe87199bb537$export$e6e34fd1f2686227)({}, this.options_);
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return (0, $beaefe87199bb537$export$e6e34fd1f2686227)({}, options, newOptions);
    };
    /**
     * Animate the view.  The view's center, zoom (or resolution), and rotation
     * can be animated for smooth transitions between view states.  For example,
     * to animate the view to a new zoom level:
     *
     *     view.animate({zoom: view.getZoom() + 1});
     *
     * By default, the animation lasts one second and uses in-and-out easing.  You
     * can customize this behavior by including `duration` (in milliseconds) and
     * `easing` options (see {@link module:ol/easing}).
     *
     * To chain together multiple animations, call the method with multiple
     * animation objects.  For example, to first zoom and then pan:
     *
     *     view.animate({zoom: 10}, {center: [0, 0]});
     *
     * If you provide a function as the last argument to the animate method, it
     * will get called at the end of an animation series.  The callback will be
     * called with `true` if the animation series completed on its own or `false`
     * if it was cancelled.
     *
     * Animations are cancelled by user interactions (e.g. dragging the map) or by
     * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
     * (or another method that calls one of these).
     *
     * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
     *     options.  Multiple animations can be run in series by passing multiple
     *     options objects.  To run multiple animations in parallel, call the method
     *     multiple times.  An optional callback can be provided as a final
     *     argument.  The callback will be called with a boolean indicating whether
     *     the animation completed without being cancelled.
     * @api
     */ View.prototype.animate = function(var_args) {
        if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; ++i){
            var options = arguments[i];
            if (options.center) {
                options = (0, $beaefe87199bb537$export$e6e34fd1f2686227)({}, options);
                options.center = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = (0, $beaefe87199bb537$export$e6e34fd1f2686227)({}, options);
                options.anchor = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    };
    /**
     * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
     */ View.prototype.animateInternal = function(var_args) {
        var animationCount = arguments.length;
        var callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === 'function') {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        if (!this.isDef()) {
            // if view properties are not yet set, shortcut to the final state
            var state = arguments[animationCount - 1];
            if (state.center) this.setCenterInternal(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
            if (callback) $70364d0195659942$var$animationCallback(callback, true);
            return;
        }
        var start = Date.now();
        var center = this.targetCenter_.slice();
        var resolution = this.targetResolution_;
        var rotation = this.targetRotation_;
        var series = [];
        for(var i = 0; i < animationCount; ++i){
            var options = /** @type {AnimationOptions} */ arguments[i];
            var animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, $c7ccf7e681a9b333$export$9b47139b511b56e4),
                callback: callback
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                var delta = (0, $6b000a049d919fe5$export$ba467bec01d66def)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if ($70364d0195659942$export$ee75376562060184(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING, 1);
        this.updateAnimations_();
    };
    /**
     * Determine if the view is being animated.
     * @return {boolean} The view is being animated.
     * @api
     */ View.prototype.getAnimating = function() {
        return this.hints_[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] > 0;
    };
    /**
     * Determine if the user is interacting with the view, such as panning or zooming.
     * @return {boolean} The view is being interacted with.
     * @api
     */ View.prototype.getInteracting = function() {
        return this.hints_[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING] > 0;
    };
    /**
     * Cancel any ongoing animations.
     * @api
     */ View.prototype.cancelAnimations = function() {
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING, -this.hints_[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING]);
        var anchor;
        for(var i = 0, ii = this.animations_.length; i < ii; ++i){
            var series = this.animations_[i];
            if (series[0].callback) $70364d0195659942$var$animationCallback(series[0].callback, false);
            if (!anchor) for(var j = 0, jj = series.length; j < jj; ++j){
                var animation = series[j];
                if (!animation.complete) {
                    anchor = animation.anchor;
                    break;
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
    };
    /**
     * Update all animations.
     */ View.prototype.updateAnimations_ = function() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        var now = Date.now();
        var more = false;
        for(var i = this.animations_.length - 1; i >= 0; --i){
            var series = this.animations_[i];
            var seriesComplete = true;
            for(var j = 0, jj = series.length; j < jj; ++j){
                var animation = series[j];
                if (animation.complete) continue;
                var elapsed = now - animation.start;
                var fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                var progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    var x0 = animation.sourceCenter[0];
                    var y0 = animation.sourceCenter[1];
                    var x1 = animation.targetCenter[0];
                    var y1 = animation.targetCenter[1];
                    var x = x0 + progress * (x1 - x0);
                    var y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [
                        x,
                        y
                    ];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    var resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        var size = this.getViewportSize_(this.getRotation());
                        var constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    var rotation = progress === 1 ? (0, $6b000a049d919fe5$export$ba467bec01d66def)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        var constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING, -1);
                var callback = series[0].callback;
                if (callback) $70364d0195659942$var$animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
    };
    /**
     * @param {number} rotation Target rotation.
     * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
     * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
     */ View.prototype.calculateCenterRotate = function(rotation, anchor) {
        var center;
        var currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, $1bd0a226f9a16141$export$bb628a54ab399bc9)(center, rotation - this.getRotation());
            (0, $1bd0a226f9a16141$export$e16d8520af44a096)(center, anchor);
        }
        return center;
    };
    /**
     * @param {number} resolution Target resolution.
     * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
     * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
     */ View.prototype.calculateCenterZoom = function(resolution, anchor) {
        var center;
        var currentCenter = this.getCenterInternal();
        var currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            var x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            var y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    };
    /**
     * Returns the current viewport size.
     * @private
     * @param {number=} opt_rotation Take into account the rotation of the viewport when giving the size
     * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
     */ View.prototype.getViewportSize_ = function(opt_rotation) {
        var size = this.viewportSize_;
        if (opt_rotation) {
            var w = size[0];
            var h = size[1];
            return [
                Math.abs(w * Math.cos(opt_rotation)) + Math.abs(h * Math.sin(opt_rotation)),
                Math.abs(w * Math.sin(opt_rotation)) + Math.abs(h * Math.cos(opt_rotation))
            ];
        } else return size;
    };
    /**
     * Stores the viewport size on the view. The viewport size is not read every time from the DOM
     * to avoid performance hit and layout reflow.
     * This should be done on map size change.
     * Note: the constraints are not resolved during an animation to avoid stopping it
     * @param {import("./size.js").Size=} opt_size Viewport size; if undefined, [100, 100] is assumed
     */ View.prototype.setViewportSize = function(opt_size) {
        this.viewportSize_ = Array.isArray(opt_size) ? opt_size.slice() : [
            100,
            100
        ];
        if (!this.getAnimating()) this.resolveConstraints(0);
    };
    /**
     * Get the view center.
     * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
     * @observable
     * @api
     */ View.prototype.getCenter = function() {
        var center = this.getCenterInternal();
        if (!center) return center;
        return (0, $9c4744460e43e41b$export$698f563af1ba02a5)(center, this.getProjection());
    };
    /**
     * Get the view center without transforming to user projection.
     * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
     */ View.prototype.getCenterInternal = function() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER);
    };
    /**
     * @return {Constraints} Constraints.
     */ View.prototype.getConstraints = function() {
        return this.constraints_;
    };
    /**
     * @return {boolean} Resolution constraint is set
     */ View.prototype.getConstrainResolution = function() {
        return this.options_.constrainResolution;
    };
    /**
     * @param {Array<number>=} opt_hints Destination array.
     * @return {Array<number>} Hint.
     */ View.prototype.getHints = function(opt_hints) {
        if (opt_hints !== undefined) {
            opt_hints[0] = this.hints_[0];
            opt_hints[1] = this.hints_[1];
            return opt_hints;
        } else return this.hints_.slice();
    };
    /**
     * Calculate the extent for the current view state and the passed size.
     * The size is the pixel dimensions of the box into which the calculated extent
     * should fit. In most cases you want to get the extent of the entire map,
     * that is `map.getSize()`.
     * @param {import("./size.js").Size=} opt_size Box pixel size. If not provided, the size
     * of the map that uses this view will be used.
     * @return {import("./extent.js").Extent} Extent.
     * @api
     */ View.prototype.calculateExtent = function(opt_size) {
        var extent = this.calculateExtentInternal(opt_size);
        return (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, this.getProjection());
    };
    /**
     * @param {import("./size.js").Size=} opt_size Box pixel size. If not provided,
     * the map's last known viewport size will be used.
     * @return {import("./extent.js").Extent} Extent.
     */ View.prototype.calculateExtentInternal = function(opt_size) {
        var size = opt_size || this.getViewportSize_();
        var center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(center, 1); // The view center is not defined
        var resolution = /** @type {!number} */ this.getResolution();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(resolution !== undefined, 2); // The view resolution is not defined
        var rotation = /** @type {!number} */ this.getRotation();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(rotation !== undefined, 3); // The view rotation is not defined
        return (0, $6da4c8ed3074c92b$export$13ba650faf8308)(center, resolution, rotation, size);
    };
    /**
     * Get the maximum resolution of the view.
     * @return {number} The maximum resolution of the view.
     * @api
     */ View.prototype.getMaxResolution = function() {
        return this.maxResolution_;
    };
    /**
     * Get the minimum resolution of the view.
     * @return {number} The minimum resolution of the view.
     * @api
     */ View.prototype.getMinResolution = function() {
        return this.minResolution_;
    };
    /**
     * Get the maximum zoom level for the view.
     * @return {number} The maximum zoom level.
     * @api
     */ View.prototype.getMaxZoom = function() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    };
    /**
     * Set a new maximum zoom level for the view.
     * @param {number} zoom The maximum zoom level.
     * @api
     */ View.prototype.setMaxZoom = function(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    };
    /**
     * Get the minimum zoom level for the view.
     * @return {number} The minimum zoom level.
     * @api
     */ View.prototype.getMinZoom = function() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    };
    /**
     * Set a new minimum zoom level for the view.
     * @param {number} zoom The minimum zoom level.
     * @api
     */ View.prototype.setMinZoom = function(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    };
    /**
     * Set whether the view shoud allow intermediary zoom levels.
     * @param {boolean} enabled Whether the resolution is constrained.
     * @api
     */ View.prototype.setConstrainResolution = function(enabled) {
        this.applyOptions_(this.getUpdatedOptions_({
            constrainResolution: enabled
        }));
    };
    /**
     * Get the view projection.
     * @return {import("./proj/Projection.js").default} The projection of the view.
     * @api
     */ View.prototype.getProjection = function() {
        return this.projection_;
    };
    /**
     * Get the view resolution.
     * @return {number|undefined} The resolution of the view.
     * @observable
     * @api
     */ View.prototype.getResolution = function() {
        return /** @type {number|undefined} */ this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).RESOLUTION);
    };
    /**
     * Get the resolutions for the view. This returns the array of resolutions
     * passed to the constructor of the View, or undefined if none were given.
     * @return {Array<number>|undefined} The resolutions of the view.
     * @api
     */ View.prototype.getResolutions = function() {
        return this.resolutions_;
    };
    /**
     * Get the resolution for a provided extent (in map units) and size (in pixels).
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {import("./size.js").Size=} opt_size Box pixel size.
     * @return {number} The resolution at which the provided extent will render at
     *     the given size.
     * @api
     */ View.prototype.getResolutionForExtent = function(extent, opt_size) {
        return this.getResolutionForExtentInternal((0, $9c4744460e43e41b$export$494be3a3a25689ca)(extent, this.getProjection()), opt_size);
    };
    /**
     * Get the resolution for a provided extent (in map units) and size (in pixels).
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {import("./size.js").Size=} opt_size Box pixel size.
     * @return {number} The resolution at which the provided extent will render at
     *     the given size.
     */ View.prototype.getResolutionForExtentInternal = function(extent, opt_size) {
        var size = opt_size || this.getViewportSize_();
        var xResolution = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / size[0];
        var yResolution = (0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    };
    /**
     * Return a function that returns a value between 0 and 1 for a
     * resolution. Exponential scaling is assumed.
     * @param {number=} opt_power Power.
     * @return {function(number): number} Resolution for value function.
     */ View.prototype.getResolutionForValueFunction = function(opt_power) {
        var power = opt_power || 2;
        var maxResolution = this.getConstrainedResolution(this.maxResolution_);
        var minResolution = this.minResolution_;
        var max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
         * @param {number} value Value.
         * @return {number} Resolution.
         */ function(value) {
            var resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    };
    /**
     * Get the view rotation.
     * @return {number} The rotation of the view in radians.
     * @observable
     * @api
     */ View.prototype.getRotation = function() {
        return /** @type {number} */ this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION);
    };
    /**
     * Return a function that returns a resolution for a value between
     * 0 and 1. Exponential scaling is assumed.
     * @param {number=} opt_power Power.
     * @return {function(number): number} Value for resolution function.
     */ View.prototype.getValueForResolutionFunction = function(opt_power) {
        var logPower = Math.log(opt_power || 2);
        var maxResolution = this.getConstrainedResolution(this.maxResolution_);
        var minResolution = this.minResolution_;
        var max = Math.log(maxResolution / minResolution) / logPower;
        return(/**
         * @param {number} resolution Resolution.
         * @return {number} Value.
         */ function(resolution) {
            var value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    };
    /**
     * Returns the size of the viewport minus padding.
     * @private
     * @param {number=} opt_rotation Take into account the rotation of the viewport when giving the size
     * @return {import("./size.js").Size} Viewport size reduced by the padding.
     */ View.prototype.getViewportSizeMinusPadding_ = function(opt_rotation) {
        var size = this.getViewportSize_(opt_rotation);
        var padding = this.padding;
        if (padding) size = [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ];
        return size;
    };
    /**
     * @return {State} View state.
     */ View.prototype.getState = function() {
        var projection = this.getProjection();
        var resolution = /** @type {number} */ this.getResolution();
        var rotation = this.getRotation();
        var center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        var padding = this.padding;
        if (padding) {
            var reducedSize = this.getViewportSizeMinusPadding_();
            center = $70364d0195659942$var$calculateCenterOn(center, this.getViewportSize_(), [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            rotation: rotation,
            zoom: this.getZoom()
        };
    };
    /**
     * Get the current zoom level. This method may return non-integer zoom levels
     * if the view does not constrain the resolution, or if an interaction or
     * animation is underway.
     * @return {number|undefined} Zoom.
     * @api
     */ View.prototype.getZoom = function() {
        var zoom;
        var resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    };
    /**
     * Get the zoom level for a resolution.
     * @param {number} resolution The resolution.
     * @return {number|undefined} The zoom level for the provided resolution.
     * @api
     */ View.prototype.getZoomForResolution = function(resolution) {
        var offset = this.minZoom_ || 0;
        var max, zoomFactor;
        if (this.resolutions_) {
            var nearest = (0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    };
    /**
     * Get the resolution for a zoom level.
     * @param {number} zoom Zoom level.
     * @return {number} The view resolution for the provided zoom level.
     * @api
     */ View.prototype.getResolutionForZoom = function(zoom) {
        if (this.resolutions_) {
            if (this.resolutions_.length <= 1) return 0;
            var baseLevel = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(Math.floor(zoom), 0, this.resolutions_.length - 2);
            var zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(zoom - baseLevel, 0, 1));
        } else return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
    };
    /**
     * Fit the given geometry or extent based on the given map size and border.
     * The size is pixel dimensions of the box to fit the extent into.
     * In most cases you will want to use the map size, that is `map.getSize()`.
     * Takes care of the map angle.
     * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
     *     extent to fit the view to.
     * @param {FitOptions=} opt_options Options.
     * @api
     */ View.prototype.fit = function(geometryOrExtent, opt_options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */ var geometry;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === 'function', 24); // Invalid extent or geometry provided as `geometry`
        if (Array.isArray(geometryOrExtent)) {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(!(0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(geometryOrExtent), 25); // Cannot fit empty extent provided as `geometry`
            var extent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(geometryOrExtent, this.getProjection());
            geometry = (0, $40aa8d43bbe572bf$export$c16b671815801c75)(extent);
        } else if (geometryOrExtent.getType() === (0, $419865bd7211e6e7$export$2e2bcd8739ae039).CIRCLE) {
            var extent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(geometryOrExtent.getExtent(), this.getProjection());
            geometry = (0, $40aa8d43bbe572bf$export$c16b671815801c75)(extent);
            geometry.rotate(this.getRotation(), (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(extent));
        } else {
            var userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
            if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
            else geometry = geometryOrExtent;
        }
        this.fitInternal(geometry, opt_options);
    };
    /**
     * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
     * @param {FitOptions=} opt_options Options.
     */ View.prototype.fitInternal = function(geometry, opt_options) {
        var options = opt_options || {};
        var size = options.size;
        if (!size) size = this.getViewportSizeMinusPadding_();
        var padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        var nearest = options.nearest !== undefined ? options.nearest : false;
        var minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
        else minResolution = 0;
        var coords = geometry.getFlatCoordinates();
        // calculate rotated extent
        var rotation = this.getRotation();
        var cosAngle = Math.cos(-rotation);
        var sinAngle = Math.sin(-rotation);
        var minRotX = Infinity;
        var minRotY = Infinity;
        var maxRotX = -Infinity;
        var maxRotY = -Infinity;
        var stride = geometry.getStride();
        for(var i = 0, ii = coords.length; i < ii; i += stride){
            var rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            var rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        // calculate resolution
        var resolution = this.getResolutionForExtentInternal([
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ], [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        sinAngle = -sinAngle; // go back to original rotation
        var centerRotX = (minRotX + maxRotX) / 2;
        var centerRotY = (minRotY + maxRotY) / 2;
        centerRotX += (padding[1] - padding[3]) / 2 * resolution;
        centerRotY += (padding[0] - padding[2]) / 2 * resolution;
        var centerX = centerRotX * cosAngle - centerRotY * sinAngle;
        var centerY = centerRotY * cosAngle + centerRotX * sinAngle;
        var center = this.getConstrainedCenter([
            centerX,
            centerY
        ], resolution);
        var callback = options.callback ? options.callback : (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
        if (options.duration !== undefined) this.animateInternal({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            $70364d0195659942$var$animationCallback(callback, true);
        }
    };
    /**
     * Center on coordinate and view position.
     * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("./size.js").Size} size Box pixel size.
     * @param {import("./pixel.js").Pixel} position Position on the view to center on.
     * @api
     */ View.prototype.centerOn = function(coordinate, size, position) {
        this.centerOnInternal((0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinate, this.getProjection()), size, position);
    };
    /**
     * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("./size.js").Size} size Box pixel size.
     * @param {import("./pixel.js").Pixel} position Position on the view to center on.
     */ View.prototype.centerOnInternal = function(coordinate, size, position) {
        this.setCenterInternal($70364d0195659942$var$calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    };
    /**
     * Calculates the shift between map and viewport center.
     * @param {import("./coordinate.js").Coordinate} center Center.
     * @param {number} resolution Resolution.
     * @param {number} rotation Rotation.
     * @param {import("./size.js").Size} size Size.
     * @return {Array<number>|undefined} Center shift.
     */ View.prototype.calculateCenterShift = function(center, resolution, rotation, size) {
        var centerShift;
        var padding = this.padding;
        if (padding && center) {
            var reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            var shiftedCenter = $70364d0195659942$var$calculateCenterOn(center, size, [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1]
            ];
        }
        return centerShift;
    };
    /**
     * @return {boolean} Is defined.
     */ View.prototype.isDef = function() {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    };
    /**
     * Adds relative coordinates to the center of the view. Any extent constraint will apply.
     * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
     * @api
     */ View.prototype.adjustCenter = function(deltaCoordinates) {
        var center = (0, $9c4744460e43e41b$export$698f563af1ba02a5)(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    };
    /**
     * Adds relative coordinates to the center of the view. Any extent constraint will apply.
     * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
     */ View.prototype.adjustCenterInternal = function(deltaCoordinates) {
        var center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    };
    /**
     * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
     * constraint will apply.
     * @param {number} ratio The ratio to apply on the view resolution.
     * @param {import("./coordinate.js").Coordinate=} opt_anchor The origin of the transformation.
     * @api
     */ View.prototype.adjustResolution = function(ratio, opt_anchor) {
        var anchor = opt_anchor && (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(opt_anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    };
    /**
     * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
     * constraint will apply.
     * @param {number} ratio The ratio to apply on the view resolution.
     * @param {import("./coordinate.js").Coordinate=} opt_anchor The origin of the transformation.
     */ View.prototype.adjustResolutionInternal = function(ratio, opt_anchor) {
        var isMoving = this.getAnimating() || this.getInteracting();
        var size = this.getViewportSize_(this.getRotation());
        var newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (opt_anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, opt_anchor);
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    };
    /**
     * Adds a value to the view zoom level, optionally using an anchor. Any resolution
     * constraint will apply.
     * @param {number} delta Relative value to add to the zoom level.
     * @param {import("./coordinate.js").Coordinate=} opt_anchor The origin of the transformation.
     * @api
     */ View.prototype.adjustZoom = function(delta, opt_anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), opt_anchor);
    };
    /**
     * Adds a value to the view rotation, optionally using an anchor. Any rotation
     * constraint will apply.
     * @param {number} delta Relative value to add to the zoom rotation, in radians.
     * @param {import("./coordinate.js").Coordinate=} opt_anchor The rotation center.
     * @api
     */ View.prototype.adjustRotation = function(delta, opt_anchor) {
        if (opt_anchor) opt_anchor = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(opt_anchor, this.getProjection());
        this.adjustRotationInternal(delta, opt_anchor);
    };
    /**
     * @param {number} delta Relative value to add to the zoom rotation, in radians.
     * @param {import("./coordinate.js").Coordinate=} opt_anchor The rotation center.
     */ View.prototype.adjustRotationInternal = function(delta, opt_anchor) {
        var isMoving = this.getAnimating() || this.getInteracting();
        var newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (opt_anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, opt_anchor);
        this.targetRotation_ += delta;
        this.applyTargetState_();
    };
    /**
     * Set the center of the current view. Any extent constraint will apply.
     * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
     * @observable
     * @api
     */ View.prototype.setCenter = function(center) {
        this.setCenterInternal((0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(center, this.getProjection()));
    };
    /**
     * Set the center using the view projection (not the user projection).
     * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
     */ View.prototype.setCenterInternal = function(center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    };
    /**
     * @param {import("./ViewHint.js").default} hint Hint.
     * @param {number} delta Delta.
     * @return {number} New value.
     */ View.prototype.setHint = function(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    };
    /**
     * Set the resolution for this view. Any resolution constraint will apply.
     * @param {number|undefined} resolution The resolution of the view.
     * @observable
     * @api
     */ View.prototype.setResolution = function(resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    };
    /**
     * Set the rotation for this view. Any rotation constraint will apply.
     * @param {number} rotation The rotation of the view in radians.
     * @observable
     * @api
     */ View.prototype.setRotation = function(rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    };
    /**
     * Zoom to a specific zoom level. Any resolution constrain will apply.
     * @param {number} zoom Zoom level.
     * @api
     */ View.prototype.setZoom = function(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    };
    /**
     * Recompute rotation/resolution/center based on target values.
     * Note: we have to compute rotation first, then resolution and center considering that
     * parameters can influence one another in case a view extent constraint is present.
     * @param {boolean=} opt_doNotCancelAnims Do not cancel animations.
     * @param {boolean=} opt_forceMoving Apply constraints as if the view is moving.
     * @private
     */ View.prototype.applyTargetState_ = function(opt_doNotCancelAnims, opt_forceMoving) {
        var isMoving = this.getAnimating() || this.getInteracting() || opt_forceMoving;
        // compute rotation
        var newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        var size = this.getViewportSize_(newRotation);
        var newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        var newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION) !== newRotation) this.set((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION, newRotation);
        if (this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).RESOLUTION) !== newResolution) this.set((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).RESOLUTION, newResolution);
        if (!this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER) || !(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER), newCenter)) this.set((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER, newCenter);
        if (this.getAnimating() && !opt_doNotCancelAnims) this.cancelAnimations();
        this.cancelAnchor_ = undefined;
    };
    /**
     * If any constraints need to be applied, an animation will be triggered.
     * This is typically done on interaction end.
     * Note: calling this with a duration of 0 will apply the constrained values straight away,
     * without animation.
     * @param {number=} opt_duration The animation duration in ms.
     * @param {number=} opt_resolutionDirection Which direction to zoom.
     * @param {import("./coordinate.js").Coordinate=} opt_anchor The origin of the transformation.
     */ View.prototype.resolveConstraints = function(opt_duration, opt_resolutionDirection, opt_anchor) {
        var duration = opt_duration !== undefined ? opt_duration : 200;
        var direction = opt_resolutionDirection || 0;
        var newRotation = this.constraints_.rotation(this.targetRotation_);
        var size = this.getViewportSize_(newRotation);
        var newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        var newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        var anchor = opt_anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) this.cancelAnimations();
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0),
                anchor: anchor
            });
        }
    };
    /**
     * Notify the View that an interaction has started.
     * The view state will be resolved to a stable one if needed
     * (depending on its constraints).
     * @api
     */ View.prototype.beginInteraction = function() {
        this.resolveConstraints(0);
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING, 1);
    };
    /**
     * Notify the View that an interaction has ended. The view state will be resolved
     * to a stable one if needed (depending on its constraints).
     * @param {number=} opt_duration Animation duration in ms.
     * @param {number=} opt_resolutionDirection Which direction to zoom.
     * @param {import("./coordinate.js").Coordinate=} opt_anchor The origin of the transformation.
     * @api
     */ View.prototype.endInteraction = function(opt_duration, opt_resolutionDirection, opt_anchor) {
        var anchor = opt_anchor && (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(opt_anchor, this.getProjection());
        this.endInteractionInternal(opt_duration, opt_resolutionDirection, anchor);
    };
    /**
     * Notify the View that an interaction has ended. The view state will be resolved
     * to a stable one if needed (depending on its constraints).
     * @param {number=} opt_duration Animation duration in ms.
     * @param {number=} opt_resolutionDirection Which direction to zoom.
     * @param {import("./coordinate.js").Coordinate=} opt_anchor The origin of the transformation.
     */ View.prototype.endInteractionInternal = function(opt_duration, opt_resolutionDirection, opt_anchor) {
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING, -1);
        this.resolveConstraints(opt_duration, opt_resolutionDirection, opt_anchor);
    };
    /**
     * Get a valid position for the view center according to the current constraints.
     * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
     * @param {number=} opt_targetResolution Target resolution. If not supplied, the current one will be used.
     * This is useful to guess a valid center position at a different zoom level.
     * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
     */ View.prototype.getConstrainedCenter = function(targetCenter, opt_targetResolution) {
        var size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, opt_targetResolution || this.getResolution(), size);
    };
    /**
     * Get a valid zoom level according to the current view constraints.
     * @param {number|undefined} targetZoom Target zoom.
     * @param {number=} [opt_direction=0] Indicate which resolution should be used
     * by a renderer if the view resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @return {number|undefined} Valid zoom level.
     */ View.prototype.getConstrainedZoom = function(targetZoom, opt_direction) {
        var targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, opt_direction));
    };
    /**
     * Get a valid resolution according to the current view constraints.
     * @param {number|undefined} targetResolution Target resolution.
     * @param {number=} [opt_direction=0] Indicate which resolution should be used
     * by a renderer if the view resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @return {number|undefined} Valid resolution.
     */ View.prototype.getConstrainedResolution = function(targetResolution, opt_direction) {
        var direction = opt_direction || 0;
        var size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    };
    return View;
}((0, $b68b3d6e32e3074a$export$2e2bcd8739ae039));
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $70364d0195659942$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $70364d0195659942$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) {
        var smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, $b21a6e049949bb31$export$c2f0af2c946f6897)(options.extent, options.constrainOnlyCenter, smooth);
    }
    var projection = (0, $9c4744460e43e41b$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    if (options.multiWorld !== true && projection.isGlobal()) {
        var extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, $b21a6e049949bb31$export$c2f0af2c946f6897)(extent, false, false);
    }
    return 0, $b21a6e049949bb31$export$f883a24d5edde77c;
}
function $70364d0195659942$export$c68d65f9148da196(options) {
    var resolutionConstraint;
    var maxResolution;
    var minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    var defaultMaxZoom = 28;
    var defaultZoomFactor = 2;
    var minZoom = options.minZoom !== undefined ? options.minZoom : $70364d0195659942$var$DEFAULT_MIN_ZOOM;
    var maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    var zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    var multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    var smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    var showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    var projection = (0, $9c4744460e43e41b$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    var projExtent = projection.getExtent();
    var constrainOnlyCenter = options.constrainOnlyCenter;
    var extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        var resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, $bac43a1f4a628548$export$d65a517690fc4385)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $bac43a1f4a628548$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        var size = !projExtent ? 360 * (0, $03edbd434a9e6608$export$1482081eec883108)[(0, $03edbd434a9e6608$export$2e2bcd8739ae039).DEGREES] / projection.getMetersPerUnit() : Math.max((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projExtent), (0, $6da4c8ed3074c92b$export$c08559766941f856)(projExtent));
        var defaultMaxResolution = size / (0, $57cd8651d88957a0$export$6b8cb5cd370bd90c) / Math.pow(defaultZoomFactor, $70364d0195659942$var$DEFAULT_MIN_ZOOM);
        var defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $70364d0195659942$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, $bac43a1f4a628548$export$22ac0f6b219de91a)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $bac43a1f4a628548$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $70364d0195659942$export$4eeaa08dd550e3c0(options) {
    var enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        var constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $d65f0a322291d127$export$17a6e6f3448b17e8)();
        else if (constrainRotation === false) return 0, $d65f0a322291d127$export$f883a24d5edde77c;
        else if (typeof constrainRotation === 'number') return (0, $d65f0a322291d127$export$9ba78806de831083)(constrainRotation);
        else return 0, $d65f0a322291d127$export$f883a24d5edde77c;
    } else return 0, $d65f0a322291d127$export$e20fbacbb41798b;
}
function $70364d0195659942$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function $70364d0195659942$var$calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    var cosAngle = Math.cos(-rotation);
    var sinAngle = Math.sin(-rotation);
    var rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    var rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    var centerX = rotX * cosAngle - rotY * sinAngle;
    var centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
var $70364d0195659942$export$2e2bcd8739ae039 = $70364d0195659942$var$View;









/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size=} opt_size Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $cc435a5409103773$export$ab1029bcae9ddb4a(size, num, opt_size) {
    if (opt_size === undefined) opt_size = [
        0,
        0
    ];
    opt_size[0] = size[0] + 2 * num;
    opt_size[1] = size[1] + 2 * num;
    return opt_size;
}
function $cc435a5409103773$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $cc435a5409103773$export$dcdf75081b88279d(size, ratio, opt_size) {
    if (opt_size === undefined) opt_size = [
        0,
        0
    ];
    opt_size[0] = size[0] * ratio + 0.5 | 0;
    opt_size[1] = size[1] * ratio + 0.5 | 0;
    return opt_size;
}
function $cc435a5409103773$export$a71a825ff42fb8e1(size, opt_size) {
    if (Array.isArray(size)) return size;
    else {
        if (opt_size === undefined) opt_size = [
            size,
            size
        ];
        else {
            opt_size[0] = size;
            opt_size[1] = size;
        }
        return opt_size;
    }
}




var $cceb59c4bc2a46b0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate
 * @property {import("./transform.js").Transform} coordinateToPixelTransform
 * @property {import("rbush").default} declutterTree
 * @property {null|import("./extent.js").Extent} extent
 * @property {number} index
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray
 * @property {number} layerIndex
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform
 * @property {Array<PostRenderFunction>} postRenderFunctions
 * @property {import("./size.js").Size} size
 * @property {TileQueue} tileQueue
 * @property {!Object<string, Object<string, boolean>>} usedTiles
 * @property {Array<number>} viewHints
 * @property {!Object<string, Object<string, boolean>>} wantedTiles
 */ /**
 * @typedef {function(PluggableMap, ?FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls]
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions]
 * @property {HTMLElement|Document} keyboardEventTarget
 * @property {Collection<import("./Overlay.js").default>} overlays
 * @property {Object<string, *>} values
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control~defaults} is used.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction~defaults} is used.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * @property {View} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ var $cceb59c4bc2a46b0$var$PluggableMap = /** @class */ function(_super) {
    $cceb59c4bc2a46b0$var$__extends(PluggableMap, _super);
    /**
     * @param {MapOptions} options Map options.
     */ function PluggableMap(options) {
        var _this = _super.call(this) || this;
        var optionsInternal = $cceb59c4bc2a46b0$var$createOptionsInternal(options);
        /** @private */ _this.boundHandleBrowserEvent_ = _this.handleBrowserEvent.bind(_this);
        /**
         * @type {number}
         * @private
         */ _this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
         * @private
         * @type {number}
         */ _this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $67c66761d21428d0$export$6b83a0446fc26f94);
        /**
         * @private
         * @type {*}
         */ _this.postRenderTimeoutHandle_;
        /**
         * @private
         * @type {number|undefined}
         */ _this.animationDelayKey_;
        /**
         * @private
         */ _this.animationDelay_ = /** @this {PluggableMap} */ (function() {
            this.animationDelayKey_ = undefined;
            this.renderFrame_(Date.now());
        }).bind(_this);
        /**
         * @private
         * @type {import("./transform.js").Transform}
         */ _this.coordinateToPixelTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
         * @private
         * @type {import("./transform.js").Transform}
         */ _this.pixelToCoordinateTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
         * @private
         * @type {number}
         */ _this.frameIndex_ = 0;
        /**
         * @private
         * @type {?FrameState}
         */ _this.frameState_ = null;
        /**
         * The extent at the previous 'moveend' event.
         * @private
         * @type {import("./extent.js").Extent}
         */ _this.previousExtent_ = null;
        /**
         * @private
         * @type {?import("./events.js").EventsKey}
         */ _this.viewPropertyListenerKey_ = null;
        /**
         * @private
         * @type {?import("./events.js").EventsKey}
         */ _this.viewChangeListenerKey_ = null;
        /**
         * @private
         * @type {?Array<import("./events.js").EventsKey>}
         */ _this.layerGroupPropertyListenerKeys_ = null;
        /**
         * @private
         * @type {!HTMLElement}
         */ _this.viewport_ = document.createElement('div');
        _this.viewport_.className = 'ol-viewport' + ('ontouchstart' in window ? ' ol-touch' : '');
        _this.viewport_.style.position = 'relative';
        _this.viewport_.style.overflow = 'hidden';
        _this.viewport_.style.width = '100%';
        _this.viewport_.style.height = '100%';
        /**
         * @private
         * @type {!HTMLElement}
         */ _this.overlayContainer_ = document.createElement('div');
        _this.overlayContainer_.style.position = 'absolute';
        _this.overlayContainer_.style.zIndex = '0';
        _this.overlayContainer_.style.width = '100%';
        _this.overlayContainer_.style.height = '100%';
        _this.overlayContainer_.style.pointerEvents = 'none';
        _this.overlayContainer_.className = 'ol-overlaycontainer';
        _this.viewport_.appendChild(_this.overlayContainer_);
        /**
         * @private
         * @type {!HTMLElement}
         */ _this.overlayContainerStopEvent_ = document.createElement('div');
        _this.overlayContainerStopEvent_.style.position = 'absolute';
        _this.overlayContainerStopEvent_.style.zIndex = '0';
        _this.overlayContainerStopEvent_.style.width = '100%';
        _this.overlayContainerStopEvent_.style.height = '100%';
        _this.overlayContainerStopEvent_.style.pointerEvents = 'none';
        _this.overlayContainerStopEvent_.className = 'ol-overlaycontainer-stopevent';
        _this.viewport_.appendChild(_this.overlayContainerStopEvent_);
        /**
         * @private
         * @type {MapBrowserEventHandler}
         */ _this.mapBrowserEventHandler_ = null;
        /**
         * @private
         * @type {number}
         */ _this.moveTolerance_ = options.moveTolerance;
        /**
         * @private
         * @type {HTMLElement|Document}
         */ _this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
         * @private
         * @type {?Array<import("./events.js").EventsKey>}
         */ _this.keyHandlerKeys_ = null;
        /**
         * @type {Collection<import("./control/Control.js").default>}
         * @protected
         */ _this.controls = optionsInternal.controls || new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
        /**
         * @type {Collection<import("./interaction/Interaction.js").default>}
         * @protected
         */ _this.interactions = optionsInternal.interactions || new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
        /**
         * @type {Collection<import("./Overlay.js").default>}
         * @private
         */ _this.overlays_ = optionsInternal.overlays;
        /**
         * A lookup of overlays by id.
         * @private
         * @type {Object<string, import("./Overlay.js").default>}
         */ _this.overlayIdIndex_ = {};
        /**
         * @type {import("./renderer/Map.js").default}
         * @private
         */ _this.renderer_ = null;
        /**
         * @type {undefined|function(Event): void}
         * @private
         */ _this.handleResize_;
        /**
         * @private
         * @type {!Array<PostRenderFunction>}
         */ _this.postRenderFunctions_ = [];
        /**
         * @private
         * @type {TileQueue}
         */ _this.tileQueue_ = new (0, $4c51fd53052a6bbc$export$2e2bcd8739ae039)(_this.getTilePriority.bind(_this), _this.handleTileChange_.bind(_this));
        _this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)((0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP), _this.handleLayerGroupChanged_);
        _this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW), _this.handleViewChanged_);
        _this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)((0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE), _this.handleSizeChanged_);
        _this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET), _this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        _this.setProperties(optionsInternal.values);
        _this.controls.forEach(/**
         * @param {import("./control/Control.js").default} control Control.
         * @this {PluggableMap}
         */ (function(control) {
            control.setMap(this);
        }).bind(_this));
        _this.controls.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */ (function(event) {
            event.element.setMap(this);
        }).bind(_this));
        _this.controls.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */ (function(event) {
            event.element.setMap(null);
        }).bind(_this));
        _this.interactions.forEach(/**
         * @param {import("./interaction/Interaction.js").default} interaction Interaction.
         * @this {PluggableMap}
         */ (function(interaction) {
            interaction.setMap(this);
        }).bind(_this));
        _this.interactions.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */ (function(event) {
            event.element.setMap(this);
        }).bind(_this));
        _this.interactions.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */ (function(event) {
            event.element.setMap(null);
        }).bind(_this));
        _this.overlays_.forEach(_this.addOverlayInternal_.bind(_this));
        _this.overlays_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */ (function(event) {
            this.addOverlayInternal_(/** @type {import("./Overlay.js").default} */ event.element);
        }).bind(_this));
        _this.overlays_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */ (function(event) {
            var overlay = /** @type {import("./Overlay.js").default} */ event.element;
            var id = overlay.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        }).bind(_this));
        return _this;
    }
    /**
     * @abstract
     * @return {import("./renderer/Map.js").default} The map renderer
     */ PluggableMap.prototype.createRenderer = function() {
        throw new Error('Use a map type that has a createRenderer method');
    };
    /**
     * Add the given control to the map.
     * @param {import("./control/Control.js").default} control Control.
     * @api
     */ PluggableMap.prototype.addControl = function(control) {
        this.getControls().push(control);
    };
    /**
     * Add the given interaction to the map. If you want to add an interaction
     * at another point of the collection use `getInteraction()` and the methods
     * available on {@link module:ol/Collection~Collection}. This can be used to
     * stop the event propagation from the handleEvent function. The interactions
     * get to handle the events in the reverse order of this collection.
     * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
     * @api
     */ PluggableMap.prototype.addInteraction = function(interaction) {
        this.getInteractions().push(interaction);
    };
    /**
     * Adds the given layer to the top of this map. If you want to add a layer
     * elsewhere in the stack, use `getLayers()` and the methods available on
     * {@link module:ol/Collection~Collection}.
     * @param {import("./layer/Base.js").default} layer Layer.
     * @api
     */ PluggableMap.prototype.addLayer = function(layer) {
        var layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    };
    /**
     * Add the given overlay to the map.
     * @param {import("./Overlay.js").default} overlay Overlay.
     * @api
     */ PluggableMap.prototype.addOverlay = function(overlay) {
        this.getOverlays().push(overlay);
    };
    /**
     * This deals with map's overlay collection changes.
     * @param {import("./Overlay.js").default} overlay Overlay.
     * @private
     */ PluggableMap.prototype.addOverlayInternal_ = function(overlay) {
        var id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    };
    /**
     *
     * Clean up.
     */ PluggableMap.prototype.disposeInternal = function() {
        this.setTarget(null);
        _super.prototype.disposeInternal.call(this);
    };
    /**
     * Detect features that intersect a pixel on the viewport, and execute a
     * callback with each intersecting feature. Layers included in the detection can
     * be configured through the `layerFilter` option in `opt_options`.
     * @param {import("./pixel.js").Pixel} pixel Pixel.
     * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
     *     called with two arguments. The first argument is one
     *     {@link module:ol/Feature feature} or
     *     {@link module:ol/render/Feature render feature} at the pixel, the second is
     *     the {@link module:ol/layer/Layer layer} of the feature and will be null for
     *     unmanaged layers. To stop detection, callback functions can return a
     *     truthy value.
     * @param {AtPixelOptions=} opt_options Optional options.
     * @return {T|undefined} Callback result, i.e. the return value of last
     * callback execution, or the first truthy callback return value.
     * @template S,T
     * @api
     */ PluggableMap.prototype.forEachFeatureAtPixel = function(pixel, callback, opt_options) {
        if (!this.frameState_) return;
        var coordinate = this.getCoordinateFromPixelInternal(pixel);
        opt_options = opt_options !== undefined ? opt_options : {};
        var hitTolerance = opt_options.hitTolerance !== undefined ? opt_options.hitTolerance : 0;
        var layerFilter = opt_options.layerFilter !== undefined ? opt_options.layerFilter : (0, $013a1733c226ec50$export$22e23a2304399231);
        var checkWrapped = opt_options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    };
    /**
     * Get all features that intersect a pixel on the viewport.
     * @param {import("./pixel.js").Pixel} pixel Pixel.
     * @param {AtPixelOptions=} opt_options Optional options.
     * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
     * an empty array if none were found.
     * @api
     */ PluggableMap.prototype.getFeaturesAtPixel = function(pixel, opt_options) {
        var features = [];
        this.forEachFeatureAtPixel(pixel, function(feature) {
            features.push(feature);
        }, opt_options);
        return features;
    };
    /**
     * Detect layers that have a color value at a pixel on the viewport, and
     * execute a callback with each matching layer. Layers included in the
     * detection can be configured through `opt_layerFilter`.
     *
     * Note: this may give false positives unless the map layers have had different `className`
     * properties assigned to them.
     *
     * @param {import("./pixel.js").Pixel} pixel Pixel.
     * @param {function(this: S, import("./layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback
     *     Layer callback. This callback will receive two arguments: first is the
     *     {@link module:ol/layer/Layer layer}, second argument is an array representing
     *     [R, G, B, A] pixel values (0 - 255) and will be `null` for layer types
     *     that do not currently support this argument. To stop detection, callback
     *     functions can return a truthy value.
     * @param {AtPixelOptions=} opt_options Configuration options.
     * @return {T|undefined} Callback result, i.e. the return value of last
     * callback execution, or the first truthy callback return value.
     * @template S,T
     * @api
     */ PluggableMap.prototype.forEachLayerAtPixel = function(pixel, callback, opt_options) {
        if (!this.frameState_) return;
        var options = opt_options || {};
        var hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        var layerFilter = options.layerFilter || (0, $013a1733c226ec50$export$22e23a2304399231);
        return this.renderer_.forEachLayerAtPixel(pixel, this.frameState_, hitTolerance, callback, layerFilter);
    };
    /**
     * Detect if features intersect a pixel on the viewport. Layers included in the
     * detection can be configured through `opt_layerFilter`.
     * @param {import("./pixel.js").Pixel} pixel Pixel.
     * @param {AtPixelOptions=} opt_options Optional options.
     * @return {boolean} Is there a feature at the given pixel?
     * @api
     */ PluggableMap.prototype.hasFeatureAtPixel = function(pixel, opt_options) {
        if (!this.frameState_) return false;
        var coordinate = this.getCoordinateFromPixelInternal(pixel);
        opt_options = opt_options !== undefined ? opt_options : {};
        var layerFilter = opt_options.layerFilter !== undefined ? opt_options.layerFilter : (0, $013a1733c226ec50$export$22e23a2304399231);
        var hitTolerance = opt_options.hitTolerance !== undefined ? opt_options.hitTolerance : 0;
        var checkWrapped = opt_options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    };
    /**
     * Returns the coordinate in user projection for a browser event.
     * @param {MouseEvent} event Event.
     * @return {import("./coordinate.js").Coordinate} Coordinate.
     * @api
     */ PluggableMap.prototype.getEventCoordinate = function(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    };
    /**
     * Returns the coordinate in view projection for a browser event.
     * @param {MouseEvent} event Event.
     * @return {import("./coordinate.js").Coordinate} Coordinate.
     */ PluggableMap.prototype.getEventCoordinateInternal = function(event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    };
    /**
     * Returns the map pixel position for a browser event relative to the viewport.
     * @param {UIEvent} event Event.
     * @return {import("./pixel.js").Pixel} Pixel.
     * @api
     */ PluggableMap.prototype.getEventPixel = function(event) {
        var viewportPosition = this.viewport_.getBoundingClientRect();
        var eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
        'changedTouches' in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            eventPosition.clientX - viewportPosition.left,
            eventPosition.clientY - viewportPosition.top
        ];
    };
    /**
     * Get the target in which this map is rendered.
     * Note that this returns what is entered as an option or in setTarget:
     * if that was an element, it returns an element; if a string, it returns that.
     * @return {HTMLElement|string|undefined} The Element or id of the Element that the
     *     map is rendered in.
     * @observable
     * @api
     */ PluggableMap.prototype.getTarget = function() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET);
    };
    /**
     * Get the DOM element into which this map is rendered. In contrast to
     * `getTarget` this method always return an `Element`, or `null` if the
     * map has no target.
     * @return {HTMLElement} The element that the map is rendered in.
     * @api
     */ PluggableMap.prototype.getTargetElement = function() {
        var target = this.getTarget();
        if (target !== undefined) return typeof target === 'string' ? document.getElementById(target) : target;
        else return null;
    };
    /**
     * Get the coordinate for a given pixel.  This returns a coordinate in the
     * user projection.
     * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
     * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
     * @api
     */ PluggableMap.prototype.getCoordinateFromPixel = function(pixel) {
        return (0, $9c4744460e43e41b$export$698f563af1ba02a5)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    };
    /**
     * Get the coordinate for a given pixel.  This returns a coordinate in the
     * map view projection.
     * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
     * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
     */ PluggableMap.prototype.getCoordinateFromPixelInternal = function(pixel) {
        var frameState = this.frameState_;
        if (!frameState) return null;
        else return (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
    };
    /**
     * Get the map controls. Modifying this collection changes the controls
     * associated with the map.
     * @return {Collection<import("./control/Control.js").default>} Controls.
     * @api
     */ PluggableMap.prototype.getControls = function() {
        return this.controls;
    };
    /**
     * Get the map overlays. Modifying this collection changes the overlays
     * associated with the map.
     * @return {Collection<import("./Overlay.js").default>} Overlays.
     * @api
     */ PluggableMap.prototype.getOverlays = function() {
        return this.overlays_;
    };
    /**
     * Get an overlay by its identifier (the value returned by overlay.getId()).
     * Note that the index treats string and numeric identifiers as the same. So
     * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
     * @param {string|number} id Overlay identifier.
     * @return {import("./Overlay.js").default} Overlay.
     * @api
     */ PluggableMap.prototype.getOverlayById = function(id) {
        var overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    };
    /**
     * Get the map interactions. Modifying this collection changes the interactions
     * associated with the map.
     *
     * Interactions are used for e.g. pan, zoom and rotate.
     * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
     * @api
     */ PluggableMap.prototype.getInteractions = function() {
        return this.interactions;
    };
    /**
     * Get the layergroup associated with this map.
     * @return {LayerGroup} A layer group containing the layers in this map.
     * @observable
     * @api
     */ PluggableMap.prototype.getLayerGroup = function() {
        return /** @type {LayerGroup} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP);
    };
    /**
     * Get the collection of layers associated with this map.
     * @return {!Collection<import("./layer/Base.js").default>} Layers.
     * @api
     */ PluggableMap.prototype.getLayers = function() {
        var layers = this.getLayerGroup().getLayers();
        return layers;
    };
    /**
     * @return {boolean} Layers have sources that are still loading.
     */ PluggableMap.prototype.getLoading = function() {
        var layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for(var i = 0, ii = layerStatesArray.length; i < ii; ++i){
            var layer = layerStatesArray[i].layer;
            var source = /** @type {import("./layer/Layer.js").default} */ layer.getSource();
            if (source && source.loading) return true;
        }
        return false;
    };
    /**
     * Get the pixel for a coordinate.  This takes a coordinate in the user
     * projection and returns the corresponding pixel.
     * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
     * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
     * @api
     */ PluggableMap.prototype.getPixelFromCoordinate = function(coordinate) {
        var viewCoordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    };
    /**
     * Get the pixel for a coordinate.  This takes a coordinate in the map view
     * projection and returns the corresponding pixel.
     * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
     * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
     */ PluggableMap.prototype.getPixelFromCoordinateInternal = function(coordinate) {
        var frameState = this.frameState_;
        if (!frameState) return null;
        else return (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    };
    /**
     * Get the map renderer.
     * @return {import("./renderer/Map.js").default} Renderer
     */ PluggableMap.prototype.getRenderer = function() {
        return this.renderer_;
    };
    /**
     * Get the size of this map.
     * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
     * @observable
     * @api
     */ PluggableMap.prototype.getSize = function() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE);
    };
    /**
     * Get the view associated with this map. A view manages properties such as
     * center and resolution.
     * @return {View} The view that controls this map.
     * @observable
     * @api
     */ PluggableMap.prototype.getView = function() {
        return /** @type {View} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW);
    };
    /**
     * Get the element that serves as the map viewport.
     * @return {HTMLElement} Viewport.
     * @api
     */ PluggableMap.prototype.getViewport = function() {
        return this.viewport_;
    };
    /**
     * Get the element that serves as the container for overlays.  Elements added to
     * this container will let mousedown and touchstart events through to the map,
     * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
     * events.
     * @return {!HTMLElement} The map's overlay container.
     */ PluggableMap.prototype.getOverlayContainer = function() {
        return this.overlayContainer_;
    };
    /**
     * Get the element that serves as a container for overlays that don't allow
     * event propagation. Elements added to this container won't let mousedown and
     * touchstart events through to the map, so clicks and gestures on an overlay
     * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @return {!HTMLElement} The map's overlay container that stops events.
     */ PluggableMap.prototype.getOverlayContainerStopEvent = function() {
        return this.overlayContainerStopEvent_;
    };
    /**
     * @return {!Document} The document where the map is displayed.
     */ PluggableMap.prototype.getOwnerDocument = function() {
        return this.getTargetElement() ? this.getTargetElement().ownerDocument : document;
    };
    /**
     * @param {import("./Tile.js").default} tile Tile.
     * @param {string} tileSourceKey Tile source key.
     * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
     * @param {number} tileResolution Tile resolution.
     * @return {number} Tile priority.
     */ PluggableMap.prototype.getTilePriority = function(tile, tileSourceKey, tileCenter, tileResolution) {
        return (0, $4c51fd53052a6bbc$export$f08ad5eceeff5d45)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    };
    /**
     * @param {UIEvent} browserEvent Browser event.
     * @param {string=} opt_type Type.
     */ PluggableMap.prototype.handleBrowserEvent = function(browserEvent, opt_type) {
        var type = opt_type || browserEvent.type;
        var mapBrowserEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    };
    /**
     * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
     */ PluggableMap.prototype.handleMapBrowserEvent = function(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        var originalEvent = /** @type {PointerEvent} */ mapBrowserEvent.originalEvent;
        var eventType = originalEvent.type;
        if (eventType === (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERDOWN || eventType === (0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL || eventType === (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN) {
            var doc = this.getOwnerDocument();
            var rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
            var target = 'host' in rootNode // ShadowRoot
             ? /** @type {ShadowRoot} */ rootNode.elementFromPoint(originalEvent.clientX, originalEvent.clientY) : /** @type {Node} */ originalEvent.target;
            if (// Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
            // It's possible for the target to no longer be in the page if it has been removed in an
            // event listener, this might happen in a Control that recreates it's content based on
            // user interaction either manually or via a render in something like https://reactjs.org/
            !(rootNode === doc ? doc.documentElement : rootNode).contains(target)) return;
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            var interactionsArray = this.getInteractions().getArray().slice();
            for(var i = interactionsArray.length - 1; i >= 0; i--){
                var interaction = interactionsArray[i];
                if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                var cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) break;
            }
        }
    };
    /**
     * @protected
     */ PluggableMap.prototype.handlePostRender = function() {
        var frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        var tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            var maxTotalLoading = this.maxTilesLoading_;
            var maxNewLoads = maxTotalLoading;
            if (frameState) {
                var hints = frameState.viewHints;
                if (hints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] || hints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING]) {
                    var lowOnFrameBudget = !(0, $67c66761d21428d0$export$716f8695eedb9bad) && Date.now() - frameState.time > 8;
                    maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                    maxNewLoads = lowOnFrameBudget ? 0 : 2;
                }
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                tileQueue.reprioritize(); // FIXME only call if view has changed
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).RENDERCOMPLETE) && !frameState.animate && !this.tileQueue_.getTilesLoading() && !this.getLoading()) this.renderer_.dispatchRenderEvent((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).RENDERCOMPLETE, frameState);
        var postRenderFunctions = this.postRenderFunctions_;
        for(var i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    };
    /**
     * @private
     */ PluggableMap.prototype.handleSizeChanged_ = function() {
        if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
        this.render();
    };
    /**
     * @private
     */ PluggableMap.prototype.handleTargetChanged_ = function() {
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        var targetElement;
        if (this.getTarget()) targetElement = this.getTargetElement();
        if (this.mapBrowserEventHandler_) {
            for(var i = 0, ii = this.keyHandlerKeys_.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.keyHandlerKeys_[i]);
            this.keyHandlerKeys_ = null;
            this.viewport_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_);
            if (this.handleResize_ !== undefined) {
                removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).RESIZE, this.handleResize_, false);
                this.handleResize_ = undefined;
            }
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            (0, $075f937d7366f1a2$export$1d0aa160432dfea5)(this.viewport_);
        }
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        } else {
            targetElement.appendChild(this.viewport_);
            if (!this.renderer_) this.renderer_ = this.createRenderer();
            this.mapBrowserEventHandler_ = new (0, $6085d006f9d0efe2$export$2e2bcd8739ae039)(this, this.moveTolerance_);
            for(var key in 0, $150f412a4a7fa263$export$2e2bcd8739ae039)this.mapBrowserEventHandler_.addEventListener((0, $150f412a4a7fa263$export$2e2bcd8739ae039)[key], this.handleMapBrowserEvent.bind(this));
            this.viewport_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
            this.viewport_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_, (0, $67c66761d21428d0$export$f751ce96c6c4e4fc) ? {
                passive: false
            } : false);
            var keyboardEventTarget = !this.keyboardEventTarget_ ? targetElement : this.keyboardEventTarget_;
            this.keyHandlerKeys_ = [
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(keyboardEventTarget, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN, this.handleBrowserEvent, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(keyboardEventTarget, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYPRESS, this.handleBrowserEvent, this)
            ];
            if (!this.handleResize_) {
                this.handleResize_ = this.updateSize.bind(this);
                window.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).RESIZE, this.handleResize_, false);
            }
        }
        this.updateSize();
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    };
    /**
     * @private
     */ PluggableMap.prototype.handleTileChange_ = function() {
        this.render();
    };
    /**
     * @private
     */ PluggableMap.prototype.handleViewPropertyChanged_ = function() {
        this.render();
    };
    /**
     * @private
     */ PluggableMap.prototype.handleViewChanged_ = function() {
        if (this.viewPropertyListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        var view = this.getView();
        if (view) {
            this.updateViewportSize_();
            this.viewPropertyListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(view, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(view, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    };
    /**
     * @private
     */ PluggableMap.prototype.handleLayerGroupChanged_ = function() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        var layerGroup = this.getLayerGroup();
        if (layerGroup) this.layerGroupPropertyListenerKeys_ = [
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.render, this),
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.render, this)
        ];
        this.render();
    };
    /**
     * @return {boolean} Is rendered.
     */ PluggableMap.prototype.isRendered = function() {
        return !!this.frameState_;
    };
    /**
     * Requests an immediate render in a synchronous manner.
     * @api
     */ PluggableMap.prototype.renderSync = function() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    };
    /**
     * Redraws all text after new fonts have loaded
     */ PluggableMap.prototype.redrawText = function() {
        var layerStates = this.getLayerGroup().getLayerStatesArray();
        for(var i = 0, ii = layerStates.length; i < ii; ++i){
            var layer = layerStates[i].layer;
            if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
        }
    };
    /**
     * Request a map rendering (at the next animation frame).
     * @api
     */ PluggableMap.prototype.render = function() {
        if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    };
    /**
     * Remove the given control from the map.
     * @param {import("./control/Control.js").default} control Control.
     * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
     *     if the control was not found).
     * @api
     */ PluggableMap.prototype.removeControl = function(control) {
        return this.getControls().remove(control);
    };
    /**
     * Remove the given interaction from the map.
     * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
     * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
     *     undefined if the interaction was not found).
     * @api
     */ PluggableMap.prototype.removeInteraction = function(interaction) {
        return this.getInteractions().remove(interaction);
    };
    /**
     * Removes the given layer from the map.
     * @param {import("./layer/Base.js").default} layer Layer.
     * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
     *     layer was not found).
     * @api
     */ PluggableMap.prototype.removeLayer = function(layer) {
        var layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    };
    /**
     * Remove the given overlay from the map.
     * @param {import("./Overlay.js").default} overlay Overlay.
     * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
     *     if the overlay was not found).
     * @api
     */ PluggableMap.prototype.removeOverlay = function(overlay) {
        return this.getOverlays().remove(overlay);
    };
    /**
     * @param {number} time Time.
     * @private
     */ PluggableMap.prototype.renderFrame_ = function(time) {
        var _this = this;
        var size = this.getSize();
        var view = this.getView();
        var previousFrameState = this.frameState_;
        /** @type {?FrameState} */ var frameState = null;
        if (size !== undefined && (0, $cc435a5409103773$export$622c471beb1693c7)(size) && view && view.isDef()) {
            var viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            var viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutterTree: null,
                extent: (0, $6da4c8ed3074c92b$export$13ba650faf8308)(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {}
            };
        }
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                var moveStart = !this.previousExtent_ || !(0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(this.previousExtent_) && !(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, $6da4c8ed3074c92b$export$3e2152b047719fa1)(this.previousExtent_);
                }
            }
            var idle = this.previousExtent_ && !frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] && !frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING] && !(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).MOVEEND, this, frameState));
                (0, $6da4c8ed3074c92b$export$9cd59f9826255e47)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, this, frameState));
        if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(function() {
            _this.postRenderTimeoutHandle_ = undefined;
            _this.handlePostRender();
        }, 0);
    };
    /**
     * Sets the layergroup of this map.
     * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
     * @observable
     * @api
     */ PluggableMap.prototype.setLayerGroup = function(layerGroup) {
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP, layerGroup);
    };
    /**
     * Set the size of this map.
     * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
     * @observable
     * @api
     */ PluggableMap.prototype.setSize = function(size) {
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE, size);
    };
    /**
     * Set the target element to render this map into.
     * @param {HTMLElement|string|undefined} target The Element or id of the Element
     *     that the map is rendered in.
     * @observable
     * @api
     */ PluggableMap.prototype.setTarget = function(target) {
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET, target);
    };
    /**
     * Set the view for this map.
     * @param {View} view The view that controls this map.
     * @observable
     * @api
     */ PluggableMap.prototype.setView = function(view) {
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW, view);
    };
    /**
     * Force a recalculation of the map viewport size.  This should be called when
     * third-party code changes the size of the map viewport.
     * @api
     */ PluggableMap.prototype.updateSize = function() {
        var targetElement = this.getTargetElement();
        if (!targetElement) this.setSize(undefined);
        else {
            var computedStyle = getComputedStyle(targetElement);
            this.setSize([
                targetElement.offsetWidth - parseFloat(computedStyle['borderLeftWidth']) - parseFloat(computedStyle['paddingLeft']) - parseFloat(computedStyle['paddingRight']) - parseFloat(computedStyle['borderRightWidth']),
                targetElement.offsetHeight - parseFloat(computedStyle['borderTopWidth']) - parseFloat(computedStyle['paddingTop']) - parseFloat(computedStyle['paddingBottom']) - parseFloat(computedStyle['borderBottomWidth'])
            ]);
        }
        this.updateViewportSize_();
    };
    /**
     * Recomputes the viewport size and save it on the view object (if any)
     * @private
     */ PluggableMap.prototype.updateViewportSize_ = function() {
        var view = this.getView();
        if (view) {
            var size = undefined;
            var computedStyle = getComputedStyle(this.viewport_);
            if (computedStyle.width && computedStyle.height) size = [
                parseInt(computedStyle.width, 10),
                parseInt(computedStyle.height, 10)
            ];
            view.setViewportSize(size);
        }
    };
    return PluggableMap;
}((0, $b68b3d6e32e3074a$export$2e2bcd8739ae039));
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $cceb59c4bc2a46b0$var$createOptionsInternal(options) {
    /**
     * @type {HTMLElement|Document}
     */ var keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === 'string' ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
     * @type {Object<string, *>}
     */ var values = {};
    var layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === 'function' ? /** @type {LayerGroup} */ options.layers : new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
        layers: /** @type {Collection} */ options.layers
    });
    values[(0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP] = layerGroup;
    values[(0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET] = options.target;
    values[(0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW] = options.view !== undefined ? options.view : new (0, $70364d0195659942$export$2e2bcd8739ae039)();
    var controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(options.controls.slice());
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ options.controls.getArray === 'function', 47); // Expected `controls` to be an array or an `import("./Collection.js").Collection`
            controls = /** @type {Collection} */ options.controls;
        }
    }
    var interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(options.interactions.slice());
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ options.interactions.getArray === 'function', 48); // Expected `interactions` to be an array or an `import("./Collection.js").Collection`
            interactions = /** @type {Collection} */ options.interactions;
        }
    }
    var overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(options.overlays.slice());
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ options.overlays.getArray === 'function', 49); // Expected `overlays` to be an array or an `import("./Collection.js").Collection`
            overlays = options.overlays;
        }
    } else overlays = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $cceb59c4bc2a46b0$export$2e2bcd8739ae039 = $cceb59c4bc2a46b0$var$PluggableMap;



/**
 * @module ol/control
 */ 




var $b978dafe8f7d27ff$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * var myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ var $b978dafe8f7d27ff$var$Control = /** @class */ function(_super) {
    $b978dafe8f7d27ff$var$__extends(Control, _super);
    /**
     * @param {Options} options Control options.
     */ function Control(options) {
        var _this = _super.call(this) || this;
        var element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = 'auto';
        /**
         * @protected
         * @type {HTMLElement}
         */ _this.element = element ? element : null;
        /**
         * @private
         * @type {HTMLElement}
         */ _this.target_ = null;
        /**
         * @private
         * @type {import("../PluggableMap.js").default}
         */ _this.map_ = null;
        /**
         * @protected
         * @type {!Array<import("../events.js").EventsKey>}
         */ _this.listenerKeys = [];
        if (options.render) _this.render = options.render;
        if (options.target) _this.setTarget(options.target);
        return _this;
    }
    /**
     * Clean up.
     */ Control.prototype.disposeInternal = function() {
        (0, $075f937d7366f1a2$export$1d0aa160432dfea5)(this.element);
        _super.prototype.disposeInternal.call(this);
    };
    /**
     * Get the map associated with this control.
     * @return {import("../PluggableMap.js").default} Map.
     * @api
     */ Control.prototype.getMap = function() {
        return this.map_;
    };
    /**
     * Remove the control from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     * @api
     */ Control.prototype.setMap = function(map) {
        if (this.map_) (0, $075f937d7366f1a2$export$1d0aa160432dfea5)(this.element);
        for(var i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (this.map_) {
            var target = this.target_ ? this.target_ : map.getOverlayContainerStopEvent();
            target.appendChild(this.element);
            if (this.render !== (0, $013a1733c226ec50$export$1cd1943b3a73bbe8)) this.listenerKeys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, this.render, this));
            map.render();
        }
    };
    /**
     * Renders the control.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @api
     */ Control.prototype.render = function(mapEvent) {};
    /**
     * This function is used to set a target element for the control. It has no
     * effect if it is called after the control has been added to the map (i.e.
     * after `setMap` is called on the control). If no `target` is set in the
     * options passed to the control constructor and if `setTarget` is not called
     * then the control is added to the map's overlay container.
     * @param {HTMLElement|string} target Target.
     * @api
     */ Control.prototype.setTarget = function(target) {
        this.target_ = typeof target === 'string' ? document.getElementById(target) : target;
    };
    return Control;
}((0, $b68b3d6e32e3074a$export$2e2bcd8739ae039));
var $b978dafe8f7d27ff$export$2e2bcd8739ae039 = $b978dafe8f7d27ff$var$Control;







var $6a26ab11104d2c24$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='»'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ var $6a26ab11104d2c24$var$Attribution = /** @class */ function(_super) {
    $6a26ab11104d2c24$var$__extends(Attribution, _super);
    /**
     * @param {Options=} opt_options Attribution options.
     */ function Attribution(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        }) || this;
        /**
         * @private
         * @type {HTMLElement}
         */ _this.ulElement_ = document.createElement('ul');
        /**
         * @private
         * @type {boolean}
         */ _this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
         * @private
         * @type {boolean}
         */ _this.userCollapsed_ = _this.collapsed_;
        /**
         * @private
         * @type {boolean}
         */ _this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
         * @private
         * @type {boolean}
         */ _this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!_this.collapsible_) _this.collapsed_ = false;
        var className = options.className !== undefined ? options.className : 'ol-attribution';
        var tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Attributions';
        var expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + '-expand';
        var collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u00BB';
        var collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + '-collpase';
        if (typeof collapseLabel === 'string') {
            /**
             * @private
             * @type {HTMLElement}
             */ _this.collapseLabel_ = document.createElement('span');
            _this.collapseLabel_.textContent = collapseLabel;
            _this.collapseLabel_.className = collapseClassName;
        } else _this.collapseLabel_ = collapseLabel;
        var label = options.label !== undefined ? options.label : 'i';
        if (typeof label === 'string') {
            /**
             * @private
             * @type {HTMLElement}
             */ _this.label_ = document.createElement('span');
            _this.label_.textContent = label;
            _this.label_.className = expandClassName;
        } else _this.label_ = label;
        var activeLabel = _this.collapsible_ && !_this.collapsed_ ? _this.collapseLabel_ : _this.label_;
        var button = document.createElement('button');
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(activeLabel);
        button.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, _this.handleClick_.bind(_this), false);
        var cssClasses = className + ' ' + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + ' ' + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192) + (_this.collapsed_ && _this.collapsible_ ? ' ' + (0, $ce07df6d5d4656f1$export$e16017ac68d14492) : '') + (_this.collapsible_ ? '' : ' ol-uncollapsible');
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(_this.ulElement_);
        element.appendChild(button);
        /**
         * A list of currently rendered resolutions.
         * @type {Array<string>}
         * @private
         */ _this.renderedAttributions_ = [];
        /**
         * @private
         * @type {boolean}
         */ _this.renderedVisible_ = true;
        return _this;
    }
    /**
     * Collect a list of visible attributions and set the collapsible state.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @return {Array<string>} Attributions.
     * @private
     */ Attribution.prototype.collectSourceAttributions_ = function(frameState) {
        /**
         * Used to determine if an attribution already exists.
         * @type {!Object<string, boolean>}
         */ var lookup = {};
        /**
         * A list of visible attributions.
         * @type {Array<string>}
         */ var visibleAttributions = [];
        var collapsible = true;
        var layerStatesArray = frameState.layerStatesArray;
        for(var i = 0, ii = layerStatesArray.length; i < ii; ++i){
            var layerState = layerStatesArray[i];
            if (!(0, $534f30fce11effcd$export$acb1e9cb9ce4ca56)(layerState, frameState.viewState)) continue;
            var source = /** @type {import("../layer/Layer.js").default} */ layerState.layer.getSource();
            if (!source) continue;
            var attributionGetter = source.getAttributions();
            if (!attributionGetter) continue;
            var attributions = attributionGetter(frameState);
            if (!attributions) continue;
            collapsible = collapsible && source.getAttributionsCollapsible() !== false;
            if (Array.isArray(attributions)) {
                for(var j = 0, jj = attributions.length; j < jj; ++j)if (!(attributions[j] in lookup)) {
                    visibleAttributions.push(attributions[j]);
                    lookup[attributions[j]] = true;
                }
            } else if (!(attributions in lookup)) {
                visibleAttributions.push(attributions);
                lookup[attributions] = true;
            }
        }
        if (!this.overrideCollapsible_) this.setCollapsible(collapsible);
        return visibleAttributions;
    };
    /**
     * @private
     * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
     */ Attribution.prototype.updateElement_ = function(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        var attributions = this.collectSourceAttributions_(frameState);
        var visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? '' : 'none';
            this.renderedVisible_ = visible;
        }
        if ((0, $b998d41b678ed5d1$export$e9bab7fafb253603)(attributions, this.renderedAttributions_)) return;
        (0, $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1)(this.ulElement_);
        // append the attributions
        for(var i = 0, ii = attributions.length; i < ii; ++i){
            var element = document.createElement('li');
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    };
    /**
     * @param {MouseEvent} event The event to handle
     * @private
     */ Attribution.prototype.handleClick_ = function(event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    };
    /**
     * @private
     */ Attribution.prototype.handleToggle_ = function() {
        this.element.classList.toggle((0, $ce07df6d5d4656f1$export$e16017ac68d14492));
        if (this.collapsed_) (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.collapseLabel_, this.label_);
        else (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
    };
    /**
     * Return `true` if the attribution is collapsible, `false` otherwise.
     * @return {boolean} True if the widget is collapsible.
     * @api
     */ Attribution.prototype.getCollapsible = function() {
        return this.collapsible_;
    };
    /**
     * Set whether the attribution should be collapsible.
     * @param {boolean} collapsible True if the widget is collapsible.
     * @api
     */ Attribution.prototype.setCollapsible = function(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle('ol-uncollapsible');
        if (this.userCollapsed_) this.handleToggle_();
    };
    /**
     * Collapse or expand the attribution according to the passed parameter. Will
     * not do anything if the attribution isn't collapsible or if the current
     * collapsed state is already the one requested.
     * @param {boolean} collapsed True if the widget is collapsed.
     * @api
     */ Attribution.prototype.setCollapsed = function(collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    };
    /**
     * Return `true` when the attribution is currently collapsed or `false`
     * otherwise.
     * @return {boolean} True if the widget is collapsed.
     * @api
     */ Attribution.prototype.getCollapsed = function() {
        return this.collapsed_;
    };
    /**
     * Update the attribution element.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @override
     */ Attribution.prototype.render = function(mapEvent) {
        this.updateElement_(mapEvent.frameState);
    };
    return Attribution;
}((0, $b978dafe8f7d27ff$export$2e2bcd8739ae039));
var $6a26ab11104d2c24$export$2e2bcd8739ae039 = $6a26ab11104d2c24$var$Attribution;







var $a305cff1f91b3b86$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ var $a305cff1f91b3b86$var$Rotate = /** @class */ function(_super) {
    $a305cff1f91b3b86$var$__extends(Rotate, _super);
    /**
     * @param {Options=} opt_options Rotate options.
     */ function Rotate(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        }) || this;
        var className = options.className !== undefined ? options.className : 'ol-rotate';
        var label = options.label !== undefined ? options.label : '\u21E7';
        var compassClassName = options.compassClassName !== undefined ? options.compassClassName : 'ol-compass';
        /**
         * @type {HTMLElement}
         * @private
         */ _this.label_ = null;
        if (typeof label === 'string') {
            _this.label_ = document.createElement('span');
            _this.label_.className = compassClassName;
            _this.label_.textContent = label;
        } else {
            _this.label_ = label;
            _this.label_.classList.add(compassClassName);
        }
        var tipLabel = options.tipLabel ? options.tipLabel : 'Reset rotation';
        var button = document.createElement('button');
        button.className = className + '-reset';
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(_this.label_);
        button.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, _this.handleClick_.bind(_this), false);
        var cssClasses = className + ' ' + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + ' ' + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192);
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(button);
        _this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
         * @type {number}
         * @private
         */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
         * @type {boolean}
         * @private
         */ _this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
         * @private
         * @type {number|undefined}
         */ _this.rotation_ = undefined;
        if (_this.autoHide_) _this.element.classList.add((0, $ce07df6d5d4656f1$export$981241db82723ce2));
        return _this;
    }
    /**
     * @param {MouseEvent} event The event to handle
     * @private
     */ Rotate.prototype.handleClick_ = function(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    };
    /**
     * @private
     */ Rotate.prototype.resetNorth_ = function() {
        var map = this.getMap();
        var view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        var rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
            });
            else view.setRotation(0);
        }
    };
    /**
     * Update the rotate control element.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @override
     */ Rotate.prototype.render = function(mapEvent) {
        var frameState = mapEvent.frameState;
        if (!frameState) return;
        var rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            var transform = 'rotate(' + rotation + 'rad)';
            if (this.autoHide_) {
                var contains = this.element.classList.contains((0, $ce07df6d5d4656f1$export$981241db82723ce2));
                if (!contains && rotation === 0) this.element.classList.add((0, $ce07df6d5d4656f1$export$981241db82723ce2));
                else if (contains && rotation !== 0) this.element.classList.remove((0, $ce07df6d5d4656f1$export$981241db82723ce2));
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    };
    return Rotate;
}((0, $b978dafe8f7d27ff$export$2e2bcd8739ae039));
var $a305cff1f91b3b86$export$2e2bcd8739ae039 = $a305cff1f91b3b86$var$Rotate;






var $4901e3e27e30416a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='-'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ var $4901e3e27e30416a$var$Zoom = /** @class */ function(_super) {
    $4901e3e27e30416a$var$__extends(Zoom, _super);
    /**
     * @param {Options=} opt_options Zoom options.
     */ function Zoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            target: options.target
        }) || this;
        var className = options.className !== undefined ? options.className : 'ol-zoom';
        var delta = options.delta !== undefined ? options.delta : 1;
        var zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + '-in';
        var zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + '-out';
        var zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : '+';
        var zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : '\u2212';
        var zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : 'Zoom in';
        var zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : 'Zoom out';
        var inElement = document.createElement('button');
        inElement.className = zoomInClassName;
        inElement.setAttribute('type', 'button');
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === 'string' ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, _this.handleClick_.bind(_this, delta), false);
        var outElement = document.createElement('button');
        outElement.className = zoomOutClassName;
        outElement.setAttribute('type', 'button');
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === 'string' ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, _this.handleClick_.bind(_this, -delta), false);
        var cssClasses = className + ' ' + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + ' ' + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192);
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
         * @type {number}
         * @private
         */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    /**
     * @param {number} delta Zoom delta.
     * @param {MouseEvent} event The event to handle
     * @private
     */ Zoom.prototype.handleClick_ = function(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    };
    /**
     * @param {number} delta Zoom delta.
     * @private
     */ Zoom.prototype.zoomByDelta_ = function(delta) {
        var map = this.getMap();
        var view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        var currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            var newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
                });
            } else view.setZoom(newZoom);
        }
    };
    return Zoom;
}((0, $b978dafe8f7d27ff$export$2e2bcd8739ae039));
var $4901e3e27e30416a$export$2e2bcd8739ae039 = $4901e3e27e30416a$var$Zoom;








var $213858285507f9af$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $213858285507f9af$var$events = [
    'fullscreenchange',
    'webkitfullscreenchange',
    'MSFullscreenChange'
];
/**
 * @enum {string}
 */ var $213858285507f9af$var$FullScreenEventType = {
    /**
     * Triggered after the map entered fullscreen.
     * @event FullScreenEventType#enterfullscreen
     * @api
     */ ENTERFULLSCREEN: 'enterfullscreen',
    /**
     * Triggered after the map leave fullscreen.
     * @event FullScreenEventType#leavefullscreen
     * @api
     */ LEAVEFULLSCREEN: 'leavefullscreen'
};
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-full-screen'] CSS class name.
 * @property {string|Text} [label='\u2922'] Text label to use for the button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|Text} [labelActive='\u00d7'] Text label to use for the
 * button when full-screen is active.
 * @property {string} [activeClassName=className + '-true'] CSS class name for the button
 * when full-screen is active.
 * @property {string} [inactiveClassName=className + '-false'] CSS class name for the button
 * when full-screen is inactive.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Toggle full-screen'] Text label to use for the button tip.
 * @property {boolean} [keys=false] Full keyboard access.
 * @property {HTMLElement|string} [target] Specify a target if you want the
 * control to be rendered outside of the map's viewport.
 * @property {HTMLElement|string} [source] The element to be displayed
 * fullscreen. When not provided, the element containing the map viewport will
 * be displayed fullscreen.
 */ /**
 * @classdesc
 * Provides a button that when clicked fills up the full screen with the map.
 * The full screen source element is by default the element containing the map viewport unless
 * overridden by providing the `source` option. In which case, the dom
 * element introduced using this parameter will be displayed in full screen.
 *
 * When in full screen mode, a close button is shown to exit full screen mode.
 * The [Fullscreen API](http://www.w3.org/TR/fullscreen/) is used to
 * toggle the map in full screen mode.
 *
 * @fires FullScreenEventType#enterfullscreen
 * @fires FullScreenEventType#leavefullscreen
 * @api
 */ var $213858285507f9af$var$FullScreen = /** @class */ function(_super) {
    $213858285507f9af$var$__extends(FullScreen, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function FullScreen(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            target: options.target
        }) || this;
        /**
         * @private
         * @type {string}
         */ _this.cssClassName_ = options.className !== undefined ? options.className : 'ol-full-screen';
        /**
         * @private
         * @type {Array<string>}
         */ _this.activeClassName_ = options.activeClassName !== undefined ? options.activeClassName.split(' ') : [
            _this.cssClassName_ + '-true'
        ];
        /**
         * @private
         * @type {Array<string>}
         */ _this.inactiveClassName_ = options.inactiveClassName !== undefined ? options.inactiveClassName.split(' ') : [
            _this.cssClassName_ + '-false'
        ];
        var label = options.label !== undefined ? options.label : '\u2922';
        /**
         * @private
         * @type {Text}
         */ _this.labelNode_ = typeof label === 'string' ? document.createTextNode(label) : label;
        var labelActive = options.labelActive !== undefined ? options.labelActive : '\u00d7';
        /**
         * @private
         * @type {Text}
         */ _this.labelActiveNode_ = typeof labelActive === 'string' ? document.createTextNode(labelActive) : labelActive;
        /**
         * @private
         * @type {HTMLElement}
         */ _this.button_ = document.createElement('button');
        var tipLabel = options.tipLabel ? options.tipLabel : 'Toggle full-screen';
        _this.setClassName_(_this.button_, $213858285507f9af$var$isFullScreen());
        _this.button_.setAttribute('type', 'button');
        _this.button_.title = tipLabel;
        _this.button_.appendChild(_this.labelNode_);
        _this.button_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, _this.handleClick_.bind(_this), false);
        var cssClasses = _this.cssClassName_ + ' ' + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + ' ' + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192) + ' ' + (!$213858285507f9af$var$isFullScreenSupported() ? (0, $ce07df6d5d4656f1$export$68eede0dd8c6c1da) : '');
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(_this.button_);
        /**
         * @private
         * @type {boolean}
         */ _this.keys_ = options.keys !== undefined ? options.keys : false;
        /**
         * @private
         * @type {HTMLElement|string|undefined}
         */ _this.source_ = options.source;
        return _this;
    }
    /**
     * @param {MouseEvent} event The event to handle
     * @private
     */ FullScreen.prototype.handleClick_ = function(event) {
        event.preventDefault();
        this.handleFullScreen_();
    };
    /**
     * @private
     */ FullScreen.prototype.handleFullScreen_ = function() {
        if (!$213858285507f9af$var$isFullScreenSupported()) return;
        var map = this.getMap();
        if (!map) return;
        if ($213858285507f9af$var$isFullScreen()) $213858285507f9af$var$exitFullScreen();
        else {
            var element = void 0;
            if (this.source_) element = typeof this.source_ === 'string' ? document.getElementById(this.source_) : this.source_;
            else element = map.getTargetElement();
            if (this.keys_) $213858285507f9af$var$requestFullScreenWithKeys(element);
            else $213858285507f9af$var$requestFullScreen(element);
        }
    };
    /**
     * @private
     */ FullScreen.prototype.handleFullScreenChange_ = function() {
        var map = this.getMap();
        if ($213858285507f9af$var$isFullScreen()) {
            this.setClassName_(this.button_, true);
            (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.labelActiveNode_, this.labelNode_);
            this.dispatchEvent($213858285507f9af$var$FullScreenEventType.ENTERFULLSCREEN);
        } else {
            this.setClassName_(this.button_, false);
            (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.labelNode_, this.labelActiveNode_);
            this.dispatchEvent($213858285507f9af$var$FullScreenEventType.LEAVEFULLSCREEN);
        }
        if (map) map.updateSize();
    };
    /**
     * @param {HTMLElement} element Target element
     * @param {boolean} fullscreen True if fullscreen class name should be active
     * @private
     */ FullScreen.prototype.setClassName_ = function(element, fullscreen) {
        var _a, _b, _c;
        var activeClassName = this.activeClassName_;
        var inactiveClassName = this.inactiveClassName_;
        var nextClassName = fullscreen ? activeClassName : inactiveClassName;
        (_a = element.classList).remove.apply(_a, activeClassName);
        (_b = element.classList).remove.apply(_b, inactiveClassName);
        (_c = element.classList).add.apply(_c, nextClassName);
    };
    /**
     * Remove the control from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     * @api
     */ FullScreen.prototype.setMap = function(map) {
        _super.prototype.setMap.call(this, map);
        if (map) for(var i = 0, ii = $213858285507f9af$var$events.length; i < ii; ++i)this.listenerKeys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(document, $213858285507f9af$var$events[i], this.handleFullScreenChange_, this));
    };
    return FullScreen;
}((0, $b978dafe8f7d27ff$export$2e2bcd8739ae039));
/**
 * @return {boolean} Fullscreen is supported by the current platform.
 */ function $213858285507f9af$var$isFullScreenSupported() {
    var body = document.body;
    return !!(body['webkitRequestFullscreen'] || body['msRequestFullscreen'] && document['msFullscreenEnabled'] || body.requestFullscreen && document.fullscreenEnabled);
}
/**
 * @return {boolean} Element is currently in fullscreen.
 */ function $213858285507f9af$var$isFullScreen() {
    return !!(document['webkitIsFullScreen'] || document['msFullscreenElement'] || document.fullscreenElement);
}
/**
 * Request to fullscreen an element.
 * @param {HTMLElement} element Element to request fullscreen
 */ function $213858285507f9af$var$requestFullScreen(element) {
    if (element.requestFullscreen) element.requestFullscreen();
    else if (element['msRequestFullscreen']) element['msRequestFullscreen']();
    else if (element['webkitRequestFullscreen']) element['webkitRequestFullscreen']();
}
/**
 * Request to fullscreen an element with keyboard input.
 * @param {HTMLElement} element Element to request fullscreen
 */ function $213858285507f9af$var$requestFullScreenWithKeys(element) {
    if (element['webkitRequestFullscreen']) element['webkitRequestFullscreen']();
    else $213858285507f9af$var$requestFullScreen(element);
}
/**
 * Exit fullscreen.
 */ function $213858285507f9af$var$exitFullScreen() {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document['msExitFullscreen']) document['msExitFullscreen']();
    else if (document['webkitExitFullscreen']) document['webkitExitFullscreen']();
}
var $213858285507f9af$export$2e2bcd8739ae039 = $213858285507f9af$var$FullScreen;







function $b4471d80e1d69273$export$ebe90cb607ad99e(opt_options) {
    var options = opt_options ? opt_options : {};
    var controls = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    var zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $4901e3e27e30416a$export$2e2bcd8739ae039)(options.zoomOptions));
    var rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $a305cff1f91b3b86$export$2e2bcd8739ae039)(options.rotateOptions));
    var attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $6a26ab11104d2c24$export$2e2bcd8739ae039)(options.attributionOptions));
    return controls;
}


/**
 * @module ol/interaction
 */ 

/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $2c9e42723ccf2bfb$export$2e2bcd8739ae039 = {
    ACTIVE: 'active'
};



var $39210df8527e63e5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} handleEvent
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ var $39210df8527e63e5$var$Interaction = /** @class */ function(_super) {
    $39210df8527e63e5$var$__extends(Interaction, _super);
    /**
     * @param {InteractionOptions=} opt_options Options.
     */ function Interaction(opt_options) {
        var _this = _super.call(this) || this;
        if (opt_options && opt_options.handleEvent) _this.handleEvent = opt_options.handleEvent;
        /**
         * @private
         * @type {import("../PluggableMap.js").default}
         */ _this.map_ = null;
        _this.setActive(true);
        return _this;
    }
    /**
     * Return whether the interaction is currently active.
     * @return {boolean} `true` if the interaction is active, `false` otherwise.
     * @observable
     * @api
     */ Interaction.prototype.getActive = function() {
        return /** @type {boolean} */ this.get((0, $2c9e42723ccf2bfb$export$2e2bcd8739ae039).ACTIVE);
    };
    /**
     * Get the map associated with this interaction.
     * @return {import("../PluggableMap.js").default} Map.
     * @api
     */ Interaction.prototype.getMap = function() {
        return this.map_;
    };
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event}.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @api
     */ Interaction.prototype.handleEvent = function(mapBrowserEvent) {
        return true;
    };
    /**
     * Activate or deactivate the interaction.
     * @param {boolean} active Active.
     * @observable
     * @api
     */ Interaction.prototype.setActive = function(active) {
        this.set((0, $2c9e42723ccf2bfb$export$2e2bcd8739ae039).ACTIVE, active);
    };
    /**
     * Remove the interaction from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     */ Interaction.prototype.setMap = function(map) {
        this.map_ = map;
    };
    return Interaction;
}((0, $b68b3d6e32e3074a$export$2e2bcd8739ae039));
function $39210df8527e63e5$export$4c486572e961a974(view, delta, opt_duration) {
    var currentCenter = view.getCenterInternal();
    if (currentCenter) {
        var center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: opt_duration !== undefined ? opt_duration : 250,
            easing: (0, $c7ccf7e681a9b333$export$45db2fc2f15997e7),
            center: view.getConstrainedCenter(center)
        });
    }
}
function $39210df8527e63e5$export$ace321ff2a8016ef(view, delta, opt_anchor, opt_duration) {
    var currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    var newZoom = view.getConstrainedZoom(currentZoom + delta);
    var newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: opt_anchor,
        duration: opt_duration !== undefined ? opt_duration : 250,
        easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
    });
}
var $39210df8527e63e5$export$2e2bcd8739ae039 = $39210df8527e63e5$var$Interaction;



var $b50403621294a654$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ var $b50403621294a654$var$DoubleClickZoom = /** @class */ function(_super) {
    $b50403621294a654$var$__extends(DoubleClickZoom, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function DoubleClickZoom(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         * @type {number}
         */ _this.delta_ = options.delta ? options.delta : 1;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} (if it was a
     * doubleclick) and eventually zooms the map.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     */ DoubleClickZoom.prototype.handleEvent = function(mapBrowserEvent) {
        var stopEvent = false;
        if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK) {
            var browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
            var map = mapBrowserEvent.map;
            var anchor = mapBrowserEvent.coordinate;
            var delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            var view = map.getView();
            (0, $39210df8527e63e5$export$ace321ff2a8016ef)(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    };
    return DoubleClickZoom;
}((0, $39210df8527e63e5$export$2e2bcd8739ae039));
var $b50403621294a654$export$2e2bcd8739ae039 = $b50403621294a654$var$DoubleClickZoom;





var $cf1eb502962d87a8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ var $cf1eb502962d87a8$var$PointerInteraction = /** @class */ function(_super) {
    $cf1eb502962d87a8$var$__extends(PointerInteraction, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function PointerInteraction(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, /** @type {import("./Interaction.js").InteractionOptions} */ options) || this;
        if (options.handleDownEvent) _this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) _this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) _this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) _this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) _this.stopDown = options.stopDown;
        /**
         * @type {boolean}
         * @protected
         */ _this.handlingDownUpSequence = false;
        /**
         * @type {!Object<string, PointerEvent>}
         * @private
         */ _this.trackedPointers_ = {};
        /**
         * @type {Array<PointerEvent>}
         * @protected
         */ _this.targetPointers = [];
        return _this;
    }
    /**
     * Returns the current number of pointers involved in the interaction,
     * e.g. `2` when two fingers are used.
     * @return {number} The number of pointers.
     * @api
     */ PointerInteraction.prototype.getPointerCount = function() {
        return this.targetPointers.length;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     * @protected
     */ PointerInteraction.prototype.handleDownEvent = function(mapBrowserEvent) {
        return false;
    };
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @protected
     */ PointerInteraction.prototype.handleDragEvent = function(mapBrowserEvent) {};
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} and may call into
     * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
     * detected.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @api
     */ PointerInteraction.prototype.handleEvent = function(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        var stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            } else if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP) {
                var handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN) {
                var handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    };
    /**
     * Handle pointer move events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @protected
     */ PointerInteraction.prototype.handleMoveEvent = function(mapBrowserEvent) {};
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     * @protected
     */ PointerInteraction.prototype.handleUpEvent = function(mapBrowserEvent) {
        return false;
    };
    /**
     * This function is used to determine if "down" events should be propagated
     * to other interactions or should be stopped.
     * @param {boolean} handled Was the event handled by the interaction?
     * @return {boolean} Should the `down` event be stopped?
     */ PointerInteraction.prototype.stopDown = function(handled) {
        return handled;
    };
    /**
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @private
     */ PointerInteraction.prototype.updateTrackedPointers_ = function(mapBrowserEvent) {
        if ($cf1eb502962d87a8$var$isPointerDraggingEvent(mapBrowserEvent)) {
            var event_1 = mapBrowserEvent.originalEvent;
            var id = event_1.pointerId.toString();
            if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP) delete this.trackedPointers_[id];
            else if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN) this.trackedPointers_[id] = event_1;
            else if (id in this.trackedPointers_) // update only when there was a pointerdown event for this pointer
            this.trackedPointers_[id] = event_1;
            this.targetPointers = (0, $beaefe87199bb537$export$a5c4301012ad6f07)(this.trackedPointers_);
        }
    };
    return PointerInteraction;
}((0, $39210df8527e63e5$export$2e2bcd8739ae039));
function $cf1eb502962d87a8$export$e2a20c553f6c85ce(pointerEvents) {
    var length = pointerEvents.length;
    var clientX = 0;
    var clientY = 0;
    for(var i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return [
        clientX / length,
        clientY / length
    ];
}
/**
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
 * @return {boolean} Whether the event is a pointerdown, pointerdrag
 *     or pointerup event.
 */ function $cf1eb502962d87a8$var$isPointerDraggingEvent(mapBrowserEvent) {
    var type = mapBrowserEvent.type;
    return type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN || type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG || type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP;
}
var $cf1eb502962d87a8$export$2e2bcd8739ae039 = $cf1eb502962d87a8$var$PointerInteraction;



/**
 * @module ol/events/condition
 */ 



function $edf87b50170125f7$export$84bf76cd7afc7469(var_args) {
    var conditions = arguments;
    /**
     * @param {import("../MapBrowserEvent.js").default} event Event.
     * @return {boolean} All conditions passed.
     */ return function(event) {
        var pass = true;
        for(var i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
var $edf87b50170125f7$export$573409992e89967e = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
var $edf87b50170125f7$export$4e5f01653f9f1f82 = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
var $edf87b50170125f7$export$d7ddd398f22d79ef = function(event) {
    return event.target.getTargetElement().contains(document.activeElement);
};
var $edf87b50170125f7$export$ae2cdf064e3b0c55 = function(event) {
    return event.map.getTargetElement().hasAttribute('tabindex') ? $edf87b50170125f7$export$d7ddd398f22d79ef(event) : true;
};
var $edf87b50170125f7$export$ba9e5d519bc326ca = (0, $013a1733c226ec50$export$22e23a2304399231);
var $edf87b50170125f7$export$64ef1bee2b9504c1 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).CLICK;
};
var $edf87b50170125f7$export$1238ad6b5e7fff70 = function(mapBrowserEvent) {
    var originalEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.button == 0 && !((0, $67c66761d21428d0$export$39dfd62a25e0fe93) && (0, $67c66761d21428d0$export$76c0a3b101d93136) && originalEvent.ctrlKey);
};
var $edf87b50170125f7$export$b3e22bcfd64c1022 = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
var $edf87b50170125f7$export$71eac0963f2c2f01 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == 'pointermove';
};
var $edf87b50170125f7$export$194df8bad091b401 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK;
};
var $edf87b50170125f7$export$c59d944dd10b3dc7 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK;
};
var $edf87b50170125f7$export$fdc892d0d8fe3bfb = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
var $edf87b50170125f7$export$f3100d8d6292d638 = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $67c66761d21428d0$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
var $edf87b50170125f7$export$5d31fe68a477cfbb = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
var $edf87b50170125f7$export$e5570ca80cd8fd54 = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    var tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== 'INPUT' && tagName !== 'SELECT' && tagName !== 'TEXTAREA';
};
var $edf87b50170125f7$export$abb7acbfa76bf3c4 = function(mapBrowserEvent) {
    var pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $35d5ec884318008e$export$a7a9523472993e97)(pointerEvent !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    // see http://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvent.pointerType == 'mouse';
};
var $edf87b50170125f7$export$e74de664a571d084 = function(mapBrowserEvent) {
    var pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $35d5ec884318008e$export$a7a9523472993e97)(pointerEvt !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    // see http://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === 'touch';
};
var $edf87b50170125f7$export$cd1707283a23f059 = function(mapBrowserEvent) {
    var pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $35d5ec884318008e$export$a7a9523472993e97)(pointerEvt !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    // see http://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === 'pen';
};
var $edf87b50170125f7$export$189f0d593022b199 = function(mapBrowserEvent) {
    var pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $35d5ec884318008e$export$a7a9523472993e97)(pointerEvent !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    return pointerEvent.isPrimary && pointerEvent.button === 0;
};




var $c11585da26a016db$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition~noModifierKeys} and {@link module:ol/events/condition~primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ var $c11585da26a016db$var$DragPan = /** @class */ function(_super) {
    $c11585da26a016db$var$__extends(DragPan, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function DragPan(opt_options) {
        var _this = _super.call(this, {
            stopDown: (0, $013a1733c226ec50$export$8f11cee4bdc7e668)
        }) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         * @type {import("../Kinetic.js").default|undefined}
         */ _this.kinetic_ = options.kinetic;
        /**
         * @type {import("../pixel.js").Pixel}
         */ _this.lastCentroid = null;
        /**
         * @type {number}
         */ _this.lastPointersCount_;
        /**
         * @type {boolean}
         */ _this.panning_ = false;
        var condition = options.condition ? options.condition : (0, $edf87b50170125f7$export$84bf76cd7afc7469)((0, $edf87b50170125f7$export$fdc892d0d8fe3bfb), (0, $edf87b50170125f7$export$189f0d593022b199));
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */ _this.condition_ = options.onFocusOnly ? (0, $edf87b50170125f7$export$84bf76cd7afc7469)((0, $edf87b50170125f7$export$ae2cdf064e3b0c55), condition) : condition;
        /**
         * @private
         * @type {boolean}
         */ _this.noKinetic_ = false;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */ DragPan.prototype.handleDragEvent = function(mapBrowserEvent) {
        if (!this.panning_) {
            this.panning_ = true;
            this.getMap().getView().beginInteraction();
        }
        var targetPointers = this.targetPointers;
        var centroid = (0, $cf1eb502962d87a8$export$e2a20c553f6c85ce)(targetPointers);
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                var delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1]
                ];
                var map = mapBrowserEvent.map;
                var view = map.getView();
                (0, $1bd0a226f9a16141$export$dcdf75081b88279d)(delta, view.getResolution());
                (0, $1bd0a226f9a16141$export$bb628a54ab399bc9)(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ DragPan.prototype.handleUpEvent = function(mapBrowserEvent) {
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                var distance = this.kinetic_.getDistance();
                var angle = this.kinetic_.getAngle();
                var center = view.getCenterInternal();
                var centerpx = map.getPixelFromCoordinateInternal(center);
                var dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        } else {
            if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
            // after one finger up, tiny drag, second finger up
            this.kinetic_.begin();
            this.lastCentroid = null;
            return true;
        }
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ DragPan.prototype.handleDownEvent = function(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.cancelAnimations();
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        } else return false;
    };
    return DragPan;
}((0, $cf1eb502962d87a8$export$2e2bcd8739ae039));
var $c11585da26a016db$export$2e2bcd8739ae039 = $c11585da26a016db$var$DragPan;






var $197c7092261b2aa0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition~altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ var $197c7092261b2aa0$var$DragRotate = /** @class */ function(_super) {
    $197c7092261b2aa0$var$__extends(DragRotate, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function DragRotate(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            stopDown: (0, $013a1733c226ec50$export$8f11cee4bdc7e668)
        }) || this;
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */ _this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$4e5f01653f9f1f82);
        /**
         * @private
         * @type {number|undefined}
         */ _this.lastAngle_ = undefined;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */ DragRotate.prototype.handleDragEvent = function(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (view.getConstraints().rotation === (0, $d65f0a322291d127$export$e20fbacbb41798b)) return;
        var size = map.getSize();
        var offset = mapBrowserEvent.pixel;
        var theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            var delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ DragRotate.prototype.handleUpEvent = function(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ DragRotate.prototype.handleDownEvent = function(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
        if ((0, $edf87b50170125f7$export$1238ad6b5e7fff70)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            var map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        } else return false;
    };
    return DragRotate;
}((0, $cf1eb502962d87a8$export$2e2bcd8739ae039));
var $197c7092261b2aa0$export$2e2bcd8739ae039 = $197c7092261b2aa0$var$DragRotate;




/**
 * @module ol/render/Box
 */ 

var $c47adf75308683a6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c47adf75308683a6$var$RenderBox = /** @class */ function(_super) {
    $c47adf75308683a6$var$__extends(RenderBox, _super);
    /**
     * @param {string} className CSS class name.
     */ function RenderBox(className) {
        var _this = _super.call(this) || this;
        /**
         * @type {import("../geom/Polygon.js").default}
         * @private
         */ _this.geometry_ = null;
        /**
         * @type {HTMLDivElement}
         * @private
         */ _this.element_ = document.createElement('div');
        _this.element_.style.position = 'absolute';
        _this.element_.style.pointerEvents = 'auto';
        _this.element_.className = 'ol-box ' + className;
        /**
         * @private
         * @type {import("../PluggableMap.js").default}
         */ _this.map_ = null;
        /**
         * @private
         * @type {import("../pixel.js").Pixel}
         */ _this.startPixel_ = null;
        /**
         * @private
         * @type {import("../pixel.js").Pixel}
         */ _this.endPixel_ = null;
        return _this;
    }
    /**
     * Clean up.
     */ RenderBox.prototype.disposeInternal = function() {
        this.setMap(null);
    };
    /**
     * @private
     */ RenderBox.prototype.render_ = function() {
        var startPixel = this.startPixel_;
        var endPixel = this.endPixel_;
        var px = 'px';
        var style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    };
    /**
     * @param {import("../PluggableMap.js").default} map Map.
     */ RenderBox.prototype.setMap = function(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            var style = this.element_.style;
            style.left = 'inherit';
            style.top = 'inherit';
            style.width = 'inherit';
            style.height = 'inherit';
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    };
    /**
     * @param {import("../pixel.js").Pixel} startPixel Start pixel.
     * @param {import("../pixel.js").Pixel} endPixel End pixel.
     */ RenderBox.prototype.setPixels = function(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    };
    /**
     * Creates or updates the cached geometry.
     */ RenderBox.prototype.createOrUpdateGeometry = function() {
        var startPixel = this.startPixel_;
        var endPixel = this.endPixel_;
        var pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        var coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    };
    /**
     * @return {import("../geom/Polygon.js").default} Geometry.
     */ RenderBox.prototype.getGeometry = function() {
        return this.geometry_;
    };
    return RenderBox;
}((0, $3273ed08087da3da$export$2e2bcd8739ae039));
var $c47adf75308683a6$export$2e2bcd8739ae039 = $c47adf75308683a6$var$RenderBox;



var $e05f414bc3918235$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * A function that takes a {@link module:ol/MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ var $e05f414bc3918235$var$DragBoxEventType = {
    /**
     * Triggered upon drag box start.
     * @event DragBoxEvent#boxstart
     * @api
     */ BOXSTART: 'boxstart',
    /**
     * Triggered on drag when box is active.
     * @event DragBoxEvent#boxdrag
     * @api
     */ BOXDRAG: 'boxdrag',
    /**
     * Triggered upon drag box end.
     * @event DragBoxEvent#boxend
     * @api
     */ BOXEND: 'boxend',
    /**
     * Triggered upon drag box canceled.
     * @event DragBoxEvent#boxcancel
     * @api
     */ BOXCANCEL: 'boxcancel'
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/DragBox~DragBox} instances are instances of
 * this type.
 */ var $e05f414bc3918235$export$7053c33c051365ea = /** @class */ function(_super) {
    $e05f414bc3918235$var$__extends(DragBoxEvent, _super);
    /**
     * @param {string} type The event type.
     * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
     */ function DragBoxEvent(type, coordinate, mapBrowserEvent) {
        var _this = _super.call(this, type) || this;
        /**
         * The coordinate of the drag event.
         * @const
         * @type {import("../coordinate.js").Coordinate}
         * @api
         */ _this.coordinate = coordinate;
        /**
         * @const
         * @type {import("../MapBrowserEvent.js").default}
         * @api
         */ _this.mapBrowserEvent = mapBrowserEvent;
        return _this;
    }
    return DragBoxEvent;
}((0, $aeedce20e9577100$export$2e2bcd8739ae039));
/**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ var $e05f414bc3918235$var$DragBox = /** @class */ function(_super) {
    $e05f414bc3918235$var$__extends(DragBox, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function DragBox(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @type {import("../render/Box.js").default}
         * @private
         */ _this.box_ = new (0, $c47adf75308683a6$export$2e2bcd8739ae039)(options.className || 'ol-dragbox');
        /**
         * @type {number}
         * @private
         */ _this.minArea_ = options.minArea !== undefined ? options.minArea : 64;
        if (options.onBoxEnd) _this.onBoxEnd = options.onBoxEnd;
        /**
         * @type {import("../pixel.js").Pixel}
         * @private
         */ _this.startPixel_ = null;
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */ _this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$1238ad6b5e7fff70);
        /**
         * @private
         * @type {EndCondition}
         */ _this.boxEndCondition_ = options.boxEndCondition ? options.boxEndCondition : _this.defaultBoxEndCondition;
        return _this;
    }
    /**
     * The default condition for determining whether the boxend event
     * should fire.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
     *     leading to the box end.
     * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
     * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
     * @return {boolean} Whether or not the boxend condition should be fired.
     */ DragBox.prototype.defaultBoxEndCondition = function(mapBrowserEvent, startPixel, endPixel) {
        var width = endPixel[0] - startPixel[0];
        var height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    };
    /**
     * Returns geometry of last drawn box.
     * @return {import("../geom/Polygon.js").default} Geometry.
     * @api
     */ DragBox.prototype.getGeometry = function() {
        return this.box_.getGeometry();
    };
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */ DragBox.prototype.handleDragEvent = function(mapBrowserEvent) {
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ DragBox.prototype.handleUpEvent = function(mapBrowserEvent) {
        this.box_.setMap(null);
        var completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) this.onBoxEnd(mapBrowserEvent);
        this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea(completeBox ? $e05f414bc3918235$var$DragBoxEventType.BOXEND : $e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        return false;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ DragBox.prototype.handleDownEvent = function(mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        } else return false;
    };
    /**
     * Function to execute just before `onboxend` is fired
     * @param {import("../MapBrowserEvent.js").default} event Event.
     */ DragBox.prototype.onBoxEnd = function(event) {};
    return DragBox;
}((0, $cf1eb502962d87a8$export$2e2bcd8739ae039));
var $e05f414bc3918235$export$2e2bcd8739ae039 = $e05f414bc3918235$var$DragBox;





var $afc7f51010a5b660$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition~shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ var $afc7f51010a5b660$var$DragZoom = /** @class */ function(_super) {
    $afc7f51010a5b660$var$__extends(DragZoom, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function DragZoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var condition = options.condition ? options.condition : (0, $edf87b50170125f7$export$5d31fe68a477cfbb);
        _this = _super.call(this, {
            condition: condition,
            className: options.className || 'ol-dragzoom',
            minArea: options.minArea
        }) || this;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
         * @private
         * @type {boolean}
         */ _this.out_ = options.out !== undefined ? options.out : false;
        return _this;
    }
    /**
     * Function to execute just before `onboxend` is fired
     * @param {import("../MapBrowserEvent.js").default} event Event.
     */ DragZoom.prototype.onBoxEnd = function(event) {
        var map = this.getMap();
        var view = /** @type {!import("../View.js").default} */ map.getView();
        var size = /** @type {!import("../size.js").Size} */ map.getSize();
        var extent = this.getGeometry().getExtent();
        if (this.out_) {
            var mapExtent = view.calculateExtentInternal(size);
            var boxPixelExtent = (0, $6da4c8ed3074c92b$export$29e3ad4dbd0cb863)([
                map.getPixelFromCoordinateInternal((0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(extent)),
                map.getPixelFromCoordinateInternal((0, $6da4c8ed3074c92b$export$b84fa077c8b05295)(extent))
            ]);
            var factor = view.getResolutionForExtentInternal(boxPixelExtent, size);
            (0, $6da4c8ed3074c92b$export$80cbab86674143b6)(mapExtent, 1 / factor);
            extent = mapExtent;
        }
        var resolution = view.getConstrainedResolution(view.getResolutionForExtentInternal(extent, size));
        var center = view.getConstrainedCenter((0, $6da4c8ed3074c92b$export$c91255cadecfe081)(extent), resolution);
        view.animateInternal({
            resolution: resolution,
            center: center,
            duration: this.duration_,
            easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
        });
    };
    return DragZoom;
}((0, $e05f414bc3918235$export$2e2bcd8739ae039));
var $afc7f51010a5b660$export$2e2bcd8739ae039 = $afc7f51010a5b660$var$DragZoom;




/**
 * @module ol/events/KeyCode
 */ /**
 * @enum {number}
 * @const
 */ var $82662515908d12f9$export$2e2bcd8739ae039 = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
};




var $178bb1517d626802$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition~noModifierKeys} and
 * {@link module:ol/events/condition~targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ var $178bb1517d626802$var$KeyboardPan = /** @class */ function(_super) {
    $178bb1517d626802$var$__extends(KeyboardPan, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function KeyboardPan(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options || {};
        /**
         * @private
         * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
         * @return {boolean} Combined condition result.
         */ _this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $edf87b50170125f7$export$fdc892d0d8fe3bfb)(mapBrowserEvent) && (0, $edf87b50170125f7$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */ _this.condition_ = options.condition !== undefined ? options.condition : _this.defaultCondition_;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
         * @private
         * @type {number}
         */ _this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
        return _this;
    }
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} if it was a
     * `KeyEvent`, and decides the direction to pan to (if an arrow key was
     * pressed).
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @this {KeyboardPan}
     */ KeyboardPan.prototype.handleEvent = function(mapBrowserEvent) {
        var stopEvent = false;
        if (mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN) {
            var keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            var keyCode = keyEvent.keyCode;
            if (this.condition_(mapBrowserEvent) && (keyCode == (0, $82662515908d12f9$export$2e2bcd8739ae039).DOWN || keyCode == (0, $82662515908d12f9$export$2e2bcd8739ae039).LEFT || keyCode == (0, $82662515908d12f9$export$2e2bcd8739ae039).RIGHT || keyCode == (0, $82662515908d12f9$export$2e2bcd8739ae039).UP)) {
                var map = mapBrowserEvent.map;
                var view = map.getView();
                var mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                var deltaX = 0, deltaY = 0;
                if (keyCode == (0, $82662515908d12f9$export$2e2bcd8739ae039).DOWN) deltaY = -mapUnitsDelta;
                else if (keyCode == (0, $82662515908d12f9$export$2e2bcd8739ae039).LEFT) deltaX = -mapUnitsDelta;
                else if (keyCode == (0, $82662515908d12f9$export$2e2bcd8739ae039).RIGHT) deltaX = mapUnitsDelta;
                else deltaY = mapUnitsDelta;
                var delta = [
                    deltaX,
                    deltaY
                ];
                (0, $1bd0a226f9a16141$export$bb628a54ab399bc9)(delta, view.getRotation());
                (0, $39210df8527e63e5$export$4c486572e961a974)(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    };
    return KeyboardPan;
}((0, $39210df8527e63e5$export$2e2bcd8739ae039));
var $178bb1517d626802$export$2e2bcd8739ae039 = $178bb1517d626802$var$KeyboardPan;





var $2237fabfa170eefc$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition~targetNotEditable}.
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ var $2237fabfa170eefc$var$KeyboardZoom = /** @class */ function(_super) {
    $2237fabfa170eefc$var$__extends(KeyboardZoom, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function KeyboardZoom(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */ _this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$e5570ca80cd8fd54);
        /**
         * @private
         * @type {number}
         */ _this.delta_ = options.delta ? options.delta : 1;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 100;
        return _this;
    }
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} if it was a
     * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
     * key pressed was '+' or '-').
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @this {KeyboardZoom}
     */ KeyboardZoom.prototype.handleEvent = function(mapBrowserEvent) {
        var stopEvent = false;
        if (mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN || mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYPRESS) {
            var keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            var charCode = keyEvent.charCode;
            if (this.condition_(mapBrowserEvent) && (charCode == '+'.charCodeAt(0) || charCode == '-'.charCodeAt(0))) {
                var map = mapBrowserEvent.map;
                var delta = charCode == '+'.charCodeAt(0) ? this.delta_ : -this.delta_;
                var view = map.getView();
                (0, $39210df8527e63e5$export$ace321ff2a8016ef)(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    };
    return KeyboardZoom;
}((0, $39210df8527e63e5$export$2e2bcd8739ae039));
var $2237fabfa170eefc$export$2e2bcd8739ae039 = $2237fabfa170eefc$var$KeyboardZoom;


/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ var $9a54ea8d5f7a49ee$var$Kinetic = /** @class */ function() {
    /**
     * @param {number} decay Rate of decay (must be negative).
     * @param {number} minVelocity Minimum velocity (pixels/millisecond).
     * @param {number} delay Delay to consider to calculate the kinetic
     *     initial values (milliseconds).
     */ function Kinetic(decay, minVelocity, delay) {
        /**
         * @private
         * @type {number}
         */ this.decay_ = decay;
        /**
         * @private
         * @type {number}
         */ this.minVelocity_ = minVelocity;
        /**
         * @private
         * @type {number}
         */ this.delay_ = delay;
        /**
         * @private
         * @type {Array<number>}
         */ this.points_ = [];
        /**
         * @private
         * @type {number}
         */ this.angle_ = 0;
        /**
         * @private
         * @type {number}
         */ this.initialVelocity_ = 0;
    }
    /**
     * FIXME empty description for jsdoc
     */ Kinetic.prototype.begin = function() {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     */ Kinetic.prototype.update = function(x, y) {
        this.points_.push(x, y, Date.now());
    };
    /**
     * @return {boolean} Whether we should do kinetic animation.
     */ Kinetic.prototype.end = function() {
        if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
        // in the array)
        return false;
        var delay = Date.now() - this.delay_;
        var lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
        // panning before releasing the map
        return false;
        // get the first point which still falls into the delay time
        var firstIndex = lastIndex - 3;
        while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
        var duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) return false;
        var dx = this.points_[lastIndex] - this.points_[firstIndex];
        var dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    };
    /**
     * @return {number} Total distance travelled (pixels).
     */ Kinetic.prototype.getDistance = function() {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    };
    /**
     * @return {number} Angle of the kinetic panning animation (radians).
     */ Kinetic.prototype.getAngle = function() {
        return this.angle_;
    };
    return Kinetic;
}();
var $9a54ea8d5f7a49ee$export$2e2bcd8739ae039 = $9a54ea8d5f7a49ee$var$Kinetic;







var $aaa378764710d71e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aaa378764710d71e$export$9484bbecc3c49a2e = {
    TRACKPAD: 'trackpad',
    WHEEL: 'wheel'
};
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition~always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ var $aaa378764710d71e$var$MouseWheelZoom = /** @class */ function(_super) {
    $aaa378764710d71e$var$__extends(MouseWheelZoom, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function MouseWheelZoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, /** @type {import("./Interaction.js").InteractionOptions} */ options) || this;
        /**
         * @private
         * @type {number}
         */ _this.totalDelta_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.lastDelta_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
         * @private
         * @type {number}
         */ _this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
         * @private
         * @type {boolean}
         */ _this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
         * @private
         * @type {boolean}
         */ _this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        var condition = options.condition ? options.condition : (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */ _this.condition_ = options.onFocusOnly ? (0, $edf87b50170125f7$export$84bf76cd7afc7469)((0, $edf87b50170125f7$export$ae2cdf064e3b0c55), condition) : condition;
        /**
         * @private
         * @type {?import("../coordinate.js").Coordinate}
         */ _this.lastAnchor_ = null;
        /**
         * @private
         * @type {number|undefined}
         */ _this.startTime_ = undefined;
        /**
         * @private
         * @type {?}
         */ _this.timeoutId_;
        /**
         * @private
         * @type {Mode|undefined}
         */ _this.mode_ = undefined;
        /**
         * Trackpad events separated by this delay will be considered separate
         * interactions.
         * @type {number}
         */ _this.trackpadEventGap_ = 400;
        /**
         * @type {?}
         */ _this.trackpadTimeoutId_;
        /**
         * The number of delta values per zoom level
         * @private
         * @type {number}
         */ _this.deltaPerZoom_ = 300;
        return _this;
    }
    /**
     * @private
     */ MouseWheelZoom.prototype.endInteraction_ = function() {
        this.trackpadTimeoutId_ = undefined;
        var view = this.getMap().getView();
        view.endInteraction(undefined, this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0, this.lastAnchor_);
    };
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
     * zooms the map.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     */ MouseWheelZoom.prototype.handleEvent = function(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        var type = mapBrowserEvent.type;
        if (type !== (0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL) return true;
        var map = mapBrowserEvent.map;
        var wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        wheelEvent.preventDefault();
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.coordinate;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        var delta;
        if (mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL) {
            delta = wheelEvent.deltaY;
            if ((0, $67c66761d21428d0$export$8442bdfd18b7b8a6) && wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) delta /= (0, $67c66761d21428d0$export$6b83a0446fc26f94);
            if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) delta *= 40;
        }
        if (delta === 0) return false;
        else this.lastDelta_ = delta;
        var now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? $aaa378764710d71e$export$9484bbecc3c49a2e.TRACKPAD : $aaa378764710d71e$export$9484bbecc3c49a2e.WHEEL;
        var view = map.getView();
        if (this.mode_ === $aaa378764710d71e$export$9484bbecc3c49a2e.TRACKPAD && !(view.getConstrainResolution() || this.constrainResolution_)) {
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else {
                if (view.getAnimating()) view.cancelAnimations();
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        var timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    };
    /**
     * @private
     * @param {import("../PluggableMap.js").default} map Map.
     */ MouseWheelZoom.prototype.handleWheelZoom_ = function(map) {
        var view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        var delta = -(0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
        delta = delta ? delta > 0 ? 1 : -1 : 0;
        (0, $39210df8527e63e5$export$ace321ff2a8016ef)(view, delta, this.lastAnchor_, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    };
    /**
     * Enable or disable using the mouse's location as an anchor when zooming
     * @param {boolean} useAnchor true to zoom to the mouse's location, false
     * to zoom to the center of the map
     * @api
     */ MouseWheelZoom.prototype.setMouseAnchor = function(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    };
    return MouseWheelZoom;
}((0, $39210df8527e63e5$export$2e2bcd8739ae039));
var $aaa378764710d71e$export$2e2bcd8739ae039 = $aaa378764710d71e$var$MouseWheelZoom;





var $9727451f2459496c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ var $9727451f2459496c$var$PinchRotate = /** @class */ function(_super) {
    $9727451f2459496c$var$__extends(PinchRotate, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function PinchRotate(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
        _this = _super.call(this, pointerOptions) || this;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */ _this.anchor_ = null;
        /**
         * @private
         * @type {number|undefined}
         */ _this.lastAngle_ = undefined;
        /**
         * @private
         * @type {boolean}
         */ _this.rotating_ = false;
        /**
         * @private
         * @type {number}
         */ _this.rotationDelta_ = 0.0;
        /**
         * @private
         * @type {number}
         */ _this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */ PinchRotate.prototype.handleDragEvent = function(mapBrowserEvent) {
        var rotationDelta = 0.0;
        var touch0 = this.targetPointers[0];
        var touch1 = this.targetPointers[1];
        // angle between touches
        var angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            var delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (view.getConstraints().rotation === (0, $d65f0a322291d127$export$e20fbacbb41798b)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        var viewportPosition = map.getViewport().getBoundingClientRect();
        var centroid = (0, $cf1eb502962d87a8$export$e2a20c553f6c85ce)(this.targetPointers);
        centroid[0] -= viewportPosition.left;
        centroid[1] -= viewportPosition.top;
        this.anchor_ = map.getCoordinateFromPixelInternal(centroid);
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ PinchRotate.prototype.handleUpEvent = function(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        } else return true;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ PinchRotate.prototype.handleDownEvent = function(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            var map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        } else return false;
    };
    return PinchRotate;
}((0, $cf1eb502962d87a8$export$2e2bcd8739ae039));
var $9727451f2459496c$export$2e2bcd8739ae039 = $9727451f2459496c$var$PinchRotate;




var $79c946b60b88d4a6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ var $79c946b60b88d4a6$var$PinchZoom = /** @class */ function(_super) {
    $79c946b60b88d4a6$var$__extends(PinchZoom, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function PinchZoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
        _this = _super.call(this, pointerOptions) || this;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */ _this.anchor_ = null;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
         * @private
         * @type {number|undefined}
         */ _this.lastDistance_ = undefined;
        /**
         * @private
         * @type {number}
         */ _this.lastScaleDelta_ = 1;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */ PinchZoom.prototype.handleDragEvent = function(mapBrowserEvent) {
        var scaleDelta = 1.0;
        var touch0 = this.targetPointers[0];
        var touch1 = this.targetPointers[1];
        var dx = touch0.clientX - touch1.clientX;
        var dy = touch0.clientY - touch1.clientY;
        // distance between touches
        var distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        var viewportPosition = map.getViewport().getBoundingClientRect();
        var centroid = (0, $cf1eb502962d87a8$export$e2a20c553f6c85ce)(this.targetPointers);
        centroid[0] -= viewportPosition.left;
        centroid[1] -= viewportPosition.top;
        this.anchor_ = map.getCoordinateFromPixelInternal(centroid);
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ PinchZoom.prototype.handleUpEvent = function(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            var direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        } else return true;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ PinchZoom.prototype.handleDownEvent = function(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            var map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        } else return false;
    };
    return PinchZoom;
}((0, $cf1eb502962d87a8$export$2e2bcd8739ae039));
var $79c946b60b88d4a6$export$2e2bcd8739ae039 = $79c946b60b88d4a6$var$PinchZoom;













function $fdc8b40501c0cf45$export$ebe90cb607ad99e(opt_options) {
    var options = opt_options ? opt_options : {};
    var interactions = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    var kinetic = new (0, $9a54ea8d5f7a49ee$export$2e2bcd8739ae039)(-0.005, 0.05, 100);
    var altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $197c7092261b2aa0$export$2e2bcd8739ae039)());
    var doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $b50403621294a654$export$2e2bcd8739ae039)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    var dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $c11585da26a016db$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    var pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $9727451f2459496c$export$2e2bcd8739ae039)());
    var pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $79c946b60b88d4a6$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    var keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $178bb1517d626802$export$2e2bcd8739ae039)());
        interactions.push(new (0, $2237fabfa170eefc$export$2e2bcd8739ae039)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    var mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $aaa378764710d71e$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    var shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $afc7f51010a5b660$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    return interactions;
}


var $41aa29ae0c4b607a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map';
 *     import View from 'ol/View';
 *     import TileLayer from 'ol/layer/Tile';
 *     import OSM from 'ol/source/OSM';
 *
 *     var map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM()
 *         })
 *       ],
 *       target: 'map'
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~Group}
 * is a subclass of {@link module:ol/layer/Base}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @api
 */ var $41aa29ae0c4b607a$var$Map = /** @class */ function(_super) {
    $41aa29ae0c4b607a$var$__extends(Map, _super);
    /**
     * @param {import("./PluggableMap.js").MapOptions} options Map options.
     */ function Map(options) {
        var _this = this;
        options = (0, $beaefe87199bb537$export$e6e34fd1f2686227)({}, options);
        if (!options.controls) options.controls = (0, $b4471d80e1d69273$export$ebe90cb607ad99e)();
        if (!options.interactions) options.interactions = (0, $fdc8b40501c0cf45$export$ebe90cb607ad99e)({
            onFocusOnly: true
        });
        _this = _super.call(this, options) || this;
        return _this;
    }
    Map.prototype.createRenderer = function() {
        return new (0, $fa78c97693b12120$export$2e2bcd8739ae039)(this);
    };
    return Map;
}((0, $cceb59c4bc2a46b0$export$2e2bcd8739ae039));
var $41aa29ae0c4b607a$export$2e2bcd8739ae039 = $41aa29ae0c4b607a$var$Map;



/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $e4c61536de922b84$export$2e2bcd8739ae039 = {
    PRELOAD: 'preload',
    USE_INTERIM_TILES_ON_ERROR: 'useInterimTilesOnError'
};



var $93be2de6a052f587$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {import("../source/Tile.js").default} [source] Source for this layer.
 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link module:ol/Map#addLayer}.
 * @property {boolean} [useInterimTilesOnError=true] Use interim tiles on error.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @extends {Layer<import("../source/Tile.js").default>}
 * @api
 */ var $93be2de6a052f587$var$BaseTileLayer = /** @class */ function(_super) {
    $93be2de6a052f587$var$__extends(BaseTileLayer, _super);
    /**
     * @param {Options=} opt_options Tile layer options.
     */ function BaseTileLayer(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var baseOptions = (0, $beaefe87199bb537$export$e6e34fd1f2686227)({}, options);
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        _this = _super.call(this, baseOptions) || this;
        _this.setPreload(options.preload !== undefined ? options.preload : 0);
        _this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
        return _this;
    }
    /**
     * Return the level as number to which we will preload tiles up to.
     * @return {number} The level to preload tiles up to.
     * @observable
     * @api
     */ BaseTileLayer.prototype.getPreload = function() {
        return /** @type {number} */ this.get((0, $e4c61536de922b84$export$2e2bcd8739ae039).PRELOAD);
    };
    /**
     * Set the level as number to which we will preload tiles up to.
     * @param {number} preload The level to preload tiles up to.
     * @observable
     * @api
     */ BaseTileLayer.prototype.setPreload = function(preload) {
        this.set((0, $e4c61536de922b84$export$2e2bcd8739ae039).PRELOAD, preload);
    };
    /**
     * Whether we use interim tiles on error.
     * @return {boolean} Use interim tiles on error.
     * @observable
     * @api
     */ BaseTileLayer.prototype.getUseInterimTilesOnError = function() {
        return /** @type {boolean} */ this.get((0, $e4c61536de922b84$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
    };
    /**
     * Set whether we use interim tiles on error.
     * @param {boolean} useInterimTilesOnError Use interim tiles on error.
     * @observable
     * @api
     */ BaseTileLayer.prototype.setUseInterimTilesOnError = function(useInterimTilesOnError) {
        this.set((0, $e4c61536de922b84$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    };
    return BaseTileLayer;
}((0, $534f30fce11effcd$export$2e2bcd8739ae039));
var $93be2de6a052f587$export$2e2bcd8739ae039 = $93be2de6a052f587$var$BaseTileLayer;



/**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $7eb75c96a6b6f2c6$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};





var $cb18cdefd702a327$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ var $cb18cdefd702a327$var$LayerRenderer = /** @class */ function(_super) {
    $cb18cdefd702a327$var$__extends(LayerRenderer, _super);
    /**
     * @param {LayerType} layer Layer.
     */ function LayerRenderer(layer) {
        var _this = _super.call(this) || this;
        /** @private */ _this.boundHandleImageChange_ = _this.handleImageChange_.bind(_this);
        /**
         * @protected
         * @type {LayerType}
         */ _this.layer_ = layer;
        /**
         * @type {import("../render/canvas/ExecutorGroup").default}
         */ _this.declutterExecutorGroup = null;
        return _this;
    }
    /**
     * Asynchronous layer level hit detection.
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../Feature").default>>} Promise that resolves with
     * an array of features.
     */ LayerRenderer.prototype.getFeatures = function(pixel) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Determine whether render should be called.
     * @abstract
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */ LayerRenderer.prototype.prepareFrame = function(frameState) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Render the layer.
     * @abstract
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     */ LayerRenderer.prototype.renderFrame = function(frameState, target) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
     * @param {number} zoom Zoom level.
     * @param {import("../Tile.js").default} tile Tile.
     * @return {boolean|void} If `false`, the tile will not be considered loaded.
     */ LayerRenderer.prototype.loadedTileCallback = function(tiles, zoom, tile) {
        if (!tiles[zoom]) tiles[zoom] = {};
        tiles[zoom][tile.tileCoord.toString()] = tile;
        return undefined;
    };
    /**
     * Create a function that adds loaded tiles to the tile lookup.
     * @param {import("../source/Tile.js").default} source Tile source.
     * @param {import("../proj/Projection.js").default} projection Projection of the tiles.
     * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
     * @return {function(number, import("../TileRange.js").default):boolean} A function that can be
     *     called with a zoom level and a tile range to add loaded tiles to the lookup.
     * @protected
     */ LayerRenderer.prototype.createLoadedTileFinder = function(source, projection, tiles) {
        return(/**
         * @param {number} zoom Zoom level.
         * @param {import("../TileRange.js").default} tileRange Tile range.
         * @return {boolean} The tile range is fully loaded.
         * @this {LayerRenderer}
         */ (function(zoom, tileRange) {
            var callback = this.loadedTileCallback.bind(this, tiles, zoom);
            return source.forEachLoadedTile(projection, zoom, tileRange, callback);
        }).bind(this));
    };
    /**
     * @abstract
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
     * @return {T|undefined} Callback result.
     * @template T
     */ LayerRenderer.prototype.forEachFeatureAtCoordinate = function(coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    };
    /**
     * @abstract
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @return {Uint8ClampedArray|Uint8Array} The result.  If there is no data at the pixel
     *    location, null will be returned.  If there is data, but pixel values cannot be
     *    returned, and empty array will be returned.
     */ LayerRenderer.prototype.getDataAtPixel = function(pixel, frameState, hitTolerance) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @return {LayerType} Layer.
     */ LayerRenderer.prototype.getLayer = function() {
        return this.layer_;
    };
    /**
     * Perform action necessary to get the layer rendered after new fonts have loaded
     * @abstract
     */ LayerRenderer.prototype.handleFontsChanged = function() {};
    /**
     * Handle changes in image state.
     * @param {import("../events/Event.js").default} event Image change event.
     * @private
     */ LayerRenderer.prototype.handleImageChange_ = function(event) {
        var image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) this.renderIfReadyAndVisible();
    };
    /**
     * Load the image if not already loaded, and register the image change
     * listener if needed.
     * @param {import("../ImageBase.js").default} image Image.
     * @return {boolean} `true` if the image is already loaded, `false` otherwise.
     * @protected
     */ LayerRenderer.prototype.loadImage = function(image) {
        var imageState = image.getState();
        if (imageState != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED && imageState != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) image.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleImageChange_);
        if (imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
    };
    /**
     * @protected
     */ LayerRenderer.prototype.renderIfReadyAndVisible = function() {
        var layer = this.getLayer();
        if (layer.getVisible() && layer.getSourceState() == (0, $98f5bfe3c4864f05$export$2e2bcd8739ae039).READY) layer.changed();
    };
    return LayerRenderer;
}((0, $1f093ab5083c8a1f$export$2e2bcd8739ae039));
var $cb18cdefd702a327$export$2e2bcd8739ae039 = $cb18cdefd702a327$var$LayerRenderer;








var $42152f52b26b6ca7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 */ var $42152f52b26b6ca7$var$CanvasLayerRenderer = /** @class */ function(_super) {
    $42152f52b26b6ca7$var$__extends(CanvasLayerRenderer, _super);
    /**
     * @param {LayerType} layer Layer.
     */ function CanvasLayerRenderer(layer) {
        var _this = _super.call(this, layer) || this;
        /**
         * @protected
         * @type {HTMLElement}
         */ _this.container = null;
        /**
         * @protected
         * @type {number}
         */ _this.renderedResolution;
        /**
         * A temporary transform.  The values in this transform should only be used in a
         * function that sets the values.
         * @protected
         * @type {import("../../transform.js").Transform}
         */ _this.tempTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
         * The transform for rendered pixels to viewport CSS pixels.  This transform must
         * be set when rendering a frame and may be used by other functions after rendering.
         * @protected
         * @type {import("../../transform.js").Transform}
         */ _this.pixelTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
         * The transform for viewport CSS pixels to rendered pixels.  This transform must
         * be set when rendering a frame and may be used by other functions after rendering.
         * @protected
         * @type {import("../../transform.js").Transform}
         */ _this.inversePixelTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
         * @type {CanvasRenderingContext2D}
         */ _this.context = null;
        /**
         * @type {boolean}
         */ _this.containerReused = false;
        return _this;
    }
    /**
     * Get a rendering container from an existing target, if compatible.
     * @param {HTMLElement} target Potential render target.
     * @param {string} transform CSS Transform.
     * @param {number} opacity Opacity.
     */ CanvasLayerRenderer.prototype.useContainer = function(target, transform, opacity) {
        var layerClassName = this.getLayer().getClassName();
        var container, context;
        if (target && target.style.opacity === '' && target.className === layerClassName) {
            var canvas = target.firstElementChild;
            if (canvas instanceof HTMLCanvasElement) context = canvas.getContext('2d');
        }
        if (context && (context.canvas.width === 0 || context.canvas.style.transform === transform)) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        } else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        }
        if (!this.container) {
            container = document.createElement('div');
            container.className = layerClassName;
            var style = container.style;
            style.position = 'absolute';
            style.width = '100%';
            style.height = '100%';
            context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)();
            var canvas = context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = 'absolute';
            style.left = '0';
            style.transformOrigin = 'top left';
            this.container = container;
            this.context = context;
        }
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("../../extent.js").Extent} extent Clip extent.
     * @protected
     */ CanvasLayerRenderer.prototype.clip = function(context, frameState, extent) {
        var pixelRatio = frameState.pixelRatio;
        var halfWidth = frameState.size[0] * pixelRatio / 2;
        var halfHeight = frameState.size[1] * pixelRatio / 2;
        var rotation = frameState.viewState.rotation;
        var topLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(extent);
        var topRight = (0, $6da4c8ed3074c92b$export$b84fa077c8b05295)(extent);
        var bottomRight = (0, $6da4c8ed3074c92b$export$e77c1cf70445e168)(extent);
        var bottomLeft = (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(extent);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topLeft);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomLeft);
        context.save();
        (0, $d4aabc5c971073f1$export$8ac4d72be78047e6)(context, -rotation, halfWidth, halfHeight);
        context.beginPath();
        context.moveTo(topLeft[0] * pixelRatio, topLeft[1] * pixelRatio);
        context.lineTo(topRight[0] * pixelRatio, topRight[1] * pixelRatio);
        context.lineTo(bottomRight[0] * pixelRatio, bottomRight[1] * pixelRatio);
        context.lineTo(bottomLeft[0] * pixelRatio, bottomLeft[1] * pixelRatio);
        context.clip();
        (0, $d4aabc5c971073f1$export$8ac4d72be78047e6)(context, rotation, halfWidth, halfHeight);
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("../../extent.js").Extent} extent Clip extent.
     * @protected
     */ CanvasLayerRenderer.prototype.clipUnrotated = function(context, frameState, extent) {
        var topLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(extent);
        var topRight = (0, $6da4c8ed3074c92b$export$b84fa077c8b05295)(extent);
        var bottomRight = (0, $6da4c8ed3074c92b$export$e77c1cf70445e168)(extent);
        var bottomLeft = (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(extent);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topLeft);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomLeft);
        var inverted = this.inversePixelTransform;
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, topLeft);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, topRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, bottomRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    };
    /**
     * @param {import("../../render/EventType.js").default} type Event type.
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @private
     */ CanvasLayerRenderer.prototype.dispatchRenderEvent_ = function(type, context, frameState) {
        var layer = this.getLayer();
        if (layer.hasListener(type)) {
            var event_1 = new (0, $b80dddceb0c42ad4$export$2e2bcd8739ae039)(type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event_1);
        }
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @protected
     */ CanvasLayerRenderer.prototype.preRender = function(context, frameState) {
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRERENDER, context, frameState);
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @protected
     */ CanvasLayerRenderer.prototype.postRender = function(context, frameState) {
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTRENDER, context, frameState);
    };
    /**
     * Creates a transform for rendering to an element that will be rotated after rendering.
     * @param {import("../../coordinate.js").Coordinate} center Center.
     * @param {number} resolution Resolution.
     * @param {number} rotation Rotation.
     * @param {number} pixelRatio Pixel ratio.
     * @param {number} width Width of the rendered element (in pixels).
     * @param {number} height Height of the rendered element (in pixels).
     * @param {number} offsetX Offset on the x-axis in view coordinates.
     * @protected
     * @return {!import("../../transform.js").Transform} Transform.
     */ CanvasLayerRenderer.prototype.getRenderTransform = function(center, resolution, rotation, pixelRatio, width, height, offsetX) {
        var dx1 = width / 2;
        var dy1 = height / 2;
        var sx = pixelRatio / resolution;
        var sy = -sx;
        var dx2 = -center[0] + offsetX;
        var dy2 = -center[1];
        return (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    };
    /**
     * @param {import("../../pixel.js").Pixel} pixel Pixel.
     * @param {import("../../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @return {Uint8ClampedArray|Uint8Array} The result.  If there is no data at the pixel
     *    location, null will be returned.  If there is data, but pixel values cannot be
     *    returned, and empty array will be returned.
     */ CanvasLayerRenderer.prototype.getDataAtPixel = function(pixel, frameState, hitTolerance) {
        var renderPixel = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(this.inversePixelTransform, pixel.slice());
        var context = this.context;
        var layer = this.getLayer();
        var layerExtent = layer.getExtent();
        if (layerExtent) {
            var renderCoordinate = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
            /** get only data inside of the layer extent */ if (!(0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(layerExtent, renderCoordinate)) return null;
        }
        var data;
        try {
            var x = Math.round(renderPixel[0]);
            var y = Math.round(renderPixel[1]);
            var newCanvas = document.createElement('canvas');
            var newContext = newCanvas.getContext('2d');
            newCanvas.width = 1;
            newCanvas.height = 1;
            newContext.clearRect(0, 0, 1, 1);
            newContext.drawImage(context.canvas, x, y, 1, 1, 0, 0, 1, 1);
            data = newContext.getImageData(0, 0, 1, 1).data;
        } catch (err) {
            if (err.name === 'SecurityError') // tainted canvas, we assume there is data at the given pixel (although there might not be)
            return new Uint8Array();
            return data;
        }
        if (data[3] === 0) return null;
        return data;
    };
    return CanvasLayerRenderer;
}((0, $cb18cdefd702a327$export$2e2bcd8739ae039));
var $42152f52b26b6ca7$export$2e2bcd8739ae039 = $42152f52b26b6ca7$var$CanvasLayerRenderer;


/**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ var $550e524b0d1b61d4$var$TileRange = /** @class */ function() {
    /**
     * @param {number} minX Minimum X.
     * @param {number} maxX Maximum X.
     * @param {number} minY Minimum Y.
     * @param {number} maxY Maximum Y.
     */ function TileRange(minX, maxX, minY, maxY) {
        /**
         * @type {number}
         */ this.minX = minX;
        /**
         * @type {number}
         */ this.maxX = maxX;
        /**
         * @type {number}
         */ this.minY = minY;
        /**
         * @type {number}
         */ this.maxY = maxY;
    }
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @return {boolean} Contains tile coordinate.
     */ TileRange.prototype.contains = function(tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    };
    /**
     * @param {TileRange} tileRange Tile range.
     * @return {boolean} Contains.
     */ TileRange.prototype.containsTileRange = function(tileRange) {
        return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
    };
    /**
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @return {boolean} Contains coordinate.
     */ TileRange.prototype.containsXY = function(x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    };
    /**
     * @param {TileRange} tileRange Tile range.
     * @return {boolean} Equals.
     */ TileRange.prototype.equals = function(tileRange) {
        return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
    };
    /**
     * @param {TileRange} tileRange Tile range.
     */ TileRange.prototype.extend = function(tileRange) {
        if (tileRange.minX < this.minX) this.minX = tileRange.minX;
        if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
        if (tileRange.minY < this.minY) this.minY = tileRange.minY;
        if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
    };
    /**
     * @return {number} Height.
     */ TileRange.prototype.getHeight = function() {
        return this.maxY - this.minY + 1;
    };
    /**
     * @return {import("./size.js").Size} Size.
     */ TileRange.prototype.getSize = function() {
        return [
            this.getWidth(),
            this.getHeight()
        ];
    };
    /**
     * @return {number} Width.
     */ TileRange.prototype.getWidth = function() {
        return this.maxX - this.minX + 1;
    };
    /**
     * @param {TileRange} tileRange Tile range.
     * @return {boolean} Intersects.
     */ TileRange.prototype.intersects = function(tileRange) {
        return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
    };
    return TileRange;
}();
function $550e524b0d1b61d4$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    } else return new $550e524b0d1b61d4$var$TileRange(minX, maxX, minY, maxY);
}
var $550e524b0d1b61d4$export$2e2bcd8739ae039 = $550e524b0d1b61d4$var$TileRange;










var $02fffef185f4339b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 */ var $02fffef185f4339b$var$CanvasTileLayerRenderer = /** @class */ function(_super) {
    $02fffef185f4339b$var$__extends(CanvasTileLayerRenderer, _super);
    /**
     * @param {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default} tileLayer Tile layer.
     */ function CanvasTileLayerRenderer(tileLayer) {
        var _this = _super.call(this, tileLayer) || this;
        /**
         * Rendered extent has changed since the previous `renderFrame()` call
         * @type {boolean}
         */ _this.extentChanged = true;
        /**
         * @private
         * @type {?import("../../extent.js").Extent}
         */ _this.renderedExtent_ = null;
        /**
         * @protected
         * @type {number}
         */ _this.renderedPixelRatio;
        /**
         * @protected
         * @type {import("../../proj/Projection.js").default}
         */ _this.renderedProjection = null;
        /**
         * @protected
         * @type {number}
         */ _this.renderedRevision;
        /**
         * @protected
         * @type {!Array<import("../../Tile.js").default>}
         */ _this.renderedTiles = [];
        /**
         * @private
         * @type {boolean}
         */ _this.newTiles_ = false;
        /**
         * @protected
         * @type {import("../../extent.js").Extent}
         */ _this.tmpExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
         * @private
         * @type {import("../../TileRange.js").default}
         */ _this.tmpTileRange_ = new (0, $550e524b0d1b61d4$export$2e2bcd8739ae039)(0, 0, 0, 0);
        return _this;
    }
    /**
     * @protected
     * @param {import("../../Tile.js").default} tile Tile.
     * @return {boolean} Tile is drawable.
     */ CanvasTileLayerRenderer.prototype.isDrawableTile = function(tile) {
        var tileLayer = this.getLayer();
        var tileState = tile.getState();
        var useInterimTilesOnError = tileLayer.getUseInterimTilesOnError();
        return tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED || tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY || tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR && !useInterimTilesOnError;
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {!import("../../Tile.js").default} Tile.
     */ CanvasTileLayerRenderer.prototype.getTile = function(z, x, y, frameState) {
        var pixelRatio = frameState.pixelRatio;
        var projection = frameState.viewState.projection;
        var tileLayer = this.getLayer();
        var tileSource = tileLayer.getSource();
        var tile = tileSource.getTile(z, x, y, pixelRatio, projection);
        if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) {
            if (!tileLayer.getUseInterimTilesOnError()) // When useInterimTilesOnError is false, we consider the error tile as loaded.
            tile.setState((0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED);
            else if (tileLayer.getPreload() > 0) // Preloaded tiles for lower resolutions might have finished loading.
            this.newTiles_ = true;
        }
        if (!this.isDrawableTile(tile)) tile = tile.getInterimTile();
        return tile;
    };
    /**
     * @param {Object<number, Object<string, import("../../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
     * @param {number} zoom Zoom level.
     * @param {import("../../Tile.js").default} tile Tile.
     * @return {boolean|void} If `false`, the tile will not be considered loaded.
     */ CanvasTileLayerRenderer.prototype.loadedTileCallback = function(tiles, zoom, tile) {
        if (this.isDrawableTile(tile)) return _super.prototype.loadedTileCallback.call(this, tiles, zoom, tile);
        return false;
    };
    /**
     * Determine whether render should be called.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */ CanvasTileLayerRenderer.prototype.prepareFrame = function(frameState) {
        return !!this.getLayer().getSource();
    };
    /**
     * Render the layer.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     */ CanvasTileLayerRenderer.prototype.renderFrame = function(frameState, target) {
        var layerState = frameState.layerStatesArray[frameState.layerIndex];
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        var viewResolution = viewState.resolution;
        var viewCenter = viewState.center;
        var rotation = viewState.rotation;
        var pixelRatio = frameState.pixelRatio;
        var tileLayer = this.getLayer();
        var tileSource = tileLayer.getSource();
        var sourceRevision = tileSource.getRevision();
        var tileGrid = tileSource.getTileGridForProjection(projection);
        var z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        var tileResolution = tileGrid.getResolution(z);
        var extent = frameState.extent;
        var layerExtent = layerState.extent && (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, projection);
        if (layerExtent) extent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(extent, (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, projection));
        var tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        // desired dimensions of the canvas in pixels
        var width = Math.round(frameState.size[0] * tilePixelRatio);
        var height = Math.round(frameState.size[1] * tilePixelRatio);
        if (rotation) {
            var size = Math.round(Math.sqrt(width * width + height * height));
            width = size;
            height = size;
        }
        var dx = tileResolution * width / 2 / tilePixelRatio;
        var dy = tileResolution * height / 2 / tilePixelRatio;
        var canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy
        ];
        var tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
        /**
         * @type {Object<number, Object<string, import("../../Tile.js").default>>}
         */ var tilesToDrawByZ = {};
        tilesToDrawByZ[z] = {};
        var findLoadedTiles = this.createLoadedTileFinder(tileSource, projection, tilesToDrawByZ);
        var tmpExtent = this.tmpExtent;
        var tmpTileRange = this.tmpTileRange_;
        this.newTiles_ = false;
        for(var x = tileRange.minX; x <= tileRange.maxX; ++x)for(var y = tileRange.minY; y <= tileRange.maxY; ++y){
            var tile = this.getTile(z, x, y, frameState);
            if (this.isDrawableTile(tile)) {
                var uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(this);
                if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                    tilesToDrawByZ[z][tile.tileCoord.toString()] = tile;
                    var inTransition = tile.inTransition(uid);
                    if (!this.newTiles_ && (inTransition || this.renderedTiles.indexOf(tile) === -1)) this.newTiles_ = true;
                }
                if (tile.getAlpha(uid, frameState.time) === 1) continue;
            }
            var childTileRange = tileGrid.getTileCoordChildTileRange(tile.tileCoord, tmpTileRange, tmpExtent);
            var covered = false;
            if (childTileRange) covered = findLoadedTiles(z + 1, childTileRange);
            if (!covered) tileGrid.forEachTileCoordParentTileRange(tile.tileCoord, findLoadedTiles, tmpTileRange, tmpExtent);
        }
        var canvasScale = tileResolution / viewResolution;
        // set forward and inverse pixel transforms
        (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / tilePixelRatio, 1 / tilePixelRatio, rotation, -width / 2, -height / 2);
        var canvasTransform = (0, $d4aabc5c971073f1$export$e989e34b92d28568)(this.pixelTransform);
        this.useContainer(target, canvasTransform, layerState.opacity);
        var context = this.context;
        var canvas = context.canvas;
        (0, $e22e7611e69f42a9$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
        // set scale transform for calculating tile positions on the canvas
        (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (canvas.width != width || canvas.height != height) {
            canvas.width = width;
            canvas.height = height;
        } else if (!this.containerReused) context.clearRect(0, 0, width, height);
        if (layerExtent) this.clipUnrotated(context, frameState, layerExtent);
        (0, $beaefe87199bb537$export$e6e34fd1f2686227)(context, tileSource.getContextOptions());
        this.preRender(context, frameState);
        this.renderedTiles.length = 0;
        /** @type {Array<number>} */ var zs = Object.keys(tilesToDrawByZ).map(Number);
        zs.sort((0, $b998d41b678ed5d1$export$4e734a3b32fb971b));
        var clips, clipZs, currentClip;
        if (layerState.opacity === 1 && (!this.containerReused || tileSource.getOpaque(frameState.viewState.projection))) zs = zs.reverse();
        else {
            clips = [];
            clipZs = [];
        }
        for(var i = zs.length - 1; i >= 0; --i){
            var currentZ = zs[i];
            var currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            var currentResolution = tileGrid.getResolution(currentZ);
            var currentScale = currentResolution / tileResolution;
            var dx_1 = currentTilePixelSize[0] * currentScale * canvasScale;
            var dy_1 = currentTilePixelSize[1] * currentScale * canvasScale;
            var originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(canvasExtent), currentZ);
            var originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            var origin_1 = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(this.tempTransform, [
                tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
            ]);
            var tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            var tilesToDraw = tilesToDrawByZ[currentZ];
            for(var tileCoordKey in tilesToDraw){
                var tile = /** @type {import("../../ImageTile.js").default} */ tilesToDraw[tileCoordKey];
                var tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                var floatX = origin_1[0] - (originTileCoord[1] - tileCoord[1]) * dx_1;
                var nextX = Math.round(floatX + dx_1);
                var floatY = origin_1[1] - (originTileCoord[2] - tileCoord[2]) * dy_1;
                var nextY = Math.round(floatY + dy_1);
                var x = Math.round(floatX);
                var y = Math.round(floatY);
                var w = nextX - x;
                var h = nextY - y;
                var transition = z === currentZ;
                var inTransition = transition && tile.getAlpha((0, $6c5e11070e371322$export$5e82334337e0f204)(this), frameState.time) !== 1;
                if (!inTransition) {
                    if (clips) {
                        // Clip mask for regions in this tile that already filled by a higher z tile
                        context.save();
                        currentClip = [
                            x,
                            y,
                            x + w,
                            y,
                            x + w,
                            y + h,
                            x,
                            y + h
                        ];
                        for(var i_1 = 0, ii = clips.length; i_1 < ii; ++i_1)if (z !== currentZ && currentZ < clipZs[i_1]) {
                            var clip = clips[i_1];
                            context.beginPath();
                            // counter-clockwise (outer ring) for current tile
                            context.moveTo(currentClip[0], currentClip[1]);
                            context.lineTo(currentClip[2], currentClip[3]);
                            context.lineTo(currentClip[4], currentClip[5]);
                            context.lineTo(currentClip[6], currentClip[7]);
                            // clockwise (inner ring) for higher z tile
                            context.moveTo(clip[6], clip[7]);
                            context.lineTo(clip[4], clip[5]);
                            context.lineTo(clip[2], clip[3]);
                            context.lineTo(clip[0], clip[1]);
                            context.clip();
                        }
                        clips.push(currentClip);
                        clipZs.push(currentZ);
                    } else context.clearRect(x, y, w, h);
                }
                this.drawTileImage(tile, frameState, x, y, w, h, tileGutter, transition, layerState.opacity);
                if (clips && !inTransition) context.restore();
                this.renderedTiles.push(tile);
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        this.renderedRevision = sourceRevision;
        this.renderedResolution = tileResolution;
        this.extentChanged = !this.renderedExtent_ || !(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.renderedProjection = projection;
        this.manageTilePyramid(frameState, tileSource, tileGrid, pixelRatio, projection, extent, z, tileLayer.getPreload());
        this.scheduleExpireCache(frameState, tileSource);
        this.postRender(context, frameState);
        if (layerState.extent) context.restore();
        if (canvasTransform !== canvas.style.transform) canvas.style.transform = canvasTransform;
        return this.container;
    };
    /**
     * @param {import("../../ImageTile.js").default} tile Tile.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} x Left of the tile.
     * @param {number} y Top of the tile.
     * @param {number} w Width of the tile.
     * @param {number} h Height of the tile.
     * @param {number} gutter Tile gutter.
     * @param {boolean} transition Apply an alpha transition.
     * @param {number} opacity Opacity.
     */ CanvasTileLayerRenderer.prototype.drawTileImage = function(tile, frameState, x, y, w, h, gutter, transition, opacity) {
        var image = this.getTileImage(tile);
        if (!image) return;
        var uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(this);
        var tileAlpha = transition ? tile.getAlpha(uid, frameState.time) : 1;
        var alpha = opacity * tileAlpha;
        var alphaChanged = alpha !== this.context.globalAlpha;
        if (alphaChanged) {
            this.context.save();
            this.context.globalAlpha = alpha;
        }
        this.context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) this.context.restore();
        if (tileAlpha !== 1) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    };
    /**
     * @return {HTMLCanvasElement} Image
     */ CanvasTileLayerRenderer.prototype.getImage = function() {
        var context = this.context;
        return context ? context.canvas : null;
    };
    /**
     * Get the image from a tile.
     * @param {import("../../ImageTile.js").default} tile Tile.
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     * @protected
     */ CanvasTileLayerRenderer.prototype.getTileImage = function(tile) {
        return tile.getImage();
    };
    /**
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("../../source/Tile.js").default} tileSource Tile source.
     * @protected
     */ CanvasTileLayerRenderer.prototype.scheduleExpireCache = function(frameState, tileSource) {
        if (tileSource.canExpireCache()) {
            /**
             * @param {import("../../source/Tile.js").default} tileSource Tile source.
             * @param {import("../../PluggableMap.js").default} map Map.
             * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
             */ var postRenderFunction = (function(tileSource, map, frameState) {
                var tileSourceKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(tileSource);
                if (tileSourceKey in frameState.usedTiles) tileSource.expireCache(frameState.viewState.projection, frameState.usedTiles[tileSourceKey]);
            }).bind(null, tileSource);
            frameState.postRenderFunctions.push(/** @type {import("../../PluggableMap.js").PostRenderFunction} */ postRenderFunction);
        }
    };
    /**
     * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
     * @param {import("../../source/Tile.js").default} tileSource Tile source.
     * @param {import('../../Tile.js').default} tile Tile.
     * @protected
     */ CanvasTileLayerRenderer.prototype.updateUsedTiles = function(usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        var tileSourceKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
        usedTiles[tileSourceKey][tile.getKey()] = true;
    };
    /**
     * Manage tile pyramid.
     * This function performs a number of functions related to the tiles at the
     * current zoom and lower zoom levels:
     * - registers idle tiles in frameState.wantedTiles so that they are not
     *   discarded by the tile queue
     * - enqueues missing tiles
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("../../source/Tile.js").default} tileSource Tile source.
     * @param {import("../../tilegrid/TileGrid.js").default} tileGrid Tile grid.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../../proj/Projection.js").default} projection Projection.
     * @param {import("../../extent.js").Extent} extent Extent.
     * @param {number} currentZ Current Z.
     * @param {number} preload Load low resolution tiles up to 'preload' levels.
     * @param {function(import("../../Tile.js").default)=} opt_tileCallback Tile callback.
     * @protected
     */ CanvasTileLayerRenderer.prototype.manageTilePyramid = function(frameState, tileSource, tileGrid, pixelRatio, projection, extent, currentZ, preload, opt_tileCallback) {
        var tileSourceKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        var wantedTiles = frameState.wantedTiles[tileSourceKey];
        var tileQueue = frameState.tileQueue;
        var minZoom = tileGrid.getMinZoom();
        var tileCount = 0;
        var tile, tileRange, tileResolution, x, y, z;
        for(z = minZoom; z <= currentZ; ++z){
            tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, tileRange);
            tileResolution = tileGrid.getResolution(z);
            for(x = tileRange.minX; x <= tileRange.maxX; ++x){
                for(y = tileRange.minY; y <= tileRange.maxY; ++y)if (currentZ - z <= preload) {
                    ++tileCount;
                    tile = tileSource.getTile(z, x, y, pixelRatio, projection);
                    if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) {
                        wantedTiles[tile.getKey()] = true;
                        if (!tileQueue.isKeyQueued(tile.getKey())) tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tile.tileCoord),
                            tileResolution
                        ]);
                    }
                    if (opt_tileCallback !== undefined) opt_tileCallback(tile);
                } else tileSource.useTile(z, x, y, projection);
            }
        }
        tileSource.updateCacheSize(tileCount, projection);
    };
    return CanvasTileLayerRenderer;
}((0, $42152f52b26b6ca7$export$2e2bcd8739ae039));
/**
 * @function
 * @return {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default}
 */ $02fffef185f4339b$var$CanvasTileLayerRenderer.prototype.getLayer;
var $02fffef185f4339b$export$2e2bcd8739ae039 = $02fffef185f4339b$var$CanvasTileLayerRenderer;


var $32e67a4d3559554a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @api
 */ var $32e67a4d3559554a$var$TileLayer = /** @class */ function(_super) {
    $32e67a4d3559554a$var$__extends(TileLayer, _super);
    /**
     * @param {import("./BaseTile.js").Options=} opt_options Tile layer options.
     */ function TileLayer(opt_options) {
        return _super.call(this, opt_options) || this;
    }
    /**
     * Create a renderer for this layer.
     * @return {import("../renderer/Layer.js").default} A layer renderer.
     * @protected
     */ TileLayer.prototype.createRenderer = function() {
        return new (0, $02fffef185f4339b$export$2e2bcd8739ae039)(this);
    };
    return TileLayer;
}((0, $93be2de6a052f587$export$2e2bcd8739ae039));
var $32e67a4d3559554a$export$2e2bcd8739ae039 = $32e67a4d3559554a$var$TileLayer;


var $176ca75ee9f69668$exports = {};
!function(t, i) {
    $176ca75ee9f69668$exports = i();
}($176ca75ee9f69668$exports, function() {
    "use strict";
    function t(t, r, e, a, h) {
        !function t(n, r, e, a, h) {
            for(; a > e;){
                if (a - e > 600) {
                    var o = a - e + 1, s = r - e + 1, l = Math.log(o), f = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * f * (o - f) / o) * (s - o / 2 < 0 ? -1 : 1), m = Math.max(e, Math.floor(r - s * f / o + u)), c = Math.min(a, Math.floor(r + (o - s) * f / o + u));
                    t(n, r, m, c, h);
                }
                var p = n[r], d = e, x = a;
                for(i(n, e, r), h(n[a], p) > 0 && i(n, e, a); d < x;){
                    for(i(n, d, x), d++, x--; h(n[d], p) < 0;)d++;
                    for(; h(n[x], p) > 0;)x--;
                }
                0 === h(n[e], p) ? i(n, e, x) : i(n, ++x, a), x <= r && (e = x + 1), r <= x && (a = x - 1);
            }
        }(t, r, e || 0, a || t.length - 1, h || n);
    }
    function i(t, i, n) {
        var r = t[i];
        t[i] = t[n], t[n] = r;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    var r = function(t) {
        void 0 === t && (t = 9), this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
    };
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(var r = 0; r < i.length; r++)if (n(t, i[r])) return r;
        return -1;
    }
    function a(t, i) {
        h(t, 0, t.children.length, i, t);
    }
    function h(t, i, n, r, e) {
        e || (e = p(null)), e.minX = 1 / 0, e.minY = 1 / 0, e.maxX = -1 / 0, e.maxY = -1 / 0;
        for(var a = i; a < n; a++){
            var h = t.children[a];
            o(e, t.leaf ? r(h) : h);
        }
        return e;
    }
    function o(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function s(t, i) {
        return t.minX - i.minX;
    }
    function l(t, i) {
        return t.minY - i.minY;
    }
    function f(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function u(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function c(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function p(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function d(i, n, r, e, a) {
        for(var h = [
            n,
            r
        ]; h.length;)if (!((r = h.pop()) - (n = h.pop()) <= e)) {
            var o = n + Math.ceil((r - n) / e / 2) * e;
            t(i, o, n, r, a), h.push(n, o, o, r);
        }
    }
    return r.prototype.all = function() {
        return this._all(this.data, []);
    }, r.prototype.search = function(t) {
        var i = this.data, n = [];
        if (!c(t, i)) return n;
        for(var r = this.toBBox, e = []; i;){
            for(var a = 0; a < i.children.length; a++){
                var h = i.children[a], o = i.leaf ? r(h) : h;
                c(t, o) && (i.leaf ? n.push(h) : m(t, o) ? this._all(h, n) : e.push(h));
            }
            i = e.pop();
        }
        return n;
    }, r.prototype.collides = function(t) {
        var i = this.data;
        if (!c(t, i)) return !1;
        for(var n = []; i;){
            for(var r = 0; r < i.children.length; r++){
                var e = i.children[r], a = i.leaf ? this.toBBox(e) : e;
                if (c(t, a)) {
                    if (i.leaf || m(t, a)) return !0;
                    n.push(e);
                }
            }
            i = n.pop();
        }
        return !1;
    }, r.prototype.load = function(t) {
        if (!t || !t.length) return this;
        if (t.length < this._minEntries) {
            for(var i = 0; i < t.length; i++)this.insert(t[i]);
            return this;
        }
        var n = this._build(t.slice(), 0, t.length - 1, 0);
        if (this.data.children.length) {
            if (this.data.height === n.height) this._splitRoot(this.data, n);
            else {
                if (this.data.height < n.height) {
                    var r = this.data;
                    this.data = n, n = r;
                }
                this._insert(n, this.data.height - n.height - 1, !0);
            }
        } else this.data = n;
        return this;
    }, r.prototype.insert = function(t) {
        return t && this._insert(t, this.data.height - 1), this;
    }, r.prototype.clear = function() {
        return this.data = p([]), this;
    }, r.prototype.remove = function(t, i) {
        if (!t) return this;
        for(var n, r, a, h = this.data, o = this.toBBox(t), s = [], l = []; h || s.length;){
            if (h || (h = s.pop(), r = s[s.length - 1], n = l.pop(), a = !0), h.leaf) {
                var f = e(t, h.children, i);
                if (-1 !== f) return h.children.splice(f, 1), s.push(h), this._condense(s), this;
            }
            a || h.leaf || !m(h, o) ? r ? (n++, h = r.children[n], a = !1) : h = null : (s.push(h), l.push(n), n = 0, r = h, h = h.children[0]);
        }
        return this;
    }, r.prototype.toBBox = function(t) {
        return t;
    }, r.prototype.compareMinX = function(t, i) {
        return t.minX - i.minX;
    }, r.prototype.compareMinY = function(t, i) {
        return t.minY - i.minY;
    }, r.prototype.toJSON = function() {
        return this.data;
    }, r.prototype.fromJSON = function(t) {
        return this.data = t, this;
    }, r.prototype._all = function(t, i) {
        for(var n = []; t;)t.leaf ? i.push.apply(i, t.children) : n.push.apply(n, t.children), t = n.pop();
        return i;
    }, r.prototype._build = function(t, i, n, r) {
        var e, h = n - i + 1, o = this._maxEntries;
        if (h <= o) return a(e = p(t.slice(i, n + 1)), this.toBBox), e;
        r || (r = Math.ceil(Math.log(h) / Math.log(o)), o = Math.ceil(h / Math.pow(o, r - 1))), (e = p([])).leaf = !1, e.height = r;
        var s = Math.ceil(h / o), l = s * Math.ceil(Math.sqrt(o));
        d(t, i, n, l, this.compareMinX);
        for(var f = i; f <= n; f += l){
            var u = Math.min(f + l - 1, n);
            d(t, f, u, s, this.compareMinY);
            for(var m = f; m <= u; m += s){
                var c = Math.min(m + s - 1, u);
                e.children.push(this._build(t, m, c, r - 1));
            }
        }
        return a(e, this.toBBox), e;
    }, r.prototype._chooseSubtree = function(t, i, n, r) {
        for(; r.push(i), !i.leaf && r.length - 1 !== n;){
            for(var e = 1 / 0, a = 1 / 0, h = void 0, o = 0; o < i.children.length; o++){
                var s = i.children[o], l = f(s), u = (m = t, c = s, (Math.max(c.maxX, m.maxX) - Math.min(c.minX, m.minX)) * (Math.max(c.maxY, m.maxY) - Math.min(c.minY, m.minY)) - l);
                u < a ? (a = u, e = l < e ? l : e, h = s) : u === a && l < e && (e = l, h = s);
            }
            i = h || i.children[0];
        }
        var m, c;
        return i;
    }, r.prototype._insert = function(t, i, n) {
        var r = n ? t : this.toBBox(t), e = [], a = this._chooseSubtree(r, this.data, i, e);
        for(a.children.push(t), o(a, r); i >= 0 && e[i].children.length > this._maxEntries;)this._split(e, i), i--;
        this._adjustParentBBoxes(r, e, i);
    }, r.prototype._split = function(t, i) {
        var n = t[i], r = n.children.length, e = this._minEntries;
        this._chooseSplitAxis(n, e, r);
        var h = this._chooseSplitIndex(n, e, r), o = p(n.children.splice(h, n.children.length - h));
        o.height = n.height, o.leaf = n.leaf, a(n, this.toBBox), a(o, this.toBBox), i ? t[i - 1].children.push(o) : this._splitRoot(n, o);
    }, r.prototype._splitRoot = function(t, i) {
        this.data = p([
            t,
            i
        ]), this.data.height = t.height + 1, this.data.leaf = !1, a(this.data, this.toBBox);
    }, r.prototype._chooseSplitIndex = function(t, i, n) {
        for(var r, e, a, o, s, l, u, m = 1 / 0, c = 1 / 0, p = i; p <= n - i; p++){
            var d = h(t, 0, p, this.toBBox), x = h(t, p, n, this.toBBox), v = (e = d, a = x, o = void 0, s = void 0, l = void 0, u = void 0, o = Math.max(e.minX, a.minX), s = Math.max(e.minY, a.minY), l = Math.min(e.maxX, a.maxX), u = Math.min(e.maxY, a.maxY), Math.max(0, l - o) * Math.max(0, u - s)), M = f(d) + f(x);
            v < m ? (m = v, r = p, c = M < c ? M : c) : v === m && M < c && (c = M, r = p);
        }
        return r || n - i;
    }, r.prototype._chooseSplitAxis = function(t, i, n) {
        var r = t.leaf ? this.compareMinX : s, e = t.leaf ? this.compareMinY : l;
        this._allDistMargin(t, i, n, r) < this._allDistMargin(t, i, n, e) && t.children.sort(r);
    }, r.prototype._allDistMargin = function(t, i, n, r) {
        t.children.sort(r);
        for(var e = this.toBBox, a = h(t, 0, i, e), s = h(t, n - i, n, e), l = u(a) + u(s), f = i; f < n - i; f++){
            var m = t.children[f];
            o(a, t.leaf ? e(m) : m), l += u(a);
        }
        for(var c = n - i - 1; c >= i; c--){
            var p = t.children[c];
            o(s, t.leaf ? e(p) : p), l += u(s);
        }
        return l;
    }, r.prototype._adjustParentBBoxes = function(t, i, n) {
        for(var r = n; r >= 0; r--)o(i[r], t);
    }, r.prototype._condense = function(t) {
        for(var i = t.length - 1, n = void 0; i >= 0; i--)0 === t[i].children.length ? i > 0 ? (n = t[i - 1].children).splice(n.indexOf(t[i]), 1) : this.clear() : a(t[i], this.toBBox);
    }, r;
});



/**
 * @module ol/style/Style
 */ /**
 * @module ol/style/Circle
 */ /**
 * @module ol/style/RegularShape
 */ 
/**
 * @module ol/style/Image
 */ 

/**
 * @typedef {Object} Options
 * @property {number} opacity
 * @property {boolean} rotateWithView
 * @property {number} rotation
 * @property {number|import("../size.js").Size} scale
 * @property {Array<number>} displacement
 */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ var $e60011aea38e6239$var$ImageStyle = /** @class */ function() {
    /**
     * @param {Options} options Options.
     */ function ImageStyle(options) {
        /**
         * @private
         * @type {number}
         */ this.opacity_ = options.opacity;
        /**
         * @private
         * @type {boolean}
         */ this.rotateWithView_ = options.rotateWithView;
        /**
         * @private
         * @type {number}
         */ this.rotation_ = options.rotation;
        /**
         * @private
         * @type {number|import("../size.js").Size}
         */ this.scale_ = options.scale;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(options.scale);
        /**
         * @private
         * @type {Array<number>}
         */ this.displacement_ = options.displacement;
    }
    /**
     * Clones the style.
     * @return {ImageStyle} The cloned style.
     * @api
     */ ImageStyle.prototype.clone = function() {
        var scale = this.getScale();
        return new ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice()
        });
    };
    /**
     * Get the symbolizer opacity.
     * @return {number} Opacity.
     * @api
     */ ImageStyle.prototype.getOpacity = function() {
        return this.opacity_;
    };
    /**
     * Determine whether the symbolizer rotates with the map.
     * @return {boolean} Rotate with map.
     * @api
     */ ImageStyle.prototype.getRotateWithView = function() {
        return this.rotateWithView_;
    };
    /**
     * Get the symoblizer rotation.
     * @return {number} Rotation.
     * @api
     */ ImageStyle.prototype.getRotation = function() {
        return this.rotation_;
    };
    /**
     * Get the symbolizer scale.
     * @return {number|import("../size.js").Size} Scale.
     * @api
     */ ImageStyle.prototype.getScale = function() {
        return this.scale_;
    };
    /**
     * Get the symbolizer scale array.
     * @return {import("../size.js").Size} Scale array.
     */ ImageStyle.prototype.getScaleArray = function() {
        return this.scaleArray_;
    };
    /**
     * Get the displacement of the shape
     * @return {Array<number>} Shape's center displacement
     * @api
     */ ImageStyle.prototype.getDisplacement = function() {
        return this.displacement_;
    };
    /**
     * Get the anchor point in pixels. The anchor determines the center point for the
     * symbolizer.
     * @abstract
     * @return {Array<number>} Anchor.
     */ ImageStyle.prototype.getAnchor = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Get the image element for the symbolizer.
     * @abstract
     * @param {number} pixelRatio Pixel ratio.
     * @return {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} Image element.
     */ ImageStyle.prototype.getImage = function(pixelRatio) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @abstract
     * @return {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} Image element.
     */ ImageStyle.prototype.getHitDetectionImage = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /*
     * Get the image pixel ratio.
     * @param {number} pixelRatio Pixel ratio.
     * */ ImageStyle.prototype.getPixelRatio = function(pixelRatio) {
        return 1;
    };
    /**
     * @abstract
     * @return {import("../ImageState.js").default} Image state.
     */ ImageStyle.prototype.getImageState = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @abstract
     * @return {import("../size.js").Size} Image size.
     */ ImageStyle.prototype.getImageSize = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @abstract
     * @return {import("../size.js").Size} Size of the hit-detection image.
     */ ImageStyle.prototype.getHitDetectionImageSize = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Get the origin of the symbolizer.
     * @abstract
     * @return {Array<number>} Origin.
     */ ImageStyle.prototype.getOrigin = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Get the size of the symbolizer (in pixels).
     * @abstract
     * @return {import("../size.js").Size} Size.
     */ ImageStyle.prototype.getSize = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Set the opacity.
     *
     * @param {number} opacity Opacity.
     * @api
     */ ImageStyle.prototype.setOpacity = function(opacity) {
        this.opacity_ = opacity;
    };
    /**
     * Set whether to rotate the style with the view.
     *
     * @param {boolean} rotateWithView Rotate with map.
     * @api
     */ ImageStyle.prototype.setRotateWithView = function(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    };
    /**
     * Set the rotation.
     *
     * @param {number} rotation Rotation.
     * @api
     */ ImageStyle.prototype.setRotation = function(rotation) {
        this.rotation_ = rotation;
    };
    /**
     * Set the scale.
     *
     * @param {number|import("../size.js").Size} scale Scale.
     * @api
     */ ImageStyle.prototype.setScale = function(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(scale);
    };
    /**
     * @abstract
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */ ImageStyle.prototype.listenImageChange = function(listener) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Load not yet loaded URI.
     * @abstract
     */ ImageStyle.prototype.load = function() {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @abstract
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */ ImageStyle.prototype.unlistenImageChange = function(listener) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    return ImageStyle;
}();
var $e60011aea38e6239$export$2e2bcd8739ae039 = $e60011aea38e6239$var$ImageStyle;



/**
 * @module ol/colorlike
 */ 
function $e0807f400ec9a0a9$export$dc5b1400ac3a10a8(color) {
    if (Array.isArray(color)) return (0, $322346e1ff7894ca$export$f84e8e69fd4488a5)(color);
    else return color;
}




var $3e99c452138b2224$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Specify radius for regular polygons, or radius1 and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} [radius] Radius of a regular polygon.
 * @property {number} [radius1] Outer radius of a star.
 * @property {number} [radius2] Inner radius of a star.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's point facing up.
 * @property {Array<number>} [displacement=[0,0]] Displacement of the shape
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius`, `radius1` and `radius2`.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike} [strokeStyle]
 * @property {number} strokeWidth
 * @property {number} size
 * @property {CanvasLineCap} lineCap
 * @property {Array<number>} lineDash
 * @property {number} lineDashOffset
 * @property {CanvasLineJoin} lineJoin
 * @property {number} miterLimit
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when `radius1` and
 * `radius2` are provided.
 * @api
 */ var $3e99c452138b2224$var$RegularShape = /** @class */ function(_super) {
    $3e99c452138b2224$var$__extends(RegularShape, _super);
    /**
     * @param {Options} options Options.
     */ function RegularShape(options) {
        var _this = this;
        /**
         * @type {boolean}
         */ var rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        _this = _super.call(this, {
            opacity: 1,
            rotateWithView: rotateWithView,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ]
        }) || this;
        /**
         * @private
         * @type {Object<number, HTMLCanvasElement>}
         */ _this.canvas_ = {};
        /**
         * @private
         * @type {HTMLCanvasElement}
         */ _this.hitDetectionCanvas_ = null;
        /**
         * @private
         * @type {import("./Fill.js").default}
         */ _this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
         * @private
         * @type {Array<number>}
         */ _this.origin_ = [
            0,
            0
        ];
        /**
         * @private
         * @type {number}
         */ _this.points_ = options.points;
        /**
         * @protected
         * @type {number}
         */ _this.radius_ = options.radius !== undefined ? options.radius : options.radius1;
        /**
         * @private
         * @type {number|undefined}
         */ _this.radius2_ = options.radius2;
        /**
         * @private
         * @type {number}
         */ _this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
         * @private
         * @type {import("./Stroke.js").default}
         */ _this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
         * @private
         * @type {Array<number>}
         */ _this.anchor_ = null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ _this.size_ = null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ _this.imageSize_ = null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ _this.hitDetectionImageSize_ = null;
        _this.render();
        return _this;
    }
    /**
     * Clones the style.
     * @return {RegularShape} The cloned style.
     * @api
     */ RegularShape.prototype.clone = function() {
        var scale = this.getScale();
        var style = new RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice()
        });
        style.setOpacity(this.getOpacity());
        return style;
    };
    /**
     * Get the anchor point in pixels. The anchor determines the center point for the
     * symbolizer.
     * @return {Array<number>} Anchor.
     * @api
     */ RegularShape.prototype.getAnchor = function() {
        return this.anchor_;
    };
    /**
     * Get the angle used in generating the shape.
     * @return {number} Shape's rotation in radians.
     * @api
     */ RegularShape.prototype.getAngle = function() {
        return this.angle_;
    };
    /**
     * Get the fill style for the shape.
     * @return {import("./Fill.js").default} Fill style.
     * @api
     */ RegularShape.prototype.getFill = function() {
        return this.fill_;
    };
    /**
     * @return {HTMLCanvasElement} Image element.
     */ RegularShape.prototype.getHitDetectionImage = function() {
        if (!this.hitDetectionCanvas_) {
            var renderOptions = this.createRenderOptions();
            this.createHitDetectionCanvas_(renderOptions);
        }
        return this.hitDetectionCanvas_;
    };
    /**
     * Get the image icon.
     * @param {number} pixelRatio Pixel ratio.
     * @return {HTMLCanvasElement} Image or Canvas element.
     * @api
     */ RegularShape.prototype.getImage = function(pixelRatio) {
        if (!this.canvas_[pixelRatio || 1]) {
            var renderOptions = this.createRenderOptions();
            var context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(renderOptions.size * pixelRatio || 1, renderOptions.size * pixelRatio || 1);
            this.draw_(renderOptions, context, 0, 0, pixelRatio || 1);
            this.canvas_[pixelRatio || 1] = context.canvas;
        }
        return this.canvas_[pixelRatio || 1];
    };
    /*
     * Get the image pixel ratio.
     * @param {number} pixelRatio Pixel ratio.
     * */ RegularShape.prototype.getPixelRatio = function(pixelRatio) {
        return pixelRatio;
    };
    /**
     * @return {import("../size.js").Size} Image size.
     */ RegularShape.prototype.getImageSize = function() {
        return this.imageSize_;
    };
    /**
     * @return {import("../size.js").Size} Size of the hit-detection image.
     */ RegularShape.prototype.getHitDetectionImageSize = function() {
        return this.hitDetectionImageSize_;
    };
    /**
     * @return {import("../ImageState.js").default} Image state.
     */ RegularShape.prototype.getImageState = function() {
        return (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
    };
    /**
     * Get the origin of the symbolizer.
     * @return {Array<number>} Origin.
     * @api
     */ RegularShape.prototype.getOrigin = function() {
        return this.origin_;
    };
    /**
     * Get the number of points for generating the shape.
     * @return {number} Number of points for stars and regular polygons.
     * @api
     */ RegularShape.prototype.getPoints = function() {
        return this.points_;
    };
    /**
     * Get the (primary) radius for the shape.
     * @return {number} Radius.
     * @api
     */ RegularShape.prototype.getRadius = function() {
        return this.radius_;
    };
    /**
     * Get the secondary radius for the shape.
     * @return {number|undefined} Radius2.
     * @api
     */ RegularShape.prototype.getRadius2 = function() {
        return this.radius2_;
    };
    /**
     * Get the size of the symbolizer (in pixels).
     * @return {import("../size.js").Size} Size.
     * @api
     */ RegularShape.prototype.getSize = function() {
        return this.size_;
    };
    /**
     * Get the stroke style for the shape.
     * @return {import("./Stroke.js").default} Stroke style.
     * @api
     */ RegularShape.prototype.getStroke = function() {
        return this.stroke_;
    };
    /**
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */ RegularShape.prototype.listenImageChange = function(listener) {};
    /**
     * Load not yet loaded URI.
     */ RegularShape.prototype.load = function() {};
    /**
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */ RegularShape.prototype.unlistenImageChange = function(listener) {};
    /**
     * @returns {RenderOptions}  The render options
     * @protected
     */ RegularShape.prototype.createRenderOptions = function() {
        var lineCap = (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
        var lineJoin = (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
        var miterLimit = 0;
        var lineDash = null;
        var lineDashOffset = 0;
        var strokeStyle;
        var strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = this.stroke_.getColor();
            if (strokeStyle === null) strokeStyle = (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e);
            strokeStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(strokeStyle);
            strokeWidth = this.stroke_.getWidth();
            if (strokeWidth === undefined) strokeWidth = (0, $d4aabc5c971073f1$export$79661f132c62010e);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset();
            lineJoin = this.stroke_.getLineJoin();
            if (lineJoin === undefined) lineJoin = (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
            lineCap = this.stroke_.getLineCap();
            if (lineCap === undefined) lineCap = (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
            miterLimit = this.stroke_.getMiterLimit();
            if (miterLimit === undefined) miterLimit = (0, $d4aabc5c971073f1$export$80c1c01844597b7b);
        }
        var size = 2 * (this.radius_ + strokeWidth) + 1;
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
    };
    /**
     * @protected
     */ RegularShape.prototype.render = function() {
        var renderOptions = this.createRenderOptions();
        var context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(renderOptions.size, renderOptions.size);
        this.draw_(renderOptions, context, 0, 0, 1);
        this.canvas_ = {};
        this.canvas_[1] = context.canvas;
        // canvas.width and height are rounded to the closest integer
        var size = context.canvas.width;
        var imageSize = size;
        var displacement = this.getDisplacement();
        this.hitDetectionImageSize_ = [
            renderOptions.size,
            renderOptions.size
        ];
        this.createHitDetectionCanvas_(renderOptions);
        this.anchor_ = [
            size / 2 - displacement[0],
            size / 2 + displacement[1]
        ];
        this.size_ = [
            size,
            size
        ];
        this.imageSize_ = [
            imageSize,
            imageSize
        ];
    };
    /**
     * @private
     * @param {RenderOptions} renderOptions Render options.
     * @param {CanvasRenderingContext2D} context The rendering context.
     * @param {number} x The origin for the symbol (x).
     * @param {number} y The origin for the symbol (y).
     * @param {number} pixelRatio The pixel ratio.
     */ RegularShape.prototype.draw_ = function(renderOptions, context, x, y, pixelRatio) {
        var i, angle0, radiusC;
        // reset transform
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        // then move to (x, y)
        context.translate(x, y);
        context.beginPath();
        var points = this.points_;
        if (points === Infinity) context.arc(renderOptions.size / 2, renderOptions.size / 2, this.radius_, 0, 2 * Math.PI, true);
        else {
            var radius2 = this.radius2_ !== undefined ? this.radius2_ : this.radius_;
            if (radius2 !== this.radius_) points = 2 * points;
            for(i = 0; i <= points; i++){
                angle0 = i * 2 * Math.PI / points - Math.PI / 2 + this.angle_;
                radiusC = i % 2 === 0 ? this.radius_ : radius2;
                context.lineTo(renderOptions.size / 2 + radiusC * Math.cos(angle0), renderOptions.size / 2 + radiusC * Math.sin(angle0));
            }
        }
        if (this.fill_) {
            var color = this.fill_.getColor();
            if (color === null) color = (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2);
            context.fillStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(color);
            context.fill();
        }
        if (this.stroke_) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (context.setLineDash && renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
        context.closePath();
    };
    /**
     * @private
     * @param {RenderOptions} renderOptions Render options.
     */ RegularShape.prototype.createHitDetectionCanvas_ = function(renderOptions) {
        this.hitDetectionCanvas_ = this.getImage(1);
        if (this.fill_) {
            var color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            var opacity = 0;
            if (typeof color === 'string') color = (0, $322346e1ff7894ca$export$75093a47a9fa838d)(color);
            if (color === null) opacity = 1;
            else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                var context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(renderOptions.size, renderOptions.size);
                this.hitDetectionCanvas_ = context.canvas;
                this.drawHitDetectionCanvas_(renderOptions, context, 0, 0);
            }
        }
    };
    /**
     * @private
     * @param {RenderOptions} renderOptions Render options.
     * @param {CanvasRenderingContext2D} context The context.
     * @param {number} x The origin for the symbol (x).
     * @param {number} y The origin for the symbol (y).
     */ RegularShape.prototype.drawHitDetectionCanvas_ = function(renderOptions, context, x, y) {
        // move to (x, y)
        context.translate(x, y);
        context.beginPath();
        var points = this.points_;
        if (points === Infinity) context.arc(renderOptions.size / 2, renderOptions.size / 2, this.radius_, 0, 2 * Math.PI, true);
        else {
            var radius2 = this.radius2_ !== undefined ? this.radius2_ : this.radius_;
            if (radius2 !== this.radius_) points = 2 * points;
            var i = void 0, radiusC = void 0, angle0 = void 0;
            for(i = 0; i <= points; i++){
                angle0 = i * 2 * Math.PI / points - Math.PI / 2 + this.angle_;
                radiusC = i % 2 === 0 ? this.radius_ : radius2;
                context.lineTo(renderOptions.size / 2 + radiusC * Math.cos(angle0), renderOptions.size / 2 + radiusC * Math.sin(angle0));
            }
        }
        context.fillStyle = (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2);
        context.fill();
        if (this.stroke_) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.stroke();
        }
        context.closePath();
    };
    return RegularShape;
}((0, $e60011aea38e6239$export$2e2bcd8739ae039));
var $3e99c452138b2224$export$2e2bcd8739ae039 = $3e99c452138b2224$var$RegularShape;


var $06150d8570b7481b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ var $06150d8570b7481b$var$CircleStyle = /** @class */ function(_super) {
    $06150d8570b7481b$var$__extends(CircleStyle, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function CircleStyle(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ]
        }) || this;
        return _this;
    }
    /**
     * Clones the style.
     * @return {CircleStyle} The cloned style.
     * @api
     */ CircleStyle.prototype.clone = function() {
        var scale = this.getScale();
        var style = new CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice()
        });
        style.setOpacity(this.getOpacity());
        return style;
    };
    /**
     * Set the circle radius.
     *
     * @param {number} radius Circle radius.
     * @api
     */ CircleStyle.prototype.setRadius = function(radius) {
        this.radius_ = radius;
        this.render();
    };
    return CircleStyle;
}((0, $3e99c452138b2224$export$2e2bcd8739ae039));
var $06150d8570b7481b$export$2e2bcd8739ae039 = $06150d8570b7481b$var$CircleStyle;


/**
 * @module ol/style/Fill
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color=null] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ var $d61d1dcaf3c44610$var$Fill = /** @class */ function() {
    /**
     * @param {Options=} opt_options Options.
     */ function Fill(opt_options) {
        var options = opt_options || {};
        /**
         * @private
         * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
         */ this.color_ = options.color !== undefined ? options.color : null;
    }
    /**
     * Clones the style. The color is not cloned if it is an {@link module:ol/colorlike~ColorLike}.
     * @return {Fill} The cloned style.
     * @api
     */ Fill.prototype.clone = function() {
        var color = this.getColor();
        return new Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined
        });
    };
    /**
     * Get the fill color.
     * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
     * @api
     */ Fill.prototype.getColor = function() {
        return this.color_;
    };
    /**
     * Set the color.
     *
     * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
     * @api
     */ Fill.prototype.setColor = function(color) {
        this.color_ = color;
    };
    return Fill;
}();
var $d61d1dcaf3c44610$export$2e2bcd8739ae039 = $d61d1dcaf3c44610$var$Fill;



/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * Please note that Internet Explorer 10 and lower do not support the `setLineDash` method on
 * the `CanvasRenderingContext2D` and therefore this option will have no visual effect in these browsers.
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ var $f9d0329c5c745263$var$Stroke = /** @class */ function() {
    /**
     * @param {Options=} opt_options Options.
     */ function Stroke(opt_options) {
        var options = opt_options || {};
        /**
         * @private
         * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
         */ this.color_ = options.color !== undefined ? options.color : null;
        /**
         * @private
         * @type {CanvasLineCap|undefined}
         */ this.lineCap_ = options.lineCap;
        /**
         * @private
         * @type {Array<number>}
         */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
         * @private
         * @type {number|undefined}
         */ this.lineDashOffset_ = options.lineDashOffset;
        /**
         * @private
         * @type {CanvasLineJoin|undefined}
         */ this.lineJoin_ = options.lineJoin;
        /**
         * @private
         * @type {number|undefined}
         */ this.miterLimit_ = options.miterLimit;
        /**
         * @private
         * @type {number|undefined}
         */ this.width_ = options.width;
    }
    /**
     * Clones the style.
     * @return {Stroke} The cloned style.
     * @api
     */ Stroke.prototype.clone = function() {
        var color = this.getColor();
        return new Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            width: this.getWidth()
        });
    };
    /**
     * Get the stroke color.
     * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
     * @api
     */ Stroke.prototype.getColor = function() {
        return this.color_;
    };
    /**
     * Get the line cap type for the stroke.
     * @return {CanvasLineCap|undefined} Line cap.
     * @api
     */ Stroke.prototype.getLineCap = function() {
        return this.lineCap_;
    };
    /**
     * Get the line dash style for the stroke.
     * @return {Array<number>} Line dash.
     * @api
     */ Stroke.prototype.getLineDash = function() {
        return this.lineDash_;
    };
    /**
     * Get the line dash offset for the stroke.
     * @return {number|undefined} Line dash offset.
     * @api
     */ Stroke.prototype.getLineDashOffset = function() {
        return this.lineDashOffset_;
    };
    /**
     * Get the line join type for the stroke.
     * @return {CanvasLineJoin|undefined} Line join.
     * @api
     */ Stroke.prototype.getLineJoin = function() {
        return this.lineJoin_;
    };
    /**
     * Get the miter limit for the stroke.
     * @return {number|undefined} Miter limit.
     * @api
     */ Stroke.prototype.getMiterLimit = function() {
        return this.miterLimit_;
    };
    /**
     * Get the stroke width.
     * @return {number|undefined} Width.
     * @api
     */ Stroke.prototype.getWidth = function() {
        return this.width_;
    };
    /**
     * Set the color.
     *
     * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
     * @api
     */ Stroke.prototype.setColor = function(color) {
        this.color_ = color;
    };
    /**
     * Set the line cap.
     *
     * @param {CanvasLineCap|undefined} lineCap Line cap.
     * @api
     */ Stroke.prototype.setLineCap = function(lineCap) {
        this.lineCap_ = lineCap;
    };
    /**
     * Set the line dash.
     *
     * Please note that Internet Explorer 10 and lower [do not support][mdn] the
     * `setLineDash` method on the `CanvasRenderingContext2D` and therefore this
     * property will have no visual effect in these browsers.
     *
     * [mdn]: https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility
     *
     * @param {Array<number>} lineDash Line dash.
     * @api
     */ Stroke.prototype.setLineDash = function(lineDash) {
        this.lineDash_ = lineDash;
    };
    /**
     * Set the line dash offset.
     *
     * @param {number|undefined} lineDashOffset Line dash offset.
     * @api
     */ Stroke.prototype.setLineDashOffset = function(lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    };
    /**
     * Set the line join.
     *
     * @param {CanvasLineJoin|undefined} lineJoin Line join.
     * @api
     */ Stroke.prototype.setLineJoin = function(lineJoin) {
        this.lineJoin_ = lineJoin;
    };
    /**
     * Set the miter limit.
     *
     * @param {number|undefined} miterLimit Miter limit.
     * @api
     */ Stroke.prototype.setMiterLimit = function(miterLimit) {
        this.miterLimit_ = miterLimit;
    };
    /**
     * Set the width.
     *
     * @param {number|undefined} width Width.
     * @api
     */ Stroke.prototype.setWidth = function(width) {
        this.width_ = width;
    };
    return Stroke;
}();
var $f9d0329c5c745263$export$2e2bcd8739ae039 = $f9d0329c5c745263$var$Stroke;



/**
 * A function that takes an {@link module:ol/Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes an {@link module:ol/Feature} as argument and returns an
 * {@link module:ol/geom/Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>),import("../render.js").State): void}
 * RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Fill, Stroke, Circle, Style} from 'ol/style';
 *
 *  var fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)'
 *  });
 *  var stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25
 *  });
 *  var styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5
 *      }),
 *      fill: fill,
 *      stroke: stroke
 *    })
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Fill, Stroke, Circle, Style} from 'ol/style';
 *  import GeometryType from 'ol/geom/GeometryType';
 *
 *  var white = [255, 255, 255, 1];
 *  var blue = [0, 153, 255, 1];
 *  var width = 3;
 *  styles[GeometryType.POLYGON] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5]
 *      })
 *    })
 *  ];
 *  styles[GeometryType.MULTI_POLYGON] =
 *      styles[GeometryType.POLYGON];
 *  styles[GeometryType.LINE_STRING] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2
 *      })
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width
 *      })
 *    })
 *  ];
 *  styles[GeometryType.MULTI_LINE_STRING] =
 *      styles[GeometryType.LINE_STRING];
 *  styles[GeometryType.POINT] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2
 *        })
 *      }),
 *      zIndex: Infinity
 *    })
 *  ];
 *  styles[GeometryType.MULTI_POINT] =
 *      styles[GeometryType.POINT];
 *  styles[GeometryType.GEOMETRY_COLLECTION] =
 *      styles[GeometryType.POLYGON].concat(
 *          styles[GeometryType.LINE_STRING],
 *          styles[GeometryType.POINT]
 *      );
 * ```
 *
 * @api
 */ var $8c7f6dda98e8cb9c$var$Style = /** @class */ function() {
    /**
     * @param {Options=} opt_options Style options.
     */ function Style(opt_options) {
        var options = opt_options || {};
        /**
         * @private
         * @type {string|import("../geom/Geometry.js").default|GeometryFunction}
         */ this.geometry_ = null;
        /**
         * @private
         * @type {!GeometryFunction}
         */ this.geometryFunction_ = $8c7f6dda98e8cb9c$var$defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
         * @private
         * @type {import("./Fill.js").default}
         */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
         * @private
         * @type {import("./Image.js").default}
         */ this.image_ = options.image !== undefined ? options.image : null;
        /**
         * @private
         * @type {RenderFunction|null}
         */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
         * @private
         * @type {import("./Stroke.js").default}
         */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
         * @private
         * @type {import("./Text.js").default}
         */ this.text_ = options.text !== undefined ? options.text : null;
        /**
         * @private
         * @type {number|undefined}
         */ this.zIndex_ = options.zIndex;
    }
    /**
     * Clones the style.
     * @return {Style} The cloned style.
     * @api
     */ Style.prototype.clone = function() {
        var geometry = this.getGeometry();
        if (geometry && typeof geometry === 'object') geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
        return new Style({
            geometry: geometry,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex()
        });
    };
    /**
     * Get the custom renderer function that was configured with
     * {@link #setRenderer} or the `renderer` constructor option.
     * @return {RenderFunction|null} Custom renderer function.
     * @api
     */ Style.prototype.getRenderer = function() {
        return this.renderer_;
    };
    /**
     * Sets a custom renderer function for this style. When set, `fill`, `stroke`
     * and `image` options of the style will be ignored.
     * @param {RenderFunction|null} renderer Custom renderer function.
     * @api
     */ Style.prototype.setRenderer = function(renderer) {
        this.renderer_ = renderer;
    };
    /**
     * Get the geometry to be rendered.
     * @return {string|import("../geom/Geometry.js").default|GeometryFunction}
     * Feature property or geometry or function that returns the geometry that will
     * be rendered with this style.
     * @api
     */ Style.prototype.getGeometry = function() {
        return this.geometry_;
    };
    /**
     * Get the function used to generate a geometry for rendering.
     * @return {!GeometryFunction} Function that is called with a feature
     * and returns the geometry to render instead of the feature's geometry.
     * @api
     */ Style.prototype.getGeometryFunction = function() {
        return this.geometryFunction_;
    };
    /**
     * Get the fill style.
     * @return {import("./Fill.js").default} Fill style.
     * @api
     */ Style.prototype.getFill = function() {
        return this.fill_;
    };
    /**
     * Set the fill style.
     * @param {import("./Fill.js").default} fill Fill style.
     * @api
     */ Style.prototype.setFill = function(fill) {
        this.fill_ = fill;
    };
    /**
     * Get the image style.
     * @return {import("./Image.js").default} Image style.
     * @api
     */ Style.prototype.getImage = function() {
        return this.image_;
    };
    /**
     * Set the image style.
     * @param {import("./Image.js").default} image Image style.
     * @api
     */ Style.prototype.setImage = function(image) {
        this.image_ = image;
    };
    /**
     * Get the stroke style.
     * @return {import("./Stroke.js").default} Stroke style.
     * @api
     */ Style.prototype.getStroke = function() {
        return this.stroke_;
    };
    /**
     * Set the stroke style.
     * @param {import("./Stroke.js").default} stroke Stroke style.
     * @api
     */ Style.prototype.setStroke = function(stroke) {
        this.stroke_ = stroke;
    };
    /**
     * Get the text style.
     * @return {import("./Text.js").default} Text style.
     * @api
     */ Style.prototype.getText = function() {
        return this.text_;
    };
    /**
     * Set the text style.
     * @param {import("./Text.js").default} text Text style.
     * @api
     */ Style.prototype.setText = function(text) {
        this.text_ = text;
    };
    /**
     * Get the z-index for the style.
     * @return {number|undefined} ZIndex.
     * @api
     */ Style.prototype.getZIndex = function() {
        return this.zIndex_;
    };
    /**
     * Set a geometry that is rendered instead of the feature's geometry.
     *
     * @param {string|import("../geom/Geometry.js").default|GeometryFunction} geometry
     *     Feature property or geometry or function returning a geometry to render
     *     for this style.
     * @api
     */ Style.prototype.setGeometry = function(geometry) {
        if (typeof geometry === 'function') this.geometryFunction_ = geometry;
        else if (typeof geometry === 'string') this.geometryFunction_ = function(feature) {
            return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
        };
        else if (!geometry) this.geometryFunction_ = $8c7f6dda98e8cb9c$var$defaultGeometryFunction;
        else if (geometry !== undefined) this.geometryFunction_ = function() {
            return /** @type {import("../geom/Geometry.js").default} */ geometry;
        };
        this.geometry_ = geometry;
    };
    /**
     * Set the z-index.
     *
     * @param {number|undefined} zIndex ZIndex.
     * @api
     */ Style.prototype.setZIndex = function(zIndex) {
        this.zIndex_ = zIndex;
    };
    return Style;
}();
function $8c7f6dda98e8cb9c$export$c314ea3f6b164147(obj) {
    var styleFunction;
    if (typeof obj === 'function') styleFunction = obj;
    else {
        /**
         * @type {Array<Style>}
         */ var styles_1;
        if (Array.isArray(obj)) styles_1 = obj;
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === 'function', 41); // Expected an `Style` or an array of `Style`
            var style = /** @type {Style} */ obj;
            styles_1 = [
                style
            ];
        }
        styleFunction = function() {
            return styles_1;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>}
 */ var $8c7f6dda98e8cb9c$var$defaultStyles = null;
function $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$8c7f6dda98e8cb9c$var$defaultStyles) {
        var fill = new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: 'rgba(255,255,255,0.4)'
        });
        var stroke = new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
            color: '#3399CC',
            width: 1.25
        });
        $8c7f6dda98e8cb9c$var$defaultStyles = [
            new $8c7f6dda98e8cb9c$var$Style({
                image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $8c7f6dda98e8cb9c$var$defaultStyles;
}
function $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/GeometryType.js").default, Array<Style>>} */ var styles = {};
    var white = [
        255,
        255,
        255,
        1
    ];
    var blue = [
        0,
        153,
        255,
        1
    ];
    var width = 3;
    styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON] = [
        new $8c7f6dda98e8cb9c$var$Style({
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POLYGON] = styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON];
    styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING] = [
        new $8c7f6dda98e8cb9c$var$Style({
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: white,
                width: width + 2
            })
        }),
        new $8c7f6dda98e8cb9c$var$Style({
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: blue,
                width: width
            })
        })
    ];
    styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_LINE_STRING] = styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING];
    styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).CIRCLE] = styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON].concat(styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING]);
    styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).POINT] = [
        new $8c7f6dda98e8cb9c$var$Style({
            image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                radius: width * 2,
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: blue
                }),
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POINT] = styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).POINT];
    styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).GEOMETRY_COLLECTION] = styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON].concat(styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING], styles[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).POINT]);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $8c7f6dda98e8cb9c$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $8c7f6dda98e8cb9c$export$2e2bcd8739ae039 = $8c7f6dda98e8cb9c$var$Style;


var $c8d6dc4c09ed9916$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {import("../source/Vector.js").default} [source] Source.
 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link module:ol/Map#addLayer}.
 * @property {boolean} [declutter=false] Declutter images and text. Decluttering is applied to all
 * image and text styles of all Vector and VectorTile layers that have set this to `true`. The priority
 * is defined by the z-index of the layer, the `zIndex` of the style and the render order of features.
 * Higher z-index means higher priority. Within the same z-index, a feature rendered before another has
 * higher priority.
 * @property {import("../style/Style.js").StyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style} for default style
 * which will be used if this is not set.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 */ /**
 * @enum {string}
 * @private
 */ var $c8d6dc4c09ed9916$var$Property = {
    RENDER_ORDER: 'renderOrder'
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default|import("../source/VectorTile.js").default} VectorSourceType
 * @extends {Layer<VectorSourceType>}
 * @api
 */ var $c8d6dc4c09ed9916$var$BaseVectorLayer = /** @class */ function(_super) {
    $c8d6dc4c09ed9916$var$__extends(BaseVectorLayer, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function BaseVectorLayer(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var baseOptions = (0, $beaefe87199bb537$export$e6e34fd1f2686227)({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        _this = _super.call(this, baseOptions) || this;
        /**
         * @private
         * @type {boolean}
         */ _this.declutter_ = options.declutter !== undefined ? options.declutter : false;
        /**
         * @type {number}
         * @private
         */ _this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
         * User provided style.
         * @type {import("../style/Style.js").StyleLike}
         * @private
         */ _this.style_ = null;
        /**
         * Style function for use within the library.
         * @type {import("../style/Style.js").StyleFunction|undefined}
         * @private
         */ _this.styleFunction_ = undefined;
        _this.setStyle(options.style);
        /**
         * @type {boolean}
         * @private
         */ _this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
         * @type {boolean}
         * @private
         */ _this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
        return _this;
    }
    /**
     * @return {boolean} Declutter.
     */ BaseVectorLayer.prototype.getDeclutter = function() {
        return this.declutter_;
    };
    /**
     * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
     * that resolves with an array of features. The array will either contain the topmost feature
     * when a hit was detected, or it will be empty.
     *
     * The hit detection algorithm used for this method is optimized for performance, but is less
     * accurate than the one used in {@link import("../PluggableMap.js").default#getFeaturesAtPixel}: Text
     * is not considered, and icons are only represented by their bounding box instead of the exact
     * image.
     *
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../Feature").default>>} Promise that resolves with an array of features.
     * @api
     */ BaseVectorLayer.prototype.getFeatures = function(pixel) {
        return _super.prototype.getFeatures.call(this, pixel);
    };
    /**
     * @return {number|undefined} Render buffer.
     */ BaseVectorLayer.prototype.getRenderBuffer = function() {
        return this.renderBuffer_;
    };
    /**
     * @return {function(import("../Feature.js").default, import("../Feature.js").default): number|null|undefined} Render
     *     order.
     */ BaseVectorLayer.prototype.getRenderOrder = function() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($c8d6dc4c09ed9916$var$Property.RENDER_ORDER);
    };
    /**
     * Get the style for features.  This returns whatever was passed to the `style`
     * option at construction or to the `setStyle` method.
     * @return {import("../style/Style.js").StyleLike|null|undefined} Layer style.
     * @api
     */ BaseVectorLayer.prototype.getStyle = function() {
        return this.style_;
    };
    /**
     * Get the style function.
     * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
     * @api
     */ BaseVectorLayer.prototype.getStyleFunction = function() {
        return this.styleFunction_;
    };
    /**
     * @return {boolean} Whether the rendered layer should be updated while
     *     animating.
     */ BaseVectorLayer.prototype.getUpdateWhileAnimating = function() {
        return this.updateWhileAnimating_;
    };
    /**
     * @return {boolean} Whether the rendered layer should be updated while
     *     interacting.
     */ BaseVectorLayer.prototype.getUpdateWhileInteracting = function() {
        return this.updateWhileInteracting_;
    };
    /**
     * Render declutter items for this layer
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     */ BaseVectorLayer.prototype.renderDeclutter = function(frameState) {
        if (!frameState.declutterTree) frameState.declutterTree = new (0, (/*@__PURE__*/$parcel$interopDefault($176ca75ee9f69668$exports)))(9);
        /** @type {*} */ this.getRenderer().renderDeclutter(frameState);
    };
    /**
     * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
     *     Render order.
     */ BaseVectorLayer.prototype.setRenderOrder = function(renderOrder) {
        this.set($c8d6dc4c09ed9916$var$Property.RENDER_ORDER, renderOrder);
    };
    /**
     * Set the style for features.  This can be a single style object, an array
     * of styles, or a function that takes a feature and resolution and returns
     * an array of styles. If set to `null`, the layer has no style (a `null` style),
     * so only features that have their own styles will be rendered in the layer. Call
     * `setStyle()` without arguments to reset to the default style. See
     * {@link module:ol/style} for information on the default style.
     * @param {(import("../style/Style.js").StyleLike|null)=} opt_style Layer style.
     * @api
     */ BaseVectorLayer.prototype.setStyle = function(opt_style) {
        this.style_ = opt_style !== undefined ? opt_style : (0, $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6);
        this.styleFunction_ = opt_style === null ? undefined : (0, $8c7f6dda98e8cb9c$export$c314ea3f6b164147)(this.style_);
        this.changed();
    };
    return BaseVectorLayer;
}((0, $534f30fce11effcd$export$2e2bcd8739ae039));
var $c8d6dc4c09ed9916$export$2e2bcd8739ae039 = $c8d6dc4c09ed9916$var$BaseVectorLayer;


/**
 * @module ol/render/canvas/BuilderGroup
 */ /**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ var $cf547866e052f25b$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
var $cf547866e052f25b$export$f21891651e408226 = [
    $cf547866e052f25b$var$Instruction.FILL
];
var $cf547866e052f25b$export$7a98aa5364d62ba8 = [
    $cf547866e052f25b$var$Instruction.STROKE
];
var $cf547866e052f25b$export$9f746cc58a899a00 = [
    $cf547866e052f25b$var$Instruction.BEGIN_PATH
];
var $cf547866e052f25b$export$89b10f327e413e71 = [
    $cf547866e052f25b$var$Instruction.CLOSE_PATH
];
var $cf547866e052f25b$export$2e2bcd8739ae039 = $cf547866e052f25b$var$Instruction;




/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ var $eb0e5c3938110b4c$var$VectorContext = /** @class */ function() {
    function VectorContext() {}
    /**
     * Render a geometry with a custom renderer.
     *
     * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {Function} renderer Renderer.
     */ VectorContext.prototype.drawCustom = function(geometry, feature, renderer) {};
    /**
     * Render a geometry.
     *
     * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
     */ VectorContext.prototype.drawGeometry = function(geometry) {};
    /**
     * Set the rendering style.
     *
     * @param {import("../style/Style.js").default} style The rendering style.
     */ VectorContext.prototype.setStyle = function(style) {};
    /**
     * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
     * @param {import("../Feature.js").default} feature Feature.
     */ VectorContext.prototype.drawCircle = function(circleGeometry, feature) {};
    /**
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("../style/Style.js").default} style Style.
     */ VectorContext.prototype.drawFeature = function(feature, style) {};
    /**
     * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
     * @param {import("../Feature.js").default} feature Feature.
     */ VectorContext.prototype.drawGeometryCollection = function(geometryCollectionGeometry, feature) {};
    /**
     * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawLineString = function(lineStringGeometry, feature) {};
    /**
     * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawMultiLineString = function(multiLineStringGeometry, feature) {};
    /**
     * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawMultiPoint = function(multiPointGeometry, feature) {};
    /**
     * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawMultiPolygon = function(multiPolygonGeometry, feature) {};
    /**
     * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawPoint = function(pointGeometry, feature) {};
    /**
     * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawPolygon = function(polygonGeometry, feature) {};
    /**
     * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawText = function(geometry, feature) {};
    /**
     * @param {import("../style/Fill.js").default} fillStyle Fill style.
     * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
     */ VectorContext.prototype.setFillStrokeStyle = function(fillStyle, strokeStyle) {};
    /**
     * @param {import("../style/Image.js").default} imageStyle Image style.
     * @param {import("../render/canvas.js").DeclutterImageWithText=} opt_declutterImageWithText Shared data for combined decluttering with a text style.
     */ VectorContext.prototype.setImageStyle = function(imageStyle, opt_declutterImageWithText) {};
    /**
     * @param {import("../style/Text.js").default} textStyle Text style.
     * @param {import("../render/canvas.js").DeclutterImageWithText=} opt_declutterImageWithText Shared data for combined decluttering with an image style.
     */ VectorContext.prototype.setTextStyle = function(textStyle, opt_declutterImageWithText) {};
    return VectorContext;
}();
var $eb0e5c3938110b4c$export$2e2bcd8739ae039 = $eb0e5c3938110b4c$var$VectorContext;







var $2bb20f8873deb436$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2bb20f8873deb436$var$CanvasBuilder = /** @class */ function(_super) {
    $2bb20f8873deb436$var$__extends(CanvasBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */ function CanvasBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        var _this = _super.call(this) || this;
        /**
         * @protected
         * @type {number}
         */ _this.tolerance = tolerance;
        /**
         * @protected
         * @const
         * @type {import("../../extent.js").Extent}
         */ _this.maxExtent = maxExtent;
        /**
         * @protected
         * @type {number}
         */ _this.pixelRatio = pixelRatio;
        /**
         * @protected
         * @type {number}
         */ _this.maxLineWidth = 0;
        /**
         * @protected
         * @const
         * @type {number}
         */ _this.resolution = resolution;
        /**
         * @private
         * @type {Array<*>}
         */ _this.beginGeometryInstruction1_ = null;
        /**
         * @private
         * @type {Array<*>}
         */ _this.beginGeometryInstruction2_ = null;
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */ _this.bufferedMaxExtent_ = null;
        /**
         * @protected
         * @type {Array<*>}
         */ _this.instructions = [];
        /**
         * @protected
         * @type {Array<number>}
         */ _this.coordinates = [];
        /**
         * @private
         * @type {import("../../coordinate.js").Coordinate}
         */ _this.tmpCoordinate_ = [];
        /**
         * @protected
         * @type {Array<*>}
         */ _this.hitDetectionInstructions = [];
        /**
         * @protected
         * @type {import("../canvas.js").FillStrokeState}
         */ _this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
        return _this;
    }
    /**
     * @protected
     * @param {Array<number>} dashArray Dash array.
     * @return {Array<number>} Dash array with pixel ratio applied
     */ CanvasBuilder.prototype.applyPixelRatio = function(dashArray) {
        var pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} stride Stride.
     * @protected
     * @return {number} My end
     */ CanvasBuilder.prototype.appendFlatPointCoordinates = function(flatCoordinates, stride) {
        var extent = this.getBufferedMaxExtent();
        var tmpCoord = this.tmpCoordinate_;
        var coordinates = this.coordinates;
        var myEnd = coordinates.length;
        for(var i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if ((0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @param {boolean} closed Last input coordinate equals first.
     * @param {boolean} skipFirst Skip first coordinate.
     * @protected
     * @return {number} My end.
     */ CanvasBuilder.prototype.appendFlatLineCoordinates = function(flatCoordinates, offset, end, stride, closed, skipFirst) {
        var coordinates = this.coordinates;
        var myEnd = coordinates.length;
        var extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        var lastXCoord = flatCoordinates[offset];
        var lastYCoord = flatCoordinates[offset + 1];
        var nextCoord = this.tmpCoordinate_;
        var skipped = true;
        var i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, $6da4c8ed3074c92b$export$f97905ead28c61a8)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            } else if (nextRel === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {Array<number>} ends Ends.
     * @param {number} stride Stride.
     * @param {Array<number>} builderEnds Builder ends.
     * @return {number} Offset.
     */ CanvasBuilder.prototype.drawCustomCoordinates_ = function(flatCoordinates, offset, ends, stride, builderEnds) {
        for(var i = 0, ii = ends.length; i < ii; ++i){
            var end = ends[i];
            var builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    };
    /**
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {Function} renderer Renderer.
     */ CanvasBuilder.prototype.drawCustom = function(geometry, feature, renderer) {
        this.beginGeometry(geometry, feature);
        var type = geometry.getType();
        var stride = geometry.getStride();
        var builderBegin = this.coordinates.length;
        var flatCoordinates, builderEnd, builderEnds, builderEndss;
        var offset;
        if (type == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POLYGON) {
            flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
            builderEndss = [];
            var endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
            offset = 0;
            for(var i = 0, ii = endss.length; i < ii; ++i){
                var myEnds = [];
                offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                builderEndss.push(myEnds);
            }
            this.instructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                builderBegin,
                builderEndss,
                geometry,
                renderer,
                (0, $5454470599558ddd$export$915c7058aeb4dfeb)
            ]);
        } else if (type == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON || type == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_LINE_STRING) {
            builderEnds = [];
            flatCoordinates = type == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
            offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
            this.instructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                builderBegin,
                builderEnds,
                geometry,
                renderer,
                (0, $5454470599558ddd$export$cbb9596fc0f40db2)
            ]);
        } else if (type == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING || type == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).CIRCLE) {
            flatCoordinates = geometry.getFlatCoordinates();
            builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
            this.instructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                builderBegin,
                builderEnd,
                geometry,
                renderer,
                (0, $5454470599558ddd$export$9c0934e4e9c3f61e)
            ]);
        } else if (type == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POINT) {
            flatCoordinates = geometry.getFlatCoordinates();
            builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (builderEnd > builderBegin) this.instructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                builderBegin,
                builderEnd,
                geometry,
                renderer,
                (0, $5454470599558ddd$export$9c0934e4e9c3f61e)
            ]);
        } else if (type == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POINT) {
            flatCoordinates = geometry.getFlatCoordinates();
            this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
            builderEnd = this.coordinates.length;
            this.instructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                builderBegin,
                builderEnd,
                geometry,
                renderer
            ]);
        }
        this.endGeometry(feature);
    };
    /**
     * @protected
     * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasBuilder.prototype.beginGeometry = function(geometry, feature) {
        this.beginGeometryInstruction1_ = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    };
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */ CanvasBuilder.prototype.finish = function() {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates
        };
    };
    /**
     * Reverse the hit detection instructions.
     */ CanvasBuilder.prototype.reverseHitDetectionInstructions = function() {
        var hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        var i;
        var n = hitDetectionInstructions.length;
        var instruction;
        var type;
        var begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ instruction[0];
            if (type == (0, $cf547866e052f25b$export$2e2bcd8739ae039).END_GEOMETRY) begin = i;
            else if (type == (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, $b998d41b678ed5d1$export$292cfa960964f0e0)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    };
    /**
     * @param {import("../../style/Fill.js").default} fillStyle Fill style.
     * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
     */ CanvasBuilder.prototype.setFillStrokeStyle = function(fillStyle, strokeStyle) {
        var state = this.state;
        if (fillStyle) {
            var fillStyleColor = fillStyle.getColor();
            state.fillStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2));
        } else state.fillStyle = undefined;
        if (strokeStyle) {
            var strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e));
            var strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
            var strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc);
            var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $d4aabc5c971073f1$export$e06efc2409049f76);
            var strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
            var strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $d4aabc5c971073f1$export$79661f132c62010e);
            var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $d4aabc5c971073f1$export$80c1c01844597b7b);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
        }
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     * @return {Array<*>} Fill instruction.
     */ CanvasBuilder.prototype.createFill = function(state) {
        var fillStyle = state.fillStyle;
        /** @type {Array<*>} */ var fillInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== 'string') // Fill is a pattern or gradient - align it!
        fillInstruction.push(true);
        return fillInstruction;
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     */ CanvasBuilder.prototype.applyStroke = function(state) {
        this.instructions.push(this.createStroke(state));
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     * @return {Array<*>} Stroke instruction.
     */ CanvasBuilder.prototype.createStroke = function(state) {
        return [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            this.applyPixelRatio(state.lineDash),
            state.lineDashOffset * this.pixelRatio
        ];
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
     */ CanvasBuilder.prototype.updateFillStyle = function(state, createFill) {
        var fillStyle = state.fillStyle;
        if (typeof fillStyle !== 'string' || state.currentFillStyle != fillStyle) {
            if (fillStyle !== undefined) this.instructions.push(createFill.call(this, state));
            state.currentFillStyle = fillStyle;
        }
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
     */ CanvasBuilder.prototype.updateStrokeStyle = function(state, applyStroke) {
        var strokeStyle = state.strokeStyle;
        var lineCap = state.lineCap;
        var lineDash = state.lineDash;
        var lineDashOffset = state.lineDashOffset;
        var lineJoin = state.lineJoin;
        var lineWidth = state.lineWidth;
        var miterLimit = state.miterLimit;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit) {
            if (strokeStyle !== undefined) applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
        }
    };
    /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasBuilder.prototype.endGeometry = function(feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        var endGeometryInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    };
    /**
     * Get the buffered rendering extent.  Rendering will be clipped to the extent
     * provided to the constructor.  To account for symbolizers that may intersect
     * this extent, we calculate a buffered extent (e.g. based on stroke width).
     * @return {import("../../extent.js").Extent} The buffered rendering extent.
     * @protected
     */ CanvasBuilder.prototype.getBufferedMaxExtent = function() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, $6da4c8ed3074c92b$export$9cd59f9826255e47)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                var width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    };
    return CanvasBuilder;
}((0, $eb0e5c3938110b4c$export$2e2bcd8739ae039));
var $2bb20f8873deb436$export$2e2bcd8739ae039 = $2bb20f8873deb436$var$CanvasBuilder;




var $b652f9dd73b29cfe$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b652f9dd73b29cfe$var$CanvasImageBuilder = /** @class */ function(_super) {
    $b652f9dd73b29cfe$var$__extends(CanvasImageBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */ function CanvasImageBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        var _this = _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
         */ _this.hitDetectionImage_ = null;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
         */ _this.image_ = null;
        /**
         * @private
         * @type {number|undefined}
         */ _this.imagePixelRatio_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.anchorX_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.anchorY_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.height_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.opacity_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.originX_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.originY_ = undefined;
        /**
         * @private
         * @type {boolean|undefined}
         */ _this.rotateWithView_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.rotation_ = undefined;
        /**
         * @private
         * @type {import("../../size.js").Size|undefined}
         */ _this.scale_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.width_ = undefined;
        /**
         * Data shared with a text builder for combined decluttering.
         * @private
         * @type {import("../canvas.js").DeclutterImageWithText}
         */ _this.declutterImageWithText_ = undefined;
        return _this;
    }
    /**
     * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasImageBuilder.prototype.drawPoint = function(pointGeometry, feature) {
        if (!this.image_) return;
        this.beginGeometry(pointGeometry, feature);
        var flatCoordinates = pointGeometry.getFlatCoordinates();
        var stride = pointGeometry.getStride();
        var myBegin = this.coordinates.length;
        var myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    };
    /**
     * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasImageBuilder.prototype.drawMultiPoint = function(multiPointGeometry, feature) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature);
        var flatCoordinates = multiPointGeometry.getFlatCoordinates();
        var stride = multiPointGeometry.getStride();
        var myBegin = this.coordinates.length;
        var myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    };
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */ CanvasImageBuilder.prototype.finish = function() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return _super.prototype.finish.call(this);
    };
    /**
     * @param {import("../../style/Image.js").default} imageStyle Image style.
     * @param {Object=} opt_sharedData Shared data.
     */ CanvasImageBuilder.prototype.setImageStyle = function(imageStyle, opt_sharedData) {
        var anchor = imageStyle.getAnchor();
        var size = imageStyle.getSize();
        var hitDetectionImage = imageStyle.getHitDetectionImage();
        var image = imageStyle.getImage(this.pixelRatio);
        var origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = hitDetectionImage;
        this.image_ = image;
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterImageWithText_ = opt_sharedData;
    };
    return CanvasImageBuilder;
}((0, $2bb20f8873deb436$export$2e2bcd8739ae039));
var $b652f9dd73b29cfe$export$2e2bcd8739ae039 = $b652f9dd73b29cfe$var$CanvasImageBuilder;




var $a207f23baa5aa2c5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a207f23baa5aa2c5$var$CanvasLineStringBuilder = /** @class */ function(_super) {
    $a207f23baa5aa2c5$var$__extends(CanvasLineStringBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */ function CanvasLineStringBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        return _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
    }
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @private
     * @return {number} end.
     */ CanvasLineStringBuilder.prototype.drawFlatCoordinates_ = function(flatCoordinates, offset, end, stride) {
        var myBegin = this.coordinates.length;
        var myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        var moveToLineToInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
            myBegin,
            myEnd
        ];
        this.instructions.push(moveToLineToInstruction);
        this.hitDetectionInstructions.push(moveToLineToInstruction);
        return end;
    };
    /**
     * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasLineStringBuilder.prototype.drawLineString = function(lineStringGeometry, feature) {
        var state = this.state;
        var strokeStyle = state.strokeStyle;
        var lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ], (0, $cf547866e052f25b$export$9f746cc58a899a00));
        var flatCoordinates = lineStringGeometry.getFlatCoordinates();
        var stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    };
    /**
     * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasLineStringBuilder.prototype.drawMultiLineString = function(multiLineStringGeometry, feature) {
        var state = this.state;
        var strokeStyle = state.strokeStyle;
        var lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ], (0, $cf547866e052f25b$export$9f746cc58a899a00));
        var ends = multiLineStringGeometry.getEnds();
        var flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        var stride = multiLineStringGeometry.getStride();
        var offset = 0;
        for(var i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride);
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    };
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */ CanvasLineStringBuilder.prototype.finish = function() {
        var state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        this.reverseHitDetectionInstructions();
        this.state = null;
        return _super.prototype.finish.call(this);
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     */ CanvasLineStringBuilder.prototype.applyStroke = function(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        _super.prototype.applyStroke.call(this, state);
        this.instructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00));
    };
    return CanvasLineStringBuilder;
}((0, $2bb20f8873deb436$export$2e2bcd8739ae039));
var $a207f23baa5aa2c5$export$2e2bcd8739ae039 = $a207f23baa5aa2c5$var$CanvasLineStringBuilder;






var $7d2e8ba11a45ae8a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7d2e8ba11a45ae8a$var$CanvasPolygonBuilder = /** @class */ function(_super) {
    $7d2e8ba11a45ae8a$var$__extends(CanvasPolygonBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */ function CanvasPolygonBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        return _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
    }
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {Array<number>} ends Ends.
     * @param {number} stride Stride.
     * @private
     * @return {number} End.
     */ CanvasPolygonBuilder.prototype.drawFlatCoordinatess_ = function(flatCoordinates, offset, ends, stride) {
        var state = this.state;
        var fill = state.fillStyle !== undefined;
        var stroke = state.strokeStyle !== undefined;
        var numEnds = ends.length;
        this.instructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00));
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00));
        for(var i = 0; i < numEnds; ++i){
            var end = ends[i];
            var myBegin = this.coordinates.length;
            var myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            var moveToLineToInstruction = [
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                myBegin,
                myEnd
            ];
            this.instructions.push(moveToLineToInstruction);
            this.hitDetectionInstructions.push(moveToLineToInstruction);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push((0, $cf547866e052f25b$export$89b10f327e413e71));
                this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$89b10f327e413e71));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, $cf547866e052f25b$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$f21891651e408226));
        }
        if (stroke) {
            this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        }
        return offset;
    };
    /**
     * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
     * @param {import("../../Feature.js").default} feature Feature.
     */ CanvasPolygonBuilder.prototype.drawCircle = function(circleGeometry, feature) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        var strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ]);
        var flatCoordinates = circleGeometry.getFlatCoordinates();
        var stride = circleGeometry.getStride();
        var myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        var circleInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).CIRCLE,
            myBegin
        ];
        this.instructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00), circleInstruction);
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00), circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push((0, $cf547866e052f25b$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$f21891651e408226));
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        }
        this.endGeometry(feature);
    };
    /**
     * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasPolygonBuilder.prototype.drawPolygon = function(polygonGeometry, feature) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        var strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ]);
        var ends = polygonGeometry.getEnds();
        var flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        var stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride);
        this.endGeometry(feature);
    };
    /**
     * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasPolygonBuilder.prototype.drawMultiPolygon = function(multiPolygonGeometry, feature) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        var strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ]);
        var endss = multiPolygonGeometry.getEndss();
        var flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        var stride = multiPolygonGeometry.getStride();
        var offset = 0;
        for(var i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
        this.endGeometry(feature);
    };
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */ CanvasPolygonBuilder.prototype.finish = function() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        var tolerance = this.tolerance;
        if (tolerance !== 0) {
            var coordinates = this.coordinates;
            for(var i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $8780aae6970f5f65$export$51a0620f7a28532b)(coordinates[i], tolerance);
        }
        return _super.prototype.finish.call(this);
    };
    /**
     * @private
     */ CanvasPolygonBuilder.prototype.setFillStrokeStyles_ = function() {
        var state = this.state;
        var fillStyle = state.fillStyle;
        if (fillStyle !== undefined) this.updateFillStyle(state, this.createFill);
        if (state.strokeStyle !== undefined) this.updateStrokeStyle(state, this.applyStroke);
    };
    return CanvasPolygonBuilder;
}((0, $2bb20f8873deb436$export$2e2bcd8739ae039));
var $7d2e8ba11a45ae8a$export$2e2bcd8739ae039 = $7d2e8ba11a45ae8a$var$CanvasPolygonBuilder;





/**
 * @module ol/style/TextPlacement
 */ /**
 * Text placement. One of `'point'`, `'line'`. Default is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 * @enum {string}
 */ var $27569314e3df91c2$export$2e2bcd8739ae039 = {
    POINT: 'point',
    LINE: 'line'
};






/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $79529ab61b92f869$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    var chunkStart = offset;
    var chunkEnd = offset;
    var chunkM = 0;
    var m = 0;
    var start = offset;
    var acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        var x2 = flatCoordinates[i];
        var y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}


var $8243e906fae47bbe$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8243e906fae47bbe$export$91a016276e4aee96 = {
    'left': 0,
    'end': 0,
    'center': 0.5,
    'right': 1,
    'start': 1,
    'top': 0,
    'middle': 0.5,
    'hanging': 0.2,
    'alphabetic': 0.8,
    'ideographic': 0.8,
    'bottom': 1
};
var $8243e906fae47bbe$var$CanvasTextBuilder = /** @class */ function(_super) {
    $8243e906fae47bbe$var$__extends(CanvasTextBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */ function CanvasTextBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        var _this = _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
        /**
         * @private
         * @type {Array<HTMLCanvasElement>}
         */ _this.labels_ = null;
        /**
         * @private
         * @type {string}
         */ _this.text_ = '';
        /**
         * @private
         * @type {number}
         */ _this.textOffsetX_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.textOffsetY_ = 0;
        /**
         * @private
         * @type {boolean|undefined}
         */ _this.textRotateWithView_ = undefined;
        /**
         * @private
         * @type {number}
         */ _this.textRotation_ = 0;
        /**
         * @private
         * @type {?import("../canvas.js").FillState}
         */ _this.textFillState_ = null;
        /**
         * @type {!Object<string, import("../canvas.js").FillState>}
         */ _this.fillStates = {};
        /**
         * @private
         * @type {?import("../canvas.js").StrokeState}
         */ _this.textStrokeState_ = null;
        /**
         * @type {!Object<string, import("../canvas.js").StrokeState>}
         */ _this.strokeStates = {};
        /**
         * @private
         * @type {import("../canvas.js").TextState}
         */ _this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
         * @type {!Object<string, import("../canvas.js").TextState>}
         */ _this.textStates = {};
        /**
         * @private
         * @type {string}
         */ _this.textKey_ = '';
        /**
         * @private
         * @type {string}
         */ _this.fillKey_ = '';
        /**
         * @private
         * @type {string}
         */ _this.strokeKey_ = '';
        /**
         * Data shared with an image builder for combined decluttering.
         * @private
         * @type {import("../canvas.js").DeclutterImageWithText}
         */ _this.declutterImageWithText_ = undefined;
        return _this;
    }
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */ CanvasTextBuilder.prototype.finish = function() {
        var instructions = _super.prototype.finish.call(this);
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    };
    /**
     * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasTextBuilder.prototype.drawText = function(geometry, feature) {
        var fillState = this.textFillState_;
        var strokeState = this.textStrokeState_;
        var textState = this.textState_;
        if (this.text_ === '' || !textState || !fillState && !strokeState) return;
        var coordinates = this.coordinates;
        var begin = coordinates.length;
        var geometryType = geometry.getType();
        var flatCoordinates = null;
        var stride = geometry.getStride();
        if (textState.placement === (0, $27569314e3df91c2$export$2e2bcd8739ae039).LINE && (geometryType == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING || geometryType == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_LINE_STRING || geometryType == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON || geometryType == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POLYGON)) {
            if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.getBufferedMaxExtent(), geometry.getExtent())) return;
            var ends = void 0;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING) ends = [
                flatCoordinates.length
            ];
            else if (geometryType == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_LINE_STRING) ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
            else if (geometryType == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON) ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
            else if (geometryType == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POLYGON) {
                var endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                ends = [];
                for(var i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            this.beginGeometry(geometry, feature);
            var textAlign = textState.textAlign;
            var flatOffset = 0;
            var flatEnd = void 0;
            for(var o = 0, oo = ends.length; o < oo; ++o){
                if (textAlign == undefined) {
                    var range = (0, $79529ab61b92f869$export$ed6c897eea07a254)(textState.maxAngle, flatCoordinates, flatOffset, ends[o], stride);
                    flatOffset = range[0];
                    flatEnd = range[1];
                } else flatEnd = ends[o];
                for(var i = flatOffset; i < flatEnd; i += stride)coordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
                var end = coordinates.length;
                flatOffset = ends[o];
                this.drawChars_(begin, end);
                begin = end;
            }
            this.endGeometry(feature);
        } else {
            var geometryWidths = textState.overflow ? null : [];
            switch(geometryType){
                case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POINT:
                case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POINT:
                    flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                    break;
                case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING:
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).CIRCLE:
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_LINE_STRING:
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    stride = 2;
                    break;
                case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON:
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                    stride = 3;
                    break;
                case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POLYGON:
                    var interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(var i = 0, ii = interiorPoints.length; i < ii; i += 3){
                        if (!textState.overflow) geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) return;
                    stride = 2;
                    break;
                default:
            }
            var end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) return;
            this.saveTextStates_();
            if (textState.backgroundFill || textState.backgroundStroke) {
                this.setFillStrokeStyle(textState.backgroundFill, textState.backgroundStroke);
                if (textState.backgroundFill) {
                    this.updateFillStyle(this.state, this.createFill);
                    this.hitDetectionInstructions.push(this.createFill(this.state));
                }
                if (textState.backgroundStroke) {
                    this.updateStrokeStyle(this.state, this.applyStroke);
                    this.hitDetectionInstructions.push(this.createStroke(this.state));
                }
            }
            this.beginGeometry(geometry, feature);
            // adjust padding for negative scale
            var padding = textState.padding;
            if (padding != (0, $d4aabc5c971073f1$export$40a9eeef55665a40) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                var p0 = textState.padding[0];
                var p1 = textState.padding[1];
                var p2 = textState.padding[2];
                var p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [
                    p0,
                    p1,
                    p2,
                    p3
                ];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            var pixelRatio_1 = this.pixelRatio;
            this.instructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    1,
                    1
                ],
                NaN,
                this.declutterImageWithText_,
                padding == (0, $d4aabc5c971073f1$export$40a9eeef55665a40) ? (0, $d4aabc5c971073f1$export$40a9eeef55665a40) : padding.map(function(p) {
                    return p * pixelRatio_1;
                }),
                !!textState.backgroundFill,
                !!textState.backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            var scale = 1 / pixelRatio_1;
            this.hitDetectionInstructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    scale,
                    scale
                ],
                NaN,
                this.declutterImageWithText_,
                padding,
                !!textState.backgroundFill,
                !!textState.backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            this.endGeometry(feature);
        }
    };
    /**
     * @private
     */ CanvasTextBuilder.prototype.saveTextStates_ = function() {
        var strokeState = this.textStrokeState_;
        var textState = this.textState_;
        var fillState = this.textFillState_;
        var strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        var textKey = this.textKey_;
        if (!(textKey in this.textStates)) this.textStates[textKey] = {
            font: textState.font,
            textAlign: textState.textAlign || (0, $d4aabc5c971073f1$export$94d53b95641b5766),
            textBaseline: textState.textBaseline || (0, $d4aabc5c971073f1$export$cf2279a1bff62eb),
            scale: textState.scale
        };
        var fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                fillStyle: fillState.fillStyle
            };
        }
    };
    /**
     * @private
     * @param {number} begin Begin.
     * @param {number} end End.
     */ CanvasTextBuilder.prototype.drawChars_ = function(begin, end) {
        var strokeState = this.textStrokeState_;
        var textState = this.textState_;
        var strokeKey = this.strokeKey_;
        var textKey = this.textKey_;
        var fillKey = this.fillKey_;
        this.saveTextStates_();
        var pixelRatio = this.pixelRatio;
        var baseline = $8243e906fae47bbe$export$91a016276e4aee96[textState.textBaseline];
        var offsetY = this.textOffsetY_ * pixelRatio;
        var text = this.text_;
        var strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
        this.instructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1
        ]);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            1,
            offsetY,
            strokeKey,
            strokeWidth,
            text,
            textKey,
            1 / pixelRatio
        ]);
    };
    /**
     * @param {import("../../style/Text.js").default} textStyle Text style.
     * @param {Object=} opt_sharedData Shared data.
     */ CanvasTextBuilder.prototype.setTextStyle = function(textStyle, opt_sharedData) {
        var textState, fillState, strokeState;
        if (!textStyle) this.text_ = '';
        else {
            var textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            } else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ {};
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textFillStyle.getColor() || (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2));
            }
            var textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            } else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                    this.textStrokeState_ = strokeState;
                }
                var lineDash = textStrokeStyle.getLineDash();
                var lineDashOffset = textStrokeStyle.getLineDashOffset();
                var lineWidth = textStrokeStyle.getWidth();
                var miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $d4aabc5c971073f1$export$e06efc2409049f76) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
                strokeState.lineWidth = lineWidth === undefined ? (0, $d4aabc5c971073f1$export$79661f132c62010e) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, $d4aabc5c971073f1$export$80c1c01844597b7b) : miterLimit;
                strokeState.strokeStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textStrokeStyle.getColor() || (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e));
            }
            textState = this.textState_;
            var font = textStyle.getFont() || (0, $d4aabc5c971073f1$export$3847dfea4f8d4dfa);
            (0, $d4aabc5c971073f1$export$a534074a28fa87ff)(font);
            var textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.textBaseline = textStyle.getTextBaseline() || (0, $d4aabc5c971073f1$export$cf2279a1bff62eb);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, $d4aabc5c971073f1$export$40a9eeef55665a40);
            textState.scale = textScale === undefined ? [
                1,
                1
            ] : textScale;
            var textOffsetX = textStyle.getOffsetX();
            var textOffsetY = textStyle.getOffsetY();
            var textRotateWithView = textStyle.getRotateWithView();
            var textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || '';
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : (0, $6c5e11070e371322$export$5e82334337e0f204)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' : '';
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?') + (textState.textBaseline || '?');
            this.fillKey_ = fillState ? typeof fillState.fillStyle == 'string' ? fillState.fillStyle : '|' + (0, $6c5e11070e371322$export$5e82334337e0f204)(fillState.fillStyle) : '';
        }
        this.declutterImageWithText_ = opt_sharedData;
    };
    return CanvasTextBuilder;
}((0, $2bb20f8873deb436$export$2e2bcd8739ae039));
var $8243e906fae47bbe$export$2e2bcd8739ae039 = $8243e906fae47bbe$var$CanvasTextBuilder;


/**
 * @type {Object<import("./BuilderType").default, typeof Builder>}
 */ var $e22658f4b743550b$var$BATCH_CONSTRUCTORS = {
    'Circle': (0, $7d2e8ba11a45ae8a$export$2e2bcd8739ae039),
    'Default': (0, $2bb20f8873deb436$export$2e2bcd8739ae039),
    'Image': (0, $b652f9dd73b29cfe$export$2e2bcd8739ae039),
    'LineString': (0, $a207f23baa5aa2c5$export$2e2bcd8739ae039),
    'Polygon': (0, $7d2e8ba11a45ae8a$export$2e2bcd8739ae039),
    'Text': (0, $8243e906fae47bbe$export$2e2bcd8739ae039)
};
var $e22658f4b743550b$var$BuilderGroup = /** @class */ function() {
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Max extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */ function BuilderGroup(tolerance, maxExtent, resolution, pixelRatio) {
        /**
         * @private
         * @type {number}
         */ this.tolerance_ = tolerance;
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */ this.maxExtent_ = maxExtent;
        /**
         * @private
         * @type {number}
         */ this.pixelRatio_ = pixelRatio;
        /**
         * @private
         * @type {number}
         */ this.resolution_ = resolution;
        /**
         * @private
         * @type {!Object<string, !Object<import("./BuilderType").default, Builder>>}
         */ this.buildersByZIndex_ = {};
    }
    /**
     * @return {!Object<string, !Object<import("./BuilderType").default, import("./Builder.js").SerializableInstructions>>} The serializable instructions
     */ BuilderGroup.prototype.finish = function() {
        var builderInstructions = {};
        for(var zKey in this.buildersByZIndex_){
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            var builders = this.buildersByZIndex_[zKey];
            for(var builderKey in builders){
                var builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    };
    /**
     * @param {number|undefined} zIndex Z index.
     * @param {import("./BuilderType.js").default} builderType Replay type.
     * @return {import("../VectorContext.js").default} Replay.
     */ BuilderGroup.prototype.getBuilder = function(zIndex, builderType) {
        var zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
        var replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        var replay = replays[builderType];
        if (replay === undefined) {
            var Constructor = $e22658f4b743550b$var$BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    };
    return BuilderGroup;
}();
var $e22658f4b743550b$export$2e2bcd8739ae039 = $e22658f4b743550b$var$BuilderGroup;



/**
 * @module ol/render/canvas/ExecutorGroup
 */ /**
 * @module ol/render/canvas/BuilderType
 */ /**
 * @enum {string}
 */ var $e74ccf0666398498$export$2e2bcd8739ae039 = {
    CIRCLE: 'Circle',
    DEFAULT: 'Default',
    IMAGE: 'Image',
    LINE_STRING: 'LineString',
    POLYGON: 'Polygon',
    TEXT: 'Text'
};


/**
 * @module ol/render/canvas/Executor
 */ 





/**
 * @module ol/geom/flat/textpath
 */ 

function $f6421f31729929e6$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation) {
    var x2 = flatCoordinates[offset];
    var y2 = flatCoordinates[offset + 1];
    var x1 = 0;
    var y1 = 0;
    var segmentLength = 0;
    var segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    var interpolate = (startM - segmentM) / segmentLength;
    var beginX = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    var beginY = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    var startOffset = offset - stride;
    var startLength = segmentM;
    var endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = (endM - segmentM) / segmentLength;
    var endX = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    var endY = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    // Keep text upright
    var reverse;
    if (rotation) {
        var flat = [
            beginX,
            beginY,
            endX,
            endY
        ];
        (0, $14c6e714516e527b$export$bb628a54ab399bc9)(flat, 0, 4, 2, rotation, flat, flat);
        reverse = flat[0] > flat[2];
    } else reverse = beginX > endX;
    var PI = Math.PI;
    var result = [];
    var singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    // All on the same segment
    if (singleSegment) {
        advance();
        var previousAngle_1 = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle_1 += previousAngle_1 > 0 ? -PI : PI;
        var x = (endX + beginX) / 2;
        var y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle_1,
            text
        ];
        return result;
    }
    var previousAngle;
    for(var i = 0, ii = text.length; i < ii;){
        advance();
        var angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            var delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        var iStart = i;
        var charLength = 0;
        for(; i < ii; ++i){
            var index = reverse ? ii - i - 1 : i;
            var len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        var chars = reverse ? text.substring(ii - iStart, ii - i) : text.substring(iStart, i);
        interpolate = (startM + charLength / 2 - segmentM) / segmentLength;
        var x = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
        var y = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
        result.push([
            x,
            y,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}



/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $bf04349d827c1d16$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    var length = 0;
    for(var i = offset + stride; i < end; i += stride){
        var x2 = flatCoordinates[i];
        var y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $bf04349d827c1d16$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    var perimeter = $bf04349d827c1d16$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    var dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    var dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}



/**
 * @typedef {Object} BBox
 * @property {number} minX
 * @property {number} minY
 * @property {number} maxX
 * @property {number} maxY
 * @property {*} value
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX
 * @property {number} drawImageY
 * @property {number} drawImageW
 * @property {number} drawImageH
 * @property {number} originX
 * @property {number} originY
 * @property {Array<number>} scale
 * @property {BBox} declutterBox
 * @property {import("../../transform.js").Transform} canvasTransform
 */ /**
 * @typedef {{0: CanvasRenderingContext2D, 1: number, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ var $6526fa4ee42dc39d$var$tmpExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
/** @type {import("../../coordinate.js").Coordinate} */ var $6526fa4ee42dc39d$var$p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ var $6526fa4ee42dc39d$var$p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ var $6526fa4ee42dc39d$var$p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ var $6526fa4ee42dc39d$var$p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {BBox} Declutter bbox.
 */ function $6526fa4ee42dc39d$var$getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
var $6526fa4ee42dc39d$var$rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ '[' + String.fromCharCode(0x00591) + '-' + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + '-' + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + '-' + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + '-' + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + '-' + String.fromCharCode(0x1efff) + ']');
/**
 * @param {string} text Text.
 * @param {string} align Alignment.
 * @return {number} Text alignment.
 */ function $6526fa4ee42dc39d$var$horizontalTextAlign(text, align) {
    if ((align === 'start' || align === 'end') && !$6526fa4ee42dc39d$var$rtlRegEx.test(text)) align = align === 'start' ? 'left' : 'right';
    return (0, $8243e906fae47bbe$export$91a016276e4aee96)[align];
}
var $6526fa4ee42dc39d$var$Executor = /** @class */ function() {
    /**
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {boolean} overlaps The replay can have overlapping geometries.
     * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions
     * @param {import("../../size.js").Size} renderBuffer Render buffer (width/height) in pixels.
     */ function Executor(resolution, pixelRatio, overlaps, instructions, renderBuffer) {
        /**
         * @protected
         * @type {boolean}
         */ this.overlaps = overlaps;
        /**
         * @protected
         * @type {number}
         */ this.pixelRatio = pixelRatio;
        /**
         * @protected
         * @const
         * @type {number}
         */ this.resolution = resolution;
        /**
         * @private
         * @type {boolean}
         */ this.alignFill_;
        /**
         * @protected
         * @type {Array<*>}
         */ this.instructions = instructions.instructions;
        /**
         * @protected
         * @type {Array<number>}
         */ this.coordinates = instructions.coordinates;
        /**
         * @private
         * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
         */ this.coordinateCache_ = {};
        /**
         * @private
         * @type {import("../../size.js").Size}
         */ this.renderBuffer_ = renderBuffer;
        /**
         * @private
         * @type {!import("../../transform.js").Transform}
         */ this.renderedTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
         * @protected
         * @type {Array<*>}
         */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
         * @private
         * @type {Array<number>}
         */ this.pixelCoordinates_ = null;
        /**
         * @private
         * @type {number}
         */ this.viewRotation_ = 0;
        /**
         * @type {!Object<string, import("../canvas.js").FillState>}
         */ this.fillStates = instructions.fillStates || {};
        /**
         * @type {!Object<string, import("../canvas.js").StrokeState>}
         */ this.strokeStates = instructions.strokeStates || {};
        /**
         * @type {!Object<string, import("../canvas.js").TextState>}
         */ this.textStates = instructions.textStates || {};
        /**
         * @private
         * @type {Object<string, Object<string, number>>}
         */ this.widths_ = {};
        /**
         * @private
         * @type {Object<string, import("../canvas.js").Label>}
         */ this.labels_ = {};
    }
    /**
     * @param {string} text Text.
     * @param {string} textKey Text style key.
     * @param {string} fillKey Fill style key.
     * @param {string} strokeKey Stroke style key.
     * @return {import("../canvas.js").Label} Label.
     */ Executor.prototype.createLabel = function(text, textKey, fillKey, strokeKey) {
        var key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) return this.labels_[key];
        var strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        var fillState = fillKey ? this.fillStates[fillKey] : null;
        var textState = this.textStates[textKey];
        var pixelRatio = this.pixelRatio;
        var scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio
        ];
        var align = $6526fa4ee42dc39d$var$horizontalTextAlign(text, textState.textAlign || (0, $d4aabc5c971073f1$export$94d53b95641b5766));
        var strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        var lines = text.split('\n');
        var numLines = lines.length;
        var widths = [];
        var width = (0, $d4aabc5c971073f1$export$a539decdd6096c57)(textState.font, lines, widths);
        var lineHeight = (0, $d4aabc5c971073f1$export$4feaf6852ff92513)(textState.font);
        var height = lineHeight * numLines;
        var renderWidth = width + strokeWidth;
        var contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        var w = (renderWidth + 2) * scale[0];
        var h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */ var label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions
        };
        if (scale[0] != 1 || scale[1] != 1) contextInstructions.push('scale', scale);
        contextInstructions.push('font', textState.font);
        if (strokeKey) {
            contextInstructions.push('strokeStyle', strokeState.strokeStyle);
            contextInstructions.push('lineWidth', strokeWidth);
            contextInstructions.push('lineCap', strokeState.lineCap);
            contextInstructions.push('lineJoin', strokeState.lineJoin);
            contextInstructions.push('miterLimit', strokeState.miterLimit);
            // eslint-disable-next-line
            var Context = (0, $67c66761d21428d0$export$98fcef3dc9973292) ? OffscreenCanvasRenderingContext2D : CanvasRenderingContext2D;
            if (Context.prototype.setLineDash) {
                contextInstructions.push('setLineDash', [
                    strokeState.lineDash
                ]);
                contextInstructions.push('lineDashOffset', strokeState.lineDashOffset);
            }
        }
        if (fillKey) contextInstructions.push('fillStyle', fillState.fillStyle);
        contextInstructions.push('textBaseline', 'middle');
        contextInstructions.push('textAlign', 'center');
        var leftRight = 0.5 - align;
        var x = align * renderWidth + leftRight * strokeWidth;
        var i;
        if (strokeKey) for(i = 0; i < numLines; ++i)contextInstructions.push('strokeText', [
            lines[i],
            x + leftRight * widths[i],
            0.5 * (strokeWidth + lineHeight) + i * lineHeight
        ]);
        if (fillKey) for(i = 0; i < numLines; ++i)contextInstructions.push('fillText', [
            lines[i],
            x + leftRight * widths[i],
            0.5 * (strokeWidth + lineHeight) + i * lineHeight
        ]);
        this.labels_[key] = label;
        return label;
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
     * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
     * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
     * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
     * @param {Array<*>} fillInstruction Fill instruction.
     * @param {Array<*>} strokeInstruction Stroke instruction.
     */ Executor.prototype.replayTextBackground_ = function(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignFill_ = /** @type {boolean} */ fillInstruction[2];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    };
    /**
     * @private
     * @param {number} sheetWidth Width of the sprite sheet.
     * @param {number} sheetHeight Height of the sprite sheet.
     * @param {number} centerX X.
     * @param {number} centerY Y.
     * @param {number} width Width.
     * @param {number} height Height.
     * @param {number} anchorX Anchor X.
     * @param {number} anchorY Anchor Y.
     * @param {number} originX Origin X.
     * @param {number} originY Origin Y.
     * @param {number} rotation Rotation.
     * @param {import("../../size.js").Size} scale Scale.
     * @param {boolean} snapToPixel Snap to pixel.
     * @param {Array<number>} padding Padding.
     * @param {boolean} fillStroke Background fill or stroke.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
     */ Executor.prototype.calculateImageOrLabelDimensions_ = function(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        var x = centerX - anchorX;
        var y = centerY - anchorY;
        var w = width + originX > sheetWidth ? sheetWidth - originX : width;
        var h = height + originY > sheetHeight ? sheetHeight - originY : height;
        var boxW = padding[3] + w * scale[0] + padding[1];
        var boxH = padding[0] + h * scale[1] + padding[2];
        var boxX = x - padding[3];
        var boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            $6526fa4ee42dc39d$var$p1[0] = boxX;
            $6526fa4ee42dc39d$var$p4[0] = boxX;
            $6526fa4ee42dc39d$var$p1[1] = boxY;
            $6526fa4ee42dc39d$var$p2[1] = boxY;
            $6526fa4ee42dc39d$var$p2[0] = boxX + boxW;
            $6526fa4ee42dc39d$var$p3[0] = $6526fa4ee42dc39d$var$p2[0];
            $6526fa4ee42dc39d$var$p3[1] = boxY + boxH;
            $6526fa4ee42dc39d$var$p4[1] = $6526fa4ee42dc39d$var$p3[1];
        }
        var transform;
        if (rotation !== 0) {
            transform = (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)((0, $e22e7611e69f42a9$export$185802fd694ee1f5)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p1);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p2);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p3);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p4);
            (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(Math.min($6526fa4ee42dc39d$var$p1[0], $6526fa4ee42dc39d$var$p2[0], $6526fa4ee42dc39d$var$p3[0], $6526fa4ee42dc39d$var$p4[0]), Math.min($6526fa4ee42dc39d$var$p1[1], $6526fa4ee42dc39d$var$p2[1], $6526fa4ee42dc39d$var$p3[1], $6526fa4ee42dc39d$var$p4[1]), Math.max($6526fa4ee42dc39d$var$p1[0], $6526fa4ee42dc39d$var$p2[0], $6526fa4ee42dc39d$var$p3[0], $6526fa4ee42dc39d$var$p4[0]), Math.max($6526fa4ee42dc39d$var$p1[1], $6526fa4ee42dc39d$var$p2[1], $6526fa4ee42dc39d$var$p3[1], $6526fa4ee42dc39d$var$p4[1]), $6526fa4ee42dc39d$var$tmpExtent);
        } else (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), $6526fa4ee42dc39d$var$tmpExtent);
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: $6526fa4ee42dc39d$var$tmpExtent[0],
                minY: $6526fa4ee42dc39d$var$tmpExtent[1],
                maxX: $6526fa4ee42dc39d$var$tmpExtent[2],
                maxY: $6526fa4ee42dc39d$var$tmpExtent[3],
                value: feature
            },
            canvasTransform: transform,
            scale: scale
        };
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} contextScale Scale of the context.
     * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
     * @param {ImageOrLabelDimensions} dimensions Dimensions.
     * @param {number} opacity Opacity.
     * @param {Array<*>} fillInstruction Fill instruction.
     * @param {Array<*>} strokeInstruction Stroke instruction.
     * @return {boolean} The image or label was rendered.
     */ Executor.prototype.replayImageOrLabel_ = function(context, contextScale, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        var fillStroke = !!(fillInstruction || strokeInstruction);
        var box = dimensions.declutterBox;
        var canvas = context.canvas;
        var strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
        var intersects = box.minX - strokePadding <= canvas.width / contextScale && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= canvas.height / contextScale && box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, $6526fa4ee42dc39d$var$p1, $6526fa4ee42dc39d$var$p2, $6526fa4ee42dc39d$var$p3, $6526fa4ee42dc39d$var$p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, $d4aabc5c971073f1$export$3cb6f3a6e49cc0ee)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context Context.
     */ Executor.prototype.fill_ = function(context) {
        if (this.alignFill_) {
            var origin_1 = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(this.renderedTransform_, [
                0,
                0
            ]);
            var repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin_1[0] % repeatSize, origin_1[1] % repeatSize);
            context.rotate(this.viewRotation_);
        }
        context.fill();
        if (this.alignFill_) context.restore();
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context Context.
     * @param {Array<*>} instruction Instruction.
     */ Executor.prototype.setStrokeStyle_ = function(context, instruction) {
        context['strokeStyle'] = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        if (context.setLineDash) {
            context.lineDashOffset = /** @type {number} */ instruction[7];
            context.setLineDash(/** @type {Array<number>} */ instruction[6]);
        }
    };
    /**
     * @private
     * @param {string} text The text to draw.
     * @param {string} textKey The key of the text state.
     * @param {string} strokeKey The key for the stroke state.
     * @param {string} fillKey The key for the fill state.
     * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
     */ Executor.prototype.drawLabelWithPointPlacement_ = function(text, textKey, strokeKey, fillKey) {
        var textState = this.textStates[textKey];
        var label = this.createLabel(text, textKey, fillKey, strokeKey);
        var strokeState = this.strokeStates[strokeKey];
        var pixelRatio = this.pixelRatio;
        var align = $6526fa4ee42dc39d$var$horizontalTextAlign(text, textState.textAlign || (0, $d4aabc5c971073f1$export$94d53b95641b5766));
        var baseline = (0, $8243e906fae47bbe$export$91a016276e4aee96)[textState.textBaseline || (0, $d4aabc5c971073f1$export$cf2279a1bff62eb)];
        var strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        var width = label.width / pixelRatio - 2 * textState.scale[0];
        var anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        var anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY
        };
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} contextScale Scale of the context.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {Array<*>} instructions Instructions array.
     * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
     * @param {FeatureCallback<T>=} opt_featureCallback Feature callback.
     * @param {import("../../extent.js").Extent=} opt_hitExtent Only check
     *     features that intersect this extent.
     * @param {import("rbush").default=} opt_declutterTree Declutter tree.
     * @return {T|undefined} Callback result.
     * @template T
     */ Executor.prototype.execute_ = function(context, contextScale, transform, instructions, snapToPixel, opt_featureCallback, opt_hitExtent, opt_declutterTree) {
        /** @type {Array<number>} */ var pixelCoordinates;
        if (this.pixelCoordinates_ && (0, $b998d41b678ed5d1$export$e9bab7fafb253603)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, $e22e7611e69f42a9$export$42b4187a82d80ed0)(this.renderedTransform_, transform);
        }
        var i = 0; // instruction index
        var ii = instructions.length; // end of instructions
        var d = 0; // data index
        var dd; // end of per-instruction data
        var anchorX, anchorY, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        var pendingFill = 0;
        var pendingStroke = 0;
        var lastFillInstruction = null;
        var lastStrokeInstruction = null;
        var coordinateCache = this.coordinateCache_;
        var viewRotation = this.viewRotation_;
        var viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        var state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        var batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        var /** @type {import("../../Feature.js").FeatureLike} */ feature;
        var x, y, currentGeometry;
        while(i < ii){
            var instruction = instructions[i];
            var type = /** @type {import("./Instruction.js").default} */ instruction[0];
            switch(type){
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (opt_hitExtent !== undefined && !(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(opt_hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    var x1 = pixelCoordinates[d];
                    var y1 = pixelCoordinates[d + 1];
                    var x2 = pixelCoordinates[d + 2];
                    var y2 = pixelCoordinates[d + 3];
                    var dx = x2 - x1;
                    var dy = y2 - y1;
                    var r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    var geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    var renderer = instruction[4];
                    var fn = instruction.length == 6 ? instruction[5] : undefined;
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    var coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    var height = /** @type {number} */ instruction[6];
                    var opacity = /** @type {number} */ instruction[7];
                    var originX = /** @type {number} */ instruction[8];
                    var originY = /** @type {number} */ instruction[9];
                    var rotateWithView = /** @type {boolean} */ instruction[10];
                    var rotation = /** @type {number} */ instruction[11];
                    var scale = /** @type {import("../../size.js").Size} */ instruction[12];
                    var width = /** @type {number} */ instruction[13];
                    var declutterImageWithText = /** @type {import("../canvas.js").DeclutterImageWithText} */ instruction[14];
                    if (!image && instruction.length >= 19) {
                        // create label images
                        text = /** @type {string} */ instruction[18];
                        textKey = /** @type {string} */ instruction[19];
                        strokeKey = /** @type {string} */ instruction[20];
                        fillKey = /** @type {string} */ instruction[21];
                        var labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        var textOffsetX = /** @type {number} */ instruction[22];
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        var textOffsetY = /** @type {number} */ instruction[23];
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    var geometryWidths = void 0;
                    if (instruction.length > 24) geometryWidths = /** @type {number} */ instruction[24];
                    var padding = void 0, backgroundFill = void 0, backgroundStroke = void 0;
                    if (instruction.length > 16) {
                        padding = /** @type {Array<number>} */ instruction[15];
                        backgroundFill = /** @type {boolean} */ instruction[16];
                        backgroundStroke = /** @type {boolean} */ instruction[17];
                    } else {
                        padding = (0, $d4aabc5c971073f1$export$40a9eeef55665a40);
                        backgroundFill = false;
                        backgroundStroke = false;
                    }
                    if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                    rotation += viewRotation;
                    else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                    rotation -= viewRotation;
                    var widthIndex = 0;
                    for(; d < dd; d += 2){
                        if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                        var dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, backgroundFill || backgroundStroke, feature);
                        /** @type {ReplayImageOrLabelArgs} */ var args = [
                            context,
                            contextScale,
                            image,
                            dimensions,
                            opacity,
                            backgroundFill ? /** @type {Array<*>} */ lastFillInstruction : null,
                            backgroundStroke ? /** @type {Array<*>} */ lastStrokeInstruction : null
                        ];
                        var imageArgs = void 0;
                        var imageDeclutterBox = void 0;
                        if (opt_declutterTree && declutterImageWithText) {
                            if (!declutterImageWithText[d]) {
                                // We now have the image for an image+text combination.
                                declutterImageWithText[d] = args;
                                continue;
                            }
                            imageArgs = declutterImageWithText[d];
                            delete declutterImageWithText[d];
                            imageDeclutterBox = $6526fa4ee42dc39d$var$getDeclutterBox(imageArgs);
                            if (opt_declutterTree.collides(imageDeclutterBox)) continue;
                        }
                        if (opt_declutterTree && opt_declutterTree.collides(dimensions.declutterBox)) continue;
                        if (imageArgs) {
                            // We now have image and text for an image+text combination.
                            if (opt_declutterTree) opt_declutterTree.insert(imageDeclutterBox);
                            // Render the image before we render the text.
                            this.replayImageOrLabel_.apply(this, imageArgs);
                        }
                        if (opt_declutterTree) opt_declutterTree.insert(dimensions.declutterBox);
                        this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_CHARS:
                    var begin = /** @type {number} */ instruction[1];
                    var end = /** @type {number} */ instruction[2];
                    var baseline = /** @type {number} */ instruction[3];
                    var overflow = /** @type {number} */ instruction[4];
                    fillKey = /** @type {string} */ instruction[5];
                    var maxAngle = /** @type {number} */ instruction[6];
                    var measurePixelRatio = /** @type {number} */ instruction[7];
                    var offsetY = /** @type {number} */ instruction[8];
                    strokeKey = /** @type {string} */ instruction[9];
                    var strokeWidth = /** @type {number} */ instruction[10];
                    text = /** @type {string} */ instruction[11];
                    textKey = /** @type {string} */ instruction[12];
                    var pixelRatioScale = [
                        /** @type {number} */ instruction[13],
                        /** @type {number} */ instruction[13]
                    ];
                    var textState = this.textStates[textKey];
                    var font = textState.font;
                    var textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio
                    ];
                    var cachedWidths = void 0;
                    if (font in this.widths_) cachedWidths = this.widths_[font];
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    var pathLength = (0, $bf04349d827c1d16$export$153f8c6b4d8caebc)(pixelCoordinates, begin, end, 2);
                    var textLength = Math.abs(textScale[0]) * (0, $d4aabc5c971073f1$export$915c7ba51467308f)(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        var textAlign = this.textStates[textKey].textAlign;
                        var startM = (pathLength - textLength) * (0, $8243e906fae47bbe$export$91a016276e4aee96)[textAlign];
                        var parts = (0, $f6421f31729929e6$export$153a9a17ab3e949f)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, $d4aabc5c971073f1$export$915c7ba51467308f), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */ var replayImageOrLabelArgs = [];
                            var c = void 0, cc = void 0, chars = void 0, label = void 0, part = void 0;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, '', strokeKey);
                                anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                var dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $d4aabc5c971073f1$export$40a9eeef55665a40), false, feature);
                                if (opt_declutterTree && opt_declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    contextScale,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, fillKey, '');
                                anchorX = /** @type {number} */ part[2];
                                anchorY = baseline * label.height - offsetY;
                                var dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $d4aabc5c971073f1$export$40a9eeef55665a40), false, feature);
                                if (opt_declutterTree && opt_declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    contextScale,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (opt_declutterTree) opt_declutterTree.load(replayImageOrLabelArgs.map($6526fa4ee42dc39d$var$getDeclutterBox));
                            for(var i_1 = 0, ii_1 = replayImageOrLabelArgs.length; i_1 < ii_1; ++i_1)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i_1]);
                        }
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).END_GEOMETRY:
                    if (opt_featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                        var result = opt_featureCallback(feature, currentGeometry);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    roundX = x + 0.5 | 0;
                    roundY = y + 0.5 | 0;
                    if (roundX !== prevX || roundY !== prevY) {
                        context.moveTo(x, y);
                        prevX = roundX;
                        prevY = roundY;
                    }
                    for(d += 2; d < dd; d += 2){
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE:
                    lastFillInstruction = instruction;
                    this.alignFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }
                    context.fillStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE:
                    lastStrokeInstruction = instruction;
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i; // consume the instruction anyway, to avoid an infinite loop
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} contextScale Scale of the context.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {number} viewRotation View rotation.
     * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
     * @param {import("rbush").default=} opt_declutterTree Declutter tree.
     */ Executor.prototype.execute = function(context, contextScale, transform, viewRotation, snapToPixel, opt_declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, contextScale, transform, this.instructions, snapToPixel, undefined, undefined, opt_declutterTree);
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {number} viewRotation View rotation.
     * @param {FeatureCallback<T>=} opt_featureCallback Feature callback.
     * @param {import("../../extent.js").Extent=} opt_hitExtent Only check
     *     features that intersect this extent.
     * @return {T|undefined} Callback result.
     * @template T
     */ Executor.prototype.executeHitDetection = function(context, transform, viewRotation, opt_featureCallback, opt_hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, 1, transform, this.hitDetectionInstructions, true, opt_featureCallback, opt_hitExtent);
    };
    return Executor;
}();
var $6526fa4ee42dc39d$export$2e2bcd8739ae039 = $6526fa4ee42dc39d$var$Executor;








/**
 * @const
 * @type {Array<import("./BuilderType.js").default>}
 */ var $a34a824d875e4ea1$var$ORDER = [
    (0, $e74ccf0666398498$export$2e2bcd8739ae039).POLYGON,
    (0, $e74ccf0666398498$export$2e2bcd8739ae039).CIRCLE,
    (0, $e74ccf0666398498$export$2e2bcd8739ae039).LINE_STRING,
    (0, $e74ccf0666398498$export$2e2bcd8739ae039).IMAGE,
    (0, $e74ccf0666398498$export$2e2bcd8739ae039).TEXT,
    (0, $e74ccf0666398498$export$2e2bcd8739ae039).DEFAULT
];
var $a34a824d875e4ea1$var$ExecutorGroup = /** @class */ function() {
    /**
     * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
     * `maxExtent` was set on the Buillder for this executor group, the same `maxExtent`
     * should be set here, unless the target context does not exceet that extent (which
     * can be the case when rendering to tiles).
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {boolean} overlaps The executor group can have overlapping geometries.
     * @param {!Object<string, !Object<import("./BuilderType.js").default, import("../canvas.js").SerializableInstructions>>} allInstructions
     * The serializable instructions.
     * @param {number=} opt_renderBuffer Optional rendering buffer.
     */ function ExecutorGroup(maxExtent, resolution, pixelRatio, overlaps, allInstructions, opt_renderBuffer) {
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */ this.maxExtent_ = maxExtent;
        /**
         * @private
         * @type {boolean}
         */ this.overlaps_ = overlaps;
        /**
         * @private
         * @type {number}
         */ this.pixelRatio_ = pixelRatio;
        /**
         * @private
         * @type {number}
         */ this.resolution_ = resolution;
        /**
         * @private
         * @type {number|undefined}
         */ this.renderBuffer_ = opt_renderBuffer;
        /**
         * @private
         * @type {!Object<string, !Object<import("./BuilderType.js").default, import("./Executor").default>>}
         */ this.executorsByZIndex_ = {};
        /**
         * @private
         * @type {CanvasRenderingContext2D}
         */ this.hitDetectionContext_ = null;
        /**
         * @private
         * @type {import("../../transform.js").Transform}
         */ this.hitDetectionTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        this.createExecutors_(allInstructions);
    }
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../transform.js").Transform} transform Transform.
     */ ExecutorGroup.prototype.clip = function(context, transform) {
        var flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    };
    /**
     * Create executors and populate them using the provided instructions.
     * @private
     * @param {!Object<string, !Object<import("./BuilderType.js").default, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
     */ ExecutorGroup.prototype.createExecutors_ = function(allInstructions) {
        for(var zIndex in allInstructions){
            var executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            var instructionByZindex = allInstructions[zIndex];
            var renderBuffer = [
                this.renderBuffer_ || 0,
                this.renderBuffer_ || 0
            ];
            for(var builderType in instructionByZindex){
                var instructions = instructionByZindex[builderType];
                executors[builderType] = new (0, $6526fa4ee42dc39d$export$2e2bcd8739ae039)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions, renderBuffer);
            }
        }
    };
    /**
     * @param {Array<import("./BuilderType.js").default>} executors Executors.
     * @return {boolean} Has executors of the provided types.
     */ ExecutorGroup.prototype.hasExecutors = function(executors) {
        for(var zIndex in this.executorsByZIndex_){
            var candidates = this.executorsByZIndex_[zIndex];
            for(var i = 0, ii = executors.length; i < ii; ++i){
                if (executors[i] in candidates) return true;
            }
        }
        return false;
    };
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {number} resolution Resolution.
     * @param {number} rotation Rotation.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
     * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
     * @return {T|undefined} Callback result.
     * @template T
     */ ExecutorGroup.prototype.forEachFeatureAtCoordinate = function(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        hitTolerance = Math.round(hitTolerance);
        var contextSize = hitTolerance * 2 + 1;
        var transform = (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        var newContext = !this.hitDetectionContext_;
        if (newContext) this.hitDetectionContext_ = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(contextSize, contextSize);
        var context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
        /**
         * @type {import("../../extent.js").Extent}
         */ var hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(hitExtent, coordinate);
            (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        var indexes = $a34a824d875e4ea1$export$96fc84ea21b8269f(hitTolerance);
        var builderType;
        /**
         * @param {import("../../Feature.js").FeatureLike} feature Feature.
         * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
         * @return {T|undefined} Callback result.
         */ function featureCallback(feature, geometry) {
            var imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(var i_1 = 0, ii = indexes.length; i_1 < ii; i_1++)if (imageData[indexes[i_1]] > 0) {
                if (!declutteredFeatures || builderType !== (0, $e74ccf0666398498$export$2e2bcd8739ae039).IMAGE && builderType !== (0, $e74ccf0666398498$export$2e2bcd8739ae039).TEXT || declutteredFeatures.indexOf(feature) !== -1) {
                    var idx = (indexes[i_1] - 3) / 4;
                    var x = hitTolerance - idx % contextSize;
                    var y = hitTolerance - (idx / contextSize | 0);
                    var result_1 = callback(feature, geometry, x * x + y * y);
                    if (result_1) return result_1;
                }
                context.clearRect(0, 0, contextSize, contextSize);
                break;
            }
            return undefined;
        }
        /** @type {Array<number>} */ var zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $b998d41b678ed5d1$export$4e734a3b32fb971b));
        var i, j, executors, executor, result;
        for(i = zs.length - 1; i >= 0; --i){
            var zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for(j = $a34a824d875e4ea1$var$ORDER.length - 1; j >= 0; --j){
                builderType = $a34a824d875e4ea1$var$ORDER[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) return result;
                }
            }
        }
        return undefined;
    };
    /**
     * @param {import("../../transform.js").Transform} transform Transform.
     * @return {Array<number>} Clip coordinates.
     */ ExecutorGroup.prototype.getClipCoords = function(transform) {
        var maxExtent = this.maxExtent_;
        if (!maxExtent) return null;
        var minX = maxExtent[0];
        var minY = maxExtent[1];
        var maxX = maxExtent[2];
        var maxY = maxExtent[3];
        var flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    };
    /**
     * @return {boolean} Is empty.
     */ ExecutorGroup.prototype.isEmpty = function() {
        return (0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.executorsByZIndex_);
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} contextScale Scale of the context.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {number} viewRotation View rotation.
     * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
     * @param {Array<import("./BuilderType.js").default>=} opt_builderTypes Ordered replay types to replay.
     *     Default is {@link module:ol/render/replay~ORDER}
     * @param {import("rbush").default=} opt_declutterTree Declutter tree.
     */ ExecutorGroup.prototype.execute = function(context, contextScale, transform, viewRotation, snapToPixel, opt_builderTypes, opt_declutterTree) {
        /** @type {Array<number>} */ var zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $b998d41b678ed5d1$export$4e734a3b32fb971b));
        // setup clipping so that the parts of over-simplified geometries are not
        // visible outside the current extent when panning
        if (this.maxExtent_) {
            context.save();
            this.clip(context, transform);
        }
        var builderTypes = opt_builderTypes ? opt_builderTypes : $a34a824d875e4ea1$var$ORDER;
        var i, ii, j, jj, replays, replay;
        if (opt_declutterTree) zs.reverse();
        for(i = 0, ii = zs.length; i < ii; ++i){
            var zIndexKey = zs[i].toString();
            replays = this.executorsByZIndex_[zIndexKey];
            for(j = 0, jj = builderTypes.length; j < jj; ++j){
                var builderType = builderTypes[j];
                replay = replays[builderType];
                if (replay !== undefined) replay.execute(context, contextScale, transform, viewRotation, snapToPixel, opt_declutterTree);
            }
        }
        if (this.maxExtent_) context.restore();
    };
    return ExecutorGroup;
}();
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ var $a34a824d875e4ea1$var$circlePixelIndexArrayCache = {};
function $a34a824d875e4ea1$export$96fc84ea21b8269f(radius) {
    if ($a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius] !== undefined) return $a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius];
    var size = radius * 2 + 1;
    var maxDistanceSq = radius * radius;
    var distances = new Array(maxDistanceSq + 1);
    for(var i = 0; i <= radius; ++i)for(var j = 0; j <= radius; ++j){
        var distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        var distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    var pixelIndex = [];
    for(var i = 0, ii = distances.length; i < ii; ++i)if (distances[i]) pixelIndex.push.apply(pixelIndex, distances[i]);
    $a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
var $a34a824d875e4ea1$export$2e2bcd8739ae039 = $a34a824d875e4ea1$var$ExecutorGroup;





/**
 * @module ol/render/canvas/hitdetect
 */ /**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?









var $7b0c2128a27f5020$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ var $7b0c2128a27f5020$var$CanvasImmediateRenderer = /** @class */ function(_super) {
    $7b0c2128a27f5020$var$__extends(CanvasImmediateRenderer, _super);
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../../extent.js").Extent} extent Extent.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {number} viewRotation View rotation.
     * @param {number=} opt_squaredTolerance Optional squared tolerance for simplification.
     * @param {import("../../proj.js").TransformFunction=} opt_userTransform Transform from user to view projection.
     */ function CanvasImmediateRenderer(context, pixelRatio, extent, transform, viewRotation, opt_squaredTolerance, opt_userTransform) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {CanvasRenderingContext2D}
         */ _this.context_ = context;
        /**
         * @private
         * @type {number}
         */ _this.pixelRatio_ = pixelRatio;
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */ _this.extent_ = extent;
        /**
         * @private
         * @type {import("../../transform.js").Transform}
         */ _this.transform_ = transform;
        /**
         * @private
         * @type {number}
         */ _this.viewRotation_ = viewRotation;
        /**
         * @private
         * @type {number}
         */ _this.squaredTolerance_ = opt_squaredTolerance;
        /**
         * @private
         * @type {import("../../proj.js").TransformFunction}
         */ _this.userTransform_ = opt_userTransform;
        /**
         * @private
         * @type {?import("../canvas.js").FillState}
         */ _this.contextFillState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").StrokeState}
         */ _this.contextStrokeState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").TextState}
         */ _this.contextTextState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").FillState}
         */ _this.fillState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").StrokeState}
         */ _this.strokeState_ = null;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
         */ _this.image_ = null;
        /**
         * @private
         * @type {number}
         */ _this.imageAnchorX_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.imageAnchorY_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.imageHeight_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.imageOpacity_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.imageOriginX_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.imageOriginY_ = 0;
        /**
         * @private
         * @type {boolean}
         */ _this.imageRotateWithView_ = false;
        /**
         * @private
         * @type {number}
         */ _this.imageRotation_ = 0;
        /**
         * @private
         * @type {import("../../size.js").Size}
         */ _this.imageScale_ = [
            0,
            0
        ];
        /**
         * @private
         * @type {number}
         */ _this.imageWidth_ = 0;
        /**
         * @private
         * @type {string}
         */ _this.text_ = '';
        /**
         * @private
         * @type {number}
         */ _this.textOffsetX_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.textOffsetY_ = 0;
        /**
         * @private
         * @type {boolean}
         */ _this.textRotateWithView_ = false;
        /**
         * @private
         * @type {number}
         */ _this.textRotation_ = 0;
        /**
         * @private
         * @type {import("../../size.js").Size}
         */ _this.textScale_ = [
            0,
            0
        ];
        /**
         * @private
         * @type {?import("../canvas.js").FillState}
         */ _this.textFillState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").StrokeState}
         */ _this.textStrokeState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").TextState}
         */ _this.textState_ = null;
        /**
         * @private
         * @type {Array<number>}
         */ _this.pixelCoordinates_ = [];
        /**
         * @private
         * @type {import("../../transform.js").Transform}
         */ _this.tmpLocalTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        return _this;
    }
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @private
     */ CanvasImmediateRenderer.prototype.drawImages_ = function(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        var pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, 2, this.transform_, this.pixelCoordinates_);
        var context = this.context_;
        var localTransform = this.tmpLocalTransform_;
        var alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        var rotation = this.imageRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(var i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            var x = pixelCoordinates[i] - this.imageAnchorX_;
            var y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                var centerX = x + this.imageAnchorX_;
                var centerY = y + this.imageAnchorY_;
                (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.setTransform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.setTransform(1, 0, 0, 1, 0, 0);
            } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @private
     */ CanvasImmediateRenderer.prototype.drawText_ = function(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === '') return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        var pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        var context = this.context_;
        var rotation = this.textRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            var x = pixelCoordinates[offset] + this.textOffsetX_;
            var y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                var localTransform = (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.tmpLocalTransform_, x, y, 1, 1, rotation, -x, -y);
                context.setTransform.apply(context, localTransform);
                context.translate(x, y);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                if (this.textFillState_) context.fillText(this.text_, 0, 0);
                context.setTransform(1, 0, 0, 1, 0, 0);
            } else {
                if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                if (this.textFillState_) context.fillText(this.text_, x, y);
            }
        }
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @param {boolean} close Close.
     * @private
     * @return {number} end End.
     */ CanvasImmediateRenderer.prototype.moveToLineTo_ = function(flatCoordinates, offset, end, stride, close) {
        var context = this.context_;
        var pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        var length = pixelCoordinates.length;
        if (close) length -= 2;
        for(var i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {Array<number>} ends Ends.
     * @param {number} stride Stride.
     * @private
     * @return {number} End.
     */ CanvasImmediateRenderer.prototype.drawRings_ = function(flatCoordinates, offset, ends, stride) {
        for(var i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
        return offset;
    };
    /**
     * Render a circle geometry into the canvas.  Rendering is immediate and uses
     * the current fill and stroke styles.
     *
     * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
     * @api
     */ CanvasImmediateRenderer.prototype.drawCircle = function(geometry) {
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            var pixelCoordinates = (0, $c76e993e57efc8c4$export$a3767472617c7861)(geometry, this.transform_, this.pixelCoordinates_);
            var dx = pixelCoordinates[2] - pixelCoordinates[0];
            var dy = pixelCoordinates[3] - pixelCoordinates[1];
            var radius = Math.sqrt(dx * dx + dy * dy);
            var context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') this.drawText_(geometry.getCenter(), 0, 2, 2);
    };
    /**
     * Set the rendering style.  Note that since this is an immediate rendering API,
     * any `zIndex` on the provided style will be ignored.
     *
     * @param {import("../../style/Style.js").default} style The rendering style.
     * @api
     */ CanvasImmediateRenderer.prototype.setStyle = function(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    };
    /**
     * @param {import("../../transform.js").Transform} transform Transform.
     */ CanvasImmediateRenderer.prototype.setTransform = function(transform) {
        this.transform_ = transform;
    };
    /**
     * Render a geometry into the canvas.  Call
     * {@link module:ol/render/canvas/Immediate#setStyle} first to set the rendering style.
     *
     * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
     * @api
     */ CanvasImmediateRenderer.prototype.drawGeometry = function(geometry) {
        var type = geometry.getType();
        switch(type){
            case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POINT:
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING:
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON:
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POINT:
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_LINE_STRING:
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_POLYGON:
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).GEOMETRY_COLLECTION:
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case (0, $419865bd7211e6e7$export$2e2bcd8739ae039).CIRCLE:
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    };
    /**
     * Render a feature into the canvas.  Note that any `zIndex` on the provided
     * style will be ignored - features are rendered immediately in the order that
     * this method is called.  If you need `zIndex` support, you should be using an
     * {@link module:ol/layer/Vector~VectorLayer} instead.
     *
     * @param {import("../../Feature.js").default} feature Feature.
     * @param {import("../../style/Style.js").default} style Style.
     * @api
     */ CanvasImmediateRenderer.prototype.drawFeature = function(feature, style) {
        var geometry = style.getGeometryFunction()(feature);
        if (!geometry || !(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    };
    /**
     * Render a GeometryCollection to the canvas.  Rendering is immediate and
     * uses the current styles appropriate for each geometry in the collection.
     *
     * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
     */ CanvasImmediateRenderer.prototype.drawGeometryCollection = function(geometry) {
        var geometries = geometry.getGeometriesArray();
        for(var i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    };
    /**
     * Render a Point geometry into the canvas.  Rendering is immediate and uses
     * the current style.
     *
     * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
     */ CanvasImmediateRenderer.prototype.drawPoint = function(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        var flatCoordinates = geometry.getFlatCoordinates();
        var stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    };
    /**
     * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
     * uses the current style.
     *
     * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
     */ CanvasImmediateRenderer.prototype.drawMultiPoint = function(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        var flatCoordinates = geometry.getFlatCoordinates();
        var stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    };
    /**
     * Render a LineString into the canvas.  Rendering is immediate and uses
     * the current style.
     *
     * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
     */ CanvasImmediateRenderer.prototype.drawLineString = function(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            var flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false);
            context.stroke();
        }
        if (this.text_ !== '') {
            var flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    };
    /**
     * Render a MultiLineString geometry into the canvas.  Rendering is immediate
     * and uses the current style.
     *
     * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
     */ CanvasImmediateRenderer.prototype.drawMultiLineString = function(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        var geometryExtent = geometry.getExtent();
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            var flatCoordinates = geometry.getFlatCoordinates();
            var offset = 0;
            var ends = /** @type {Array<number>} */ geometry.getEnds();
            var stride = geometry.getStride();
            context.beginPath();
            for(var i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
            context.stroke();
        }
        if (this.text_ !== '') {
            var flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    };
    /**
     * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
     * the current style.
     *
     * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
     */ CanvasImmediateRenderer.prototype.drawPolygon = function(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride());
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            var flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    };
    /**
     * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
     * uses the current style.
     * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
     */ CanvasImmediateRenderer.prototype.drawMultiPolygon = function(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            var flatCoordinates = geometry.getOrientedFlatCoordinates();
            var offset = 0;
            var endss = geometry.getEndss();
            var stride = geometry.getStride();
            context.beginPath();
            for(var i = 0, ii = endss.length; i < ii; ++i){
                var ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            var flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    };
    /**
     * @param {import("../canvas.js").FillState} fillState Fill state.
     * @private
     */ CanvasImmediateRenderer.prototype.setContextFillState_ = function(fillState) {
        var context = this.context_;
        var contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) {
            contextFillState.fillStyle = fillState.fillStyle;
            context.fillStyle = fillState.fillStyle;
        }
    };
    /**
     * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
     * @private
     */ CanvasImmediateRenderer.prototype.setContextStrokeState_ = function(strokeState) {
        var context = this.context_;
        var contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            if (context.setLineDash) {
                context.setLineDash(strokeState.lineDash);
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (context.setLineDash) {
                if (!(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
                if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                    contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                    context.lineDashOffset = strokeState.lineDashOffset;
                }
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    };
    /**
     * @param {import("../canvas.js").TextState} textState Text state.
     * @private
     */ CanvasImmediateRenderer.prototype.setContextTextState_ = function(textState) {
        var context = this.context_;
        var contextTextState = this.contextTextState_;
        var textAlign = textState.textAlign ? textState.textAlign : (0, $d4aabc5c971073f1$export$94d53b95641b5766);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = /** @type {CanvasTextAlign} */ textAlign;
            context.textBaseline = /** @type {CanvasTextBaseline} */ textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = /** @type {CanvasTextAlign} */ textAlign;
                context.textAlign = /** @type {CanvasTextAlign} */ textAlign;
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = /** @type {CanvasTextBaseline} */ textState.textBaseline;
                context.textBaseline = /** @type {CanvasTextBaseline} */ textState.textBaseline;
            }
        }
    };
    /**
     * Set the fill and stroke style for subsequent draw operations.  To clear
     * either fill or stroke styles, pass null for the appropriate parameter.
     *
     * @param {import("../../style/Fill.js").default} fillStyle Fill style.
     * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
     */ CanvasImmediateRenderer.prototype.setFillStrokeStyle = function(fillStyle, strokeStyle) {
        if (!fillStyle) this.fillState_ = null;
        else {
            var fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            var strokeStyleColor = strokeStyle.getColor();
            var strokeStyleLineCap = strokeStyle.getLineCap();
            var strokeStyleLineDash = strokeStyle.getLineDash();
            var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            var strokeStyleLineJoin = strokeStyle.getLineJoin();
            var strokeStyleWidth = strokeStyle.getWidth();
            var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e),
                lineDash: strokeStyleLineDash ? strokeStyleLineDash : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
                lineDashOffset: strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $d4aabc5c971073f1$export$e06efc2409049f76),
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $d4aabc5c971073f1$export$365eb9648cf19bd0),
                lineWidth: this.pixelRatio_ * (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $d4aabc5c971073f1$export$79661f132c62010e)),
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $d4aabc5c971073f1$export$80c1c01844597b7b),
                strokeStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e))
            };
        }
    };
    /**
     * Set the image style for subsequent draw operations.  Pass null to remove
     * the image style.
     *
     * @param {import("../../style/Image.js").default} imageStyle Image style.
     */ CanvasImmediateRenderer.prototype.setImageStyle = function(imageStyle) {
        if (!imageStyle) this.image_ = null;
        else {
            var imageSize = imageStyle.getSize();
            if (!imageSize) this.image_ = null;
            else {
                var imageAnchor = imageStyle.getAnchor();
                // FIXME pixel ratio
                var imageImage = imageStyle.getImage(1);
                var imageOrigin = imageStyle.getOrigin();
                var imageScale = imageStyle.getScaleArray();
                this.imageAnchorX_ = imageAnchor[0];
                this.imageAnchorY_ = imageAnchor[1];
                this.imageHeight_ = imageSize[1];
                this.image_ = imageImage;
                this.imageOpacity_ = imageStyle.getOpacity();
                this.imageOriginX_ = imageOrigin[0];
                this.imageOriginY_ = imageOrigin[1];
                this.imageRotateWithView_ = imageStyle.getRotateWithView();
                this.imageRotation_ = imageStyle.getRotation();
                this.imageScale_ = [
                    this.pixelRatio_ * imageScale[0],
                    this.pixelRatio_ * imageScale[1]
                ];
                this.imageWidth_ = imageSize[0];
            }
        }
    };
    /**
     * Set the text style for subsequent draw operations.  Pass null to
     * remove the text style.
     *
     * @param {import("../../style/Text.js").default} textStyle Text style.
     */ CanvasImmediateRenderer.prototype.setTextStyle = function(textStyle) {
        if (!textStyle) this.text_ = '';
        else {
            var textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                var textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textFillStyleColor ? textFillStyleColor : (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2))
                };
            }
            var textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                var textStrokeStyleColor = textStrokeStyle.getColor();
                var textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                var textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                var textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                var textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                var textStrokeStyleWidth = textStrokeStyle.getWidth();
                var textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $d4aabc5c971073f1$export$e06efc2409049f76),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $d4aabc5c971073f1$export$365eb9648cf19bd0),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $d4aabc5c971073f1$export$79661f132c62010e),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $d4aabc5c971073f1$export$80c1c01844597b7b),
                    strokeStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textStrokeStyleColor ? textStrokeStyleColor : (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e))
                };
            }
            var textFont = textStyle.getFont();
            var textOffsetX = textStyle.getOffsetX();
            var textOffsetY = textStyle.getOffsetY();
            var textRotateWithView = textStyle.getRotateWithView();
            var textRotation = textStyle.getRotation();
            var textScale = textStyle.getScaleArray();
            var textText = textStyle.getText();
            var textTextAlign = textStyle.getTextAlign();
            var textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, $d4aabc5c971073f1$export$3847dfea4f8d4dfa),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, $d4aabc5c971073f1$export$94d53b95641b5766),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $d4aabc5c971073f1$export$cf2279a1bff62eb)
            };
            this.text_ = textText !== undefined ? textText : '';
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1]
            ];
        }
    };
    return CanvasImmediateRenderer;
}((0, $eb0e5c3938110b4c$export$2e2bcd8739ae039));
var $7b0c2128a27f5020$export$2e2bcd8739ae039 = $7b0c2128a27f5020$var$CanvasImmediateRenderer;



/**
 * @module ol/style/IconAnchorUnits
 */ /**
 * Icon anchor units. One of 'fraction', 'pixels'.
 * @enum {string}
 */ var $61c65c2463af340d$export$2e2bcd8739ae039 = {
    /**
     * Anchor is a fraction
     * @api
     */ FRACTION: 'fraction',
    /**
     * Anchor is in pixels
     * @api
     */ PIXELS: 'pixels'
};




/**
 * @module ol/style/IconOrigin
 */ /**
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 * @enum {string}
 */ var $546509bca2d85ec0$export$2e2bcd8739ae039 = {
    /**
     * Origin is at bottom left
     * @api
     */ BOTTOM_LEFT: 'bottom-left',
    /**
     * Origin is at bottom right
     * @api
     */ BOTTOM_RIGHT: 'bottom-right',
    /**
     * Origin is at top left
     * @api
     */ TOP_LEFT: 'top-left',
    /**
     * Origin is at top right
     * @api
     */ TOP_RIGHT: 'top-right'
};






/**
 * @module ol/style/IconImage
 */ 









var $5edd00bd92be9cf8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @abstract
 */ var $5edd00bd92be9cf8$var$ImageBase = /** @class */ function(_super) {
    $5edd00bd92be9cf8$var$__extends(ImageBase, _super);
    /**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number|undefined} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./ImageState.js").default} state State.
     */ function ImageBase(extent, resolution, pixelRatio, state) {
        var _this = _super.call(this) || this;
        /**
         * @protected
         * @type {import("./extent.js").Extent}
         */ _this.extent = extent;
        /**
         * @private
         * @type {number}
         */ _this.pixelRatio_ = pixelRatio;
        /**
         * @protected
         * @type {number|undefined}
         */ _this.resolution = resolution;
        /**
         * @protected
         * @type {import("./ImageState.js").default}
         */ _this.state = state;
        return _this;
    }
    /**
     * @protected
     */ ImageBase.prototype.changed = function() {
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    };
    /**
     * @return {import("./extent.js").Extent} Extent.
     */ ImageBase.prototype.getExtent = function() {
        return this.extent;
    };
    /**
     * @abstract
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     */ ImageBase.prototype.getImage = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * @return {number} PixelRatio.
     */ ImageBase.prototype.getPixelRatio = function() {
        return this.pixelRatio_;
    };
    /**
     * @return {number} Resolution.
     */ ImageBase.prototype.getResolution = function() {
        return /** @type {number} */ this.resolution;
    };
    /**
     * @return {import("./ImageState.js").default} State.
     */ ImageBase.prototype.getState = function() {
        return this.state;
    };
    /**
     * Load not yet loaded URI.
     * @abstract
     */ ImageBase.prototype.load = function() {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    return ImageBase;
}((0, $08c28d22c0cb5a39$export$2e2bcd8739ae039));
var $5edd00bd92be9cf8$export$2e2bcd8739ae039 = $5edd00bd92be9cf8$var$ImageBase;






var $b54439be79d4619a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * A function that takes an {@link module:ol/Image~Image} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~Image#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(ImageWrapper, string): void} LoadFunction
 * @api
 */ var $b54439be79d4619a$var$ImageWrapper = /** @class */ function(_super) {
    $b54439be79d4619a$var$__extends(ImageWrapper, _super);
    /**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number|undefined} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {string} src Image source URI.
     * @param {?string} crossOrigin Cross origin.
     * @param {LoadFunction} imageLoadFunction Image load function.
     */ function ImageWrapper(extent, resolution, pixelRatio, src, crossOrigin, imageLoadFunction) {
        var _this = _super.call(this, extent, resolution, pixelRatio, (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) || this;
        /**
         * @private
         * @type {string}
         */ _this.src_ = src;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement}
         */ _this.image_ = new Image();
        if (crossOrigin !== null) _this.image_.crossOrigin = crossOrigin;
        /**
         * @private
         * @type {?function():void}
         */ _this.unlisten_ = null;
        /**
         * @protected
         * @type {import("./ImageState.js").default}
         */ _this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE;
        /**
         * @private
         * @type {LoadFunction}
         */ _this.imageLoadFunction_ = imageLoadFunction;
        return _this;
    }
    /**
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     * @api
     */ ImageWrapper.prototype.getImage = function() {
        return this.image_;
    };
    /**
     * Tracks loading or read errors.
     *
     * @private
     */ ImageWrapper.prototype.handleImageError_ = function() {
        this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.changed();
    };
    /**
     * Tracks successful image load.
     *
     * @private
     */ ImageWrapper.prototype.handleImageLoad_ = function() {
        if (this.resolution === undefined) this.resolution = (0, $6da4c8ed3074c92b$export$c08559766941f856)(this.extent) / this.image_.height;
        this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
        this.unlistenImage_();
        this.changed();
    };
    /**
     * Load the image or retry if loading previously failed.
     * Loading is taken care of by the tile queue, and calling this method is
     * only needed for preloading or for reloading in case of an error.
     * @api
     */ ImageWrapper.prototype.load = function() {
        if (this.state == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE || this.state == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) {
            this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.imageLoadFunction_(this, this.src_);
            this.unlisten_ = $b54439be79d4619a$export$bc96ecc7c2a50764(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    };
    /**
     * @param {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} image Image.
     */ ImageWrapper.prototype.setImage = function(image) {
        this.image_ = image;
    };
    /**
     * Discards event handlers which listen for load completion or errors.
     *
     * @private
     */ ImageWrapper.prototype.unlistenImage_ = function() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    };
    return ImageWrapper;
}((0, $5edd00bd92be9cf8$export$2e2bcd8739ae039));
function $b54439be79d4619a$export$bc96ecc7c2a50764(image, loadHandler, errorHandler) {
    var img = /** @type {HTMLImageElement} */ image;
    if (img.src && (0, $67c66761d21428d0$export$716f8695eedb9bad)) {
        var promise = img.decode();
        var listening_1 = true;
        var unlisten = function() {
            listening_1 = false;
        };
        promise.then(function() {
            if (listening_1) loadHandler();
        }).catch(function(error) {
            if (listening_1) {
                // FIXME: Unconditionally call errorHandler() when this bug is fixed upstream:
                //        https://bugs.webkit.org/show_bug.cgi?id=198527
                if (error.name === 'EncodingError' && error.message === 'Invalid image type.') loadHandler();
                else errorHandler();
            }
        });
        return unlisten;
    }
    var listenerKeys = [
        (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(img, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).LOAD, loadHandler),
        (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(img, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).ERROR, errorHandler)
    ];
    return function unlisten() {
        listenerKeys.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
    };
}
var $b54439be79d4619a$export$2e2bcd8739ae039 = $b54439be79d4619a$var$ImageWrapper;


var $0e5ad1d3b638689e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @type {CanvasRenderingContext2D}
 */ var $0e5ad1d3b638689e$var$taintedTestContext = null;
var $0e5ad1d3b638689e$var$IconImage = /** @class */ function(_super) {
    $0e5ad1d3b638689e$var$__extends(IconImage, _super);
    /**
     * @param {HTMLImageElement|HTMLCanvasElement} image Image.
     * @param {string|undefined} src Src.
     * @param {import("../size.js").Size} size Size.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("../ImageState.js").default} imageState Image state.
     * @param {import("../color.js").Color} color Color.
     */ function IconImage(image, src, size, crossOrigin, imageState, color) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {HTMLImageElement|HTMLCanvasElement}
         */ _this.hitDetectionImage_ = null;
        /**
         * @private
         * @type {HTMLImageElement|HTMLCanvasElement}
         */ _this.image_ = !image ? new Image() : image;
        if (crossOrigin !== null) /** @type {HTMLImageElement} */ _this.image_.crossOrigin = crossOrigin;
        /**
         * @private
         * @type {Object<number, HTMLCanvasElement>}
         */ _this.canvas_ = {};
        /**
         * @private
         * @type {import("../color.js").Color}
         */ _this.color_ = color;
        /**
         * @private
         * @type {?function():void}
         */ _this.unlisten_ = null;
        /**
         * @private
         * @type {import("../ImageState.js").default}
         */ _this.imageState_ = imageState;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ _this.size_ = size;
        /**
         * @private
         * @type {string|undefined}
         */ _this.src_ = src;
        /**
         * @private
         */ _this.tainted_;
        return _this;
    }
    /**
     * @private
     * @return {boolean} The image canvas is tainted.
     */ IconImage.prototype.isTainted_ = function() {
        if (this.tainted_ === undefined && this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) {
            if (!$0e5ad1d3b638689e$var$taintedTestContext) $0e5ad1d3b638689e$var$taintedTestContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1);
            $0e5ad1d3b638689e$var$taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                $0e5ad1d3b638689e$var$taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            } catch (e) {
                $0e5ad1d3b638689e$var$taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    };
    /**
     * @private
     */ IconImage.prototype.dispatchChangeEvent_ = function() {
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    };
    /**
     * @private
     */ IconImage.prototype.handleImageError_ = function() {
        this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.dispatchChangeEvent_();
    };
    /**
     * @private
     */ IconImage.prototype.handleImageLoad_ = function() {
        this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
        if (this.size_) {
            this.image_.width = this.size_[0];
            this.image_.height = this.size_[1];
        } else this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.unlistenImage_();
        this.dispatchChangeEvent_();
    };
    /**
     * @param {number} pixelRatio Pixel ratio.
     * @return {HTMLImageElement|HTMLCanvasElement} Image or Canvas element.
     */ IconImage.prototype.getImage = function(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    };
    /**
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Image or Canvas element.
     */ IconImage.prototype.getPixelRatio = function(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    };
    /**
     * @return {import("../ImageState.js").default} Image state.
     */ IconImage.prototype.getImageState = function() {
        return this.imageState_;
    };
    /**
     * @return {HTMLImageElement|HTMLCanvasElement} Image element.
     */ IconImage.prototype.getHitDetectionImage = function() {
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                var width = this.size_[0];
                var height = this.size_[1];
                var context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    };
    /**
     * Get the size of the icon (in pixels).
     * @return {import("../size.js").Size} Image size.
     */ IconImage.prototype.getSize = function() {
        return this.size_;
    };
    /**
     * @return {string|undefined} Image src.
     */ IconImage.prototype.getSrc = function() {
        return this.src_;
    };
    /**
     * Load not yet loaded URI.
     */ IconImage.prototype.load = function() {
        if (this.imageState_ == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) {
            this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
            try {
                /** @type {HTMLImageElement} */ this.image_.src = this.src_;
            } catch (e) {
                this.handleImageError_();
            }
            this.unlisten_ = (0, $b54439be79d4619a$export$bc96ecc7c2a50764)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    };
    /**
     * @param {number} pixelRatio Pixel ratio.
     * @private
     */ IconImage.prototype.replaceColor_ = function(pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio]) return;
        var canvas = document.createElement('canvas');
        this.canvas_[pixelRatio] = canvas;
        canvas.width = Math.ceil(this.image_.width * pixelRatio);
        canvas.height = Math.ceil(this.image_.height * pixelRatio);
        var ctx = canvas.getContext('2d');
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(this.image_, 0, 0);
        ctx.globalCompositeOperation = 'multiply';
        // Internet Explorer 11 does not support the multiply operation.
        // If the canvas is tainted in Internet Explorer this still produces
        // a solid color image with the shape of the icon.
        if (ctx.globalCompositeOperation === 'multiply' || this.isTainted_()) {
            ctx.fillStyle = (0, $322346e1ff7894ca$export$590567be997858b6)(this.color_);
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.globalCompositeOperation = 'destination-in';
            ctx.drawImage(this.image_, 0, 0);
        } else {
            var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            var data = imgData.data;
            var r = this.color_[0] / 255.0;
            var g = this.color_[1] / 255.0;
            var b = this.color_[2] / 255.0;
            var a = this.color_[3];
            for(var i = 0, ii = data.length; i < ii; i += 4){
                data[i] *= r;
                data[i + 1] *= g;
                data[i + 2] *= b;
                data[i + 3] *= a;
            }
            ctx.putImageData(imgData, 0, 0);
        }
    };
    /**
     * Discards event handlers which listen for load completion or errors.
     *
     * @private
     */ IconImage.prototype.unlistenImage_ = function() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    };
    return IconImage;
}((0, $08c28d22c0cb5a39$export$2e2bcd8739ae039));
function $0e5ad1d3b638689e$export$3988ae62b71be9a3(image, src, size, crossOrigin, imageState, color) {
    var iconImage = (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).get(src, crossOrigin, color);
    if (!iconImage) {
        iconImage = new $0e5ad1d3b638689e$var$IconImage(image, src, size, crossOrigin, imageState, color);
        (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).set(src, crossOrigin, color, iconImage);
    }
    return iconImage;
}
var $0e5ad1d3b638689e$export$2e2bcd8739ae039 = $0e5ad1d3b638689e$var$IconImage;



var $8463d325b53eeb0c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {import("./IconOrigin.js").default} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("./IconAnchorUnits.js").default} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {import("./IconAnchorUnits.js").default} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {HTMLImageElement|HTMLCanvasElement} [img] Image object for the icon. If the `src` option is not provided then the
 * provided image must already be loaded. And in that case, it is required
 * to provide the size of the image, with the `imgSize` option.
 * @property {Array<number>} [offset=[0, 0]] Offset, which, together with the size and the offset origin, define the
 * sub-rectangle to use from the original icon image.
 * @property {Array<number>} [displacement=[0,0]] Displacement the icon
 * @property {import("./IconOrigin.js").default} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {import("../size.js").Size} [size] Icon size in pixel. Can be used together with `offset` to define the
 * sub-rectangle to use from the origin (sprite) icon image.
 * @property {import("../size.js").Size} [imgSize] Image size in pixels. Only required if `img` is set and `src` is not, and
 * for SVG images in Internet Explorer 11. The provided `imgSize` needs to match the actual size of the image.
 * @property {string} [src] Image source URI.
 */ /**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ var $8463d325b53eeb0c$var$Icon = /** @class */ function(_super) {
    $8463d325b53eeb0c$var$__extends(Icon, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function Icon(opt_options) {
        var _this = this;
        var options = opt_options || {};
        /**
         * @type {number}
         */ var opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
         * @type {number}
         */ var rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
         * @type {number|import("../size.js").Size}
         */ var scale = options.scale !== undefined ? options.scale : 1;
        /**
         * @type {boolean}
         */ var rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        _this = _super.call(this, {
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView
        }) || this;
        /**
         * @private
         * @type {Array<number>}
         */ _this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
         * @private
         * @type {Array<number>}
         */ _this.normalizedAnchor_ = null;
        /**
         * @private
         * @type {import("./IconOrigin.js").default}
         */ _this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : (0, $546509bca2d85ec0$export$2e2bcd8739ae039).TOP_LEFT;
        /**
         * @private
         * @type {import("./IconAnchorUnits.js").default}
         */ _this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : (0, $61c65c2463af340d$export$2e2bcd8739ae039).FRACTION;
        /**
         * @private
         * @type {import("./IconAnchorUnits.js").default}
         */ _this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : (0, $61c65c2463af340d$export$2e2bcd8739ae039).FRACTION;
        /**
         * @private
         * @type {?string}
         */ _this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
         * @type {HTMLImageElement|HTMLCanvasElement}
         */ var image = options.img !== undefined ? options.img : null;
        /**
         * @type {import("../size.js").Size}
         */ var imgSize = options.imgSize !== undefined ? options.imgSize : null;
        /**
         * @type {string|undefined}
         */ var src = options.src;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!(src !== undefined && image), 4); // `image` and `src` cannot be provided at the same time
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!image || image && imgSize, 5); // `imgSize` must be set when `image` is provided
        if ((src === undefined || src.length === 0) && image) src = /** @type {HTMLImageElement} */ image.src || (0, $6c5e11070e371322$export$5e82334337e0f204)(image);
        (0, $35d5ec884318008e$export$a7a9523472993e97)(src !== undefined && src.length > 0, 6); // A defined and non-empty `src` or `image` must be provided
        /**
         * @type {import("../ImageState.js").default}
         */ var imageState = options.src !== undefined ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE : (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
        /**
         * @private
         * @type {import("../color.js").Color}
         */ _this.color_ = options.color !== undefined ? (0, $322346e1ff7894ca$export$75093a47a9fa838d)(options.color) : null;
        /**
         * @private
         * @type {import("./IconImage.js").default}
         */ _this.iconImage_ = (0, $0e5ad1d3b638689e$export$3988ae62b71be9a3)(image, /** @type {string} */ src, imgSize, _this.crossOrigin_, imageState, _this.color_);
        /**
         * @private
         * @type {Array<number>}
         */ _this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
         * @private
         * @type {import("./IconOrigin.js").default}
         */ _this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : (0, $546509bca2d85ec0$export$2e2bcd8739ae039).TOP_LEFT;
        /**
         * @private
         * @type {Array<number>}
         */ _this.origin_ = null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ _this.size_ = options.size !== undefined ? options.size : null;
        return _this;
    }
    /**
     * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
     * @return {Icon} The cloned style.
     * @api
     */ Icon.prototype.clone = function() {
        var scale = this.getScale();
        return new Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            crossOrigin: this.crossOrigin_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            src: this.getSrc(),
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView()
        });
    };
    /**
     * Get the anchor point in pixels. The anchor determines the center point for the
     * symbolizer.
     * @return {Array<number>} Anchor.
     * @api
     */ Icon.prototype.getAnchor = function() {
        if (this.normalizedAnchor_) return this.normalizedAnchor_;
        var anchor = this.anchor_;
        var size = this.getSize();
        if (this.anchorXUnits_ == (0, $61c65c2463af340d$export$2e2bcd8739ae039).FRACTION || this.anchorYUnits_ == (0, $61c65c2463af340d$export$2e2bcd8739ae039).FRACTION) {
            if (!size) return null;
            anchor = this.anchor_.slice();
            if (this.anchorXUnits_ == (0, $61c65c2463af340d$export$2e2bcd8739ae039).FRACTION) anchor[0] *= size[0];
            if (this.anchorYUnits_ == (0, $61c65c2463af340d$export$2e2bcd8739ae039).FRACTION) anchor[1] *= size[1];
        }
        if (this.anchorOrigin_ != (0, $546509bca2d85ec0$export$2e2bcd8739ae039).TOP_LEFT) {
            if (!size) return null;
            if (anchor === this.anchor_) anchor = this.anchor_.slice();
            if (this.anchorOrigin_ == (0, $546509bca2d85ec0$export$2e2bcd8739ae039).TOP_RIGHT || this.anchorOrigin_ == (0, $546509bca2d85ec0$export$2e2bcd8739ae039).BOTTOM_RIGHT) anchor[0] = -anchor[0] + size[0];
            if (this.anchorOrigin_ == (0, $546509bca2d85ec0$export$2e2bcd8739ae039).BOTTOM_LEFT || this.anchorOrigin_ == (0, $546509bca2d85ec0$export$2e2bcd8739ae039).BOTTOM_RIGHT) anchor[1] = -anchor[1] + size[1];
        }
        this.normalizedAnchor_ = anchor;
        return this.normalizedAnchor_;
    };
    /**
     * Set the anchor point. The anchor determines the center point for the
     * symbolizer.
     *
     * @param {Array<number>} anchor Anchor.
     * @api
     */ Icon.prototype.setAnchor = function(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    };
    /**
     * Get the icon color.
     * @return {import("../color.js").Color} Color.
     * @api
     */ Icon.prototype.getColor = function() {
        return this.color_;
    };
    /**
     * Get the image icon.
     * @param {number} pixelRatio Pixel ratio.
     * @return {HTMLImageElement|HTMLCanvasElement} Image or Canvas element.
     * @api
     */ Icon.prototype.getImage = function(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    };
    /**
     * Get the pixel ratio.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} The pixel ration of the image.
     * @api
     */ Icon.prototype.getPixelRatio = function(pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    };
    /**
     * @return {import("../size.js").Size} Image size.
     */ Icon.prototype.getImageSize = function() {
        return this.iconImage_.getSize();
    };
    /**
     * @return {import("../size.js").Size} Size of the hit-detection image.
     */ Icon.prototype.getHitDetectionImageSize = function() {
        return this.getImageSize();
    };
    /**
     * @return {import("../ImageState.js").default} Image state.
     */ Icon.prototype.getImageState = function() {
        return this.iconImage_.getImageState();
    };
    /**
     * @return {HTMLImageElement|HTMLCanvasElement} Image element.
     */ Icon.prototype.getHitDetectionImage = function() {
        return this.iconImage_.getHitDetectionImage();
    };
    /**
     * Get the origin of the symbolizer.
     * @return {Array<number>} Origin.
     * @api
     */ Icon.prototype.getOrigin = function() {
        if (this.origin_) return this.origin_;
        var offset = this.offset_;
        var displacement = this.getDisplacement();
        if (this.offsetOrigin_ != (0, $546509bca2d85ec0$export$2e2bcd8739ae039).TOP_LEFT) {
            var size = this.getSize();
            var iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == (0, $546509bca2d85ec0$export$2e2bcd8739ae039).TOP_RIGHT || this.offsetOrigin_ == (0, $546509bca2d85ec0$export$2e2bcd8739ae039).BOTTOM_RIGHT) offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == (0, $546509bca2d85ec0$export$2e2bcd8739ae039).BOTTOM_LEFT || this.offsetOrigin_ == (0, $546509bca2d85ec0$export$2e2bcd8739ae039).BOTTOM_RIGHT) offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        offset[0] += displacement[0];
        offset[1] += displacement[1];
        this.origin_ = offset;
        return this.origin_;
    };
    /**
     * Get the image URL.
     * @return {string|undefined} Image src.
     * @api
     */ Icon.prototype.getSrc = function() {
        return this.iconImage_.getSrc();
    };
    /**
     * Get the size of the icon (in pixels).
     * @return {import("../size.js").Size} Image size.
     * @api
     */ Icon.prototype.getSize = function() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    };
    /**
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */ Icon.prototype.listenImageChange = function(listener) {
        this.iconImage_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, listener);
    };
    /**
     * Load not yet loaded URI.
     * When rendering a feature with an icon style, the vector renderer will
     * automatically call this method. However, you might want to call this
     * method yourself for preloading or other purposes.
     * @api
     */ Icon.prototype.load = function() {
        this.iconImage_.load();
    };
    /**
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */ Icon.prototype.unlistenImageChange = function(listener) {
        this.iconImage_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, listener);
    };
    return Icon;
}((0, $e60011aea38e6239$export$2e2bcd8739ae039));
var $8463d325b53eeb0c$export$2e2bcd8739ae039 = $8463d325b53eeb0c$var$Icon;





function $13dfa0283bf5c35f$export$bd05e394339d469(size, transforms, features, styleFunction, extent, resolution, rotation) {
    var width = size[0] / 2;
    var height = size[1] / 2;
    var context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(width, height);
    context.imageSmoothingEnabled = false;
    var canvas = context.canvas;
    var renderer = new (0, $7b0c2128a27f5020$export$2e2bcd8739ae039)(context, 0.5, extent, null, rotation);
    var featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    var indexFactor = Math.floor(16777215 / featureCount);
    var featuresByZIndex = {};
    for(var i = 1; i <= featureCount; ++i){
        var feature = features[i - 1];
        var featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!styleFunction) continue;
        var styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        var index = i * indexFactor;
        var color = '#' + ('000000' + index.toString(16)).slice(-6);
        for(var j = 0, jj = styles.length; j < jj; ++j){
            var originalStyle = styles[j];
            var style = originalStyle.clone();
            var fill = style.getFill();
            if (fill) fill.setColor(color);
            var stroke = style.getStroke();
            if (stroke) stroke.setColor(color);
            style.setText(undefined);
            var image = originalStyle.getImage();
            if (image) {
                var imgSize = image.getImageSize();
                if (!imgSize) continue;
                var canvas_1 = document.createElement('canvas');
                canvas_1.width = imgSize[0];
                canvas_1.height = imgSize[1];
                var imgContext = canvas_1.getContext('2d', {
                    alpha: false
                });
                imgContext.fillStyle = color;
                var img = imgContext.canvas;
                imgContext.fillRect(0, 0, img.width, img.height);
                var width_1 = imgSize ? imgSize[0] : img.width;
                var height_1 = imgSize ? imgSize[1] : img.height;
                var iconContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(width_1, height_1);
                iconContext.drawImage(img, 0, 0);
                style.setImage(new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
                    img: img,
                    imgSize: imgSize,
                    anchor: image.getAnchor(),
                    anchorXUnits: (0, $61c65c2463af340d$export$2e2bcd8739ae039).PIXELS,
                    anchorYUnits: (0, $61c65c2463af340d$export$2e2bcd8739ae039).PIXELS,
                    offset: image.getOrigin(),
                    size: image.getSize(),
                    opacity: image.getOpacity(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            var zIndex = Number(style.getZIndex());
            var byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).POLYGON] = [];
                byGeometryType[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).CIRCLE] = [];
                byGeometryType[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING] = [];
                byGeometryType[(0, $419865bd7211e6e7$export$2e2bcd8739ae039).POINT] = [];
            }
            var geometry = style.getGeometryFunction()(feature);
            if (geometry && (0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(extent, geometry.getExtent())) byGeometryType[geometry.getType().replace('Multi', '')].push(geometry, style);
        }
    }
    var zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, $b998d41b678ed5d1$export$4e734a3b32fb971b));
    for(var i = 0, ii = zIndexKeys.length; i < ii; ++i){
        var byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for(var type in byGeometryType){
            var geomAndStyle = byGeometryType[type];
            for(var j = 0, jj = geomAndStyle.length; j < jj; j += 2){
                renderer.setStyle(geomAndStyle[j + 1]);
                for(var k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function $13dfa0283bf5c35f$export$6d4d555ddbfffa32(pixel, features, imageData) {
    var resultFeatures = [];
    if (imageData) {
        var index = (Math.round(pixel[0] / 2) + Math.round(pixel[1] / 2) * imageData.width) * 4;
        var r = imageData.data[index];
        var g = imageData.data[index + 1];
        var b = imageData.data[index + 2];
        var i = b + 256 * (g + 256 * r);
        var indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}


/**
 * @module ol/renderer/vector
 */ 



/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature feature} or {@link module:ol/render/Feature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ var $4b9ac454600c05d2$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/GeometryType.js").default,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ var $4b9ac454600c05d2$var$GEOMETRY_RENDERERS = {
    'Point': $4b9ac454600c05d2$var$renderPointGeometry,
    'LineString': $4b9ac454600c05d2$var$renderLineStringGeometry,
    'Polygon': $4b9ac454600c05d2$var$renderPolygonGeometry,
    'MultiPoint': $4b9ac454600c05d2$var$renderMultiPointGeometry,
    'MultiLineString': $4b9ac454600c05d2$var$renderMultiLineStringGeometry,
    'MultiPolygon': $4b9ac454600c05d2$var$renderMultiPolygonGeometry,
    'GeometryCollection': $4b9ac454600c05d2$var$renderGeometryCollectionGeometry,
    'Circle': $4b9ac454600c05d2$var$renderCircleGeometry
};
function $4b9ac454600c05d2$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $6c5e11070e371322$export$5e82334337e0f204)(feature1), 10) - parseInt((0, $6c5e11070e371322$export$5e82334337e0f204)(feature2), 10);
}
function $4b9ac454600c05d2$export$75084a70d324c1e6(resolution, pixelRatio) {
    var tolerance = $4b9ac454600c05d2$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $4b9ac454600c05d2$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $4b9ac454600c05d2$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default=} opt_declutterBuilderGroup Builder for decluttering.
 */ function $4b9ac454600c05d2$var$renderCircleGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        var circleReplay = builderGroup.getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).CIRCLE);
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
function $4b9ac454600c05d2$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, opt_transform, opt_declutterBuilderGroup) {
    var loading = false;
    var imageStyle = style.getImage();
    if (imageStyle) {
        var imageState = imageStyle.getImageState();
        if (imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) imageStyle.unlistenImageChange(listener);
        else {
            if (imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) imageStyle.load();
            imageState = imageStyle.getImageState();
            imageStyle.listenImageChange(listener);
            loading = true;
        }
    }
    $4b9ac454600c05d2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, opt_transform, opt_declutterBuilderGroup);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [opt_transform] Optional transform function.
 * @param {import("../render/canvas/BuilderGroup.js").default=} opt_declutterBuilderGroup Builder for decluttering.
 */ function $4b9ac454600c05d2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, opt_transform, opt_declutterBuilderGroup) {
    var geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    var simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, opt_transform);
    var renderer = style.getRenderer();
    if (renderer) $4b9ac454600c05d2$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature);
    else {
        var geometryRenderer = $4b9ac454600c05d2$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, opt_declutterBuilderGroup);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 */ function $4b9ac454600c05d2$var$renderGeometry(replayGroup, geometry, style, feature) {
    if (geometry.getType() == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).GEOMETRY_COLLECTION) {
        var geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(var i = 0, ii = geometries.length; i < ii; ++i)$4b9ac454600c05d2$var$renderGeometry(replayGroup, geometries[i], style, feature);
        return;
    }
    var replay = replayGroup.getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).DEFAULT);
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer());
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default=} opt_declutterBuilderGroup Builder for decluttering.
 */ function $4b9ac454600c05d2$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var geometries = geometry.getGeometriesArray();
    var i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        var geometryRenderer = $4b9ac454600c05d2$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, opt_declutterBuilderGroup);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default=} opt_declutterBuilderGroup Builder for decluttering.
 */ function $4b9ac454600c05d2$var$renderLineStringGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var strokeStyle = style.getStroke();
    if (strokeStyle) {
        var lineStringReplay = builderGroup.getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).LINE_STRING);
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default=} opt_declutterBuilderGroup Builder for decluttering.
 */ function $4b9ac454600c05d2$var$renderMultiLineStringGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var strokeStyle = style.getStroke();
    if (strokeStyle) {
        var lineStringReplay = builderGroup.getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).LINE_STRING);
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default=} opt_declutterBuilderGroup Builder for decluttering.
 */ function $4b9ac454600c05d2$var$renderMultiPolygonGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        var polygonReplay = builderGroup.getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).POLYGON);
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default=} opt_declutterBuilderGroup Builder for decluttering.
 */ function $4b9ac454600c05d2$var$renderPointGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var imageStyle = style.getImage();
    var textStyle = style.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ var declutterImageWithText;
    if (opt_declutterBuilderGroup) {
        builderGroup = opt_declutterBuilderGroup;
        declutterImageWithText = imageStyle && textStyle && textStyle.getText() ? {} : undefined;
    }
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return;
        var imageReplay = builderGroup.getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).IMAGE);
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature);
    }
    if (textStyle && textStyle.getText()) {
        var textReplay = builderGroup.getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default=} opt_declutterBuilderGroup Builder for decluttering.
 */ function $4b9ac454600c05d2$var$renderMultiPointGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var imageStyle = style.getImage();
    var textStyle = style.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ var declutterImageWithText;
    if (opt_declutterBuilderGroup) {
        builderGroup = opt_declutterBuilderGroup;
        declutterImageWithText = imageStyle && textStyle && textStyle.getText() ? {} : undefined;
    }
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return;
        var imageReplay = builderGroup.getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).IMAGE);
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature);
    }
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default=} opt_declutterBuilderGroup Builder for decluttering.
 */ function $4b9ac454600c05d2$var$renderPolygonGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        var polygonReplay = builderGroup.getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).POLYGON);
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), (0, $e74ccf0666398498$export$2e2bcd8739ae039).TEXT);
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}





var $659e0e97392a5f5e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ var $659e0e97392a5f5e$var$CanvasVectorLayerRenderer = /** @class */ function(_super) {
    $659e0e97392a5f5e$var$__extends(CanvasVectorLayerRenderer, _super);
    /**
     * @param {import("../../layer/Vector.js").default} vectorLayer Vector layer.
     */ function CanvasVectorLayerRenderer(vectorLayer) {
        var _this = _super.call(this, vectorLayer) || this;
        /** @private */ _this.boundHandleStyleImageChange_ = _this.handleStyleImageChange_.bind(_this);
        /**
         * @type {boolean}
         */ _this.animatingOrInteracting_;
        /**
         * @private
         * @type {boolean}
         */ _this.dirty_ = false;
        /**
         * @type {ImageData}
         */ _this.hitDetectionImageData_ = null;
        /**
         * @type {Array<import("../../Feature.js").default>}
         */ _this.renderedFeatures_ = null;
        /**
         * @private
         * @type {number}
         */ _this.renderedRevision_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.renderedResolution_ = NaN;
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */ _this.renderedExtent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
         * @private
         * @type {number}
         */ _this.renderedRotation_;
        /**
         * @private
         * @type {import("../../coordinate").Coordinate}
         */ _this.renderedCenter_ = null;
        /**
         * @private
         * @type {import("../../proj/Projection").default}
         */ _this.renderedProjection_ = null;
        /**
         * @private
         * @type {function(import("../../Feature.js").default, import("../../Feature.js").default): number|null}
         */ _this.renderedRenderOrder_ = null;
        /**
         * @private
         * @type {import("../../render/canvas/ExecutorGroup").default}
         */ _this.replayGroup_ = null;
        /**
         * A new replay group had to be created by `prepareFrame()`
         * @type {boolean}
         */ _this.replayGroupChanged = true;
        /**
         * @type {import("../../render/canvas/ExecutorGroup").default}
         */ _this.declutterExecutorGroup = null;
        /**
         * Clipping to be performed by `renderFrame()`
         * @type {boolean}
         */ _this.clipping = true;
        return _this;
    }
    /**
     * Get a rendering container from an existing target, if compatible.
     * @param {HTMLElement} target Potential render target.
     * @param {string} transform CSS Transform.
     * @param {number} opacity Opacity.
     */ CanvasVectorLayerRenderer.prototype.useContainer = function(target, transform, opacity) {
        if (opacity < 1) target = null;
        _super.prototype.useContainer.call(this, target, transform, opacity);
    };
    /**
     * @param {ExecutorGroup} executorGroup Executor group.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("rbush").default=} opt_declutterTree Declutter tree.
     */ CanvasVectorLayerRenderer.prototype.renderWorlds = function(executorGroup, frameState, opt_declutterTree) {
        var extent = frameState.extent;
        var viewState = frameState.viewState;
        var center = viewState.center;
        var resolution = viewState.resolution;
        var projection = viewState.projection;
        var rotation = viewState.rotation;
        var projectionExtent = projection.getExtent();
        var vectorSource = this.getLayer().getSource();
        var pixelRatio = frameState.pixelRatio;
        var viewHints = frameState.viewHints;
        var snapToPixel = !(viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING]);
        var context = this.context;
        var width = Math.round(frameState.size[0] * pixelRatio);
        var height = Math.round(frameState.size[1] * pixelRatio);
        var multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        var worldWidth = multiWorld ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent) : null;
        var endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + 1 : 1;
        var world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) : 0;
        do {
            var transform = this.getRenderTransform(center, resolution, rotation, pixelRatio, width, height, world * worldWidth);
            executorGroup.execute(context, 1, transform, rotation, snapToPixel, undefined, opt_declutterTree);
        }while (++world < endWorld);
    };
    /**
     * Render declutter items for this layer
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     */ CanvasVectorLayerRenderer.prototype.renderDeclutter = function(frameState) {
        if (this.declutterExecutorGroup) this.renderWorlds(this.declutterExecutorGroup, frameState, frameState.declutterTree);
    };
    /**
     * Render the layer.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     */ CanvasVectorLayerRenderer.prototype.renderFrame = function(frameState, target) {
        var pixelRatio = frameState.pixelRatio;
        var layerState = frameState.layerStatesArray[frameState.layerIndex];
        // set forward and inverse pixel transforms
        (0, $e22e7611e69f42a9$export$3e4e33ea14aeb531)(this.pixelTransform, 1 / pixelRatio, 1 / pixelRatio);
        (0, $e22e7611e69f42a9$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
        var canvasTransform = (0, $e22e7611e69f42a9$export$f84e8e69fd4488a5)(this.pixelTransform);
        this.useContainer(target, canvasTransform, layerState.opacity);
        var context = this.context;
        var canvas = context.canvas;
        var replayGroup = this.replayGroup_;
        var declutterExecutorGroup = this.declutterExecutorGroup;
        if ((!replayGroup || replayGroup.isEmpty()) && (!declutterExecutorGroup || declutterExecutorGroup.isEmpty())) {
            if (!this.containerReused && canvas.width > 0) canvas.width = 0;
            return this.container;
        }
        // resize and clear
        var width = Math.round(frameState.size[0] * pixelRatio);
        var height = Math.round(frameState.size[1] * pixelRatio);
        if (canvas.width != width || canvas.height != height) {
            canvas.width = width;
            canvas.height = height;
            if (canvas.style.transform !== canvasTransform) canvas.style.transform = canvasTransform;
        } else if (!this.containerReused) context.clearRect(0, 0, width, height);
        this.preRender(context, frameState);
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        // clipped rendering if layer extent is set
        var clipped = false;
        if (layerState.extent && this.clipping) {
            var layerExtent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, projection);
            clipped = !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(layerExtent, frameState.extent) && (0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
            if (clipped) this.clipUnrotated(context, frameState, layerExtent);
        }
        this.renderWorlds(replayGroup, frameState);
        if (clipped) context.restore();
        this.postRender(context, frameState);
        var opacity = layerState.opacity;
        var container = this.container;
        if (opacity !== parseFloat(container.style.opacity)) container.style.opacity = opacity === 1 ? '' : String(opacity);
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        return this.container;
    };
    /**
     * Asynchronous layer level hit detection.
     * @param {import("../../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../../Feature").default>>} Promise that resolves with an array of features.
     */ CanvasVectorLayerRenderer.prototype.getFeatures = function(pixel) {
        return new Promise(/**
         * @param {function(Array<import("../../Feature").default|import("../../render/Feature").default>): void} resolve Resolver function.
         * @this {CanvasVectorLayerRenderer}
         */ (function(resolve) {
            if (!this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                var size = [
                    this.context.canvas.width,
                    this.context.canvas.height
                ];
                (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(this.pixelTransform, size);
                var center = this.renderedCenter_;
                var resolution = this.renderedResolution_;
                var rotation = this.renderedRotation_;
                var projection = this.renderedProjection_;
                var extent = this.renderedExtent_;
                var layer = this.getLayer();
                var transforms = [];
                var width = size[0] / 2;
                var height = size[1] / 2;
                transforms.push(this.getRenderTransform(center, resolution, rotation, 0.5, width, height, 0).slice());
                var source = layer.getSource();
                var projectionExtent = projection.getExtent();
                if (source.getWrapX() && projection.canWrapX() && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(projectionExtent, extent)) {
                    var startX = extent[0];
                    var worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
                    var world = 0;
                    var offsetX = void 0;
                    while(startX < projectionExtent[0]){
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, 0.5, width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while(startX > projectionExtent[2]){
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, 0.5, width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                this.hitDetectionImageData_ = (0, $13dfa0283bf5c35f$export$bd05e394339d469)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation);
            }
            resolve((0, $13dfa0283bf5c35f$export$6d4d555ddbfffa32)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        }).bind(this));
    };
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
     * @return {T|undefined} Callback result.
     * @template T
     */ CanvasVectorLayerRenderer.prototype.forEachFeatureAtCoordinate = function(coordinate, frameState, hitTolerance, callback, matches) {
        var _this = this;
        if (!this.replayGroup_) return undefined;
        var resolution = frameState.viewState.resolution;
        var rotation = frameState.viewState.rotation;
        var layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ var features = {};
        /**
         * @param {import("../../Feature.js").FeatureLike} feature Feature.
         * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
         * @param {number} distanceSq The squared distance to the click position
         * @return {T|undefined} Callback result.
         */ var featureCallback = function(feature, geometry, distanceSq) {
            var key = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            var match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        var result;
        var executorGroups = [
            this.replayGroup_
        ];
        if (this.declutterExecutorGroup) executorGroups.push(this.declutterExecutorGroup);
        executorGroups.some(function(executorGroup) {
            return result = executorGroup.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, executorGroup === _this.declutterExecutorGroup ? frameState.declutterTree.all().map(function(item) {
                return item.value;
            }) : null);
        });
        return result;
    };
    /**
     * Perform action necessary to get the layer rendered after new fonts have loaded
     */ CanvasVectorLayerRenderer.prototype.handleFontsChanged = function() {
        var layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    };
    /**
     * Handle changes in image style state.
     * @param {import("../../events/Event.js").default} event Image style change event.
     * @private
     */ CanvasVectorLayerRenderer.prototype.handleStyleImageChange_ = function(event) {
        this.renderIfReadyAndVisible();
    };
    /**
     * Determine whether render should be called.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */ CanvasVectorLayerRenderer.prototype.prepareFrame = function(frameState) {
        var vectorLayer = this.getLayer();
        var vectorSource = vectorLayer.getSource();
        if (!vectorSource) return false;
        var animating = frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING];
        var interacting = frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING];
        var updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        var updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (!this.dirty_ && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        var frameStateExtent = frameState.extent;
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        var resolution = viewState.resolution;
        var pixelRatio = frameState.pixelRatio;
        var vectorLayerRevision = vectorLayer.getRevision();
        var vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        var vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $4b9ac454600c05d2$export$531ddd8416d52dfc);
        var center = viewState.center.slice();
        var extent = (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        var loadExtents = [
            extent.slice()
        ];
        var projectionExtent = projection.getExtent();
        if (vectorSource.getWrapX() && projection.canWrapX() && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(projectionExtent, frameState.extent)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            var worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
            var gutter = Math.max((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / 2, worldWidth);
            extent[0] = projectionExtent[0] - gutter;
            extent[2] = projectionExtent[2] + gutter;
            (0, $1bd0a226f9a16141$export$39a9ce3624977b84)(center, projection);
            var loadExtent = (0, $6da4c8ed3074c92b$export$39a9ce3624977b84)(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                loadExtent[0] + worldWidth,
                loadExtent[1],
                loadExtent[2] + worldWidth,
                loadExtent[3]
            ]);
            else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                loadExtent[0] - worldWidth,
                loadExtent[1],
                loadExtent[2] - worldWidth,
                loadExtent[3]
            ]);
        }
        if (!this.dirty_ && this.renderedResolution_ == resolution && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && (0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(this.renderedExtent_, extent)) {
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        this.dirty_ = false;
        var replayGroup = new (0, $e22658f4b743550b$export$2e2bcd8739ae039)((0, $4b9ac454600c05d2$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
        var declutterBuilderGroup;
        if (this.getLayer().getDeclutter()) declutterBuilderGroup = new (0, $e22658f4b743550b$export$2e2bcd8739ae039)((0, $4b9ac454600c05d2$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
        var userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        var userTransform;
        if (userProjection) {
            for(var i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures((0, $9c4744460e43e41b$export$96bfd09e2cffb006)(loadExtents[i], projection), resolution, userProjection);
            userTransform = (0, $9c4744460e43e41b$export$e3c4995a701c26a3)(userProjection, projection);
        } else for(var i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures(loadExtents[i], resolution, projection);
        var squaredTolerance = (0, $4b9ac454600c05d2$export$75084a70d324c1e6)(resolution, pixelRatio);
        var render = /**
         * @param {import("../../Feature.js").default} feature Feature.
         * @this {CanvasVectorLayerRenderer}
         */ (function(feature) {
            var styles;
            var styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                var dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, declutterBuilderGroup);
                this.dirty_ = this.dirty_ || dirty;
            }
        }).bind(this);
        var userExtent = (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */ var features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
        for(var i = 0, ii = features.length; i < ii; ++i)render(features[i]);
        this.renderedFeatures_ = features;
        var replayGroupInstructions = replayGroup.finish();
        var executorGroup = new (0, $a34a824d875e4ea1$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer());
        if (declutterBuilderGroup) this.declutterExecutorGroup = new (0, $a34a824d875e4ea1$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), declutterBuilderGroup.finish(), vectorLayer.getRenderBuffer());
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    };
    /**
     * @param {import("../../Feature.js").default} feature Feature.
     * @param {number} squaredTolerance Squared render tolerance.
     * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
     * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
     * @param {import("../../proj.js").TransformFunction=} opt_transform Transform from user to view projection.
     * @param {import("../../render/canvas/BuilderGroup.js").default=} opt_declutterBuilderGroup Builder for decluttering.
     * @return {boolean} `true` if an image is loading.
     */ CanvasVectorLayerRenderer.prototype.renderFeature = function(feature, squaredTolerance, styles, builderGroup, opt_transform, opt_declutterBuilderGroup) {
        if (!styles) return false;
        var loading = false;
        if (Array.isArray(styles)) for(var i = 0, ii = styles.length; i < ii; ++i)loading = (0, $4b9ac454600c05d2$export$36f470a33a42f413)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, opt_transform, opt_declutterBuilderGroup) || loading;
        else loading = (0, $4b9ac454600c05d2$export$36f470a33a42f413)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, opt_transform, opt_declutterBuilderGroup);
        return loading;
    };
    return CanvasVectorLayerRenderer;
}((0, $42152f52b26b6ca7$export$2e2bcd8739ae039));
var $659e0e97392a5f5e$export$2e2bcd8739ae039 = $659e0e97392a5f5e$var$CanvasVectorLayerRenderer;


var $82a68515bd6ef378$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @extends {BaseVectorLayer<import("../source/Vector.js").default>}
 * @api
 */ var $82a68515bd6ef378$var$VectorLayer = /** @class */ function(_super) {
    $82a68515bd6ef378$var$__extends(VectorLayer, _super);
    /**
     * @param {import("./BaseVector.js").Options=} opt_options Options.
     */ function VectorLayer(opt_options) {
        return _super.call(this, opt_options) || this;
    }
    /**
     * Create a renderer for this layer.
     * @return {import("../renderer/Layer.js").default} A layer renderer.
     */ VectorLayer.prototype.createRenderer = function() {
        return new (0, $659e0e97392a5f5e$export$2e2bcd8739ae039)(this);
    };
    return VectorLayer;
}((0, $c8d6dc4c09ed9916$export$2e2bcd8739ae039));
var $82a68515bd6ef378$export$2e2bcd8739ae039 = $82a68515bd6ef378$var$VectorLayer;



/**
 * @module ol/source/OSM
 */ /**
 * @module ol/source/XYZ
 */ 





var $0f235d2d04095c6e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * A function that takes an {@link module:ol/Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   var xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     var data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~Tile} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes an {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ var $0f235d2d04095c6e$var$Tile = /** @class */ function(_super) {
    $0f235d2d04095c6e$var$__extends(Tile, _super);
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("./TileState.js").default} state State.
     * @param {Options=} opt_options Tile options.
     */ function Tile(tileCoord, state, opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @type {import("./tilecoord.js").TileCoord}
         */ _this.tileCoord = tileCoord;
        /**
         * @protected
         * @type {import("./TileState.js").default}
         */ _this.state = state;
        /**
         * An "interim" tile for this tile. The interim tile may be used while this
         * one is loading, for "smooth" transitions when changing params/dimensions
         * on the source.
         * @type {Tile}
         */ _this.interimTile = null;
        /**
         * The tile is available at the highest possible resolution. Subclasses can
         * set this to `false` initially. Tile load listeners will not be
         * unregistered before this is set to `true` and a `#changed()` is called.
         * @type {boolean}
         */ _this.hifi = true;
        /**
         * A key assigned to the tile. This is used by the tile source to determine
         * if this tile can effectively be used, or if a new tile should be created
         * and this one be used as an interim tile for this new tile.
         * @type {string}
         */ _this.key = '';
        /**
         * The duration for the opacity transition.
         * @type {number}
         */ _this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
         * Lookup of start times for rendering transitions.  If the start time is
         * equal to -1, the transition is complete.
         * @type {Object<string, number>}
         */ _this.transitionStarts_ = {};
        return _this;
    }
    /**
     * @protected
     */ Tile.prototype.changed = function() {
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    };
    /**
     * Called by the tile cache when the tile is removed from the cache due to expiry
     */ Tile.prototype.release = function() {};
    /**
     * @return {string} Key.
     */ Tile.prototype.getKey = function() {
        return this.key + '/' + this.tileCoord;
    };
    /**
     * Get the interim tile most suitable for rendering using the chain of interim
     * tiles. This corresponds to the  most recent tile that has been loaded, if no
     * such tile exists, the original tile is returned.
     * @return {!Tile} Best tile for rendering.
     */ Tile.prototype.getInterimTile = function() {
        if (!this.interimTile) //empty chain
        return this;
        var tile = this.interimTile;
        // find the first loaded tile and return it. Since the chain is sorted in
        // decreasing order of creation time, there is no need to search the remainder
        // of the list (all those tiles correspond to older requests and will be
        // cleaned up by refreshInterimChain)
        do {
            if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                // Show tile immediately instead of fading it in after loading, because
                // the interim tile is in place already
                this.transition_ = 0;
                return tile;
            }
            tile = tile.interimTile;
        }while (tile);
        // we can not find a better tile
        return this;
    };
    /**
     * Goes through the chain of interim tiles and discards sections of the chain
     * that are no longer relevant.
     */ Tile.prototype.refreshInterimChain = function() {
        if (!this.interimTile) return;
        var tile = this.interimTile;
        var prev = /** @type {Tile} */ this;
        do {
            if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                //we have a loaded tile, we can discard the rest of the list
                //we would could abort any LOADING tile request
                //older than this tile (i.e. any LOADING tile following this entry in the chain)
                tile.interimTile = null;
                break;
            } else if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING) //keep this LOADING tile any loaded tiles later in the chain are
            //older than this tile, so we're still interested in the request
            prev = tile;
            else if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) //the head of the list is the most current tile, we don't need
            //to start any other requests for this chain
            prev.interimTile = tile.interimTile;
            else prev = tile;
            tile = prev.interimTile;
        }while (tile);
    };
    /**
     * Get the tile coordinate for this tile.
     * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
     * @api
     */ Tile.prototype.getTileCoord = function() {
        return this.tileCoord;
    };
    /**
     * @return {import("./TileState.js").default} State.
     */ Tile.prototype.getState = function() {
        return this.state;
    };
    /**
     * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
     * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
     * when the tile cannot be loaded. Otherwise the tile cannot be removed from
     * the tile queue and will block other requests.
     * @param {import("./TileState.js").default} state State.
     * @api
     */ Tile.prototype.setState = function(state) {
        if (this.state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR && this.state > state) throw new Error('Tile load sequence violation');
        this.state = state;
        this.changed();
    };
    /**
     * Load the image or retry if loading previously failed.
     * Loading is taken care of by the tile queue, and calling this method is
     * only needed for preloading or for reloading in case of an error.
     * @abstract
     * @api
     */ Tile.prototype.load = function() {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Get the alpha value for rendering.
     * @param {string} id An id for the renderer.
     * @param {number} time The render frame time.
     * @return {number} A number between 0 and 1.
     */ Tile.prototype.getAlpha = function(id, time) {
        if (!this.transition_) return 1;
        var start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        var delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, $c7ccf7e681a9b333$export$929e5a82286172a6)(delta / this.transition_);
    };
    /**
     * Determine if a tile is in an alpha transition.  A tile is considered in
     * transition if tile.getAlpha() has not yet been called or has been called
     * and returned 1.
     * @param {string} id An id for the renderer.
     * @return {boolean} The tile is in transition.
     */ Tile.prototype.inTransition = function(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    };
    /**
     * Mark a transition as complete.
     * @param {string} id An id for the renderer.
     */ Tile.prototype.endTransition = function(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    };
    return Tile;
}((0, $08c28d22c0cb5a39$export$2e2bcd8739ae039));
var $0f235d2d04095c6e$export$2e2bcd8739ae039 = $0f235d2d04095c6e$var$Tile;





var $cd3bc8d185522361$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $cd3bc8d185522361$var$ImageTile = /** @class */ function(_super) {
    $cd3bc8d185522361$var$__extends(ImageTile, _super);
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("./TileState.js").default} state State.
     * @param {string} src Image source URI.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
     * @param {import("./Tile.js").Options=} opt_options Tile options.
     */ function ImageTile(tileCoord, state, src, crossOrigin, tileLoadFunction, opt_options) {
        var _this = _super.call(this, tileCoord, state, opt_options) || this;
        /**
         * @private
         * @type {?string}
         */ _this.crossOrigin_ = crossOrigin;
        /**
         * Image URI
         *
         * @private
         * @type {string}
         */ _this.src_ = src;
        _this.key = src;
        /**
         * @private
         * @type {HTMLImageElement|HTMLCanvasElement}
         */ _this.image_ = new Image();
        if (crossOrigin !== null) _this.image_.crossOrigin = crossOrigin;
        /**
         * @private
         * @type {?function():void}
         */ _this.unlisten_ = null;
        /**
         * @private
         * @type {import("./Tile.js").LoadFunction}
         */ _this.tileLoadFunction_ = tileLoadFunction;
        return _this;
    }
    /**
     * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     * @api
     */ ImageTile.prototype.getImage = function() {
        return this.image_;
    };
    /**
     * Tracks loading or read errors.
     *
     * @private
     */ ImageTile.prototype.handleImageError_ = function() {
        this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.image_ = $cd3bc8d185522361$var$getBlankImage();
        this.changed();
    };
    /**
     * Tracks successful image load.
     *
     * @private
     */ ImageTile.prototype.handleImageLoad_ = function() {
        var image = /** @type {HTMLImageElement} */ this.image_;
        if (image.naturalWidth && image.naturalHeight) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
        else this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        this.unlistenImage_();
        this.changed();
    };
    /**
     * Load not yet loaded URI.
     * @api
     */ ImageTile.prototype.load = function() {
        if (this.state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        }
        if (this.state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = (0, $b54439be79d4619a$export$bc96ecc7c2a50764)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    };
    /**
     * Discards event handlers which listen for load completion or errors.
     *
     * @private
     */ ImageTile.prototype.unlistenImage_ = function() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    };
    return ImageTile;
}((0, $0f235d2d04095c6e$export$2e2bcd8739ae039));
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement} Blank image.
 */ function $cd3bc8d185522361$var$getBlankImage() {
    var ctx = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1);
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $cd3bc8d185522361$export$2e2bcd8739ae039 = $cd3bc8d185522361$var$ImageTile;


/**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ var $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855 = 0.5;
var $8ea51dd7be3ba5e2$export$584433cc24140052 = true;





/**
 * @module ol/reproj/Triangulation
 */ 


/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source
 * @property {Array<import("../coordinate.js").Coordinate>} target
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ var $6be53f6edfbf1854$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ var $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ var $6be53f6edfbf1854$var$Triangulation = /** @class */ function() {
    /**
     * @param {import("../proj/Projection.js").default} sourceProj Source projection.
     * @param {import("../proj/Projection.js").default} targetProj Target projection.
     * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
     * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
     * @param {number} errorThreshold Acceptable error (in source units).
     * @param {?number} opt_destinationResolution The (optional) resolution of the destination.
     */ function Triangulation(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, opt_destinationResolution) {
        /**
         * @type {import("../proj/Projection.js").default}
         * @private
         */ this.sourceProj_ = sourceProj;
        /**
         * @type {import("../proj/Projection.js").default}
         * @private
         */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ var transformInvCache = {};
        var transformInv = (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(this.targetProj_, this.sourceProj_);
        /**
         * @param {import("../coordinate.js").Coordinate} c A coordinate.
         * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
         * @private
         */ this.transformInv_ = function(c) {
            var key = c[0] + '/' + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
         * @type {import("../extent.js").Extent}
         * @private
         */ this.maxSourceExtent_ = maxSourceExtent;
        /**
         * @type {number}
         * @private
         */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
         * @type {Array<Triangle>}
         * @private
         */ this.triangles_ = [];
        /**
         * Indicates that the triangulation crosses edge of the source projection.
         * @type {boolean}
         * @private
         */ this.wrapsXInSource_ = false;
        /**
         * @type {boolean}
         * @private
         */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(maxSourceExtent) == (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent());
        /**
         * @type {?number}
         * @private
         */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent()) : null;
        /**
         * @type {?number}
         * @private
         */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.targetProj_.getExtent()) : null;
        var destinationTopLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(targetExtent);
        var destinationTopRight = (0, $6da4c8ed3074c92b$export$b84fa077c8b05295)(targetExtent);
        var destinationBottomRight = (0, $6da4c8ed3074c92b$export$e77c1cf70445e168)(targetExtent);
        var destinationBottomLeft = (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(targetExtent);
        var sourceTopLeft = this.transformInv_(destinationTopLeft);
        var sourceTopRight = this.transformInv_(destinationTopRight);
        var sourceBottomRight = this.transformInv_(destinationBottomRight);
        var sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
         * The maxSubdivision controls how many splittings of the target area can
         * be done. The idea here is to do a linear mapping of the target areas
         * but the actual overal reprojection (can be) extremely non-linear. The
         * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
         * tile size. However this function is also called to remap canvas rendered
         * layers which can be much larger. This calculation increases the maxSubdivision
         * value by the right factor so that each 256x256 pixel area has
         * MAX_SUBDIVISION divisions.
         */ var maxSubdivision = $6be53f6edfbf1854$var$MAX_SUBDIVISION + (opt_destinationResolution ? Math.max(0, Math.ceil((0, $6b000a049d919fe5$export$b9fae0bba9d9094d)((0, $6da4c8ed3074c92b$export$520c40045967cb15)(targetExtent) / (opt_destinationResolution * opt_destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            var leftBound_1 = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound_1 = Math.min(leftBound_1, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach((function(triangle) {
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound_1 > this.sourceWorldWidth_ / 2) {
                    var newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound_1 > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound_1 > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound_1 > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    var minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    var maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            }).bind(this));
        }
        transformInvCache = {};
    }
    /**
     * Adds triangle to the triangulation.
     * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
     * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
     * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
     * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
     * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
     * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
     * @private
     */ Triangulation.prototype.addTriangle_ = function(a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [
                aSrc,
                bSrc,
                cSrc
            ],
            target: [
                a,
                b,
                c
            ]
        });
    };
    /**
     * Adds quad (points in clock-wise order) to the triangulation
     * (and reprojects the vertices) if valid.
     * Performs quad subdivision if needed to increase precision.
     *
     * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
     * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
     * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
     * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
     * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
     * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
     * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
     * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
     * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
     * @private
     */ Triangulation.prototype.addQuad_ = function(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        var sourceQuadExtent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
            aSrc,
            bSrc,
            cSrc,
            dSrc
        ]);
        var sourceCoverageX = this.sourceWorldWidth_ ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
        var sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        var wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
        var needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                var targetQuadExtent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
                    a,
                    b,
                    c,
                    d
                ]);
                var targetCoverageX = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision = targetCoverageX > $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                return;
            }
        }
        var isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) needsSubdivision = true;
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                var center = [
                    (a[0] + c[0]) / 2,
                    (a[1] + c[1]) / 2
                ];
                var centerSrc = this.transformInv_(center);
                var dx = void 0;
                if (wrapsX) {
                    var centerSrcEstimX = ((0, $6b000a049d919fe5$export$ba467bec01d66def)(aSrc[0], sourceWorldWidth) + (0, $6b000a049d919fe5$export$ba467bec01d66def)(cSrc[0], sourceWorldWidth)) / 2;
                    dx = centerSrcEstimX - (0, $6b000a049d919fe5$export$ba467bec01d66def)(centerSrc[0], sourceWorldWidth);
                } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                var dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                var centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    var bc = [
                        (b[0] + c[0]) / 2,
                        (b[1] + c[1]) / 2
                    ];
                    var bcSrc = this.transformInv_(bc);
                    var da = [
                        (d[0] + a[0]) / 2,
                        (d[1] + a[1]) / 2
                    ];
                    var daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                } else {
                    // split vertically (left & right)
                    var ab = [
                        (a[0] + b[0]) / 2,
                        (a[1] + b[1]) / 2
                    ];
                    var abSrc = this.transformInv_(ab);
                    var cd = [
                        (c[0] + d[0]) / 2,
                        (c[1] + d[1]) / 2
                    ];
                    var cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) return;
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
        }
    };
    /**
     * Calculates extent of the 'source' coordinates from all the triangles.
     *
     * @return {import("../extent.js").Extent} Calculated extent.
     */ Triangulation.prototype.calculateSourceExtent = function() {
        var extent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        this.triangles_.forEach(function(triangle, i, arr) {
            var src = triangle.source;
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(extent, src[0]);
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(extent, src[1]);
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(extent, src[2]);
        });
        return extent;
    };
    /**
     * @return {Array<Triangle>} Array of the calculated triangles.
     */ Triangulation.prototype.getTriangles = function() {
        return this.triangles_;
    };
    return Triangulation;
}();
var $6be53f6edfbf1854$export$2e2bcd8739ae039 = $6be53f6edfbf1854$var$Triangulation;


/**
 * @module ol/reproj
 */ /**
 * @module ol/source/common
 */ /**
 * Default WMS version.
 * @type {string}
 */ var $1dd040dde677fb20$export$8c33e4eedb20eeb5 = '1.3.0';
var $1dd040dde677fb20$export$ab6c91696bd3263e = {
    imageSmoothingEnabled: false,
    msImageSmoothingEnabled: false
};







var $2b0a118af78fb031$var$brokenDiagonalRendering_;
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function $2b0a118af78fb031$var$drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * IE also doesn't. Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function $2b0a118af78fb031$var$isBrokenDiagonalRendering() {
    if ($2b0a118af78fb031$var$brokenDiagonalRendering_ === undefined) {
        var ctx = document.createElement('canvas').getContext('2d');
        ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = 'rgba(210, 0, 0, 0.75)';
        $2b0a118af78fb031$var$drawTestTriangle(ctx, 4, 5, 4, 0);
        $2b0a118af78fb031$var$drawTestTriangle(ctx, 4, 5, 0, 5);
        var data = ctx.getImageData(0, 0, 3, 3).data;
        $2b0a118af78fb031$var$brokenDiagonalRendering_ = $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 0) || $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 4) || $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 8);
    }
    return $2b0a118af78fb031$var$brokenDiagonalRendering_;
}
function $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    var sourceCenter = (0, $9c4744460e43e41b$export$51186ad6e864892a)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    var sourceResolution = (0, $9c4744460e43e41b$export$2d8f7b4eec383d44)(targetProj, targetResolution, targetCenter);
    var targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    var sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    var sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(sourceExtent, sourceCenter)) {
        var compensationFactor = (0, $9c4744460e43e41b$export$2d8f7b4eec383d44)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function $2b0a118af78fb031$export$16d356211d01f1cc(sourceProj, targetProj, targetExtent, targetResolution) {
    var targetCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(targetExtent);
    var sourceResolution = $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, $6da4c8ed3074c92b$export$f9ed8a3d123a08e2)(targetExtent, function(corner) {
        sourceResolution = $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function $2b0a118af78fb031$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, opt_renderEdges, opt_contextOptions) {
    var context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(Math.round(pixelRatio * width), Math.round(pixelRatio * height));
    (0, $beaefe87199bb537$export$e6e34fd1f2686227)(context, opt_contextOptions);
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = 'lighter';
    var sourceDataExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
    sources.forEach(function(src, i, arr) {
        (0, $6da4c8ed3074c92b$export$8b58be045bf06082)(sourceDataExtent, src.extent);
    });
    var canvasWidthInUnits = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceDataExtent);
    var canvasHeightInUnits = (0, $6da4c8ed3074c92b$export$c08559766941f856)(sourceDataExtent);
    var stitchContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(Math.round(pixelRatio * canvasWidthInUnits / sourceResolution), Math.round(pixelRatio * canvasHeightInUnits / sourceResolution));
    (0, $beaefe87199bb537$export$e6e34fd1f2686227)(stitchContext, opt_contextOptions);
    var stitchScale = pixelRatio / sourceResolution;
    sources.forEach(function(src, i, arr) {
        var xPos = src.extent[0] - sourceDataExtent[0];
        var yPos = -(src.extent[3] - sourceDataExtent[3]);
        var srcWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(src.extent);
        var srcHeight = (0, $6da4c8ed3074c92b$export$c08559766941f856)(src.extent);
        // This test should never fail -- but it does. Need to find a fix the upstream condition
        if (src.image.width > 0 && src.image.height > 0) stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, xPos * stitchScale, yPos * stitchScale, srcWidth * stitchScale, srcHeight * stitchScale);
    });
    var targetTopLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
         * Resulting matrix can be used to transform coordinate
         * from `sourceProjection` to destination pixels.
         *
         * To optimize number of context calls and increase numerical stability,
         * we also do the following operations:
         * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
         * here before solving the linear system so [ui, vi] are pixel coordinates.
         *
         * Src points: xi, yi
         * Dst points: ui, vi
         * Affine coefficients: aij
         *
         * | x0 y0 1  0  0 0 |   |a00|   |u0|
         * | x1 y1 1  0  0 0 |   |a01|   |u1|
         * | x2 y2 1  0  0 0 | x |a02| = |u2|
         * |  0  0 0 x0 y0 1 |   |a10|   |v0|
         * |  0  0 0 x1 y1 1 |   |a11|   |v1|
         * |  0  0 0 x2 y2 1 |   |a12|   |v2|
         */ var source = triangle.source;
        var target = triangle.target;
        var x0 = source[0][0], y0 = source[0][1];
        var x1 = source[1][0], y1 = source[1][1];
        var x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        var u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        var v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        var u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        var v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        var u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        var v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        var sourceNumericalShiftX = x0;
        var sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        var augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        var affineCoefs = (0, $6b000a049d919fe5$export$8240f01c446270e6)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if ($2b0a118af78fb031$var$isBrokenDiagonalRendering() || opt_contextOptions === (0, $1dd040dde677fb20$export$ab6c91696bd3263e)) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            var steps = 4;
            var ud = u0 - u1;
            var vd = v0 - v1;
            for(var step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        context.scale(sourceResolution / pixelRatio, -sourceResolution / pixelRatio);
        context.drawImage(stitchContext.canvas, 0, 0);
        context.restore();
    });
    if (opt_renderEdges) {
        context.save();
        context.globalCompositeOperation = 'source-over';
        context.strokeStyle = 'black';
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            var target = triangle.target;
            var u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            var v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            var u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            var v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            var u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            var v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}





var $398e350e33050c07$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {function(number, number, number, number) : import("../Tile.js").default} FunctionType
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ var $398e350e33050c07$var$ReprojTile = /** @class */ function(_super) {
    $398e350e33050c07$var$__extends(ReprojTile, _super);
    /**
     * @param {import("../proj/Projection.js").default} sourceProj Source projection.
     * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
     * @param {import("../proj/Projection.js").default} targetProj Target projection.
     * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
     * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
     * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
     * @param {number} pixelRatio Pixel ratio.
     * @param {number} gutter Gutter of the source tiles.
     * @param {FunctionType} getTileFunction
     *     Function returning source tiles (z, x, y, pixelRatio).
     * @param {number=} opt_errorThreshold Acceptable reprojection error (in px).
     * @param {boolean=} opt_renderEdges Render reprojection edges.
     * @param {object=} opt_contextOptions Properties to set on the canvas context.
     */ function ReprojTile(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, opt_errorThreshold, opt_renderEdges, opt_contextOptions) {
        var _this = _super.call(this, tileCoord, (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) || this;
        /**
         * @private
         * @type {boolean}
         */ _this.renderEdges_ = opt_renderEdges !== undefined ? opt_renderEdges : false;
        /**
         * @private
         * @type {object}
         */ _this.contextOptions_ = opt_contextOptions;
        /**
         * @private
         * @type {number}
         */ _this.pixelRatio_ = pixelRatio;
        /**
         * @private
         * @type {number}
         */ _this.gutter_ = gutter;
        /**
         * @private
         * @type {HTMLCanvasElement}
         */ _this.canvas_ = null;
        /**
         * @private
         * @type {import("../tilegrid/TileGrid.js").default}
         */ _this.sourceTileGrid_ = sourceTileGrid;
        /**
         * @private
         * @type {import("../tilegrid/TileGrid.js").default}
         */ _this.targetTileGrid_ = targetTileGrid;
        /**
         * @private
         * @type {import("../tilecoord.js").TileCoord}
         */ _this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
         * @private
         * @type {!Array<import("../Tile.js").default>}
         */ _this.sourceTiles_ = [];
        /**
         * @private
         * @type {?Array<import("../events.js").EventsKey>}
         */ _this.sourcesListenerKeys_ = null;
        /**
         * @private
         * @type {number}
         */ _this.sourceZ_ = 0;
        var targetExtent = targetTileGrid.getTileCoordExtent(_this.wrappedTileCoord_);
        var maxTargetExtent = _this.targetTileGrid_.getExtent();
        var maxSourceExtent = _this.sourceTileGrid_.getExtent();
        var limitedTargetExtent = maxTargetExtent ? (0, $6da4c8ed3074c92b$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $6da4c8ed3074c92b$export$520c40045967cb15)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            _this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return _this;
        }
        var sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(maxSourceExtent, sourceProjExtent);
        }
        var targetResolution = targetTileGrid.getResolution(_this.wrappedTileCoord_[0]);
        var sourceResolution = (0, $2b0a118af78fb031$export$16d356211d01f1cc)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            _this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return _this;
        }
        var errorThresholdInPixels = opt_errorThreshold !== undefined ? opt_errorThreshold : (0, $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855);
        /**
         * @private
         * @type {!import("./Triangulation.js").default}
         */ _this.triangulation_ = new (0, $6be53f6edfbf1854$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (_this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            _this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return _this;
        }
        _this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        var sourceExtent = _this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $6da4c8ed3074c92b$export$520c40045967cb15)(sourceExtent)) _this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        else {
            var sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(sourceExtent, _this.sourceZ_);
            for(var srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(var srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                var tile = getTileFunction(_this.sourceZ_, srcX, srcY, pixelRatio);
                if (tile) _this.sourceTiles_.push(tile);
            }
            if (_this.sourceTiles_.length === 0) _this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        }
        return _this;
    }
    /**
     * Get the HTML Canvas element for this tile.
     * @return {HTMLCanvasElement} Canvas.
     */ ReprojTile.prototype.getImage = function() {
        return this.canvas_;
    };
    /**
     * @private
     */ ReprojTile.prototype.reproject_ = function() {
        var sources = [];
        this.sourceTiles_.forEach((function(tile, i, arr) {
            if (tile && tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) sources.push({
                extent: this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord),
                image: tile.getImage()
            });
        }).bind(this));
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR;
        else {
            var z = this.wrappedTileCoord_[0];
            var size = this.targetTileGrid_.getTileSize(z);
            var width = typeof size === 'number' ? size : size[0];
            var height = typeof size === 'number' ? size : size[1];
            var targetResolution = this.targetTileGrid_.getResolution(z);
            var sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            var targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, $2b0a118af78fb031$export$b3890eb0ae9dca99)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.contextOptions_);
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
        }
        this.changed();
    };
    /**
     * Load not yet loaded URI.
     */ ReprojTile.prototype.load = function() {
        if (this.state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING;
            this.changed();
            var leftToLoad_1 = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach((function(tile, i, arr) {
                var state = tile.getState();
                if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING) {
                    leftToLoad_1++;
                    var sourceListenKey_1 = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(tile, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, function(e) {
                        var state = tile.getState();
                        if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) {
                            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(sourceListenKey_1);
                            leftToLoad_1--;
                            if (leftToLoad_1 === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    }, this);
                    this.sourcesListenerKeys_.push(sourceListenKey_1);
                }
            }).bind(this));
            this.sourceTiles_.forEach(function(tile, i, arr) {
                var state = tile.getState();
                if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) tile.load();
            });
            if (leftToLoad_1 === 0) setTimeout(this.reproject_.bind(this), 0);
        }
    };
    /**
     * @private
     */ ReprojTile.prototype.unlistenSources_ = function() {
        this.sourcesListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.sourcesListenerKeys_ = null;
    };
    return ReprojTile;
}((0, $0f235d2d04095c6e$export$2e2bcd8739ae039));
var $398e350e33050c07$export$2e2bcd8739ae039 = $398e350e33050c07$var$ReprojTile;


/**
 * @module ol/structs/LRUCache
 */ 
/**
 * @typedef {Object} Entry
 * @property {string} key_
 * @property {Object} newer
 * @property {Object} older
 * @property {*} value_
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ var $859b1614288c6316$var$LRUCache = /** @class */ function() {
    /**
     * @param {number=} opt_highWaterMark High water mark.
     */ function LRUCache(opt_highWaterMark) {
        /**
         * Desired max cache size after expireCache(). If set to 0, no cache entries
         * will be pruned at all.
         * @type {number}
         */ this.highWaterMark = opt_highWaterMark !== undefined ? opt_highWaterMark : 2048;
        /**
         * @private
         * @type {number}
         */ this.count_ = 0;
        /**
         * @private
         * @type {!Object<string, Entry>}
         */ this.entries_ = {};
        /**
         * @private
         * @type {?Entry}
         */ this.oldest_ = null;
        /**
         * @private
         * @type {?Entry}
         */ this.newest_ = null;
    }
    /**
     * @return {boolean} Can expire cache.
     */ LRUCache.prototype.canExpireCache = function() {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    };
    /**
     * FIXME empty description for jsdoc
     */ LRUCache.prototype.clear = function() {
        this.count_ = 0;
        this.entries_ = {};
        this.oldest_ = null;
        this.newest_ = null;
    };
    /**
     * @param {string} key Key.
     * @return {boolean} Contains key.
     */ LRUCache.prototype.containsKey = function(key) {
        return this.entries_.hasOwnProperty(key);
    };
    /**
     * @param {function(T, string, LRUCache<T>): ?} f The function
     *     to call for every entry from the oldest to the newer. This function takes
     *     3 arguments (the entry value, the entry key and the LRUCache object).
     *     The return value is ignored.
     */ LRUCache.prototype.forEach = function(f) {
        var entry = this.oldest_;
        while(entry){
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    };
    /**
     * @param {string} key Key.
     * @param {*=} opt_options Options (reserverd for subclasses).
     * @return {T} Value.
     */ LRUCache.prototype.get = function(key, opt_options) {
        var entry = this.entries_[key];
        (0, $35d5ec884318008e$export$a7a9523472993e97)(entry !== undefined, 15); // Tried to get a value for a key that does not exist in the cache
        if (entry === this.newest_) return entry.value_;
        else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    };
    /**
     * Remove an entry from the cache.
     * @param {string} key The entry key.
     * @return {T} The removed entry.
     */ LRUCache.prototype.remove = function(key) {
        var entry = this.entries_[key];
        (0, $35d5ec884318008e$export$a7a9523472993e97)(entry !== undefined, 15); // Tried to get a value for a key that does not exist in the cache
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    };
    /**
     * @return {number} Count.
     */ LRUCache.prototype.getCount = function() {
        return this.count_;
    };
    /**
     * @return {Array<string>} Keys.
     */ LRUCache.prototype.getKeys = function() {
        var keys = new Array(this.count_);
        var i = 0;
        var entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    };
    /**
     * @return {Array<T>} Values.
     */ LRUCache.prototype.getValues = function() {
        var values = new Array(this.count_);
        var i = 0;
        var entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    };
    /**
     * @return {T} Last value.
     */ LRUCache.prototype.peekLast = function() {
        return this.oldest_.value_;
    };
    /**
     * @return {string} Last key.
     */ LRUCache.prototype.peekLastKey = function() {
        return this.oldest_.key_;
    };
    /**
     * Get the key of the newest item in the cache.  Throws if the cache is empty.
     * @return {string} The newest key.
     */ LRUCache.prototype.peekFirstKey = function() {
        return this.newest_.key_;
    };
    /**
     * @return {T} value Value.
     */ LRUCache.prototype.pop = function() {
        var entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    };
    /**
     * @param {string} key Key.
     * @param {T} value Value.
     */ LRUCache.prototype.replace = function(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    };
    /**
     * @param {string} key Key.
     * @param {T} value Value.
     */ LRUCache.prototype.set = function(key, value) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!(key in this.entries_), 16); // Tried to set a value for a key that is used already
        var entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    };
    /**
     * Set a maximum number of entries for the cache.
     * @param {number} size Cache size.
     * @api
     */ LRUCache.prototype.setSize = function(size) {
        this.highWaterMark = size;
    };
    return LRUCache;
}();
var $859b1614288c6316$export$2e2bcd8739ae039 = $859b1614288c6316$var$LRUCache;


/**
 * @module ol/tilecoord
 */ /**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z` (zoom level), `x` (column), and `y` (row).
 * @typedef {Array<number>} TileCoord
 * @api
 */ /**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord=} opt_tileCoord Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */ function $bf2a04496fadabc6$export$958e3e1a02eac4b6(z, x, y, opt_tileCoord) {
    if (opt_tileCoord !== undefined) {
        opt_tileCoord[0] = z;
        opt_tileCoord[1] = x;
        opt_tileCoord[2] = y;
        return opt_tileCoord;
    } else return [
        z,
        x,
        y
    ];
}
function $bf2a04496fadabc6$export$92d0df0f1d25c63c(z, x, y) {
    return z + '/' + x + '/' + y;
}
function $bf2a04496fadabc6$export$a47fb462a08de82f(tileCoord) {
    return $bf2a04496fadabc6$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $bf2a04496fadabc6$export$a807b7874eb66454(key) {
    return key.split('/').map(Number);
}
function $bf2a04496fadabc6$export$d6af199866bfb566(tileCoord) {
    return (tileCoord[1] << tileCoord[0]) + tileCoord[2];
}
function $bf2a04496fadabc6$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    var z = tileCoord[0];
    var x = tileCoord[1];
    var y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    var tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    else return tileRange.containsXY(x, y);
}


var $a12e09565a34db59$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a12e09565a34db59$var$TileCache = /** @class */ function(_super) {
    $a12e09565a34db59$var$__extends(TileCache, _super);
    function TileCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {!Object<string, boolean>} usedTiles Used tiles.
     */ TileCache.prototype.expireCache = function(usedTiles) {
        while(this.canExpireCache()){
            var tile = this.peekLast();
            if (tile.getKey() in usedTiles) break;
            else this.pop().release();
        }
    };
    /**
     * Prune all tiles from the cache that don't have the same z as the newest tile.
     */ TileCache.prototype.pruneExceptNewestZ = function() {
        if (this.getCount() === 0) return;
        var key = this.peekFirstKey();
        var tileCoord = (0, $bf2a04496fadabc6$export$a807b7874eb66454)(key);
        var z = tileCoord[0];
        this.forEach((function(tile) {
            if (tile.tileCoord[0] !== z) {
                this.remove((0, $bf2a04496fadabc6$export$a47fb462a08de82f)(tile.tileCoord));
                tile.release();
            }
        }).bind(this));
    };
    return TileCache;
}((0, $859b1614288c6316$export$2e2bcd8739ae039));
var $a12e09565a34db59$export$2e2bcd8739ae039 = $a12e09565a34db59$var$TileCache;



/**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $7e3d7a0f8b272861$export$2e2bcd8739ae039 = {
    /**
     * Triggered when a tile starts loading.
     * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
     * @api
     */ TILELOADSTART: 'tileloadstart',
    /**
     * Triggered when a tile finishes loading, either when its data is loaded,
     * or when loading was aborted because the tile is no longer needed.
     * @event module:ol/source/Tile.TileSourceEvent#tileloadend
     * @api
     */ TILELOADEND: 'tileloadend',
    /**
     * Triggered if tile loading results in an error.
     * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
     * @api
     */ TILELOADERROR: 'tileloaderror'
};







var $ed6dc99f268f3882$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * A function that returns a string or an array of strings representing source
 * attributions.
 *
 * @typedef {function(import("../PluggableMap.js").FrameState): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * * a simple string (e.g. `'© Acme Inc.'`)
 * * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions]
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./State.js").default} [state='ready']
 * @property {boolean} [wrapX=false]
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ var $ed6dc99f268f3882$var$Source = /** @class */ function(_super) {
    $ed6dc99f268f3882$var$__extends(Source, _super);
    /**
     * @param {Options} options Source options.
     */ function Source(options) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {import("../proj/Projection.js").default}
         */ _this.projection_ = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.projection);
        /**
         * @private
         * @type {?Attribution}
         */ _this.attributions_ = $ed6dc99f268f3882$var$adaptAttributions(options.attributions);
        /**
         * @private
         * @type {boolean}
         */ _this.attributionsCollapsible_ = options.attributionsCollapsible !== undefined ? options.attributionsCollapsible : true;
        /**
         * This source is currently loading data. Sources that defer loading to the
         * map's tile queue never set this to `true`.
         * @type {boolean}
         */ _this.loading = false;
        /**
         * @private
         * @type {import("./State.js").default}
         */ _this.state_ = options.state !== undefined ? options.state : (0, $98f5bfe3c4864f05$export$2e2bcd8739ae039).READY;
        /**
         * @private
         * @type {boolean}
         */ _this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        return _this;
    }
    /**
     * Get the attribution function for the source.
     * @return {?Attribution} Attribution function.
     */ Source.prototype.getAttributions = function() {
        return this.attributions_;
    };
    /**
     * @return {boolean} Attributions are collapsible.
     */ Source.prototype.getAttributionsCollapsible = function() {
        return this.attributionsCollapsible_;
    };
    /**
     * Get the projection of the source.
     * @return {import("../proj/Projection.js").default} Projection.
     * @api
     */ Source.prototype.getProjection = function() {
        return this.projection_;
    };
    /**
     * @abstract
     * @return {Array<number>|undefined} Resolutions.
     */ Source.prototype.getResolutions = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Get the state of the source, see {@link module:ol/source/State~State} for possible states.
     * @return {import("./State.js").default} State.
     * @api
     */ Source.prototype.getState = function() {
        return this.state_;
    };
    /**
     * @return {boolean|undefined} Wrap X.
     */ Source.prototype.getWrapX = function() {
        return this.wrapX_;
    };
    /**
     * @return {Object|undefined} Context options.
     */ Source.prototype.getContextOptions = function() {
        return undefined;
    };
    /**
     * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
     * @api
     */ Source.prototype.refresh = function() {
        this.changed();
    };
    /**
     * Set the attributions of the source.
     * @param {AttributionLike|undefined} attributions Attributions.
     *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
     *     or `undefined`.
     * @api
     */ Source.prototype.setAttributions = function(attributions) {
        this.attributions_ = $ed6dc99f268f3882$var$adaptAttributions(attributions);
        this.changed();
    };
    /**
     * Set the state of the source.
     * @param {import("./State.js").default} state State.
     */ Source.prototype.setState = function(state) {
        this.state_ = state;
        this.changed();
    };
    return Source;
}((0, $b68b3d6e32e3074a$export$2e2bcd8739ae039));
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {?Attribution} An attribution function (or null).
 */ function $ed6dc99f268f3882$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (Array.isArray(attributionLike)) return function(frameState) {
        return attributionLike;
    };
    if (typeof attributionLike === 'function') return attributionLike;
    return function(frameState) {
        return [
            attributionLike
        ];
    };
}
var $ed6dc99f268f3882$export$2e2bcd8739ae039 = $ed6dc99f268f3882$var$Source;








/**
 * @module ol/tilegrid
 */ 
/**
 * @module ol/tilegrid/TileGrid
 */ 







/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ var $bb602a307ef98bb5$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ var $bb602a307ef98bb5$var$TileGrid = /** @class */ function() {
    /**
     * @param {Options} options Tile grid options.
     */ function TileGrid(options) {
        /**
         * @protected
         * @type {number}
         */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
         * @private
         * @type {!Array<number>}
         */ this.resolutions_ = options.resolutions;
        (0, $35d5ec884318008e$export$a7a9523472993e97)((0, $b998d41b678ed5d1$export$efa610630f9e181)(this.resolutions_, function(a, b) {
            return b - a;
        }, true), 17); // `resolutions` must be sorted in descending order
        // check if we've got a consistent zoom factor and origin
        var zoomFactor;
        if (!options.origins) for(var i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
         * @private
         * @type {number|undefined}
         */ this.zoomFactor_ = zoomFactor;
        /**
         * @protected
         * @type {number}
         */ this.maxZoom = this.resolutions_.length - 1;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
         * @private
         * @type {Array<import("../coordinate.js").Coordinate>}
         */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, $35d5ec884318008e$export$a7a9523472993e97)(this.origins_.length == this.resolutions_.length, 20); // Number of `origins` and `resolutions` must be equal
        }
        var extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(extent);
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, 18); // Either `origin` or `origins` must be configured, never both
        /**
         * @private
         * @type {Array<number|import("../size.js").Size>}
         */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, $35d5ec884318008e$export$a7a9523472993e97)(this.tileSizes_.length == this.resolutions_.length, 19); // Number of `tileSizes` and `resolutions` must be equal
        }
        /**
         * @private
         * @type {number|import("../size.js").Size}
         */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $57cd8651d88957a0$export$6b8cb5cd370bd90c) : null;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, 22); // Either `tileSize` or `tileSizes` must be configured, never both
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */ this.extent_ = extent !== undefined ? extent : null;
        /**
         * @private
         * @type {Array<import("../TileRange.js").default>}
         */ this.fullTileRanges_ = null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ this.tmpSize_ = [
            0,
            0
        ];
        if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map(function(size, z) {
            var tileRange = new (0, $550e524b0d1b61d4$export$2e2bcd8739ae039)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                var restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        }, this);
        else if (extent) this.calculateTileRanges_(extent);
    }
    /**
     * Call a function with each tile coordinate for a given extent and zoom level.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} zoom Integer zoom level.
     * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
     * @api
     */ TileGrid.prototype.forEachTileCoord = function(extent, zoom, callback) {
        var tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for(var i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(var j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
            zoom,
            i,
            j
        ]);
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
     * @param {import("../TileRange.js").default=} opt_tileRange Temporary import("../TileRange.js").default object.
     * @param {import("../extent.js").Extent=} opt_extent Temporary import("../extent.js").Extent object.
     * @return {boolean} Callback succeeded.
     */ TileGrid.prototype.forEachTileCoordParentTileRange = function(tileCoord, callback, opt_tileRange, opt_extent) {
        var tileRange, x, y;
        var tileCoordExtent = null;
        var z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        } else tileCoordExtent = this.getTileCoordExtent(tileCoord, opt_extent);
        while(z >= this.minZoom){
            if (this.zoomFactor_ === 2) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(x, x, y, y, opt_tileRange);
            } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, opt_tileRange);
            if (callback(z, tileRange)) return true;
            --z;
        }
        return false;
    };
    /**
     * Get the extent for this tile grid, if it was configured.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */ TileGrid.prototype.getExtent = function() {
        return this.extent_;
    };
    /**
     * Get the maximum zoom level for the grid.
     * @return {number} Max zoom.
     * @api
     */ TileGrid.prototype.getMaxZoom = function() {
        return this.maxZoom;
    };
    /**
     * Get the minimum zoom level for the grid.
     * @return {number} Min zoom.
     * @api
     */ TileGrid.prototype.getMinZoom = function() {
        return this.minZoom;
    };
    /**
     * Get the origin for the grid at the given zoom level.
     * @param {number} z Integer zoom level.
     * @return {import("../coordinate.js").Coordinate} Origin.
     * @api
     */ TileGrid.prototype.getOrigin = function(z) {
        if (this.origin_) return this.origin_;
        else return this.origins_[z];
    };
    /**
     * Get the resolution for the given zoom level.
     * @param {number} z Integer zoom level.
     * @return {number} Resolution.
     * @api
     */ TileGrid.prototype.getResolution = function(z) {
        return this.resolutions_[z];
    };
    /**
     * Get the list of resolutions for the tile grid.
     * @return {Array<number>} Resolutions.
     * @api
     */ TileGrid.prototype.getResolutions = function() {
        return this.resolutions_;
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../TileRange.js").default=} opt_tileRange Temporary import("../TileRange.js").default object.
     * @param {import("../extent.js").Extent=} opt_extent Temporary import("../extent.js").Extent object.
     * @return {import("../TileRange.js").default} Tile range.
     */ TileGrid.prototype.getTileCoordChildTileRange = function(tileCoord, opt_tileRange, opt_extent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                var minX = tileCoord[1] * 2;
                var minY = tileCoord[2] * 2;
                return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, minX + 1, minY, minY + 1, opt_tileRange);
            }
            var tileCoordExtent = this.getTileCoordExtent(tileCoord, opt_extent);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, opt_tileRange);
        }
        return null;
    };
    /**
     * Get the extent for a tile range.
     * @param {number} z Integer zoom level.
     * @param {import("../TileRange.js").default} tileRange Tile range.
     * @param {import("../extent.js").Extent=} opt_extent Temporary import("../extent.js").Extent object.
     * @return {import("../extent.js").Extent} Extent.
     */ TileGrid.prototype.getTileRangeExtent = function(z, tileRange, opt_extent) {
        var origin = this.getOrigin(z);
        var resolution = this.getResolution(z);
        var tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        var minX = origin[0] + tileRange.minX * tileSize[0] * resolution;
        var maxX = origin[0] + (tileRange.maxX + 1) * tileSize[0] * resolution;
        var minY = origin[1] + tileRange.minY * tileSize[1] * resolution;
        var maxY = origin[1] + (tileRange.maxY + 1) * tileSize[1] * resolution;
        return (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(minX, minY, maxX, maxY, opt_extent);
    };
    /**
     * Get a tile range for the given extent and integer zoom level.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} z Integer zoom level.
     * @param {import("../TileRange.js").default=} opt_tileRange Temporary tile range object.
     * @return {import("../TileRange.js").default} Tile range.
     */ TileGrid.prototype.getTileRangeForExtentAndZ = function(extent, z, opt_tileRange) {
        var tileCoord = $bb602a307ef98bb5$var$tmpTileCoord;
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, tileCoord);
        var minX = tileCoord[1];
        var minY = tileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, tileCoord);
        return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, tileCoord[1], minY, tileCoord[2], opt_tileRange);
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @return {import("../coordinate.js").Coordinate} Tile center.
     */ TileGrid.prototype.getTileCoordCenter = function(tileCoord) {
        var origin = this.getOrigin(tileCoord[0]);
        var resolution = this.getResolution(tileCoord[0]);
        var tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
        ];
    };
    /**
     * Get the extent of a tile coordinate.
     *
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../extent.js").Extent=} opt_extent Temporary extent object.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */ TileGrid.prototype.getTileCoordExtent = function(tileCoord, opt_extent) {
        var origin = this.getOrigin(tileCoord[0]);
        var resolution = this.getResolution(tileCoord[0]);
        var tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        var minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        var minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        var maxX = minX + tileSize[0] * resolution;
        var maxY = minY + tileSize[1] * resolution;
        return (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(minX, minY, maxX, maxY, opt_extent);
    };
    /**
     * Get the tile coordinate for the given map coordinate and resolution.  This
     * method considers that coordinates that intersect tile boundaries should be
     * assigned the higher tile coordinate.
     *
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {number} resolution Resolution.
     * @param {import("../tilecoord.js").TileCoord=} opt_tileCoord Destination import("../tilecoord.js").TileCoord object.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
     * @api
     */ TileGrid.prototype.getTileCoordForCoordAndResolution = function(coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    };
    /**
     * Note that this method should not be called for resolutions that correspond
     * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
     * @param {number} x X.
     * @param {number} y Y.
     * @param {number} resolution Resolution (for a non-integer zoom level).
     * @param {boolean} reverseIntersectionPolicy Instead of letting edge
     *     intersections go to the higher tile coordinate, let edge intersections
     *     go to the lower tile coordinate.
     * @param {import("../tilecoord.js").TileCoord=} opt_tileCoord Temporary import("../tilecoord.js").TileCoord object.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
     * @private
     */ TileGrid.prototype.getTileCoordForXYAndResolution_ = function(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        var z = this.getZForResolution(resolution);
        var scale = resolution / this.getResolution(z);
        var origin = this.getOrigin(z);
        var tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        var adjustX = reverseIntersectionPolicy ? 0.5 : 0;
        var adjustY = reverseIntersectionPolicy ? 0.5 : 0;
        var xFromOrigin = Math.floor((x - origin[0]) / resolution + adjustX);
        var yFromOrigin = Math.floor((origin[1] - y) / resolution + adjustY);
        var tileCoordX = scale * xFromOrigin / tileSize[0];
        var tileCoordY = scale * yFromOrigin / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = Math.ceil(tileCoordX) - 1;
            tileCoordY = Math.ceil(tileCoordY) - 1;
        } else {
            tileCoordX = Math.floor(tileCoordX);
            tileCoordY = Math.floor(tileCoordY);
        }
        return (0, $bf2a04496fadabc6$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    };
    /**
     * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
     * they should have separate implementations.  This method is for integer zoom
     * levels.  The other method should only be called for resolutions corresponding
     * to non-integer zoom levels.
     * @param {number} x Map x coordinate.
     * @param {number} y Map y coordinate.
     * @param {number} z Integer zoom level.
     * @param {boolean} reverseIntersectionPolicy Instead of letting edge
     *     intersections go to the higher tile coordinate, let edge intersections
     *     go to the lower tile coordinate.
     * @param {import("../tilecoord.js").TileCoord=} opt_tileCoord Temporary import("../tilecoord.js").TileCoord object.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
     * @private
     */ TileGrid.prototype.getTileCoordForXYAndZ_ = function(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        var origin = this.getOrigin(z);
        var resolution = this.getResolution(z);
        var tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        var adjustX = reverseIntersectionPolicy ? 0.5 : 0;
        var adjustY = reverseIntersectionPolicy ? 0.5 : 0;
        var xFromOrigin = Math.floor((x - origin[0]) / resolution + adjustX);
        var yFromOrigin = Math.floor((origin[1] - y) / resolution + adjustY);
        var tileCoordX = xFromOrigin / tileSize[0];
        var tileCoordY = yFromOrigin / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = Math.ceil(tileCoordX) - 1;
            tileCoordY = Math.ceil(tileCoordY) - 1;
        } else {
            tileCoordX = Math.floor(tileCoordX);
            tileCoordY = Math.floor(tileCoordY);
        }
        return (0, $bf2a04496fadabc6$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    };
    /**
     * Get a tile coordinate given a map coordinate and zoom level.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {number} z Zoom level.
     * @param {import("../tilecoord.js").TileCoord=} opt_tileCoord Destination import("../tilecoord.js").TileCoord object.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
     * @api
     */ TileGrid.prototype.getTileCoordForCoordAndZ = function(coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @return {number} Tile resolution.
     */ TileGrid.prototype.getTileCoordResolution = function(tileCoord) {
        return this.resolutions_[tileCoord[0]];
    };
    /**
     * Get the tile size for a zoom level. The type of the return value matches the
     * `tileSize` or `tileSizes` that the tile grid was configured with. To always
     * get an `import("../size.js").Size`, run the result through `import("../size.js").Size.toSize()`.
     * @param {number} z Z.
     * @return {number|import("../size.js").Size} Tile size.
     * @api
     */ TileGrid.prototype.getTileSize = function(z) {
        if (this.tileSize_) return this.tileSize_;
        else return this.tileSizes_[z];
    };
    /**
     * @param {number} z Zoom level.
     * @return {import("../TileRange.js").default} Extent tile range for the specified zoom level.
     */ TileGrid.prototype.getFullTileRange = function(z) {
        if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
        else return this.fullTileRanges_[z];
    };
    /**
     * @param {number} resolution Resolution.
     * @param {number=} opt_direction If 0, the nearest resolution will be used.
     *     If 1, the nearest lower resolution will be used. If -1, the nearest
     *     higher resolution will be used. Default is 0.
     * @return {number} Z.
     * @api
     */ TileGrid.prototype.getZForResolution = function(resolution, opt_direction) {
        var z = (0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(this.resolutions_, resolution, opt_direction || 0);
        return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(z, this.minZoom, this.maxZoom);
    };
    /**
     * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
     * @private
     */ TileGrid.prototype.calculateTileRanges_ = function(extent) {
        var length = this.resolutions_.length;
        var fullTileRanges = new Array(length);
        for(var z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        this.fullTileRanges_ = fullTileRanges;
    };
    return TileGrid;
}();
var $bb602a307ef98bb5$export$2e2bcd8739ae039 = $bb602a307ef98bb5$var$TileGrid;







function $5779655d81caea04$export$1f4812384df8a9c5(projection) {
    var tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $5779655d81caea04$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $5779655d81caea04$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    var z = tileCoord[0];
    var center = tileGrid.getTileCoordCenter(tileCoord);
    var projectionExtent = $5779655d81caea04$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(projectionExtent, center)) {
        var worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
        var worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    } else return tileCoord;
}
function $5779655d81caea04$export$ce88871416242df8(extent, opt_maxZoom, opt_tileSize, opt_corner) {
    var corner = opt_corner !== undefined ? opt_corner : (0, $2f35615121725455$export$2e2bcd8739ae039).TOP_LEFT;
    var resolutions = $5779655d81caea04$var$resolutionsFromExtent(extent, opt_maxZoom, opt_tileSize);
    return new (0, $bb602a307ef98bb5$export$2e2bcd8739ae039)({
        extent: extent,
        origin: (0, $6da4c8ed3074c92b$export$a1cfd206661d0801)(extent, corner),
        resolutions: resolutions,
        tileSize: opt_tileSize
    });
}
function $5779655d81caea04$export$38500bbeccc864ff(opt_options) {
    var xyzOptions = opt_options || {};
    var extent = xyzOptions.extent || (0, $9c4744460e43e41b$export$3988ae62b71be9a3)('EPSG:3857').getExtent();
    var gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $5779655d81caea04$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, $bb602a307ef98bb5$export$2e2bcd8739ae039)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number=} opt_maxZoom Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size=} opt_tileSize Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number=} opt_maxResolution Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function $5779655d81caea04$var$resolutionsFromExtent(extent, opt_maxZoom, opt_tileSize, opt_maxResolution) {
    var maxZoom = opt_maxZoom !== undefined ? opt_maxZoom : (0, $57cd8651d88957a0$export$e98a216cdcc847dc);
    var height = (0, $6da4c8ed3074c92b$export$c08559766941f856)(extent);
    var width = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent);
    var tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(opt_tileSize !== undefined ? opt_tileSize : (0, $57cd8651d88957a0$export$6b8cb5cd370bd90c));
    var maxResolution = opt_maxResolution > 0 ? opt_maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    var length = maxZoom + 1;
    var resolutions = new Array(length);
    for(var z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $5779655d81caea04$export$a251b12f5601c16f(projection, opt_maxZoom, opt_tileSize, opt_corner) {
    var extent = $5779655d81caea04$export$7b5b6ef8fd55fac4(projection);
    return $5779655d81caea04$export$ce88871416242df8(extent, opt_maxZoom, opt_tileSize, opt_corner);
}
function $5779655d81caea04$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
    var extent = projection.getExtent();
    if (!extent) {
        var half = 180 * (0, $03edbd434a9e6608$export$1482081eec883108)[(0, $03edbd434a9e6608$export$2e2bcd8739ae039).DEGREES] / projection.getMetersPerUnit();
        extent = (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(-half, -half, half, half);
    }
    return extent;
}



var $988a11d09320f6a8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions]
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize]
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {number} [tilePixelRatio]
 * @property {import("../proj.js").ProjectionLike} [projection]
 * @property {import("./State.js").default} [state]
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid]
 * @property {boolean} [wrapX=true]
 * @property {number} [transition]
 * @property {string} [key]
 * @property {number} [zDirection=0]
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 * @abstract
 * @api
 */ var $988a11d09320f6a8$var$TileSource = /** @class */ function(_super) {
    $988a11d09320f6a8$var$__extends(TileSource, _super);
    /**
     * @param {Options} options SourceTile source options.
     */ function TileSource(options) {
        var _this = _super.call(this, {
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX
        }) || this;
        /**
         * @private
         * @type {boolean}
         */ _this.opaque_ = options.opaque !== undefined ? options.opaque : false;
        /**
         * @private
         * @type {number}
         */ _this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
         * @protected
         * @type {import("../tilegrid/TileGrid.js").default}
         */ _this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        var tileSize = [
            256,
            256
        ];
        var tileGrid = options.tileGrid;
        if (tileGrid) (0, $cc435a5409103773$export$a71a825ff42fb8e1)(tileGrid.getTileSize(tileGrid.getMinZoom()), tileSize);
        /**
         * @protected
         * @type {import("../TileCache.js").default}
         */ _this.tileCache = new (0, $a12e09565a34db59$export$2e2bcd8739ae039)(options.cacheSize || 0);
        /**
         * @protected
         * @type {import("../size.js").Size}
         */ _this.tmpSize = [
            0,
            0
        ];
        /**
         * @private
         * @type {string}
         */ _this.key_ = options.key || '';
        /**
         * @protected
         * @type {import("../Tile.js").Options}
         */ _this.tileOptions = {
            transition: options.transition
        };
        /**
         * zDirection hint, read by the renderer. Indicates which resolution should be used
         * by a renderer if the views resolution does not match any resolution of the tile source.
         * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
         * will be used. If -1, the nearest higher resolution will be used.
         * @type {number}
         */ _this.zDirection = options.zDirection ? options.zDirection : 0;
        return _this;
    }
    /**
     * @return {boolean} Can expire cache.
     */ TileSource.prototype.canExpireCache = function() {
        return this.tileCache.canExpireCache();
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {!Object<string, boolean>} usedTiles Used tiles.
     */ TileSource.prototype.expireCache = function(projection, usedTiles) {
        var tileCache = this.getTileCacheForProjection(projection);
        if (tileCache) tileCache.expireCache(usedTiles);
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {number} z Zoom level.
     * @param {import("../TileRange.js").default} tileRange Tile range.
     * @param {function(import("../Tile.js").default):(boolean|void)} callback Called with each
     *     loaded tile.  If the callback returns `false`, the tile will not be
     *     considered loaded.
     * @return {boolean} The tile range is fully covered with loaded tiles.
     */ TileSource.prototype.forEachLoadedTile = function(projection, z, tileRange, callback) {
        var tileCache = this.getTileCacheForProjection(projection);
        if (!tileCache) return false;
        var covered = true;
        var tile, tileCoordKey, loaded;
        for(var x = tileRange.minX; x <= tileRange.maxX; ++x)for(var y = tileRange.minY; y <= tileRange.maxY; ++y){
            tileCoordKey = (0, $bf2a04496fadabc6$export$92d0df0f1d25c63c)(z, x, y);
            loaded = false;
            if (tileCache.containsKey(tileCoordKey)) {
                tile = /** @type {!import("../Tile.js").default} */ tileCache.get(tileCoordKey);
                loaded = tile.getState() === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
                if (loaded) loaded = callback(tile) !== false;
            }
            if (!loaded) covered = false;
        }
        return covered;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {number} Gutter.
     */ TileSource.prototype.getGutterForProjection = function(projection) {
        return 0;
    };
    /**
     * Return the key to be used for all tiles in the source.
     * @return {string} The key for all tiles.
     * @protected
     */ TileSource.prototype.getKey = function() {
        return this.key_;
    };
    /**
     * Set the value to be used as the key for all tiles in the source.
     * @param {string} key The key for tiles.
     * @protected
     */ TileSource.prototype.setKey = function(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {boolean} Opaque.
     */ TileSource.prototype.getOpaque = function(projection) {
        return this.opaque_;
    };
    /**
     * @return {Array<number>} Resolutions.
     */ TileSource.prototype.getResolutions = function() {
        return this.tileGrid.getResolutions();
    };
    /**
     * @abstract
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../Tile.js").default} Tile.
     */ TileSource.prototype.getTile = function(z, x, y, pixelRatio, projection) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Return the tile grid of the tile source.
     * @return {import("../tilegrid/TileGrid.js").default} Tile grid.
     * @api
     */ TileSource.prototype.getTileGrid = function() {
        return this.tileGrid;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
     */ TileSource.prototype.getTileGridForProjection = function(projection) {
        if (!this.tileGrid) return (0, $5779655d81caea04$export$1f4812384df8a9c5)(projection);
        else return this.tileGrid;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../TileCache.js").default} Tile cache.
     * @protected
     */ TileSource.prototype.getTileCacheForProjection = function(projection) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)((0, $9c4744460e43e41b$export$fe091d73a555748b)(this.getProjection(), projection), 68 // A VectorTile source can only be rendered if it has a projection compatible with the view projection.
        );
        return this.tileCache;
    };
    /**
     * Get the tile pixel ratio for this source. Subclasses may override this
     * method, which is meant to return a supported pixel ratio that matches the
     * provided `pixelRatio` as close as possible.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Tile pixel ratio.
     */ TileSource.prototype.getTilePixelRatio = function(pixelRatio) {
        return this.tilePixelRatio_;
    };
    /**
     * @param {number} z Z.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../size.js").Size} Tile size.
     */ TileSource.prototype.getTilePixelSize = function(z, pixelRatio, projection) {
        var tileGrid = this.getTileGridForProjection(projection);
        var tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        var tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        else return (0, $cc435a5409103773$export$dcdf75081b88279d)(tileSize, tilePixelRatio, this.tmpSize);
    };
    /**
     * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
     * is outside the resolution and extent range of the tile grid, `null` will be
     * returned.
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../proj/Projection.js").default=} opt_projection Projection.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
     *     null if no tile URL should be created for the passed `tileCoord`.
     */ TileSource.prototype.getTileCoordForTileUrlFunction = function(tileCoord, opt_projection) {
        var projection = opt_projection !== undefined ? opt_projection : this.getProjection();
        var tileGrid = this.getTileGridForProjection(projection);
        if (this.getWrapX() && projection.isGlobal()) tileCoord = (0, $5779655d81caea04$export$39a9ce3624977b84)(tileGrid, tileCoord, projection);
        return (0, $bf2a04496fadabc6$export$60bedf8e3e3c3dbe)(tileCoord, tileGrid) ? tileCoord : null;
    };
    /**
     * Remove all cached tiles from the source. The next render cycle will fetch new tiles.
     * @api
     */ TileSource.prototype.clear = function() {
        this.tileCache.clear();
    };
    TileSource.prototype.refresh = function() {
        this.clear();
        _super.prototype.refresh.call(this);
    };
    /**
     * Increases the cache size if needed
     * @param {number} tileCount Minimum number of tiles needed.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */ TileSource.prototype.updateCacheSize = function(tileCount, projection) {
        var tileCache = this.getTileCacheForProjection(projection);
        if (tileCount > tileCache.highWaterMark) tileCache.highWaterMark = tileCount;
    };
    /**
     * Marks a tile coord as being used, without triggering a load.
     * @abstract
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */ TileSource.prototype.useTile = function(z, x, y, projection) {};
    return TileSource;
}((0, $ed6dc99f268f3882$export$2e2bcd8739ae039));
/**
 * @classdesc
 * Events emitted by {@link module:ol/source/Tile~TileSource} instances are instances of this
 * type.
 */ var $988a11d09320f6a8$export$c571855c51e6c4b6 = /** @class */ function(_super) {
    $988a11d09320f6a8$var$__extends(TileSourceEvent, _super);
    /**
     * @param {string} type Type.
     * @param {import("../Tile.js").default} tile The tile.
     */ function TileSourceEvent(type, tile) {
        var _this = _super.call(this, type) || this;
        /**
         * The tile related to the event.
         * @type {import("../Tile.js").default}
         * @api
         */ _this.tile = tile;
        return _this;
    }
    return TileSourceEvent;
}((0, $aeedce20e9577100$export$2e2bcd8739ae039));
var $988a11d09320f6a8$export$2e2bcd8739ae039 = $988a11d09320f6a8$var$TileSource;



/**
 * @module ol/tileurlfunction
 */ 


function $91dd08a0f5859882$export$f0ecb46e90798741(template, tileGrid) {
    var zRegEx = /\{z\}/g;
    var xRegEx = /\{x\}/g;
    var yRegEx = /\{y\}/g;
    var dashYRegEx = /\{-y\}/g;
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        else return template.replace(zRegEx, tileCoord[0].toString()).replace(xRegEx, tileCoord[1].toString()).replace(yRegEx, tileCoord[2].toString()).replace(dashYRegEx, function() {
            var z = tileCoord[0];
            var range = tileGrid.getFullTileRange(z);
            (0, $35d5ec884318008e$export$a7a9523472993e97)(range, 55); // The {-y} placeholder requires a tile grid with extent
            var y = range.getHeight() - tileCoord[2] - 1;
            return y.toString();
        });
    });
}
function $91dd08a0f5859882$export$436f44dbcc31fea3(templates, tileGrid) {
    var len = templates.length;
    var tileUrlFunctions = new Array(len);
    for(var i = 0; i < len; ++i)tileUrlFunctions[i] = $91dd08a0f5859882$export$f0ecb46e90798741(templates[i], tileGrid);
    return $91dd08a0f5859882$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $91dd08a0f5859882$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        else {
            var h = (0, $bf2a04496fadabc6$export$d6af199866bfb566)(tileCoord);
            var index = (0, $6b000a049d919fe5$export$ba467bec01d66def)(h, tileUrlFunctions.length);
            return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
        }
    });
}
function $91dd08a0f5859882$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}
function $91dd08a0f5859882$export$2a1fa079bfd73dde(url) {
    var urls = [];
    var match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        var startCharCode = match[1].charCodeAt(0);
        var stopCharCode = match[2].charCodeAt(0);
        var charCode = void 0;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        var stop_1 = parseInt(match[2], 10);
        for(var i = parseInt(match[1], 10); i <= stop_1; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}




var $e6408236331c2614$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions]
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize]
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection]
 * @property {import("./State.js").default} [state]
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid]
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction
 * @property {number} [tilePixelRatio]
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction]
 * @property {string} [url]
 * @property {Array<string>} [urls]
 * @property {boolean} [wrapX=true]
 * @property {number} [transition]
 * @property {string} [key]
 * @property {number} [zDirection=0]
 */ /**
 * @classdesc
 * Base class for sources providing tiles divided into a tile grid over http.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ var $e6408236331c2614$var$UrlTile = /** @class */ function(_super) {
    $e6408236331c2614$var$__extends(UrlTile, _super);
    /**
     * @param {Options} options Image tile options.
     */ function UrlTile(options) {
        var _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        }) || this;
        /**
         * @private
         * @type {boolean}
         */ _this.generateTileUrlFunction_ = _this.tileUrlFunction === UrlTile.prototype.tileUrlFunction;
        /**
         * @protected
         * @type {import("../Tile.js").LoadFunction}
         */ _this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) _this.tileUrlFunction = options.tileUrlFunction;
        /**
         * @protected
         * @type {!Array<string>|null}
         */ _this.urls = null;
        if (options.urls) _this.setUrls(options.urls);
        else if (options.url) _this.setUrl(options.url);
        /**
         * @private
         * @type {!Object<string, boolean>}
         */ _this.tileLoadingKeys_ = {};
        return _this;
    }
    /**
     * Return the tile load function of the source.
     * @return {import("../Tile.js").LoadFunction} TileLoadFunction
     * @api
     */ UrlTile.prototype.getTileLoadFunction = function() {
        return this.tileLoadFunction;
    };
    /**
     * Return the tile URL function of the source.
     * @return {import("../Tile.js").UrlFunction} TileUrlFunction
     * @api
     */ UrlTile.prototype.getTileUrlFunction = function() {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
    };
    /**
     * Return the URLs used for this source.
     * When a tileUrlFunction is used instead of url or urls,
     * null will be returned.
     * @return {!Array<string>|null} URLs.
     * @api
     */ UrlTile.prototype.getUrls = function() {
        return this.urls;
    };
    /**
     * Handle tile change events.
     * @param {import("../events/Event.js").default} event Event.
     * @protected
     */ UrlTile.prototype.handleTileChange = function(event) {
        var tile = /** @type {import("../Tile.js").default} */ event.target;
        var uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(tile);
        var tileState = tile.getState();
        var type;
        if (tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, $7e3d7a0f8b272861$export$2e2bcd8739ae039).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR ? (0, $7e3d7a0f8b272861$export$2e2bcd8739ae039).TILELOADERROR : tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED ? (0, $7e3d7a0f8b272861$export$2e2bcd8739ae039).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, $988a11d09320f6a8$export$c571855c51e6c4b6)(type, tile));
    };
    /**
     * Set the tile load function of the source.
     * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
     * @api
     */ UrlTile.prototype.setTileLoadFunction = function(tileLoadFunction) {
        this.tileCache.clear();
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    };
    /**
     * Set the tile URL function of the source.
     * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
     * @param {string=} key Optional new tile key for the source.
     * @api
     */ UrlTile.prototype.setTileUrlFunction = function(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        this.tileCache.pruneExceptNewestZ();
        if (typeof key !== 'undefined') this.setKey(key);
        else this.changed();
    };
    /**
     * Set the URL to use for requests.
     * @param {string} url URL.
     * @api
     */ UrlTile.prototype.setUrl = function(url) {
        var urls = (0, $91dd08a0f5859882$export$2a1fa079bfd73dde)(url);
        this.urls = urls;
        this.setUrls(urls);
    };
    /**
     * Set the URLs to use for requests.
     * @param {Array<string>} urls URLs.
     * @api
     */ UrlTile.prototype.setUrls = function(urls) {
        this.urls = urls;
        var key = urls.join('\n');
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $91dd08a0f5859882$export$436f44dbcc31fea3)(urls, this.tileGrid), key);
        else this.setKey(key);
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ UrlTile.prototype.tileUrlFunction = function(tileCoord, pixelRatio, projection) {
        return undefined;
    };
    /**
     * Marks a tile coord as being used, without triggering a load.
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     */ UrlTile.prototype.useTile = function(z, x, y) {
        var tileCoordKey = (0, $bf2a04496fadabc6$export$92d0df0f1d25c63c)(z, x, y);
        if (this.tileCache.containsKey(tileCoordKey)) this.tileCache.get(tileCoordKey);
    };
    return UrlTile;
}((0, $988a11d09320f6a8$export$2e2bcd8739ae039));
var $e6408236331c2614$export$2e2bcd8739ae039 = $e6408236331c2614$var$UrlTile;








var $51d055913ca55b5e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./State.js").default} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get tile URL given a tile coordinate and the projection.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number} [zDirection=0] Indicate which resolution should be used
 * by a renderer if the view resolution does not match any resolution of the tile source.
 * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
 * will be used. If -1, the nearest higher resolution will be used.
 */ /**
 * @classdesc
 * Base class for sources providing images divided into a tile grid.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ var $51d055913ca55b5e$var$TileImage = /** @class */ function(_super) {
    $51d055913ca55b5e$var$__extends(TileImage, _super);
    /**
     * @param {!Options} options Image tile options.
     */ function TileImage(options) {
        var _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $51d055913ca55b5e$var$defaultTileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        }) || this;
        /**
         * @protected
         * @type {?string}
         */ _this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
         * @protected
         * @type {typeof ImageTile}
         */ _this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $cd3bc8d185522361$export$2e2bcd8739ae039);
        /**
         * @protected
         * @type {!Object<string, TileCache>}
         */ _this.tileCacheForProjection = {};
        /**
         * @protected
         * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
         */ _this.tileGridForProjection = {};
        /**
         * @private
         * @type {number|undefined}
         */ _this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
         * @private
         * @type {object|undefined}
         */ _this.contextOptions_ = options.imageSmoothing === false ? (0, $1dd040dde677fb20$export$ab6c91696bd3263e) : undefined;
        /**
         * @private
         * @type {boolean}
         */ _this.renderReprojectionEdges_ = false;
        return _this;
    }
    /**
     * @return {boolean} Can expire cache.
     */ TileImage.prototype.canExpireCache = function() {
        if (!(0, $8ea51dd7be3ba5e2$export$584433cc24140052)) return _super.prototype.canExpireCache.call(this);
        if (this.tileCache.canExpireCache()) return true;
        else for(var key in this.tileCacheForProjection){
            if (this.tileCacheForProjection[key].canExpireCache()) return true;
        }
        return false;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {!Object<string, boolean>} usedTiles Used tiles.
     */ TileImage.prototype.expireCache = function(projection, usedTiles) {
        if (!(0, $8ea51dd7be3ba5e2$export$584433cc24140052)) {
            _super.prototype.expireCache.call(this, projection, usedTiles);
            return;
        }
        var usedTileCache = this.getTileCacheForProjection(projection);
        this.tileCache.expireCache(this.tileCache == usedTileCache ? usedTiles : {});
        for(var id in this.tileCacheForProjection){
            var tileCache = this.tileCacheForProjection[id];
            tileCache.expireCache(tileCache == usedTileCache ? usedTiles : {});
        }
    };
    /**
     * @return {Object|undefined} Context options.
     */ TileImage.prototype.getContextOptions = function() {
        return this.contextOptions_;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {number} Gutter.
     */ TileImage.prototype.getGutterForProjection = function(projection) {
        if ((0, $8ea51dd7be3ba5e2$export$584433cc24140052) && this.getProjection() && projection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(this.getProjection(), projection)) return 0;
        else return this.getGutter();
    };
    /**
     * @return {number} Gutter.
     */ TileImage.prototype.getGutter = function() {
        return 0;
    };
    /**
     * Return the key to be used for all tiles in the source.
     * @return {string} The key for all tiles.
     * @protected
     */ TileImage.prototype.getKey = function() {
        return _super.prototype.getKey.call(this) + (this.contextOptions_ ? '\n' + JSON.stringify(this.contextOptions_) : '');
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {boolean} Opaque.
     */ TileImage.prototype.getOpaque = function(projection) {
        if ((0, $8ea51dd7be3ba5e2$export$584433cc24140052) && this.getProjection() && projection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(this.getProjection(), projection)) return false;
        else return _super.prototype.getOpaque.call(this, projection);
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
     */ TileImage.prototype.getTileGridForProjection = function(projection) {
        if (!(0, $8ea51dd7be3ba5e2$export$584433cc24140052)) return _super.prototype.getTileGridForProjection.call(this, projection);
        var thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, $9c4744460e43e41b$export$fe091d73a555748b)(thisProj, projection))) return this.tileGrid;
        else {
            var projKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(projection);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $5779655d81caea04$export$1f4812384df8a9c5)(projection);
            return this.tileGridForProjection[projKey];
        }
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../TileCache.js").default} Tile cache.
     */ TileImage.prototype.getTileCacheForProjection = function(projection) {
        if (!(0, $8ea51dd7be3ba5e2$export$584433cc24140052)) return _super.prototype.getTileCacheForProjection.call(this, projection);
        var thisProj = this.getProjection();
        if (!thisProj || (0, $9c4744460e43e41b$export$fe091d73a555748b)(thisProj, projection)) return this.tileCache;
        else {
            var projKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(projection);
            if (!(projKey in this.tileCacheForProjection)) this.tileCacheForProjection[projKey] = new (0, $a12e09565a34db59$export$2e2bcd8739ae039)(this.tileCache.highWaterMark);
            return this.tileCacheForProjection[projKey];
        }
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {string} key The key set on the tile.
     * @return {!import("../Tile.js").default} Tile.
     * @private
     */ TileImage.prototype.createTile_ = function(z, x, y, pixelRatio, projection, key) {
        var tileCoord = [
            z,
            x,
            y
        ];
        var urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        var tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        var tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE : (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY, tileUrl !== undefined ? tileUrl : '', this.crossOrigin, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleTileChange.bind(this));
        return tile;
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../Tile.js").default} Tile.
     */ TileImage.prototype.getTile = function(z, x, y, pixelRatio, projection) {
        var sourceProjection = this.getProjection();
        if (!(0, $8ea51dd7be3ba5e2$export$584433cc24140052) || !sourceProjection || !projection || (0, $9c4744460e43e41b$export$fe091d73a555748b)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        else {
            var cache = this.getTileCacheForProjection(projection);
            var tileCoord = [
                z,
                x,
                y
            ];
            var tile = void 0;
            var tileCoordKey = (0, $bf2a04496fadabc6$export$a47fb462a08de82f)(tileCoord);
            if (cache.containsKey(tileCoordKey)) tile = cache.get(tileCoordKey);
            var key = this.getKey();
            if (tile && tile.key == key) return tile;
            else {
                var sourceTileGrid = this.getTileGridForProjection(sourceProjection);
                var targetTileGrid = this.getTileGridForProjection(projection);
                var wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
                var newTile = new (0, $398e350e33050c07$export$2e2bcd8739ae039)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (function(z, x, y, pixelRatio) {
                    return this.getTileInternal(z, x, y, pixelRatio, sourceProjection);
                }).bind(this), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.contextOptions_);
                newTile.key = key;
                if (tile) {
                    newTile.interimTile = tile;
                    newTile.refreshInterimChain();
                    cache.replace(tileCoordKey, newTile);
                } else cache.set(tileCoordKey, newTile);
                return newTile;
            }
        }
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {!import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../Tile.js").default} Tile.
     * @protected
     */ TileImage.prototype.getTileInternal = function(z, x, y, pixelRatio, projection) {
        var tile = null;
        var tileCoordKey = (0, $bf2a04496fadabc6$export$92d0df0f1d25c63c)(z, x, y);
        var key = this.getKey();
        if (!this.tileCache.containsKey(tileCoordKey)) {
            tile = this.createTile_(z, x, y, pixelRatio, projection, key);
            this.tileCache.set(tileCoordKey, tile);
        } else {
            tile = this.tileCache.get(tileCoordKey);
            if (tile.key != key) {
                // The source's params changed. If the tile has an interim tile and if we
                // can use it then we use it. Otherwise we create a new tile.  In both
                // cases we attempt to assign an interim tile to the new tile.
                var interimTile = tile;
                tile = this.createTile_(z, x, y, pixelRatio, projection, key);
                //make the new tile the head of the list,
                if (interimTile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) //the old tile hasn't begun loading yet, and is now outdated, so we can simply discard it
                tile.interimTile = interimTile.interimTile;
                else tile.interimTile = interimTile;
                tile.refreshInterimChain();
                this.tileCache.replace(tileCoordKey, tile);
            }
        }
        return tile;
    };
    /**
     * Sets whether to render reprojection edges or not (usually for debugging).
     * @param {boolean} render Render the edges.
     * @api
     */ TileImage.prototype.setRenderReprojectionEdges = function(render) {
        if (!(0, $8ea51dd7be3ba5e2$export$584433cc24140052) || this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        for(var id in this.tileCacheForProjection)this.tileCacheForProjection[id].clear();
        this.changed();
    };
    /**
     * Sets the tile grid to use when reprojecting the tiles to the given
     * projection instead of the default tile grid for the projection.
     *
     * This can be useful when the default tile grid cannot be created
     * (e.g. projection has no extent defined) or
     * for optimization reasons (custom tile size, resolutions, ...).
     *
     * @param {import("../proj.js").ProjectionLike} projection Projection.
     * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
     * @api
     */ TileImage.prototype.setTileGridForProjection = function(projection, tilegrid) {
        if (0, $8ea51dd7be3ba5e2$export$584433cc24140052) {
            var proj = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
            if (proj) {
                var projKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(proj);
                if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
            }
        }
    };
    return TileImage;
}((0, $e6408236331c2614$export$2e2bcd8739ae039));
/**
 * @param {ImageTile} imageTile Image tile.
 * @param {string} src Source.
 */ function $51d055913ca55b5e$var$defaultTileLoadFunction(imageTile, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $51d055913ca55b5e$export$2e2bcd8739ae039 = $51d055913ca55b5e$var$TileImage;



var $963a7ef65488964c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=42] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom=0] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Not used if `tileGrid` is provided.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get
 * tile URL given a tile coordinate and the projection.
 * Required if `url` or `urls` are not provided.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number} [zDirection=0] Indicate which resolution should be used
 * by a renderer if the view resolution does not match any resolution of the tile source.
 * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
 * will be used. If -1, the nearest higher resolution will be used.
 */ /**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case
 * a `tileUrlFunction` can be used, such as:
 * ```js
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *      coordinate[1] + '/' + (-coordinate[2] - 1) + '.png';
 *  }
 * ```
 * @api
 */ var $963a7ef65488964c$var$XYZ = /** @class */ function(_super) {
    $963a7ef65488964c$var$__extends(XYZ, _super);
    /**
     * @param {Options=} opt_options XYZ options.
     */ function XYZ(opt_options) {
        var _this = this;
        var options = opt_options || {};
        var projection = options.projection !== undefined ? options.projection : 'EPSG:3857';
        var tileGrid = options.tileGrid !== undefined ? options.tileGrid : (0, $5779655d81caea04$export$38500bbeccc864ff)({
            extent: (0, $5779655d81caea04$export$7b5b6ef8fd55fac4)(projection),
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom,
            minZoom: options.minZoom,
            tileSize: options.tileSize
        });
        _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            imageSmoothing: options.imageSmoothing,
            opaque: options.opaque,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        }) || this;
        return _this;
    }
    return XYZ;
}((0, $51d055913ca55b5e$export$2e2bcd8739ae039));
var $963a7ef65488964c$export$2e2bcd8739ae039 = $963a7ef65488964c$var$XYZ;


var $6c8498cc816f2362$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6c8498cc816f2362$export$4de8a5e77eb994ad = '&#169; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.';
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {number} [maxZoom=19] Max zoom.
 * @property {boolean} [opaque=true] Whether the layer is opaque.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [url='https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 */ /**
 * @classdesc
 * Layer source for the OpenStreetMap tile server.
 * @api
 */ var $6c8498cc816f2362$var$OSM = /** @class */ function(_super) {
    $6c8498cc816f2362$var$__extends(OSM, _super);
    /**
     * @param {Options=} [opt_options] Open Street Map options.
     */ function OSM(opt_options) {
        var _this = this;
        var options = opt_options || {};
        var attributions;
        if (options.attributions !== undefined) attributions = options.attributions;
        else attributions = [
            $6c8498cc816f2362$export$4de8a5e77eb994ad
        ];
        var crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : 'anonymous';
        var url = options.url !== undefined ? options.url : 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png';
        _this = _super.call(this, {
            attributions: attributions,
            attributionsCollapsible: false,
            cacheSize: options.cacheSize,
            crossOrigin: crossOrigin,
            imageSmoothing: options.imageSmoothing,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
            opaque: options.opaque !== undefined ? options.opaque : true,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            transition: options.transition,
            url: url,
            wrapX: options.wrapX
        }) || this;
        return _this;
    }
    return OSM;
}((0, $963a7ef65488964c$export$2e2bcd8739ae039));
var $6c8498cc816f2362$export$2e2bcd8739ae039 = $6c8498cc816f2362$var$OSM;







var $9fd014ab6df63665$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature';
 * import Polygon from 'ol/geom/Polygon';
 * import Point from 'ol/geom/Point';
 *
 * var feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon'
 * });
 *
 * // get the polygon geometry
 * var poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * var point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} Geometry
 */ var $9fd014ab6df63665$var$Feature = /** @class */ function(_super) {
    $9fd014ab6df63665$var$__extends(Feature, _super);
    /**
     * @param {Geometry|Object<string, *>=} opt_geometryOrProperties
     *     You may pass a Geometry object directly, or an object literal containing
     *     properties. If you pass an object literal, you may include a Geometry
     *     associated with a `geometry` key.
     */ function Feature(opt_geometryOrProperties) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {number|string|undefined}
         */ _this.id_ = undefined;
        /**
         * @type {string}
         * @private
         */ _this.geometryName_ = 'geometry';
        /**
         * User provided style.
         * @private
         * @type {import("./style/Style.js").StyleLike}
         */ _this.style_ = null;
        /**
         * @private
         * @type {import("./style/Style.js").StyleFunction|undefined}
         */ _this.styleFunction_ = undefined;
        /**
         * @private
         * @type {?import("./events.js").EventsKey}
         */ _this.geometryChangeKey_ = null;
        _this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)(_this.geometryName_), _this.handleGeometryChanged_);
        if (opt_geometryOrProperties) {
            if (typeof /** @type {?} */ opt_geometryOrProperties.getSimplifiedGeometry === 'function') {
                var geometry = /** @type {Geometry} */ opt_geometryOrProperties;
                _this.setGeometry(geometry);
            } else {
                /** @type {Object<string, *>} */ var properties = opt_geometryOrProperties;
                _this.setProperties(properties);
            }
        }
        return _this;
    }
    /**
     * Clone this feature. If the original feature has a geometry it
     * is also cloned. The feature id is not set in the clone.
     * @return {Feature} The clone.
     * @api
     */ Feature.prototype.clone = function() {
        var clone = new Feature(this.hasProperties() ? this.getProperties() : null);
        clone.setGeometryName(this.getGeometryName());
        var geometry = this.getGeometry();
        if (geometry) clone.setGeometry(geometry.clone());
        var style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    };
    /**
     * Get the feature's default geometry.  A feature may have any number of named
     * geometries.  The "default" geometry (the one that is rendered by default) is
     * set when calling {@link module:ol/Feature~Feature#setGeometry}.
     * @return {Geometry|undefined} The default geometry for the feature.
     * @api
     * @observable
     */ Feature.prototype.getGeometry = function() {
        return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
    };
    /**
     * Get the feature identifier.  This is a stable identifier for the feature and
     * is either set when reading data from a remote source or set explicitly by
     * calling {@link module:ol/Feature~Feature#setId}.
     * @return {number|string|undefined} Id.
     * @api
     */ Feature.prototype.getId = function() {
        return this.id_;
    };
    /**
     * Get the name of the feature's default geometry.  By default, the default
     * geometry is named `geometry`.
     * @return {string} Get the property name associated with the default geometry
     *     for this feature.
     * @api
     */ Feature.prototype.getGeometryName = function() {
        return this.geometryName_;
    };
    /**
     * Get the feature's style. Will return what was provided to the
     * {@link module:ol/Feature~Feature#setStyle} method.
     * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
     * @api
     */ Feature.prototype.getStyle = function() {
        return this.style_;
    };
    /**
     * Get the feature's style function.
     * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
     * representing the current style of this feature.
     * @api
     */ Feature.prototype.getStyleFunction = function() {
        return this.styleFunction_;
    };
    /**
     * @private
     */ Feature.prototype.handleGeometryChange_ = function() {
        this.changed();
    };
    /**
     * @private
     */ Feature.prototype.handleGeometryChanged_ = function() {
        if (this.geometryChangeKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        var geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(geometry, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    };
    /**
     * Set the default geometry for the feature.  This will update the property
     * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
     * @param {Geometry|undefined} geometry The new geometry.
     * @api
     * @observable
     */ Feature.prototype.setGeometry = function(geometry) {
        this.set(this.geometryName_, geometry);
    };
    /**
     * Set the style for the feature to override the layer style.  This can be a
     * single style object, an array of styles, or a function that takes a
     * resolution and returns an array of styles. To unset the feature style, call
     * `setStyle()` without arguments or a falsey value.
     * @param {import("./style/Style.js").StyleLike=} opt_style Style for this feature.
     * @api
     * @fires module:ol/events/Event~BaseEvent#event:change
     */ Feature.prototype.setStyle = function(opt_style) {
        this.style_ = opt_style;
        this.styleFunction_ = !opt_style ? undefined : $9fd014ab6df63665$export$bb06ddfd5d66e02e(opt_style);
        this.changed();
    };
    /**
     * Set the feature id.  The feature id is considered stable and may be used when
     * requesting features or comparing identifiers returned from a remote source.
     * The feature id can be used with the
     * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
     * @param {number|string|undefined} id The feature id.
     * @api
     * @fires module:ol/events/Event~BaseEvent#event:change
     */ Feature.prototype.setId = function(id) {
        this.id_ = id;
        this.changed();
    };
    /**
     * Set the property name to be used when getting the feature's default geometry.
     * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
     * this name will be returned.
     * @param {string} name The property name of the default geometry.
     * @api
     */ Feature.prototype.setGeometryName = function(name) {
        this.removeEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)(this.geometryName_), this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)(this.geometryName_), this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    };
    return Feature;
}((0, $b68b3d6e32e3074a$export$2e2bcd8739ae039));
function $9fd014ab6df63665$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === 'function') return obj;
    else {
        /**
         * @type {Array<import("./style/Style.js").default>}
         */ var styles_1;
        if (Array.isArray(obj)) styles_1 = obj;
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === 'function', 41); // Expected an `import("./style/Style.js").Style` or an array of `import("./style/Style.js").Style`
            var style = /** @type {import("./style/Style.js").default} */ obj;
            styles_1 = [
                style
            ];
        }
        return function() {
            return styles_1;
        };
    }
}
var $9fd014ab6df63665$export$2e2bcd8739ae039 = $9fd014ab6df63665$var$Feature;














/**
 * @module ol/geom/flat/interpolate
 */ 

function $43ed5485a1d0c509$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, opt_dest, opt_dimension) {
    var o, t;
    var n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        var x1 = flatCoordinates[offset];
        var y1 = flatCoordinates[offset + 1];
        var length_1 = 0;
        var cumulativeLengths = [
            0
        ];
        for(var i = offset + stride; i < end; i += stride){
            var x2 = flatCoordinates[i];
            var y2 = flatCoordinates[i + 1];
            length_1 += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length_1);
            x1 = x2;
            y1 = y2;
        }
        var target = fraction * length_1;
        var index = (0, $b998d41b678ed5d1$export$2e0ae67339d5f1ac)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    var dimension = opt_dimension > 1 ? opt_dimension : 2;
    var dest = opt_dest ? opt_dest : new Array(dimension);
    for(var i = 0; i < dimension; ++i)dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    return dest;
}
function $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    var coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        } else return null;
    } else if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        } else return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    var lo = offset / stride;
    var hi = end / stride;
    while(lo < hi){
        var mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    var m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    var m1 = flatCoordinates[(lo + 1) * stride - 1];
    var t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(var i = 0; i < stride - 1; ++i)coordinate.push((0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $43ed5485a1d0c509$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    var coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        } else return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        } else return null;
    }
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        else if (m <= flatCoordinates[end - 1]) return $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}




var $292e4002746c8223$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ var $292e4002746c8223$var$LineString = /** @class */ function(_super) {
    $292e4002746c8223$var$__extends(LineString, _super);
    /**
     * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
     *     For internal use, flat coordinates in combination with `opt_layout` are also accepted.
     * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
     */ function LineString(coordinates, opt_layout) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */ _this.flatMidpoint_ = null;
        /**
         * @private
         * @type {number}
         */ _this.flatMidpointRevision_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.maxDeltaRevision_ = -1;
        if (opt_layout !== undefined && !Array.isArray(coordinates[0])) _this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
        else _this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, opt_layout);
        return _this;
    }
    /**
     * Append the passed coordinate to the coordinates of the linestring.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @api
     */ LineString.prototype.appendCoordinate = function(coordinate) {
        if (!this.flatCoordinates) this.flatCoordinates = coordinate.slice();
        else (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, coordinate);
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!LineString} Clone.
     * @api
     */ LineString.prototype.clone = function() {
        var lineString = new LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ LineString.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * Iterate over each segment, calling the provided callback.
     * If the callback returns a truthy value the function returns that
     * value immediately. Otherwise the function returns `false`.
     *
     * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
     *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
     * @return {T|boolean} Value.
     * @template T,S
     * @api
     */ LineString.prototype.forEachSegment = function(callback) {
        return (0, $3e64078bffae1cbd$export$4b80e395e36b5a56)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    };
    /**
     * Returns the coordinate at `m` using linear interpolation, or `null` if no
     * such coordinate exists.
     *
     * `opt_extrapolate` controls extrapolation beyond the range of Ms in the
     * MultiLineString. If `opt_extrapolate` is `true` then Ms less than the first
     * M will return the first coordinate and Ms greater than the last M will
     * return the last coordinate.
     *
     * @param {number} m M.
     * @param {boolean=} opt_extrapolate Extrapolate. Default is `false`.
     * @return {import("../coordinate.js").Coordinate} Coordinate.
     * @api
     */ LineString.prototype.getCoordinateAtM = function(m, opt_extrapolate) {
        if (this.layout != (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYM && this.layout != (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYZM) return null;
        var extrapolate = opt_extrapolate !== undefined ? opt_extrapolate : false;
        return (0, $43ed5485a1d0c509$export$8f44c3c220ef6f09)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    };
    /**
     * Return the coordinates of the linestring.
     * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
     * @api
     */ LineString.prototype.getCoordinates = function() {
        return (0, $5454470599558ddd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * Return the coordinate at the provided fraction along the linestring.
     * The `fraction` is a number between 0 and 1, where 0 is the start of the
     * linestring and 1 is the end.
     * @param {number} fraction Fraction.
     * @param {import("../coordinate.js").Coordinate=} opt_dest Optional coordinate whose values will
     *     be modified. If not provided, a new coordinate will be returned.
     * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
     * @api
     */ LineString.prototype.getCoordinateAt = function(fraction, opt_dest) {
        return (0, $43ed5485a1d0c509$export$687ff82efd78795b)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, opt_dest, this.stride);
    };
    /**
     * Return the length of the linestring on projected plane.
     * @return {number} Length (on projected plane).
     * @api
     */ LineString.prototype.getLength = function() {
        return (0, $bf04349d827c1d16$export$153f8c6b4d8caebc)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * @return {Array<number>} Flat midpoint.
     */ LineString.prototype.getFlatMidpoint = function() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return this.flatMidpoint_;
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {LineString} Simplified LineString.
     * @protected
     */ LineString.prototype.getSimplifiedGeometryInternal = function(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new LineString(simplifiedFlatCoordinates, (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XY);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */ LineString.prototype.getType = function() {
        return (0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ LineString.prototype.intersectsExtent = function(extent) {
        return (0, $acee589e5b390c5c$export$40d8d71841a3d779)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    };
    /**
     * Set the coordinates of the linestring.
     * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
     * @api
     */ LineString.prototype.setCoordinates = function(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return LineString;
}((0, $c76e993e57efc8c4$export$2e2bcd8739ae039));
var $292e4002746c8223$export$2e2bcd8739ae039 = $292e4002746c8223$var$LineString;














var $b4c0e2e13beea46e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ var $b4c0e2e13beea46e$var$MultiLineString = /** @class */ function(_super) {
    $b4c0e2e13beea46e$var$__extends(MultiLineString, _super);
    /**
     * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
     *     Coordinates or LineString geometries. (For internal use, flat coordinates in
     *     combination with `opt_layout` and `opt_ends` are also accepted.)
     * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
     * @param {Array<number>=} opt_ends Flat coordinate ends for internal use.
     */ function MultiLineString(coordinates, opt_layout, opt_ends) {
        var _this = _super.call(this) || this;
        /**
         * @type {Array<number>}
         * @private
         */ _this.ends_ = [];
        /**
         * @private
         * @type {number}
         */ _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) _this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, opt_layout);
        else if (opt_layout !== undefined && opt_ends) {
            _this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
            _this.ends_ = opt_ends;
        } else {
            var layout = _this.getLayout();
            var lineStrings = /** @type {Array<LineString>} */ coordinates;
            var flatCoordinates = [];
            var ends = [];
            for(var i = 0, ii = lineStrings.length; i < ii; ++i){
                var lineString = lineStrings[i];
                if (i === 0) layout = lineString.getLayout();
                (0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            _this.setFlatCoordinates(layout, flatCoordinates);
            _this.ends_ = ends;
        }
        return _this;
    }
    /**
     * Append the passed linestring to the multilinestring.
     * @param {LineString} lineString LineString.
     * @api
     */ MultiLineString.prototype.appendLineString = function(lineString) {
        if (!this.flatCoordinates) this.flatCoordinates = lineString.getFlatCoordinates().slice();
        else (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!MultiLineString} Clone.
     * @api
     */ MultiLineString.prototype.clone = function() {
        var multiLineString = new MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ MultiLineString.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * Returns the coordinate at `m` using linear interpolation, or `null` if no
     * such coordinate exists.
     *
     * `opt_extrapolate` controls extrapolation beyond the range of Ms in the
     * MultiLineString. If `opt_extrapolate` is `true` then Ms less than the first
     * M will return the first coordinate and Ms greater than the last M will
     * return the last coordinate.
     *
     * `opt_interpolate` controls interpolation between consecutive LineStrings
     * within the MultiLineString. If `opt_interpolate` is `true` the coordinates
     * will be linearly interpolated between the last coordinate of one LineString
     * and the first coordinate of the next LineString.  If `opt_interpolate` is
     * `false` then the function will return `null` for Ms falling between
     * LineStrings.
     *
     * @param {number} m M.
     * @param {boolean=} opt_extrapolate Extrapolate. Default is `false`.
     * @param {boolean=} opt_interpolate Interpolate. Default is `false`.
     * @return {import("../coordinate.js").Coordinate} Coordinate.
     * @api
     */ MultiLineString.prototype.getCoordinateAtM = function(m, opt_extrapolate, opt_interpolate) {
        if (this.layout != (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYM && this.layout != (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYZM || this.flatCoordinates.length === 0) return null;
        var extrapolate = opt_extrapolate !== undefined ? opt_extrapolate : false;
        var interpolate = opt_interpolate !== undefined ? opt_interpolate : false;
        return (0, $43ed5485a1d0c509$export$6a3300857e9ef453)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    };
    /**
     * Return the coordinates of the multilinestring.
     * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
     * @api
     */ MultiLineString.prototype.getCoordinates = function() {
        return (0, $5454470599558ddd$export$cbb9596fc0f40db2)(this.flatCoordinates, 0, this.ends_, this.stride);
    };
    /**
     * @return {Array<number>} Ends.
     */ MultiLineString.prototype.getEnds = function() {
        return this.ends_;
    };
    /**
     * Return the linestring at the specified index.
     * @param {number} index Index.
     * @return {LineString} LineString.
     * @api
     */ MultiLineString.prototype.getLineString = function(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $292e4002746c8223$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    };
    /**
     * Return the linestrings of this multilinestring.
     * @return {Array<LineString>} LineStrings.
     * @api
     */ MultiLineString.prototype.getLineStrings = function() {
        var flatCoordinates = this.flatCoordinates;
        var ends = this.ends_;
        var layout = this.layout;
        /** @type {Array<LineString>} */ var lineStrings = [];
        var offset = 0;
        for(var i = 0, ii = ends.length; i < ii; ++i){
            var end = ends[i];
            var lineString = new (0, $292e4002746c8223$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    };
    /**
     * @return {Array<number>} Flat midpoints.
     */ MultiLineString.prototype.getFlatMidpoints = function() {
        var midpoints = [];
        var flatCoordinates = this.flatCoordinates;
        var offset = 0;
        var ends = this.ends_;
        var stride = this.stride;
        for(var i = 0, ii = ends.length; i < ii; ++i){
            var end = ends[i];
            var midpoint = (0, $43ed5485a1d0c509$export$687ff82efd78795b)(flatCoordinates, offset, end, stride, 0.5);
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {MultiLineString} Simplified MultiLineString.
     * @protected
     */ MultiLineString.prototype.getSimplifiedGeometryInternal = function(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        var simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$cedb9900c0b225c2)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new MultiLineString(simplifiedFlatCoordinates, (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XY, simplifiedEnds);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */ MultiLineString.prototype.getType = function() {
        return (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_LINE_STRING;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ MultiLineString.prototype.intersectsExtent = function(extent) {
        return (0, $acee589e5b390c5c$export$fdb1d8e850bf7937)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    };
    /**
     * Set the coordinates of the multilinestring.
     * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
     * @param {GeometryLayout=} opt_layout Layout.
     * @api
     */ MultiLineString.prototype.setCoordinates = function(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        var ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    };
    return MultiLineString;
}((0, $c76e993e57efc8c4$export$2e2bcd8739ae039));
var $b4c0e2e13beea46e$export$2e2bcd8739ae039 = $b4c0e2e13beea46e$var$MultiLineString;



/**
 * @module ol/format/Feature
 */ 



/**
 * @typedef {Object} ReadOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
 * If not provided, the projection will be derived from the data (where possible) or
 * the `dataProjection` of the format is assigned (where set). If the projection
 * can not be derived from the data and if no `dataProjection` is set for a format,
 * the features will not be reprojected.
 * @property {import("../extent.js").Extent} [extent] Tile extent in map units of the tile being read.
 * This is only required when reading data with tile pixels as geometry units. When configured,
 * a `dataProjection` with `TILE_PIXELS` as `units` and the tile's pixel extent as `extent` needs to be
 * provided.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * created by the format reader. If not provided, features will be returned in the
 * `dataProjection`.
 */ /**
 * @typedef {Object} WriteOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
 * If not provided, the `dataProjection` of the format is assigned (where set).
 * If no `dataProjection` is set for a format, the features will be returned
 * in the `featureProjection`.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * that will be serialized by the format writer. If not provided, geometries are assumed
 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
 * as they are provided at construction.  If `true`, the right-hand rule will
 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
 * exterior and counter-clockwise for interior rings).  Note that not all
 * formats support this.  The GeoJSON format does use this property when writing
 * geometries.
 * @property {number} [decimals] Maximum number of decimal places for coordinates.
 * Coordinates are stored internally as floats, but floating-point arithmetic can create
 * coordinates with a large number of decimal places, not generally wanted on output.
 * Set a number here to round coordinates. Can also be used to ensure that
 * coordinates read in can be written back out with the same number of decimals.
 * Default is no rounding.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for feature formats.
 * {@link module:ol/format/Feature~FeatureFormat} subclasses provide the ability to decode and encode
 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
 * file formats.  See the documentation for each format for more details.
 *
 * @abstract
 * @api
 */ var $ec084d0ff9c13a22$var$FeatureFormat = /** @class */ function() {
    function FeatureFormat() {
        /**
         * @protected
         * @type {import("../proj/Projection.js").default}
         */ this.dataProjection = null;
        /**
         * @protected
         * @type {import("../proj/Projection.js").default}
         */ this.defaultFeatureProjection = null;
    }
    /**
     * Adds the data projection to the read options.
     * @param {Document|Element|Object|string} source Source.
     * @param {ReadOptions=} opt_options Options.
     * @return {ReadOptions|undefined} Options.
     * @protected
     */ FeatureFormat.prototype.getReadOptions = function(source, opt_options) {
        var options;
        if (opt_options) {
            var dataProjection = opt_options.dataProjection ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(opt_options.dataProjection) : this.readProjection(source);
            if (opt_options.extent && dataProjection && dataProjection.getUnits() === (0, $03edbd434a9e6608$export$2e2bcd8739ae039).TILE_PIXELS) {
                dataProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(dataProjection);
                dataProjection.setWorldExtent(opt_options.extent);
            }
            options = {
                dataProjection: dataProjection,
                featureProjection: opt_options.featureProjection
            };
        }
        return this.adaptOptions(options);
    };
    /**
     * Sets the `dataProjection` on the options, if no `dataProjection`
     * is set.
     * @param {WriteOptions|ReadOptions|undefined} options
     *     Options.
     * @protected
     * @return {WriteOptions|ReadOptions|undefined}
     *     Updated options.
     */ FeatureFormat.prototype.adaptOptions = function(options) {
        return (0, $beaefe87199bb537$export$e6e34fd1f2686227)({
            dataProjection: this.dataProjection,
            featureProjection: this.defaultFeatureProjection
        }, options);
    };
    /**
     * @abstract
     * @return {import("./FormatType.js").default} Format.
     */ FeatureFormat.prototype.getType = function() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Read a single feature from a source.
     *
     * @abstract
     * @param {Document|Element|Object|string} source Source.
     * @param {ReadOptions=} opt_options Read options.
     * @return {import("../Feature.js").FeatureLike} Feature.
     */ FeatureFormat.prototype.readFeature = function(source, opt_options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Read all features from a source.
     *
     * @abstract
     * @param {Document|Element|ArrayBuffer|Object|string} source Source.
     * @param {ReadOptions=} opt_options Read options.
     * @return {Array<import("../Feature.js").FeatureLike>} Features.
     */ FeatureFormat.prototype.readFeatures = function(source, opt_options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Read a single geometry from a source.
     *
     * @abstract
     * @param {Document|Element|Object|string} source Source.
     * @param {ReadOptions=} opt_options Read options.
     * @return {import("../geom/Geometry.js").default} Geometry.
     */ FeatureFormat.prototype.readGeometry = function(source, opt_options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Read the projection from a source.
     *
     * @abstract
     * @param {Document|Element|Object|string} source Source.
     * @return {import("../proj/Projection.js").default} Projection.
     */ FeatureFormat.prototype.readProjection = function(source) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Encode a feature in this format.
     *
     * @abstract
     * @param {import("../Feature.js").default} feature Feature.
     * @param {WriteOptions=} opt_options Write options.
     * @return {string} Result.
     */ FeatureFormat.prototype.writeFeature = function(feature, opt_options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Encode an array of features in this format.
     *
     * @abstract
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {WriteOptions=} opt_options Write options.
     * @return {string} Result.
     */ FeatureFormat.prototype.writeFeatures = function(features, opt_options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Write a single geometry in this format.
     *
     * @abstract
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {WriteOptions=} opt_options Write options.
     * @return {string} Result.
     */ FeatureFormat.prototype.writeGeometry = function(geometry, opt_options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    return FeatureFormat;
}();
var $ec084d0ff9c13a22$export$2e2bcd8739ae039 = $ec084d0ff9c13a22$var$FeatureFormat;
function $ec084d0ff9c13a22$export$7beeea566b560d4(geometry, write, opt_options) {
    var featureProjection = opt_options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(opt_options.featureProjection) : null;
    var dataProjection = opt_options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(opt_options.dataProjection) : null;
    var transformed;
    if (featureProjection && dataProjection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(featureProjection, dataProjection)) transformed = (write ? geometry.clone() : geometry).transform(write ? featureProjection : dataProjection, write ? dataProjection : featureProjection);
    else transformed = geometry;
    if (write && opt_options && /** @type {WriteOptions} */ opt_options.decimals !== undefined) {
        var power_1 = Math.pow(10, /** @type {WriteOptions} */ opt_options.decimals);
        // if decimals option on write, round each coordinate appropriately
        /**
         * @param {Array<number>} coordinates Coordinates.
         * @return {Array<number>} Transformed coordinates.
         */ var transform = function(coordinates) {
            for(var i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = Math.round(coordinates[i] * power_1) / power_1;
            return coordinates;
        };
        if (transformed === geometry) transformed = geometry.clone();
        transformed.applyTransform(transform);
    }
    return transformed;
}
function $ec084d0ff9c13a22$export$d3e9e4b1c7f2405c(extent, opt_options) {
    var featureProjection = opt_options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(opt_options.featureProjection) : null;
    var dataProjection = opt_options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(opt_options.dataProjection) : null;
    if (featureProjection && dataProjection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(featureProjection, dataProjection)) return (0, $9c4744460e43e41b$export$751c68e0e0efff79)(extent, dataProjection, featureProjection);
    else return extent;
}


/**
 * @module ol/format/FormatType
 */ /**
 * @enum {string}
 */ var $fdcc6dd70a9488b9$export$2e2bcd8739ae039 = {
    ARRAY_BUFFER: 'arraybuffer',
    JSON: 'json',
    TEXT: 'text',
    XML: 'xml'
};




/**
 * @module ol/xml
 */ 
var $a4f89edd2ef65182$export$be284679de3fbea8 = 'http://www.w3.org/2001/XMLSchema-instance';
function $a4f89edd2ef65182$export$7094a064528c7fee(namespaceURI, qualifiedName) {
    return $a4f89edd2ef65182$export$f65ca476c09acec0().createElementNS(namespaceURI, qualifiedName);
}
function $a4f89edd2ef65182$export$b089dda0fde13047(node, normalizeWhitespace) {
    return $a4f89edd2ef65182$export$caa0047a9c11e135(node, normalizeWhitespace, []).join('');
}
function $a4f89edd2ef65182$export$caa0047a9c11e135(node, normalizeWhitespace, accumulator) {
    if (node.nodeType == Node.CDATA_SECTION_NODE || node.nodeType == Node.TEXT_NODE) {
        if (normalizeWhitespace) accumulator.push(String(node.nodeValue).replace(/(\r\n|\r|\n)/g, ''));
        else accumulator.push(node.nodeValue);
    } else {
        var n = void 0;
        for(n = node.firstChild; n; n = n.nextSibling)$a4f89edd2ef65182$export$caa0047a9c11e135(n, normalizeWhitespace, accumulator);
    }
    return accumulator;
}
function $a4f89edd2ef65182$export$62858bae88b53fd0(object) {
    return 'documentElement' in object;
}
function $a4f89edd2ef65182$export$199b05d6829fbbad(node, namespaceURI, name) {
    return node.getAttributeNS(namespaceURI, name) || '';
}
function $a4f89edd2ef65182$export$98e6a39c04603d36(xml) {
    return new DOMParser().parseFromString(xml, 'application/xml');
}
function $a4f89edd2ef65182$export$b2d5eb949eb55a2a(valueReader, opt_this) {
    return(/**
     * @param {Node} node Node.
     * @param {Array<*>} objectStack Object stack.
     */ function(node, objectStack) {
        var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
        if (value !== undefined) {
            var array = /** @type {Array<*>} */ objectStack[objectStack.length - 1];
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(array, value);
        }
    });
}
function $a4f89edd2ef65182$export$18ed2f5932a1b385(valueReader, opt_this) {
    return(/**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */ function(node, objectStack) {
        var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
        if (value !== undefined) {
            var array = /** @type {Array<*>} */ objectStack[objectStack.length - 1];
            array.push(value);
        }
    });
}
function $a4f89edd2ef65182$export$b1b80676c57c5713(valueReader, opt_this) {
    return(/**
     * @param {Node} node Node.
     * @param {Array<*>} objectStack Object stack.
     */ function(node, objectStack) {
        var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
        if (value !== undefined) objectStack[objectStack.length - 1] = value;
    });
}
function $a4f89edd2ef65182$export$145ce5485ab74220(valueReader, opt_property, opt_this) {
    return(/**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */ function(node, objectStack) {
        var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
        if (value !== undefined) {
            var object = /** @type {!Object} */ objectStack[objectStack.length - 1];
            var property = opt_property !== undefined ? opt_property : node.localName;
            var array = void 0;
            if (property in object) array = object[property];
            else {
                array = [];
                object[property] = array;
            }
            array.push(value);
        }
    });
}
function $a4f89edd2ef65182$export$b69a91976ee81208(valueReader, opt_property, opt_this) {
    return(/**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */ function(node, objectStack) {
        var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
        if (value !== undefined) {
            var object = /** @type {!Object} */ objectStack[objectStack.length - 1];
            var property = opt_property !== undefined ? opt_property : node.localName;
            object[property] = value;
        }
    });
}
function $a4f89edd2ef65182$export$77b73fc7f982cc07(nodeWriter, opt_this) {
    return function(node, value, objectStack) {
        nodeWriter.call(opt_this !== undefined ? opt_this : this, node, value, objectStack);
        var parent = /** @type {NodeStackItem} */ objectStack[objectStack.length - 1];
        var parentNode = parent.node;
        parentNode.appendChild(node);
    };
}
function $a4f89edd2ef65182$export$fa227189764d6986(nodeWriter, opt_this) {
    var serializersNS, nodeFactory;
    return function(node, value, objectStack) {
        if (serializersNS === undefined) {
            serializersNS = {};
            var serializers = {};
            serializers[node.localName] = nodeWriter;
            serializersNS[node.namespaceURI] = serializers;
            nodeFactory = $a4f89edd2ef65182$export$7989129829daaabf(node.localName);
        }
        $a4f89edd2ef65182$export$dfdc1655ccc5b9cb(serializersNS, nodeFactory, value, objectStack);
    };
}
function $a4f89edd2ef65182$export$7989129829daaabf(opt_nodeName, opt_namespaceURI) {
    var fixedNodeName = opt_nodeName;
    return(/**
     * @param {*} value Value.
     * @param {Array<*>} objectStack Object stack.
     * @param {string=} opt_nodeName Node name.
     * @return {Node} Node.
     */ function(value, objectStack, opt_nodeName) {
        var context = /** @type {NodeStackItem} */ objectStack[objectStack.length - 1];
        var node = context.node;
        var nodeName = fixedNodeName;
        if (nodeName === undefined) nodeName = opt_nodeName;
        var namespaceURI = opt_namespaceURI !== undefined ? opt_namespaceURI : node.namespaceURI;
        return $a4f89edd2ef65182$export$7094a064528c7fee(namespaceURI, /** @type {string} */ nodeName);
    });
}
var $a4f89edd2ef65182$export$d91b08b611cef144 = $a4f89edd2ef65182$export$7989129829daaabf();
function $a4f89edd2ef65182$export$939885a13683f4dc(object, orderedKeys) {
    var length = orderedKeys.length;
    var sequence = new Array(length);
    for(var i = 0; i < length; ++i)sequence[i] = object[orderedKeys[i]];
    return sequence;
}
function $a4f89edd2ef65182$export$c6eb0402f939765f(namespaceURIs, structure, opt_structureNS) {
    /**
     * @type {Object<string, T>}
     */ var structureNS = opt_structureNS !== undefined ? opt_structureNS : {};
    var i, ii;
    for(i = 0, ii = namespaceURIs.length; i < ii; ++i)structureNS[namespaceURIs[i]] = structure;
    return structureNS;
}
function $a4f89edd2ef65182$export$dc8ce45ce1679f4f(parsersNS, node, objectStack, opt_this) {
    var n;
    for(n = node.firstElementChild; n; n = n.nextElementSibling){
        var parsers = parsersNS[n.namespaceURI];
        if (parsers !== undefined) {
            var parser = parsers[n.localName];
            if (parser !== undefined) parser.call(opt_this, n, objectStack);
        }
    }
}
function $a4f89edd2ef65182$export$5c934df85741dbd1(object, parsersNS, node, objectStack, opt_this) {
    objectStack.push(object);
    $a4f89edd2ef65182$export$dc8ce45ce1679f4f(parsersNS, node, objectStack, opt_this);
    return /** @type {T} */ objectStack.pop();
}
function $a4f89edd2ef65182$export$dfdc1655ccc5b9cb(serializersNS, nodeFactory, values, objectStack, opt_keys, opt_this) {
    var length = (opt_keys !== undefined ? opt_keys : values).length;
    var value, node;
    for(var i = 0; i < length; ++i){
        value = values[i];
        if (value !== undefined) {
            node = nodeFactory.call(opt_this !== undefined ? opt_this : this, value, objectStack, opt_keys !== undefined ? opt_keys[i] : undefined);
            if (node !== undefined) serializersNS[node.namespaceURI][node.localName].call(opt_this, node, value, objectStack);
        }
    }
}
function $a4f89edd2ef65182$export$a79a01f4edad8da8(object, serializersNS, nodeFactory, values, objectStack, opt_keys, opt_this) {
    objectStack.push(object);
    $a4f89edd2ef65182$export$dfdc1655ccc5b9cb(serializersNS, nodeFactory, values, objectStack, opt_keys, opt_this);
    return /** @type {O|undefined} */ objectStack.pop();
}
var $a4f89edd2ef65182$var$xmlSerializer_ = undefined;
function $a4f89edd2ef65182$export$6d77e0eada4b836a(xmlSerializer) {
    $a4f89edd2ef65182$var$xmlSerializer_ = xmlSerializer;
}
function $a4f89edd2ef65182$export$e087df39da12b01f() {
    if ($a4f89edd2ef65182$var$xmlSerializer_ === undefined && typeof XMLSerializer !== 'undefined') $a4f89edd2ef65182$var$xmlSerializer_ = new XMLSerializer();
    return $a4f89edd2ef65182$var$xmlSerializer_;
}
var $a4f89edd2ef65182$var$document_ = undefined;
function $a4f89edd2ef65182$export$4bebdef07101fbd4(document1) {
    $a4f89edd2ef65182$var$document_ = document1;
}
function $a4f89edd2ef65182$export$f65ca476c09acec0() {
    if ($a4f89edd2ef65182$var$document_ === undefined && typeof document !== 'undefined') $a4f89edd2ef65182$var$document_ = document.implementation.createDocument('', '', null);
    return $a4f89edd2ef65182$var$document_;
}


var $ce16c3ce3167dc37$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for XML feature formats.
 *
 * @abstract
 */ var $ce16c3ce3167dc37$var$XMLFeature = /** @class */ function(_super) {
    $ce16c3ce3167dc37$var$__extends(XMLFeature, _super);
    function XMLFeature() {
        var _this = _super.call(this) || this;
        /**
         * @type {XMLSerializer}
         * @private
         */ _this.xmlSerializer_ = (0, $a4f89edd2ef65182$export$e087df39da12b01f)();
        return _this;
    }
    /**
     * @return {import("./FormatType.js").default} Format.
     */ XMLFeature.prototype.getType = function() {
        return (0, $fdcc6dd70a9488b9$export$2e2bcd8739ae039).XML;
    };
    /**
     * Read a single feature.
     *
     * @param {Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
     * @return {import("../Feature.js").default} Feature.
     * @api
     */ XMLFeature.prototype.readFeature = function(source, opt_options) {
        if (!source) return null;
        else if (typeof source === 'string') {
            var doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readFeatureFromDocument(doc, opt_options);
        } else if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readFeatureFromDocument(/** @type {Document} */ source, opt_options);
        else return this.readFeatureFromNode(/** @type {Element} */ source, opt_options);
    };
    /**
     * @param {Document} doc Document.
     * @param {import("./Feature.js").ReadOptions=} opt_options Options.
     * @return {import("../Feature.js").default} Feature.
     */ XMLFeature.prototype.readFeatureFromDocument = function(doc, opt_options) {
        var features = this.readFeaturesFromDocument(doc, opt_options);
        if (features.length > 0) return features[0];
        else return null;
    };
    /**
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions=} opt_options Options.
     * @return {import("../Feature.js").default} Feature.
     */ XMLFeature.prototype.readFeatureFromNode = function(node, opt_options) {
        return null; // not implemented
    };
    /**
     * Read all features from a feature collection.
     *
     * @param {Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions=} opt_options Options.
     * @return {Array<import("../Feature.js").default>} Features.
     * @api
     */ XMLFeature.prototype.readFeatures = function(source, opt_options) {
        if (!source) return [];
        else if (typeof source === 'string') {
            var doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readFeaturesFromDocument(doc, opt_options);
        } else if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readFeaturesFromDocument(/** @type {Document} */ source, opt_options);
        else return this.readFeaturesFromNode(/** @type {Element} */ source, opt_options);
    };
    /**
     * @param {Document} doc Document.
     * @param {import("./Feature.js").ReadOptions=} opt_options Options.
     * @protected
     * @return {Array<import("../Feature.js").default>} Features.
     */ XMLFeature.prototype.readFeaturesFromDocument = function(doc, opt_options) {
        /** @type {Array<import("../Feature.js").default>} */ var features = [];
        for(var n = doc.firstChild; n; n = n.nextSibling)if (n.nodeType == Node.ELEMENT_NODE) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(features, this.readFeaturesFromNode(/** @type {Element} */ n, opt_options));
        return features;
    };
    /**
     * @abstract
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions=} opt_options Options.
     * @protected
     * @return {Array<import("../Feature.js").default>} Features.
     */ XMLFeature.prototype.readFeaturesFromNode = function(node, opt_options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    };
    /**
     * Read a single geometry from a source.
     *
     * @param {Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
     * @return {import("../geom/Geometry.js").default} Geometry.
     */ XMLFeature.prototype.readGeometry = function(source, opt_options) {
        if (!source) return null;
        else if (typeof source === 'string') {
            var doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readGeometryFromDocument(doc, opt_options);
        } else if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readGeometryFromDocument(/** @type {Document} */ source, opt_options);
        else return this.readGeometryFromNode(/** @type {Element} */ source, opt_options);
    };
    /**
     * @param {Document} doc Document.
     * @param {import("./Feature.js").ReadOptions=} opt_options Options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */ XMLFeature.prototype.readGeometryFromDocument = function(doc, opt_options) {
        return null; // not implemented
    };
    /**
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions=} opt_options Options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */ XMLFeature.prototype.readGeometryFromNode = function(node, opt_options) {
        return null; // not implemented
    };
    /**
     * Read the projection from the source.
     *
     * @param {Document|Element|Object|string} source Source.
     * @return {import("../proj/Projection.js").default} Projection.
     * @api
     */ XMLFeature.prototype.readProjection = function(source) {
        if (!source) return null;
        else if (typeof source === 'string') {
            var doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readProjectionFromDocument(doc);
        } else if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readProjectionFromDocument(/** @type {Document} */ source);
        else return this.readProjectionFromNode(/** @type {Element} */ source);
    };
    /**
     * @param {Document} doc Document.
     * @protected
     * @return {import("../proj/Projection.js").default} Projection.
     */ XMLFeature.prototype.readProjectionFromDocument = function(doc) {
        return this.dataProjection;
    };
    /**
     * @param {Element} node Node.
     * @protected
     * @return {import("../proj/Projection.js").default} Projection.
     */ XMLFeature.prototype.readProjectionFromNode = function(node) {
        return this.dataProjection;
    };
    /**
     * Encode a feature as string.
     *
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
     * @return {string} Encoded feature.
     */ XMLFeature.prototype.writeFeature = function(feature, opt_options) {
        var node = this.writeFeatureNode(feature, opt_options);
        return this.xmlSerializer_.serializeToString(node);
    };
    /**
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions=} opt_options Options.
     * @protected
     * @return {Node} Node.
     */ XMLFeature.prototype.writeFeatureNode = function(feature, opt_options) {
        return null; // not implemented
    };
    /**
     * Encode an array of features as string.
     *
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
     * @return {string} Result.
     * @api
     */ XMLFeature.prototype.writeFeatures = function(features, opt_options) {
        var node = this.writeFeaturesNode(features, opt_options);
        return this.xmlSerializer_.serializeToString(node);
    };
    /**
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions=} opt_options Options.
     * @return {Node} Node.
     */ XMLFeature.prototype.writeFeaturesNode = function(features, opt_options) {
        return null; // not implemented
    };
    /**
     * Encode a geometry as string.
     *
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
     * @return {string} Encoded geometry.
     */ XMLFeature.prototype.writeGeometry = function(geometry, opt_options) {
        var node = this.writeGeometryNode(geometry, opt_options);
        return this.xmlSerializer_.serializeToString(node);
    };
    /**
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions=} opt_options Options.
     * @return {Node} Node.
     */ XMLFeature.prototype.writeGeometryNode = function(geometry, opt_options) {
        return null; // not implemented
    };
    return XMLFeature;
}((0, $ec084d0ff9c13a22$export$2e2bcd8739ae039));
var $ce16c3ce3167dc37$export$2e2bcd8739ae039 = $ce16c3ce3167dc37$var$XMLFeature;





/**
 * @module ol/format/xsd
 */ 

function $d5e0fde316cac971$export$f9a84177eae95ed5(node) {
    var s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    return $d5e0fde316cac971$export$a8558234a836634(s);
}
function $d5e0fde316cac971$export$a8558234a836634(string) {
    var m = /^\s*(true|1)|(false|0)\s*$/.exec(string);
    if (m) return m[1] !== undefined || false;
    else return undefined;
}
function $d5e0fde316cac971$export$5079def2140fe6f2(node) {
    var s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    var dateTime = Date.parse(s);
    return isNaN(dateTime) ? undefined : dateTime / 1000;
}
function $d5e0fde316cac971$export$5be9c99d34ad295b(node) {
    var s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    return $d5e0fde316cac971$export$5a7483b211367c0c(s);
}
function $d5e0fde316cac971$export$5a7483b211367c0c(string) {
    // FIXME check spec
    var m = /^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*$/i.exec(string);
    if (m) return parseFloat(m[1]);
    else return undefined;
}
function $d5e0fde316cac971$export$81f1f9c19953199c(node) {
    var s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    return $d5e0fde316cac971$export$1c8fe3e9d3126f53(s);
}
function $d5e0fde316cac971$export$1c8fe3e9d3126f53(string) {
    var m = /^\s*(\d+)\s*$/.exec(string);
    if (m) return parseInt(m[1], 10);
    else return undefined;
}
function $d5e0fde316cac971$export$dda73877cb166cd3(node) {
    return (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false).trim();
}
function $d5e0fde316cac971$export$9de8e8a584a450b7(node, bool) {
    $d5e0fde316cac971$export$3255ca5635e70aed(node, bool ? '1' : '0');
}
function $d5e0fde316cac971$export$d6c624180454e8f9(node, string) {
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createCDATASection(string));
}
function $d5e0fde316cac971$export$4e91791cb8677e27(node, dateTime) {
    var date = new Date(dateTime * 1000);
    var string = date.getUTCFullYear() + '-' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(date.getUTCMonth() + 1, 2) + '-' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(date.getUTCDate(), 2) + 'T' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(date.getUTCHours(), 2) + ':' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(date.getUTCMinutes(), 2) + ':' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(date.getUTCSeconds(), 2) + 'Z';
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createTextNode(string));
}
function $d5e0fde316cac971$export$f8009f9ca036d7d1(node, decimal) {
    var string = decimal.toPrecision();
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createTextNode(string));
}
function $d5e0fde316cac971$export$b6c828910b813a07(node, nonNegativeInteger) {
    var string = nonNegativeInteger.toString();
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createTextNode(string));
}
function $d5e0fde316cac971$export$3255ca5635e70aed(node, string) {
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createTextNode(string));
}



var $c7152e7ae8968a6e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @const
 * @type {Array<null|string>}
 */ var $c7152e7ae8968a6e$var$NAMESPACE_URIS = [
    null,
    'http://www.topografix.com/GPX/1/0',
    'http://www.topografix.com/GPX/1/1'
];
/**
 * @const
 * @type {string}
 */ var $c7152e7ae8968a6e$var$SCHEMA_LOCATION = "http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd";
/**
 * @const
 * @type {Object<string, function(Node, Array<*>): (Feature|undefined)>}
 */ var $c7152e7ae8968a6e$var$FEATURE_READER = {
    'rte': $c7152e7ae8968a6e$var$readRte,
    'trk': $c7152e7ae8968a6e$var$readTrk,
    'wpt': $c7152e7ae8968a6e$var$readWpt
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$GPX_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'rte': (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($c7152e7ae8968a6e$var$readRte),
    'trk': (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($c7152e7ae8968a6e$var$readTrk),
    'wpt': (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($c7152e7ae8968a6e$var$readWpt)
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$LINK_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'text': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3), 'linkText'),
    'type': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3), 'linkType')
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$GPX_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'rte': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeRte),
    'trk': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeTrk),
    'wpt': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeWpt)
});
/**
 * @typedef {Object} Options
 * @property {function(Feature, Node):void} [readExtensions] Callback function
 * to process `extensions` nodes. To prevent memory leaks, this callback function must
 * not store any references to the node. Note that the `extensions`
 * node is not allowed in GPX 1.0. Moreover, only `extensions`
 * nodes from `wpt`, `rte` and `trk` can be processed, as those are
 * directly mapped to a feature.
 */ /**
 * @typedef {Object} LayoutOptions
 * @property {boolean} [hasZ]
 * @property {boolean} [hasM]
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the GPX format.
 *
 * Note that {@link module:ol/format/GPX~GPX#readFeature} only reads the first
 * feature of the source.
 *
 * When reading, routes (`<rte>`) are converted into LineString geometries, and
 * tracks (`<trk>`) into MultiLineString. Any properties on route and track
 * waypoints are ignored.
 *
 * When writing, LineString geometries are output as routes (`<rte>`), and
 * MultiLineString as tracks (`<trk>`).
 *
 * @api
 */ var $c7152e7ae8968a6e$var$GPX = /** @class */ function(_super) {
    $c7152e7ae8968a6e$var$__extends(GPX, _super);
    /**
     * @param {Options=} opt_options Options.
     */ function GPX(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @type {import("../proj/Projection.js").default}
         */ _this.dataProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)('EPSG:4326');
        /**
         * @type {function(Feature, Node): void|undefined}
         * @private
         */ _this.readExtensions_ = options.readExtensions;
        return _this;
    }
    /**
     * @param {Array<Feature>} features List of features.
     * @private
     */ GPX.prototype.handleReadExtensions_ = function(features) {
        if (!features) features = [];
        for(var i = 0, ii = features.length; i < ii; ++i){
            var feature = features[i];
            if (this.readExtensions_) {
                var extensionsNode = feature.get('extensionsNode_') || null;
                this.readExtensions_(feature, extensionsNode);
            }
            feature.set('extensionsNode_', undefined);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions=} opt_options Options.
     * @return {import("../Feature.js").default} Feature.
     */ GPX.prototype.readFeatureFromNode = function(node, opt_options) {
        if (!(0, $b998d41b678ed5d1$export$ee2e0f811dca1807)($c7152e7ae8968a6e$var$NAMESPACE_URIS, node.namespaceURI)) return null;
        var featureReader = $c7152e7ae8968a6e$var$FEATURE_READER[node.localName];
        if (!featureReader) return null;
        var feature = featureReader(node, [
            this.getReadOptions(node, opt_options)
        ]);
        if (!feature) return null;
        this.handleReadExtensions_([
            feature
        ]);
        return feature;
    };
    /**
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions=} opt_options Options.
     * @return {Array<import("../Feature.js").default>} Features.
     */ GPX.prototype.readFeaturesFromNode = function(node, opt_options) {
        if (!(0, $b998d41b678ed5d1$export$ee2e0f811dca1807)($c7152e7ae8968a6e$var$NAMESPACE_URIS, node.namespaceURI)) return [];
        if (node.localName == 'gpx') {
            /** @type {Array<Feature>} */ var features = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)([], $c7152e7ae8968a6e$var$GPX_PARSERS, node, [
                this.getReadOptions(node, opt_options)
            ]);
            if (features) {
                this.handleReadExtensions_(features);
                return features;
            } else return [];
        }
        return [];
    };
    /**
     * Encode an array of features in the GPX format as an XML node.
     * LineString geometries are output as routes (`<rte>`), and MultiLineString
     * as tracks (`<trk>`).
     *
     * @param {Array<Feature>} features Features.
     * @param {import("./Feature.js").WriteOptions=} opt_options Options.
     * @return {Node} Node.
     * @api
     */ GPX.prototype.writeFeaturesNode = function(features, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        //FIXME Serialize metadata
        var gpx = (0, $a4f89edd2ef65182$export$7094a064528c7fee)('http://www.topografix.com/GPX/1/1', 'gpx');
        var xmlnsUri = 'http://www.w3.org/2000/xmlns/';
        gpx.setAttributeNS(xmlnsUri, 'xmlns:xsi', (0, $a4f89edd2ef65182$export$be284679de3fbea8));
        gpx.setAttributeNS((0, $a4f89edd2ef65182$export$be284679de3fbea8), 'xsi:schemaLocation', $c7152e7ae8968a6e$var$SCHEMA_LOCATION);
        gpx.setAttribute('version', '1.1');
        gpx.setAttribute('creator', 'OpenLayers');
        (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(/** @type {import("../xml.js").NodeStackItem} */ {
            node: gpx
        }, $c7152e7ae8968a6e$var$GPX_SERIALIZERS, $c7152e7ae8968a6e$var$GPX_NODE_FACTORY, features, [
            opt_options
        ]);
        return gpx;
    };
    return GPX;
}((0, $ce16c3ce3167dc37$export$2e2bcd8739ae039));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$RTE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'name': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'cmt': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'desc': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'src': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'link': $c7152e7ae8968a6e$var$parseLink,
    'number': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$81f1f9c19953199c)),
    'extensions': $c7152e7ae8968a6e$var$parseExtensions,
    'type': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'rtept': $c7152e7ae8968a6e$var$parseRtePt
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$RTEPT_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'ele': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'time': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5079def2140fe6f2))
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$TRK_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'name': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'cmt': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'desc': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'src': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'link': $c7152e7ae8968a6e$var$parseLink,
    'number': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$81f1f9c19953199c)),
    'type': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'extensions': $c7152e7ae8968a6e$var$parseExtensions,
    'trkseg': $c7152e7ae8968a6e$var$parseTrkSeg
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$TRKSEG_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'trkpt': $c7152e7ae8968a6e$var$parseTrkPt
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$TRKPT_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'ele': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'time': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5079def2140fe6f2))
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$WPT_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'ele': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'time': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5079def2140fe6f2)),
    'magvar': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'geoidheight': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'name': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'cmt': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'desc': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'src': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'link': $c7152e7ae8968a6e$var$parseLink,
    'sym': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'type': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'fix': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'sat': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$81f1f9c19953199c)),
    'hdop': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'vdop': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'pdop': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'ageofdgpsdata': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'dgpsid': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$81f1f9c19953199c)),
    'extensions': $c7152e7ae8968a6e$var$parseExtensions
});
/**
 * @const
 * @type {Array<string>}
 */ var $c7152e7ae8968a6e$var$LINK_SEQUENCE = [
    'text',
    'type'
];
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$LINK_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'text': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'type': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed))
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$RTE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, [
    'name',
    'cmt',
    'desc',
    'src',
    'link',
    'number',
    'type',
    'rtept'
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$RTE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'name': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'cmt': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'desc': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'src': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'link': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeLink),
    'number': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$b6c828910b813a07)),
    'type': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'rtept': (0, $a4f89edd2ef65182$export$fa227189764d6986)((0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeWptType))
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$RTEPT_TYPE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, [
    'ele',
    'time'
]);
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$TRK_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, [
    'name',
    'cmt',
    'desc',
    'src',
    'link',
    'number',
    'type',
    'trkseg'
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$TRK_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'name': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'cmt': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'desc': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'src': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'link': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeLink),
    'number': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$b6c828910b813a07)),
    'type': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'trkseg': (0, $a4f89edd2ef65182$export$fa227189764d6986)((0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeTrkSeg))
});
/**
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ var $c7152e7ae8968a6e$var$TRKSEG_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)('trkpt');
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$TRKSEG_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'trkpt': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeWptType)
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$WPT_TYPE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, [
    'ele',
    'time',
    'magvar',
    'geoidheight',
    'name',
    'cmt',
    'desc',
    'src',
    'link',
    'sym',
    'type',
    'fix',
    'sat',
    'hdop',
    'vdop',
    'pdop',
    'ageofdgpsdata',
    'dgpsid'
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
var $c7152e7ae8968a6e$var$WPT_TYPE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    'ele': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    'time': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$4e91791cb8677e27)),
    'magvar': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    'geoidheight': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    'name': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'cmt': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'desc': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'src': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'link': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeLink),
    'sym': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'type': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'fix': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'sat': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$b6c828910b813a07)),
    'hdop': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    'vdop': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    'pdop': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    'ageofdgpsdata': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    'dgpsid': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$b6c828910b813a07))
});
/**
 * @const
 * @type {Object<string, string>}
 */ var $c7152e7ae8968a6e$var$GEOMETRY_TYPE_TO_NODENAME = {
    'Point': 'wpt',
    'LineString': 'rte',
    'MultiLineString': 'trk'
};
/**
 * @param {*} value Value.
 * @param {Array<*>} objectStack Object stack.
 * @param {string=} opt_nodeName Node name.
 * @return {Node|undefined} Node.
 */ function $c7152e7ae8968a6e$var$GPX_NODE_FACTORY(value, objectStack, opt_nodeName) {
    var geometry = /** @type {Feature} */ value.getGeometry();
    if (geometry) {
        var nodeName = $c7152e7ae8968a6e$var$GEOMETRY_TYPE_TO_NODENAME[geometry.getType()];
        if (nodeName) {
            var parentNode = objectStack[objectStack.length - 1].node;
            return (0, $a4f89edd2ef65182$export$7094a064528c7fee)(parentNode.namespaceURI, nodeName);
        }
    }
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {LayoutOptions} layoutOptions Layout options.
 * @param {Element} node Node.
 * @param {!Object} values Values.
 * @return {Array<number>} Flat coordinates.
 */ function $c7152e7ae8968a6e$var$appendCoordinate(flatCoordinates, layoutOptions, node, values) {
    flatCoordinates.push(parseFloat(node.getAttribute('lon')), parseFloat(node.getAttribute('lat')));
    if ('ele' in values) {
        flatCoordinates.push(/** @type {number} */ values['ele']);
        delete values['ele'];
        layoutOptions.hasZ = true;
    } else flatCoordinates.push(0);
    if ('time' in values) {
        flatCoordinates.push(/** @type {number} */ values['time']);
        delete values['time'];
        layoutOptions.hasM = true;
    } else flatCoordinates.push(0);
    return flatCoordinates;
}
/**
 * Choose GeometryLayout based on flags in layoutOptions and adjust flatCoordinates
 * and ends arrays by shrinking them accordingly (removing unused zero entries).
 *
 * @param {LayoutOptions} layoutOptions Layout options.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {Array<number>=} ends Ends.
 * @return {import("../geom/GeometryLayout.js").default} Layout.
 */ function $c7152e7ae8968a6e$var$applyLayoutOptions(layoutOptions, flatCoordinates, ends) {
    var layout = (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XY;
    var stride = 2;
    if (layoutOptions.hasZ && layoutOptions.hasM) {
        layout = (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYZM;
        stride = 4;
    } else if (layoutOptions.hasZ) {
        layout = (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYZ;
        stride = 3;
    } else if (layoutOptions.hasM) {
        layout = (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYM;
        stride = 3;
    }
    if (stride !== 4) {
        for(var i = 0, ii = flatCoordinates.length / 4; i < ii; i++){
            flatCoordinates[i * stride] = flatCoordinates[i * 4];
            flatCoordinates[i * stride + 1] = flatCoordinates[i * 4 + 1];
            if (layoutOptions.hasZ) flatCoordinates[i * stride + 2] = flatCoordinates[i * 4 + 2];
            if (layoutOptions.hasM) flatCoordinates[i * stride + 2] = flatCoordinates[i * 4 + 3];
        }
        flatCoordinates.length = flatCoordinates.length / 4 * stride;
        if (ends) for(var i = 0, ii = ends.length; i < ii; i++)ends[i] = ends[i] / 4 * stride;
    }
    return layout;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$parseLink(node, objectStack) {
    var values = /** @type {Object} */ objectStack[objectStack.length - 1];
    var href = node.getAttribute('href');
    if (href !== null) values['link'] = href;
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($c7152e7ae8968a6e$var$LINK_PARSERS, node, objectStack);
}
/**
 * @param {Node} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$parseExtensions(node, objectStack) {
    var values = /** @type {Object} */ objectStack[objectStack.length - 1];
    values['extensionsNode_'] = node;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$parseRtePt(node, objectStack) {
    var values = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $c7152e7ae8968a6e$var$RTEPT_PARSERS, node, objectStack);
    if (values) {
        var rteValues = /** @type {!Object} */ objectStack[objectStack.length - 1];
        var flatCoordinates = /** @type {Array<number>} */ rteValues['flatCoordinates'];
        var layoutOptions = /** @type {LayoutOptions} */ rteValues['layoutOptions'];
        $c7152e7ae8968a6e$var$appendCoordinate(flatCoordinates, layoutOptions, node, values);
    }
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$parseTrkPt(node, objectStack) {
    var values = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $c7152e7ae8968a6e$var$TRKPT_PARSERS, node, objectStack);
    if (values) {
        var trkValues = /** @type {!Object} */ objectStack[objectStack.length - 1];
        var flatCoordinates = /** @type {Array<number>} */ trkValues['flatCoordinates'];
        var layoutOptions = /** @type {LayoutOptions} */ trkValues['layoutOptions'];
        $c7152e7ae8968a6e$var$appendCoordinate(flatCoordinates, layoutOptions, node, values);
    }
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$parseTrkSeg(node, objectStack) {
    var values = /** @type {Object} */ objectStack[objectStack.length - 1];
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($c7152e7ae8968a6e$var$TRKSEG_PARSERS, node, objectStack);
    var flatCoordinates = /** @type {Array<number>} */ values['flatCoordinates'];
    var ends = /** @type {Array<number>} */ values['ends'];
    ends.push(flatCoordinates.length);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Feature|undefined} Track.
 */ function $c7152e7ae8968a6e$var$readRte(node, objectStack) {
    var options = /** @type {import("./Feature.js").ReadOptions} */ objectStack[0];
    var values = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({
        'flatCoordinates': [],
        'layoutOptions': {}
    }, $c7152e7ae8968a6e$var$RTE_PARSERS, node, objectStack);
    if (!values) return undefined;
    var flatCoordinates = /** @type {Array<number>} */ values['flatCoordinates'];
    delete values['flatCoordinates'];
    var layoutOptions = /** @type {LayoutOptions} */ values['layoutOptions'];
    delete values['layoutOptions'];
    var layout = $c7152e7ae8968a6e$var$applyLayoutOptions(layoutOptions, flatCoordinates);
    var geometry = new (0, $292e4002746c8223$export$2e2bcd8739ae039)(flatCoordinates, layout);
    (0, $ec084d0ff9c13a22$export$7beeea566b560d4)(geometry, false, options);
    var feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(geometry);
    feature.setProperties(values, true);
    return feature;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Feature|undefined} Track.
 */ function $c7152e7ae8968a6e$var$readTrk(node, objectStack) {
    var options = /** @type {import("./Feature.js").ReadOptions} */ objectStack[0];
    var values = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({
        'flatCoordinates': [],
        'ends': [],
        'layoutOptions': {}
    }, $c7152e7ae8968a6e$var$TRK_PARSERS, node, objectStack);
    if (!values) return undefined;
    var flatCoordinates = /** @type {Array<number>} */ values['flatCoordinates'];
    delete values['flatCoordinates'];
    var ends = /** @type {Array<number>} */ values['ends'];
    delete values['ends'];
    var layoutOptions = /** @type {LayoutOptions} */ values['layoutOptions'];
    delete values['layoutOptions'];
    var layout = $c7152e7ae8968a6e$var$applyLayoutOptions(layoutOptions, flatCoordinates, ends);
    var geometry = new (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039)(flatCoordinates, layout, ends);
    (0, $ec084d0ff9c13a22$export$7beeea566b560d4)(geometry, false, options);
    var feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(geometry);
    feature.setProperties(values, true);
    return feature;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Feature|undefined} Waypoint.
 */ function $c7152e7ae8968a6e$var$readWpt(node, objectStack) {
    var options = /** @type {import("./Feature.js").ReadOptions} */ objectStack[0];
    var values = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $c7152e7ae8968a6e$var$WPT_PARSERS, node, objectStack);
    if (!values) return undefined;
    var layoutOptions = /** @type {LayoutOptions} */ {};
    var coordinates = $c7152e7ae8968a6e$var$appendCoordinate([], layoutOptions, node, values);
    var layout = $c7152e7ae8968a6e$var$applyLayoutOptions(layoutOptions, coordinates);
    var geometry = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(coordinates, layout);
    (0, $ec084d0ff9c13a22$export$7beeea566b560d4)(geometry, false, options);
    var feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(geometry);
    feature.setProperties(values, true);
    return feature;
}
/**
 * @param {Element} node Node.
 * @param {string} value Value for the link's `href` attribute.
 * @param {Array<*>} objectStack Node stack.
 */ function $c7152e7ae8968a6e$var$writeLink(node, value, objectStack) {
    node.setAttribute('href', value);
    var context = objectStack[objectStack.length - 1];
    var properties = context['properties'];
    var link = [
        properties['linkText'],
        properties['linkType']
    ];
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(/** @type {import("../xml.js").NodeStackItem} */ {
        node: node
    }, $c7152e7ae8968a6e$var$LINK_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), link, objectStack, $c7152e7ae8968a6e$var$LINK_SEQUENCE);
}
/**
 * @param {Element} node Node.
 * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$writeWptType(node, coordinate, objectStack) {
    var context = objectStack[objectStack.length - 1];
    var parentNode = context.node;
    var namespaceURI = parentNode.namespaceURI;
    var properties = context['properties'];
    //FIXME Projection handling
    node.setAttributeNS(null, 'lat', String(coordinate[1]));
    node.setAttributeNS(null, 'lon', String(coordinate[0]));
    var geometryLayout = context['geometryLayout'];
    switch(geometryLayout){
        case (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYZM:
            if (coordinate[3] !== 0) properties['time'] = coordinate[3];
        // fall through
        case (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYZ:
            if (coordinate[2] !== 0) properties['ele'] = coordinate[2];
            break;
        case (0, $42282ac5c8474df1$export$2e2bcd8739ae039).XYM:
            if (coordinate[2] !== 0) properties['time'] = coordinate[2];
            break;
        default:
    }
    var orderedKeys = node.nodeName == 'rtept' ? $c7152e7ae8968a6e$var$RTEPT_TYPE_SEQUENCE[namespaceURI] : $c7152e7ae8968a6e$var$WPT_TYPE_SEQUENCE[namespaceURI];
    var values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(/** @type {import("../xml.js").NodeStackItem} */ {
        node: node,
        'properties': properties
    }, $c7152e7ae8968a6e$var$WPT_TYPE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @param {Node} node Node.
 * @param {Feature} feature Feature.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$writeRte(node, feature, objectStack) {
    var options = /** @type {import("./Feature.js").WriteOptions} */ objectStack[0];
    var properties = feature.getProperties();
    var context = {
        node: node
    };
    context['properties'] = properties;
    var geometry = feature.getGeometry();
    if (geometry.getType() == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).LINE_STRING) {
        var lineString = /** @type {LineString} */ (0, $ec084d0ff9c13a22$export$7beeea566b560d4)(geometry, true, options);
        context['geometryLayout'] = lineString.getLayout();
        properties['rtept'] = lineString.getCoordinates();
    }
    var parentNode = objectStack[objectStack.length - 1].node;
    var orderedKeys = $c7152e7ae8968a6e$var$RTE_SEQUENCE[parentNode.namespaceURI];
    var values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $c7152e7ae8968a6e$var$RTE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @param {Node} node Node.
 * @param {Feature} feature Feature.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$writeTrk(node, feature, objectStack) {
    var options = /** @type {import("./Feature.js").WriteOptions} */ objectStack[0];
    var properties = feature.getProperties();
    /** @type {import("../xml.js").NodeStackItem} */ var context = {
        node: node
    };
    context['properties'] = properties;
    var geometry = feature.getGeometry();
    if (geometry.getType() == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).MULTI_LINE_STRING) {
        var multiLineString = /** @type {MultiLineString} */ (0, $ec084d0ff9c13a22$export$7beeea566b560d4)(geometry, true, options);
        properties['trkseg'] = multiLineString.getLineStrings();
    }
    var parentNode = objectStack[objectStack.length - 1].node;
    var orderedKeys = $c7152e7ae8968a6e$var$TRK_SEQUENCE[parentNode.namespaceURI];
    var values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $c7152e7ae8968a6e$var$TRK_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @param {Node} node Node.
 * @param {LineString} lineString LineString.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$writeTrkSeg(node, lineString, objectStack) {
    /** @type {import("../xml.js").NodeStackItem} */ var context = {
        node: node
    };
    context['geometryLayout'] = lineString.getLayout();
    context['properties'] = {};
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $c7152e7ae8968a6e$var$TRKSEG_SERIALIZERS, $c7152e7ae8968a6e$var$TRKSEG_NODE_FACTORY, lineString.getCoordinates(), objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Feature} feature Feature.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$writeWpt(node, feature, objectStack) {
    var options = /** @type {import("./Feature.js").WriteOptions} */ objectStack[0];
    var context = objectStack[objectStack.length - 1];
    context['properties'] = feature.getProperties();
    var geometry = feature.getGeometry();
    if (geometry.getType() == (0, $419865bd7211e6e7$export$2e2bcd8739ae039).POINT) {
        var point = /** @type {Point} */ (0, $ec084d0ff9c13a22$export$7beeea566b560d4)(geometry, true, options);
        context['geometryLayout'] = point.getLayout();
        $c7152e7ae8968a6e$var$writeWptType(node, point.getCoordinates(), objectStack);
    }
}
var $c7152e7ae8968a6e$export$2e2bcd8739ae039 = $c7152e7ae8968a6e$var$GPX;


/**
 * @module ol/source/Vector
 */ 




/**
 * @module ol/structs/RBush
 */ 



/**
 * @typedef {Object} Entry
 * @property {number} minX
 * @property {number} minY
 * @property {number} maxX
 * @property {number} maxY
 * @property {Object} [value]
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template T
 */ var $34c742891733e7a4$var$RBush = /** @class */ function() {
    /**
     * @param {number=} opt_maxEntries Max entries.
     */ function RBush(opt_maxEntries) {
        /**
         * @private
         */ this.rbush_ = new (0, (/*@__PURE__*/$parcel$interopDefault($176ca75ee9f69668$exports)))(opt_maxEntries);
        /**
         * A mapping between the objects added to this rbush wrapper
         * and the objects that are actually added to the internal rbush.
         * @private
         * @type {Object<string, Entry>}
         */ this.items_ = {};
    }
    /**
     * Insert a value into the RBush.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {T} value Value.
     */ RBush.prototype.insert = function(extent, value) {
        /** @type {Entry} */ var item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        this.rbush_.insert(item);
        this.items_[(0, $6c5e11070e371322$export$5e82334337e0f204)(value)] = item;
    };
    /**
     * Bulk-insert values into the RBush.
     * @param {Array<import("../extent.js").Extent>} extents Extents.
     * @param {Array<T>} values Values.
     */ RBush.prototype.load = function(extents, values) {
        var items = new Array(values.length);
        for(var i = 0, l = values.length; i < l; i++){
            var extent = extents[i];
            var value = values[i];
            /** @type {Entry} */ var item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value
            };
            items[i] = item;
            this.items_[(0, $6c5e11070e371322$export$5e82334337e0f204)(value)] = item;
        }
        this.rbush_.load(items);
    };
    /**
     * Remove a value from the RBush.
     * @param {T} value Value.
     * @return {boolean} Removed.
     */ RBush.prototype.remove = function(value) {
        var uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        var item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    };
    /**
     * Update the extent of a value in the RBush.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {T} value Value.
     */ RBush.prototype.update = function(extent, value) {
        var item = this.items_[(0, $6c5e11070e371322$export$5e82334337e0f204)(value)];
        var bbox = [
            item.minX,
            item.minY,
            item.maxX,
            item.maxY
        ];
        if (!(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    };
    /**
     * Return all values in the RBush.
     * @return {Array<T>} All.
     */ RBush.prototype.getAll = function() {
        var items = this.rbush_.all();
        return items.map(function(item) {
            return item.value;
        });
    };
    /**
     * Return all values in the given extent.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {Array<T>} All in extent.
     */ RBush.prototype.getInExtent = function(extent) {
        /** @type {Entry} */ var bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3]
        };
        var items = this.rbush_.search(bbox);
        return items.map(function(item) {
            return item.value;
        });
    };
    /**
     * Calls a callback function with each value in the tree.
     * If the callback returns a truthy value, this value is returned without
     * checking the rest of the tree.
     * @param {function(T): *} callback Callback.
     * @return {*} Callback return value.
     */ RBush.prototype.forEach = function(callback) {
        return this.forEach_(this.getAll(), callback);
    };
    /**
     * Calls a callback function with each value in the provided extent.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {function(T): *} callback Callback.
     * @return {*} Callback return value.
     */ RBush.prototype.forEachInExtent = function(extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    };
    /**
     * @param {Array<T>} values Values.
     * @param {function(T): *} callback Callback.
     * @private
     * @return {*} Callback return value.
     */ RBush.prototype.forEach_ = function(values, callback) {
        var result;
        for(var i = 0, l = values.length; i < l; i++){
            result = callback(values[i]);
            if (result) return result;
        }
        return result;
    };
    /**
     * @return {boolean} Is empty.
     */ RBush.prototype.isEmpty = function() {
        return (0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.items_);
    };
    /**
     * Remove all values from the RBush.
     */ RBush.prototype.clear = function() {
        this.rbush_.clear();
        this.items_ = {};
    };
    /**
     * @param {import("../extent.js").Extent=} opt_extent Extent.
     * @return {import("../extent.js").Extent} Extent.
     */ RBush.prototype.getExtent = function(opt_extent) {
        var data = this.rbush_.toJSON();
        return (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(data.minX, data.minY, data.maxX, data.maxY, opt_extent);
    };
    /**
     * @param {RBush} rbush R-Tree.
     */ RBush.prototype.concat = function(rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for(var i in rbush.items_)this.items_[i] = rbush.items_[i];
    };
    return RBush;
}();
var $34c742891733e7a4$export$2e2bcd8739ae039 = $34c742891733e7a4$var$RBush;




/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $ccc4e6f11f11978f$export$2e2bcd8739ae039 = {
    /**
     * Triggered when a feature is added to the source.
     * @event module:ol/source/Vector.VectorSourceEvent#addfeature
     * @api
     */ ADDFEATURE: 'addfeature',
    /**
     * Triggered when a feature is updated.
     * @event module:ol/source/Vector.VectorSourceEvent#changefeature
     * @api
     */ CHANGEFEATURE: 'changefeature',
    /**
     * Triggered when the clear method is called on the source.
     * @event module:ol/source/Vector.VectorSourceEvent#clear
     * @api
     */ CLEAR: 'clear',
    /**
     * Triggered when a feature is removed from the source.
     * See {@link module:ol/source/Vector#clear source.clear()} for exceptions.
     * @event module:ol/source/Vector.VectorSourceEvent#removefeature
     * @api
     */ REMOVEFEATURE: 'removefeature',
    /**
     * Triggered when features starts loading.
     * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
     * @api
     */ FEATURESLOADSTART: 'featuresloadstart',
    /**
     * Triggered when features finishes loading.
     * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
     * @api
     */ FEATURESLOADEND: 'featuresloadend',
    /**
     * Triggered if feature loading results in an error.
     * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
     * @api
     */ FEATURESLOADERROR: 'featuresloaderror'
};



/**
 * @module ol/loadingstrategy
 */ /**
 * Strategy function for loading all features with a single request.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @return {Array<import("./extent.js").Extent>} Extents.
 * @api
 */ function $eb51d0a16123ee90$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $eb51d0a16123ee90$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $eb51d0a16123ee90$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution) {
        var z = tileGrid.getZForResolution(resolution);
        var tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
        /** @type {Array<import("./extent.js").Extent>} */ var extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ var tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push(tileGrid.getTileCoordExtent(tileCoord));
        return extents;
    });
}








/**
 * @module ol/featureloader
 */ 

/**
 *
 * @type {boolean}
 * @private
 */ var $588823c001569193$var$withCredentials = false;
function $588823c001569193$export$441d7b57adab24d0(url, format, extent, resolution, projection, success, failure) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', typeof url === 'function' ? url(extent, resolution, projection) : url, true);
    if (format.getType() == (0, $fdcc6dd70a9488b9$export$2e2bcd8739ae039).ARRAY_BUFFER) xhr.responseType = 'arraybuffer';
    xhr.withCredentials = $588823c001569193$var$withCredentials;
    /**
     * @param {Event} event Event.
     * @private
     */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            var type = format.getType();
            /** @type {Document|Node|Object|string|undefined} */ var source = void 0;
            if (type == (0, $fdcc6dd70a9488b9$export$2e2bcd8739ae039).JSON || type == (0, $fdcc6dd70a9488b9$export$2e2bcd8739ae039).TEXT) source = xhr.responseText;
            else if (type == (0, $fdcc6dd70a9488b9$export$2e2bcd8739ae039).XML) {
                source = xhr.responseXML;
                if (!source) source = new DOMParser().parseFromString(xhr.responseText, 'application/xml');
            } else if (type == (0, $fdcc6dd70a9488b9$export$2e2bcd8739ae039).ARRAY_BUFFER) source = /** @type {ArrayBuffer} */ xhr.response;
            if (source) success(/** @type {Array<import("./Feature.js").default>} */ format.readFeatures(source, {
                extent: extent,
                featureProjection: projection
            }), format.readProjection(source));
            else failure();
        } else failure();
    };
    /**
     * @private
     */ xhr.onerror = failure;
    xhr.send();
}
function $588823c001569193$export$14cc81df70b6707e(url, format) {
    /**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @param {function(): void=} success Success
     *      Function called when loading succeeded.
     * @param {function(): void=} failure Failure
     *      Function called when loading failed.
     * @this {import("./source/Vector").default}
     */ return function(extent, resolution, projection, success, failure) {
        var source = /** @type {import("./source/Vector").default} */ this;
        $588823c001569193$export$441d7b57adab24d0(url, format, extent, resolution, projection, /**
         * @param {Array<import("./Feature.js").default>} features The loaded features.
         * @param {import("./proj/Projection.js").default} dataProjection Data
         * projection.
         */ function(features, dataProjection) {
            if (success !== undefined) success(features);
            source.addFeatures(features);
        }, /* FIXME handle error */ failure ? failure : (0, $013a1733c226ec50$export$1cd1943b3a73bbe8));
    };
}
function $588823c001569193$export$36fa6977a6d0d8fe(xhrWithCredentials) {
    $588823c001569193$var$withCredentials = xhrWithCredentials;
}


var $84888e4daf3fdf44$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * A function that takes an {@link module:ol/extent~Extent} and a resolution as arguments, and
 * returns an array of {@link module:ol/extent~Extent} with the extents to load. Usually this
 * is one of the standard {@link module:ol/loadingstrategy} strategies.
 *
 * @typedef {function(import("../extent.js").Extent, number): Array<import("../extent.js").Extent>} LoadingStrategy
 * @api
 */ /**
 * @classdesc
 * Events emitted by {@link module:ol/source/Vector} instances are instances of this
 * type.
 * @template {import("../geom/Geometry.js").default} Geometry
 */ var $84888e4daf3fdf44$export$d402fd02dc2b661c = /** @class */ function(_super) {
    $84888e4daf3fdf44$var$__extends(VectorSourceEvent, _super);
    /**
     * @param {string} type Type.
     * @param {import("../Feature.js").default<Geometry>=} opt_feature Feature.
     * @param {Array<import("../Feature.js").default<Geometry>>=} opt_features Features.
     */ function VectorSourceEvent(type, opt_feature, opt_features) {
        var _this = _super.call(this, type) || this;
        /**
         * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
         * @type {import("../Feature.js").default<Geometry>|undefined}
         * @api
         */ _this.feature = opt_feature;
        /**
         * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
         * @type {Array<import("../Feature.js").default<Geometry>>|undefined}
         * @api
         */ _this.features = opt_features;
        return _this;
    }
    return VectorSourceEvent;
}((0, $aeedce20e9577100$export$2e2bcd8739ae039));
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<import("../Feature.js").default>|Collection<import("../Feature.js").default>} [features]
 * Features. If provided as {@link module:ol/Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader.
 *
 * Example:
 *
 * ```js
 * import {Vector} from 'ol/source';
 * import {GeoJSON} from 'ol/format';
 * import {bbox} from 'ol/loadingstrategy';
 *
 * var vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection) {
 *      var proj = projection.getCode();
 *      var url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      var xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      var onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          vectorSource.addFeatures(
 *              vectorSource.getFormat().readFeatures(xhr.responseText));
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy~all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader~xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy~all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../geom/Geometry.js").default} Geometry
 */ var $84888e4daf3fdf44$var$VectorSource = /** @class */ function(_super) {
    $84888e4daf3fdf44$var$__extends(VectorSource, _super);
    /**
     * @param {Options=} opt_options Vector source options.
     */ function VectorSource(opt_options) {
        var _this = this;
        var options = opt_options || {};
        _this = _super.call(this, {
            attributions: options.attributions,
            projection: undefined,
            state: (0, $98f5bfe3c4864f05$export$2e2bcd8739ae039).READY,
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        }) || this;
        /**
         * @private
         * @type {import("../featureloader.js").FeatureLoader}
         */ _this.loader_ = (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
        /**
         * @private
         * @type {import("../format/Feature.js").default|undefined}
         */ _this.format_ = options.format;
        /**
         * @private
         * @type {boolean}
         */ _this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
         * @private
         * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
         */ _this.url_ = options.url;
        if (options.loader !== undefined) _this.loader_ = options.loader;
        else if (_this.url_ !== undefined) {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(_this.format_, 7); // `format` must be set when `url` is set
            // create a XHR feature loader for "url" and "format"
            _this.loader_ = (0, $588823c001569193$export$14cc81df70b6707e)(_this.url_, /** @type {import("../format/Feature.js").default} */ _this.format_);
        }
        /**
         * @private
         * @type {LoadingStrategy}
         */ _this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $eb51d0a16123ee90$export$84bf76cd7afc7469);
        var useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
         * @private
         * @type {RBush<import("../Feature.js").default<Geometry>>}
         */ _this.featuresRtree_ = useSpatialIndex ? new (0, $34c742891733e7a4$export$2e2bcd8739ae039)() : null;
        /**
         * @private
         * @type {RBush<{extent: import("../extent.js").Extent}>}
         */ _this.loadedExtentsRtree_ = new (0, $34c742891733e7a4$export$2e2bcd8739ae039)();
        /**
         * @private
         * @type {!Object<string, import("../Feature.js").default<Geometry>>}
         */ _this.nullGeometryFeatures_ = {};
        /**
         * A lookup of features by id (the return from feature.getId()).
         * @private
         * @type {!Object<string, import("../Feature.js").default<Geometry>>}
         */ _this.idIndex_ = {};
        /**
         * A lookup of features by uid (using getUid(feature)).
         * @private
         * @type {!Object<string, import("../Feature.js").default<Geometry>>}
         */ _this.uidIndex_ = {};
        /**
         * @private
         * @type {Object<string, Array<import("../events.js").EventsKey>>}
         */ _this.featureChangeKeys_ = {};
        /**
         * @private
         * @type {Collection<import("../Feature.js").default<Geometry>>}
         */ _this.featuresCollection_ = null;
        var collection, features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(features);
        if (features !== undefined) _this.addFeaturesInternal(features);
        if (collection !== undefined) _this.bindFeaturesCollection_(collection);
        return _this;
    }
    /**
     * Add a single feature to the source.  If you want to add a batch of features
     * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
     * instead. A feature will not be added to the source if feature with
     * the same id is already there. The reason for this behavior is to avoid
     * feature duplication when using bbox or tile loading strategies.
     * Note: this also applies if an {@link module:ol/Collection} is used for features,
     * meaning that if a feature with a duplicate id is added in the collection, it will
     * be removed from it right away.
     * @param {import("../Feature.js").default<Geometry>} feature Feature to add.
     * @api
     */ VectorSource.prototype.addFeature = function(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    };
    /**
     * Add a feature without firing a `change` event.
     * @param {import("../Feature.js").default<Geometry>} feature Feature.
     * @protected
     */ VectorSource.prototype.addFeatureInternal = function(feature) {
        var featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) this.featuresCollection_.remove(feature);
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        var geometry = feature.getGeometry();
        if (geometry) {
            var extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, feature));
    };
    /**
     * @param {string} featureKey Unique identifier for the feature.
     * @param {import("../Feature.js").default<Geometry>} feature The feature.
     * @private
     */ VectorSource.prototype.setupChangeEvents_ = function(featureKey, feature) {
        this.featureChangeKeys_[featureKey] = [
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(feature, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_, this),
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(feature, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    };
    /**
     * @param {string} featureKey Unique identifier for the feature.
     * @param {import("../Feature.js").default<Geometry>} feature The feature.
     * @return {boolean} The feature is "valid", in the sense that it is also a
     *     candidate for insertion into the Rtree.
     * @private
     */ VectorSource.prototype.addToIndex_ = function(featureKey, feature) {
        var valid = true;
        var id = feature.getId();
        if (id !== undefined) {
            if (!(id.toString() in this.idIndex_)) this.idIndex_[id.toString()] = feature;
            else valid = false;
        }
        if (valid) {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(!(featureKey in this.uidIndex_), 30); // The passed `feature` was already added to the source
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    };
    /**
     * Add a batch of features to the source.
     * @param {Array<import("../Feature.js").default<Geometry>>} features Features to add.
     * @api
     */ VectorSource.prototype.addFeatures = function(features) {
        this.addFeaturesInternal(features);
        this.changed();
    };
    /**
     * Add features without firing a `change` event.
     * @param {Array<import("../Feature.js").default<Geometry>>} features Features.
     * @protected
     */ VectorSource.prototype.addFeaturesInternal = function(features) {
        var extents = [];
        var newFeatures = [];
        var geometryFeatures = [];
        for(var i = 0, length_1 = features.length; i < length_1; i++){
            var feature = features[i];
            var featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(var i = 0, length_2 = newFeatures.length; i < length_2; i++){
            var feature = newFeatures[i];
            var featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            this.setupChangeEvents_(featureKey, feature);
            var geometry = feature.getGeometry();
            if (geometry) {
                var extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            } else this.nullGeometryFeatures_[featureKey] = feature;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        for(var i = 0, length_3 = newFeatures.length; i < length_3; i++)this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, newFeatures[i]));
    };
    /**
     * @param {!Collection<import("../Feature.js").default<Geometry>>} collection Collection.
     * @private
     */ VectorSource.prototype.bindFeaturesCollection_ = function(collection) {
        var modifyingCollection = false;
        this.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, /**
         * @param {VectorSourceEvent<Geometry>} evt The vector source event
         */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE, /**
         * @param {VectorSourceEvent<Geometry>} evt The vector source event
         */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
         * @param {import("../Collection.js").CollectionEvent} evt The collection event
         */ (function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(/** @type {import("../Feature.js").default<Geometry>} */ evt.element);
                modifyingCollection = false;
            }
        }).bind(this));
        collection.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
         * @param {import("../Collection.js").CollectionEvent} evt The collection event
         */ (function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(/** @type {import("../Feature.js").default<Geometry>} */ evt.element);
                modifyingCollection = false;
            }
        }).bind(this));
        this.featuresCollection_ = collection;
    };
    /**
     * Remove all features from the source.
     * @param {boolean=} opt_fast Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#removefeature} events.
     * @api
     */ VectorSource.prototype.clear = function(opt_fast) {
        if (opt_fast) {
            for(var featureId in this.featureChangeKeys_){
                var keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            this.featuresRtree_.forEach(this.removeFeatureInternal.bind(this));
            for(var id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.nullGeometryFeatures_ = {};
        var clearEvent = new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    };
    /**
     * Iterate through all features on the source, calling the provided callback
     * with each one.  If the callback returns any "truthy" value, iteration will
     * stop and the function will return the same value.
     * Note: this function only iterate through the feature that have a defined geometry.
     *
     * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
     *     on the source.  Return a truthy value to stop iteration.
     * @return {T|undefined} The return value from the last call to the callback.
     * @template T
     * @api
     */ VectorSource.prototype.forEachFeature = function(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        else if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    };
    /**
     * Iterate through all features whose geometries contain the provided
     * coordinate, calling the callback with each feature.  If the callback returns
     * a "truthy" value, iteration will stop and the function will return the same
     * value.
     *
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
     *     whose goemetry contains the provided coordinate.
     * @return {T|undefined} The return value from the last call to the callback.
     * @template T
     */ VectorSource.prototype.forEachFeatureAtCoordinateDirect = function(coordinate, callback) {
        var extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            var geometry = feature.getGeometry();
            if (geometry.intersectsCoordinate(coordinate)) return callback(feature);
            else return undefined;
        });
    };
    /**
     * Iterate through all features whose bounding box intersects the provided
     * extent (note that the feature's geometry may not intersect the extent),
     * calling the callback with each feature.  If the callback returns a "truthy"
     * value, iteration will stop and the function will return the same value.
     *
     * If you are interested in features whose geometry intersects an extent, call
     * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
     *
     * When `useSpatialIndex` is set to false, this method will loop through all
     * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
     *     whose bounding box intersects the provided extent.
     * @return {T|undefined} The return value from the last call to the callback.
     * @template T
     * @api
     */ VectorSource.prototype.forEachFeatureInExtent = function(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        else if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    };
    /**
     * Iterate through all features whose geometry intersects the provided extent,
     * calling the callback with each feature.  If the callback returns a "truthy"
     * value, iteration will stop and the function will return the same value.
     *
     * If you only want to test for bounding box intersection, call the
     * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
     *     whose geometry intersects the provided extent.
     * @return {T|undefined} The return value from the last call to the callback.
     * @template T
     * @api
     */ VectorSource.prototype.forEachFeatureIntersectingExtent = function(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
         * @param {import("../Feature.js").default<Geometry>} feature Feature.
         * @return {T|undefined} The return value from the last call to the callback.
         */ function(feature) {
            var geometry = feature.getGeometry();
            if (geometry.intersectsExtent(extent)) {
                var result = callback(feature);
                if (result) return result;
            }
        });
    };
    /**
     * Get the features collection associated with this source. Will be `null`
     * unless the source was configured with `useSpatialIndex` set to `false`, or
     * with an {@link module:ol/Collection} as `features`.
     * @return {Collection<import("../Feature.js").default<Geometry>>} The collection of features.
     * @api
     */ VectorSource.prototype.getFeaturesCollection = function() {
        return this.featuresCollection_;
    };
    /**
     * Get all features on the source in random order.
     * @return {Array<import("../Feature.js").default<Geometry>>} Features.
     * @api
     */ VectorSource.prototype.getFeatures = function() {
        var features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray();
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_)) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(features, (0, $beaefe87199bb537$export$a5c4301012ad6f07)(this.nullGeometryFeatures_));
        }
        return /** @type {Array<import("../Feature.js").default<Geometry>>} */ features;
    };
    /**
     * Get all features whose geometry intersects the provided coordinate.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {Array<import("../Feature.js").default<Geometry>>} Features.
     * @api
     */ VectorSource.prototype.getFeaturesAtCoordinate = function(coordinate) {
        var features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    };
    /**
     * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
     * all features intersecting the given extent in random order (so it may include
     * features whose geometries do not intersect the extent).
     *
     * When `useSpatialIndex` is set to false, this method will return all
     * features.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {Array<import("../Feature.js").default<Geometry>>} Features.
     * @api
     */ VectorSource.prototype.getFeaturesInExtent = function(extent) {
        if (this.featuresRtree_) return this.featuresRtree_.getInExtent(extent);
        else if (this.featuresCollection_) return this.featuresCollection_.getArray();
        else return [];
    };
    /**
     * Get the closest feature to the provided coordinate.
     *
     * This method is not available when the source is configured with
     * `useSpatialIndex` set to `false`.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {function(import("../Feature.js").default<Geometry>):boolean=} opt_filter Feature filter function.
     *     The filter function will receive one argument, the {@link module:ol/Feature feature}
     *     and it should return a boolean value. By default, no filtering is made.
     * @return {import("../Feature.js").default<Geometry>} Closest feature.
     * @api
     */ VectorSource.prototype.getClosestFeatureToCoordinate = function(coordinate, opt_filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        var x = coordinate[0];
        var y = coordinate[1];
        var closestFeature = null;
        var closestPoint = [
            NaN,
            NaN
        ];
        var minSquaredDistance = Infinity;
        var extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        var filter = opt_filter ? opt_filter : (0, $013a1733c226ec50$export$22e23a2304399231);
        this.featuresRtree_.forEachInExtent(extent, /**
         * @param {import("../Feature.js").default<Geometry>} feature Feature.
         */ function(feature) {
            if (filter(feature)) {
                var geometry = feature.getGeometry();
                var previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    var minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    };
    /**
     * Get the extent of the features currently in the source.
     *
     * This method is not available when the source is configured with
     * `useSpatialIndex` set to `false`.
     * @param {import("../extent.js").Extent=} opt_extent Destination extent. If provided, no new extent
     *     will be created. Instead, that extent's coordinates will be overwritten.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */ VectorSource.prototype.getExtent = function(opt_extent) {
        return this.featuresRtree_.getExtent(opt_extent);
    };
    /**
     * Get a feature by its identifier (the value returned by feature.getId()).
     * Note that the index treats string and numeric identifiers as the same.  So
     * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
     *
     * @param {string|number} id Feature identifier.
     * @return {import("../Feature.js").default<Geometry>} The feature (or `null` if not found).
     * @api
     */ VectorSource.prototype.getFeatureById = function(id) {
        var feature = this.idIndex_[id.toString()];
        return feature !== undefined ? feature : null;
    };
    /**
     * Get a feature by its internal unique identifier (using `getUid`).
     *
     * @param {string} uid Feature identifier.
     * @return {import("../Feature.js").default<Geometry>} The feature (or `null` if not found).
     */ VectorSource.prototype.getFeatureByUid = function(uid) {
        var feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    };
    /**
     * Get the format associated with this source.
     *
     * @return {import("../format/Feature.js").default|undefined} The feature format.
     * @api
     */ VectorSource.prototype.getFormat = function() {
        return this.format_;
    };
    /**
     * @return {boolean} The source can have overlapping geometries.
     */ VectorSource.prototype.getOverlaps = function() {
        return this.overlaps_;
    };
    /**
     * Get the url associated with this source.
     *
     * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
     * @api
     */ VectorSource.prototype.getUrl = function() {
        return this.url_;
    };
    /**
     * @param {Event} event Event.
     * @private
     */ VectorSource.prototype.handleFeatureChange_ = function(event) {
        var feature = /** @type {import("../Feature.js").default<Geometry>} */ event.target;
        var featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        var geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            var extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        var id = feature.getId();
        if (id !== undefined) {
            var sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).CHANGEFEATURE, feature));
    };
    /**
     * Returns true if the feature is contained within the source.
     * @param {import("../Feature.js").default<Geometry>} feature Feature.
     * @return {boolean} Has feature.
     * @api
     */ VectorSource.prototype.hasFeature = function(feature) {
        var id = feature.getId();
        if (id !== undefined) return id in this.idIndex_;
        else return (0, $6c5e11070e371322$export$5e82334337e0f204)(feature) in this.uidIndex_;
    };
    /**
     * @return {boolean} Is empty.
     */ VectorSource.prototype.isEmpty = function() {
        return this.featuresRtree_.isEmpty() && (0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_);
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */ VectorSource.prototype.loadFeatures = function(extent, resolution, projection) {
        var loadedExtentsRtree = this.loadedExtentsRtree_;
        var extentsToLoad = this.strategy_(extent, resolution);
        this.loading = false;
        var _loop_1 = function(i, ii) {
            var extentToLoad = extentsToLoad[i];
            var alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
             * @param {{extent: import("../extent.js").Extent}} object Object.
             * @return {boolean} Contains.
             */ function(object) {
                return (0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                this_1.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).FEATURESLOADSTART));
                this_1.loader_.call(this_1, extentToLoad, resolution, projection, (function(features) {
                    this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).FEATURESLOADEND, undefined, features));
                }).bind(this_1), (function() {
                    this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).FEATURESLOADERROR));
                }).bind(this_1));
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
                this_1.loading = this_1.loader_ !== (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
            }
        };
        var this_1 = this;
        for(var i = 0, ii = extentsToLoad.length; i < ii; ++i)_loop_1(i, ii);
    };
    VectorSource.prototype.refresh = function() {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        _super.prototype.refresh.call(this);
    };
    /**
     * Remove an extent from the list of loaded extents.
     * @param {import("../extent.js").Extent} extent Extent.
     * @api
     */ VectorSource.prototype.removeLoadedExtent = function(extent) {
        var loadedExtentsRtree = this.loadedExtentsRtree_;
        var obj;
        loadedExtentsRtree.forEachInExtent(extent, function(object) {
            if ((0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(object.extent, extent)) {
                obj = object;
                return true;
            }
        });
        if (obj) loadedExtentsRtree.remove(obj);
    };
    /**
     * Remove a single feature from the source.  If you want to remove all features
     * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
     * instead.
     * @param {import("../Feature.js").default<Geometry>} feature Feature to remove.
     * @api
     */ VectorSource.prototype.removeFeature = function(feature) {
        var featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        this.removeFeatureInternal(feature);
        this.changed();
    };
    /**
     * Remove feature without firing a `change` event.
     * @param {import("../Feature.js").default<Geometry>} feature Feature.
     * @protected
     */ VectorSource.prototype.removeFeatureInternal = function(feature) {
        var featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        this.featureChangeKeys_[featureKey].forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        delete this.featureChangeKeys_[featureKey];
        var id = feature.getId();
        if (id !== undefined) delete this.idIndex_[id.toString()];
        delete this.uidIndex_[featureKey];
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE, feature));
    };
    /**
     * Remove a feature from the id index.  Called internally when the feature id
     * may have changed.
     * @param {import("../Feature.js").default<Geometry>} feature The feature.
     * @return {boolean} Removed the feature from the index.
     * @private
     */ VectorSource.prototype.removeFromIdIndex_ = function(feature) {
        var removed = false;
        for(var id in this.idIndex_)if (this.idIndex_[id] === feature) {
            delete this.idIndex_[id];
            removed = true;
            break;
        }
        return removed;
    };
    /**
     * Set the new loader of the source. The next render cycle will use the
     * new loader.
     * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
     * @api
     */ VectorSource.prototype.setLoader = function(loader) {
        this.loader_ = loader;
    };
    /**
     * Points the source to a new url. The next render cycle will use the new url.
     * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
     * @api
     */ VectorSource.prototype.setUrl = function(url) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(this.format_, 7); // `format` must be set when `url` is set
        this.setLoader((0, $588823c001569193$export$14cc81df70b6707e)(url, this.format_));
    };
    return VectorSource;
}((0, $ed6dc99f268f3882$export$2e2bcd8739ae039));
var $84888e4daf3fdf44$export$2e2bcd8739ae039 = $84888e4daf3fdf44$var$VectorSource;





/**
 * @module ol/OverlayPositioning
 */ /**
 * Overlay position: `'bottom-left'`, `'bottom-center'`,  `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, `'top-right'`
 * @enum {string}
 */ var $53538eb1d663b5af$export$2e2bcd8739ae039 = {
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_CENTER: 'bottom-center',
    BOTTOM_RIGHT: 'bottom-right',
    CENTER_LEFT: 'center-left',
    CENTER_CENTER: 'center-center',
    CENTER_RIGHT: 'center-right',
    TOP_LEFT: 'top-left',
    TOP_CENTER: 'top-center',
    TOP_RIGHT: 'top-right'
};






var $c80d3ed2a84f41ed$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {number|string} [id] Set the overlay id. The overlay id can be used
 * with the {@link module:ol/Map~Map#getOverlayById} method.
 * @property {HTMLElement} [element] The overlay element.
 * @property {Array<number>} [offset=[0, 0]] Offsets in pixels used when positioning
 * the overlay. The first element in the
 * array is the horizontal offset. A positive value shifts the overlay right.
 * The second element in the array is the vertical offset. A positive value
 * shifts the overlay down.
 * @property {import("./coordinate.js").Coordinate} [position] The overlay position
 * in map projection.
 * @property {import("./OverlayPositioning.js").default} [positioning='top-left'] Defines how
 * the overlay is actually positioned with respect to its `position` property.
 * Possible values are `'bottom-left'`, `'bottom-center'`, `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, and `'top-right'`.
 * @property {boolean} [stopEvent=true] Whether event propagation to the map
 * viewport should be stopped. If `true` the overlay is placed in the same
 * container as that of the controls (CSS class name
 * `ol-overlaycontainer-stopevent`); if `false` it is placed in the container
 * with CSS class name specified by the `className` property.
 * @property {boolean} [insertFirst=true] Whether the overlay is inserted first
 * in the overlay container, or appended. If the overlay is placed in the same
 * container as that of the controls (see the `stopEvent` option) you will
 * probably set `insertFirst` to `true` so the overlay is displayed below the
 * controls.
 * @property {PanIntoViewOptions|boolean} [autoPan=false] Pan the map when calling
 * `setPosition`, so that the overlay is entirely visible in the current viewport?
 * If `true` (deprecated), then `autoPanAnimation` and `autoPanMargin` will be
 * used to determine the panning parameters; if an object is supplied then other
 * parameters are ignored.
 * @property {PanOptions} [autoPanAnimation] The animation options used to pan
 * the overlay into view. This animation is only used when `autoPan` is enabled.
 * A `duration` and `easing` may be provided to customize the animation.
 * Deprecated and ignored if `autoPan` is supplied as an object.
 * @property {number} [autoPanMargin=20] The margin (in pixels) between the
 * overlay and the borders of the map when autopanning. Deprecated and ignored
 * if `autoPan` is supplied as an object.
 * @property {PanIntoViewOptions} [autoPanOptions] The options to use for the
 * autoPan. This is only used when `autoPan` is enabled and has preference over
 * the individual `autoPanMargin` and `autoPanOptions`.
 * @property {string} [className='ol-overlay-container ol-selectable'] CSS class
 * name.
 */ /**
 * @typedef {Object} PanOptions
 * @property {number} [duration=1000] The duration of the animation in
 * milliseconds.
 * @property {function(number):number} [easing] The easing function to use. Can
 * be one from {@link module:ol/easing} or a custom function.
 * Default is {@link module:ol/easing~inAndOut}.
 */ /**
 * @typedef {Object} PanIntoViewOptions
 * @property {PanOptions} [animation={}] The animation parameters for the pan
 * @property {number} [margin=20] The margin (in pixels) between the
 * overlay and the borders of the map when panning into view.
 */ /**
 * @enum {string}
 * @protected
 */ var $c80d3ed2a84f41ed$var$Property = {
    ELEMENT: 'element',
    MAP: 'map',
    OFFSET: 'offset',
    POSITION: 'position',
    POSITIONING: 'positioning'
};
/**
 * @classdesc
 * An element to be displayed over the map and attached to a single map
 * location.  Like {@link module:ol/control/Control~Control}, Overlays are
 * visible widgets. Unlike Controls, they are not in a fixed position on the
 * screen, but are tied to a geographical coordinate, so panning the map will
 * move an Overlay but not a Control.
 *
 * Example:
 *
 *     import Overlay from 'ol/Overlay';
 *
 *     var popup = new Overlay({
 *       element: document.getElementById('popup')
 *     });
 *     popup.setPosition(coordinate);
 *     map.addOverlay(popup);
 *
 * @api
 */ var $c80d3ed2a84f41ed$var$Overlay = /** @class */ function(_super) {
    $c80d3ed2a84f41ed$var$__extends(Overlay, _super);
    /**
     * @param {Options} options Overlay options.
     */ function Overlay(options) {
        var _this = _super.call(this) || this;
        /**
         * @protected
         * @type {Options}
         */ _this.options = options;
        /**
         * @protected
         * @type {number|string|undefined}
         */ _this.id = options.id;
        /**
         * @protected
         * @type {boolean}
         */ _this.insertFirst = options.insertFirst !== undefined ? options.insertFirst : true;
        /**
         * @protected
         * @type {boolean}
         */ _this.stopEvent = options.stopEvent !== undefined ? options.stopEvent : true;
        /**
         * @protected
         * @type {HTMLElement}
         */ _this.element = document.createElement('div');
        _this.element.className = options.className !== undefined ? options.className : 'ol-overlay-container ' + (0, $ce07df6d5d4656f1$export$99b49471b0394319);
        _this.element.style.position = 'absolute';
        _this.element.style.pointerEvents = 'auto';
        var autoPan = options.autoPan;
        if (autoPan && 'object' !== typeof autoPan) autoPan = {
            animation: options.autoPanAnimation,
            margin: options.autoPanMargin
        };
        /**
         * @protected
         * @type {PanIntoViewOptions|false}
         */ _this.autoPan = /** @type {PanIntoViewOptions} */ autoPan || false;
        /**
         * @protected
         * @type {{transform_: string,
         *         visible: boolean}}
         */ _this.rendered = {
            transform_: '',
            visible: true
        };
        /**
         * @protected
         * @type {?import("./events.js").EventsKey}
         */ _this.mapPostrenderListenerKey = null;
        _this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)($c80d3ed2a84f41ed$var$Property.ELEMENT), _this.handleElementChanged);
        _this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)($c80d3ed2a84f41ed$var$Property.MAP), _this.handleMapChanged);
        _this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)($c80d3ed2a84f41ed$var$Property.OFFSET), _this.handleOffsetChanged);
        _this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)($c80d3ed2a84f41ed$var$Property.POSITION), _this.handlePositionChanged);
        _this.addEventListener((0, $b68b3d6e32e3074a$export$1ae67e5877b1d378)($c80d3ed2a84f41ed$var$Property.POSITIONING), _this.handlePositioningChanged);
        if (options.element !== undefined) _this.setElement(options.element);
        _this.setOffset(options.offset !== undefined ? options.offset : [
            0,
            0
        ]);
        _this.setPositioning(options.positioning !== undefined ? /** @type {import("./OverlayPositioning.js").default} */ options.positioning : (0, $53538eb1d663b5af$export$2e2bcd8739ae039).TOP_LEFT);
        if (options.position !== undefined) _this.setPosition(options.position);
        return _this;
    }
    /**
     * Get the DOM element of this overlay.
     * @return {HTMLElement|undefined} The Element containing the overlay.
     * @observable
     * @api
     */ Overlay.prototype.getElement = function() {
        return /** @type {HTMLElement|undefined} */ this.get($c80d3ed2a84f41ed$var$Property.ELEMENT);
    };
    /**
     * Get the overlay identifier which is set on constructor.
     * @return {number|string|undefined} Id.
     * @api
     */ Overlay.prototype.getId = function() {
        return this.id;
    };
    /**
     * Get the map associated with this overlay.
     * @return {import("./PluggableMap.js").default|undefined} The map that the
     * overlay is part of.
     * @observable
     * @api
     */ Overlay.prototype.getMap = function() {
        return /** @type {import("./PluggableMap.js").default|undefined} */ this.get($c80d3ed2a84f41ed$var$Property.MAP);
    };
    /**
     * Get the offset of this overlay.
     * @return {Array<number>} The offset.
     * @observable
     * @api
     */ Overlay.prototype.getOffset = function() {
        return /** @type {Array<number>} */ this.get($c80d3ed2a84f41ed$var$Property.OFFSET);
    };
    /**
     * Get the current position of this overlay.
     * @return {import("./coordinate.js").Coordinate|undefined} The spatial point that the overlay is
     *     anchored at.
     * @observable
     * @api
     */ Overlay.prototype.getPosition = function() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get($c80d3ed2a84f41ed$var$Property.POSITION);
    };
    /**
     * Get the current positioning of this overlay.
     * @return {import("./OverlayPositioning.js").default} How the overlay is positioned
     *     relative to its point on the map.
     * @observable
     * @api
     */ Overlay.prototype.getPositioning = function() {
        return /** @type {import("./OverlayPositioning.js").default} */ this.get($c80d3ed2a84f41ed$var$Property.POSITIONING);
    };
    /**
     * @protected
     */ Overlay.prototype.handleElementChanged = function() {
        (0, $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1)(this.element);
        var element = this.getElement();
        if (element) this.element.appendChild(element);
    };
    /**
     * @protected
     */ Overlay.prototype.handleMapChanged = function() {
        if (this.mapPostrenderListenerKey) {
            (0, $075f937d7366f1a2$export$1d0aa160432dfea5)(this.element);
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.mapPostrenderListenerKey);
            this.mapPostrenderListenerKey = null;
        }
        var map = this.getMap();
        if (map) {
            this.mapPostrenderListenerKey = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, this.render, this);
            this.updatePixelPosition();
            var container = this.stopEvent ? map.getOverlayContainerStopEvent() : map.getOverlayContainer();
            if (this.insertFirst) container.insertBefore(this.element, container.childNodes[0] || null);
            else container.appendChild(this.element);
            this.performAutoPan();
        }
    };
    /**
     * @protected
     */ Overlay.prototype.render = function() {
        this.updatePixelPosition();
    };
    /**
     * @protected
     */ Overlay.prototype.handleOffsetChanged = function() {
        this.updatePixelPosition();
    };
    /**
     * @protected
     */ Overlay.prototype.handlePositionChanged = function() {
        this.updatePixelPosition();
        this.performAutoPan();
    };
    /**
     * @protected
     */ Overlay.prototype.handlePositioningChanged = function() {
        this.updatePixelPosition();
    };
    /**
     * Set the DOM element to be associated with this overlay.
     * @param {HTMLElement|undefined} element The Element containing the overlay.
     * @observable
     * @api
     */ Overlay.prototype.setElement = function(element) {
        this.set($c80d3ed2a84f41ed$var$Property.ELEMENT, element);
    };
    /**
     * Set the map to be associated with this overlay.
     * @param {import("./PluggableMap.js").default|undefined} map The map that the
     * overlay is part of.
     * @observable
     * @api
     */ Overlay.prototype.setMap = function(map) {
        this.set($c80d3ed2a84f41ed$var$Property.MAP, map);
    };
    /**
     * Set the offset for this overlay.
     * @param {Array<number>} offset Offset.
     * @observable
     * @api
     */ Overlay.prototype.setOffset = function(offset) {
        this.set($c80d3ed2a84f41ed$var$Property.OFFSET, offset);
    };
    /**
     * Set the position for this overlay. If the position is `undefined` the
     * overlay is hidden.
     * @param {import("./coordinate.js").Coordinate|undefined} position The spatial point that the overlay
     *     is anchored at.
     * @observable
     * @api
     */ Overlay.prototype.setPosition = function(position) {
        this.set($c80d3ed2a84f41ed$var$Property.POSITION, position);
    };
    /**
     * Pan the map so that the overlay is entirely visisble in the current viewport
     * (if necessary) using the configured autoPan parameters
     * @protected
     */ Overlay.prototype.performAutoPan = function() {
        if (this.autoPan) this.panIntoView(this.autoPan);
    };
    /**
     * Pan the map so that the overlay is entirely visible in the current viewport
     * (if necessary).
     * @param {PanIntoViewOptions=} opt_panIntoViewOptions Options for the pan action
     * @api
     */ Overlay.prototype.panIntoView = function(opt_panIntoViewOptions) {
        var map = this.getMap();
        if (!map || !map.getTargetElement() || !this.get($c80d3ed2a84f41ed$var$Property.POSITION)) return;
        var mapRect = this.getRect(map.getTargetElement(), map.getSize());
        var element = this.getElement();
        var overlayRect = this.getRect(element, [
            (0, $075f937d7366f1a2$export$e823f88e4111159a)(element),
            (0, $075f937d7366f1a2$export$fc5b8aac72846d1e)(element)
        ]);
        var panIntoViewOptions = opt_panIntoViewOptions || {};
        var myMargin = panIntoViewOptions.margin === undefined ? 20 : panIntoViewOptions.margin;
        if (!(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(mapRect, overlayRect)) {
            // the overlay is not completely inside the viewport, so pan the map
            var offsetLeft = overlayRect[0] - mapRect[0];
            var offsetRight = mapRect[2] - overlayRect[2];
            var offsetTop = overlayRect[1] - mapRect[1];
            var offsetBottom = mapRect[3] - overlayRect[3];
            var delta = [
                0,
                0
            ];
            if (offsetLeft < 0) // move map to the left
            delta[0] = offsetLeft - myMargin;
            else if (offsetRight < 0) // move map to the right
            delta[0] = Math.abs(offsetRight) + myMargin;
            if (offsetTop < 0) // move map up
            delta[1] = offsetTop - myMargin;
            else if (offsetBottom < 0) // move map down
            delta[1] = Math.abs(offsetBottom) + myMargin;
            if (delta[0] !== 0 || delta[1] !== 0) {
                var center = /** @type {import("./coordinate.js").Coordinate} */ map.getView().getCenterInternal();
                var centerPx = map.getPixelFromCoordinateInternal(center);
                if (!centerPx) return;
                var newCenterPx = [
                    centerPx[0] + delta[0],
                    centerPx[1] + delta[1]
                ];
                var panOptions = panIntoViewOptions.animation || {};
                map.getView().animateInternal({
                    center: map.getCoordinateFromPixelInternal(newCenterPx),
                    duration: panOptions.duration,
                    easing: panOptions.easing
                });
            }
        }
    };
    /**
     * Get the extent of an element relative to the document
     * @param {HTMLElement} element The element.
     * @param {import("./size.js").Size} size The size of the element.
     * @return {import("./extent.js").Extent} The extent.
     * @protected
     */ Overlay.prototype.getRect = function(element, size) {
        var box = element.getBoundingClientRect();
        var offsetX = box.left + window.pageXOffset;
        var offsetY = box.top + window.pageYOffset;
        return [
            offsetX,
            offsetY,
            offsetX + size[0],
            offsetY + size[1]
        ];
    };
    /**
     * Set the positioning for this overlay.
     * @param {import("./OverlayPositioning.js").default} positioning how the overlay is
     *     positioned relative to its point on the map.
     * @observable
     * @api
     */ Overlay.prototype.setPositioning = function(positioning) {
        this.set($c80d3ed2a84f41ed$var$Property.POSITIONING, positioning);
    };
    /**
     * Modify the visibility of the element.
     * @param {boolean} visible Element visibility.
     * @protected
     */ Overlay.prototype.setVisible = function(visible) {
        if (this.rendered.visible !== visible) {
            this.element.style.display = visible ? '' : 'none';
            this.rendered.visible = visible;
        }
    };
    /**
     * Update pixel position.
     * @protected
     */ Overlay.prototype.updatePixelPosition = function() {
        var map = this.getMap();
        var position = this.getPosition();
        if (!map || !map.isRendered() || !position) {
            this.setVisible(false);
            return;
        }
        var pixel = map.getPixelFromCoordinate(position);
        var mapSize = map.getSize();
        this.updateRenderedPosition(pixel, mapSize);
    };
    /**
     * @param {import("./pixel.js").Pixel} pixel The pixel location.
     * @param {import("./size.js").Size|undefined} mapSize The map size.
     * @protected
     */ Overlay.prototype.updateRenderedPosition = function(pixel, mapSize) {
        var style = this.element.style;
        var offset = this.getOffset();
        var positioning = this.getPositioning();
        this.setVisible(true);
        var x = Math.round(pixel[0] + offset[0]) + 'px';
        var y = Math.round(pixel[1] + offset[1]) + 'px';
        var posX = '0%';
        var posY = '0%';
        if (positioning == (0, $53538eb1d663b5af$export$2e2bcd8739ae039).BOTTOM_RIGHT || positioning == (0, $53538eb1d663b5af$export$2e2bcd8739ae039).CENTER_RIGHT || positioning == (0, $53538eb1d663b5af$export$2e2bcd8739ae039).TOP_RIGHT) posX = '-100%';
        else if (positioning == (0, $53538eb1d663b5af$export$2e2bcd8739ae039).BOTTOM_CENTER || positioning == (0, $53538eb1d663b5af$export$2e2bcd8739ae039).CENTER_CENTER || positioning == (0, $53538eb1d663b5af$export$2e2bcd8739ae039).TOP_CENTER) posX = '-50%';
        if (positioning == (0, $53538eb1d663b5af$export$2e2bcd8739ae039).BOTTOM_LEFT || positioning == (0, $53538eb1d663b5af$export$2e2bcd8739ae039).BOTTOM_CENTER || positioning == (0, $53538eb1d663b5af$export$2e2bcd8739ae039).BOTTOM_RIGHT) posY = '-100%';
        else if (positioning == (0, $53538eb1d663b5af$export$2e2bcd8739ae039).CENTER_LEFT || positioning == (0, $53538eb1d663b5af$export$2e2bcd8739ae039).CENTER_CENTER || positioning == (0, $53538eb1d663b5af$export$2e2bcd8739ae039).CENTER_RIGHT) posY = '-50%';
        var transform = "translate(" + posX + ", " + posY + ") translate(" + x + ", " + y + ")";
        if (this.rendered.transform_ != transform) {
            this.rendered.transform_ = transform;
            style.transform = transform;
            // @ts-ignore IE9
            style.msTransform = transform;
        }
    };
    /**
     * returns the options this Overlay has been created with
     * @return {Options} overlay options
     */ Overlay.prototype.getOptions = function() {
        return this.options;
    };
    return Overlay;
}((0, $b68b3d6e32e3074a$export$2e2bcd8739ae039));
var $c80d3ed2a84f41ed$export$2e2bcd8739ae039 = $c80d3ed2a84f41ed$var$Overlay;







// al final de tot hi ha un export
function $500a9350cc2f0c6d$var$llista_modalitats() {
    var modalitats = [
        {
            "modalitat": "BTT",
            "value": "btt",
            "id": "chk_btt"
        },
        {
            "modalitat": "senderisme",
            "value": "senderisme",
            "id": "chk_senderisme"
        },
        {
            "modalitat": "ciclisme",
            "value": "ciclisme",
            "id": "chk_ciclisme"
        }
    ];
    return modalitats;
}
var $500a9350cc2f0c6d$export$2e2bcd8739ae039 = $500a9350cc2f0c6d$var$llista_modalitats;


// al final de tot hi ha un export
function $330732299c8bab21$var$llista_rutes() {
    var rutes = [
        {
            "zona": "Sant Feliu",
            "id": "sant_feliu",
            "rutes": [
                {
                    "ruta": "Figar\xf3-Sant Mart\xed de C-Cingles de Bert\xed-Sant Feliu de C-Riells-La Garriga",
                    "fitxer": "figaro-sant_marti_c-cingles_de_berti-sant_feliu_c-riells-la_garriga.gpx",
                    "desc": "BTT*Sant Feliu*figaro-sant_marti_c-cingles_de_berti-sant_feliu_c-riells-la_garriga.gpx*2025-02-07*54.7 Km*03:52:10*04:35:28*2612 m*2275 m*246m*839m*"
                },
                {
                    "ruta": "Sant Feliu-Sant Miquel del Fai-Sant Quirze Safaja",
                    "fitxer": "sant_feliu-sant_miquel_del_fai-sant_quirze_safaja.gpx",
                    "desc": "ciclisme*Sant Feliu*sant_feliu-sant_miquel_del_fai-sant_quirze_safaja.gpx*2023-07-18*22.0 Km*00:58:23*00:58:23*978 m*802 m*455m*694m*"
                },
                {
                    "ruta": "Sant Feliu de Codines-Sabadell v2",
                    "fitxer": "sant_feliu_de_c-sabadell_v2.gpx",
                    "desc": "BTT*Sant Feliu*sant_feliu_de_c-sabadell.gpx*2021-05-30*28.6 Km*02:16:56*02:19:44*791 m*583 m*138m*621m*"
                },
                {
                    "ruta": "St Feliu de Codines-Tenes-Bes\xf3s-BCN",
                    "fitxer": "st_feliu_codines-tenes-besos-bcn.gpx",
                    "desc": "BTT*Sant Feliu*st_feliu_codines-tenes-besos-bcn.gpx*2020-09-20*55.5 Km*02:51:40 *03:05:16*595 m*270 m*11m*537m*vNOPPMJmWYO"
                },
                {
                    "ruta": "Sant Feliu de C-Vacarisses",
                    "fitxer": "sant_feliu_de_c-vacarisses.gpx",
                    "desc": "BTT*Sant Feliu*sant_feliu_de_c-vacarisses.gpx*2021-07-04*44.4 Km*03:10:43*03:23:43*1470 m*1182 m*314m*761m*"
                },
                {
                    "ruta": "St Feliu-Volta a la Popa",
                    "fitxer": "st_feliu_cod-volta_a_la_popa.gpx",
                    "desc": "BTT*Sant Feliu*st_feliu_cod-volta_a_la_popa.gpx*2021-03-31*35.0 Km*03:27:20*03:47:36*1113 m*906 m*472 m*887 m*"
                },
                {
                    "ruta": "Sant Feliu-Riells-Puiggraci\xf3s-Figar\xf3-Cardedeu-Granollers",
                    "fitxer": "st_feliu-riells-puigracios-figaro-cardedeu-granollers.gpx",
                    "desc": "BTT*Sant Feliu*st_feliu-riells-puigracios-figaro-cardedeu-granollers.gpx*2024-11-15*66.7 Km*04:48:05*06:20:26*2256 m*2019 m*97m*712m*"
                },
                {
                    "ruta": "Sant Feliu-Riells-Puiggraci\xf3s-Figar\xf3-Cardedeu-Granollers",
                    "fitxer": "st_feliu-riells-puigracios-figaro-cardedeu-granollers.gpx",
                    "desc": "BTT*Sant Feliu*st_feliu-riells-puigracios-figaro-cardedeu-granollers.gpx*2024-11-15*66.7 Km*04:48:05*06:20:26*2256 m*2019 m*97m*712m*"
                },
                {
                    "ruta": "Sant Feliu de Codines-Sabadell",
                    "fitxer": "sant_feliu_codines_sabadell.gpx",
                    "desc": "BTT*Sant Feliu*sant_feliu_codines_sabadell.gpx*2019-11-21*33.4 Km*02:03:28 *02:14:43*801 m*619 m*116m*621m*vNOPnEm5K2q"
                },
                {
                    "ruta": "St Feliu-Uny\xf3-Ull\xe0",
                    "fitxer": "st_miquel_del_fai_uno_ulla.gpx",
                    "desc": "senderisme*Sant Feliu*st_miquel_del_fai_uno_ulla.gpx*2015-03-30*6.4 Km*00:00:46 *03:00:27*604 m*309 m*467m*778m*vMq5dwywkQ6"
                },
                {
                    "ruta": "Volta per Sant Feliu 5",
                    "fitxer": "volta_per_sant_feliu_5.gpx",
                    "desc": "BTT*Sant Feliu*volta_per_sant_feliu_5.gpx*2022-04-09*7.8 Km*00:43:36*00:46:00*275 m*230 m*472m*640m*"
                },
                {
                    "ruta": "St Feliu de Codines-Gallifa-El Farell-Caldes",
                    "fitxer": "st_feliu_codines_gallifa_farell_caldes.gpx",
                    "desc": "BTT*Sant Feliu*st_feliu_codines_gallifa_farell_caldes.gpx*2020-06-13*29.6 Km*01:46:34*02:30:04*979 m*797 m*230m*691m*vMq5d2w37Q6"
                },
                {
                    "ruta": "Moi\xe0-Estany-Rodons-Montbr\xfa",
                    "fitxer": "moia-estany-rodons-montbru.gpx",
                    "desc": "BTT*Sant Feliu*moia-estany-rodons-montbru.gpx*2022-04-12*37.9 Km*02:35:08*03:11:48*1415 m*1056 m*541m*1032m*"
                },
                {
                    "ruta": "Caldes-El Farell-Coll Monner-Castellar",
                    "fitxer": "caldes-el_farell-coll_monner-castellar.gpx",
                    "desc": "BTT*Sant Feliu*caldes-el_farell-coll_monner-castellar.gpx*2024-09-01*35.0 Km*02:07:27*02:44:42*1279 m*1144 m*198m*691m*"
                },
                {
                    "ruta": "Sant Feliu-Gorg Negre",
                    "fitxer": "sant_feliu-gorg_negre.gpx",
                    "desc": "BTT*Sant Feliu*sant_feliu-gorg_negre.gpx*2022-08-28*10.8 Km*01:08:20*01:17:44*503 m*365 m*356m*533m*"
                },
                {
                    "ruta": "Centelles - Sant Feliu",
                    "fitxer": "centelles_stfeliu.gpx",
                    "desc": "BTT*Sant Feliu*centelles_stfeliu.gpx*2019-11-16*29.5 Km*02:14:00 *02:26:19*965 m*777 m*464m*877m*vNOPnEm5V2q"
                },
                {
                    "ruta": "Caldes de Montbui-Castell de Montbui-St Feliu-St Quirze",
                    "fitxer": "caldes_montbui-castell_montbui-st_feliu-st_quirze.gpx",
                    "desc": "BTT*Sant Feliu*caldes_montbui-castell_montbui-st_feliu-st_quirze.gpx*2023-09-03*26.4 Km*02:10:59*03:05:27*1031 m*924 m*235m*709m*"
                },
                {
                    "ruta": "Sant Feliu de Codines-Les Rovires de Baix",
                    "fitxer": "st_feliu_de_codines-les_rovires_de_baix.gpx",
                    "desc": "ciclisme*Sant Feliu*st_feliu_de_codines-les_rovires_de_baix.gpx*2023-04-07*74.1 Km*03:44:20*04:17:08*2071 m*1669 m*453m*888m*"
                },
                {
                    "ruta": "Barcelona-Sant Feliu de Codines",
                    "fitxer": "barcelona-sant_feliu.gpx",
                    "desc": "BTT*Sant Feliu*barcelona-sant_feliu.gpx*2024-12-23*37.7 Km*02:57:00*03:47:30*902 m*820 m*10m*528m*"
                },
                {
                    "ruta": "Sant Vicen\xe7 de Castellet-Obac-Estenalles-Sant Lloren\xe7 Savall-Sant Feliu de Codines",
                    "fitxer": "st_vicenc_castellet-obac-estenalles-st_llorenc_savall-st_feliu_codines.gpx",
                    "desc": "BTT*Sant Feliu*st_vicenc_castellet-obac-estenalles-st_llorenc_savall-st_feliu_codines.gpx*2022-12-24*50.9 Km*04:25:28*05:30:32*2610 m*1811 m*178m*946m*"
                },
                {
                    "ruta": "Sant Feliu de Codines-Barcelona",
                    "fitxer": "sant_feliu_codines-barcelona.gpx",
                    "desc": "BTT*Sant Feliu*sant_feliu_codines-barcelona.gpx*2024-12-27*40.5 Km*02:03:27*02:30:43*476 m*336 m*6m*485m*"
                },
                {
                    "ruta": "Sant Feliu-Sant Lloren\xe7-Vinardell-Castellter\xe7ol-Coll de Termes",
                    "fitxer": "sant_feliu-sant_llorenc-vinardell-castelltercol-coll_termes.gpx",
                    "desc": "BTT*Sant Feliu*sant_feliu-sant_llorenc-vinardell-castelltercol-coll_termes.gpx*2021-12-27*38.7 Km*03:22:00*03:39:00*1462 m*1186 m*473m*937m*"
                },
                {
                    "ruta": "Sant Feliu-Sant Miquel del Fai-Sant Quirze Safaja",
                    "fitxer": "sant_feliu-sant_miquel_del_fai-sant_quirze_safaja_v2.gpx",
                    "desc": "ciclisme*Sant Feliu*sant_feliu-sant_miquel_del_fai-sant_quirze_safaja_v2.gpx*2023-07-24*23.2 Km*00:59:20*00:59:20*1027 m*819 m*455m*695m*"
                },
                {
                    "ruta": "ToDo-St Feliu corriols",
                    "fitxer": "todo-st_feliu-corriols.gpx",
                    "desc": "BTT*Sant Feliu*todo-st_feliu-corriols.gpx*2021-04-10*15.2 Km*01:38:50*01:39:30*557 m*420 m*473 m*703 m*"
                },
                {
                    "ruta": "Barcelona-Vall del Tenes-Sant Feliu",
                    "fitxer": "barcelona-vall_del_tenes-sant_feliu.gpx",
                    "desc": "BTT*Sant Feliu*barcelona-vall_del_tenes-sant_feliu.gpx*2022-04-24*56.0 Km*03:12:52*04:05:20*974 m*741 m*0m*481m*"
                },
                {
                    "ruta": "Sant Feliu de Codines-Barnils-Puigdolena",
                    "fitxer": "st_feliu_c-barnils-puigdolena.gpx",
                    "desc": "BTT*Sant Feliu*st_feliu_c-barnils-puigdolena.gpx*2025-04-25*37.1 Km*02:51:31*03:23:59*1541 m*1349 m*467m*879m*"
                },
                {
                    "ruta": "Cam\xed dels Feliuans a la Mola de Gallifa",
                    "fitxer": "cami_feliuans-mola_gallifa.gpx",
                    "desc": "BTT*Sant Feliu*cami_feliuans-mola_gallifa.gpx*2022-05-01*3.0 Km*00:50:29*01:08:13*375 m*330 m*516m*906m*"
                },
                {
                    "ruta": "Volta per Sant Feliu 6",
                    "fitxer": "volta_per_sant_feliu_6.gpx",
                    "desc": "BTT*Sant Feliu*volta_per_sant_feliu_6.gpx*2022-08-21*12.7 Km*01:13:36*01:14:28*526 m*429 m*473m*842m*"
                },
                {
                    "ruta": "ToDo-Volta per Sant Feliu 5",
                    "fitxer": "todo-volta_per_sant_feliu_5.gpx",
                    "desc": "BTT*Sant Feliu*todo-volta_per_sant_feliu_5.gpx*2022-03-07*7.3 Km*00:00:00*00:54:20*260 m*179 m*472m*640m*"
                },
                {
                    "ruta": "Barcelona - Sant Feliu",
                    "fitxer": "bcn_stfeliu_1.gpx",
                    "desc": "BTT*Sant Feliu*bcn_stfeliu_1.gpx*2013-07-13*55.8 Km*00:25:13 *00:25:13*1466 m*1048 m*101m*674m*vYvE9GLMAwv"
                },
                {
                    "ruta": "Sant Feliu-La Garriga",
                    "fitxer": "st_feliu-la_garriga.gpx",
                    "desc": "BTT*Sant Feliu*st_feliu-la_garriga.gpx*2012-11-04*25.4 Km*01:24:47*01:59:25*686 m*581 m*302m*893m*v1OwMKVx5Xq"
                },
                {
                    "ruta": "Sant Feliu de C-Riera de Caldes-Riu Bes\xf3s-Sta Coloma de Gr",
                    "fitxer": "st_feliu_de_c-sta_coloma_de_gr.gpx",
                    "desc": "BTT*Sant Feliu*st_feliu_de_c-sta_coloma_de_gr.gpx*2020-03-01*40.7 Km*02:05:53 *02:43:06*357 m*111 m*11m*483m*vRO7d4pNXK6"
                },
                {
                    "ruta": "Sant Feliu-Sant Quirze Safaja-Sant Miquel del Fai",
                    "fitxer": "st_feliu_c-st_quirze_safaja-st_miquel_del_fai.gpx",
                    "desc": "ciclisme*Sant Feliu*st_feliu_c-st_quirze_safaja-st_miquel_del_fai.gpx*2023-07-20*23.3 Km*01:02:23*01:03:32*1036 m*847 m*440m*696m*"
                },
                {
                    "ruta": "Mollet-Gallecs-Caldes-3 Maries-El Farell-Sant Feliu",
                    "fitxer": "mollet-gallecs-caldes-3_maries-el_farell-st_feliu.gpx",
                    "desc": "BTT*Sant Feliu*mollet-gallecs-caldes-3_maries-el_farell-st_feliu.gpx*2024-11-02*31.8 Km*02:14:52*02:27:58*1358 m*1210 m*71m*779m*"
                },
                {
                    "ruta": "Manresa-Sant Feliu",
                    "fitxer": "manresa-sant_feliu.gpx",
                    "desc": "BTT*Sant Feliu*manresa-sant_feliu.gpx*2022-09-17*64.6 Km*04:38:44*05:31:40*2243 m*1650 m*201m*942m*"
                },
                {
                    "ruta": "Sant Feliu-Caldes-Sentmenat-Castellar-Can Cadafalch-Gallifa",
                    "fitxer": "sant_feliu-caldes-sentmenat-castellar-can_cadafalch-gallifa.gpx",
                    "desc": "BTT*Sant Feliu*sant_feliu-caldes-sentmenat-castellar-can_cadafalch-gallifa.gpx*2022-08-29*40.5 Km*02:25:24*02:43:52*1266 m*912 m*206m*657m*"
                },
                {
                    "ruta": "Caldes de Monbui-Castell de Montbui-St Feliu-St Quirze",
                    "fitxer": "caldes_monbui-castell_montbui-st_feliu-st_quirze.gpx",
                    "desc": "BTT*Sant Feliu*caldes_monbui-castell_montbui-st_feliu-st_quirze.gpx*2023-09-03*26.4 Km*02:10:59*03:05:27*1031 m*924 m*235m*709m*"
                },
                {
                    "ruta": "Sant Feliu-La Garriga v2",
                    "fitxer": "st_feliu-la_garriga_v2.gpx",
                    "desc": "BTT*Sant Feliu*st_feliu-la_garriga_v2.gpx*2021-04-09*25.6 Km*02:03:04*02:27:04*936 m*722 m*242 m*832 m*"
                },
                {
                    "ruta": "Centelles-Collsuspina-Popa-St Feliu de Codines",
                    "fitxer": "Centelles-Collsuspina-Popa-St_Feliu_de_Codines.gpx",
                    "desc": "BTT*Sant Feliu*Centelles-Collsuspina-Popa-St_Feliu_de_Codines.gpx*2020-12-24*35.6 Km*02:56:36*03:13:12*1071 m*798 m*475m*946m*"
                },
                {
                    "ruta": "Terrassa-Sant Feliu de Codines",
                    "fitxer": "Terrassa-Sant_Feliu_de_Codines.gpx",
                    "desc": "BTT*Sant Feliu*Terrassa-Sant_Feliu_de_Codines.gpx*2020-02-02*34.7 Km*02:34:50 *02:50:15*1253 m*1040 m*269m*644m*vQvyz5M5yKO"
                },
                {
                    "ruta": "Castellter\xe7ol, Sant Juli\xe0 d'\xdaixols i Sant Quirze Safaja",
                    "fitxer": "castelltercol-sant-julia-duixols-i-sant-quirze-safaja.gpx",
                    "desc": "BTT*Sant Feliu*castelltercol-sant-julia-duixols-i-sant-quirze-safaja.gpx*2011-09-18*15.5 Km*22:22:32 *22:22:32*552 m*456 m*604m*893m*v1OwMKVPmXq"
                },
                {
                    "ruta": "St_Feliu_Codines-Poses-Matafaluga-Gallifa",
                    "fitxer": "St_Feliu_Codines-Poses-Matafaluga-Gallifa.gpx",
                    "desc": "BTT*Sant Feliu*St_Feliu_Codines-Poses-Matafaluga-Gallifa.gpx*2020-07-18*37.9 Km*02:27:36*02:39:48*1171 m*887 m*471m*942m*vQvyD1NxNKq"
                },
                {
                    "ruta": "Volta per Sant Feliu 1",
                    "fitxer": "volta_per_st_feliu_1.gpx",
                    "desc": "BTT*Sant Feliu*volta_per_st_feliu_1.gpx*2020-12-07*12.4 Km*01:03:32*01:03:52*450 m*367 m*362m*560m*"
                },
                {
                    "ruta": "Sant Feliu-Castellter\xe7ol-Granera-Monistrol-Calders-Sant Fruit\xf3s-Manresa",
                    "fitxer": "st_feliu-castelltercol-granera-monistrol-calders-st_fruitos-manresa.gpx",
                    "desc": "ciclisme*Sant Feliu*st_feliu-castelltercol-granera-monistrol-calders-st_fruitos-manresa.gpx*2024-11-08*52.6 Km*02:20:24*03:07:47*1362 m*1121 m*206m*793m*"
                },
                {
                    "ruta": "Girona-Els \xc0ngels",
                    "fitxer": "girona-els_angels.gpx",
                    "desc": "ciclisme*Sant Feliu*girona-els_angels.gpx*2024-03-16*24.0 Km*01:12:04*01:27:19*901 m*764 m*73m*475m*"
                },
                {
                    "ruta": "Sant Feliu-Castellter\xe7ol-Llogari-Granera",
                    "fitxer": "can_deu-termes-uixols-castelltercol-llogari-granera-gallifa.gpx",
                    "desc": "BTT*Sant Feliu*can_deu-termes-uixols-castelltercol-llogari-granera-gallifa.gpx*2021-08-19*50.7 Km*03:24:24*03:39:48*1569 m*1264 m*470m*894m*"
                },
                {
                    "ruta": "Sta Coloma Gr-Vall del Tenes-St Feliu",
                    "fitxer": "sta_coloma-tenes-st_feliu.gpx",
                    "desc": "BTT*Sant Feliu*sta_coloma-tenes-st_feliu.gpx*2021-03-30*43.8 Km*02:55:44*02:56:58*841 m*601 m*13 m*480 m*"
                },
                {
                    "ruta": "Sant Feliu-Sant Miquel del Fai-Cam\xed a Llobateres",
                    "fitxer": "sant_feliu-sant_miquel_del_fai-cami_a_llobateres.gpx",
                    "desc": "BTT*Sant Feliu*sant_feliu-sant_miquel_del_fai-cami_a_llobateres.gpx*2021-08-30*15.4 Km*01:56:52*01:57:19*551 m*407 m*472m*656m*"
                },
                {
                    "ruta": "Volta per Sant Feliu 4",
                    "fitxer": "volta_per_sant_feliu_4.gpx",
                    "desc": "senderisme*Sant Feliu*volta_per_sant_feliu_4.gpx*2021-12-25*6.7 Km*01:55:44*02:07:28*324 m*295 m*414m*566m*"
                },
                {
                    "ruta": "Vacarisses-Obac-St Llorenc Savall-Gallifa-St Feliu",
                    "fitxer": "Vacarisses-Obac-St_Llorenc_Savall-Gallifa-St_Feliu.gpx",
                    "desc": "BTT*Sant Feliu*Vacarisses-Obac-St_Llorenc_Savall-Gallifa-St_Feliu.gpx*2021-05-08*45.0 Km*03:03:32*03:06:56*1461 m*1177 m*324m*760m*"
                },
                {
                    "ruta": "Sant Feliu de Codines-Terrassa",
                    "fitxer": "Sant_feliu_codines-Terrassa.gpx",
                    "desc": "BTT*Sant Feliu*Sant_feliu_codines-Terrassa.gpx*2020-02-09*39.4 Km*02:44:36 *03:12:44*1201 m*932 m*273m*636m*vXvLYm5E97O"
                },
                {
                    "ruta": "Volta a Sant Feliu 3",
                    "fitxer": "volta_sant_feliu_3.gpx",
                    "desc": "BTT*Sant Feliu*volta_sant_feliu_3.gpx*2021-08-17*31.9 Km*02:52:40*02:58:16*1002 m*767 m*318m*559m*"
                },
                {
                    "ruta": "Volta per Sant Feliu 2",
                    "fitxer": "volta_per_sant_feliu_2.gpx",
                    "desc": "BTT*Sant Feliu*volta_per_sant_feliu_2.gpx*2021-07-03*15.4 Km*01:11:28*01:11:28*523 m*398 m*318m*533m*"
                },
                {
                    "ruta": "Sant Feliu de C-Sant Vicen\xe7 de Castellet",
                    "fitxer": "sant_feliu_de_c-sant_vicenc_de_castellet.gpx",
                    "desc": "ciclisme*Sant Feliu*sant_feliu_de_c-sant_vicenc_de_castellet.gpx*2021-09-25*47.9 Km*02:14:40*02:14:40*1038 m*706 m*175m*651m*"
                },
                {
                    "ruta": "Sant Feliu-Soler del Coll-Centelles-Popa-Sant Feliu",
                    "fitxer": "sant_feliu-soler_del_coll-centelles-popa-sant_feliu.gpx",
                    "desc": "BTT*Sant Feliu*sant_feliu-soler_del_coll-centelles-popa-sant_feliu.gpx*2022-02-27*49.5 Km*03:19:24*03:36:31*1956 m*1300 m*456m*891m*"
                },
                {
                    "ruta": "Sabadell-Sant Feliu-Sabadell",
                    "fitxer": "sabadell-sant_feliu-sabadell.gpx",
                    "desc": "BTT*Sant Feliu*sabadell-sant_feliu-sabadell.gpx*2024-09-27*57.2 Km*03:17:24*03:54:44*1929 m*1731 m*144m*780m*"
                },
                {
                    "ruta": "Sant Feliu-Can D\xe9u-Collet dels Termes",
                    "fitxer": "st_feliu-can_deu-collet_termes.gpx",
                    "desc": "BTT*Sant Feliu*st_feliu-can_deu-collet_termes.gpx*2024-03-28*13.8 Km*01:09:44*01:10:50*665 m*603 m*468m*836m*"
                },
                {
                    "ruta": "Can D\xe9u del Ve\xefnat-Collet de Termes-Coll de Poses-Cam\xed dels Horts",
                    "fitxer": "can_deu_del_veinat-collet_de_termes-coll_de_poses-cami_dels_horts.gpx",
                    "desc": "BTT*Sant Feliu*can_deu_del_veinat-collet_de_termes-coll_de_poses-cami_dels_horts.gpx*2021-09-19*14.7 Km*01:30:48*01:30:48*526 m*445 m*465m*840m*"
                },
                {
                    "ruta": "Can D\xe9u del Ve\xefnat-Collet de Termes-Coll de Poses-Cam\xed dels Horts",
                    "fitxer": "can_deu_del_veinat-collet_de_termes-coll_de_poses-cami_dels_horts.gpx",
                    "desc": "BTT*Sant Feliu*can_deu_del_veinat-collet_de_termes-coll_de_poses-cami_dels_horts.gpx*2021-09-19*14.7 Km*01:30:48*01:30:48*526 m*445 m*465m*840m*"
                },
                {
                    "ruta": "Centelles-Collsuspina-Sta Coloma S-Castellter\xe7ol-St Juli\xe0 Uixols-St Feliu",
                    "fitxer": "centelles-collsus-sta_col_sasserra-castelltercol-uixols.gpx",
                    "desc": "BTT*Sant Feliu*centelles-collsus-sta_col_sasserra-castelltercol-uixols.gpx*2021-02-21*41.0 Km*03:07:16*03:20:44*1170 m*960 m*471m*939m*"
                },
                {
                    "ruta": "Sant Feliu de Codines-Caldes-Sentmenat-Castellar-St Sebasti\xe0 de Montmajor",
                    "fitxer": "st_feliu-caldes-castellar-montmajor.gpx",
                    "desc": "BTT*Sant Feliu*st_feliu-caldes-castellar-montmajor.gpx*2020-06-07*38.9 Km*02:53:22 *03:02:33*1345 m*1061 m*201m*621m*v8qV125GE76"
                },
                {
                    "ruta": "Centelles-El Soler del Coll-Sant Feliu",
                    "fitxer": "centelles-el_soler_del_coll-sant_feliu.gpx",
                    "desc": "BTT*Sant Feliu*centelles-el_soler_del_coll-sant_feliu..gpx*2024-09-14*25.9 Km*01:42:25*01:45:15*1226 m*1020 m*455m*850m*"
                },
                {
                    "ruta": "Sant Feliu-Collsuspina",
                    "fitxer": "sant_feliu-collsuspina.gpx",
                    "desc": "BTT*Sant Feliu*sant_feliu-collsuspina.gpx*2021-08-22*46.5 Km*03:20:59*03:31:47*1177 m*893 m*472m*916m*"
                },
                {
                    "ruta": "NO-Volta per Sant Feliu 6",
                    "fitxer": "NO-volta_per_sant_feliu_6.gpx",
                    "desc": "BTT*Sant Feliu*NO-volta_per_sant_feliu_6.gpx*2022-08-27*12.0 Km*01:12:56*01:12:56*523 m*433 m*481m*843m*"
                },
                {
                    "ruta": "Sant Feliu de C-Castellter\xe7ol-Granera-Sant Lloren\xe7 Savall",
                    "fitxer": "sant_feliu_c-castelltercol-granera-sant_llorenc_savall.gpx",
                    "desc": "ciclisme*Sant Feliu*sant_feliu_c-castelltercol-granera-sant_llorenc_savall.gpx*2023-07-19*46.9 Km*02:00:53*02:02:46*1526 m*1271 m*467m*793m*"
                }
            ]
        },
        {
            "zona": "TNR",
            "id": "tnr",
            "rutes": [
                {
                    "ruta": "TNR-7",
                    "fitxer": "TNR-7.gpx",
                    "desc": "BTT*TNR*TNR-7.gpx*2024-07-09*84.9 Km*07:29:37*10:28:29*4751 m*3378 m*769m*2242m*"
                },
                {
                    "ruta": "TNR-1",
                    "fitxer": "TNR-1.gpx",
                    "desc": "BTT*TNR*TNR-1.gpx*2024-07-03*57.8 Km*03:50:01*05:08:31*1991 m*1717 m*224m*1182m*"
                },
                {
                    "ruta": "TNR-1",
                    "fitxer": "TNR-1.gpx",
                    "desc": "BTT*TNR*TNR-1.gpx*2024-07-03*57.8 Km*03:50:01*05:08:31*1991 m*1717 m*224m*1182m*"
                },
                {
                    "ruta": "TNR-4",
                    "fitxer": "TNR-4.gpx",
                    "desc": "BTT*TNR*TNR-4.gpx*2024-07-06*50.2 Km*04:19:35*07:43:03*2569 m*2316 m*1181m*2362m*"
                },
                {
                    "ruta": "TNR-8",
                    "fitxer": "TNR-8.gpx",
                    "desc": "BTT*TNR*TNR-8.gpx*2024-07-10*77.4 Km*05:45:43*09:20:22*4945 m*3536 m*298m*2032m*"
                },
                {
                    "ruta": "TNR-9",
                    "fitxer": "TNR-9.gpx",
                    "desc": "BTT*TNR*TNR-9.gpx*2024-07-11*66.6 Km*04:13:30*06:17:05*3080 m*2206 m*3m*1101m*"
                },
                {
                    "ruta": "TNR-5",
                    "fitxer": "TNR-5.gpx",
                    "desc": "BTT*TNR*TNR-5.gpx*2024-07-07*103.6 Km*07:40:11*10:48:43*4903 m*3592 m*736m*2739m*"
                },
                {
                    "ruta": "TNR-6",
                    "fitxer": "TNR-6.gpx",
                    "desc": "BTT*TNR*TNR-6.gpx*2024-07-08*93.3 Km*05:22:45*10:24:05*3604 m*2630 m*596m*2533m*"
                },
                {
                    "ruta": "TNR-3",
                    "fitxer": "TNR-3.gpx",
                    "desc": "BTT*TNR*TNR-3.gpx*2024-07-05*75.9 Km*05:35:29*08:07:11*3405 m*2730 m*1181m*2537m*"
                },
                {
                    "ruta": "TNR-0",
                    "fitxer": "TNR-0.gpx",
                    "desc": "BTT*TNR*TNR-0.gpx*2024-07-03*18.3 Km*01:20:12*01:27:02*309 m*277 m*214m*299m*"
                },
                {
                    "ruta": "TNR-2",
                    "fitxer": "TNR-2.gpx",
                    "desc": "BTT*TNR*TNR-2.gpx*2024-07-04*74.4 Km*07:08:32*10:38:50*3943 m*3299 m*367m*2103m*"
                }
            ]
        },
        {
            "zona": "Bergued\xe0",
            "id": "bergueda",
            "rutes": [
                {
                    "ruta": "Volta Catalunya Central 2/3-Sant Quirze de Besora-Berga-Solsona",
                    "fitxer": "VCC2-st_quirze_besora-berga-solsona.gpx",
                    "desc": "BTT*Bergued\xe0*VCC2-st_quirze_besora-berga-solsona.gpx*2024-11-24*111.3 Km*08:40:02*10:16:42*3811 m*3460 m*489m*979m*"
                },
                {
                    "ruta": "Malanyeu-Grau del Griell-Foradada",
                    "fitxer": "malanyeu-grau_del_griell-foradada.gpx",
                    "desc": "senderisme*Bergued\xe0*malanyeu-grau_del_griell-foradada.gpx*2021-07-11*4.0 Km*01:21:21*02:01:46*538 m*426 m*1010m*1321m*"
                },
                {
                    "ruta": "Manresa-la s\xe8quia-Cornet-Les Rovires",
                    "fitxer": "manresa-la_sequia-cornet-rovires.gpx",
                    "desc": "BTT*Bergued\xe0*manresa-la_sequia-cornet-rovires.gpx*2025-05-01*72.4 Km*04:24:29*05:30:40*2032 m*1782 m*207m*876m*"
                },
                {
                    "ruta": "Riutort - Pobla de Lillet",
                    "fitxer": "riutort_pobla_de_lillet.gpx",
                    "desc": "BTT*Bergued\xe0*riutort_pobla_de_lillet.gpx*2020-01-11*14.4 Km*00:04:34 *00:04:34*734 m*652 m*781m*1417m*vmqX1GGWYov"
                },
                {
                    "ruta": "Les Rovires de Baix 6",
                    "fitxer": "les_rovires_de_baix_6.gpx",
                    "desc": "BTT*Bergued\xe0*les_rovires_de_baix_6.gpx*2022-06-23*7.8 Km*00:46:52*00:46:52*354 m*294 m*687m*876m*"
                },
                {
                    "ruta": "Les Rovires de Baix-Tordelesp\xe0",
                    "fitxer": "les_rovires_de_baix-tordelespa.gpx",
                    "desc": "senderisme*Bergued\xe0*les_rovires_de_baix-tordelespa.gpx*2022-10-31*12.6 Km*02:19:04*06:03:32*515 m*523 m*723m*875m*"
                },
                {
                    "ruta": "Berga-Cal Rosal St Maurici de la Quar-La Portella",
                    "fitxer": "berga-cal_rosal_st_maurici_de_la_quar-la_portella.gpx",
                    "desc": "BTT*Bergued\xe0*berga-cal_rosal_st_maurici_de_la_quar-la_portella.gpx*2022-04-11*46.7 Km*04:25:39*05:05:44*1761 m*1242 m*469m*1049m*"
                },
                {
                    "ruta": "Carretera del Jou",
                    "fitxer": "carretera_del_jou.gpx",
                    "desc": "BTT*Bergued\xe0*carretera_del_jou.gpx*2021-08-23*11.1 Km*01:28:24*02:00:12*332 m*283 m*881m*1043m*"
                },
                {
                    "ruta": "ToDo-Sant Jaume de Frontany\xe0 - Gombr\xe8n v2",
                    "fitxer": "todo-gombren-sant-jaume-de-frontanya-gombren_v2.gpx",
                    "desc": "BTT*Bergued\xe0*todo-gombren-sant-jaume-de-frontanya-gombren_v2.gpx*2020-12-18*45.5 Km*01:30:30 *01:30:30*1612 m*981 m*777m*1385m*"
                },
                {
                    "ruta": "Cercs-Berga-els Rasos de Peguera-Peguera-F\xedgols-Cercs",
                    "fitxer": "cercs-berga-rasos_peguera-peguera-figols-cercs.gpx",
                    "desc": "BTT*Bergued\xe0*cercs-berga-rasos_peguera-peguera-figols-cercs.gpx*2025-06-06*46.5 Km*03:10:40*03:48:12*2228 m*2017 m*645m*1895m*"
                },
                {
                    "ruta": "ToDo-Volta a la Serra d'Ensija",
                    "fitxer": "todo-volta_serra_ensija.gpx",
                    "desc": "BTT*Bergued\xe0*todo-volta_serra_ensija.gpx*2021-01-12*27.8 Km*00:43:00*00:43:00*1572 m*1032 m*1144m*1830m*"
                },
                {
                    "ruta": "ToDo-Cercs-Figuerassa",
                    "fitxer": "todo-cercs-figuerassa.gpx",
                    "desc": "BTT*Bergued\xe0*todo-cercs-figuerassa.gpx*2022-10-22*25.9 Km*00:20:08*00:54:08*1229 m*809 m*691m*1492m*"
                },
                {
                    "ruta": "El Collet-Coll de Pradell",
                    "fitxer": "collet-coll_pradell.gpx",
                    "desc": "ciclisme*Bergued\xe0*collet-coll_pradell.gpx*2024-03-23*15.4 Km*01:36:30*01:40:18*1341 m*1267 m*710m*1745m*"
                },
                {
                    "ruta": "ToDo-Campdev\xe0nol-Les Rovires",
                    "fitxer": "todo-campdevanol-les_rovires.gpx",
                    "desc": "BTT*Bergued\xe0*todo-camprodon-les_rovires.gpx*2021-08-02*1.0 Km*01:00:00*01:00:00*100 m*100 m*100m*100m*"
                },
                {
                    "ruta": "ToDo-Campdev\xe0nol-Les Rovires",
                    "fitxer": "todo-campdevanol-les_rovires.gpx",
                    "desc": "BTT*Bergued\xe0*todo-camprodon-les_rovires.gpx*2021-08-02*1.0 Km*01:00:00*01:00:00*100 m*100 m*100m*100m*"
                },
                {
                    "ruta": "Pedr\xf3 de Tubau",
                    "fitxer": "pedro_de_tubau.gpx",
                    "desc": "senderisme*Bergued\xe0*pedro_de_tubau.gpx*2023-10-12*13.6 Km*20:10:14*21:19:15*773 m*684 m*1114m*1529m*"
                },
                {
                    "ruta": "Vallcebre-Coll de Pradell-Cingles de Costafreda",
                    "fitxer": "vallcebre-coll_de_pradell-cingles_de_costafreda.gpx",
                    "desc": "BTT*Bergued\xe0*vallcebre-coll_de_pradell-cingles_de_costafreda.gpx*2022-08-03*15.8 Km*01:18:32*01:26:27*795 m*722 m*1123m*1745m*"
                },
                {
                    "ruta": "Mirador de la Figuerassa",
                    "fitxer": "mirador_de_la_figuerassa.gpx",
                    "desc": "senderisme*Bergued\xe0*mirador_de_la_figuerassa.gpx*2023-02-20*5.8 Km*01:40:40*01:49:24*336 m*279 m*1312m*1493m*"
                },
                {
                    "ruta": "ToDo-Sant Jaume de Frontany\xe0 - Gombr\xe8n v1",
                    "fitxer": "todo-gombren-sant-jaume-de-frontanya-gombren_v1.gpx",
                    "desc": "BTT*Bergued\xe0*todo-gombren-sant-jaume-de-frontanya-gombren_v1.gpx*2020-12-18*45.5 Km*01:30:30 *01:30:30*1813 m*1094 m*777m*1377m*"
                },
                {
                    "ruta": "ToDo-Volta als Rasos de Tubau",
                    "fitxer": "todo-volta_rasos_tubau.gpx",
                    "desc": "BTT*Bergued\xe0*todo-todo-volta_rasos_tubau.gpx*2021-01-12*45.1 Km*01:23:00*01:23:00*1699 m*915 m*723m*1219m*"
                },
                {
                    "ruta": "Rasos de Peguera-Cogull\xf3 d'Estela-Roca d'Aur\xf3-Torre dels Enginyers",
                    "fitxer": "rasos_peguera-cogullo_estela-roca_auro-torre_enginyers.gpx",
                    "desc": "senderisme*Bergued\xe0*rasos_peguera-cogullo_estela-roca_auro-torre_enginyers.gpx*2025-08-17*11.5 Km*02:50:09*03:03:32*861 m*697 m*1724m*2054m*"
                },
                {
                    "ruta": "La Sala-Sta Cec\xedlia de Riutort-Coll Cerqueda-Coll Portelletes",
                    "fitxer": "la_sala-sta_cecilia_riutort-coll_cerqueda-coll_portelletes.gpx",
                    "desc": "BTT*Bergued\xe0*la_sala-sta_cecilia_riutort-coll_cerqueda-coll_portelletes.gpx*2020-07-02*17.2 Km*01:21:59 *02:10:15*809 m*668 m*793m*1299m*vZqNNRxKxGq"
                },
                {
                    "ruta": "ToDo-Rovires de Baix-Pedr\xf3 de Tubau-v2",
                    "fitxer": "todo-rovires_de_baix-pedro_tubau-v2.gpx",
                    "desc": "BTT*Bergued\xe0*todo-rovires_de_baix-pedro_tubau-v2.gpx*2022-10-22*46.1 Km*00:20:08*00:54:08*1888 m*1121 m*743m*1529m*"
                },
                {
                    "ruta": "ToDo-Coll de Pal-Pobla de Lillet",
                    "fitxer": "todo-coll_de_pal-pobla_de_lillet.gpx",
                    "desc": "BTT*Bergued\xe0*todo-coll_de_pal-pobla_de_lillet.gpx*2021-01-12*15.8 Km*00:22:00*00:22:00*357 m*65 m*854m*1967m*"
                },
                {
                    "ruta": "ToDo-Coll de Pal-Pobla de Lillet",
                    "fitxer": "todo-coll_de_pal-pobla_de_lillet.gpx",
                    "desc": "BTT*Bergued\xe0*todo-coll_de_pal-pobla_de_lillet.gpx*2021-01-12*15.8 Km*00:22:00*00:22:00*357 m*65 m*854m*1967m*"
                },
                {
                    "ruta": "Les Rovires de Baix 1",
                    "fitxer": "les_rovires_de_baix_1.gpx",
                    "desc": "BTT*Bergued\xe0*les_rovires_de_baix_1.gpx*2020-08-08*15.5 Km*02:55:10*02:55:10*710 m*536 m*732m*952m*vRO7dZ1pYy6"
                },
                {
                    "ruta": "Cercs - Peguera - Cercs",
                    "fitxer": "cercs-peguera.gpx",
                    "desc": "BTT*Bergued\xe0*cercs-peguera.gpx*2013-07-13*37.9 Km*00:10:16 *06:24:24*1715 m*1423 m*635m*1830m*vdvmB4no4NO"
                },
                {
                    "ruta": "ToDo-Ripoll-Les Rovires",
                    "fitxer": "todo-ripoll-les_rovires.gpx",
                    "desc": "BTT*Bergued\xe0*todo-ripoll-les_rovires.gpx*2021-08-02*1.0 Km*01:00:00*01:00:00*100 m*100 m*100m*100m*"
                },
                {
                    "ruta": "La Catllar\xe0s 2018",
                    "fitxer": "la-catllaras-2018.gpx",
                    "desc": "BTT*Bergued\xe0*la-catllaras-2018.gpx*2018-10-22*47.8 Km*00:22:42 *03:44:41*2213 m*1865 m*871m*1695m*vXOd3mjA54v"
                },
                {
                    "ruta": "La Pobla de Lillet-Gombr\xe8n-Castellar de n'Hug",
                    "fitxer": "la_pobla_de_lillet-gombren-castellar_de_nhug.gpx",
                    "desc": "BTT*Bergued\xe0*la_pobla_de_lillet-gombren-castellar_de_nhug.gpx*2021-11-06*45.8 Km*03:48:20*04:14:34*1755 m*1362 m*836m*1415m"
                },
                {
                    "ruta": "Montclar-Montmajor-Cardona",
                    "fitxer": "montclar-montmajor-cardona.gpx",
                    "desc": "BTT*Bergued\xe0*montclar-montmajor-cardona.gpx*2021-08-29*50.8 Km*03:13:43*03:34:43*1355 m*1063 m*403m*820m*"
                },
                {
                    "ruta": "Les Rovires de Baix-Ripoll",
                    "fitxer": "les_rovires_de_baix-ripoll.gpx",
                    "desc": "ciclisme*Bergued\xe0*les_rovires_de_baix-ripoll.gpx*2023-04-08*25.9 Km*01:09:36*01:14:20*686 m*423 m*666m*982m*"
                },
                {
                    "ruta": "Queralt-Espinalbet-La Figuerassa",
                    "fitxer": "queralt-espinalbet-la_figuerassa.gpx",
                    "desc": "BTT*Bergued\xe0*queralt-espinalbet-la_figuerassa.gpx*2023-08-19*17.5 Km*02:33:01*03:34:40*1048 m*818 m*920m*1493m*"
                },
                {
                    "ruta": "ToDo-Vilada-La Nou-Malanyeu-La Clusa",
                    "fitxer": "todo-vilada-la_nou-malanyeu-la_clusa.gpx",
                    "desc": "BTT*Bergued\xe0*todo-vilada-la_nou-malanyeu-la_clusa.gpx*2022-10-22*34.3 Km*00:20:08*00:54:08*1909 m*1168 m*643m*1586m*"
                },
                {
                    "ruta": "ToDo-El Collet-Vallcebre-Coll de Pradell-Saldes-Riera Saldes",
                    "fitxer": "todo-el_collet-vallcebre-coll_de_pradell-saldes-riera_saldes.gpx",
                    "desc": "BTT*Bergued\xe0*todo-el_collet-vallcebre-coll_de_pradell-saldes-riera_saldes.gpx*2021-01-12*40.1 Km*00:57:00*00:57:00*1972 m*1150 m*718m*1738m*"
                },
                {
                    "ruta": "Cavalls del Vent",
                    "fitxer": "cavalls_del_vent.gpx",
                    "desc": "senderisme*Bergued\xe0*cavalls_del_vent.gpx*2004-08-15*78.9 Km*00:00:40*05:51:00*6709 m*5459 m*910m*2520m*"
                },
                {
                    "ruta": "Les Rovires de Baix 4",
                    "fitxer": "les_rovires_de_baix_4.gpx",
                    "desc": "BTT*Bergued\xe0*les_rovires_de_baix_4.gpx*2021-10-10*25.4 Km*02:12:00*02:15:44*1067 m*831 m*731m*1099m*"
                },
                {
                    "ruta": "Baix Bergued\xe0",
                    "fitxer": "baix_bergueda.gpx",
                    "desc": "ciclisme*Bergued\xe0*baix_bergueda.gpx*2023-08-20*68.2 Km*03:31:26*04:43:18*1584 m*1175 m*351m*891m*"
                },
                {
                    "ruta": "Les Rovires de Baix 7",
                    "fitxer": "les_rovires_de_baix_7.gpx",
                    "desc": "BTT*Bergued\xe0*les_rovires_de_baix_7.gpx*2022-10-16*32.6 Km*02:37:24*02:38:48*1490 m*1029 m*742m*1262m*"
                },
                {
                    "ruta": "La Nou-La Baells-Berga-Cercs",
                    "fitxer": "la_nou-la_baells-berga-cercs.gpx",
                    "desc": "ciclisme*Bergued\xe0*la_nou-la_baells-berga-cercs.gpx*2023-08-16*28.3 Km*02:20:00*02:20:00*1116 m*623 m*624m*927m*"
                },
                {
                    "ruta": "Les Rovires-Borred\xe0 a peu",
                    "fitxer": "les_rovires-borreda-a_peu.gpx",
                    "desc": "senderisme*Bergued\xe0*les_rovires-borreda-a_peu.gpx*2021-04-03*4.0 Km*01:56:04*02:13:32*236 m*193 m*769 m*922 m*"
                },
                {
                    "ruta": "berga-cal_rosal-montsent_(el_banc)",
                    "fitxer": "berga-cal_rosal-montsent_(el_banc).gpx",
                    "desc": "BTT*Bergued\xe0*berga-cal_rosal-montsent_(el_banc).gpx*2022-08-08*23.8 Km*02:32:32*03:11:19*1166 m*966 m*483m*934m*"
                },
                {
                    "ruta": "ToDo-Bag\xe0-Gr\xe9ixer-Escriu-Pend\xeds-Bellver",
                    "fitxer": "todo-baga-greixer-escriu-pendis-bellver.gpx",
                    "desc": "BTT*Bergued\xe0*todo-baga-greixer-escriu-pendis-bellver.gpx*2021-01-12*24.1 Km*00:28:00*00:28:00*950 m*864 m*815m*1815m*"
                },
                {
                    "ruta": "ToDo-Casserres-Montclar",
                    "fitxer": "todo-Casserres-Montclar.gpx",
                    "desc": "BTT*Bergued\xe0*todo-Casserres-Montclar.gpx*2020-12-18*23.8 Km*00:10:06*00:10:06*591 m*542 m*554m*773m*"
                },
                {
                    "ruta": "ToDo-Baix Bergued\xe0",
                    "fitxer": "todo-baix_bergueda.gpx",
                    "desc": "ciclisme*Bergued\xe0*todo-baix_bergueda.gpx*2021-01-04*67.0 Km*00:44:40*00:45:00*1274 m*829 m*351m*888*"
                },
                {
                    "ruta": "La Valldan-Campllong-Terrers",
                    "fitxer": "valldan-campllong-terrers.gpx",
                    "desc": "BTT*Bergued\xe0*valldan-campllong-terrers.gpx*2025-04-15*40.1 Km*03:37:16*04:18:47*2090 m*1851 m*753m*1453m*"
                },
                {
                    "ruta": "La Pobla de Lillet-Falgars",
                    "fitxer": "la_pobla_de_lillet-falgars.gpx",
                    "desc": "senderisme*Bergued\xe0*la_pobla_de_lillet-falgars.gpx*2022-12-30*3.9 Km*00:53:40*01:23:52*500 m*448 m*849m*1274m*"
                },
                {
                    "ruta": "Bag\xe0-Sant Juli\xe0 de Cerdanyola-Malanyeu-La Nou-Vilada-Sant Quirze de Besora",
                    "fitxer": "baga-st_julia_cerdanyola-malanyeu-la_nou-vilada-st_quirze_besora.gpx",
                    "desc": "BTT*Bergued\xe0*baga-st_julia_cerdanyola-malanyeu-la_nou-vilada-st_quirze_besora.gpx*2022-12-18*69.0 Km*04:50:12*05:24:06*2498 m*1843 m*568m*1385m*"
                },
                {
                    "ruta": "Les Rovires de Baix 3",
                    "fitxer": "les_rovires_de_baix_3.gpx",
                    "desc": "BTT*Bergued\xe0*les_rovires_de_baix_3.gpx*2020-08-08*15.5 Km*02:56:00 *02:56:00*710 m*536 m*732m*952m*veqzDYKQj7O"
                },
                {
                    "ruta": "Les Rovires de Baix 3",
                    "fitxer": "les_rovires_de_baix_3.gpx",
                    "desc": "BTT*Bergued\xe0*les_rovires_de_baix_3.gpx*2020-08-08*15.5 Km*02:56:00 *02:56:00*710 m*536 m*732m*952m*veqzDYKQj7O"
                },
                {
                    "ruta": "Les Rovires de Baix 2",
                    "fitxer": "les_rovires_de_baix_2.gpx",
                    "desc": "BTT*Bergued\xe0*les_rovires_de_baix_2.gpx*2020-03-08*15.4 Km*01:14:39 *01:36:36*764 m*606 m*674m*972m*vevW7ZW3pyv"
                },
                {
                    "ruta": "Les Rovires de Baix 2",
                    "fitxer": "les_rovires_de_baix_2.gpx",
                    "desc": "BTT*Bergued\xe0*les_rovires_de_baix_2.gpx*2020-03-08*15.4 Km*01:14:39 *01:36:36*764 m*606 m*674m*972m*vevW7ZW3pyv"
                },
                {
                    "ruta": "Gironella-Avi\xe0-Berga-Pedret-Obiols-Gironella",
                    "fitxer": "gironella-avia-berga-pedret-obiols-gironella.gpx",
                    "desc": "BTT*Bergued\xe0*gironella-avia-berga-pedret-obiols-gironella.gpx*2025-04-16*38.6 Km*02:12:23*02:42:10*987 m*845 m*438m*709m*"
                },
                {
                    "ruta": "Ripoll-Les Rovires de Baix",
                    "fitxer": "ripoll-les_rovires_de_baix.gpx",
                    "desc": "BTT*Bergued\xe0*ripoll-les_rovires_de_baix.gpx*2020-06-26*26.0 Km*01:30:56 *01:49:12*783 m*541 m*665m*977m*vKv2R72o14v"
                },
                {
                    "ruta": "Berga-Pont de Pedret-Cal Rosal-Sant Elies",
                    "fitxer": "berga-pont_pedret-cal_rosal-sant_elies.gpx",
                    "desc": "BTT*Bergued\xe0*berga-pont_pedret-cal_rosal-sant_elies.gpx*2024-08-15*14.1 Km*00:58:04*01:23:42*407 m*346 m*484m*691m*"
                },
                {
                    "ruta": "Serra d'Ensija-Gallina Pelada",
                    "fitxer": "serra_ensija-gallina_pelada.gpx",
                    "desc": "senderisme*Bergued\xe0*serra_ensija-gallina_pelada.gpx*2024-03-30*9.7.0 Km*03:27:49*05:59:44*735 m*657 m*1669m*2300m*"
                },
                {
                    "ruta": "Les Rovires de Baix 5",
                    "fitxer": "les_rovires_de_baix_5.gpx",
                    "desc": "BTT*Bergued\xe0*les_rovires_de_baix_5.gpx*2022-03-06*37.8 Km*02:59:32*03:03:52*1488 m*1055 m*743m*1135m*"
                },
                {
                    "ruta": "Pedraforca",
                    "fitxer": "pedraforca.gpx",
                    "desc": "senderisme*Bergued\xe0*pedraforca.gpx*2024-07-30*8.7 Km*03:32:15*09:05:41*1449 m*1111 m*1621m*2458m*"
                },
                {
                    "ruta": "ToDo-Campdev\xe0nol-Gombr\xe8n-Pedro de Tubau-Riera de Merl\xe8s-Les Rovires",
                    "fitxer": "todo-campdevanol-gombren-pedro_tubau-riera_merles-les_rovires.gpx",
                    "desc": "BTT*Bergued\xe0*todo-campdevanol-gombren-pedro_tubau-riera_merles-les_rovires.gpx*2022-10-22*44.2 Km*00:20:08*00:54:08*1848 m*1111 m*740m*1524m*"
                },
                {
                    "ruta": "Plantiu-Coll de Cerqueda-Erols-Sant Vicen\xe7 de Rus-La Pobla",
                    "fitxer": "el_plantiu-coll_cerqueda-erols-sant_vicenc_de_rus.gpx",
                    "desc": "BTT*Bergued\xe0*el_plantiu-coll_cerqueda-erols-sant_vicenc_de_rus.gpx*2021-08-24*20.8 Km*01:43:52*01:43:52*881 m*703 m*815m*1472m*"
                },
                {
                    "ruta": "ToDo-Bag\xe0-Gisclareny-Coll de Bauma-El Collell-Riera de Saldes",
                    "fitxer": "todo-baga-gisclareny-coll_bauma-el_collell-riera_saldes.gpx",
                    "desc": "BTT*Bergued\xe0*todo-baga-gisclareny-coll_bauma-el_collell-riera_saldes.gpx*2021-01-12*46.1 Km*01:12:00*01:12:00*2511 m*1240 m*789m*1924m*"
                },
                {
                    "ruta": "Cercs-L'Erola",
                    "fitxer": "cercs-l_erola.gpx",
                    "desc": "BTT*Bergued\xe0*cercs-l_erola.gpx*2023-06-02*12.7 Km*01:25:52*01:37:04*925 m*815 m*646m*1210m*"
                },
                {
                    "ruta": "ToDo-Rovires de Baix-Pedr\xf3 de Tubau-v1",
                    "fitxer": "todo-rovires_de_baix-pedro_tubau-v1.gpx",
                    "desc": "BTT*Bergued\xe0*todo-rovires_de_baix-pedro_tubau-v1.gpx*2022-10-22*65.3 Km*0:20:08*00:54:08*2409 m*1454 m*684m*1529m*"
                },
                {
                    "ruta": "Sant Quirze de Besora-Riera de Merl\xe8s",
                    "fitxer": "st_quirze_besora-riera_merles.gpx",
                    "desc": "BTT*Bergued\xe0*st_quirze_besora-riera_merles.gpx*2021-06-26*27.6 Km*02:47:45*03:39:20*1018 m*779 m*565m*890m*"
                },
                {
                    "ruta": "Les Rovires de Baix-Pedr\xf3 de Tubau",
                    "fitxer": "les_rovires_de_baix-pedro_de_tubau.gpx",
                    "desc": "BTT*Bergued\xe0*les_rovires_de_baix-pedro_de_tubau.gpx*2022-10-30*46.0 Km*03:38:17*03:48:49*1867 m*1404 m*742m*1529m*"
                },
                {
                    "ruta": "Malanyeu-La Nou de Bergued\xe0",
                    "fitxer": "malanyeu-la_nou_de_bergueda.gpx",
                    "desc": "ciclisme*Bergued\xe0*malanyeu-la_nou_de_bergueda.gpx*2022-08-04*16.7 Km*01:17:32*01:20:36*888 m*738 m*687m*1124m*"
                }
            ]
        },
        {
            "zona": "Altres",
            "id": "altres",
            "rutes": [
                {
                    "ruta": "Vanoise-La Ramasse",
                    "fitxer": "vanoise-la_ramasse.gpx",
                    "desc": "senderisme*Altres*vanoise-la_ramasse.gpx*2025-08-27*12.2 Km*02:53:28*03:07:53*1077 m*881 m*1397m*2160m*"
                },
                {
                    "ruta": "KKH-Karakorum Highway",
                    "fitxer": "KKH.gpx",
                    "desc": "BTT*Altres*KKH.gpx*1997-08-01*795.4 Km*04:45:30*04:45:30*14012 m*6123 m*1025m*4705m*"
                },
                {
                    "ruta": "Els tres refugis: Coma de Vaca, Ull de Ter, Ras de Caran\xe7\xe0",
                    "fitxer": "els_tres_refugis.gpx",
                    "desc": "senderisme*Altres*els_tres_refugis.gpx*2020-08-07*49.8 Km*01:54:12 *12:27:17*4053 m*3378 m*1133m*2722m*coma_de_vaca-ull_de_ter_ras_de_caranca"
                },
                {
                    "ruta": "Pla de Beret-Bonab\xe9-Isil-Port de la Bonaigua",
                    "fitxer": "pla_de_beret-bonabe-isil-port_de_la_bonaigua.gpx",
                    "desc": "BTT*Altres*pla_de_beret-bonabe-isil-port_de_la_bonaigua.gpx*2025-07-16*57.8 Km*03:49:01*04:58:30*2512 m*1897 m*1115m*2336m*"
                },
                {
                    "ruta": "Sender arqueol\xf2gic d'Eina",
                    "fitxer": "sender_arqueologic_eyna.gpx",
                    "desc": "senderisme*Altres*sender_arqueologic_eyna.gpx*2024-02-25*5.8 Km*01:02:13*02:08:25*201 m*171 m*1501m*1622m*"
                },
                {
                    "ruta": "Mollet-Gallecs-Santa Perp\xe8tua",
                    "fitxer": "mollet-gallecs-sta_perpetua.gpx",
                    "desc": "BTT*Altres*mollet-gallecs-sta_perpetua.gpx*2022-09-15*18.2 Km*01:25:32*01:36:04*284 m*240 m*69m*140m*"
                },
                {
                    "ruta": "Santa Eug\xe8nia-Ridolaina-Nas-Oli\xe0",
                    "fitxer": "santa_eugenia-ridolaina-nas-olia.gpx",
                    "desc": "senderisme*Altres*santa_eugenia-ridolaina-nas-olia.gpx*2022-08-25*7.2 Km*00:00:00*09:32:00*332 m*301 m*1048m*1255m*"
                },
                {
                    "ruta": "Andorra-T\xe0rrega-dia 1",
                    "fitxer": "andorra-tarrega-dia_1.gpx",
                    "desc": "BTT*Altres*andorra-tarrega-dia_1.gpx*2025-10-04*72.2 Km*05:12:18*06:52:05*3398 m*2759 m*721m*2307m*"
                },
                {
                    "ruta": "Congost de Mont-rebei",
                    "fitxer": "congost_mont-rebei.gpx",
                    "desc": "senderisme*Altres*congost_mont-rebei.gpx*2021-12-07*10.5 Km*03:02:44*04:12:28*997 m*736 m*496m*857m*"
                },
                {
                    "ruta": "Arres de Sus-Mina Vict\xf2ria",
                    "fitxer": "arres_de_sus-mina_victoria.gpx",
                    "desc": "senderisme*Altres*arres_de_sus-mina_victoria.gpx*2025-07-20*6.0 Km*02:07:20*02:07:20*481 m*376 m*1309m*1568m*"
                },
                {
                    "ruta": "Montnegre Open MTB 32Km",
                    "fitxer": "montnegreopenmtb_32.gpx",
                    "desc": "BTT*Altres*montnegreopenmtb_32.gpx*2020-11-05*29.4 Km*02:25:40 *02:58:01*1102 m*884 m*138m*644m*vRO7RomyRyv"
                },
                {
                    "ruta": "\xc0ger-Coll d'Ares-Alsamora-Mont-rebei-La Pertusa-Cor\xe7\xe0",
                    "fitxer": "ager-coll_ares-alsamora-mont-rebei-la_pertusa-corca.gpx",
                    "desc": "BTT*Altres*ager-coll_ares-alsamora-mont-rebei-la_pertusa-corca.gpx*2008-11-18*50.5 Km*02:09:10*02:10:40*2311 m*1537 m*496m*1528m*"
                },
                {
                    "ruta": "Sant Salvador de les Espases",
                    "fitxer": "sant_salvador_de_les_espases.gpx",
                    "desc": "senderisme*Altres*sant_salvador_de_les_espases.gpx*2021-11-01*4.2 Km*01:30:42*02:04:38*445 m*360 m*94m*404m"
                },
                {
                    "ruta": "Vic-Viladrau-Vic",
                    "fitxer": "vic-viladrau-vic.gpx",
                    "desc": "BTT*Altres*vic-viladrau-vic.gpx*2022-11-11*49.2 Km*04:10:54*04:58:31*1496 m*1136 m*472m*866m*"
                },
                {
                    "ruta": "Grau del Rei-Aig\xfces-Mortes",
                    "fitxer": "grau_del_rei-aigues_mortes.gpx",
                    "desc": "senderisme*Altres*grau_del_rei-aigues_mortes.gpx*2025-08-30*16.6 Km*00:42:18*00:42:18*60 m*25 m*0m*63m*"
                },
                {
                    "ruta": "Igualada-Bellmunt-Cervera-Pujalt-Sant Mart\xed Sesgueioles-Igualada",
                    "fitxer": "igualada-bellmunt-cervera-pujalt-sant_marti_sesg-igualada.gpx",
                    "desc": "BTT*Altres*igualada-bellmunt-cervera-pujalt-sant_marti_sesg-igualada.gpx*2025-11-28*97.3 Km*05:40:49*08:04:09*2260 m*1990 m*310m*776m*"
                },
                {
                    "ruta": "Blanes-Gavarres-Girona",
                    "fitxer": "blanes-gavarres-girona.gpx",
                    "desc": "BTT*Altres*blanes-gavarres-girona.gpx*2023-03-10*84.5 Km*05:50:36*07:06:32*3023 m*2332 m*10m*458m*"
                },
                {
                    "ruta": "Serra d'Urbasa",
                    "fitxer": "serra_urbasa.gpx",
                    "desc": "BTT*Altres*serra_urbasa.gpx*1995-07-06*27.5 Km*00:25:10*00:25:10*394 m*238 m*857m*1083m*"
                },
                {
                    "ruta": "Maresme Challenge 2013",
                    "fitxer": "maresme_challenge_2013.gpx",
                    "desc": "BTT*Altres*maresme_challenge_2013.gpx*2013-04-06*39.1 Km*02:38:23 *05:06:23*1633 m*1178 m*26m*446m*vXOd3mjVNkv"
                },
                {
                    "ruta": "Artesa de Segre-Montmagastre",
                    "fitxer": "artesa_de_segre-montmagastre.gpx",
                    "desc": "BTT*Altres*artesa_de_segre-montmagastre.gpx*2023-08-31*44.4 Km*02:48:22*04:24:47*1062 m*900 m*299m*683m*"
                },
                {
                    "ruta": "Vilafranca-Santa Coloma de Queralt-Igualada-v2",
                    "fitxer": "vilafranca-sta_coloma_queralt-igualada-v2.gpx",
                    "desc": "ciclisme*Altres*vilafranca-sta_coloma_queralt-igualada-v2.gpx*2024-11-29*92.4 Km*04:24:31*06:11:30*1958 m*1750 m*223m*694m*"
                },
                {
                    "ruta": "Vilafranca-Santa Coloma de Queralt-Igualada-v2",
                    "fitxer": "vilafranca-sta_coloma_queralt-igualada-v2.gpx",
                    "desc": "ciclisme*Altres*vilafranca-sta_coloma_queralt-igualada-v2.gpx*2024-11-29*92.4 Km*04:24:31*06:11:30*1958 m*1750 m*223m*694m*"
                },
                {
                    "ruta": "Cornell\xe0-Castelldefels-Ratpenat-Begues-v2",
                    "fitxer": "cornella-castelldefels-ratpenat-begues-v2.gpx",
                    "desc": "BTT*Altres*cornella-castelldefels-ratpenat-begues-v2.gpx*2025-09-26*63.0 Km*03:43:06*04:26:00*1492 m*1317 m*2m*479m*"
                },
                {
                    "ruta": "Vanoise-Refugi d'Av\xe9role",
                    "fitxer": "vanoise-refugi_daverole.gpx",
                    "desc": "senderisme*Altres*vanoise-refugi_daverole.gpx*2025-08-24*13.8 Km*03:05:34*04:40:05*773 m*602 m*1741m*2193m*"
                },
                {
                    "ruta": "Vic-volta a Riuprimer-Muntanyola-Vic",
                    "fitxer": "vic-volta_riuprimer-muntanyola-vic.gpx",
                    "desc": "BTT*Altres*vic-volta_riuprimer-muntanyola-vic.gpx*2025-04-11*39.7 Km*03:55:57*03:56:33*1116 m*815 m*493m*820m*"
                },
                {
                    "ruta": "Mollerussa-T\xe0rrega-Cervera-Sant Guim-Sant Mart\xed Sesgueioles",
                    "fitxer": "mollerussa-tarrega-cervera-sant_guim-sant_marti_sesgueioles.gpx",
                    "desc": "BTT*Altres*mollerussa-tarrega-cervera-sant_guim-sant_marti_sesgueioles.gpx*2025-03-21*67.8 Km*03:52:45*05:15:57*1098 m*981 m*251m*788m*"
                },
                {
                    "ruta": "Manresa-Rellinars-Terrassa",
                    "fitxer": "manresa-rellinars-terrassa.gpx",
                    "desc": "BTT*Altres*manresa-rellinars-terrassa.gpx*2023-03-03*44.0 Km*03:04:48*03:48:52*1726 m*1295 m*160m*759m*"
                },
                {
                    "ruta": "Fageda d'Irati",
                    "fitxer": "fageda_irati.gpx",
                    "desc": "BTT*Altres*fageda_irati.gpx*1995-07-08*17.8 Km*00:35:20*00:35:20*580 m*266 m*747m*980m*"
                },
                {
                    "ruta": "Montnegre Open MTB 50Km",
                    "fitxer": "montnegreopenmtb_50.gpx",
                    "desc": "BTT*Altres*montnegreopenmtb_50.gpx*2021-03-19*49.1 Km*04:35:08*04:44:20*2058 m*1645 m*188m*634m*"
                },
                {
                    "ruta": "Centelles-Tona-Vic-Centelles-Plana de Vic",
                    "fitxer": "centelles-tona-vic-centelles-plana_de_vic.gpx",
                    "desc": "BTT*Altres*centelles-tona-vic-centelles-plana_de_vic.gpx*2025-09-19*48.4 Km*02:38:20*03:18:28*615 m*563 m*465m*612m*"
                },
                {
                    "ruta": "Beget-Comanegra",
                    "fitxer": "beget-comanegra.gpx",
                    "desc": "senderisme*Altres*beget-comanegra.gpx*2024-07-23*18.5 Km*04:36:25*05:46:04*1826 m*1551 m*534m*1538m*"
                },
                {
                    "ruta": "Pujada a la Mola",
                    "fitxer": "pujada_a_la_mola.gpx",
                    "desc": "senderisme*Altres*pujada_a_la_mola.gpx*2020-12-31*5.5 Km*02:39:20*03:17:26*491 m*450 m*698m*1087m*"
                },
                {
                    "ruta": "Sant Celoni-Turo de l'Home v2",
                    "fitxer": "sant_celoni-turo_de_lhome_v2.gpx",
                    "desc": "BTT*Altres*sant_celoni-turo_de_lhome_v2*2024-04-19*51.6 Km*03:46:22*05:03:51*2476 m*2121 m*131m*1680m*"
                },
                {
                    "ruta": "Centelles-Collsuspina-Canovelles",
                    "fitxer": "centelles-collsuspina-canovelles.gpx",
                    "desc": "BTT*Altres*centelles-collsuspina-canovelles.gpx*2023-06-09*63.7 Km*03:40:41*04:34:17*1899 m*1552 m*148m*1017m*"
                },
                {
                    "ruta": "Manresa-La Sala-Call\xfas-Castellnou-Santpedor",
                    "fitxer": "manresa-la_sala-callus-castellnou-santpedor.gpx",
                    "desc": "BTT*Altres*manresa-la_sala-callus-castellnou-santpedor.gpx*2021-10-23*61.3 Km*04:32:32*05:30:36*1614 m*1298 m*201m*585m"
                },
                {
                    "ruta": "Riells-Tur\xf3 de les Onze Hores",
                    "fitxer": "riells-turo_de_les_onze_hores.gpx",
                    "desc": "senderisme*Altres*riells-turo_de_les_onze_hores.gpx*2023-03-19*8.3 Km*02:04:07*02:13:47*717 m*615 m*371m*739m*"
                },
                {
                    "ruta": "Montcau",
                    "fitxer": "montcau.gpx",
                    "desc": "senderisme*Altres*montcau.gpx*2022-12-04*3.1 Km*00:58:44*01:27:44*204 m*189 m*876m*1027m*"
                },
                {
                    "ruta": "Embassament d'Irabia, Fageda d'Irati",
                    "fitxer": "embassament_irabia.gpx",
                    "desc": "BTT*Altres*embassament_irabia.gpx*1995-07-09*13.2 Km*00:24:20*00:24:20*433 m*215 m*789m*979m*"
                },
                {
                    "ruta": "La Portals 2024",
                    "fitxer": "la_portals_2024.gpx",
                    "desc": "BTT*Altres*la_portals_2024.gpx*2024-10-18*61.0 Km*03:30:15*04:16:40*1932 m*1558 m*75m*718m*"
                },
                {
                    "ruta": "Llu\xe7an\xe8s Fer\xe9stec 2019 (variant)",
                    "fitxer": "llucanes_ferestec_2019.gpx",
                    "desc": "BTT*Altres*llucanes_ferestec_2019.gpx*2022-04-10*61.5 Km*06:19:12*07:26:00*1896 m*1487 m*503m*889m*"
                },
                {
                    "ruta": "34-Lairissa",
                    "fitxer": "34-lairissa.gpx",
                    "desc": "BTT*Altres*34-lairissa.gpx*2025-07-21*32.5 Km*02:06:29*02:36:33*1754 m*1393 m*709m*1341m*"
                },
                {
                    "ruta": "Ribes-Coll de Jou-Taga-Ogassa-Camprodon-Abella-Collada Verda-Ribes",
                    "fitxer": "ribes-coll_de_jou-taga-ogassa-camprodon-abella-collada_verda-ribes.gpx",
                    "desc": "BTT*Altres*ribes-coll_de_jou-taga-ogassa-camprodon-abella-collada_verda-ribes.gpx*2022-11-18*61.4 Km*06:14:04*06:41:05*3389 m*2583 m*906m*2017m*"
                },
                {
                    "ruta": "Bardenas Reales",
                    "fitxer": "bardenas_reales.gpx",
                    "desc": "BTT*Altres*bardenas_reales.gpx*1995-07-10*50.3 Km*01:21:30*01:21:30*745 m*555 m*272m*470m*"
                },
                {
                    "ruta": "Sant Vicen\xe7 de Calders-Martorell",
                    "fitxer": "sant_vicenc_de_calders-martorell.gpx",
                    "desc": "BTT*Altres*sant_vicenc_de_calders-martorell.gpx*2022-11-25*60.9 Km*03:07:48*03:56:26*859 m*701 m*11m*256m*"
                },
                {
                    "ruta": "61-Tuca",
                    "fitxer": "61-tuca.gpx",
                    "desc": "BTT*Altres*61-Tuca.gpx*2025-07-18*25.7 Km*02:25:37*03:02:58*1645 m*1303 m*968m*1944m*"
                },
                {
                    "ruta": "Manresa (Bages Sud)",
                    "fitxer": "manresa_bages_sud.gpx",
                    "desc": "BTT*Altres*manresa_bages_sud.gpx*2023-02-24*63.2 Km*04:51:04*05:10:32*2199 m*1645 m*149m*777m*"
                },
                {
                    "ruta": "Blanes-Matar\xf3",
                    "fitxer": "blanes-mataro.gpx",
                    "desc": "BTT*Altres*blanes-mataro.gpx*2022-03-24*56.4 Km*03:47:48*04:23:28*2429 m*1660 m*7m*596m*"
                },
                {
                    "ruta": "Lleida-Sant Vicen\xe7 de Calders",
                    "fitxer": "lleida-st_vicenc_calders.gpx",
                    "desc": "BTT*Altres*lleida-st_vicenc_calders.gpx*2024-04-12*131.6 Km*06:26:35*08:07:49*1939 m*1684 m*1m*634m*"
                },
                {
                    "ruta": "La Portals 2013 (4a Volta a Montserrat)",
                    "fitxer": "la-portals-2013-4a-volta-a-la-montanya-de-montserrat-en-btt.gpx",
                    "desc": "BTT*Altres*la-portals-2013-4a-volta-a-la-montanya-de-montserrat-en-btt.gpx*2013-04-14*60.9 Km*03:20:24 *03:27:06*2289 m*1762 m*76m*718m*v1OwMKVPmXq"
                },
                {
                    "ruta": "La Portals 2013 (4a Volta a Montserrat)",
                    "fitxer": "la-portals-2013-4a-volta-a-la-montanya-de-montserrat-en-btt.gpx",
                    "desc": "BTT*Altres*la-portals-2013-4a-volta-a-la-montanya-de-montserrat-en-btt.gpx*2013-04-14*60.9 Km*03:20:24 *03:27:06*2289 m*1762 m*76m*718m*v1OwMKVPmXq"
                },
                {
                    "ruta": "Cornell\xe0-Castelldefels",
                    "fitxer": "cornella-castelldefels.gpx",
                    "desc": "BTT*Altres*cornella-castelldefels.gpx*2025-02-09*24.7 Km*01:34:38*01:41:46*194 m*159 m*1m*37m*"
                },
                {
                    "ruta": "La Pobla de Claramunt-els Mollons-Castell de Castellol\xed",
                    "fitxer": "pobla_claramunt-mollons-castellcastelloli.gpx",
                    "desc": "senderisme*Altres*pobla_claramunt-mollons-castellcastelloli.gpx*2025-03-16*15.1 Km*03:26:41*03:59:09*745 m*639 m*286m*581m*"
                },
                {
                    "ruta": "La Pobla de Claramunt-els Mollons-Castell de Castellol\xed",
                    "fitxer": "pobla_claramunt-mollons-castellcastelloli.gpx",
                    "desc": "senderisme*Altres*pobla_claramunt-mollons-castellcastelloli.gpx*2025-03-16*15.1 Km*03:26:41*03:59:09*745 m*639 m*286m*581m*"
                },
                {
                    "ruta": "La Pobla de Claramunt-els Mollons-Castell de Castellol\xed",
                    "fitxer": "pobla_claramunt-mollons-castellcastelloli.gpx",
                    "desc": "senderisme*Altres*pobla_claramunt-mollons-castellcastelloli.gpx*2025-03-16*15.1 Km*03:26:41*03:59:09*745 m*639 m*286m*581m*"
                },
                {
                    "ruta": "Sant Celoni-el Sui",
                    "fitxer": "sant_celoni-el_sui.gpx",
                    "desc": "BTT*Altres*sant_celoni-el_sui.gpx*2024-01-12*48.8 Km*03:28:45*04:12:43*1944 m*1637 m*155m*1302m*"
                },
                {
                    "ruta": "Sant Vicen\xe7 de Calders-Tarragona-Salom\xf3",
                    "fitxer": "st_vicenc_calders-tarragona-salomo.gpx",
                    "desc": "BTT*Altres*st_vicenc_calders-tarragona-salomo.gpx*2024-02-02*89.2 Km*05:24:55*07:21:17*1671 m*1447 m*6m*272m*"
                },
                {
                    "ruta": "Sel\xe8nika 2024",
                    "fitxer": "selenika_2024.gpx",
                    "desc": "BTT*Altres*selenika_2024.gpx*2024-09-29*79.9 Km*05:15:13*05:28:23*3133 m*2783 m*265m*835m*"
                },
                {
                    "ruta": "Vanoise-Lac Blanc",
                    "fitxer": "vanoise-lac_blanc.gpx",
                    "desc": "senderisme*Altres*vanoise-lac_blanc.gpx*2025-08-23*3.3 Km*01:08:56*01:15:26*329 m*296 m*2048m*2301m*"
                },
                {
                    "ruta": "Vilafranca del P.-Sant Andreu de la B.",
                    "fitxer": "vilafranca_del_p-sant_andreu_de_la_b.gpx",
                    "desc": "BTT*Altres*vilafranca_del_p-sant_andreu_de_la_b.gpx*2021-10-02*39.8 Km*02:30:08*03:42:08*900 m*684 m*38m*566m*"
                },
                {
                    "ruta": "Ulriken-Floyen-Bergen",
                    "fitxer": "ulriken-floyen-bergen.gpx",
                    "desc": "senderisme*Altres*ulriken-floyen-bergen.gpx*2023-08-12*20.8 Km*04:57:09*07:29:01*1227 m*1051 m*1m*659m*"
                },
                {
                    "ruta": "Ruta del C\xedster-GR-175",
                    "fitxer": "ruta_cister_gr_175.gpx",
                    "desc": "BTT*Altres*ruta_cister_gr_175.gpx*2024-05-31*115.7 Km*08:32:25*10:36:24*3234 m*2506 m*294m*851m*"
                },
                {
                    "ruta": "La Floresta-Vilanova i la Geltr\xfa-v2",
                    "fitxer": "la_floresta-vilanova_i_la_geltru-v2.gpx",
                    "desc": "BTT*Altres*la_floresta-vilanova_i_la_geltru-v2.gpx*2026-01-16*77.5 Km*05:40:46*07:15:24*2250 m*1793 m*10m*575m*"
                },
                {
                    "ruta": "21-Portilhon-C\xf2th de Bar\xe8tja",
                    "fitxer": "21-portilhon-coth_de_baretja.gpx",
                    "desc": "BTT*Altres*21-portilhon-coth_de_baretja.gpx*2025-07-19*36.0 Km*02:51:43*03:36:23*2542 m*1783 m*715m*1753m*"
                },
                {
                    "ruta": "Selenika 2023 Manresa",
                    "fitxer": "selenika_2023-manresa.gpx",
                    "desc": "BTT*Altres*selenika_2023-manresa.gpx*2023-09-22*75.3 Km*04:28:56*07:09:07*1926 m*1523 m*201m*658m*"
                },
                {
                    "ruta": "Montmel\xf3-Cardedeu-La Garriga",
                    "fitxer": "montmelo-cardedeu-la_garriga.gpx",
                    "desc": "BTT*Altres*montmelo-cardedeu-la_garriga.gpx*2025-05-30*38.0 Km*02:23:03*03:03:10*653 m*609 m*72m*310m*"
                },
                {
                    "ruta": "Juneda-Mas de Melons-Les Garrigues",
                    "fitxer": "juneda-mas_de_melons-les_garrigues.gpx",
                    "desc": "BTT*Altres*juneda-mas_de_melons-les_garrigues.gpx*2026-01-09*76.8 Km*05:43:50*06:38:20*1608 m*1431 m*225m*644m*"
                },
                {
                    "ruta": "Manresa-Vilafranca del Pened\xe8s",
                    "fitxer": "manresa-vilafranca_del_penedes.gpx",
                    "desc": "BTT*Altres*manresa-vilafranca_del_penedes.gpx*2023-02-17*70.4 Km*04:17:00*05:18:36*1674 m*1353 m*142m*754m*"
                },
                {
                    "ruta": "Santa Coloma de Gr-Sant Andreu de Llavaneres",
                    "fitxer": "sta_coloma-st_andreu_llavaneres.gpx",
                    "desc": "BTT*Altres*sta_coloma-st_andreu_llavaneres.gpx*2013-06-26*51.9 Km*03:10:26*03:59:53*1590 m*1369 m*25m*477m*"
                },
                {
                    "ruta": "Santa Coloma de Gr-Sant Andreu de Llavaneres",
                    "fitxer": "sta_coloma-st_andreu_llavaneres.gpx",
                    "desc": "BTT*Altres*sta_coloma-st_andreu_llavaneres.gpx*2013-06-26*51.9 Km*03:10:26*03:59:53*1590 m*1369 m*25m*477m*"
                },
                {
                    "ruta": "ToDo-Llacuna-Queralt-Sant Mart\xed de Tous",
                    "fitxer": "todo-llacuna-queralt-st_marti_de_tous.gpx",
                    "desc": "BTT*Altres*todo-llacuna-queralt-st_marti_de_tous.gpx*2012-10-13*44.8 Km*01:39:28*04:39:58*1270 m*1031 m*432m*813m*"
                },
                {
                    "ruta": "Sant Vicen\xe7 de Calders-la Pobla de Claramunt",
                    "fitxer": "st_vicenc_calders-la_pobla_claramunt.gpx",
                    "desc": "BTT*Altres*st_vicenc_calders-la_pobla_claramunt.gpx*2023-10-16*72.3 Km*04:24:27*06:00:09*2039 m*1762 m*9m*649m*"
                },
                {
                    "ruta": "Sant Vicen\xe7 de Calders-la Pobla de Claramunt",
                    "fitxer": "st_vicenc_calders-la_pobla_claramunt.gpx",
                    "desc": "BTT*Altres*st_vicenc_calders-la_pobla_claramunt.gpx*2023-10-16*72.3 Km*04:24:27*06:00:09*2039 m*1762 m*9m*649m*"
                },
                {
                    "ruta": "Orbea-Monegros 2024",
                    "fitxer": "orbea-monegros-2024.gpx",
                    "desc": "BTT*Altres*orbea-monegros-2024.gpx*2024-04-27*105.4 Km*04:34:34*05:19:08*1354 m*1145 m*192m*554m*"
                },
                {
                    "ruta": "Orbea-Monegros 2024",
                    "fitxer": "orbea-monegros-2024.gpx",
                    "desc": "BTT*Altres*orbea-monegros-2024.gpx*2024-04-27*105.4 Km*04:34:34*05:19:08*1354 m*1145 m*192m*554m*"
                },
                {
                    "ruta": "Terrassa-Obac-Sant Vicen\xe7 de Castellet",
                    "fitxer": "terrassa-obac-st_vicenc_de_castellet.gpx",
                    "desc": "BTT*Altres*terrassa-obac-st_vicenc_de_castellet.gpx*2023-03-31*36.8 Km*02:30:56*02:56:04*1449 m*1037 m*180m*678m*"
                },
                {
                    "ruta": "Pessonada-Herba Savina",
                    "fitxer": "pessonada-herba_savina.gpx",
                    "desc": "senderisme*Altres*pessonada-herba_savina.gpx*2021-12-05*13.2 Km*04:06:31*04:06:44*688 m*571 m*862m*1032m*"
                },
                {
                    "ruta": "Sant Celoni-Santa Coloma de Gr",
                    "fitxer": "sant_celoni-santa_coloma_de_gr.gpx",
                    "desc": "BTT*Altres*sant_celoni-santa_coloma_de_gr.gpx*2022-02-17*62.7 Km*04:11:16*04:35:16*2446 m*1830 m*28m*638m*"
                },
                {
                    "ruta": "Vanoise-Cam\xed de Sarrazin",
                    "fitxer": "vanoise-cami_de_sarrazin.gpx",
                    "desc": "senderisme*Altres*vanoise-cami_de_sarrazin.gpx*2025-08-27*5.7 Km*01:23:51*01:52:52*361 m*276 m*1465m*1636m*"
                },
                {
                    "ruta": "Cornell\xe0-delta Llobregat-Viladecans",
                    "fitxer": "cornella-delta_llobregat-viladecans.gpx",
                    "desc": "BTT*Altres*cornella-delta_llobregat-viladecans.gpx*2023-11-03*31.9 Km*23:15:05*23:34:41*211 m*168 m*0m*37m*"
                },
                {
                    "ruta": "La S\xe8nia-Casetes Velles-Fredes-La S\xe8nia",
                    "fitxer": "la_senia-casetes_velles-fredes-la_senia.gpx",
                    "desc": "BTT*Altres*la_senia-casetes_velles-fredes-la_senia.gpx*2012-10-01*63.9 Km*05:19:36*06:24:11*2580 m*1891 m*319m*1255m*"
                },
                {
                    "ruta": "Cornell\xe0-Sant Sadurn\xed d'Anoia",
                    "fitxer": "cornella-sant_sadurni_d_anoia.gpx",
                    "desc": "BTT*Altres*cornella-sant_sadurni_d_anoia.gpx*2022-10-13*46.0 Km*03:07:32*03:43:44*1534 m*1193 m*3m*504m*"
                },
                {
                    "ruta": "Cornell\xe0-Sant Sadurn\xed d'Anoia",
                    "fitxer": "cornella-sant_sadurni_d_anoia.gpx",
                    "desc": "BTT*Altres*cornella-sant_sadurni_d_anoia.gpx*2022-10-13*46.0 Km*03:07:32*03:43:44*1534 m*1193 m*3m*504m*"
                },
                {
                    "ruta": "Sant Sadurn\xed d'Anoia-Orpinell-La Llacuna-Mas Pontons-Torrelles de F-Monjos",
                    "fitxer": "sant_sadurni_danoia-orpinell-la_llacuna-mas_pontons-torrelles-monjos.gpx",
                    "desc": "BTT*Altres*sant_sadurni_danoia-orpinell-la_llacuna-mas_pontons-torrelles-monjos.gpx*2025-02-14*66.9 Km*03:51:01*04:25:33*1620 m*1477 m*135m*815m*"
                },
                {
                    "ruta": "Tav\xe8rnoles-Savassona",
                    "fitxer": "tavernoles-savassona.gpx",
                    "desc": "senderisme*Altres*tavernoles-savassona.gpx*2022-01-16*5.6 Km*01:20:44*01:48:24*281 m*239 m*538m*675m*"
                },
                {
                    "ruta": "Ma\xe7anet-Montsoriu-Vic",
                    "fitxer": "macanet-montsoriu-vic.gpx",
                    "desc": "BTT*Altres*macanet-montsoriu-vic.gpx*2023-04-28*77.3 Km*04:54:00*06:48:00*2130 m*1918 m*85m*855m*"
                },
                {
                    "ruta": "Llimiana, Serra Barcedana, Gercles",
                    "fitxer": "llimiana-serra-barcedana-gercles.gpx",
                    "desc": "BTT*Altres*llimiana-serra-barcedana-gercles.gpx*2013-08-20*32.2 Km*01:28:28 *03:16:37*1117 m*914 m*392m*1172m*vrqodjBjjKv"
                },
                {
                    "ruta": "Plana de Vic",
                    "fitxer": "plana_de_vic.gpx",
                    "desc": "BTT*Altres*plana_de_vic.gpx*2025-01-31*53.6 Km*02:47:44*04:27:37*776 m*699 m*402m*612m*"
                },
                {
                    "ruta": "Sel\xe8nika 2022",
                    "fitxer": "selenika-2022.gpx",
                    "desc": "BTT*Altres*selenika-2022.gpx*2023-03-24*70.2 Km*04:23:55*05:12:31*1883 m*1435 m*161m*398m*"
                },
                {
                    "ruta": "Monegros Nord",
                    "fitxer": "Monegros-nord.gpx",
                    "desc": "BTT*Altres*Monegros-nord.gpx*2016-05-01*84.8 Km*05:04:02 *05:55:26*1493 m*1205 m*189m*556m*vwq17eZKVLO"
                },
                {
                    "ruta": "ToDo-Calaf-Cellers-Quadrells",
                    "fitxer": "todo-calaf-cellers-quadrells.gpx",
                    "desc": "BTT*Altres*todo-calaf-cellers-quadrells.gpx*2020-12-18*50.1 Km*01:49:52*06:03:49*1312 m*1131 m*493m*920m*"
                },
                {
                    "ruta": "ToDo-Calaf-Cellers-Quadrells",
                    "fitxer": "todo-calaf-cellers-quadrells.gpx",
                    "desc": "BTT*Altres*todo-calaf-cellers-quadrells.gpx*2020-12-18*50.1 Km*01:49:52*06:03:49*1312 m*1131 m*493m*920m*"
                },
                {
                    "ruta": "Granollers-C\xe0noves-Roca Centella-La Garriga-Canovelles",
                    "fitxer": "granollers-canoves-roca_centella-la_garriga-canovelles.gpx",
                    "desc": "BTT*Altres*granollers-canoves-roca_centella-la_garriga-canovelles.gpx*2025-04-04*44.0 Km*03:35:10*04:31:44*1497 m*1353 m*148m*980m*"
                },
                {
                    "ruta": "Vacarisses-Montserrat-Cam\xed de Sant Jeroni-Castellbell",
                    "fitxer": "vacarisses-montserrat-cami_sant_jeroni-castellbell.gpx",
                    "desc": "BTT*Altres*vacarisses-montserrat-cami_sant_jeroni-castellbell.gpx*2024-12-15*54.3 Km*04:59:39*06:18:26*2822 m*2460 m*130m*1078m*"
                },
                {
                    "ruta": "Coll d'Estenalles-Mura",
                    "fitxer": "coll_destenalles-mura.gpx",
                    "desc": "senderisme*Altres*coll_destenalles-mura.gpx*2022-03-20*7.5 Km*02:03:12*02:20:24*202 m*147 m*466m*923m*"
                },
                {
                    "ruta": "ToDo-Calaf-Rubi\xf3-Jorba-Copons",
                    "fitxer": "todo-calaf-rubio-jorba-copons.gpx",
                    "desc": "BTT*Altres*todo-calaf-rubio-jorba-copons.gpx*2014-07-06*44.4 Km*00:02:40*03:47:52*835 m*611 m*378m*769m*"
                },
                {
                    "ruta": "Vanoise-Llac Clar",
                    "fitxer": "vanoise-llac_clar.gpx",
                    "desc": "senderisme*Altres*vanoise-llac_clar.gpx*2025-08-28*7.5 Km*02:17:11*02:42:36*719 m*690 m*2094m*2765m*"
                },
                {
                    "ruta": "Marxa del Montserrat\xed 2024",
                    "fitxer": "marxa_del_montserrati_2024.gpx",
                    "desc": "senderisme*Altres*marxa_del_montserrati_2024.gpx*2024-02-04*16.3 Km*04:00:00*04:30:00*932 m*748 m*71m*397m*"
                },
                {
                    "ruta": "Integral megal\xedtica de Vallromanes",
                    "fitxer": "integral_megalitica_vallromanes.gpx",
                    "desc": "BTT*Altres*integral_megalitica_vallromanes.gpx*2021-03-05*46.0 Km*04:12:12*05:05:56*1511 m*1270 m*51m*444m*"
                },
                {
                    "ruta": "Cueva de \xc1greda-Moncayo",
                    "fitxer": "cueva_de_agreda-moncayo.gpx",
                    "desc": "senderisme*Altres*cueva_de_agreda-moncayo.gpx*2019-12-06*11.5 Km*04:24:31*04:24:31*994 m*955 m*1311m*2304m*"
                },
                {
                    "ruta": "Puig de Bestrac\xe0",
                    "fitxer": "puig_de_bestraca.gpx",
                    "desc": "senderisme*Altres*puig_de_bestraca.gpx*2024-07-22*8.7 Km*02:24:10*04:07:45*830 m*621 m*655m*1019m*"
                },
                {
                    "ruta": "Volta Boumort",
                    "fitxer": "volta-boumort.gpx",
                    "desc": "BTT*Altres*volta-boumort.gpx*2022-10-01*77.8 Km*21:13:20*24:55:41*2875 m*2190 m*499m*1926m*"
                },
                {
                    "ruta": "Monegros Sud",
                    "fitxer": "Monegros-sud.gpx",
                    "desc": "BTT*Altres*Monegros-sud.gpx*2012-12-29*72.5 Km*14:49:09 *00:32:16*563 m*430 m*307m*411m*v4OGm8Dz4mq"
                },
                {
                    "ruta": "Garraf - Begues - Garraf",
                    "fitxer": "garraf-begues-garraf.gpx",
                    "desc": "BTT*Altres*garraf-begues-garraf.gpx*1998-03-31*38.5 Km*02:21:34 *03:35:10*1313 m*1073 m*15m*569m*vrqodwKyRKv"
                },
                {
                    "ruta": "Pineta-Llanos del Larri-Cascada del Cinca",
                    "fitxer": "pineta-llanos_del_larri-cascada_del_cinca.gpx",
                    "desc": "senderisme*Altres*pineta-llanos_del_larri-cascada_del_cinca.gpx*2022-07-24*10.3 Km*00:00:00*06:10:08*540 m*463 m*1300m*1671m*"
                },
                {
                    "ruta": "Cornell\xe0-Castelldefels-Ratpenat-Begues",
                    "fitxer": "cornella-castelldefels-ratpenat-begues.gpx",
                    "desc": "BTT*Altres*cornella-castelldefels-ratpenat-begues.gpx*2023-11-24*67.2 Km*04:16:05*05:04:35*1647 m*1463 m*2m*480m*"
                },
                {
                    "ruta": "Vilafranca del Pened\xe8s-Martorell",
                    "fitxer": "vilafranca_del_penedes-martorell.gpx",
                    "desc": "BTT*Altres*vilafranca_del_penedes-martorell.gpx*2022-10-21*48.4 Km*03:38:00*04:15:36*1414 m*1158 m*54m*635m*"
                },
                {
                    "ruta": "Vanoise-Bonneval-L'\xc9cot",
                    "fitxer": "vanoise-bonneval-lecot.gpx",
                    "desc": "senderisme*Altres*vanoise-bonneval-lecot.gpx*2025-08-26*8.9 Km*02:06:44*02:24:24*511 m*378 m*1437m*2077m*"
                },
                {
                    "ruta": "Andorra-T\xe0rrega-dia 2",
                    "fitxer": "andorra-tarrega-dia_2.gpx",
                    "desc": "BTT*Altres*andorra-tarrega-dia_2.gpx*2025-10-05*83.5 Km*06:19:30*07:51:16*2945 m*2499 m*415m*1440m*"
                },
                {
                    "ruta": "Andorra-T\xe0rrega-dia 2",
                    "fitxer": "andorra-tarrega-dia_2.gpx",
                    "desc": "BTT*Altres*andorra-tarrega-dia_2.gpx*2025-10-05*83.5 Km*06:19:30*07:51:16*2945 m*2499 m*415m*1440m*"
                },
                {
                    "ruta": "Portilhon-Banyeres de Luchon-Tour de Fran\xe7a",
                    "fitxer": "portilhon-banyeres_de_luchon-tour_de_franca.gpx",
                    "desc": "ciclisme*Altres*portilhon-banyeres_de_luchon-tour_de_franca.gpx*2025-07-19*21.3 Km*01:53:44*03:17:36*1034 m*917 m*637m*1303m*"
                },
                {
                    "ruta": "51-Varrad\xf2s",
                    "fitxer": "51-varrados.gpx",
                    "desc": "BTT*Altres*51-varrados.gpx*2025-07-17*47.9 Km*03:32:35*04:50:46*2316 m*1876 m*856m*2052m*"
                },
                {
                    "ruta": "Sant Vicen\xe7 de Calders-El Catllar-Bonastre",
                    "fitxer": "st_vicenc_calders-el_catllar-bonastre.gpx",
                    "desc": "BTT*Altres*st_vicenc_calders-el_catllar-bonastre.gpx*2024-01-26*73.0 Km*04:44:14*07:14:59*1568 m*1307 m*2m*289m*"
                },
                {
                    "ruta": "Lleida-Aiguabarreig Segre i Cinca-La Granja d'Escarp",
                    "fitxer": "lleida-aiguabarreig_segre_cinca-la_granja_descarp.gpx",
                    "desc": "BTT*Altres*lleida-aiguabarreig_segre_cinca-la_granja_descarp.gpx*2023-09-15*94.3 Km*04:41:29*06:18:27*934 m*710 m*72m*301m*"
                },
                {
                    "ruta": "Sabadell-Marquet de les Roques",
                    "fitxer": "sabadell-marquet_de_les_roques.gpx",
                    "desc": "BTT*Altres*sabadell-marquet_de_les_roques.gpx*2021-12-16*49.0 Km*03:20:08*03:54:08*1571 m*1107 m*162m*617m*"
                },
                {
                    "ruta": "Vanoise-Pointe des Fours",
                    "fitxer": "vanoise-pointe_des_fours.gpx",
                    "desc": "senderisme*Altres*vanoise-pointe_des_fours.gpx*2025-08-25*6.6 Km*02:25:21*03:10:26*541 m*508 m*2534m*3038m*"
                },
                {
                    "ruta": "Andorra-T\xe0rrega-dia 3",
                    "fitxer": "andorra-tarrega-dia_3.gpx",
                    "desc": "BTT*Altres*andorra-tarrega-dia_3.gpx*2025-10-06*105.6 Km*07:16:06*08:29:16*2672 m*2378 m*300m*1100m*"
                },
                {
                    "ruta": "Prat d'Aguil\xf3-Comabona",
                    "fitxer": "prat_aguilo-comabona.gpx",
                    "desc": "senderisme*Altres*prat_aguilo-comabona.gpx*2025-12-06*12.1 Km*04:12:15*05:44:29*1093 m*968 m*1842m*2537m*"
                },
                {
                    "ruta": "Olot-Girona",
                    "fitxer": "olot-girona.gpx",
                    "desc": "BTT*Altres*olot-girona.gpx*2022-12-10*59.1 Km*04:31:52*06:11:56*832 m*540 m*67m*598m*"
                },
                {
                    "ruta": "Calaf-Pin\xf3s-Manresa",
                    "fitxer": "calaf-pinos-manresa.gpx",
                    "desc": "ciclisme*Altres*calaf-pinos-manresa.gpx*2024-09-13*100.9 Km*04:41:52*06:41:20*2341 m*2036 m*206m*919m*"
                },
                {
                    "ruta": "Manresa-Vic",
                    "fitxer": "manresa-vic.gpx",
                    "desc": "BTT*Altres*manresa-vic.gpx*2022-10-28*64.0 Km*04:05:40*04:47:40*1857 m*1428 m*201m*936m*"
                },
                {
                    "ruta": "Cabrer\xe8s 2023",
                    "fitxer": "cabreres_2023.gpx",
                    "desc": "BTT*Altres*cabreres_2023.gpx*2023-05-14*58.7 Km*05:26:10*05:50:24*2613 m*1969 m*441m*1142m*"
                },
                {
                    "ruta": "Ripoll-Olot",
                    "fitxer": "ripoll-olot.gpx",
                    "desc": "BTT*Altres*ripoll-olot.gpx*2022-12-08*42.6 Km*03:54:52*06:26:50*1194 m*874 m*419m*1075m*"
                },
                {
                    "ruta": "Uelhs deth Jo\xe8u-Plan dera Artiga de Lin",
                    "fitxer": "uelhs-deth-joeu-plan-dera-artiga-de-lin.gpx",
                    "desc": "senderisme*Altres*uelhs-deth-joeu-plan-dera-artiga-de-lin.gpx*2025-07-17*6.6 Km*03:00:43*03:00:43*402 m*288 m*1193m*1475m*"
                },
                {
                    "ruta": "Ma\xe7anet_Massanes-Vic",
                    "fitxer": "macanet_massanes-vic.gpx",
                    "desc": "BTT*Altres*macanet_massanes-vic.gpx*2023-02-10*65.6 Km*05:28:56*06:09:40*2607 m*2064 m*60m*1088m*"
                },
                {
                    "ruta": "Aiguafreda-Manresa",
                    "fitxer": "aiguafreda-manresa.gpx",
                    "desc": "BTT*Altres*aiguafreda-manresa.gpx*2023-05-26*71.8 Km*04:25:06*06:22:59*2389 m*1833 m*208m*928m*"
                },
                {
                    "ruta": "Volta Catalunya Central 3/3-Solsona-Pin\xf3s-Manresa",
                    "fitxer": "VCC3-solsona-pinos-manresa.gpx",
                    "desc": "BTT*Altres*VCC3-solsona-pinos-manresa.gpx*2024-11-25*70.5 Km*04:48:32*05:47:02*1647 m*1463 m*206m*919m*"
                },
                {
                    "ruta": "Marxa dels Castells 2010",
                    "fitxer": "marxa_castells.gpx",
                    "desc": "senderisme*Altres*marxa_castells.gpx*2010-03-07*54.3 Km*08:53:33 *09:28:18*997 m*842 m*387m*576m*v36ArVA92Zq"
                },
                {
                    "ruta": "Palautordera-Aiguafreda",
                    "fitxer": "palautordera-aiguafreda.gpx",
                    "desc": "BTT*Altres*palautordera-aiguafreda.gpx*2024-06-07*43.1 Km*02:39:01*03:21:39*2022 m*1738 m*190m*1266m*"
                },
                {
                    "ruta": "Aiguafreda-Sabadell",
                    "fitxer": "aiguafreda-sabadell.gpx",
                    "desc": "BTT*Altres*aiguafreda-sabadell.gpx*2022-12-02*50.7 Km*02:32:52*03:42:16*1083 m*1000 m*521m*1048m*"
                },
                {
                    "ruta": "Ripoll-Ma\xe7anet_Massanes (Via Verda)",
                    "fitxer": "ripoll-macanet_massanes_via_verda.gpx",
                    "desc": "BTT*Altres*ripoll-macanet_massanes_via_verda.gpx*2023-02-03*98.5 Km*04:38:16*05:22:56*1873 m*1207 m*60m*1129m*"
                },
                {
                    "ruta": "Ripoll-Ma\xe7anet_Massanes (Via Verda)",
                    "fitxer": "ripoll-macanet_massanes_via_verda.gpx",
                    "desc": "BTT*Altres*ripoll-macanet_massanes_via_verda.gpx*2023-02-03*98.5 Km*04:38:16*05:22:56*1873 m*1207 m*60m*1129m*"
                },
                {
                    "ruta": "Manresa-Sant Sadurn\xed d'Anoia",
                    "fitxer": "manresa-sant_sadurni_d_anoia.gpx",
                    "desc": "BTT*Altres*manresa-sant_sadurni_d_anoia.gpx*2023-12-01*65.4 Km*04:43:03*05:09:52*1896 m*1696 m*142m*680m*"
                },
                {
                    "ruta": "Sant Privat d'en Bas-Puisacalm-Sallent",
                    "fitxer": "sant_privat_den_bas-puisacalm-sallent.gpx",
                    "desc": "senderisme*Altres*sant_privat_den_bas-puisacalm-sallent.gpx*2022-12-09*11.7 Km*05:11:26*06:44:24*1299 m*1198 m*618m*1485m*"
                },
                {
                    "ruta": "Alp-Collada de Toses-Planoles-Collet de les Barraques-Ribes de Freser",
                    "fitxer": "alp-collada_toses-planoles-collet_barraques-ribes_freser.gpx",
                    "desc": "ciclisme*Altres*alp-collada_toses-planoles-collet_barraques-ribes_freser.gpx*2024-03-15*64.5 Km*03:40:18*04:15:23*3072 m*2503 m*918m*1896m*"
                },
                {
                    "ruta": "Beinn \xe0 Chrulaiste",
                    "fitxer": "beinn-a-chrulaiste.gpx",
                    "desc": "senderisme*Altres*beinn-a-chrulaiste.gpx*2022-08-10*10.8 Km*00:07:30*00:07:30*675 m*582 m*240m*855m*"
                },
                {
                    "ruta": "Sant Mart\xed Sesgueioles-els Prats de Rei-Maians-Castellfollit-Manresa",
                    "fitxer": "sant_marti_sesgueioles-prats_rei-maians-castellfollit-manresa.gpx",
                    "desc": "BTT*Altres*sant_marti_sesgueioles-prats_rei-maians-castellfollit-manresa.gpx*2025-03-28*50.5 Km*02:33:03*02:49:53*1111 m*952 m*205m*798m*"
                },
                {
                    "ruta": "Marxa dels Castells-BTT",
                    "fitxer": "marxa_dels_castells-btt.gpx",
                    "desc": "BTT*Altres*marxa_dels_castells-btt.gpx*2025-05-23*56.8 Km*03:06:15*04:11:28*866 m*798 m*388m*574m*"
                },
                {
                    "ruta": "Castells del Loira",
                    "fitxer": "castells_loira.gpx",
                    "desc": "ciclisme*Altres*castells_loira.gpx*2021-08-08*195.4 Km*11:28:03*23:58:28*2244 m*996 m*26m*111m*"
                },
                {
                    "ruta": "Revilla-Refugio de Foratarruego-Miradores de Revilla",
                    "fitxer": "revilla-refugio_foratarruego-miradores_de_revilla.gpx",
                    "desc": "senderisme*Altres*revilla-refugio_foratarruego-miradores_de_revilla.gpx*2022-07-26*13.3 Km*00:00:00*04:50:49*824 m*704 m*1192m*1968m*"
                },
                {
                    "ruta": "Aiguafreda-Monistrol de Calders",
                    "fitxer": "aiguafreda-monistrol_de_calders.gpx",
                    "desc": "BTT*Altres*aiguafreda-monistrol_de_calders.gpx*2023-05-12*46.9 Km*04:02:08*05:19:20*1888 m*1459 m*412m*926m*"
                },
                {
                    "ruta": "Carros de Foc",
                    "fitxer": "carros_foc.gpx",
                    "desc": "senderisme*Altres*carros_foc.gpx*2003-09-18*67.1 Km*00:00:00*12:04:00*5577 m*4810 m*1880m*2747m*"
                },
                {
                    "ruta": "Volta Catalunya Central 1/3-Manresa-Vic-Sant Quirze de Besora",
                    "fitxer": "VCC1-manresa-vic-st_quirze_besora.gpx",
                    "desc": "BTT*Altres*VCC1-manresa-vic-st_quirze_besora.gpx*2024-11-23*102.4 Km*05:44:28*07:53:42*2686 m*2397 m*201m*935m*"
                },
                {
                    "ruta": "All-Gr\xe9ixer-Olopte",
                    "fitxer": "all-greixer-olopte.gpx",
                    "desc": "senderisme*Altres*all-greixer-olopte.gpx*2022-08-26*7.9 Km*00:00:12*02:18:53*309 m*222 m*1078m*1327m*"
                },
                {
                    "ruta": "La Floresta-Vilanova i la Geltr\xfa",
                    "fitxer": "la_floresta-vilanova_i_la_geltru.gpx",
                    "desc": "BTT*Altres*la_floresta-vilanova_i_la_geltru.gpx*2021-11-28*76.4 Km*05:46:32*06:06:08*2233 m*1750 m*11m*574m*"
                },
                {
                    "ruta": "Castelldefels-Sitges",
                    "fitxer": "castelldefels-sitges.gpx",
                    "desc": "BTT*Altres*castelldefels-sitges.gpx*2022-02-24*47.7 Km*03:12:04*03:45:48*1418 m*1096 m*8m*461m*"
                },
                {
                    "ruta": "Puigmal des del Collet de les Barraques",
                    "fitxer": "puigmal-des-del-collet-de-les-barraques.gpx",
                    "desc": "senderisme*Altres*puigmal-des-del-collet-de-les-barraques.gpx*2023-12-30*18.7 Km*06:02:48*07:27:27*1301 m*1224 m*1856m*2910m*"
                },
                {
                    "ruta": "TODO-Ur\xfas-Penyes Altes-Refugi del Cortal de Vidal",
                    "fitxer": "TODO-urus-penyes_altes-refugi_del_cortal_de_vidal.gpx",
                    "desc": "senderisme*Altres*TODO-urus-penyes_altes-refugi_del_cortal_de_vidal.gpx*2022-08-26*17.0 Km*00:00:11*06:26:36*1200 m*1031 m*1255m*2258m*"
                },
                {
                    "ruta": "10-Honeria",
                    "fitxer": "10-honeria.gpx",
                    "desc": "BTT*Altres*10-honeria.gpx*2025-07-20*39.0 Km*03:00:13*03:45:25*2568 m*1721 m*605m*1410m*"
                },
                {
                    "ruta": "Girona-Gavarres-Calonge-Ma\xe7anet",
                    "fitxer": "girona-gavarres-calonge-macanet.gpx",
                    "desc": "ciclisme*Altres*girona-gavarres-calonge-macanet.gpx*2023-12-22*92.7 Km*04:25:05*06:54:06*2086 m*1686 m*17m*475m*"
                },
                {
                    "ruta": "Sadernes-Sant Aniol",
                    "fitxer": "sadernes-sant_aniol.gpx",
                    "desc": "senderisme*Altres*sadernes-sant_aniol.gpx*2024-07-24*8.4 Km*01:46:04*02:54:35*636 m*478 m*276m*497m*"
                },
                {
                    "ruta": "Vilanova-Experience Garraf Pened\xe8s 2023",
                    "fitxer": "vilanova-experience_garraf_penedes_2023.gpx",
                    "desc": "BTT*Altres*vilanova-experience_garraf_penedes_2023.gpx*2023-01-13*64.3 Km*03:42:48*04:34:23*1858 m*1358 m*11m*329m*"
                },
                {
                    "ruta": "30-Sapartega",
                    "fitxer": "30-sapartega.gpx",
                    "desc": "BTT*Altres*30-sapartega.gpx*2025-07-18*10.1 Km*01:06:29*01:08:47*584 m*502 m*799m*1166m*"
                },
                {
                    "ruta": "Igualada-Cervera-Igualada",
                    "fitxer": "igualada-cervera-igualada.gpx",
                    "desc": "BTT*Altres*igualada-cervera-igualada.gpx*2025-10-24*90.5 Km*05:24:50*07:30:11*2195 m*1970 m*308m*797m*"
                },
                {
                    "ruta": "Roncesvalles",
                    "fitxer": "roncesvalles.gpx",
                    "desc": "BTT*Altres*roncesvalles.gpx*1995-07-07*13.3 Km*00:19:30*00:19:30*395 m*257 m*887m*1188m*"
                },
                {
                    "ruta": "Igualada-Calaf-Manresa-Igualada",
                    "fitxer": "igualada-calaf-manresa-igualada.gpx",
                    "desc": "BTT*Altres*igualada-calaf-manresa-igualada.gpx*2021-12-04*95.0 Km*05:42:36*06:52:36*2147 m*1689 m*237m*724m*"
                },
                {
                    "ruta": "Vilafranca-Santa Coloma de Queralt-Igualada",
                    "fitxer": "vilafranca-sta_coloma_queralt-igualada.gpx",
                    "desc": "ciclisme*Altres*vilafranca-sta_coloma_queralt-igualada.gpx*2024-02-16*74.8 Km*03:39:30*04:50:09*1637 m*1461 m*193m*822m*"
                },
                {
                    "ruta": "Espierba-Punta el Cuezo",
                    "fitxer": "espierba-punta_el_cuezo.gpx",
                    "desc": "senderisme*Altres*espierba-punta_el_cuezo.gpx*2022-07-25*10.1 Km*00:00:31*03:29:33*724 m*484 m*1380m*2088m*"
                }
            ]
        },
        {
            "zona": "V\xeda de la Plata",
            "id": "via_de_la_plata",
            "rutes": [
                {
                    "ruta": "4VP-C\xe1ceres-Galisteo",
                    "fitxer": "4VP-caceres-galisteo.gpx",
                    "desc": "BTT*V\xeda de la Plata*4VP-caceres-galisteo.gpx*2023-07-04*73.4 Km*04:19:04*06:08:28*1011 m*870 m*202m*495m*"
                },
                {
                    "ruta": "7VP-Salamanca-Zamora-Granja de Moreruela",
                    "fitxer": "7VP-salamanca-zamora-granja_de_moreruela.gpx",
                    "desc": "BTT*V\xeda de la Plata*7VP-salamanca-zamora-granja_de_moreruela.gpx*2023-07-07*111.8 Km*05:04:27*09:14:41*1059 m*877 m*621m*884m*"
                },
                {
                    "ruta": "10VP-Vilar de Barrio-Ourense-Silleda",
                    "fitxer": "10VP-vilar_de_barrio-ourense-silleda.gpx",
                    "desc": "BTT*V\xeda de la Plata*10VP-vilar_de_barrio-ourense-silleda.gpx*2023-07-10*111.0 Km*07:13:43*12:28:14*2487 m*2268 m*101m*819m*"
                },
                {
                    "ruta": "3VP-Villafranca de los Barros-M\xe9rida-C\xe1ceres",
                    "fitxer": "3VP-villafranca_de_los_barros-merida-caceres.gpx",
                    "desc": "BTT*V\xeda de la Plata*3VP-villafranca_de_los_barros-merida-caceres.gpx*2023-07-03*119.3 Km*05:37:29*10:58:26*1151 m*970 m*201m*489m*"
                },
                {
                    "ruta": "1VP-Sevilla-Castilblanco de los Arroyos",
                    "fitxer": "1VP-sevilla-castilblanco_de_los_arroyos.gpx",
                    "desc": "BTT*V\xeda de la Plata*1VP-sevilla-castilblanco_de_los_arroyos.gpx*2023-07-01*46.0 Km*02:52:32*04:41:20*748 m*675 m*0m*351m*"
                },
                {
                    "ruta": "8VP-Granja de Moreruela-Puebla de Sanabria",
                    "fitxer": "8VP-granja_de_moreruela-puebla_de_sanabria.gpx",
                    "desc": "BTT*V\xeda de la Plata*8VP-granja_de_moreruela-puebla_de_sanabria.gpx*2023-07-08*114.8 Km*06:32:08*09:49:36*1468 m*1312 m*684m*1013m*"
                },
                {
                    "ruta": "11VP-Silleda-Santiago de Compostela",
                    "fitxer": "11VP-silleda-santiago_de_compostela.gpx",
                    "desc": "BTT*V\xeda de la Plata*11VP-silleda-santiago_de_compostela.gpx*2023-07-11*41.1 Km*02:34:28*02:57:07*998 m*910 m*54m*494m*"
                },
                {
                    "ruta": "6VP-La Calzada de B\xe9jar-Salamanca",
                    "fitxer": "6VP-la_calzada_de_bejar-salamanca.gpx",
                    "desc": "BTT*V\xeda de la Plata*6VP-la_calzada_de_bejar-salamanca.gpx*2023-07-06*78.0 Km*04:23:04*06:35:45*1074 m*989 m*771m*1098m*"
                },
                {
                    "ruta": "9VP-Puebla de Sanabria-Vilar de Barrio",
                    "fitxer": "9VP-puebla_de_sanabria-vilar_de_barrio.gpx",
                    "desc": "BTT*V\xeda de la Plata*9VP-puebla_de_sanabria-vilar_de_barrio.gpx*2023-07-09*114.6 Km*06:53:39*09:09:00*3127 m*2664 m*466m*1356m*"
                },
                {
                    "ruta": "5VP-Galisteo-La Calzada de B\xe9jar",
                    "fitxer": "5VP-galisteo-la_calzada_de_bejar.gpx",
                    "desc": "BTT*V\xeda de la Plata*5VP-galisteo-la_calzada_de_bejar.gpx*2023-07-05*73.2 Km*04:25:38*06:18:29*1294 m*1146 m*245m*897m*"
                },
                {
                    "ruta": "2VP-Castilblanco de los Arroyos-Villafranca de los Barros",
                    "fitxer": "2VP-castilblanco_de_los_arroyos-villafranca_de_los_barros.gpx",
                    "desc": "BTT*V\xeda de la Plata*2VP-castilblanco_de_los_arroyos-villafranca_de_los_barros.gpx*2023-07-02*129.3 Km*07:38:59*13:23:12*2094 m*1924 m*299m*756m*"
                }
            ]
        },
        {
            "zona": "Bag\xe0",
            "id": "baga",
            "rutes": [
                {
                    "ruta": "Coll de Pal-Comafloriu-Xalet Coll de Pal",
                    "fitxer": "coll_pal-comafloriu-xalet_coll_de_pal.gpx",
                    "desc": "senderisme*Bag\xe0*coll_pal-comafloriu-xalet_coll_de_pal.gpx*2021-01-02*4.0 Km*01:44:04*01:54:20*217 m*188 m*1926m*2205m*"
                },
                {
                    "ruta": "ToDo-Bag\xe0-Rebost-Gavarr\xf3s-Castellar de n'Hug-Gombr\xe8n-Campdev\xe0nol",
                    "fitxer": "todo-baga-rebost-gavarros-castellar_de_nhug-gombren-campdevanol.gpx",
                    "desc": "BTT*Bag\xe0*todo-baga-rebost-gavarros-castellar_de_nhug-gombren-campdevanol.gpx*2021-08-31*51.1 Km*01:03:20*01:03:20*1813 m*1470 m*731m*1722m*"
                },
                {
                    "ruta": "Bac de Div\xed-Paller",
                    "fitxer": "bac_de_divi-paller.gpx",
                    "desc": "senderisme*Bag\xe0*bac_de_divi-paller.gpx*2021-05-22*5.0 Km*02:04:00*02:29:00*601 m*534 m*922m*1393m*"
                },
                {
                    "ruta": "Bag\xe0-Coll de Turbians-Coll de la Bena-St Mart\xed del Puig",
                    "fitxer": "baga-coll_turbians-coll_bena-st_marti_puig.gpx",
                    "desc": "BTT*Bag\xe0*baga-coll_turbians-coll_bena-st_marti_puig.gpx*2020-06-20*25.4 Km*02:07:36*02:36:46*1107 m*934 m*772m*1458m*vXvLYz55r7O"
                },
                {
                    "ruta": "Urtx-Alp-Cortal_Vidal-Penyes_Altes-dia 1",
                    "fitxer": "urtx-alp-cortal_vidal-penyes_altes-dia_1.gpx",
                    "desc": "senderisme*Bag\xe0*urtx-alp-cortal_vidal-penyes_altes-dia_1.gpx*2025-09-06*14.9 Km*03:34:32*04:32:53*1315 m*1162 m*1133m*1949m*"
                },
                {
                    "ruta": "Via Nicolau",
                    "fitxer": "via_nicolau.gpx",
                    "desc": "BTT*Bag\xe0*via_nicolau.gpx*2020-07-10*4.5 Km*00:29:36 *00:50:28*290 m*191 m*771m*934m*"
                },
                {
                    "ruta": "Transpirenaica en BTT Etapa 5 Bag\xe0-Noves de Segre",
                    "fitxer": "transpirenaica-en-btt-etapa-5-baga-noves-de-segre.gpx",
                    "desc": "BTT*Bag\xe0*transpirenaica-en-btt-etapa-5-baga-noves-de-segre.gpx*2019-07-30*66.3 Km*00:00:20 *19:21:01*2478 m*1781 m*580m*1916m*vPv4JZKn8R6"
                },
                {
                    "ruta": "Campdev\xe0nol-Sant Jaume de Frontany\xe0-Cerdanyola-Bag\xe0",
                    "fitxer": "campdevanol-st_jaume_frontanya-cerdanyola-baga.gpx",
                    "desc": "BTT*Bag\xe0*campdevanol-st_jaume_frontanya-cerdanyola-baga.gpx*2022-12-17*51.4 Km*05:00:00*05:03:48*2284 m*1383 m*725m*1555m*"
                },
                {
                    "ruta": "Bag\xe0-Coll de Pal-Gavarr\xf3s",
                    "fitxer": "baga-coll_de_pal-gavarros.gpx",
                    "desc": "BTT*Bag\xe0*baga-coll_de_pal-gavarros.gpx*2022-08-06*39.8 Km*02:58:56*03:20:32*1948 m*1603 m*724m*2110m*"
                },
                {
                    "ruta": "Via del Nicolau-el Puig-la Salle",
                    "fitxer": "via_del_nicolau-el_puig-la_salle.gpx",
                    "desc": "BTT*Bag\xe0*via_del_nicolau-el_puig-la_salle.gpx*2026-01-30*13.0 Km*00:54:41*01:11:34*658 m*501 m*781m*995m*"
                },
                {
                    "ruta": "Bag\xe0-Collet d'A\xefna-El Jou-Fumanya-Vallcebre",
                    "fitxer": "baga-collet_aina-jou-fumanya-vallcebre.gpx",
                    "desc": "ciclisme*Bag\xe0*baga-collet_aina-jou-fumanya-vallcebre.gpx*2020-08-05*40.1 Km*02:34:44 *02:47:16*1339 m*1099 m*701m*1566m*vrqoM8DDZKO"
                },
                {
                    "ruta": "Bag\xe0, Broc\xe0, Collada Grossa, Paller de Dalt, Paller de Baix, Bag\xe0",
                    "fitxer": "baga-broca-collada-grossa-paller-de-dalt-paller-de-baix-baga.gpx",
                    "desc": "BTT*Bag\xe0*baga-broca-collada-grossa-paller-de-dalt-paller-de-baix-baga.gpx*2019-08-20*19.4 Km*01:39:12*02:17:21*1081 m*868 m*768 m*1550 m*vWqBed1BjY6"
                },
                {
                    "ruta": "Bag\xe0-Pla_Castell-Collada_Grossa-Refugi_Rebost-Millar\xe8s",
                    "fitxer": "Baga-Pla_Castell-Collada_Grossa-Refugi_Rebost-Millares.gpx",
                    "desc": "BTT*Bag\xe0*Baga-Pla_Castell-Collada_Grossa-Refugi_Rebost-Millares.gpx*2020-08-03*29.0 Km*02:46:20 *03:31:24*1594 m*1352 m*795m*1725m*vXOnMG5xX5v"
                },
                {
                    "ruta": "Campdev\xe0nol-Masies de Gombr\xe8n-La Pobla-Bag\xe0",
                    "fitxer": "campdevanol-masies_de_gombren-la_pobla-baga.gpx",
                    "desc": "BTT*Bag\xe0*campdevanol-masies_de_gombren-la_pobla-baga.gpx*2024-10-25*38.3 Km*02:55:10*04:30:18*1460 m*1230 m*724m*1216m*"
                },
                {
                    "ruta": "Bag\xe0-Via del Nicolau-Coll de Turbians",
                    "fitxer": "baga-via_nicolau-coll_turbians.gpx",
                    "desc": "BTT*Bag\xe0*baga-via_nicolau-coll_turbians.gpx*2021-12-16*49.0 Km*03:20:08*03:54:08*1571 m*1107 m*162m*617m*"
                },
                {
                    "ruta": "Bag\xe0-Refugi de Rebost-L'Hospitalet",
                    "fitxer": "baga-refugi_rebost-l_hospitalet.gpx",
                    "desc": "BTT*Bag\xe0*baga-refugi_rebost-l_hospitalet.gpx*2025-08-19*25.3 Km*01:41:34*01:41:52*1522 m*1332 m*817m*1732m*"
                },
                {
                    "ruta": "Bag\xe0-Coll de Pal",
                    "fitxer": "baga-coll_de_pal.gpx",
                    "desc": "ciclisme*Bag\xe0*baga-coll_de_pal.gpx*2021-08-26*38.3 Km*04:04:56*04:04:56*1611 m*1321 m*820m*2107m*"
                },
                {
                    "ruta": "L'Hospitalet-Coll de Jou-Penyes Altes-Canal de la Serp-Gr\xe9ixer",
                    "fitxer": "l_hospitalet-coll_jou-penyes_altes-canal_serp-greixer.gpx",
                    "desc": "senderisme*Bag\xe0*l_hospitalet-coll_jou-penyes_altes-canal_serp-greixer.gpx*2023-09-29*14.7 Km*17:42:17*18:09:12*1952 m*1447 m*1014m*2244m*"
                },
                {
                    "ruta": "L'Hospitalet-Coll de Jou-Penyes Altes-Canal de la Serp-Gr\xe9ixer",
                    "fitxer": "l_hospitalet-coll_jou-penyes_altes-canal_serp-greixer.gpx",
                    "desc": "senderisme*Bag\xe0*l_hospitalet-coll_jou-penyes_altes-canal_serp-greixer.gpx*2023-09-29*14.7 Km*17:42:17*18:09:12*1952 m*1447 m*1014m*2244m*"
                },
                {
                    "ruta": "Entreno Bag\xe0 1",
                    "fitxer": "entreno_baga_1.gpx",
                    "desc": "BTT*Bag\xe0*entreno_baga_1.gpx*2020-07-07*17.9 Km*01:25:56 *01:33:16*908 m*624 m*730m*1113m*vMq5dmN8586"
                },
                {
                    "ruta": "Manresa-Berga-Bag\xe0",
                    "fitxer": "manresa-berga-baga.gpx",
                    "desc": "BTT*Bag\xe0*manresa-berga-baga.gpx*2024-02-09*95.2 Km*07:51:54*07:52:12*3268 m*2240 m*207m*1046m*"
                },
                {
                    "ruta": "Bag\xe0-Coll de Pal",
                    "fitxer": "baga-coll_de_pal_v2.gpx",
                    "desc": "ciclisme*Bag\xe0*baga-coll_de_pal_v2.gpx*2023-08-17*35.3 Km*03:47:34*04:01:12*1981 m*1314 m*818m*2110m*"
                },
                {
                    "ruta": "Campdev\xe0nol-Coll de Merolla-Bag\xe0",
                    "fitxer": "campdevanol-coll_merolla-baga.gpx",
                    "desc": "ciclisme*Bag\xe0*campdevanol-coll_merolla-baga.gpx*2023-07-26*34.8 Km*01:48:19*02:08:23*1322 m*1070 m*724m*1112m*"
                },
                {
                    "ruta": "Volta per Bag\xe0 2",
                    "fitxer": "volta_per_baga_2.gpx",
                    "desc": "BTT*Bag\xe0*volta_per_baga_2.gpx*2024-07-31*12.1 Km*00:46:11*00:48:58*533 m*432 m*790m*994m*"
                },
                {
                    "ruta": "Bag\xe0-La Pobla de Lillet",
                    "fitxer": "baga-la_pobla_de_lillet.gpx",
                    "desc": "BTT*Bag\xe0*baga-la_pobla_de_lillet.gpx*2023-07-27*32.3 Km*02:08:40*02:41:03*1142 m*937 m*724m*987m*"
                },
                {
                    "ruta": "Cal Cerdanyola-Monnell-Murcurols-El Puig",
                    "fitxer": "cal_cerdanyola-monnell-murcurols-el_puig.gpx",
                    "desc": "senderisme*Bag\xe0*cal_cerdanyola-monnell-murcurols-el_puig.gpx*2021-01-01*7.9 Km*02:24:19*02:37:55*530 m*458 m*915m*1192m*"
                },
                {
                    "ruta": "Bag\xe0-Coll de Merolla-Campdev\xe0nol",
                    "fitxer": "baga-coll_de_merolla-campdevanol_v3.gpx",
                    "desc": "ciclisme*Bag\xe0*baga-coll_de_merolla-campdevanol_v3.gpx*2024-10-26*35.0 Km*01:38:18*01:38:18*1217 m*997 m*724m*1112m*"
                },
                {
                    "ruta": "Bag\xe0-Coll de la Bena-Turbians-Roca de Cans-Siti",
                    "fitxer": "baga-coll_bena-turbians-roca_de_cans-siti.gpx",
                    "desc": "BTT*Bag\xe0*baga-coll_bena-turbians-roca_de_cans-siti.gpx*2021-05-21*27.6 Km*03:08:24*03:14:48*1437 m*1166 m*771m*1472m*"
                },
                {
                    "ruta": "Volta per Bag\xe0 3",
                    "fitxer": "volta_per_baga_3.gpx",
                    "desc": "BTT*Bag\xe0*volta_per_baga_3.gpx*2024-07-29*5.0 Km*00:21:55*00:23:16*280 m*239 m*852m*993m*"
                },
                {
                    "ruta": "Bag\xe0-Gr\xe9ixer-Coll d'Escriu-Empedrats-Bag\xe0",
                    "fitxer": "baga-greixer-escriu-empedrats-baga.gpx",
                    "desc": "BTT*Bag\xe0*baga-greixer-escriu-empedrats-baga.gpx*2013-03-26*16.5 Km*00:48:52 *02:11:07*1023 m*730 m*796m*1503m*vXOnEkVyQBv"
                },
                {
                    "ruta": "Bag\xe0-Cap del Tossal v0",
                    "fitxer": "baga-cap_del_tossal_v0.gpx",
                    "desc": "BTT*Bag\xe0*baga-cap_del_tossal.gpx*2020-07-01*19.5 Km*01:08:32*02:30:45*961 m*800 m*705m*1349m*vrqDmZAyGwv"
                },
                {
                    "ruta": "Bag\xe0-Bena-Bauma-Collell-Saldes-Riu de Saldes",
                    "fitxer": "baga-bena-bauma-collell-saldes-riu_de_saldes.gpx",
                    "desc": "BTT*Bag\xe0*baga-bena-bauma-collell-saldes-riu_de_saldes.gpx*2022-09-23*55.3 Km*03:50:33*05:16:47*2898 m*1779 m*710m*1924m*"
                },
                {
                    "ruta": "Penyes_Altes-Bag\xe0-dia 2",
                    "fitxer": "penyes_altes-baga-dia_2.gpx",
                    "desc": "senderisme*Bag\xe0*penyes_altes-baga-dia_2.gpx*2025-09-07*15.7 Km*04:22:25*04:38:31*938 m*669 m*818m*2241m*"
                },
                {
                    "ruta": "Volta per Broc\xe0 (sector sud)",
                    "fitxer": "volta_broca_sector_sud.gpx",
                    "desc": "senderisme*Bag\xe0*volta_broca_sector_sud.gpx*2020-07-10*7.2 Km*01:41:19 *02:21:19*297 m*224 m*745m*896m*"
                },
                {
                    "ruta": "Bag\xe0-Riugr\xe9ixer-C\xe0mping",
                    "fitxer": "riugreixer-camping.gpx",
                    "desc": "BTT*Bag\xe0*riugreixer-camping.gpx*2021-08-24*4.7 Km*00:22:36*00:22:36*180 m*117 m*798m*895m*"
                },
                {
                    "ruta": "Xalet Coll de Pal-Gavarr\xf3s-Guardiola-Bag\xe0-L'Hospitalet",
                    "fitxer": "xalet_coll_de_pal-gavarros-guardiola-baga-l_hospitalet.gpx",
                    "desc": "BTT*Bag\xe0*xalet_coll_de_pal-gavarros-guardiola-baga-l_hospitalet.gpx*2023-06-03*33.6 Km*03:25:31*06:20:38*1878 m*1648 m*724m*1990m*"
                },
                {
                    "ruta": "Bag\xe0-Coll de la Pelosa",
                    "fitxer": "baga-coll_de_la_pelosa.gpx",
                    "desc": "BTT*Bag\xe0*baga-coll_de_la_pelosa.gpx*2021-05-22*22.0 Km*01:58:28*01:58:28*943 m*716 m*798m*1421m*"
                },
                {
                    "ruta": "Bag\xe0-Broc\xe0-Collada Grossa-L'Estret-Riutort",
                    "fitxer": "baga-broca-collada_grossa-estret-riutort.gpx",
                    "desc": "BTT*Bag\xe0*baga-broca-collada_grossa-estret-riutort.gpx*2020-06-21*26.8 Km*02:22:47*03:10:57*1179 m*1029 m*747m*1551m*vNOPnVDzrYq"
                },
                {
                    "ruta": "Bag\xe0-Broc\xe0-Collada Grossa-Paller",
                    "fitxer": "baga-broca-collada_grossa-paller.gpx",
                    "desc": "BTT*Bag\xe0*baga-broca-collada_grossa-paller.gpx*2026-01-29*19.9 Km*02:20:50*02:31:46*1287 m*1154 m*758m*1545m*"
                },
                {
                    "ruta": "Bag\xe0-Broc\xe0-Pla del Castell",
                    "fitxer": "baga-broca-pla_del_castell.gpx",
                    "desc": "BTT*Bag\xe0*baga-broca-pla_del_castell.gpx*2024-08-19*16.9 Km*01:25:08*01:27:12*845 m*783 m*769m*1324m*"
                },
                {
                    "ruta": "Bag\xe0-Coll d'Escriga-Coll de Turbians",
                    "fitxer": "baga-coll_descriga-coll_de_turbians.gpx",
                    "desc": "BTT*Bag\xe0*baga-coll_descriga-coll_de_turbians.gpx*2025-08-15*20.5 Km*01:30:46*01:35:06*1281 m*1103 m*780m*1462m*"
                },
                {
                    "ruta": "Bag\xe0-Rebost-Gavarr\xf3s-Coll Roig-Collet de la Casa Nova-Sant Vicen\xe7 de Rus-La Pobla-Guardiola",
                    "fitxer": "baga-rebost-gavarros-coll_roig-collet_casa_nova-sant_vicenc_de_rus-la_pobla-guardiola.gpx",
                    "desc": "BTT*Bag\xe0*baga-rebost-gavarros-coll_roig-collet_casa_nova-sant_vicenc_de_rus-la_pobla-guardiola.gpx*2020-11-07*43.0 Km*03:53:11*04:03:47*1810 m*1426 m*720m*1723m"
                },
                {
                    "ruta": "Paller-Sant Marc de Broc\xe0",
                    "fitxer": "paller-sant_marc_de_broca.gpx",
                    "desc": "senderisme*Bag\xe0*paller-sant_marc_de_broca.gpx*2023-10-14*11.3 Km*02:45:50*03:00:25*1037 m*871 m*978m*1601m*"
                },
                {
                    "ruta": "Paller-Sant Marc de Broc\xe0",
                    "fitxer": "paller-sant_marc_de_broca.gpx",
                    "desc": "senderisme*Bag\xe0*paller-sant_marc_de_broca.gpx*2023-10-14*11.3 Km*02:45:50*03:00:25*1037 m*871 m*978m*1601m*"
                },
                {
                    "ruta": "Bag\xe0-Via Nicolau-Font de la Vinyavella-Coll de Turbians",
                    "fitxer": "baga-via_del_nicolau-font_vinyavella-coll_turbians.gpx",
                    "desc": "BTT*Bag\xe0*baga-via_del_nicolau-font_vinyavella-coll_turbians.gpx*2024-08-01*21.6 Km*01:42:36*01:47:32*1301 m*1132 m*780m*1462m*"
                },
                {
                    "ruta": "Monnell-Vimboca-Moixa-Afrau dels Cortals",
                    "fitxer": "monnell-vimboca-moixa-afrau_dels_cortals.gpx",
                    "desc": "senderisme*Bag\xe0*monnell-vimboca-moixa-afrau_dels_cortals.gpx*2024-05-12*28.5 Km*07:09:50*09:55:37*3005 m*2376 m*961m*2218m*"
                },
                {
                    "ruta": "Bag\xe0-Gresolet-Riu de Saldes",
                    "fitxer": "baga-gresolet-riu_saldes.gpx",
                    "desc": "BTT*Bag\xe0*baga-gresolet-riu_saldes.gpx*2020-07-08*43.5 Km*03:02:44 *03:37:02*1754 m*1267 m*702m*1575m*vYvrDG22zx6"
                },
                {
                    "ruta": "Bag\xe0-Gavarr\xf3s-Rebost",
                    "fitxer": "baga-gavarros-rebost.gpx",
                    "desc": "BTT*Bag\xe0*baga-gavarros-rebost.gpx*2023-07-31*28.1 Km*02:15:21*02:42:56*1520 m*1306 m*724m*1732m*"
                },
                {
                    "ruta": "Bag\xe0-Coll de Merolla-Campdev\xe0nol",
                    "fitxer": "baga-coll_de_merolla-campdevanol_v2.gpx",
                    "desc": "ciclisme*Bag\xe0*baga-coll_de_merolla-campdevanol_v2.gpx*2023-08-01*33.0 Km*01:32:56*01:32:56*1231 m*1015 m*725m*1111m*"
                },
                {
                    "ruta": "NO-via_del_nicolau",
                    "fitxer": "NO-via_del_nicolau.gpx",
                    "desc": "BTT*Bag\xe0*NO-via_del_nicolau.gpx*2022-08-04*13.0 Km*01:21:16*02:12:56*593 m*404 m*733m*930m*"
                },
                {
                    "ruta": "Volta per Bag\xe0 1",
                    "fitxer": "volta_per_baga_1.gpx",
                    "desc": "BTT*Bag\xe0*volta_per_baga_1.gpx*2024-08-02*4.7 Km*00:21:33*00:21:33*177 m*158 m*803m*908m*"
                },
                {
                    "ruta": "Gr\xe9ixer-Coll d'Escriu",
                    "fitxer": "greixer-coll_d_escriu.gpx",
                    "desc": "BTT*Bag\xe0*greixer-coll_d_escriu.gpx*2022-08-07*7.3 Km*01:28:28*02:00:40*605 m*531 m*1016m*1505m*"
                },
                {
                    "ruta": "Gr\xe9ixer-Coll d'Escriu",
                    "fitxer": "greixer-coll_d_escriu.gpx",
                    "desc": "BTT*Bag\xe0*greixer-coll_d_escriu.gpx*2022-08-07*7.3 Km*01:28:28*02:00:40*605 m*531 m*1016m*1505m*"
                },
                {
                    "ruta": "Bag\xe0-Pujada antena",
                    "fitxer": "baga-pujada_antena.gpx",
                    "desc": "BTT*Bag\xe0*baga-pujada_antena.gpx*2022-08-03*7.0 Km*00:40:52*00:40:52*393 m*312 m*811m*1111m*"
                },
                {
                    "ruta": "Bag\xe0-Cerdanyola-Sant Jaume de Frontany\xe0-Campdev\xe0nol",
                    "fitxer": "baga-cerdanyola-st_jaume_frontanya-campdevanol.gpx",
                    "desc": "BTT*Bag\xe0*baga-cerdanyola-st_jaume_frontanya-campdevanol.gpx*2024-02-23*50.7 Km*04:01:18*04:46:34*2317 m*2042 m*724m*1554m*"
                },
                {
                    "ruta": "Bag\xe0-Coll de Merolla-Campdev\xe0nol",
                    "fitxer": "baga-coll_merolla-campdevanol.gpx",
                    "desc": "ciclisme*Bag\xe0*baga-coll_merolla-campdevanol.gpx*2021-07-18*34.9 Km*01:43:19*01:43:19*848 m*451 m*721m*1100m*"
                },
                {
                    "ruta": "Bag\xe0-Sant Joan-Matallops-Vinyavella",
                    "fitxer": "baga-sant_joan-matallops-vinyavella.gpx",
                    "desc": "BTT*Bag\xe0*baga-sant_joan-matallops-vinyavella.gpx*2022-08-01*11.7 Km*01:17:32*02:07:08*535 m*411 m*780m*1037m*"
                },
                {
                    "ruta": "Alp-Masella-Molina-Creueta-Bag\xe0",
                    "fitxer": "alp-masella-molina-creueta-baga.gpx",
                    "desc": "ciclisme*Bag\xe0*alp-masella-molina-creueta-baga.gpx*2023-01-03*55.8 Km*02:24:05*02:24:05*1741 m*1078 m*724m*1926m*"
                },
                {
                    "ruta": "Bag\xe0-Coll de Turbians-Roca de  Cans",
                    "fitxer": "baga-coll_turbians-roca_de_cans.gpx",
                    "desc": "BTT*Bag\xe0*baga-coll_turbians-roca_de_cans.gpx*2025-08-20*17.6 Km*01:49:38*02:03:35*1323 m*1077 m*780m*1467m*"
                },
                {
                    "ruta": "Paller de Baix-Paller de Dalt",
                    "fitxer": "paller_de_baix-paller_de_dalt.gpx",
                    "desc": "BTT*Bag\xe0*paller_de_baix-paller_de_dalt.gpx*2022-08-02*7.5 Km*01:04:36*01:16:52*559 m*413 m*975m*1310m*"
                },
                {
                    "ruta": "Cambra del Boc",
                    "fitxer": "cambra_del_boc.gpx",
                    "desc": "senderisme*Bag\xe0*cambra_del_boc.gpx*2020-08-06*9.0 Km*02:21:36 *04:22:40*1190 m*946 m*943m*1756m*vLqe1GPEzRq"
                },
                {
                    "ruta": "Bag\xe0-Cap del Tossal v1",
                    "fitxer": "baga-cap_del_tossal.gpx",
                    "desc": "BTT*Bag\xe0*baga-cap_del_tossal.gpx*2024-08-16*16.3 Km*01:32:25*01:41:37*1050 m*919 m*734m*1341m*"
                }
            ]
        },
        {
            "zona": "TransPirenaica",
            "id": "transpirenaica",
            "rutes": [
                {
                    "ruta": "Transpirinenca. Fiscal-Aur\xedn",
                    "fitxer": "TP_11_fiscal-aurin.gpx",
                    "desc": "BTT*TransPirenaica*TP_11_fiscal-aurin.gpx*1996-07-06*50.3 Km*00:05:56*09:06:19*1295 m*1073 m*774m*1678m*"
                },
                {
                    "ruta": "Transpirinenca. Fiscal-Aur\xedn",
                    "fitxer": "TP_11_fiscal-aurin.gpx",
                    "desc": "BTT*TransPirenaica*TP_11_fiscal-aurin.gpx*1996-07-06*50.3 Km*00:05:56*09:06:19*1295 m*1073 m*774m*1678m*"
                },
                {
                    "ruta": "Transpirinenca. Bag\xe0-Noves de Segre",
                    "fitxer": "TP_05_baga-noves_de_segre.gpx",
                    "desc": "BTT*TransPirenaica*TP_05_baga-noves_de_segre.gpx*1995-07-06*66.9 Km*17:16:10*23:52:26*1778 m*1576 m*594m*1914m*"
                },
                {
                    "ruta": "Transpirinenca. Camprodon-Planoles",
                    "fitxer": "TP_03_camprodon-planoles.gpx",
                    "desc": "BTT*TransPirenaica*TP_03_camprodon-planoles.gpx*1995-05-01*57.9 Km*16:37:52*00:40:04*1847 m*1799 m*940m*2059m*"
                },
                {
                    "ruta": "Transpirinenca. Noves de Segre-Llavors\xed",
                    "fitxer": "TP_06_noves_de_segre-llavorsi.gpx",
                    "desc": "BTT*TransPirenaica*TP_06_noves_de_segre-llavorsi.gpx*1995-07-06*51.9 Km*15:57:52*23:15:35*1407 m*1245 m*652m*1757m*"
                },
                {
                    "ruta": "Transpirinenca. Etxalar-Hondarribia",
                    "fitxer": "TP_16_etxalar-hondarribia.gpx",
                    "desc": "BTT*TransPirenaica*TP_16_etxalar-hondarribia.gpx*1996-07-06*43.6 Km*00:08:07*07:37:09*1098 m*886 m*5m*450m*"
                },
                {
                    "ruta": "Transpirinenca. Planoles-Bag\xe0",
                    "fitxer": "TP_04_planoles-baga.gpx",
                    "desc": "BTT*TransPirenaica*TP_04_planoles-baga.gpx*1995-07-06*54.6 Km*00:17:04*07:17:24*1684 m*1491 m*821m*2104m*"
                },
                {
                    "ruta": "Transpirinenca. Llan\xe7\xe0-Albany\xe0",
                    "fitxer": "TP_01_llanca-albanya.gpx",
                    "desc": "BTT*TransPirenaica*TP_01_llanca-albanya.gpx*1995-05-01*75.5 Km*06:27:24*16:36:42*1667 m*1288 m*0m*362m*"
                },
                {
                    "ruta": "Transpirinenca. Izaba-Roncesvalles",
                    "fitxer": "TP_14_izaba-roncesvalles.gpx",
                    "desc": "BTT*TransPirenaica*TP_14_izaba-roncesvalles.gpx*1996-07-06*73.3 Km*00:20:02*09:28:59*1766 m*1465 m*756m*1341m*"
                },
                {
                    "ruta": "Transpirinenca. Echo-Izaba",
                    "fitxer": "TP_13_echo-izaba.gpx",
                    "desc": "BTT*TransPirenaica*TP_13_echo-izaba.gpx*1996-07-06*37.4 Km*00:03:34*06:54:15*1040 m*860 m*793m*1283m*"
                },
                {
                    "ruta": "Transpirinenca. Espui-Bonansa",
                    "fitxer": "TP_08_espui-bonansa.gpx",
                    "desc": "BTT*TransPirenaica*TP_08_espui-bonansa.gpx*1995-07-06*61.9 Km*00:25:12*11:14:13*1891 m*1649 m*861m*1595m*"
                },
                {
                    "ruta": "Transpirinenca. Bonansa-Escalona",
                    "fitxer": "TP_09_bonansa-escalona.gpx",
                    "desc": "BTT*TransPirenaica*TP_09_bonansa-escalona.gpx*1995-07-06*75.1 Km*12:25:18*23:59:13*2113 m*1706 m*622m*1615m*"
                },
                {
                    "ruta": "Transpirinenca. Llavors\xed-Espui",
                    "fitxer": "TP_07_llavorsi-espui.gpx",
                    "desc": "BTT*TransPirenaica*TP_07_llavorsi-espui.gpx*1995-07-06*58.1 Km*14:44:55*00:16:50*1872 m*1653 m*822m*2270m*"
                },
                {
                    "ruta": "Transpirinenca. Albany\xe0-Camprodon",
                    "fitxer": "TP_02_albanya-camprodon.gpx",
                    "desc": "BTT*TransPirenaica*TP_02_albanya-camprodon.gpx*1995-05-01*61.7 Km*00:16:32*08:32:53*1995 m*1698 m*219m*986m*"
                },
                {
                    "ruta": "Transpirinenca. Aur\xedn-Echo",
                    "fitxer": "TP_12_aur\xedn-echo.gpx",
                    "desc": "BTT*TransPirenaica*TP_12_aur\xedn-echo.gpx*1996-07-06*71.5 Km*14:39:07*23:49:51*1693 m*1438 m*747m*1501m*"
                },
                {
                    "ruta": "Transpirinenca. Roncesvalles-Etxalar",
                    "fitxer": "TP_15_roncesvalles-etxalar.gpx",
                    "desc": "BTT*TransPirenaica*TP_15_roncesvalles-etxalar.gpx*1996-07-06*66.6 Km*15:02:15*23:46:28*1676 m*1436 m*117m*1189m*"
                },
                {
                    "ruta": "Transpirinenca. Escalona-Fiscal",
                    "fitxer": "TP_10_escalona-fiscal.gpx",
                    "desc": "BTT*TransPirenaica*TP_10_escalona-fiscal.gpx*1995-07-06*69.3 Km*13:45:21*00:20:37*2121 m*1805 m*621m*2034m*"
                }
            ]
        },
        {
            "zona": "Montseny",
            "id": "montseny",
            "rutes": [
                {
                    "ruta": "Collformic-C\xe0noves-Caldes-Mollet",
                    "fitxer": "collformic-canoves-caldes-mollet.gpx",
                    "desc": "BTT*Montseny*collformic-canoves-caldes-mollet.gpx*2024-10-06*61.8 Km*03:36:35*05:11:39*1206 m*1040 m*60m*1288m*"
                },
                {
                    "ruta": "Collformic-Matagalls",
                    "fitxer": "collformic-matagalls.gpx",
                    "desc": "senderisme*Montseny*collformic-matagalls.gpx*2016-05-01*7.1 Km*01:12:50*01:49:54*570 m*544 m*1143m*1674m*"
                },
                {
                    "ruta": "D\xf2lmens de la Serra de l'Arca-Pla de la Calma-Aiguafreda",
                    "fitxer": "dolmens_serra_de_larca-pla_calma-aiguafreda.gpx",
                    "desc": "BTT*Montseny*dolmens_serra_de_larca-pla_calma-aiguafreda.gpx*2021-05-28*41.6 Km*00:40:15*01:30:27*2012 m*1431 m*397m*1211m*"
                },
                {
                    "ruta": "Viladrau-Matagalls-Agudes-Tur\xf3 de l'Home-Santa Fe",
                    "fitxer": "viladrau-matagalls-agudes-turo_home-santa_fe.gpx",
                    "desc": "senderisme*Montseny*viladrau-matagalls-agudes-turo_home-santa_fe.gpx*2003-09-18*24.7 Km*00:00:00*02:41:20*2175 m*1835 m*726m*1683m*"
                },
                {
                    "ruta": "Montseny-Tur\xf3 de l'Home",
                    "fitxer": "montseny-turo_home.gpx",
                    "desc": "senderisme*Montseny*montseny-turo_home.gpx*2004-01-23*5.4 Km*01:28:40*01:53:28*319 m*288 m*45m*278m*"
                },
                {
                    "ruta": "Montseny-Tur\xf3 de l'Home",
                    "fitxer": "montseny-turo_home.gpx",
                    "desc": "senderisme*Montseny*montseny-turo_home.gpx*2004-01-23*5.4 Km*01:28:40*01:53:28*319 m*288 m*45m*278m*"
                },
                {
                    "ruta": "Coll de Sant Mar\xe7al-Matagalls",
                    "fitxer": "coll_sant_marcal-matagalls.gpx",
                    "desc": "senderisme*Montseny*coll_sant_marcal-matagalls.gpx*2022-06-04*8.3 Km*02:54:55*04:02:08*719 m*665 m*1104m*1694m*"
                },
                {
                    "ruta": "La Garriga-Vallc\xe0rquera-Pla de la Calma-El Brull-Aiguafreda",
                    "fitxer": "la_garriga-vallcarquera-pla_de_la_calma-el_brull-aiguafreda.gpx",
                    "desc": "BTT*Montseny*la_garriga-vallcarquera-pla_de_la_calma-el_brull-aiguafreda.gpx*2022-01-14*55.2 Km*04:33:43*04:55:11*2422 m*1745 m*246m*1266m*"
                },
                {
                    "ruta": "Canovelles-Samalus-Roc Centelles-C\xe0noves-Marata",
                    "fitxer": "Canovelles-Samalus-Roc_Centelles-Canoves-Marata.gpx",
                    "desc": "BTT*Montseny*Canovelles-Samalus-Roc_Centelles-Canoves-Marata.gpx*2021-04-16*41.3 Km*03:31:41*03:37:09*1245 m*1029 m*151m*996*"
                },
                {
                    "ruta": "La Garriga-Vallforners-Pla de la Calma-La M\xf3ra-Aiguafreda",
                    "fitxer": "la_garriga-vallforners-pla_calma-la_mora-aiguafreda.gpx",
                    "desc": "BTT*Montseny*la_garriga-vallforners-pla_calma-la_mora-aiguafreda.gpx*2021-06-04*37.3 Km*02:57:28*02:58:12*1431 m*1193 m*257m*1293m*"
                },
                {
                    "ruta": "Aiguafreda-Fondrats-El Bellit-Tagamanent",
                    "fitxer": "aiguafreda-fondrats-bellit-tagamanent.gpx",
                    "desc": "senderisme*Montseny*aiguafreda-fondrats-bellit-tagamanent.gpx*2019-12-23*14.1 Km*00:00:57*03:30:46*887 m*707 m*408m*1100m*"
                },
                {
                    "ruta": "Aiguafreda-Pla de la Calma-Collformic-La Castanya-Montseny-El Molar",
                    "fitxer": "aiguafreda-pla_calma-collformic-la_castanya-montseny-el_molar.gpx",
                    "desc": "BTT*Montseny*aiguafreda-pla_calma-collformic-la_castanya-montseny-el_molar.gpx*2025-01-24*58.8 Km*04:35:17*05:29:51*3378 m*2870 m*400m*1293m*"
                },
                {
                    "ruta": "Aiguafreda-Pla de la Calma-Collformic-La Castanya-Montseny-El Molar",
                    "fitxer": "aiguafreda-pla_calma-collformic-la_castanya-montseny-el_molar.gpx",
                    "desc": "BTT*Montseny*aiguafreda-pla_calma-collformic-la_castanya-montseny-el_molar.gpx*2025-01-24*58.8 Km*04:35:17*05:29:51*3378 m*2870 m*400m*1293m*"
                },
                {
                    "ruta": "Palautordera-Collformic-Aiguafreda",
                    "fitxer": "palautordera-collformic-aiguafreda.gpx",
                    "desc": "ciclisme*Montseny*palautordera-collformic-aiguafreda.gpx*2024-06-07*43.1 Km*02:39:08*03:21:39*2022 m*1738 m*190m*1266m*"
                },
                {
                    "ruta": "Centelles-El Figar\xf3-Tagamanent-Aiguafreda",
                    "fitxer": "centelles-figaro-tagamanent-aiguafreda.gpx",
                    "desc": "BTT*Montseny*centelles-figaro-tagamanent-aiguafreda.gpx*2024-10-11*37.4 Km*03:24:30*04:31:23*1843 m*1575 m*312m*980m*"
                },
                {
                    "ruta": "Sant Celoni-Tur\xf3 de l'Home",
                    "fitxer": "sant_celoni-turo_de_lhome.gpx",
                    "desc": "BTT*Montseny*sant_celoni-turo_de_lhome.gpx*2021-06-12*51.1 Km*04:24:28*05:09:48*1942 m*1714 m*129m*1666m*748833287"
                },
                {
                    "ruta": "Seva-Matagalls-Viladrau",
                    "fitxer": "seva-matagalls-viladrau.gpx",
                    "desc": "BTT*Montseny*seva-matagalls-viladrau.gpx*2022-05-19*42.9 Km*04:18:40*05:22:49*1781 m*1483 m*636m*1694m*"
                },
                {
                    "ruta": "Vic-Collformic-Canovelles",
                    "fitxer": "vic-collformic-canovelles.gpx",
                    "desc": "BTT*Montseny*vic-collformic-canovelles.gpx*2022-05-05*62.8 Km*03:53:56*04:25:08*1837 m*1413 m*146m*1344m*"
                },
                {
                    "ruta": "Granollers-Roc de Centelles",
                    "fitxer": "granollers-roc_de_centelles.gpx",
                    "desc": "BTT*Montseny*granollers-roc_de_centelles.gpx*2021-04-23*53.3 Km*04:02:34*04:04:42*1803 m*1426 m*133m*1017m*"
                },
                {
                    "ruta": "Aiguafreda-Collformic-Pla de la Calma-Tagamanent",
                    "fitxer": "Aiguafreda-Collformic-Pla_de_la_Calma-Tagamanent.gpx",
                    "desc": "BTT*Montseny*Aiguafreda-Collformic-Pla_de_la_Calma-Tagamanent.gpx*2021-04-30*36.0 Km*03:48:28*04:00:41*1496 m*1227 m*395m*1345m*"
                },
                {
                    "ruta": "Els Castellets-Les Agudes-Tur\xf3 de l'Home",
                    "fitxer": "els_castellets-les_agudes-turo_de_lhome.gpx",
                    "desc": "senderisme*Montseny*els_castellets-les_agudes-turo_de_lhome.gpx*2021-12-29*13.8 Km*04:35:20*05:18:08*1068 m*956 m*1018m*1681m*"
                },
                {
                    "ruta": "Llinars-El Sui-Pla de la Calma-El Bellit-Aiguafreda",
                    "fitxer": "llinars-el_sui-pla_de_la_calma-el_bellit-aiguafreda.gpx",
                    "desc": "BTT*Montseny*llinars-el_sui-pla_de_la_calma-el_bellit-aiguafreda.gpx*2022-02-03*33.2 Km*03:21:56*03:57:16*1593 m*1351 m*184m*1302m*"
                },
                {
                    "ruta": "Aiguafreda-Vallc\xe0rquera-C\xe0noves-La Garriga",
                    "fitxer": "aiguafreda-vallcarquera-canoves-la_garriga.gpx",
                    "desc": "BTT*Montseny*aiguafreda-vallcarquera-canoves-la_garriga.gpx*2022-01-21*43.2 Km*03:30:56*04:25:53*2094 m*1537 m*242m*898m*"
                },
                {
                    "ruta": "Aiguafreda-Vallc\xe0rquera-C\xe0noves-La Garriga",
                    "fitxer": "aiguafreda-vallcarquera-canoves-la_garriga.gpx",
                    "desc": "BTT*Montseny*aiguafreda-vallcarquera-canoves-la_garriga.gpx*2022-01-21*43.2 Km*03:30:56*04:25:53*2094 m*1537 m*242m*898m*"
                }
            ]
        },
        {
            "zona": "Port de la Selva",
            "id": "port_de_la_selva",
            "rutes": [
                {
                    "ruta": "Port de la Selva-Selva Mar-Coll Bombo-Pla Causa-Puig Sardina-Roses-Mas Romanyac-GR92",
                    "fitxer": "port_selva-coll_bombo-pla_causa-puig_sardina-roses-mas_romanyac-GR9.gpx",
                    "desc": "BTT*Port de la Selva*port_selva-coll_bombo-pla_causa-puig_sardina-roses-mas_romanyac-GR9.gpx*2020-08-22*38.9 Km*02:49:34 *04:04:04*1693 m*1231 m*50m*488m*vMq5Ger5kQO"
                },
                {
                    "ruta": "Port de la Selva-St Baldiri-Cala_Taballera-Cadaqu\xe9s-GR92",
                    "fitxer": "port_selva-st_baldiri-cala_taballera-cadaques-GR92.gpx",
                    "desc": "BTT*Port de la Selva*port_selva-st_baldiri-cala_taballera-cadaques-GR92.gpx*2020-08-24*32.3 Km*03:25:28 *04:46:52*1163 m*984 m*0m*224m*vevYDQZp4yq"
                },
                {
                    "ruta": "Port de la Selva-Cadaqu\xe9s-GR-92",
                    "fitxer": "port_de_la_selva-cadaques-gr-92.gpx",
                    "desc": "senderisme*Port de la Selva*port_de_la_selva-cadaques-gr-92.gpx*2023-04-04*12.4 Km*02:51:56*03:07:08*610 m*517 m*8m*310m*"
                },
                {
                    "ruta": "Port de la Selva-Cadaqu\xe9s-GR-92",
                    "fitxer": "port_de_la_selva-cadaques-gr-92.gpx",
                    "desc": "senderisme*Port de la Selva*port_de_la_selva-cadaques-gr-92.gpx*2023-04-04*12.4 Km*02:51:56*03:07:08*610 m*517 m*8m*310m*"
                },
                {
                    "ruta": "Banyuls-Rumpissar-Portbou",
                    "fitxer": "banyuls-rumpissar-portbou.gpx",
                    "desc": "senderisme*Port de la Selva*banyuls-rumpissar-portbou.gpx*2023-04-02*13.0 Km*03:58:40*04:28:36*854 m*743 m*2m*549m*"
                },
                {
                    "ruta": "Sant Pere de Rodes",
                    "fitxer": "sant_pere_de_rodes.gpx",
                    "desc": "ciclisme*Port de la Selva*sant_pere_de_rodes.gpx*2025-08-07*18.0 Km*01:20:06*01:33:16*1015 m*911 m*0m*529m*"
                },
                {
                    "ruta": "Volta Port de la Selva",
                    "fitxer": "volta_port_de_la_selva.gpx",
                    "desc": "BTT*Port de la Selva*volta_port_de_la_selva.gpx*2024-08-24*18.6 Km*01:38:12*01:54:11*701 m*631 m*0m*310m*"
                },
                {
                    "ruta": "Port Selva-St Pere de Rodes-Llan\xe7\xe0-Puig Tifeu-Garbet",
                    "fitxer": "port_selva-st_pere_de_rodes-llanca-puig_tifeu-garbet.gpx",
                    "desc": "BTT*Port de la Selva*port_selva-st_pere_de_rodes-llanca-puig_tifeu-garbet.gpx*2020-08-20*41.6 Km*03:12:44 *04:01:24*1373 m*1128 m*1m*522m*vrqD4PZL3wq"
                },
                {
                    "ruta": "Port Selva-St Pere de Rodes-Llan\xe7\xe0-Puig Tifeu-Garbet",
                    "fitxer": "port_selva-st_pere_de_rodes-llanca-puig_tifeu-garbet.gpx",
                    "desc": "BTT*Port de la Selva*port_selva-st_pere_de_rodes-llanca-puig_tifeu-garbet.gpx*2020-08-20*41.6 Km*03:12:44 *04:01:24*1373 m*1128 m*1m*522m*vrqD4PZL3wq"
                },
                {
                    "ruta": "Port Selva-St Pere de Rodes-Llan\xe7\xe0-Puig Tifell-Garbet",
                    "fitxer": "port_selva-st_pere_de_rodes-llanca-puig_tifell-garbet.gpx",
                    "desc": "BTT*Port de la Selva*port_selva-st_pere_de_rodes-llanca-puig_tifell-garbet.gpx*2020-08-20*41.6 Km*03:12:44 *04:01:24*1373 m*1128 m*1m*522m*vrqD4PZL3wq"
                },
                {
                    "ruta": "Portbou-Colera-Llan\xe7\xe0-Port de la Selva",
                    "fitxer": "portbou-colera-llanca-port_de_la_selva.gpx",
                    "desc": "senderisme*Port de la Selva*portbou-colera-llanca-port_de_la_selva.gpx*2023-04-03*17.6 Km*04:50:47*05:10:43*727 m*624 m*0m*234m*"
                },
                {
                    "ruta": "ToDo-Camprodon - Port de la Selva /10-09-11",
                    "fitxer": "todo-camprodon-port-de-la-selva-10-09-11.gpx",
                    "desc": "BTT*Port de la Selva*camprodon-port-de-la-selva-10-09-11.gpx*2011-09-10*126.7 Km*04:55:26 *06:17:45*3374 m*2596 m*1m*1514m*vdvmB4n28NO"
                },
                {
                    "ruta": "ToDo-Camprodon - Port de la Selva /10-09-11",
                    "fitxer": "todo-camprodon-port-de-la-selva-10-09-11.gpx",
                    "desc": "BTT*Port de la Selva*camprodon-port-de-la-selva-10-09-11.gpx*2011-09-10*126.7 Km*04:55:26 *06:17:45*3374 m*2596 m*1m*1514m*vdvmB4n28NO"
                },
                {
                    "ruta": "Port de la Selva-Sant Pere de Rodes-Sant Onofre-Palau-Saverdera",
                    "fitxer": "port_de_la_selva-sant_pere_de_r-sant_onofre-palau_saverdera.gpx",
                    "desc": "BTT*Port de la Selva*port_de_la_selva-sant_pere_de_r-sant_onofre-palau_saverdera.gpx*2021-08-01*32.5 Km*02:20:07*02:20:07*960 m*842 m*2m*506m*"
                },
                {
                    "ruta": "Port de la Selva-Perafita-Cadaqu\xe9s-Roses",
                    "fitxer": "port_de_la_selva-perafita-cadaques-roses.gpx",
                    "desc": "BTT*Port de la Selva*port_de_la_selva-perafita-cadaques-roses.gpx*2024-08-22*52.1 Km*03:28:14*04:15:53*2088 m*1858 m*3m*335m*"
                },
                {
                    "ruta": "Port de la Selva-Sant Pere de Rodes-Puig d'Esquers-Colera",
                    "fitxer": "port_de_la_selva-sant_pere_de_rodes-puig_desquers-colera.gpx",
                    "desc": "BTT*Port de la Selva*port_de_la_selva-sant_pere_de_rodes-puig_desquers-colera.gpx*2023-08-26*38.4 Km*02:54:47*03:28:10*1940 m*1718 m*0m*588m*"
                },
                {
                    "ruta": "Port de la Selva-Selva de Mar-Mas Romanyac-Coll de Perafita-Cadaqu\xe9s-GR92",
                    "fitxer": "port_selva-selva_mar-mas_romanyac-perafita-cadaques-GR92.gpx",
                    "desc": "BTT*Port de la Selva*port_selva-selva_mar-mas_romanyac-perafita-cadaques-GR92.gpx*2020-08-29*33.6 Km*02:28:00 *02:55:44*1002 m*822 m*1m*349m*v26M25p4YEq"
                },
                {
                    "ruta": "Port de la Selva-Cala Taballera-Mas de Birba-GR92",
                    "fitxer": "port_selva-taballera-birba-gr92.gpx",
                    "desc": "BTT*Port de la Selva*port_selva-taballera-birba-gr92.gpx*2020-08-18*26.8 Km*02:15:12 *02:31:56*842 m*646 m*0m*257m*vRO7RoDdAyv"
                },
                {
                    "ruta": "Port de la Selva-3 d\xf2lmens de Taballera",
                    "fitxer": "port_selva-3_dolmens_taballera.gpx",
                    "desc": "BTT*Port de la Selva*port_selva-3_dolmens_taballera.gpx*2020-08-28*21.0 Km*01:45:52 *02:18:40*651 m*529 m*1m*316m*vYvrNeXGpLv"
                },
                {
                    "ruta": "Port de la Selva-Vall de la Santa Creu",
                    "fitxer": "port_selva-vall_sta_creu.gpx",
                    "desc": "BTT*Port de la Selva*port_selva-vall_sta_creu.gpx*2020-08-26*10.7 Km*00:44:04 *00:48:56*273 m*203 m*2m*177m*vmqXowZjeL6"
                },
                {
                    "ruta": "Port de la Selva-carretera de Roses a Coll de Perafita",
                    "fitxer": "port_selva-carretera_roses_perafita.gpx",
                    "desc": "BTT*Port de la Selva*port_selva-carretera_roses_perafita.gpx*2020-08-27*16.4 Km*01:38:08 *02:24:48*473 m*404 m*5m*334m*v36Ae2zyzG6"
                },
                {
                    "ruta": "Port de la Selva-Perafita-J\xf3ncols-Cadaqu\xe9s",
                    "fitxer": "port_de_la_selva-perafita-joncols-cadaques.gpx",
                    "desc": "BTT*Port de la Selva*port_de_la_selva-perafita-joncols-cadaques.gpx*2021-08-04*41.8 Km*04:03:24*04:48:20*1341 m*1159 m*2m*421m*"
                },
                {
                    "ruta": "Port de la Selva-Perafita-Cadaqu\xe9s-2",
                    "fitxer": "port_de_la_selva-perafita-cadaques-2.gpx",
                    "desc": "BTT*Port de la Selva*port_de_la_selva-perafita-cadaques-2.gpx*2026-08-27*29.4 Km*01:29:06*01:34:48*1010 m*664 m*7m*297m*"
                },
                {
                    "ruta": "Port de la Selva-Roses-d\xf2lmens-Perafita",
                    "fitxer": "port_de_la_selva-roses-dolmens-perafita.gpx",
                    "desc": "BTT*Port de la Selva*port_de_la_selva-roses-dolmens-perafita.gpx*2021-08-02*34.2 Km*02:45:23*02:48:55*1002 m*895 m*5m*447m*"
                }
            ]
        },
        {
            "zona": "Barcelona",
            "id": "barcelona",
            "rutes": [
                {
                    "ruta": "Serra de Galliners v1",
                    "fitxer": "serra_galliners-v1.gpx",
                    "desc": "BTT*Barcelona*serra_galliners-v1.gpx*2024-04-05*56.2 Km*05:21:09*07:06:55*1931 m*1778 m*152m*308m*"
                },
                {
                    "ruta": "Maria 16 anys",
                    "fitxer": "maria_16_anys.gpx",
                    "desc": "ciclisme*Barcelona*maria_16_anys.gpx*2021-11-14*24.9 Km*01:48:40*01:52:08*375 m*292 m*16m*76m*"
                },
                {
                    "ruta": "Manresa-Cam\xed Ral-Barcelona",
                    "fitxer": "manresa-cami_ral-barcelona.gpx",
                    "desc": "BTT*Barcelona*manresa-cami_ral-barcelona.gpx*2023-04-14*71.9 Km*05:06:04*06:04:08*2384 m*1759 m*75m*758m*"
                },
                {
                    "ruta": "Volta per Collserola 7",
                    "fitxer": "volta_per_collserola_7.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_7.gpx*2022-04-08*29.0 Km*02:12:52*02:17:28*1251 m*906 m*69m*482m*"
                },
                {
                    "ruta": "Terrassa-Barcelona",
                    "fitxer": "terrassa-barcelona.gpx",
                    "desc": "BTT*Barcelona*terrassa-barcelona.gpx*2024-06-14*31.6 Km*01:54:15*02:24:11*859 m*755 m*73m*435m*"
                },
                {
                    "ruta": "Volta per Collserola 16",
                    "fitxer": "volta_per_collserola_16.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_16.gpx*2026-03-01*29.7 Km*02:13:59*02:18:42*1197 m*1074 m*65m*435m*"
                },
                {
                    "ruta": "Volta per Collserola 3",
                    "fitxer": "volta_per_collserola_3.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_3.gpx*2021-02-11*28.4 Km*02:00:24*02:02:12*931 m*699 m*62m*396m*"
                },
                {
                    "ruta": "Entreno Collserola Oriental v2",
                    "fitxer": "entreno_collserola_oriental_v2.gpx",
                    "desc": "BTT*Barcelona*entreno_collserola_oriental_v2.gpx*2012-12-13*40.3 Km*02:27:03 *03:58:28*1918 m*1422 m*74m*352m*vXOd3mjr54v"
                },
                {
                    "ruta": "Integral Carretera de les Aig\xfces 2",
                    "fitxer": "integral_carretera_aigues_2.gpx",
                    "desc": "BTT*Barcelona*integral_carretera_aigues_2.gpx*2020-09-13*25.8 Km*01:27:28 *01:40:40*725 m*476 m*64m*393m*"
                },
                {
                    "ruta": "Baixador de Vallvidrera-Sitges",
                    "fitxer": "baixador_vallvidrera-sitges.gpx",
                    "desc": "BTT*Barcelona*granollers-baixador_vallvidrera-sitges.gpx*2021-01-31*53.2 Km*03:37:48*03:40:28*1585 m*1235 m*9m*464m*"
                },
                {
                    "ruta": "Volta per Collserola",
                    "fitxer": "volta_per_collserola_1.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_1.gpx*2020-11-22*30.7 Km*02:08:12 *02:27:24*1033 m*798 m*53m*434m*"
                },
                {
                    "ruta": "Volta per Collserola 10",
                    "fitxer": "volta_per_collserola_10.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_10.gpx*2022-06-12*42.5 Km*03:11:00*03:13:44*1025 m*797 m*11m*433m*"
                },
                {
                    "ruta": "Volta per Collserola 10",
                    "fitxer": "volta_per_collserola_10.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_10.gpx*2022-06-12*42.5 Km*03:11:00*03:13:44*1025 m*797 m*11m*433m*"
                },
                {
                    "ruta": "Santa Coloma-Montorn\xe8s-Mollet",
                    "fitxer": "santa_coloma-montornes-mollet.gpx",
                    "desc": "BTT*Barcelona*santa_coloma-montornes-mollet.gpx*2026-01-22*35.1 Km*02:28:20*02:44:58*1176 m*1034 m*29m*468m*"
                },
                {
                    "ruta": "Volta per Collserola 6",
                    "fitxer": "volta_per_collserola_6.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_6.gpx*2021-06-19*65.1 Km*04:32:04*04:47:08*2015 m*1577 m*58m*433m*"
                },
                {
                    "ruta": "Volta per Collserola 5-Single Track",
                    "fitxer": "volta_per_collserola_5-single_track.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_5-single_track.gpx*2021-05-24*28.4 Km*02:21:48*02:26:20*1059 m*789 m*77m*405m*"
                },
                {
                    "ruta": "Baixador de Vallvidrera-Papiol-La Floresta",
                    "fitxer": "baixador_vallvidrera-papiol-la_floresta.gpx",
                    "desc": "BTT*Barcelona*baixador_vallvidrera-papiol-la_floresta.gpx*2021-11-25*19.6 Km*01:34:48*01:36:40*894 m*660 m*72m*435m*"
                },
                {
                    "ruta": "Santa Coloma de Gramenet-Les Maleses",
                    "fitxer": "santa_coloma_gr-les_maleses.gpx",
                    "desc": "BTT*Barcelona*santa_coloma_gr-les_maleses.gpx*2023-04-21*24.0 Km*01:59:44*02:33:44*1111 m*916 m*38m*455m*"
                },
                {
                    "ruta": "Santa Coloma de Gramenet-Les Maleses",
                    "fitxer": "santa_coloma_gr-les_maleses.gpx",
                    "desc": "BTT*Barcelona*santa_coloma_gr-les_maleses.gpx*2023-04-21*24.0 Km*01:59:44*02:33:44*1111 m*916 m*38m*455m*"
                },
                {
                    "ruta": "Cornell\xe0-Gelida-Sant Esteve Sesrovires-Martorell-Cornell\xe0",
                    "fitxer": "cornella-gelida-sant_esteve_sesrovires-martorell-cornella.gpx",
                    "desc": "BTT*Barcelona*cornella-gelida-sant_esteve_sesrovires-martorell-cornella.gpx*2025-10-17*79.5 Km*05:07:26*07:02:55*2313 m*2023 m*3m*507m*"
                },
                {
                    "ruta": "Trialerada per Collserola",
                    "fitxer": "trialerada-per-collserola.gpx",
                    "desc": "BTT*Barcelona*trialerada-per-collserola.gpx*2013-02-07*22.0 Km*01:28:09 *01:56:59*812 m*623 m*129m*469m*v1vjpPwxeY6*3 trialeres de baixada bastant practicables (menys alguns passos de la primera)"
                },
                {
                    "ruta": "Vallcarca-Tibidabo-PiXandri-Sol-i-aire",
                    "fitxer": "vallcarca-tibidabo-pixandri-sol-i-aire.gpx",
                    "desc": "BTT*Barcelona*vallcarca-tibidabo-pixandri-sol-i-aire.gpx*2014-01-12*32.2 Km*00:00:20 *08:19:41*1148 m*989 m*115m*492m*vQvxVWKJw96"
                },
                {
                    "ruta": "Santa Coloma-El Masnou-Passeig Mar\xedtim",
                    "fitxer": "sta_coloma-masnou-pg_maritim.gpx",
                    "desc": "BTT*Barcelona*sta_coloma-masnou-pg_maritimgpx*2021-01-14*45.4 Km*03:02:40*03:26:00*1215 m*914 m*0m*429m*"
                },
                {
                    "ruta": "Cornell\xe0-Begues-Ratpenat-Castelldefels",
                    "fitxer": "cornella-begues-ratpenat-castelldefels.gpx",
                    "desc": "BTT*Barcelona*cornella-begues-ratpenat-castelldefels.gpx*2024-06-21*41.2 Km*02:44:25*02:58:10*1280 m*1090 m*2m*479m*"
                },
                {
                    "ruta": "Baixador Vallvidrera-Turons Can Pasqual-St Feliu-Passeig Aig\xfces",
                    "fitxer": "Baixador_Vallvidrera-Turons_Can_Pasqual-St_Feliu-Passeig_Aigues.gpx",
                    "desc": "BTT*Barcelona*Baixador_Vallvidrera-Turons_Can_Pasqual-St_Feliu-Passeig_Aigues.gpx*2020-12-27*28.7 Km*02:31:16*02:32:52*1510 m*1084 m*79m*463m*"
                },
                {
                    "ruta": "Integral Carretera de les Aig\xfces 1",
                    "fitxer": "integral_carretera_aigues_1.gpx",
                    "desc": "BTT*Barcelona*integral_carretera_aigues_1.gpx*2020-05-03*40.4 Km*23:44:58 *23:58:30*949 m*604 m*32m*434m*vRO7dx9QEK6"
                },
                {
                    "ruta": "Montju\xefc",
                    "fitxer": "montjuic.gpx",
                    "desc": "BTT*Barcelona*montjuic.gpx*2023-01-27*30.2 Km*02:20:44*02:37:52*926 m*702 m*16m*181m*"
                },
                {
                    "ruta": "Terrassa-Ullastrell-Martorell-Cornell\xe0",
                    "fitxer": "terrassa-ullastrell-martorell-cornella.gpx",
                    "desc": "BTT*Barcelona*terrassa-ullastrell-martorell-cornella.gpx*2022-01-09*49.9 Km*02:56:52*02:57:40*831 m*548 m*8m*392m*"
                },
                {
                    "ruta": "Volta per Collserola 15",
                    "fitxer": "volta_per_collserola_15.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_15.gpx*2024-09-05*10.7 Km*00:38:08*00:54:19*551 m*468 m*137m*397m*"
                },
                {
                    "ruta": "Vallen\xe7ana-Puig Castellar",
                    "fitxer": "vallencana-puig_castellar.gpx",
                    "desc": "senderisme*Barcelona*vallencana-puig_castellar.gpx*2022-01-23*5.4 Km*01:28:40*01:53:28*319 m*288 m*45m*278m*"
                },
                {
                    "ruta": "Integral Carretera de les Aig\xfces 3",
                    "fitxer": "integral_carretera_aigues_3.gpx",
                    "desc": "BTT*Barcelona*integral_carretera_aigues_3.gpx*2020-01-02*27.2 Km*01:46:17 *01:55:54*762 m*501 m*65m*392m*vPv4JZ38P36"
                },
                {
                    "ruta": "Baixador Vallvidrera-Delta Llobregat",
                    "fitxer": "baixador_vallvidrera_delta_llobregat.gpx",
                    "desc": "BTT*Barcelona*baixador_vallvidrera_delta_llobregat.gpx*2020-09-17*41.0 Km*02:13:52 *03:46:00*631 m*329 m*-1m*348m*vevWNLyMPyq"
                },
                {
                    "ruta": "ToDo-Volta per Collserola 5",
                    "fitxer": "todo-volta_per_collserola_5.gpx",
                    "desc": "BTT*Barcelona*todo-volta_per_collserola_5.gpx*2021-05-09*32.2 Km*00:00:20*08:19:41*1153 m*989 m*115m*492m*"
                },
                {
                    "ruta": "Cornell\xe0-Begues-Ratpenat-Castelldefels-Cornell\xe0",
                    "fitxer": "cornella-begues-ratpenat-castelldefels-cornella.gpx",
                    "desc": "BTT*Barcelona*cornella-begues-ratpenat-castelldefels-cornella.gpx*2025-05-16*63.6 Km*03:41:22*04:59:40*1501 m*1292 m*1m*479m*"
                },
                {
                    "ruta": "Volta per Collserola 5 Floresta Sant Just",
                    "fitxer": "volta_per_collserola_5_floresta_st_just.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_5_floresta_st_just.gpx*2021-06-09*23.2 Km*01:47:36*01:57:44*729 m*532 m*63m*423m*"
                },
                {
                    "ruta": "La Floresta-Papiol-St Bartomeu-Ol\xe8rdola-Baixador Vallvidrera",
                    "fitxer": "la_floresta-papiol-st_bartomeu-olerdola-baixador_vallvidrera.gpx",
                    "desc": "BTT*Barcelona*la_floresta-papiol-st_bartomeu-olerdola-baixador_vallvidrera.gpx*2021-01-07*28.5 Km*02:10:36*02:12:48*1389 m*1023 m*72m*369m*"
                },
                {
                    "ruta": "Volta per Collserola 4 corriols",
                    "fitxer": "volta_per_collserola_4-corriols.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_4-corriols.gpx*2021-03-26*33.9 Km*03:24:59*03:46:41*1344 m*1014 m*61 m*347 m*"
                },
                {
                    "ruta": "Caldes de Montbui-Barcelona",
                    "fitxer": "caldes_de_montbui-barcelona.gpx",
                    "desc": "BTT*Barcelona*caldes_de_montbui-barcelona.gpx*2022-10-09*29.9 Km*01:38:28*01:46:56*204 m*112 m*10m*240m*"
                },
                {
                    "ruta": "Volta per Collserola-3 cims",
                    "fitxer": "volta_per_collserola-3_cims.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola-3_cims.gpx*2022-02-10*60.5 Km*04:22:32*05:28:34*2742 m*1924 m*69m*448m*"
                },
                {
                    "ruta": "Volta per Collserola-3 cims",
                    "fitxer": "volta_per_collserola-3_cims.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola-3_cims.gpx*2022-02-10*60.5 Km*04:22:32*05:28:34*2742 m*1924 m*69m*448m*"
                },
                {
                    "ruta": "Cornell\xe0-delta del Llobregat",
                    "fitxer": "cornella-delta_del_llobregat.gpx",
                    "desc": "BTT*Barcelona*cornella-delta_del_llobregat.gpx*2023-01-08*26.2 Km*01:46:04*02:08:28*267 m*184 m*4m*38m*"
                },
                {
                    "ruta": "Volta per Collserola 14",
                    "fitxer": "volta_per_collserola_14.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_14.gpx*2024-04-23*35.9 Km*02:32:13*02:41:21*1599 m*1390 m*68m*465m*"
                },
                {
                    "ruta": "Poblat Ib\xe8ric Puig Castellar",
                    "fitxer": "poblat-iberic-puig-castellar.gpx",
                    "desc": "BTT*Barcelona*poblat-iberic-puig-castellar.gpx*2011-01-11*7.9 Km*00:52:08 *00:52:08*339 m*304 m*44m*263m*v36ArVAXKZq"
                },
                {
                    "ruta": "Corriols de la Vall de Sant Just",
                    "fitxer": "corriolada_per_sant_just_desvern.gpx",
                    "desc": "BTT*Barcelona*corriolada_per_sant_just_desvern.gpx*2013-04-11*19.0 Km*01:14:04 *01:41:35*1059 m*600 m*164m*350m*vLqeN9EYdRv"
                },
                {
                    "ruta": "Sant Sadurn\xed d'Anoia-Barcelona",
                    "fitxer": "sant_sadurni_danoia-barcelona.gpx",
                    "desc": "BTT*Barcelona*sant_sadurni_danoia-barcelona.gpx*2022-03-31*48.5 Km*03:06:28*03:45:32*1343 m*1025 m*20m*464m*"
                },
                {
                    "ruta": "Volta per Collserola 7-BCN-St Cugat",
                    "fitxer": "volta_per_collserola_7-bcn-st_cugat.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_7-bcn-st_cugat.gpx*2021-12-23*29.7 Km*01:59:32*02:02:06*1036 m*764 m*75m*433m*"
                },
                {
                    "ruta": "Volta per Collserola 7-BCN-St Cugat",
                    "fitxer": "volta_per_collserola_7-bcn-st_cugat.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_7-bcn-st_cugat.gpx*2021-12-23*29.7 Km*01:59:32*02:02:06*1036 m*764 m*75m*433m*"
                },
                {
                    "ruta": "Volta per Collserola 4-corriols v2",
                    "fitxer": "volta_per_collserola_4-corriols-v2.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_4-corriols-v2.gpx*2021-05-16*27.8 Km*02:22:36*02:58:24*1025 m*774 m*61m*348m*"
                },
                {
                    "ruta": "Premi\xe0-Barcelona",
                    "fitxer": "premia-barcelona.gpx",
                    "desc": "ciclisme*Barcelona*premia-barcelona.gpx*2024-09-20*26.3 Km*01:26:44*02:04:33*306 m*233 m*0m*28m*"
                },
                {
                    "ruta": "Montju\xefc 360",
                    "fitxer": "montju\xefc_360.gpx",
                    "desc": "BTT*Barcelona*montju\xefc_360.gpx*2023-10-20*11.0 Km*00:56:26*01:17:59*457 m*407 m*15m*181m*"
                },
                {
                    "ruta": "Volta per Collserola 6-Can Pascual-La Floresta-Les Planes",
                    "fitxer": "volta_per_collserola_6-can_pascual-floresta-planes.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_6-can_pascual-floresta-planes.gpx*2021-06-07*38.7 Km*02:49:27*02:51:23*1361 m*1049 m*63m*506m*"
                },
                {
                    "ruta": "Volta per Collserola 2",
                    "fitxer": "volta_per_collserola_2.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_2.gpx*2020-12-13*37.9 Km*02:22:00 *02:49:12*1146 m*817 m*92m*434m*"
                },
                {
                    "ruta": "Volta per Collserola 13",
                    "fitxer": "volta_per_collserola_13.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_13.gpx*2024-03-08*19.6 Km*01:43:13*01:44:42*958 m*881 m*104m*369m*"
                },
                {
                    "ruta": "Sitges-Barcelona",
                    "fitxer": "sitges-barcelona.gpx",
                    "desc": "BTT*Barcelona*sitges-barcelona.gpx*2021-07-20*52.0 Km*03:39:04*03:39:44*1435 m*1167 m*6m*464m*"
                },
                {
                    "ruta": "Barcelona-Arrabassada-Sant Cugat-Cerdanyola-Barcelona",
                    "fitxer": "barcelona-arrabassada-st_cugat-cerdanyola-barcelona.gpx",
                    "desc": "ciclisme*Barcelona*barcelona-arrabassada-st_cugat-cerdanyola-barcelona.gpx*2023-05-21*38.0 Km*01:50:52*01:52:28*1119 m*818 m*54m*432m*"
                },
                {
                    "ruta": "Barcelona-Arrabassada-Sant Cugat-Cerdanyola-Barcelona",
                    "fitxer": "barcelona-arrabassada-st_cugat-cerdanyola-barcelona.gpx",
                    "desc": "ciclisme*Barcelona*barcelona-arrabassada-st_cugat-cerdanyola-barcelona.gpx*2023-05-21*38.0 Km*01:50:52*01:52:28*1119 m*818 m*54m*432m*"
                },
                {
                    "ruta": "Barcelona-Arrabassada-Sant Cugat-Cerdanyola-Barcelona",
                    "fitxer": "barcelona-arrabassada-st_cugat-cerdanyola-barcelona.gpx",
                    "desc": "ciclisme*Barcelona*barcelona-arrabassada-st_cugat-cerdanyola-barcelona.gpx*2023-05-21*38.0 Km*01:50:52*01:52:28*1119 m*818 m*54m*432m*"
                },
                {
                    "ruta": "Volta per Collserola 12",
                    "fitxer": "volta_per_collserola_12.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_12.gpx*2024-03-20*21.6 Km*01:34:43*01:41:44*987 m*886 m*74m*434m*"
                },
                {
                    "ruta": "Cornell\xe0-Martorell",
                    "fitxer": "cornella-martorell.gpx",
                    "desc": "BTT*Barcelona*cornella-martorell.gpx*2023-06-16*46.6 Km*02:40:34*03:53:08*519 m*378 m*8m*62m*"
                },
                {
                    "ruta": "Volta per Collserola 8-Pujada de Can Borni",
                    "fitxer": "volta_per_collserola_8-pujada_can_borni.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_8-pujada_can_borni.gpx*2022-05-13*22.4 Km*02:02:52*02:04:04*982 m*762 m*76m*432m*"
                },
                {
                    "ruta": "Volta per Collserola 9",
                    "fitxer": "volta_per_collserola_9.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_9.gpx*2022-05-31*33.1 Km*02:31:00*03:20:12*1240 m*980 m*34m*492m*"
                },
                {
                    "ruta": "Cornell\xe0-delta del Llobregat-Castelldefels",
                    "fitxer": "cornella-delta_llobregat-castelldefels.gpx",
                    "desc": "BTT*Barcelona*cornella-delta_llobregat-castelldefels.gpx*2026-03-13*46.0 Km*02:06:55*02:32:47*385 m*273 m*1m*38m*"
                },
                {
                    "ruta": "Mercabarna-Delta del Llobregat",
                    "fitxer": "mercabarna-delta_llobregat.gpx",
                    "desc": "BTT*Barcelona*mercabarna-delta_llobregat.gpx*2020-12-30*19.3 Km*01:48:24*01:52:04*121 m*93 m*0m*10m*"
                },
                {
                    "ruta": "Serra de Galliners-Part 1",
                    "fitxer": "serra_galliners_part_1.gpx",
                    "desc": "BTT*Barcelona*serra_galliners_part_1.gpx*2024-05-03*34.5 Km*03:01:15*03:26:00*1224 m*1080 m*169m*308m*"
                },
                {
                    "ruta": "Carretera de la Roca",
                    "fitxer": "carretera_de_la_roca.gpx",
                    "desc": "ciclisme*Barcelona*carretera_de_la_roca.gpx*2022-04-28*46.3 Km*02:08:08*02:08:24*563 m*332 m*0m*179m*"
                },
                {
                    "ruta": "Gelida-Sant Vicen\xe7 dels Horts",
                    "fitxer": "gelida-sant_vicenc_dels_horts.gpx",
                    "desc": "BTT*Barcelona*gelida-sant_vicenc_dels_horts.gpx*2021-10-16*33.4 Km*02:33:04*02:55:40*1092 m*867 m*28m*499m"
                },
                {
                    "ruta": "Santa Coloma Gr-Vallen\xe7ana-Badalona-Vilanova-Alella-Montgat",
                    "fitxer": "sta_coloma_gr-vallencana-badalona-vilanova-alella-montgat.gpx",
                    "desc": "ciclisme*Barcelona*sta_coloma_gr-vallencana-badalona-vilanova-alella-montgat.gpx*2025-11-21*57.7 Km*02:50:51*03:41:23*1522 m*1324 m*8m*320m*"
                },
                {
                    "ruta": "Mollet-Santa Coloma",
                    "fitxer": "mollet-santa_coloma.gpx",
                    "desc": "BTT*Barcelona*mollet-santa_coloma.gpx*2024-10-04*25.7 Km*01:59:57*03:28:06*1008 m*930 m*28m*468m*"
                },
                {
                    "ruta": "Granollers-Sta Coloma de Gr",
                    "fitxer": "granollers-sta_coloma_gr.gpx",
                    "desc": "BTT*Barcelona*granollers-sta_coloma_gr.gpx*2021-02-16*46.0 Km*03:13:32*03:21:04*1326 m*1045 m*12m*485m*"
                },
                {
                    "ruta": "Montmel\xf3-Barcelona",
                    "fitxer": "montmelo-barcelona.gpx",
                    "desc": "ciclisme*Barcelona*montmelo-barcelona.gpx*2025-12-12*18.7 Km*00:53:48*00:57:33*165 m*104 m*10m*75m*"
                },
                {
                    "ruta": "Volta per Collserola 11",
                    "fitxer": "volta_per_collserola_11.gpx",
                    "desc": "BTT*Barcelona*volta_per_collserola_11.gpx*2022-09-02*27.3 Km*02:21:36*02:35:32*1268 m*902 m*74m*433m*"
                },
                {
                    "ruta": "Gallecs-Palau-Solit\xe0-Poliny\xe0-Santiga-riu Ripoll",
                    "fitxer": "gallecs-palau-solita-polinya-santiga-ripoll.gpx",
                    "desc": "BTT*Barcelona*gallecs-palau-solita-polinya-santiga-ripoll.gpx*2022-01-29*57.0 Km*03:19:04*03:30:16*978 m*751 m*18m*246m*"
                },
                {
                    "ruta": "Gallecs-Palau-Solit\xe0-Poliny\xe0-Santiga-riu Ripoll",
                    "fitxer": "gallecs-palau-solita-polinya-santiga-ripoll.gpx",
                    "desc": "BTT*Barcelona*gallecs-palau-solita-polinya-santiga-ripoll.gpx*2022-01-29*57.0 Km*03:19:04*03:30:16*978 m*751 m*18m*246m*"
                },
                {
                    "ruta": "Volta per Collserola-4 ermites",
                    "fitxer": "volta_collserola_4_ermites.gpx",
                    "desc": "BTT*Barcelona*volta_collserola_4_ermites.gpx*2021-03-12*47.0 Km*03:21:52*03:29:36*1338 m*1027 m*25m*430m*"
                },
                {
                    "ruta": "Sant Cugat del Vall\xe8s-Ullastrell-el Papiol",
                    "fitxer": "sant_cugat-ullastrell-el_papiol.gpx",
                    "desc": "BTT*Barcelona*sant_cugat-ullastrell-el_papiol.gpx*2026-02-06*45.3 Km*03:27:47*04:43:02*1361 m*1233 m*52m*326m*"
                },
                {
                    "ruta": "Serra de Galliners-Part 2",
                    "fitxer": "serra_galliners_part_2.gpx",
                    "desc": "BTT*Barcelona*serra_galliners_part_2.gpx*2024-05-24*38.9 Km*03:08:16*03:34:53*1267 m*1155 m*150m*297m*"
                }
            ]
        },
        {
            "zona": "Granada-Val\xe8ncia",
            "id": "granada-valencia",
            "rutes": [
                {
                    "ruta": "Granada-Val\xe8ncia-1",
                    "fitxer": "granada-valencia-1.gpx",
                    "desc": "BTT*Granada-Val\xe8ncia*granada-valencia-1.gpx*2026-07-13*72.6 Km*05:30:44*06:30:55*2445 m*2145 m*669m*1583m*"
                },
                {
                    "ruta": "Granada-Val\xe8ncia-1",
                    "fitxer": "granada-valencia-1.gpx",
                    "desc": "BTT*Granada-Val\xe8ncia*granada-valencia-1.gpx*2026-07-13*72.6 Km*05:30:44*06:30:55*2445 m*2145 m*669m*1583m*"
                },
                {
                    "ruta": "Granada-Val\xe8ncia-7",
                    "fitxer": "granada-valencia-7.gpx",
                    "desc": "BTT*Granada-Val\xe8ncia*granada-valencia-7.gpx*2026-07-19*93.9 Km*06:35:29*11:31:47*791 m*602 m*0m*137m*"
                },
                {
                    "ruta": "Granada-Val\xe8ncia-6",
                    "fitxer": "granada-valencia-6.gpx",
                    "desc": "BTT*Granada-Val\xe8ncia*granada-valencia-6.gpx*2026-07-18*103.8 Km*06:12:59*07:39:03*1282 m*1068 m*117m*713m*"
                },
                {
                    "ruta": "Granada-Val\xe8ncia-3",
                    "fitxer": "granada-valencia-3.gpx",
                    "desc": "BTT*Granada-Val\xe8ncia*granada-valencia-3.gpx*2026-07-15*108.4 Km*06:15:01*07:58:02*1359 m*1212 m*675m*1212m*"
                },
                {
                    "ruta": "Granada-Val\xe8ncia-4",
                    "fitxer": "granada-valencia-4.gpx",
                    "desc": "BTT*Granada-Val\xe8ncia*granada-valencia-4.gpx*2026-07-16*54.1 Km*03:34:17*04:42:33*964 m*884 m*346m*1063m*"
                },
                {
                    "ruta": "Granada-Val\xe8ncia-4",
                    "fitxer": "granada-valencia-4.gpx",
                    "desc": "BTT*Granada-Val\xe8ncia*granada-valencia-4.gpx*2026-07-16*54.1 Km*03:34:17*04:42:33*964 m*884 m*346m*1063m*"
                },
                {
                    "ruta": "Granada-Val\xe8ncia-5",
                    "fitxer": "granada-valencia-5.gpx",
                    "desc": "BTT*Granada-Val\xe8ncia*granada-valencia-5.gpx*2026-07-17*101.7 Km*06:16:18*09:20:52*1394 m*1275 m*217m*737m*"
                },
                {
                    "ruta": "Granada-Val\xe8ncia-2",
                    "fitxer": "granada-valencia-2.gpx",
                    "desc": "BTT*Granada-Val\xe8ncia*granada-valencia-2.gpx*2026-07-14*73.9 Km*04:38:45*05:44:57*1123 m*1027 m*645m*1483m*"
                }
            ]
        },
        {
            "zona": "Monta\xf1as Vac\xedas",
            "id": "montanas_vacias",
            "rutes": [
                {
                    "ruta": "MV2-Villahermosa del R\xedo-Cabra de Mora",
                    "fitxer": "MV2-villahermosa_del_rio-cabra_de_mora.gpx",
                    "desc": "BTT*Monta\xf1as Vac\xedas*MV2-villahermosa_del_rio-cabra_de_mora.gpx*2022-07-10*77.4 Km*08:29:31*11:30:41*2708 m*2327 m*874m*2016m*"
                },
                {
                    "ruta": "MV8-Barracas-Sagunt",
                    "fitxer": "MV8-barracas-sagunt.gpx",
                    "desc": "BTT*Monta\xf1as Vac\xedas*MV8-barracas-sagunt.gpx*2022-07-16*81.6 Km*04:38:24*05:57:00*1290 m*509 m*40m*987m*"
                },
                {
                    "ruta": "MV7-Torrebaja-Javalambre-Puebla de Valverde-Barracas",
                    "fitxer": "MV7-torrebaja-javalambre-puebla_de_valverde-barracas.gpx",
                    "desc": "BTT*Monta\xf1as Vac\xedas*MV7-torrebaja-javalambre-puebla_de_valverde-barracas.gpx*2022-07-15*108.1 Km*09:31:36*13:09:25*2924 m*2274 m*727m*2017m*"
                },
                {
                    "ruta": "MV6-Zafrilla-Torrebaja",
                    "fitxer": "MV6-zafrilla-torrebaja.gpx",
                    "desc": "BTT*Monta\xf1as Vac\xedas*MV6-zafrilla-torrebaja.gpx*2022-07-14*57.8 Km*04:35:16*05:33:08*1141 m*889 m*745m*1496m*"
                },
                {
                    "ruta": "MV4-Bezas-Griegos",
                    "fitxer": "MV4-bezas-griegos.gpx",
                    "desc": "BTT*Monta\xf1as Vac\xedas*MV4-bezas-griegos.gpx*2022-07-12*82.5 Km*08:15:11*11:20:02*2303 m*2081 m*1118m*1779m*"
                },
                {
                    "ruta": "MV1-Castell\xf3-Villahermosa del R\xedo",
                    "fitxer": "MV1-castello-villahermosa_del_rio.gpx",
                    "desc": "BTT*Monta\xf1as Vac\xedas*MV1-castello-villahermosa_del_rio.gpx*2022-07-09*61.1 Km*05:17:16*06:43:36*1965 m*1531 m*27m*988m*"
                },
                {
                    "ruta": "MV1-Castell\xf3-Villahermosa del R\xedo",
                    "fitxer": "MV1-castello-villahermosa_del_rio.gpx",
                    "desc": "BTT*Monta\xf1as Vac\xedas*MV1-castello-villahermosa_del_rio.gpx*2022-07-09*61.1 Km*05:17:16*06:43:36*1965 m*1531 m*27m*988m*"
                },
                {
                    "ruta": "MV3-Cabra de Mora-Bezas",
                    "fitxer": "MV3-cabra_de_mora-bezas.gpx",
                    "desc": "BTT*Monta\xf1as Vac\xedas*MV3-cabra_de_mora-bezas.gpx*2022-07-11*75.1 Km*09:07:16*12:23:49*1829 m*1552 m*875m*1506m*"
                },
                {
                    "ruta": "MV5-Griegos-Zafrilla",
                    "fitxer": "MV5-griegos-zafrilla.gpx",
                    "desc": "BTT*Monta\xf1as Vac\xedas*MV5-griegos-zafrilla.gpx*2022-07-13*89.6 Km*06:11:08*12:05:10*1916 m*1526 m*1103m*1659m*"
                }
            ]
        },
        {
            "zona": "The Grand Escape",
            "id": "the_grand_escape",
            "rutes": [
                {
                    "ruta": "TGEGA-5-Oberammergau-Wangen",
                    "fitxer": "TGEGA-5-oberammergau-wangen.gpx",
                    "desc": "ciclisme*The Grand Escape*TGEGA-5-oberammergau-wangen.gpx*2025-07-31*136.4 Km*08:07:41*11:55:17*1400 m*1306 m*579m*1005m*"
                },
                {
                    "ruta": "TGEGA-5-Oberammergau-Wangen",
                    "fitxer": "TGEGA-5-oberammergau-wangen.gpx",
                    "desc": "ciclisme*The Grand Escape*TGEGA-5-oberammergau-wangen.gpx*2025-07-31*136.4 Km*08:07:41*11:55:17*1400 m*1306 m*579m*1005m*"
                },
                {
                    "ruta": "TGEGA-2-Ammersee-Munich-Tegernsee",
                    "fitxer": "TGEGA-2-ammersee-munich-tegernsee.gpx",
                    "desc": "ciclisme*The Grand Escape*TGEGA-2-ammersee-munich-tegernsee.gpx*2025-07-28*129.6 Km*07:32:16*11:47:49*1540 m*1322 m*515m*792m*"
                },
                {
                    "ruta": "TGEGA-3-Tegernsee-Innsbruck",
                    "fitxer": "TGEGA-3-tegernsee-innsbruck.gpx",
                    "desc": "ciclisme*The Grand Escape*TGEGA-3-tegernsee-innsbruck.gpx*2025-07-29*95.0 Km*06:08:07*09:58:41*859 m*766 m*551m*975m*"
                },
                {
                    "ruta": "TGEGA-1-Wangen im Allg\xe4u-Ammersee",
                    "fitxer": "TGEGA-1-wangen_im_allgau-ammersee.gpx",
                    "desc": "ciclisme*The Grand Escape*TGEGA-1-wangen_im_allgau-ammersee.gpx*2025-07-27*129.3 Km*07:18:09*10:57:01*1438 m*1367 m*559m*885m*"
                },
                {
                    "ruta": "TGEGA-4-Innsbruck-Mittenwald-Garmisch-Oberammergau",
                    "fitxer": "TGEGA-4-innsbruck-mittenwald-garmisch-oberammergau.gpx",
                    "desc": "ciclisme*The Grand Escape*TGEGA-4-innsbruck-mittenwald-garmisch-oberammergau.gpx*2025-07-30*92.9 Km*06:52:45*10:41:17*1239 m*1169 m*570m*1227m*"
                }
            ]
        }
    ];
    //Algorisme d'ordenació alfabètica
    var rutes_nou = [];
    for(var i = 0; i < rutes.length; i++){
        var obj = rutes[i];
        var obj_rutes = obj.rutes;
        obj_rutes.sort(function(a, b) {
            //if(a.ruta < b.ruta) { return -1; }
            //if(a.ruta > b.ruta) { return 1; }
            //return 0;
            //bona comparació amb accents
            return a.ruta.localeCompare(b.ruta);
        });
        rutes_nou.push(obj);
    }
    rutes_nou.sort(function(a, b) {
        //if(a.zona < b.zona) { return -1; }
        //if(a.zona > b.zona) { return 1; }
        //return 0;
        //bona comparació amb accents
        return a.zona.localeCompare(b.zona);
    });
    return rutes_nou;
}
var $330732299c8bab21$export$2e2bcd8739ae039 = $330732299c8bab21$var$llista_rutes;


var $3ed210d2c36fb1ec$var$container = document.getElementById('tooltip');
var $3ed210d2c36fb1ec$var$content = document.getElementById('tooltip-content');
var $3ed210d2c36fb1ec$var$overlay = new (0, $c80d3ed2a84f41ed$export$2e2bcd8739ae039)({
    element: $3ed210d2c36fb1ec$var$container,
    autoPan: true,
    autoPanAnimation: {
        duration: 250
    }
});
var $3ed210d2c36fb1ec$var$body = document.getElementsByTagName("body")[0];
$3ed210d2c36fb1ec$var$body.addEventListener("load", $3ed210d2c36fb1ec$var$init(), false);
var $3ed210d2c36fb1ec$var$map;
var $3ed210d2c36fb1ec$var$layers;
var $3ed210d2c36fb1ec$var$vector;
/*
// ja no cal, no és necessari
var currZoom;
var currCenter;
*/ // var modalitats_actives = [];
var $3ed210d2c36fb1ec$var$todo_checked = true;
function $3ed210d2c36fb1ec$var$init() {
    //router
    //https://www.section.io/engineering-education/how-to-build-a-simple-router-in-javascript/
    let url = window.location;
    //console.log(url);
    let ruta_hash = url.href.replaceAll(url.origin + '/#', '');
    //console.log(ruta_hash);
    $3ed210d2c36fb1ec$var$carregar_rasters();
    $3ed210d2c36fb1ec$var$carregar_modalitats();
    $3ed210d2c36fb1ec$var$carregar_modalitat_i_rutes(); //omple la matriu modalitats_actives
    var modalitats_actives = [
        'btt',
        'senderisme',
        'ciclisme'
    ];
    //if (ruta_hash != "") console.log(ruta_hash)
    $3ed210d2c36fb1ec$var$carregar_ruta_inicial(ruta_hash);
    document.getElementById("url").addEventListener("click", function() {
        $3ed210d2c36fb1ec$var$copiar_url_link();
    }, false);
    document.getElementById("perfil").addEventListener("click", function() {
        $3ed210d2c36fb1ec$var$mostrar_perfil();
    }, false);
    document.getElementById("0_OSM").addEventListener("click", function() {
        $3ed210d2c36fb1ec$var$canviar_render("0_OSM");
    }, false);
    document.getElementById("1_ORTO").addEventListener("click", function() {
        $3ed210d2c36fb1ec$var$canviar_render("1_ORTO");
    }, false);
    document.getElementById("2_TOPOTRESC").addEventListener("click", function() {
        $3ed210d2c36fb1ec$var$canviar_render("2_TOPOTRESC");
    }, false);
    document.getElementById("3_ICGC").addEventListener("click", function() {
        $3ed210d2c36fb1ec$var$canviar_render("3_ICGC");
    }, false);
    document.getElementById("search-input").addEventListener("change", function() {
        $3ed210d2c36fb1ec$var$cercar_ruta(this.value);
    }, false);
    document.getElementById("search-input").addEventListener("click", function() {
        $3ed210d2c36fb1ec$var$netejar_cercar_ruta();
    }, false);
//cercar_ruta("pobla"); //provisional
}
function $3ed210d2c36fb1ec$var$carregar_rasters() {
    var raster_OSM = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
        source: new (0, $6c8498cc816f2362$export$2e2bcd8739ae039)()
    });
    var raster_TOPOTRESC = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
        source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
            url: 'https://api.topotresc.com/tiles/{z}/{x}/{y}',
            attributions: 'Map data <a href="https://www.topotresc.com/" target="_blank">TopoTresk</a> by <a href="https://github.com/aresta/topotresc" target="_blank">aresta</a>'
        })
    });
    //https://openicgc.github.io/
    //ortofoto: https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/orto/GRID3857/{z}/{x}/{y}.jpeg
    //topogràfic clàssic: https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/topo/GRID3857/{z}/{x}/{y}.jpeg
    //hi ha més possibilitats
    var raster_ORTO = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
        source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
            url: 'https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/orto/GRID3857/{z}/{x}/{y}.png',
            attributions: "Institut Cartogr\xe0fic i Geol\xf2gic de Catalunya -ICGC"
        })
    });
    var raster_ICGC = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
        source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
            url: 'https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/topo/GRID3857/{z}/{x}/{y}.png',
            attributions: "Institut Cartogr\xe0fic i Geol\xf2gic de Catalunya -ICGC"
        })
    });
    $3ed210d2c36fb1ec$var$layers = [
        raster_OSM,
        raster_ORTO,
        raster_TOPOTRESC,
        raster_ICGC
    ];
}
function $3ed210d2c36fb1ec$var$carregar_modalitats() {
    let modalitats_arr = (0, $500a9350cc2f0c6d$export$2e2bcd8739ae039)();
    let modalitats_div = document.getElementById("modalitats");
    let str = "";
    for(let i = 0; i < modalitats_arr.length; i++){
        var lbl = document.createElement("label");
        var br = document.createElement("BR");
        lbl.setAttribute("value", modalitats_arr[i].value);
        lbl.innerText = modalitats_arr[i].modalitat;
        var x = document.createElement("INPUT");
        x.setAttribute("type", "checkbox");
        x.setAttribute("value", modalitats_arr[i].value);
        x.setAttribute("id", modalitats_arr[i].id);
        x.setAttribute("checked", true);
        modalitats_div.appendChild(document.createTextNode('\u00A0'));
        modalitats_div.appendChild(document.createTextNode('\u00A0'));
        modalitats_div.appendChild(document.createTextNode('\u00A0'));
        modalitats_div.appendChild(x);
        modalitats_div.appendChild(document.createTextNode('\u00A0'));
        modalitats_div.appendChild(document.createTextNode('\u00A0'));
        modalitats_div.appendChild(lbl);
        modalitats_div.appendChild(br);
        x.addEventListener("change", function() {
            $3ed210d2c36fb1ec$var$carregar_modalitat_i_rutes();
        }, false);
    }
    var hr = document.createElement("HR");
    modalitats_div.appendChild(hr);
    //crear label ToDo
    var lbl = document.createElement("label");
    var br = document.createElement("BR");
    lbl.setAttribute("value", "ToDo");
    lbl.innerText = "ToDo";
    var x = document.createElement("INPUT");
    x.setAttribute("type", "checkbox");
    x.setAttribute("value", "true");
    x.setAttribute("id", "ToDo");
    x.setAttribute("checked", true);
    modalitats_div.appendChild(document.createTextNode('\u00A0'));
    modalitats_div.appendChild(document.createTextNode('\u00A0'));
    modalitats_div.appendChild(document.createTextNode('\u00A0'));
    modalitats_div.appendChild(x);
    modalitats_div.appendChild(document.createTextNode('\u00A0'));
    modalitats_div.appendChild(document.createTextNode('\u00A0'));
    modalitats_div.appendChild(lbl);
    modalitats_div.appendChild(br);
    x.addEventListener("change", function() {
        $3ed210d2c36fb1ec$var$carregar_modalitat_i_rutes();
    }, false);
    var hr = document.createElement("HR");
    modalitats_div.appendChild(hr);
}
function $3ed210d2c36fb1ec$var$carregar_modalitat_i_rutes() {
    //while (modalitats_actives.length) { modalitats_actives.pop(); } //també modalitats_actives = []
    let modalitats_actives = [];
    let modalitats_div = document.getElementById("modalitats");
    let inputs = modalitats_div.getElementsByTagName("INPUT");
    for(let i = 0; i < inputs.length; i++)if (inputs[i].checked == true) modalitats_actives.push(inputs[i].value);
    $3ed210d2c36fb1ec$var$todo_checked = document.getElementById("ToDo").checked;
    $3ed210d2c36fb1ec$var$carregar_rutes();
}
function $3ed210d2c36fb1ec$var$carregar_rutes() {
    let rutes_arr = (0, $330732299c8bab21$export$2e2bcd8739ae039)();
    let rutes_ul = document.getElementById("rutes");
    //console.log(modalitats_actives);
    //primer, eliminem totes les rutes
    while(rutes_ul.firstChild)rutes_ul.removeChild(rutes_ul.lastChild);
    for(let i = 0; i < rutes_arr.length; i++){
        var ele_li = document.createElement("LI");
        ele_li.setAttribute("class", "mb-1");
        var ele_bt = document.createElement("BUTTON");
        ele_bt.setAttribute("class", "btn d-inline-flex align-items-center rounded collapsed");
        ele_bt.setAttribute("data-bs-toggle", "collapse");
        ele_bt.setAttribute("data-bs-target", "#" + rutes_arr[i].id + "-collapse");
        ele_bt.setAttribute("aria-expanded", "false");
        ele_bt.innerText = rutes_arr[i].zona;
        ele_li.appendChild(ele_bt);
        var ele_div = document.createElement("DIV");
        ele_div.setAttribute("class", "collapse");
        ele_div.setAttribute("id", rutes_arr[i].id + "-collapse");
        for(let j = 0; j < rutes_arr[i].rutes.length; j++){
            //ToDo: quan està marcat es mostren els ToDo (si està desmarcat, es mostren només les rutes que he fet)
            //canvi que he fet 20/02/2025
            var modalitats_actives = [
                'btt',
                'senderisme',
                'ciclisme'
            ];
            if ($3ed210d2c36fb1ec$var$todo_checked || rutes_arr[i].rutes[j].ruta.indexOf("ToDo") == -1) //només he de mostrar les modalitats seleccionades
            {
                if (modalitats_actives.includes(rutes_arr[i].rutes[j].desc.split("*")[0].toLowerCase())) {
                    var ele_ul = document.createElement("UL");
                    ele_ul.setAttribute("class", "list-unstyled fw-normal pb-1 small");
                    var ele_li2 = document.createElement("LI");
                    //ele_li2.innerHTML = "<a href=\"./rutesgps/" + rutes_arr[i].rutes[j].fitxer + "\" class=\"d-inline-flex align-items-center rounded\">" + rutes_arr[i].rutes[j].ruta  + "</a>";
                    ele_li2.innerHTML = "<a href=\"#\" class=\"d-inline-flex align-items-center rounded\">" + rutes_arr[i].rutes[j].ruta + "</a>";
                    //ele_li2.addEventListener("click", function () { return confirm(rutes_arr[i].rutes[j].fitxer); }, false);
                    ele_li2.addEventListener("click", function() {
                        $3ed210d2c36fb1ec$var$carregar_ruta(rutes_arr[i].rutes[j].ruta, rutes_arr[i].rutes[j].fitxer, rutes_arr[i].rutes[j].desc);
                    }, false);
                    ele_ul.appendChild(ele_li2);
                    ele_div.appendChild(ele_ul);
                }
            }
        }
        ele_li.appendChild(ele_div);
        rutes_ul.appendChild(ele_li);
    }
    //hem d'eliminar les zones que no tenen rutes
    for(let i = rutes_ul.childNodes.length - 1; i >= 0; i--)if (rutes_ul.childNodes[i].getElementsByTagName("LI").length == 0) rutes_ul.removeChild(rutes_ul.childNodes[i]);
}
function $3ed210d2c36fb1ec$var$carregar_ruta(ruta, fitxer, desc) {
    //console.log(ruta);
    let titol_ruta = document.getElementById("titol_ruta");
    let desc_ruta = document.getElementById("desc_ruta");
    var desc_ruta_arr = desc.split('*');
    var str_img = "<img src='./img/" + desc_ruta_arr[0].toLowerCase() + "_64.png'>&nbsp;";
    //console.log(str_img)
    titol_ruta.innerHTML = str_img + ruta;
    var str = "";
    str = $3ed210d2c36fb1ec$var$changeDateFormat(desc_ruta_arr[3]);
    str = str + " - " + desc_ruta_arr[4] + " - " + desc_ruta_arr[5] + " h" + " - " + desc_ruta_arr[8] + " - (" + desc_ruta_arr[9] + " " + "&rarr;" + " " + desc_ruta_arr[10] + ")";
    desc_ruta.innerHTML = str;
    var relieve = desc_ruta_arr[11];
    let relieve_div = document.getElementById("relieve");
    if (relieve != "") {
        relieve_div.href = "https://www.relive.cc/view/" + relieve;
        relieve_div.style.display = "block";
    } else {
        relieve_div.href = "";
        relieve_div.style.display = "none";
    }
    let id_download = document.getElementById("download");
    id_download.href = "./rutesgps/" + fitxer;
    //console.log(fitxer)
    $3ed210d2c36fb1ec$var$repintar_mapa(fitxer);
}
function $3ed210d2c36fb1ec$var$carregar_ruta_inicial(ruta_hash) {
    //console.log(ruta_hash)
    let rutes_arr = (0, $330732299c8bab21$export$2e2bcd8739ae039)();
    let num1 = Math.floor(Math.random() * rutes_arr.length);
    let num2 = Math.floor(Math.random() * rutes_arr[num1].rutes.length);
    loop1: for(let i = 0; i < rutes_arr.length; i++){
        for(let j = 0; j < rutes_arr[i].rutes.length; j++)if (ruta_hash == rutes_arr[i].rutes[j].fitxer.replace('.gpx', '')) {
            num1 = i;
            num2 = j;
            break loop1;
        }
    }
    let titol_ruta = document.getElementById("titol_ruta");
    let desc_ruta = document.getElementById("desc_ruta");
    var desc_ruta_arr = rutes_arr[num1].rutes[num2].desc.split('*');
    var str_img = "<img src='./img/" + desc_ruta_arr[0].toLowerCase() + "_64.png'>&nbsp;";
    titol_ruta.innerHTML = str_img + rutes_arr[num1].rutes[num2].ruta;
    var str = "";
    str = $3ed210d2c36fb1ec$var$changeDateFormat(desc_ruta_arr[3]);
    str = str + " - " + desc_ruta_arr[4] + " - " + desc_ruta_arr[5] + " h" + " - " + desc_ruta_arr[8] + " - (" + desc_ruta_arr[9] + " " + "&rarr;" + " " + desc_ruta_arr[10] + ")";
    desc_ruta.innerHTML = str;
    var relieve = desc_ruta_arr[11];
    let relieve_div = document.getElementById("relieve");
    if (relieve != "") {
        relieve_div.href = "https://www.relive.cc/view/" + relieve;
        relieve_div.style.display = "block";
    } else {
        relieve_div.href = "";
        relieve_div.style.display = "none";
    }
    let id_download = document.getElementById("download");
    id_download.href = "./rutesgps/" + rutes_arr[num1].rutes[num2].fitxer;
    $3ed210d2c36fb1ec$var$pintar_mapa_inicial(rutes_arr[num1].rutes[num2].fitxer);
}
function $3ed210d2c36fb1ec$var$pintar_mapa_inicial(fitxer) {
    var vector = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
        source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
            url: './rutesgps/' + fitxer,
            format: new (0, $c7152e7ae8968a6e$export$2e2bcd8739ae039)()
        }),
        style: function(feature) {
            return $3ed210d2c36fb1ec$var$style[feature.getGeometry().getType()];
        }
    });
    $3ed210d2c36fb1ec$var$layers.push(vector);
    $3ed210d2c36fb1ec$var$map = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)({
        controls: (0, $b4471d80e1d69273$export$ebe90cb607ad99e)().extend([
            new (0, $213858285507f9af$export$2e2bcd8739ae039)()
        ]),
        target: document.getElementById('map'),
        overlays: [
            $3ed210d2c36fb1ec$var$overlay
        ],
        layers: [
            $3ed210d2c36fb1ec$var$layers[0],
            $3ed210d2c36fb1ec$var$layers[4]
        ],
        view: new (0, $70364d0195659942$export$2e2bcd8739ae039)({
            center: (0, $9c4744460e43e41b$export$b15d9668511529b9)([
                1.9858,
                41.9176
            ]),
            zoom: 12
        })
    });
    // ja no cal, no és necessari
    //currZoom = map.getView().getZoom();
    var padding = [
        50,
        50,
        50,
        50
    ];
    vector.getSource().on('addfeature', function() {
        $3ed210d2c36fb1ec$var$map.getView().fit(vector.getSource().getExtent(), {
            size: $3ed210d2c36fb1ec$var$map.getSize(),
            padding: padding
        });
    });
    // == INICI MARKER ===================
    const iconStyleGreen = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
        image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
            anchor: [
                0.5,
                35
            ],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: './img/green-marker.svg'
        })
    });
    const iconStyleRed = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
        image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
            anchor: [
                0.5,
                35
            ],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: './img/red-marker.svg'
        })
    });
    $3ed210d2c36fb1ec$var$getXMLDocObject('./rutesgps/' + fitxer, function(xmlDoc) {
        // extract the info from the xmlDoc object
        var trk = xmlDoc.getElementsByTagName('trk')[0];
        //console.log(trk)
        var trkseg = trk.getElementsByTagName('trkseg');
        let trkseg1 = trkseg[0];
        let trkseg2 = trkseg[trkseg.length - 1];
        let lat1 = trkseg1.children[0].getAttribute('lat');
        let lon1 = trkseg1.children[0].getAttribute('lon');
        let lat2 = trkseg2.children[trkseg2.children.length - 1].getAttribute('lat');
        let lon2 = trkseg2.children[trkseg2.children.length - 1].getAttribute('lon');
        //console.log(lat1);
        //console.log(lon1);
        //console.log(lat2);
        //console.log(lon2);
        let iconFeature1 = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
            geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)((0, $9c4744460e43e41b$export$b15d9668511529b9)([
                lon1,
                lat1
            ])),
            name: 'Inici'
        });
        let iconFeature2 = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
            geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)((0, $9c4744460e43e41b$export$b15d9668511529b9)([
                lon2,
                lat2
            ])),
            name: 'Final'
        });
        iconFeature1.setStyle(iconStyleGreen);
        iconFeature2.setStyle(iconStyleRed);
        var vector_marker = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
                features: [
                    iconFeature1,
                    iconFeature2
                ]
            })
        });
        $3ed210d2c36fb1ec$var$layers.push(vector_marker);
        $3ed210d2c36fb1ec$var$map.addLayer($3ed210d2c36fb1ec$var$layers[5]); //afegir el marker
    });
    // == FI MARKER ===================
    $3ed210d2c36fb1ec$var$pintar_relleu(fitxer);
}
function $3ed210d2c36fb1ec$var$repintar_mapa(fitxer) {
    $3ed210d2c36fb1ec$var$vector = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
        source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
            url: './rutesgps/' + fitxer,
            format: new (0, $c7152e7ae8968a6e$export$2e2bcd8739ae039)()
        }),
        style: function(feature) {
            return $3ed210d2c36fb1ec$var$style[feature.getGeometry().getType()];
        }
    });
    //treure l'anterior element (l'anterior ruta), i afegir el nou
    $3ed210d2c36fb1ec$var$map.removeLayer($3ed210d2c36fb1ec$var$layers[5]); //esborrar els markers de la ruta antiga
    $3ed210d2c36fb1ec$var$layers.pop();
    $3ed210d2c36fb1ec$var$map.removeLayer($3ed210d2c36fb1ec$var$layers[4]); //esborrar la ruta antiga
    $3ed210d2c36fb1ec$var$layers.pop();
    $3ed210d2c36fb1ec$var$layers.push($3ed210d2c36fb1ec$var$vector);
    $3ed210d2c36fb1ec$var$map.addLayer($3ed210d2c36fb1ec$var$layers[4]); //afegir la ruta nova
    var padding2 = [
        50,
        50,
        50,
        50
    ];
    $3ed210d2c36fb1ec$var$vector.getSource().on('addfeature', function() {
        $3ed210d2c36fb1ec$var$map.getView().fit($3ed210d2c36fb1ec$var$vector.getSource().getExtent(), {
            size: $3ed210d2c36fb1ec$var$map.getSize(),
            padding: padding2
        });
    });
    // == INICI MARKER ===================
    const iconStyleGreen = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
        image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
            anchor: [
                0.5,
                35
            ],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: './img/green-marker.svg'
        })
    });
    const iconStyleRed = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
        image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
            anchor: [
                0.5,
                35
            ],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: './img/red-marker.svg'
        })
    });
    $3ed210d2c36fb1ec$var$getXMLDocObject('./rutesgps/' + fitxer, function(xmlDoc) {
        // extract the info from the xmlDoc object
        var trk = xmlDoc.getElementsByTagName('trk')[0];
        //console.log(trk)
        var trkseg = trk.getElementsByTagName('trkseg');
        let trkseg1 = trkseg[0];
        let trkseg2 = trkseg[trkseg.length - 1];
        let lat1 = trkseg1.children[0].getAttribute('lat');
        let lon1 = trkseg1.children[0].getAttribute('lon');
        let lat2 = trkseg2.children[trkseg2.children.length - 1].getAttribute('lat');
        let lon2 = trkseg2.children[trkseg2.children.length - 1].getAttribute('lon');
        //console.log(lat1);
        //console.log(lon1);
        //console.log(lat2);
        //console.log(lon2);
        let iconFeature1 = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
            geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)((0, $9c4744460e43e41b$export$b15d9668511529b9)([
                lon1,
                lat1
            ])),
            name: 'Inici'
        });
        let iconFeature2 = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
            geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)((0, $9c4744460e43e41b$export$b15d9668511529b9)([
                lon2,
                lat2
            ])),
            name: 'Final'
        });
        iconFeature1.setStyle(iconStyleGreen);
        iconFeature2.setStyle(iconStyleRed);
        var vector_marker = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
                features: [
                    iconFeature1,
                    iconFeature2
                ]
            })
        });
        $3ed210d2c36fb1ec$var$layers.push(vector_marker);
        $3ed210d2c36fb1ec$var$map.addLayer($3ed210d2c36fb1ec$var$layers[5]); //afegir el marker
    });
    // == FI MARKER ===================
    $3ed210d2c36fb1ec$var$pintar_relleu(fitxer);
}
function $3ed210d2c36fb1ec$var$repintar_mapa_render(id_render, fitxer) {
    $3ed210d2c36fb1ec$var$vector = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
        source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
            url: './rutesgps/' + fitxer,
            format: new (0, $c7152e7ae8968a6e$export$2e2bcd8739ae039)()
        }),
        style: function(feature) {
            return $3ed210d2c36fb1ec$var$style[feature.getGeometry().getType()];
        }
    });
    //elimino les dues capes que hi ha (el render i la ruta)
    //https://stackoverflow.com/questions/40862706/unable-to-remove-all-layers-from-a-map/41566755
    $3ed210d2c36fb1ec$var$map.getLayers().forEach(function(layer) {
        $3ed210d2c36fb1ec$var$map.removeLayer(layer);
    });
    //for some crazy reason I need to do it twice.
    $3ed210d2c36fb1ec$var$map.getLayers().forEach(function(layer) {
        $3ed210d2c36fb1ec$var$map.removeLayer(layer);
    });
    $3ed210d2c36fb1ec$var$map.addLayer($3ed210d2c36fb1ec$var$layers[id_render]); //afegeixo el render
    $3ed210d2c36fb1ec$var$layers.pop(); //trec la ruta i afegeixo la nova ruta
    $3ed210d2c36fb1ec$var$layers.push($3ed210d2c36fb1ec$var$vector);
    $3ed210d2c36fb1ec$var$map.addLayer($3ed210d2c36fb1ec$var$layers[4]); //afegir la ruta nova
    var padding2 = [
        50,
        50,
        50,
        50
    ];
    /*
	//no cal aquest tros. Així aconsegueixo que quan canvio de render, em manté el zoom i el center
	vector.getSource().on('addfeature', function(){
		map.getView().fit(
			vector.getSource().getExtent(),
			{
				size: map.getSize(),
				padding: padding2,
			}
		);
	});
*/ $3ed210d2c36fb1ec$var$pintar_relleu(fitxer);
}
var $3ed210d2c36fb1ec$var$style = {
    'Point': new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
        image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: 'rgba(100,100,100,.8)'
            }),
            radius: 3,
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: '#000000',
                width: 2
            })
        })
    }),
    'LineString': new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
        stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
            color: '#f00',
            width: 3
        })
    }),
    'MultiLineString': new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
        stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
            color: '#000000',
            width: 3
        })
    })
};
function $3ed210d2c36fb1ec$var$changeDateFormat(inputDate) {
    var splitDate = inputDate.split('-');
    if (splitDate.count == 0) return null;
    var year = splitDate[0];
    var month = splitDate[1];
    var day = splitDate[2];
    return day + '/' + month + '/' + year;
}
$3ed210d2c36fb1ec$var$map.on("pointermove", function(e) {
    var coordinate = e.coordinate;
    var features = [];
    $3ed210d2c36fb1ec$var$map.forEachFeatureAtPixel(e.pixel, function(feature, layer) {
        //if (feature.values_.name != undefined) {
        if (feature.getGeometry().getType() == "Point") features.push(feature);
        if (features.length > 0) {
            var info = features[0].get('name');
            $3ed210d2c36fb1ec$var$container.style.visibility = "visible";
            $3ed210d2c36fb1ec$var$content.innerHTML = info;
            $3ed210d2c36fb1ec$var$map.getTarget().style.cursor = 'pointer';
            $3ed210d2c36fb1ec$var$overlay.setPosition(coordinate);
            setTimeout(function() {
                $3ed210d2c36fb1ec$var$tancar_tooltip();
            }, 500);
        } else $3ed210d2c36fb1ec$var$map.getTarget().style.cursor = '';
    });
});
function $3ed210d2c36fb1ec$var$tancar_tooltip() {
    $3ed210d2c36fb1ec$var$container.style.visibility = "hidden";
}
/*
// ja no cal, no és necessari
// capturar el canvi de zoom i de centre
map.on('moveend', function(e) {
	const view = map.getView();
	let newZoom = view.getZoom();
	if (currZoom != newZoom) {
	//console.log('zoom end, new zoom: ' + newZoom);
	currZoom = newZoom;
	}
	const center = view.getCenter();
	currCenter = toLonLat(center);
	//console.log(center);
	//console.log(toLonLat(center));
})
*/ function $3ed210d2c36fb1ec$var$pintar_relleu(fitxer) {
    //d3/exemple7.html
    //------------------------1. PREPARATION------------------------//
    //-----------------------------SVG------------------------------// 
    const width = 370;
    const height = 180;
    const margin = 0;
    const padding = 0;
    const adj = 35;
    //primer elimino els SVG que hi puguin haver
    d3.select("div#relleu").selectAll('*').remove();
    // we are appending SVG first
    const svg = d3.select("div#relleu").append("svg").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", "-" + adj + " -" + adj + " " + (width + 3 * adj) + " " + (height + 3 * adj)).style("padding", padding).style("margin", margin).classed("svg-content", true);
    //console.log(fitxer);
    fitxer = "./rutesgps/" + fitxer.replace(".gpx", ".json");
    const dataset2 = d3.json(fitxer).then(function(data) {
        //console.log(data);
        //----------------------------SCALES----------------------------//
        const xScale = d3.scaleLinear().rangeRound([
            0,
            width
        ]);
        const yScale = d3.scaleLinear().rangeRound([
            height,
            0
        ]);
        xScale.domain(d3.extent(data, function(d) {
            return d.num;
        }));
        yScale.domain([
            d3.min(data, function(c) {
                return c.ele - 20;
            }),
            d3.max(data, function(c) {
                return c.ele + 20;
            })
        ]);
        //-----------------------------AXES-----------------------------//
        const yaxis = d3.axisLeft()//.ticks((slices[0].values).length)
        .ticks(10).scale(yScale);
        const xaxis = d3.axisBottom()//.ticks(d3.timeDay.every(1))
        //.tickFormat(d3.timeFormat('%b %d'))
        .ticks(5).scale(xScale);
        //----------------------------LINES-----------------------------//
        const line = d3.line().x(function(d) {
            return xScale(d.num);
        }).y(function(d) {
            return yScale(d.ele);
        });
        //.curve(d3.curveMonotoneX); // apply smoothing to the line
        //-------------------------2. DRAWING---------------------------//
        //-----------------------------AXES-----------------------------//
        svg.append("g").attr("class", "axis").attr("transform", "translate(0," + height + ")").call(xaxis).append("text")//.attr("transform", "rotate(-90)")
        .attr("dy", "1.3em").attr("y", 2).attr("dx", "30em").style("text-anchor", "start").text("Km");
        svg.append("g").attr("class", "axis").call(yaxis);
        //----------------------------LINES-----------------------------//
        const lines = svg.selectAll("lines").data(data).enter().append("g");
        lines.append("path").attr("class", "line-0").attr("d", function(d) {
            return line(data);
        });
    });
}
function $3ed210d2c36fb1ec$var$mostrar_perfil() {
    if (document.getElementById("relleu").style.visibility == "hidden") document.getElementById("relleu").style.visibility = "visible";
    else document.getElementById("relleu").style.visibility = "hidden";
}
function $3ed210d2c36fb1ec$var$copiar_url_link() {
    let id_download = document.getElementById("download");
    let url = id_download.href.replace('.gpx', '').replace('rutesgps/', '#');
    //console.log(url);
    //navigator.clipboard: en local funciona bé, però en el servidor no funciona (undefined) perquè sembla ser que necessita https. He trobat la funció copy() que també funciona.
    //navigator.clipboard.writeText(url);
    $3ed210d2c36fb1ec$var$copy(url);
}
//https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
function $3ed210d2c36fb1ec$var$copy(text) {
    var input = document.createElement('textarea');
    input.innerHTML = text;
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand('copy');
    document.body.removeChild(input);
    return result;
}
function $3ed210d2c36fb1ec$var$canviar_render(tipus_render) {
    //console.log(tipus_render);
    //console.log(document.getElementById("OSM").getAttribute("class"))
    document.getElementById("0_OSM").setAttribute("class", "btn btn-sm btn-bd-light mb-2 mb-md-0");
    document.getElementById("1_ORTO").setAttribute("class", "btn btn-sm btn-bd-light mb-2 mb-md-0");
    document.getElementById("2_TOPOTRESC").setAttribute("class", "btn btn-sm btn-bd-light mb-2 mb-md-0");
    document.getElementById("3_ICGC").setAttribute("class", "btn btn-sm btn-bd-light mb-2 mb-md-0");
    document.getElementById(tipus_render).setAttribute("class", "btn btn-sm btn-bd-primary mb-2 mb-md-0");
    //let fitxer = document.getElementById("download").href.replace("./rutesgps/", "");
    let cad = document.getElementById("download").href;
    let fitxer = cad.substring(cad.indexOf("rutesgps/") + 9, cad.length);
    let id_render = parseInt(tipus_render.substr(0, 1));
    $3ed210d2c36fb1ec$var$repintar_mapa_render(id_render, fitxer);
}
// Funcionalitat cercar ruta
function $3ed210d2c36fb1ec$var$netejar_cercar_ruta() {
    let search_form = document.getElementById("search-form");
    //he de mirar el search_form quants childs té
    var nodeList = search_form.childNodes;
    //alert(nodeList.length);
    if (nodeList.length > 3) //he d'eliminar l'últim node, que és els resultats de la última cerca
    nodeList[nodeList.length - 1].remove();
}
function $3ed210d2c36fb1ec$var$cercar_ruta(cad_cerca) {
    cad_cerca = cad_cerca.toLowerCase().trim();
    let search_form = document.getElementById("search-form");
    //he de mirar el search_form quants childs té
    var nodeList = search_form.childNodes;
    //alert(nodeList.length);
    if (nodeList.length > 3) //he d'eliminar l'últim node, que és els resultats de la última cerca
    nodeList[nodeList.length - 1].remove();
    let div_cerca = document.createElement("div");
    div_cerca.setAttribute("id", "div_cerca");
    div_cerca.setAttribute("class", "resultats_cerca form-control");
    let rutes_arr = (0, $330732299c8bab21$export$2e2bcd8739ae039)();
    let comptador = 0;
    for(let i = 0; i < rutes_arr.length; i++){
        //console.log(rutes_arr[i].zona);
        for(let j = 0; j < rutes_arr[i].rutes.length; j++)//console.log(rutes_arr[i].rutes[j].ruta);
        if (rutes_arr[i].rutes[j].ruta.toLowerCase().indexOf(cad_cerca) >= 0 || rutes_arr[i].rutes[j].desc.toLowerCase().indexOf(cad_cerca) >= 0 || rutes_arr[i].rutes[j].fitxer.toLowerCase().indexOf(cad_cerca) >= 0) {
            comptador = comptador + 1;
            //console.log(rutes_arr[i].rutes[j].ruta);
            let a = document.createElement('a');
            let linkText = document.createTextNode(rutes_arr[i].rutes[j].ruta);
            a.appendChild(linkText);
            a.title = rutes_arr[i].rutes[j].ruta;
            a.href = "#";
            a.setAttribute("class", "link");
            a.addEventListener("click", function() {
                $3ed210d2c36fb1ec$var$carregar_ruta(rutes_arr[i].rutes[j].ruta, rutes_arr[i].rutes[j].fitxer, rutes_arr[i].rutes[j].desc);
                div_cerca.remove();
            }, false);
            div_cerca.appendChild(a);
            let hr = document.createElement("HR");
            hr.setAttribute("class", "estret");
            div_cerca.appendChild(hr);
        }
    }
    if (comptador == 0) {
        let a = document.createElement('a');
        let linkText = document.createTextNode("0 resultats");
        a.appendChild(linkText);
        a.title = "0 resultats";
        a.href = "#";
        a.setAttribute("class", "link");
        div_cerca.appendChild(a);
        setTimeout(function() {
            div_cerca.remove();
        }, 1000);
    }
    search_form.appendChild(div_cerca);
}
///== Parsejar fitxer XML (necessari per als markers d'inici i final) ==
// get content and parse it to Document Object Model
function $3ed210d2c36fb1ec$var$getXMLDocObject(xmlFile, callback) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
            var xmlContent = this.responseText;
            var xmlDoc = $3ed210d2c36fb1ec$var$parseXML(xmlContent);
            callback(xmlDoc);
        }
    };
    xhttp.open('GET', xmlFile, true);
    xhttp.send();
}
// parse a text string into an XML DOM object
function $3ed210d2c36fb1ec$var$parseXML(xmlContent) {
    var parser = new DOMParser();
    var xmlDoc = parser.parseFromString(xmlContent, 'text/xml');
    return xmlDoc;
}


//# sourceMappingURL=index.809a47ce.js.map
